import { defineComponent as Qt, computed as T, resolveComponent as de, openBlock as ge, createBlock as _e, withCtx as q, createElementBlock as yt, createElementVNode as S, normalizeStyle as le, Fragment as fe, renderList as ia, ref as G, watch as ne, onMounted as bt, toDisplayString as ce, createVNode as y, unref as Z, createTextVNode as we, createCommentVNode as ot, inject as Le, mergeProps as Y, withModifiers as zn, normalizeProps as am, guardReactiveProps as rm, normalizeClass as J, toRefs as Kr, onUnmounted as lm, onBeforeUnmount as Ft, nextTick as Se, Teleport as Ku, Transition as Rn, warn as go, shallowRef as ae, reactive as cn, watchEffect as ft, toRef as D, capitalize as Zr, isRef as qi, isReactive as Bp, isProxy as Up, toRaw as it, camelize as im, isVNode as Wp, Comment as Hp, getCurrentInstance as zp, provide as st, h as Oa, readonly as yo, useId as Rt, onDeactivated as om, onActivated as jp, onScopeDispose as It, effectScope as bo, TransitionGroup as Zu, toValue as nt, onBeforeMount as Gl, withDirectives as at, vShow as Wn, onUpdated as sm, Text as Gp, resolveDynamicComponent as qp, markRaw as Yp, cloneVNode as Kp, onBeforeUpdate as Zp, vModelText as Jp, render as um, createSlots as cm } from "vue";
import { useI18n as mn, createI18n as Xp } from "vue-i18n";
import { defineStore as ir } from "pinia";
import { useRouter as Jr, useRoute as Ju, createRouter as Qp, createWebHistory as ew } from "vue-router";
import { useDisplay as tw, createVuetify as nw } from "vuetify";
const aw = ["viewBox"], rw = ["cx", "cy", "r", "fill"], Id = 7, lw = /* @__PURE__ */ Qt({
  __name: "BubblePixelIdenticon",
  props: {
    uuid: {},
    size: { default: 64 }
  },
  setup(e) {
    const t = e, n = (r) => {
      let l = 0;
      for (let i = 0; i < r.length; i++)
        l = r.charCodeAt(i) + ((l << 5) - l);
      return Math.abs(l);
    }, a = T(() => {
      const r = n(t.uuid), l = (g) => `hsl(${(r + g) % 360}, 70%, 85%)`, i = l(0), o = l(40), s = l(180), u = [];
      u.push({ x: 3, y: 3, r: 0.5 + r % 3 * 0.05, f: i });
      const c = (g, m, h, w) => {
        for (let _ = 0; _ < m; _++) {
          const I = _ * 2 * Math.PI / m, C = 3 + g * Math.cos(I), b = 3 + g * Math.sin(I);
          u.push({ x: C, y: b, r: h, f: w });
        }
      }, d = r >> 1 & 1, f = r >> 2 & 1, v = [5, 6, 8, 10][r % 4];
      return (d || !f) && c(1.2, v, 0.35, o), f && c(2.2, v === 5 ? 5 : 8, 0.4, s), { dots: u, rotation: r % 360 };
    });
    return (r, l) => {
      const i = de("v-avatar");
      return ge(), _e(i, {
        size: e.size,
        rounded: "lg",
        class: "elevation-1",
        color: "#FFFFFF"
      }, {
        default: q(() => [
          (ge(), yt("svg", {
            viewBox: `0 0 ${Id} ${Id}`,
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            S("g", {
              style: le({ transform: `rotate(${a.value.rotation}deg)`, transformOrigin: "3.5px 3.5px" })
            }, [
              (ge(!0), yt(fe, null, ia(a.value.dots, (o, s) => (ge(), yt("circle", {
                key: s,
                cx: o.x + 0.5,
                cy: o.y + 0.5,
                r: o.r,
                fill: o.f
              }, null, 8, rw))), 128))
            ], 4)
          ], 8, aw))
        ]),
        _: 1
      }, 8, ["size"]);
    };
  }
}), iw = { class: "text-subtitle-1 text-high-emphasis" }, Bs = /* @__PURE__ */ Qt({
  __name: "ChipSelect",
  props: {
    modelValue: {},
    label: {},
    selections: {},
    loading: { type: Boolean },
    alwaysSelected: {},
    displayOnly: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, r = n.alwaysSelected ?? [], { t: l } = mn(), i = G(""), o = G([
      ...r,
      ...n.modelValue.filter((c) => !r.includes(c))
    ]);
    ne(
      () => n.modelValue,
      (c) => {
        o.value = [
          ...r,
          ...c.filter((d) => !r.includes(d))
        ];
      },
      { immediate: !0 }
    ), ne(
      o,
      (c) => {
        c.toString() !== n.modelValue.toString() && a("update:modelValue", [...c]);
      },
      { deep: !0 }
    );
    const s = T(() => o.value.length === n.selections.length), u = T(() => i.value ? n.selections.filter(
      (c) => l(`general.${c.toLowerCase()}`).toLowerCase().includes(i.value.toLowerCase())
    ) : n.selections);
    return bt(() => {
      const c = [
        ...r,
        ...n.modelValue.filter((d) => !r.includes(d))
      ];
      c.toString() !== n.modelValue.toString() && a("update:modelValue", c);
    }), (c, d) => {
      const f = de("v-chip"), v = de("v-col"), g = de("v-text-field"), m = de("v-list-item-title"), h = de("v-list-item"), w = de("v-list"), _ = de("v-card"), I = de("v-row"), C = de("v-container");
      return ge(), _e(_, {
        class: "pa-1",
        flat: ""
      }, {
        default: q(() => [
          S("div", iw, ce(e.label), 1),
          y(C, null, {
            default: q(() => [
              y(I, {
                align: "center",
                justify: "start"
              }, {
                default: q(() => [
                  (ge(!0), yt(fe, null, ia(o.value, (b, p) => (ge(), _e(v, {
                    key: b,
                    class: "py-1 pe-0",
                    cols: "auto"
                  }, {
                    default: q(() => [
                      y(f, {
                        disabled: e.loading,
                        closable: !Z(r).includes(b) && !n.displayOnly,
                        "onClick:close": (x) => n.displayOnly ? null : o.value.splice(p, 1)
                      }, {
                        default: q(() => [
                          we(ce(Z(l)(`general.${b.toLowerCase()}`)), 1)
                        ]),
                        _: 2
                      }, 1032, ["disabled", "closable", "onClick:close"])
                    ]),
                    _: 2
                  }, 1024))), 128)),
                  !s.value && !n.displayOnly ? (ge(), _e(v, {
                    key: 0,
                    cols: "12"
                  }, {
                    default: q(() => [
                      y(_, null, {
                        default: q(() => [
                          y(g, {
                            ref: "searchField",
                            modelValue: i.value,
                            "onUpdate:modelValue": d[0] || (d[0] = (b) => i.value = b),
                            label: Z(l)("general.search"),
                            "hide-details": ""
                          }, null, 8, ["modelValue", "label"]),
                          y(w, null, {
                            default: q(() => [
                              (ge(!0), yt(fe, null, ia(u.value, (b) => (ge(), yt(fe, null, [
                                !o.value.includes(b) && !Z(r).includes(b) && !n.displayOnly ? (ge(), _e(h, {
                                  key: b,
                                  disabled: e.loading || n.displayOnly,
                                  onClick: (p) => n.displayOnly ? null : o.value.push(b)
                                }, {
                                  default: q(() => [
                                    y(m, null, {
                                      default: q(() => [
                                        we(ce(Z(l)(`general.${b.toLowerCase()}`)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick"])) : ot("", !0)
                              ], 64))), 256))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : ot("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), Vr = ir("uxFeedback", {
  state: () => ({
    messageQueue: [],
    snackbarVisible: !1,
    currentMessage: {}
  }),
  actions: {
    queueMessage(e) {
      this.messageQueue.some((t) => t.message === e.message) || (this.messageQueue.push(e), this.snackbarVisible || this.showNextMessage());
    },
    showNextMessage() {
      this.messageQueue.length > 0 && (this.currentMessage = this.messageQueue.shift(), this.snackbarVisible = !0);
    },
    hideError() {
      this.snackbarVisible = !1, this.showNextMessage();
    }
  }
}), ow = {
  key: 0,
  class: "text-subtitle-1 pb-2"
}, sw = /* @__PURE__ */ Qt({
  __name: "ErrorSnackbar",
  setup(e) {
    const { t } = mn(), n = Vr(), a = T(() => n.snackbarVisible), r = T(() => n.currentMessage), l = () => {
      n.hideError();
    };
    return ne(r, (i) => {
      i && !n.messageQueue.some((o) => o.message === i.message) && (n.messageQueue = Array.from(new Set(n.messageQueue)));
    }), (i, o) => {
      const s = de("v-btn"), u = de("v-snackbar");
      return ge(), _e(u, {
        modelValue: a.value,
        "onUpdate:modelValue": o[0] || (o[0] = (c) => a.value = c),
        timeout: 3e3,
        color: r.value.type,
        variant: "tonal",
        class: "ux-snackbar"
      }, {
        actions: q(() => [
          y(s, {
            variant: "flat",
            color: "white",
            onClick: l
          }, {
            default: q(() => [
              we(ce(Z(t)("general.close")), 1)
            ]),
            _: 1
          })
        ]),
        default: q(() => [
          r.value.title ? (ge(), yt("div", ow, ce(r.value.title), 1)) : ot("", !0),
          S("p", null, ce(r.value.message), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "color"]);
    };
  }
}), Zn = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, r] of t)
    n[a] = r;
  return n;
}, uw = /* @__PURE__ */ Zn(sw, [["__scopeId", "data-v-d580c628"]]), cw = /* @__PURE__ */ Qt({
  __name: "LanguageSelector",
  setup(e) {
    const { t, getLocaleMessage: n, availableLocales: a } = mn(), r = Le("languageStore"), l = Jr(), i = Ju(), o = G(r.currentLanguage), s = G(!1), u = [
      { code: "en", name: String(n("en").languageName) },
      { code: "es", name: String(n("es").languageName) },
      { code: "de", name: String(n("de").languageName) }
    ], c = [
      ...u,
      ...a.filter((d) => r.supportedLanguages.includes(d)).filter((d) => !u.some((f) => f.code === d)).map((d) => ({
        code: d,
        name: String(n(d).languageName)
      }))
    ];
    return ne(o, async (d) => {
      const f = i.fullPath, v = f.startsWith(`/${r.currentLanguage}`) ? f.slice(r.currentLanguage.length + 1) : f;
      await l.push({ path: `/${d}${v}` });
    }), ne(
      () => r.currentLanguage,
      (d) => {
        o.value = d;
      }
    ), (d, f) => {
      const v = de("v-icon"), g = de("v-btn"), m = de("v-autocomplete"), h = de("v-menu");
      return ge(), _e(h, {
        "offset-y": "",
        "close-on-content-click": !1,
        modelValue: s.value,
        "onUpdate:modelValue": f[2] || (f[2] = (w) => s.value = w)
      }, {
        activator: q(({ props: w }) => [
          y(g, Y({ icon: "" }, w), {
            default: q(() => [
              y(v, null, {
                default: q(() => [...f[3] || (f[3] = [
                  we("mdi-translate", -1)
                ])]),
                _: 1
              })
            ]),
            _: 1
          }, 16)
        ]),
        default: q(() => [
          y(m, {
            modelValue: o.value,
            "onUpdate:modelValue": [
              f[0] || (f[0] = (w) => o.value = w),
              f[1] || (f[1] = (w) => s.value = !1)
            ],
            items: c,
            "item-title": "name",
            "item-value": "code",
            label: Z(t)("selectLanguage"),
            menu: !0
          }, null, 8, ["modelValue", "label"])
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}), dw = /* @__PURE__ */ Zn(cw, [["__scopeId", "data-v-8c7fa236"]]);
var Xu = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t) {
      this.groups = [], this.each = !1, this.context = void 0, this.type = t.type, this.name = t.name, this.target = t.target, this.propertyName = t.propertyName, this.constraints = t?.constraints, this.constraintCls = t.constraintCls, this.validationTypeOptions = t.validationTypeOptions, t.validationOptions && (this.message = t.validationOptions.message, this.groups = t.validationOptions.groups, this.always = t.validationOptions.always, this.each = t.validationOptions.each, this.context = t.validationOptions.context);
    }
    return e;
  })()
), fw = (
  /** @class */
  (function() {
    function e() {
    }
    return e.prototype.transform = function(t) {
      var n = [];
      return Object.keys(t.properties).forEach(function(a) {
        t.properties[a].forEach(function(r) {
          var l = {
            message: r.message,
            groups: r.groups,
            always: r.always,
            each: r.each
          }, i = {
            type: r.type,
            name: r.name,
            target: t.name,
            propertyName: a,
            constraints: r.constraints,
            validationTypeOptions: r.options,
            validationOptions: l
          };
          n.push(new Xu(i));
        });
      }), n;
    }, e;
  })()
);
function vw(e) {
  return e instanceof Map ? Array.from(e.values()) : Array.isArray(e) ? e : Array.from(e);
}
function mw() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof global < "u")
    return global;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
}
function cs(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var hw = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], a = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && a >= e.length && (e = void 0), { value: e && e[a++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ad = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var a = n.call(e), r, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = a.next()).done; ) l.push(r.value);
  } catch (o) {
    i = { error: o };
  } finally {
    try {
      r && !r.done && (n = a.return) && n.call(a);
    } finally {
      if (i) throw i.error;
    }
  }
  return l;
}, gw = function(e, t, n) {
  if (n || arguments.length === 2) for (var a = 0, r = t.length, l; a < r; a++)
    (l || !(a in t)) && (l || (l = Array.prototype.slice.call(t, 0, a)), l[a] = t[a]);
  return e.concat(l || Array.prototype.slice.call(t));
}, dm = (
  /** @class */
  (function() {
    function e() {
      this.validationMetadatas = /* @__PURE__ */ new Map(), this.constraintMetadatas = /* @__PURE__ */ new Map();
    }
    return Object.defineProperty(e.prototype, "hasValidationMetaData", {
      get: function() {
        return !!this.validationMetadatas.size;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.addValidationSchema = function(t) {
      var n = this, a = new fw().transform(t);
      a.forEach(function(r) {
        return n.addValidationMetadata(r);
      });
    }, e.prototype.addValidationMetadata = function(t) {
      var n = this.validationMetadatas.get(t.target);
      n ? n.push(t) : this.validationMetadatas.set(t.target, [t]);
    }, e.prototype.addConstraintMetadata = function(t) {
      var n = this.constraintMetadatas.get(t.target);
      n ? n.push(t) : this.constraintMetadatas.set(t.target, [t]);
    }, e.prototype.groupByPropertyName = function(t) {
      var n = {};
      return t.forEach(function(a) {
        n[a.propertyName] || (n[a.propertyName] = []), n[a.propertyName].push(a);
      }), n;
    }, e.prototype.getTargetValidationMetadatas = function(t, n, a, r, l) {
      var i, o, s = function(C) {
        return typeof C.always < "u" ? C.always : C.groups && C.groups.length ? !1 : a;
      }, u = function(C) {
        return !!(r && (!l || !l.length) && C.groups && C.groups.length);
      }, c = this.validationMetadatas.get(t) || [], d = c.filter(function(C) {
        return C.target !== t && C.target !== n ? !1 : s(C) ? !0 : u(C) ? !1 : l && l.length > 0 ? C.groups && !!C.groups.find(function(b) {
          return l.indexOf(b) !== -1;
        }) : !0;
      }), f = [];
      try {
        for (var v = hw(this.validationMetadatas.entries()), g = v.next(); !g.done; g = v.next()) {
          var m = Ad(g.value, 2), h = m[0], w = m[1];
          t.prototype instanceof h && f.push.apply(f, gw([], Ad(w), !1));
        }
      } catch (C) {
        i = { error: C };
      } finally {
        try {
          g && !g.done && (o = v.return) && o.call(v);
        } finally {
          if (i) throw i.error;
        }
      }
      var _ = f.filter(function(C) {
        return typeof C.target == "string" || C.target === t || C.target instanceof Function && !(t.prototype instanceof C.target) ? !1 : s(C) ? !0 : u(C) ? !1 : l && l.length > 0 ? C.groups && !!C.groups.find(function(b) {
          return l.indexOf(b) !== -1;
        }) : !0;
      }), I = _.filter(function(C) {
        return !d.find(function(b) {
          return b.propertyName === C.propertyName && b.type === C.type;
        });
      });
      return d.concat(I);
    }, e.prototype.getTargetValidatorConstraints = function(t) {
      return this.constraintMetadatas.get(t) || [];
    }, e;
  })()
);
function Yi() {
  var e = mw();
  return e.classValidatorMetadataStorage || (e.classValidatorMetadataStorage = new dm()), e.classValidatorMetadataStorage;
}
var Pd = (
  /** @class */
  (function() {
    function e() {
    }
    return e.prototype.toString = function(t, n, a, r) {
      var l = this;
      t === void 0 && (t = !1), n === void 0 && (n = !1), a === void 0 && (a = ""), r === void 0 && (r = !1);
      var i = t ? "\x1B[1m" : "", o = t ? "\x1B[22m" : "", s = function() {
        var d;
        return (r ? Object.values : Object.keys)((d = l.constraints) !== null && d !== void 0 ? d : {}).join(", ");
      }, u = function(d) {
        return " - property ".concat(i).concat(a).concat(d).concat(o, " has failed the following constraints: ").concat(i).concat(s()).concat(o, ` 
`);
      };
      if (n) {
        var c = Number.isInteger(+this.property) ? "[".concat(this.property, "]") : "".concat(a ? "." : "").concat(this.property);
        return this.constraints ? u(c) : this.children ? this.children.map(function(d) {
          return d.toString(t, !0, "".concat(a).concat(c), r);
        }).join("") : "";
      } else
        return "An instance of ".concat(i).concat(this.target ? this.target.constructor.name : "an object").concat(o, ` has failed the validation:
`) + (this.constraints ? u(this.property) : "") + (this.children ? this.children.map(function(d) {
          return d.toString(t, !0, l.property, r);
        }).join("") : "");
    }, e;
  })()
), un = (
  /** @class */
  (function() {
    function e() {
    }
    return e.isValid = function(t) {
      var n = this;
      return t !== "isValid" && t !== "getMessage" && Object.keys(this).map(function(a) {
        return n[a];
      }).indexOf(t) !== -1;
    }, e.CUSTOM_VALIDATION = "customValidation", e.NESTED_VALIDATION = "nestedValidation", e.PROMISE_VALIDATION = "promiseValidation", e.CONDITIONAL_VALIDATION = "conditionalValidation", e.WHITELIST = "whitelistValidation", e.IS_DEFINED = "isDefined", e;
  })()
);
function yw(e) {
  return Array.isArray(e) ? e.join(", ") : (typeof e == "symbol" && (e = e.description), "".concat(e));
}
var bw = (
  /** @class */
  (function() {
    function e() {
    }
    return e.replaceMessageSpecialTokens = function(t, n) {
      var a;
      return t instanceof Function ? a = t(n) : typeof t == "string" && (a = t), a && Array.isArray(n.constraints) && n.constraints.forEach(function(r, l) {
        a = a.replace(new RegExp("\\$constraint".concat(l + 1), "g"), yw(r));
      }), a && n.value !== void 0 && n.value !== null && ["string", "boolean", "number"].includes(typeof n.value) && (a = a.replace(/\$value/g, n.value)), a && (a = a.replace(/\$property/g, n.property)), a && (a = a.replace(/\$target/g, n.targetName)), a;
    }, e;
  })()
), fl = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var a = n.call(e), r, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = a.next()).done; ) l.push(r.value);
  } catch (o) {
    i = { error: o };
  } finally {
    try {
      r && !r.done && (n = a.return) && n.call(a);
    } finally {
      if (i) throw i.error;
    }
  }
  return l;
}, Vd = (
  /** @class */
  (function() {
    function e(t, n) {
      this.validator = t, this.validatorOptions = n, this.awaitingPromises = [], this.ignoreAsyncValidations = !1, this.metadataStorage = Yi();
    }
    return e.prototype.execute = function(t, n, a) {
      var r = this, l, i;
      !this.metadataStorage.hasValidationMetaData && ((l = this.validatorOptions) === null || l === void 0 ? void 0 : l.enableDebugMessages) === !0 && console.warn(`No validation metadata found. No validation will be  performed. There are multiple possible reasons:
  - There may be multiple class-validator versions installed. You will need to flatten your dependencies to fix the issue.
  - This validation runs before any file with validation decorator was parsed by NodeJS.`);
      var o = this.validatorOptions ? this.validatorOptions.groups : void 0, s = this.validatorOptions && this.validatorOptions.strictGroups || !1, u = this.validatorOptions && this.validatorOptions.always || !1, c = ((i = this.validatorOptions) === null || i === void 0 ? void 0 : i.forbidUnknownValues) === void 0 || this.validatorOptions.forbidUnknownValues !== !1, d = this.metadataStorage.getTargetValidationMetadatas(t.constructor, n, u, s, o), f = this.metadataStorage.groupByPropertyName(d);
      if (c && !d.length) {
        var v = new Pd();
        (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (v.target = t), v.value = void 0, v.property = void 0, v.children = [], v.constraints = { unknownValue: "an unknown value was passed to the validate function" }, a.push(v);
        return;
      }
      this.validatorOptions && this.validatorOptions.whitelist && this.whitelist(t, f, a), Object.keys(f).forEach(function(g) {
        var m = t[g], h = f[g].filter(function(_) {
          return _.type === un.IS_DEFINED;
        }), w = f[g].filter(function(_) {
          return _.type !== un.IS_DEFINED && _.type !== un.WHITELIST;
        });
        m instanceof Promise && w.find(function(_) {
          return _.type === un.PROMISE_VALIDATION;
        }) ? r.awaitingPromises.push(m.then(function(_) {
          r.performValidations(t, _, g, h, w, a);
        })) : r.performValidations(t, m, g, h, w, a);
      });
    }, e.prototype.whitelist = function(t, n, a) {
      var r = this, l = [];
      Object.keys(t).forEach(function(i) {
        (!n[i] || n[i].length === 0) && l.push(i);
      }), l.length > 0 && (this.validatorOptions && this.validatorOptions.forbidNonWhitelisted ? l.forEach(function(i) {
        var o, s = r.generateValidationError(t, t[i], i);
        s.constraints = (o = {}, o[un.WHITELIST] = "property ".concat(i, " should not exist"), o), s.children = void 0, a.push(s);
      }) : l.forEach(function(i) {
        return delete t[i];
      }));
    }, e.prototype.stripEmptyErrors = function(t) {
      var n = this;
      return t.filter(function(a) {
        if (a.children && (a.children = n.stripEmptyErrors(a.children)), Object.keys(a.constraints).length === 0) {
          if (a.children.length === 0)
            return !1;
          delete a.constraints;
        }
        return !0;
      });
    }, e.prototype.performValidations = function(t, n, a, r, l, i) {
      var o = l.filter(function(f) {
        return f.type === un.CUSTOM_VALIDATION;
      }), s = l.filter(function(f) {
        return f.type === un.NESTED_VALIDATION;
      }), u = l.filter(function(f) {
        return f.type === un.CONDITIONAL_VALIDATION;
      }), c = this.generateValidationError(t, n, a);
      i.push(c);
      var d = this.conditionalValidations(t, n, u);
      d && (this.customValidations(t, n, r, c), this.mapContexts(t, n, r, c), !(n === void 0 && this.validatorOptions && this.validatorOptions.skipUndefinedProperties === !0) && (n === null && this.validatorOptions && this.validatorOptions.skipNullProperties === !0 || n == null && this.validatorOptions && this.validatorOptions.skipMissingProperties === !0 || (this.customValidations(t, n, o, c), this.nestedValidations(n, s, c), this.mapContexts(t, n, l, c), this.mapContexts(t, n, o, c))));
    }, e.prototype.generateValidationError = function(t, n, a) {
      var r = new Pd();
      return (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (r.target = t), (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.value === void 0 || this.validatorOptions.validationError.value === !0) && (r.value = n), r.property = a, r.children = [], r.constraints = {}, r;
    }, e.prototype.conditionalValidations = function(t, n, a) {
      return a.map(function(r) {
        return r.constraints[0](t, n);
      }).reduce(function(r, l) {
        return r && l;
      }, !0);
    }, e.prototype.customValidations = function(t, n, a, r) {
      var l = this;
      a.forEach(function(i) {
        l.metadataStorage.getTargetValidatorConstraints(i.constraintCls).forEach(function(o) {
          if (!(o.async && l.ignoreAsyncValidations) && !(l.validatorOptions && l.validatorOptions.stopAtFirstError && Object.keys(r.constraints || {}).length > 0)) {
            var s = {
              targetName: t.constructor ? t.constructor.name : void 0,
              property: i.propertyName,
              object: t,
              value: n,
              constraints: i.constraints
            };
            if (!i.each || !(Array.isArray(n) || n instanceof Set || n instanceof Map)) {
              var u = o.instance.validate(n, s);
              if (cs(u)) {
                var c = u.then(function(b) {
                  if (!b) {
                    var p = fl(l.createValidationError(t, n, i, o), 2), x = p[0], k = p[1];
                    r.constraints[x] = k, i.context && (r.contexts || (r.contexts = {}), r.contexts[x] = Object.assign(r.contexts[x] || {}, i.context));
                  }
                });
                l.awaitingPromises.push(c);
              } else if (!u) {
                var d = fl(l.createValidationError(t, n, i, o), 2), f = d[0], v = d[1];
                r.constraints[f] = v;
              }
              return;
            }
            var g = vw(n), m = g.map(function(b) {
              return o.instance.validate(b, s);
            }), h = m.some(function(b) {
              return cs(b);
            });
            if (h) {
              var w = m.map(function(b) {
                return cs(b) ? b : Promise.resolve(b);
              }), _ = Promise.all(w).then(function(b) {
                var p = b.every(function(A) {
                  return A;
                });
                if (!p) {
                  var x = fl(l.createValidationError(t, n, i, o), 2), k = x[0], V = x[1];
                  r.constraints[k] = V, i.context && (r.contexts || (r.contexts = {}), r.contexts[k] = Object.assign(r.contexts[k] || {}, i.context));
                }
              });
              l.awaitingPromises.push(_);
              return;
            }
            var I = m.every(function(b) {
              return b;
            });
            if (!I) {
              var C = fl(l.createValidationError(t, n, i, o), 2), f = C[0], v = C[1];
              r.constraints[f] = v;
            }
          }
        });
      });
    }, e.prototype.nestedValidations = function(t, n, a) {
      var r = this;
      t !== void 0 && n.forEach(function(l) {
        if (!(l.type !== un.NESTED_VALIDATION && l.type !== un.PROMISE_VALIDATION) && !(r.validatorOptions && r.validatorOptions.stopAtFirstError && Object.keys(a.constraints || {}).length > 0))
          if (Array.isArray(t) || t instanceof Set || t instanceof Map) {
            var i = t instanceof Set ? Array.from(t) : t;
            i.forEach(function(d, f) {
              r.performValidations(t, d, f.toString(), [], n, a.children);
            });
          } else if (t instanceof Object) {
            var o = typeof l.target == "string" ? l.target : l.target.name;
            r.execute(t, o, a.children);
          } else {
            var s = fl(r.createValidationError(l.target, t, l), 2), u = s[0], c = s[1];
            a.constraints[u] = c;
          }
      });
    }, e.prototype.mapContexts = function(t, n, a, r) {
      var l = this;
      return a.forEach(function(i) {
        if (i.context) {
          var o = void 0;
          if (i.type === un.CUSTOM_VALIDATION) {
            var s = l.metadataStorage.getTargetValidatorConstraints(i.constraintCls);
            o = s[0];
          }
          var u = l.getConstraintType(i, o);
          r.constraints[u] && (r.contexts || (r.contexts = {}), r.contexts[u] = Object.assign(r.contexts[u] || {}, i.context));
        }
      });
    }, e.prototype.createValidationError = function(t, n, a, r) {
      var l = t.constructor ? t.constructor.name : void 0, i = this.getConstraintType(a, r), o = {
        targetName: l,
        property: a.propertyName,
        object: t,
        value: n,
        constraints: a.constraints
      }, s = a.message || "";
      !a.message && (!this.validatorOptions || this.validatorOptions && !this.validatorOptions.dismissDefaultMessages) && r && r.instance.defaultMessage instanceof Function && (s = r.instance.defaultMessage(o));
      var u = bw.replaceMessageSpecialTokens(s, o);
      return [i, u];
    }, e.prototype.getConstraintType = function(t, n) {
      var a = n && n.name ? n.name : t.type;
      return a;
    }, e;
  })()
), pw = function(e, t, n, a) {
  function r(l) {
    return l instanceof n ? l : new n(function(i) {
      i(l);
    });
  }
  return new (n || (n = Promise))(function(l, i) {
    function o(c) {
      try {
        u(a.next(c));
      } catch (d) {
        i(d);
      }
    }
    function s(c) {
      try {
        u(a.throw(c));
      } catch (d) {
        i(d);
      }
    }
    function u(c) {
      c.done ? l(c.value) : r(c.value).then(o, s);
    }
    u((a = a.apply(e, t || [])).next());
  });
}, ww = function(e, t) {
  var n = { label: 0, sent: function() {
    if (l[0] & 1) throw l[1];
    return l[1];
  }, trys: [], ops: [] }, a, r, l, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(u) {
    return function(c) {
      return s([u, c]);
    };
  }
  function s(u) {
    if (a) throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, u[0] && (n = 0)), n; ) try {
      if (a = 1, r && (l = u[0] & 2 ? r.return : u[0] ? r.throw || ((l = r.return) && l.call(r), 0) : r.next) && !(l = l.call(r, u[1])).done) return l;
      switch (r = 0, l && (u = [u[0] & 2, l.value]), u[0]) {
        case 0:
        case 1:
          l = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, r = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (l = n.trys, !(l = l.length > 0 && l[l.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!l || u[1] > l[0] && u[1] < l[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < l[1]) {
            n.label = l[1], l = u;
            break;
          }
          if (l && n.label < l[2]) {
            n.label = l[2], n.ops.push(u);
            break;
          }
          l[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (c) {
      u = [6, c], r = 0;
    } finally {
      a = l = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Ed = (
  /** @class */
  (function() {
    function e() {
    }
    return e.prototype.validate = function(t, n, a) {
      return this.coreValidate(t, n, a);
    }, e.prototype.validateOrReject = function(t, n, a) {
      return pw(this, void 0, void 0, function() {
        var r;
        return ww(this, function(l) {
          switch (l.label) {
            case 0:
              return [4, this.coreValidate(t, n, a)];
            case 1:
              return r = l.sent(), r.length ? [2, Promise.reject(r)] : [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.validateSync = function(t, n, a) {
      var r = typeof t == "string" ? n : t, l = typeof t == "string" ? a : n, i = typeof t == "string" ? t : void 0, o = new Vd(this, l);
      o.ignoreAsyncValidations = !0;
      var s = [];
      return o.execute(r, i, s), o.stripEmptyErrors(s);
    }, e.prototype.coreValidate = function(t, n, a) {
      var r = typeof t == "string" ? n : t, l = typeof t == "string" ? a : n, i = typeof t == "string" ? t : void 0, o = new Vd(this, l), s = [];
      return o.execute(r, i, s), Promise.all(o.awaitingPromises).then(function() {
        return o.stripEmptyErrors(s);
      });
    }, e;
  })()
), kw = new /** @class */
((function() {
  function e() {
    this.instances = [];
  }
  return e.prototype.get = function(t) {
    var n = this.instances.find(function(a) {
      return a.type === t;
    });
    return n || (n = { type: t, object: new t() }, this.instances.push(n)), n.object;
  }, e;
})())();
function Ki(e) {
  return kw.get(e);
}
var Sw = (
  /** @class */
  (function() {
    function e(t, n, a) {
      a === void 0 && (a = !1), this.target = t, this.name = n, this.async = a;
    }
    return Object.defineProperty(e.prototype, "instance", {
      // -------------------------------------------------------------------------
      // Accessors
      // -------------------------------------------------------------------------
      /**
       * Instance of the target custom validation class which performs validation.
       */
      get: function() {
        return Ki(this.target);
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })()
);
function xw(e) {
  var t;
  if (e.validator instanceof Function) {
    t = e.validator;
    var n = Ki(dm).getTargetValidatorConstraints(e.validator);
    if (n.length > 1)
      throw "More than one implementation of ValidatorConstraintInterface found for validator on: ".concat(e.target.name, ":").concat(e.propertyName);
  } else {
    var a = e.validator;
    t = /** @class */
    (function() {
      function l() {
      }
      return l.prototype.validate = function(i, o) {
        return a.validate(i, o);
      }, l.prototype.defaultMessage = function(i) {
        return a.defaultMessage ? a.defaultMessage(i) : "";
      }, l;
    })(), Yi().addConstraintMetadata(new Sw(t, e.name, e.async));
  }
  var r = {
    type: e.name && un.isValid(e.name) ? e.name : un.CUSTOM_VALIDATION,
    name: e.name,
    target: e.target,
    propertyName: e.propertyName,
    validationOptions: e.options,
    constraintCls: t,
    constraints: e.constraints
  };
  Yi().addValidationMetadata(new Xu(r));
}
function or(e, t) {
  return function(n) {
    var a = t && t.each ? "each value in " : "";
    return e(a, n);
  };
}
function sr(e, t) {
  return function(n, a) {
    xw({
      name: e.name,
      target: n.constructor,
      propertyName: a,
      options: t,
      constraints: e.constraints,
      validator: e.validator
    });
  };
}
var Cw = "isOptional";
function Da(e) {
  return function(t, n) {
    var a = {
      type: un.CONDITIONAL_VALIDATION,
      name: Cw,
      target: t.constructor,
      propertyName: n,
      constraints: [
        function(r, l) {
          return r[n] !== null && r[n] !== void 0;
        }
      ],
      validationOptions: e
    };
    Yi().addValidationMetadata(new Xu(a));
  };
}
function Qu(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var hi = { exports: {} }, Md;
function Xr() {
  return Md || (Md = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    function n(a) {
      if (a == null) throw new TypeError("Expected a string but received a ".concat(a));
      if (a.constructor.name !== "String") throw new TypeError("Expected a string but received a ".concat(a.constructor.name));
    }
    e.exports = t.default, e.exports.default = t.default;
  })(hi, hi.exports)), hi.exports;
}
var gi = { exports: {} }, Od;
function fm() {
  return Od || (Od = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    function n() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
      for (var l in r)
        typeof a[l] > "u" && (a[l] = r[l]);
      return a;
    }
    e.exports = t.default, e.exports.default = t.default;
  })(gi, gi.exports)), gi.exports;
}
var _w = "isNotEmpty";
function Tw(e) {
  return e !== "" && e !== null && e !== void 0;
}
function po(e) {
  return sr({
    name: _w,
    validator: {
      validate: function(t, n) {
        return Tw(t);
      },
      defaultMessage: or(function(t) {
        return t + "$property should not be empty";
      }, e)
    }
  }, e);
}
var yi = { exports: {} }, Dd;
function Iw() {
  return Dd || (Dd = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = l;
    var n = a(/* @__PURE__ */ Xr());
    function a(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function r(i) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
        return typeof o;
      } : function(o) {
        return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, r(i);
    }
    function l(i, o) {
      (0, n.default)(i);
      var s, u;
      r(o) === "object" ? (s = o.min || 0, u = o.max) : (s = arguments[1], u = arguments[2]);
      var c = encodeURI(i).split(/%..|./).length - 1;
      return c >= s && (typeof u > "u" || c <= u);
    }
    e.exports = t.default, e.exports.default = t.default;
  })(yi, yi.exports)), yi.exports;
}
var bi = { exports: {} }, pi = { exports: {} }, Ld;
function Aw() {
  return Ld || (Ld = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function n(r) {
      return Object.prototype.toString.call(r) === "[object RegExp]";
    }
    function a(r, l) {
      for (var i = 0; i < l.length; i++) {
        var o = l[i];
        if (r === o || n(o) && o.test(r))
          return !0;
      }
      return !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  })(pi, pi.exports)), pi.exports;
}
var wi = { exports: {} }, Nd;
function Pw() {
  return Nd || (Nd = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var n = r(/* @__PURE__ */ Xr()), a = r(/* @__PURE__ */ fm());
    function r(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var l = {
      require_tld: !0,
      allow_underscores: !1,
      allow_trailing_dot: !1,
      allow_numeric_tld: !1,
      allow_wildcard: !1,
      ignore_max_length: !1
    };
    function i(o, s) {
      (0, n.default)(o), s = (0, a.default)(s, l), s.allow_trailing_dot && o[o.length - 1] === "." && (o = o.substring(0, o.length - 1)), s.allow_wildcard === !0 && o.indexOf("*.") === 0 && (o = o.substring(2));
      var u = o.split("."), c = u[u.length - 1];
      return s.require_tld && (u.length < 2 || !s.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(c) || /\s/.test(c)) || !s.allow_numeric_tld && /^\d+$/.test(c) ? !1 : u.every(function(d) {
        return !(d.length > 63 && !s.ignore_max_length || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(d) || /[\uff01-\uff5e]/.test(d) || /^-|-$/.test(d) || !s.allow_underscores && /_/.test(d));
      });
    }
    e.exports = t.default, e.exports.default = t.default;
  })(wi, wi.exports)), wi.exports;
}
var ki = { exports: {} }, Fd;
function Vw() {
  return Fd || (Fd = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var n = a(/* @__PURE__ */ Xr());
    function a(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function r(d) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(f) {
        return typeof f;
      } : function(f) {
        return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
      }, r(d);
    }
    var l = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", i = "(".concat(l, "[.]){3}").concat(l), o = new RegExp("^".concat(i, "$")), s = "(?:[0-9a-fA-F]{1,4})", u = new RegExp("^(" + "(?:".concat(s, ":){7}(?:").concat(s, "|:)|") + "(?:".concat(s, ":){6}(?:").concat(i, "|:").concat(s, "|:)|") + "(?:".concat(s, ":){5}(?::").concat(i, "|(:").concat(s, "){1,2}|:)|") + "(?:".concat(s, ":){4}(?:(:").concat(s, "){0,1}:").concat(i, "|(:").concat(s, "){1,3}|:)|") + "(?:".concat(s, ":){3}(?:(:").concat(s, "){0,2}:").concat(i, "|(:").concat(s, "){1,4}|:)|") + "(?:".concat(s, ":){2}(?:(:").concat(s, "){0,3}:").concat(i, "|(:").concat(s, "){1,5}|:)|") + "(?:".concat(s, ":){1}(?:(:").concat(s, "){0,4}:").concat(i, "|(:").concat(s, "){1,6}|:)|") + "(?::((?::".concat(s, "){0,5}:").concat(i, "|(?::").concat(s, "){1,7}|:))") + ")(%[0-9a-zA-Z.]{1,})?$");
    function c(d) {
      var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, n.default)(d);
      var v = (r(f) === "object" ? f.version : arguments[1]) || "";
      return v ? v.toString() === "4" ? o.test(d) : v.toString() === "6" ? u.test(d) : !1 : c(d, {
        version: 4
      }) || c(d, {
        version: 6
      });
    }
    e.exports = t.default, e.exports.default = t.default;
  })(ki, ki.exports)), ki.exports;
}
var Rd;
function Ew() {
  return Rd || (Rd = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = _;
    var n = s(/* @__PURE__ */ Xr()), a = s(/* @__PURE__ */ Aw()), r = s(/* @__PURE__ */ Iw()), l = s(/* @__PURE__ */ Pw()), i = s(/* @__PURE__ */ Vw()), o = s(/* @__PURE__ */ fm());
    function s(I) {
      return I && I.__esModule ? I : { default: I };
    }
    var u = {
      allow_display_name: !1,
      allow_underscores: !1,
      require_display_name: !1,
      allow_utf8_local_part: !0,
      require_tld: !0,
      blacklisted_chars: "",
      ignore_max_length: !1,
      host_blacklist: [],
      host_whitelist: []
    }, c = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i, d = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, f = /^[a-z\d]+$/, v = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, g = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, m = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, h = 254;
    function w(I) {
      var C = I.replace(/^"(.+)"$/, "$1");
      if (!C.trim())
        return !1;
      var b = /[\.";<>]/.test(C);
      if (b) {
        if (C === I)
          return !1;
        var p = C.split('"').length === C.split('\\"').length;
        if (!p)
          return !1;
      }
      return !0;
    }
    function _(I, C) {
      if ((0, n.default)(I), C = (0, o.default)(C, u), C.require_display_name || C.allow_display_name) {
        var b = I.match(c);
        if (b) {
          var p = b[1];
          if (I = I.replace(p, "").replace(/(^<|>$)/g, ""), p.endsWith(" ") && (p = p.slice(0, -1)), !w(p))
            return !1;
        } else if (C.require_display_name)
          return !1;
      }
      if (!C.ignore_max_length && I.length > h)
        return !1;
      var x = I.split("@"), k = x.pop(), V = k.toLowerCase();
      if (C.host_blacklist.length > 0 && (0, a.default)(V, C.host_blacklist) || C.host_whitelist.length > 0 && !(0, a.default)(V, C.host_whitelist))
        return !1;
      var A = x.join("@");
      if (C.domain_specific_validation && (V === "gmail.com" || V === "googlemail.com")) {
        A = A.toLowerCase();
        var M = A.split("+")[0];
        if (!(0, r.default)(M.replace(/\./g, ""), {
          min: 6,
          max: 30
        }))
          return !1;
        for (var L = M.split("."), E = 0; E < L.length; E++)
          if (!f.test(L[E]))
            return !1;
      }
      if (C.ignore_max_length === !1 && (!(0, r.default)(A, {
        max: 64
      }) || !(0, r.default)(k, {
        max: 254
      })))
        return !1;
      if (!(0, l.default)(k, {
        require_tld: C.require_tld,
        ignore_max_length: C.ignore_max_length,
        allow_underscores: C.allow_underscores
      })) {
        if (!C.allow_ip_domain)
          return !1;
        if (!(0, i.default)(k)) {
          if (!k.startsWith("[") || !k.endsWith("]"))
            return !1;
          var P = k.slice(1, -1);
          if (P.length === 0 || !(0, i.default)(P))
            return !1;
        }
      }
      if (C.blacklisted_chars && A.search(new RegExp("[".concat(C.blacklisted_chars, "]+"), "g")) !== -1)
        return !1;
      if (A[0] === '"' && A[A.length - 1] === '"')
        return A = A.slice(1, A.length - 1), C.allow_utf8_local_part ? m.test(A) : v.test(A);
      for (var O = C.allow_utf8_local_part ? g : d, F = A.split("."), B = 0; B < F.length; B++)
        if (!O.test(F[B]))
          return !1;
      return !0;
    }
    e.exports = t.default, e.exports.default = t.default;
  })(bi, bi.exports)), bi.exports;
}
var Mw = /* @__PURE__ */ Ew();
const Ow = /* @__PURE__ */ Qu(Mw);
var Dw = "isEmail";
function Us(e, t) {
  return typeof e == "string" && Ow(e, t);
}
function ec(e, t) {
  return sr({
    name: Dw,
    constraints: [e],
    validator: {
      validate: function(n, a) {
        return Us(n, a?.constraints[0]);
      },
      defaultMessage: or(function(n) {
        return n + "$property must be an email";
      }, t)
    }
  }, t);
}
var Si = { exports: {} }, $d;
function Lw() {
  return $d || ($d = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = l;
    var n = a(/* @__PURE__ */ Xr());
    function a(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var r = {
      1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      6: /^[0-9A-F]{8}-[0-9A-F]{4}-6[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      7: /^[0-9A-F]{8}-[0-9A-F]{4}-7[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      8: /^[0-9A-F]{8}-[0-9A-F]{4}-8[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      nil: /^00000000-0000-0000-0000-000000000000$/i,
      max: /^ffffffff-ffff-ffff-ffff-ffffffffffff$/i,
      loose: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
      // From https://github.com/uuidjs/uuid/blob/main/src/regex.js
      all: /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i
    };
    function l(i, o) {
      return (0, n.default)(i), o == null && (o = "all"), o in r ? r[o].test(i) : !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  })(Si, Si.exports)), Si.exports;
}
var Nw = /* @__PURE__ */ Lw();
const Fw = /* @__PURE__ */ Qu(Nw);
var Rw = "isUuid";
function Zi(e, t) {
  return typeof e == "string" && Fw(e, t);
}
function Qr(e, t) {
  return sr({
    name: Rw,
    constraints: [e],
    validator: {
      validate: function(n, a) {
        return Zi(n, a?.constraints[0]);
      },
      defaultMessage: or(function(n) {
        return n + "$property must be a UUID";
      }, t)
    }
  }, t);
}
var xi = { exports: {} }, Bd;
function $w() {
  return Bd || (Bd = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = l;
    var n = a(/* @__PURE__ */ Xr());
    function a(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function r(i) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
        return typeof o;
      } : function(o) {
        return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, r(i);
    }
    function l(i, o) {
      (0, n.default)(i);
      var s, u;
      r(o) === "object" ? (s = o.min || 0, u = o.max) : (s = arguments[1] || 0, u = arguments[2]);
      var c = i.match(/[^\uFE0F\uFE0E][\uFE0F\uFE0E]/g) || [], d = i.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [], f = i.length - c.length - d.length, v = f >= s && (typeof u > "u" || f <= u);
      return v && Array.isArray(o?.discreteLengths) ? o.discreteLengths.some(function(g) {
        return g === f;
      }) : v;
    }
    e.exports = t.default, e.exports.default = t.default;
  })(xi, xi.exports)), xi.exports;
}
var Bw = /* @__PURE__ */ $w();
const Uw = /* @__PURE__ */ Qu(Bw);
var Ww = "maxLength";
function Hw(e, t) {
  return typeof e == "string" && Uw(e, { min: 0, max: t });
}
function zw(e, t) {
  return sr({
    name: Ww,
    constraints: [e],
    validator: {
      validate: function(n, a) {
        return Hw(n, a?.constraints[0]);
      },
      defaultMessage: or(function(n) {
        return n + "$property must be shorter than or equal to $constraint1 characters";
      }, t)
    }
  }, t);
}
var Ud = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var a = n.call(e), r, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = a.next()).done; ) l.push(r.value);
  } catch (o) {
    i = { error: o };
  } finally {
    try {
      r && !r.done && (n = a.return) && n.call(a);
    } finally {
      if (i) throw i.error;
    }
  }
  return l;
}, jw = "isEnum";
function Gw(e, t) {
  var n = Object.keys(t).map(function(a) {
    return t[a];
  });
  return n.includes(e);
}
function qw(e) {
  return Object.entries(e).filter(function(t) {
    var n = Ud(t, 2), a = n[0];
    return n[1], isNaN(parseInt(a));
  }).map(function(t) {
    var n = Ud(t, 2);
    n[0];
    var a = n[1];
    return a;
  });
}
function vm(e, t) {
  return sr({
    name: jw,
    constraints: [e, qw(e)],
    validator: {
      validate: function(n, a) {
        return Gw(n, a?.constraints[0]);
      },
      defaultMessage: or(function(n) {
        return n + "$property must be one of the following values: $constraint2";
      }, t)
    }
  }, t);
}
var Yw = "isString";
function Kw(e) {
  return e instanceof String || typeof e == "string";
}
function wo(e) {
  return sr({
    name: Yw,
    validator: {
      validate: function(t, n) {
        return Kw(t);
      },
      defaultMessage: or(function(t) {
        return t + "$property must be a string";
      }, e)
    }
  }, e);
}
var Zw = "isArray";
function Jw(e) {
  return Array.isArray(e);
}
function mm(e) {
  return sr({
    name: Zw,
    validator: {
      validate: function(t, n) {
        return Jw(t);
      },
      defaultMessage: or(function(t) {
        return t + "$property must be an array";
      }, e)
    }
  }, e);
}
function Xw(e, t, n) {
  return typeof e == "string" ? Ki(Ed).validate(e, t, n) : Ki(Ed).validate(e, t);
}
var Ji = /* @__PURE__ */ ((e) => (e.ADMIN = "ADMIN", e.BASIC = "BASIC", e))(Ji || {}), Xi = /* @__PURE__ */ ((e) => (e.ADMIN = "ADMIN", e.BASIC = "BASIC", e))(Xi || {}), We;
(function(e) {
  e[e.PLAIN_TO_CLASS = 0] = "PLAIN_TO_CLASS", e[e.CLASS_TO_PLAIN = 1] = "CLASS_TO_PLAIN", e[e.CLASS_TO_CLASS = 2] = "CLASS_TO_CLASS";
})(We || (We = {}));
var Qw = (
  /** @class */
  (function() {
    function e() {
      this._typeMetadatas = /* @__PURE__ */ new Map(), this._transformMetadatas = /* @__PURE__ */ new Map(), this._exposeMetadatas = /* @__PURE__ */ new Map(), this._excludeMetadatas = /* @__PURE__ */ new Map(), this._ancestorsMap = /* @__PURE__ */ new Map();
    }
    return e.prototype.addTypeMetadata = function(t) {
      this._typeMetadatas.has(t.target) || this._typeMetadatas.set(t.target, /* @__PURE__ */ new Map()), this._typeMetadatas.get(t.target).set(t.propertyName, t);
    }, e.prototype.addTransformMetadata = function(t) {
      this._transformMetadatas.has(t.target) || this._transformMetadatas.set(t.target, /* @__PURE__ */ new Map()), this._transformMetadatas.get(t.target).has(t.propertyName) || this._transformMetadatas.get(t.target).set(t.propertyName, []), this._transformMetadatas.get(t.target).get(t.propertyName).push(t);
    }, e.prototype.addExposeMetadata = function(t) {
      this._exposeMetadatas.has(t.target) || this._exposeMetadatas.set(t.target, /* @__PURE__ */ new Map()), this._exposeMetadatas.get(t.target).set(t.propertyName, t);
    }, e.prototype.addExcludeMetadata = function(t) {
      this._excludeMetadatas.has(t.target) || this._excludeMetadatas.set(t.target, /* @__PURE__ */ new Map()), this._excludeMetadatas.get(t.target).set(t.propertyName, t);
    }, e.prototype.findTransformMetadatas = function(t, n, a) {
      return this.findMetadatas(this._transformMetadatas, t, n).filter(function(r) {
        return !r.options || r.options.toClassOnly === !0 && r.options.toPlainOnly === !0 ? !0 : r.options.toClassOnly === !0 ? a === We.CLASS_TO_CLASS || a === We.PLAIN_TO_CLASS : r.options.toPlainOnly === !0 ? a === We.CLASS_TO_PLAIN : !0;
      });
    }, e.prototype.findExcludeMetadata = function(t, n) {
      return this.findMetadata(this._excludeMetadatas, t, n);
    }, e.prototype.findExposeMetadata = function(t, n) {
      return this.findMetadata(this._exposeMetadatas, t, n);
    }, e.prototype.findExposeMetadataByCustomName = function(t, n) {
      return this.getExposedMetadatas(t).find(function(a) {
        return a.options && a.options.name === n;
      });
    }, e.prototype.findTypeMetadata = function(t, n) {
      return this.findMetadata(this._typeMetadatas, t, n);
    }, e.prototype.getStrategy = function(t) {
      var n = this._excludeMetadatas.get(t), a = n && n.get(void 0), r = this._exposeMetadatas.get(t), l = r && r.get(void 0);
      return a && l || !a && !l ? "none" : a ? "excludeAll" : "exposeAll";
    }, e.prototype.getExposedMetadatas = function(t) {
      return this.getMetadata(this._exposeMetadatas, t);
    }, e.prototype.getExcludedMetadatas = function(t) {
      return this.getMetadata(this._excludeMetadatas, t);
    }, e.prototype.getExposedProperties = function(t, n) {
      return this.getExposedMetadatas(t).filter(function(a) {
        return !a.options || a.options.toClassOnly === !0 && a.options.toPlainOnly === !0 ? !0 : a.options.toClassOnly === !0 ? n === We.CLASS_TO_CLASS || n === We.PLAIN_TO_CLASS : a.options.toPlainOnly === !0 ? n === We.CLASS_TO_PLAIN : !0;
      }).map(function(a) {
        return a.propertyName;
      });
    }, e.prototype.getExcludedProperties = function(t, n) {
      return this.getExcludedMetadatas(t).filter(function(a) {
        return !a.options || a.options.toClassOnly === !0 && a.options.toPlainOnly === !0 ? !0 : a.options.toClassOnly === !0 ? n === We.CLASS_TO_CLASS || n === We.PLAIN_TO_CLASS : a.options.toPlainOnly === !0 ? n === We.CLASS_TO_PLAIN : !0;
      }).map(function(a) {
        return a.propertyName;
      });
    }, e.prototype.clear = function() {
      this._typeMetadatas.clear(), this._exposeMetadatas.clear(), this._excludeMetadatas.clear(), this._ancestorsMap.clear();
    }, e.prototype.getMetadata = function(t, n) {
      var a = t.get(n), r;
      a && (r = Array.from(a.values()).filter(function(d) {
        return d.propertyName !== void 0;
      }));
      for (var l = [], i = 0, o = this.getAncestors(n); i < o.length; i++) {
        var s = o[i], u = t.get(s);
        if (u) {
          var c = Array.from(u.values()).filter(function(d) {
            return d.propertyName !== void 0;
          });
          l.push.apply(l, c);
        }
      }
      return l.concat(r || []);
    }, e.prototype.findMetadata = function(t, n, a) {
      var r = t.get(n);
      if (r) {
        var l = r.get(a);
        if (l)
          return l;
      }
      for (var i = 0, o = this.getAncestors(n); i < o.length; i++) {
        var s = o[i], u = t.get(s);
        if (u) {
          var c = u.get(a);
          if (c)
            return c;
        }
      }
    }, e.prototype.findMetadatas = function(t, n, a) {
      var r = t.get(n), l;
      r && (l = r.get(a));
      for (var i = [], o = 0, s = this.getAncestors(n); o < s.length; o++) {
        var u = s[o], c = t.get(u);
        c && c.has(a) && i.push.apply(i, c.get(a));
      }
      return i.slice().reverse().concat((l || []).slice().reverse());
    }, e.prototype.getAncestors = function(t) {
      if (!t)
        return [];
      if (!this._ancestorsMap.has(t)) {
        for (var n = [], a = Object.getPrototypeOf(t.prototype.constructor); typeof a.prototype < "u"; a = Object.getPrototypeOf(a.prototype.constructor))
          n.push(a);
        this._ancestorsMap.set(t, n);
      }
      return this._ancestorsMap.get(t);
    }, e;
  })()
), ln = new Qw();
function ek() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof global < "u")
    return global;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
}
function tk(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var Wd = function(e, t, n) {
  if (n || arguments.length === 2) for (var a = 0, r = t.length, l; a < r; a++)
    (l || !(a in t)) && (l || (l = Array.prototype.slice.call(t, 0, a)), l[a] = t[a]);
  return e.concat(l || Array.prototype.slice.call(t));
};
function nk(e) {
  var t = new e();
  return !(t instanceof Set) && !("push" in t) ? [] : t;
}
var wr = (
  /** @class */
  (function() {
    function e(t, n) {
      this.transformationType = t, this.options = n, this.recursionStack = /* @__PURE__ */ new Set();
    }
    return e.prototype.transform = function(t, n, a, r, l, i) {
      var o = this;
      if (i === void 0 && (i = 0), Array.isArray(n) || n instanceof Set) {
        var s = r && this.transformationType === We.PLAIN_TO_CLASS ? nk(r) : [];
        return n.forEach(function(h, w) {
          var _ = t ? t[w] : void 0;
          if (!o.options.enableCircularCheck || !o.isCircular(h)) {
            var I = void 0;
            if (typeof a != "function" && a && a.options && a.options.discriminator && a.options.discriminator.property && a.options.discriminator.subTypes) {
              if (o.transformationType === We.PLAIN_TO_CLASS) {
                I = a.options.discriminator.subTypes.find(function(x) {
                  return x.name === h[a.options.discriminator.property];
                });
                var C = { newObject: s, object: h, property: void 0 }, b = a.typeFunction(C);
                I === void 0 ? I = b : I = I.value, a.options.keepDiscriminatorProperty || delete h[a.options.discriminator.property];
              }
              o.transformationType === We.CLASS_TO_CLASS && (I = h.constructor), o.transformationType === We.CLASS_TO_PLAIN && (h[a.options.discriminator.property] = a.options.discriminator.subTypes.find(function(x) {
                return x.value === h.constructor;
              }).name);
            } else
              I = a;
            var p = o.transform(_, h, I, void 0, h instanceof Map, i + 1);
            s instanceof Set ? s.add(p) : s.push(p);
          } else o.transformationType === We.CLASS_TO_CLASS && (s instanceof Set ? s.add(h) : s.push(h));
        }), s;
      } else {
        if (a === String && !l)
          return n == null ? n : String(n);
        if (a === Number && !l)
          return n == null ? n : Number(n);
        if (a === Boolean && !l)
          return n == null ? n : !!n;
        if ((a === Date || n instanceof Date) && !l)
          return n instanceof Date ? new Date(n.valueOf()) : n == null ? n : new Date(n);
        if (ek().Buffer && (a === Buffer || n instanceof Buffer) && !l)
          return n == null ? n : Buffer.from(n);
        if (tk(n) && !l)
          return new Promise(function(h, w) {
            n.then(function(_) {
              return h(o.transform(void 0, _, a, void 0, void 0, i + 1));
            }, w);
          });
        if (!l && n !== null && typeof n == "object" && typeof n.then == "function")
          return n;
        if (typeof n == "object" && n !== null) {
          !a && n.constructor !== Object && (!Array.isArray(n) && n.constructor === Array || (a = n.constructor)), !a && t && (a = t.constructor), this.options.enableCircularCheck && this.recursionStack.add(n);
          var u = this.getKeys(a, n, l), c = t || {};
          !t && (this.transformationType === We.PLAIN_TO_CLASS || this.transformationType === We.CLASS_TO_CLASS) && (l ? c = /* @__PURE__ */ new Map() : a ? c = new a() : c = {});
          for (var d = function(h) {
            if (h === "__proto__" || h === "constructor")
              return "continue";
            var w = h, _ = h, I = h;
            if (!f.options.ignoreDecorators && a) {
              if (f.transformationType === We.PLAIN_TO_CLASS) {
                var C = ln.findExposeMetadataByCustomName(a, h);
                C && (I = C.propertyName, _ = C.propertyName);
              } else if (f.transformationType === We.CLASS_TO_PLAIN || f.transformationType === We.CLASS_TO_CLASS) {
                var C = ln.findExposeMetadata(a, h);
                C && C.options && C.options.name && (_ = C.options.name);
              }
            }
            var b = void 0;
            f.transformationType === We.PLAIN_TO_CLASS ? b = n[w] : n instanceof Map ? b = n.get(w) : n[w] instanceof Function ? b = n[w]() : b = n[w];
            var p = void 0, x = b instanceof Map;
            if (a && l)
              p = a;
            else if (a) {
              var k = ln.findTypeMetadata(a, I);
              if (k) {
                var V = { newObject: c, object: n, property: I }, A = k.typeFunction ? k.typeFunction(V) : k.reflectedType;
                k.options && k.options.discriminator && k.options.discriminator.property && k.options.discriminator.subTypes ? n[w] instanceof Array ? p = k : (f.transformationType === We.PLAIN_TO_CLASS && (p = k.options.discriminator.subTypes.find(function(B) {
                  if (b && b instanceof Object && k.options.discriminator.property in b)
                    return B.name === b[k.options.discriminator.property];
                }), p === void 0 ? p = A : p = p.value, k.options.keepDiscriminatorProperty || b && b instanceof Object && k.options.discriminator.property in b && delete b[k.options.discriminator.property]), f.transformationType === We.CLASS_TO_CLASS && (p = b.constructor), f.transformationType === We.CLASS_TO_PLAIN && b && (b[k.options.discriminator.property] = k.options.discriminator.subTypes.find(function(B) {
                  return B.value === b.constructor;
                }).name)) : p = A, x = x || k.reflectedType === Map;
              } else if (f.options.targetMaps)
                f.options.targetMaps.filter(function(B) {
                  return B.target === a && !!B.properties[I];
                }).forEach(function(B) {
                  return p = B.properties[I];
                });
              else if (f.options.enableImplicitConversion && f.transformationType === We.PLAIN_TO_CLASS) {
                var M = Reflect.getMetadata("design:type", a.prototype, I);
                M && (p = M);
              }
            }
            var L = Array.isArray(n[w]) ? f.getReflectedType(a, I) : void 0, E = t ? t[w] : void 0;
            if (c.constructor.prototype) {
              var P = Object.getOwnPropertyDescriptor(c.constructor.prototype, _);
              if ((f.transformationType === We.PLAIN_TO_CLASS || f.transformationType === We.CLASS_TO_CLASS) && // eslint-disable-next-line @typescript-eslint/unbound-method
              (P && !P.set || c[_] instanceof Function))
                return "continue";
            }
            if (!f.options.enableCircularCheck || !f.isCircular(b)) {
              var O = f.transformationType === We.PLAIN_TO_CLASS ? _ : h, F = void 0;
              f.transformationType === We.CLASS_TO_PLAIN ? (F = n[O], F = f.applyCustomTransformations(F, a, O, n, f.transformationType), F = n[O] === F ? b : F, F = f.transform(E, F, p, L, x, i + 1)) : b === void 0 && f.options.exposeDefaultValues ? F = c[_] : (F = f.transform(E, b, p, L, x, i + 1), F = f.applyCustomTransformations(F, a, O, n, f.transformationType)), (F !== void 0 || f.options.exposeUnsetFields) && (c instanceof Map ? c.set(_, F) : c[_] = F);
            } else if (f.transformationType === We.CLASS_TO_CLASS) {
              var F = b;
              F = f.applyCustomTransformations(F, a, h, n, f.transformationType), (F !== void 0 || f.options.exposeUnsetFields) && (c instanceof Map ? c.set(_, F) : c[_] = F);
            }
          }, f = this, v = 0, g = u; v < g.length; v++) {
            var m = g[v];
            d(m);
          }
          return this.options.enableCircularCheck && this.recursionStack.delete(n), c;
        } else
          return n;
      }
    }, e.prototype.applyCustomTransformations = function(t, n, a, r, l) {
      var i = this, o = ln.findTransformMetadatas(n, a, this.transformationType);
      return this.options.version !== void 0 && (o = o.filter(function(s) {
        return s.options ? i.checkVersion(s.options.since, s.options.until) : !0;
      })), this.options.groups && this.options.groups.length ? o = o.filter(function(s) {
        return s.options ? i.checkGroups(s.options.groups) : !0;
      }) : o = o.filter(function(s) {
        return !s.options || !s.options.groups || !s.options.groups.length;
      }), o.forEach(function(s) {
        t = s.transformFn({ value: t, key: a, obj: r, type: l, options: i.options });
      }), t;
    }, e.prototype.isCircular = function(t) {
      return this.recursionStack.has(t);
    }, e.prototype.getReflectedType = function(t, n) {
      if (t) {
        var a = ln.findTypeMetadata(t, n);
        return a ? a.reflectedType : void 0;
      }
    }, e.prototype.getKeys = function(t, n, a) {
      var r = this, l = ln.getStrategy(t);
      l === "none" && (l = this.options.strategy || "exposeAll");
      var i = [];
      if ((l === "exposeAll" || a) && (n instanceof Map ? i = Array.from(n.keys()) : i = Object.keys(n)), a)
        return i;
      if (this.options.ignoreDecorators && this.options.excludeExtraneousValues && t) {
        var o = ln.getExposedProperties(t, this.transformationType), s = ln.getExcludedProperties(t, this.transformationType);
        i = Wd(Wd([], o, !0), s, !0);
      }
      if (!this.options.ignoreDecorators && t) {
        var o = ln.getExposedProperties(t, this.transformationType);
        this.transformationType === We.PLAIN_TO_CLASS && (o = o.map(function(d) {
          var f = ln.findExposeMetadata(t, d);
          return f && f.options && f.options.name ? f.options.name : d;
        })), this.options.excludeExtraneousValues ? i = o : i = i.concat(o);
        var u = ln.getExcludedProperties(t, this.transformationType);
        u.length > 0 && (i = i.filter(function(d) {
          return !u.includes(d);
        })), this.options.version !== void 0 && (i = i.filter(function(d) {
          var f = ln.findExposeMetadata(t, d);
          return !f || !f.options ? !0 : r.checkVersion(f.options.since, f.options.until);
        })), this.options.groups && this.options.groups.length ? i = i.filter(function(d) {
          var f = ln.findExposeMetadata(t, d);
          return !f || !f.options ? !0 : r.checkGroups(f.options.groups);
        }) : i = i.filter(function(d) {
          var f = ln.findExposeMetadata(t, d);
          return !f || !f.options || !f.options.groups || !f.options.groups.length;
        });
      }
      return this.options.excludePrefixes && this.options.excludePrefixes.length && (i = i.filter(function(c) {
        return r.options.excludePrefixes.every(function(d) {
          return c.substr(0, d.length) !== d;
        });
      })), i = i.filter(function(c, d, f) {
        return f.indexOf(c) === d;
      }), i;
    }, e.prototype.checkVersion = function(t, n) {
      var a = !0;
      return a && t && (a = this.options.version >= t), a && n && (a = this.options.version < n), a;
    }, e.prototype.checkGroups = function(t) {
      return t ? this.options.groups.some(function(n) {
        return t.includes(n);
      }) : !0;
    }, e;
  })()
), kr = {
  enableCircularCheck: !1,
  enableImplicitConversion: !1,
  excludeExtraneousValues: !1,
  excludePrefixes: void 0,
  exposeDefaultValues: !1,
  exposeUnsetFields: !0,
  groups: void 0,
  ignoreDecorators: !1,
  strategy: void 0,
  targetMaps: void 0,
  version: void 0
}, on = function() {
  return on = Object.assign || function(e) {
    for (var t, n = 1, a = arguments.length; n < a; n++) {
      t = arguments[n];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, on.apply(this, arguments);
}, ak = (
  /** @class */
  (function() {
    function e() {
    }
    return e.prototype.instanceToPlain = function(t, n) {
      var a = new wr(We.CLASS_TO_PLAIN, on(on({}, kr), n));
      return a.transform(void 0, t, void 0, void 0, void 0, void 0);
    }, e.prototype.classToPlainFromExist = function(t, n, a) {
      var r = new wr(We.CLASS_TO_PLAIN, on(on({}, kr), a));
      return r.transform(n, t, void 0, void 0, void 0, void 0);
    }, e.prototype.plainToInstance = function(t, n, a) {
      var r = new wr(We.PLAIN_TO_CLASS, on(on({}, kr), a));
      return r.transform(void 0, n, t, void 0, void 0, void 0);
    }, e.prototype.plainToClassFromExist = function(t, n, a) {
      var r = new wr(We.PLAIN_TO_CLASS, on(on({}, kr), a));
      return r.transform(t, n, void 0, void 0, void 0, void 0);
    }, e.prototype.instanceToInstance = function(t, n) {
      var a = new wr(We.CLASS_TO_CLASS, on(on({}, kr), n));
      return a.transform(void 0, t, void 0, void 0, void 0, void 0);
    }, e.prototype.classToClassFromExist = function(t, n, a) {
      var r = new wr(We.CLASS_TO_CLASS, on(on({}, kr), a));
      return r.transform(n, t, void 0, void 0, void 0, void 0);
    }, e.prototype.serialize = function(t, n) {
      return JSON.stringify(this.instanceToPlain(t, n));
    }, e.prototype.deserialize = function(t, n, a) {
      var r = JSON.parse(n);
      return this.plainToInstance(t, r, a);
    }, e.prototype.deserializeArray = function(t, n, a) {
      var r = JSON.parse(n);
      return this.plainToInstance(t, r, a);
    }, e;
  })()
), rk = new ak();
function lk(e, t, n) {
  return rk.plainToInstance(e, t, n);
}
const { isArray: ik } = Array;
function hm(e) {
  const t = ik(e) ? Array(e.length) : {};
  if (e && e.getTime) return new Date(e.getTime());
  for (const n in e) {
    const a = e[n];
    t[n] = typeof a == "object" && a !== null ? a.getTime ? new Date(a.getTime()) : hm(a) : a;
  }
  return t;
}
class Je {
  // Static method to create a DTO from JSON
  static fromJson(t, n) {
    const a = lk(n, t);
    return a.setInitialState(), a;
  }
  // Static method for paginated responses
  static fromPaginatedJson(t, n) {
    return {
      items: t.items.map((r) => Je.fromJson(r, n)),
      page: t.pageNumber,
      itemsPerPage: t.itemsPerPage,
      total: t.total,
      totalFiltered: t.totalFiltered
    };
  }
  // This metadata is removed before sending the object to the backend #file: request.helper.ts
  initialState = null;
  isEditingMode = !1;
  // Deep copy of the object
  clone() {
    return hm(this);
  }
  setInitialState() {
    this.initialState = this.clone();
  }
  resetToInitialState() {
    if (!this.initialState)
      return;
    const { isEditingMode: t, ...n } = this.initialState;
    Object.assign(this, n), this.setInitialState();
  }
  hasChanged() {
    if (!this.initialState)
      return !1;
    const { initialState: t, isEditingMode: n, ...a } = this, { initialState: r, isEditingMode: l, ...i } = this.initialState, o = (s) => {
      for (const u in s)
        Array.isArray(s[u]) ? s[u].sort() : typeof s[u] == "object" && s[u] !== null && o(s[u]);
    };
    return o(i), o(a), console.log(`initialStateCopy: ${JSON.stringify(i)}`), console.log(`currentState: ${JSON.stringify(a)}`), JSON.stringify(i) !== JSON.stringify(a);
  }
  activateEditingMode() {
    this.isEditingMode = !0;
  }
  deactivateEditingMode() {
    this.isEditingMode = !1;
  }
  // Validate the current instance
  async validate() {
    return await Xw(this);
  }
}
var ok = Object.defineProperty, tc = (e, t, n, a) => {
  for (var r = void 0, l = e.length - 1, i; l >= 0; l--)
    (i = e[l]) && (r = i(t, n, r) || r);
  return r && ok(t, n, r), r;
};
const ko = class gm extends Je {
  static emtpy() {
    const t = new gm();
    return t.emailAddress = "", t.roles = [], t.setInitialState(), t;
  }
  id;
  emailAddress;
  roles;
};
tc([
  Da(),
  Qr()
], ko.prototype, "id");
tc([
  po(),
  ec()
], ko.prototype, "emailAddress");
tc([
  mm(),
  vm(Ji, { each: !0 })
], ko.prototype, "roles");
let Ga = ko;
var sk = Object.defineProperty, nc = (e, t, n, a) => {
  for (var r = void 0, l = e.length - 1, i; l >= 0; l--)
    (i = e[l]) && (r = i(t, n, r) || r);
  return r && sk(t, n, r), r;
};
const So = class ym extends Je {
  static emtpy() {
    const t = new ym();
    return t.emailAddress = "", t.roles = [], t.setInitialState(), t;
  }
  id;
  emailAddress;
  roles;
};
nc([
  Da(),
  Qr()
], So.prototype, "id");
nc([
  po(),
  ec()
], So.prototype, "emailAddress");
nc([
  mm(),
  vm(Xi, { each: !0 })
], So.prototype, "roles");
let Cl = So;
const uk = { class: "text-subtitle-1 text-high-emphasis" }, ck = /* @__PURE__ */ Qt({
  __name: "MemberManagement",
  props: {
    member: {}
  },
  emits: ["add:member", "update:member", "remove:member", "cancel:member"],
  setup(e, { emit: t }) {
    const { t: n } = mn(), { xs: a } = tw(), r = e, l = t;
    ne(
      () => r.member,
      (h, w) => {
      },
      { deep: !0 }
    );
    const i = T(() => r.member instanceof Ga ? Object.values(Ji) : Object.values(Xi)), o = T(() => r.member instanceof Ga ? [Ji.BASIC] : [Xi.BASIC]), s = T(() => !Zi(r.member.id)), u = T(() => !s.value), c = T(() => r.member.isEditingMode || s.value), d = G(""), f = async (h) => {
      l("add:member", h);
    }, v = (h) => {
      h.resetToInitialState(), h.deactivateEditingMode(), l("cancel:member", h);
    }, g = (h) => {
      l("update:member", h);
    }, m = (h) => {
      l("remove:member", h);
    };
    return (h, w) => {
      const _ = de("v-text-field"), I = de("v-card-text"), C = de("v-btn"), b = de("v-tooltip"), p = de("v-card-actions"), x = de("v-card"), k = de("v-card-title"), V = de("v-card-subtitle"), A = de("v-icon"), M = de("v-avatar");
      return c.value ? (ge(), _e(x, { key: 0 }, {
        default: q(() => [
          y(I, null, {
            default: q(() => [
              S("div", uk, ce(Z(n)("memberManagement.memberEmail")), 1),
              y(_, {
                modelValue: e.member.emailAddress,
                "onUpdate:modelValue": w[0] || (w[0] = (L) => e.member.emailAddress = L),
                label: Z(n)("memberManagement.email"),
                type: "email",
                "prepend-inner-icon": "mdi-email-outline",
                required: "",
                disabled: u.value,
                "hide-details": u.value,
                "error-messages": d.value
              }, null, 8, ["modelValue", "label", "disabled", "hide-details", "error-messages"]),
              y(Bs, {
                modelValue: e.member.roles,
                "onUpdate:modelValue": w[1] || (w[1] = (L) => e.member.roles = L),
                label: Z(n)("memberManagement.roles"),
                selections: i.value,
                loading: !1,
                "always-selected": o.value
              }, null, 8, ["modelValue", "label", "selections", "always-selected"])
            ]),
            _: 1
          }),
          y(p, null, {
            default: q(() => [
              y(C, {
                onClick: w[2] || (w[2] = zn((L) => v(e.member), ["prevent"])),
                color: "error"
              }, {
                default: q(() => [
                  we(ce(Z(n)("general.cancel")), 1)
                ]),
                _: 1
              }),
              y(b, {
                disabled: e.member.hasChanged() && Z(Us)(e.member.emailAddress)
              }, {
                activator: q(({ props: L }) => [
                  S("div", am(rm(L)), [
                    u.value ? (ge(), _e(C, {
                      key: 0,
                      onClick: w[3] || (w[3] = zn((E) => g(e.member), ["prevent"])),
                      color: "primary",
                      disabled: !e.member.hasChanged()
                    }, {
                      default: q(() => [
                        we(ce(Z(n)("general.update")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])) : (ge(), _e(C, {
                      key: 1,
                      onClick: w[4] || (w[4] = zn((E) => f(e.member), ["prevent"])),
                      color: "primary",
                      disabled: !e.member.hasChanged() || !Z(Us)(e.member.emailAddress)
                    }, {
                      default: q(() => [
                        we(ce(Z(n)("general.add")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  ], 16)
                ]),
                default: q(() => [
                  S("span", null, ce(e.member.hasChanged() ? Z(n)("validationError.email") : Z(n)("validationError.noChangesDetected")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })) : (ge(), _e(x, { key: 1 }, {
        default: q(() => [
          S("div", {
            class: J(["d-flex flex-no-wrap", {
              "justify-space-around": Z(a),
              "justify-space-between": !Z(a)
            }])
          }, [
            S("div", null, [
              y(k, { class: "text-h5" }, {
                default: q(() => [
                  we(ce(e.member.emailAddress), 1)
                ]),
                _: 1
              }),
              y(V, null, {
                default: q(() => [
                  y(Bs, {
                    modelValue: e.member.roles,
                    "onUpdate:modelValue": w[5] || (w[5] = (L) => e.member.roles = L),
                    label: Z(n)("memberManagement.roles"),
                    selections: i.value,
                    loading: !1,
                    "always-selected": o.value,
                    "display-only": !0
                  }, null, 8, ["modelValue", "label", "selections", "always-selected"])
                ]),
                _: 1
              }),
              y(p, null, {
                default: q(() => [
                  y(C, {
                    onClick: w[6] || (w[6] = zn((L) => m(e.member.id), ["prevent"])),
                    color: "error"
                  }, {
                    default: q(() => [
                      we(ce(Z(n)("general.remove")), 1)
                    ]),
                    _: 1
                  }),
                  y(C, {
                    onClick: w[7] || (w[7] = zn((L) => e.member.activateEditingMode(), ["prevent"])),
                    color: "primary"
                  }, {
                    default: q(() => [
                      we(ce(Z(n)("general.edit")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            y(M, {
              class: "ma-3",
              rounded: "0",
              size: "125"
            }, {
              default: q(() => [
                y(A, {
                  size: "125",
                  color: "primary",
                  icon: "mdi-account"
                })
              ]),
              _: 1
            })
          ], 2)
        ]),
        _: 1
      }));
    };
  }
}), Pl = /* @__PURE__ */ Zn(ck, [["__scopeId", "data-v-57086bcc"]]);
var gt = /* @__PURE__ */ ((e) => (e.HOME = "home", e.ABOUT = "about", e.TEAM_MANAGEMENT = "teamManagement", e.NOT_FOUND = "notFound", e.UNEXPECTED_ERROR = "unexpectedError", e.WORKSPACE_MANAGEMENT = "workspaceManagement", e))(gt || {}), dk = Object.defineProperty, bm = (e, t, n, a) => {
  for (var r = void 0, l = e.length - 1, i; l >= 0; l--)
    (i = e[l]) && (r = i(t, n, r) || r);
  return r && dk(t, n, r), r;
};
class pa extends Je {
  id;
  name;
  workspace;
}
bm([
  Da(),
  Qr()
], pa.prototype, "id");
bm([
  wo(),
  po()
], pa.prototype, "name");
var fk = Object.defineProperty, pm = (e, t, n, a) => {
  for (var r = void 0, l = e.length - 1, i; l >= 0; l--)
    (i = e[l]) && (r = i(t, n, r) || r);
  return r && fk(t, n, r), r;
};
class Wa extends Je {
  id;
  name;
}
pm([
  Qr(),
  Da()
], Wa.prototype, "id");
pm([
  wo(),
  po()
], Wa.prototype, "name");
const _l = ir("team", {
  state: () => ({
    teamSelected: null,
    teams: /* @__PURE__ */ new Map(),
    teamPagesLoaded: /* @__PURE__ */ new Set(),
    allTeamsLoaded: !1,
    workspaceSelected: null,
    workspaces: /* @__PURE__ */ new Map(),
    workspacePagesLoaded: /* @__PURE__ */ new Set(),
    allWorkspacesLoaded: !1
  }),
  getters: {
    workspacesAvailable() {
      return Array.from(this.workspaces.values());
    },
    workspace() {
      return this.workspaceSelected;
    },
    lastWorkspacePageLoaded() {
      return Math.max(...Array.from(this.workspacePagesLoaded));
    },
    teamsAvailable() {
      return Array.from(this.teams.values());
    },
    selected() {
      return this.teamSelected;
    },
    lastPageLoaded() {
      return Math.max(...Array.from(this.teamPagesLoaded));
    }
  },
  actions: {
    async loadTeams(e, t, n) {
      if (this.teamPagesLoaded.has(t))
        return;
      const a = await e.teamService.getTeams(t, 5, n);
      a.items.forEach((r) => {
        r.id && this.teams.set(r.id, r);
      }), this.teamPagesLoaded.add(t), a.items.length < 5 && (this.allTeamsLoaded = !0);
    },
    async selectTeam(e, t) {
      this.teamSelected = t?.id && Zi(t?.id) && this.teams.has(t.id) ? this.teams.get(t.id) : null, await e.userService.updateLastSelection(this.teamSelected, this.workspaceSelected);
    },
    removeTeam(e) {
      this.teams.delete(e);
    },
    resetTeams() {
      this.teams = /* @__PURE__ */ new Map(), this.teamPagesLoaded = /* @__PURE__ */ new Set(), this.allTeamsLoaded = !1;
    },
    async loadWorkspaces(e, t) {
      if (this.workspacePagesLoaded.has(t))
        return;
      const n = await e.workspaceService.getWorkspaces(t, 3);
      this.workspacePagesLoaded.add(t), n.items.forEach((a) => {
        a.id && this.workspaces.set(a.id, a);
      }), n.items.length < 3 && (this.allWorkspacesLoaded = !0);
    },
    async loadLastSelection(e) {
      const t = await e.userService.getLastSelection();
      t.workspace?.id && (this.workspaces.set(t.workspace.id, t.workspace), this.selectWorkspace(e, t.workspace), await this.loadTeams(e, 0, t.workspace)), t.team?.id && (this.teams.set(t.team.id, t.team), this.selectTeam(e, t.team));
    },
    async selectWorkspace(e, t) {
      this.workspaceSelected !== t && (this.workspaceSelected = t?.id && Zi(t.id) && this.workspaces.has(t.id) ? this.workspaces.get(t.id) : null, this.resetTeams(), await this.selectTeam(e, null), await this.loadTeams(e, 0, t), await e.userService.updateLastSelection(this.teamSelected, this.workspaceSelected));
    },
    removeWorkspace(e) {
      this.workspaces.delete(e);
    },
    resetWorkspaces() {
      this.workspaces = /* @__PURE__ */ new Map(), this.workspacePagesLoaded = /* @__PURE__ */ new Set(), this.allWorkspacesLoaded = !1;
    }
  }
});
function wm(e) {
  if (typeof e == "boolean")
    return e;
  if (typeof e == "string") {
    const t = e.trim().toLowerCase();
    if (t === "true" || t === "1") return !0;
    if (t === "false" || t === "0" || t === "") return !1;
  } else {
    if (typeof e == "number")
      return e !== 0;
    if (e == null)
      return !1;
  }
  return !1;
}
wm("true");
const vk = "com.blueprint.app", mk = "http://localhost:5270", hk = "App", gk = "app-frontend", Ci = "http://localhost/api";
wm("false");
var Rr;
(function(e) {
  e.Unimplemented = "UNIMPLEMENTED", e.Unavailable = "UNAVAILABLE";
})(Rr || (Rr = {}));
class ds extends Error {
  constructor(t, n, a) {
    super(t), this.message = t, this.code = n, this.data = a;
  }
}
const yk = (e) => {
  var t, n;
  return e?.androidBridge ? "android" : !((n = (t = e?.webkit) === null || t === void 0 ? void 0 : t.messageHandlers) === null || n === void 0) && n.bridge ? "ios" : "web";
}, bk = (e) => {
  const t = e.CapacitorCustomPlatform || null, n = e.Capacitor || {}, a = n.Plugins = n.Plugins || {}, r = () => t !== null ? t.name : yk(e), l = () => r() !== "web", i = (d) => {
    const f = u.get(d);
    return !!(f?.platforms.has(r()) || o(d));
  }, o = (d) => {
    var f;
    return (f = n.PluginHeaders) === null || f === void 0 ? void 0 : f.find((v) => v.name === d);
  }, s = (d) => e.console.error(d), u = /* @__PURE__ */ new Map(), c = (d, f = {}) => {
    const v = u.get(d);
    if (v)
      return console.warn(`Capacitor plugin "${d}" already registered. Cannot register plugins twice.`), v.proxy;
    const g = r(), m = o(d);
    let h;
    const w = async () => (!h && g in f ? h = typeof f[g] == "function" ? h = await f[g]() : h = f[g] : t !== null && !h && "web" in f && (h = typeof f.web == "function" ? h = await f.web() : h = f.web), h), _ = (k, V) => {
      var A, M;
      if (m) {
        const L = m?.methods.find((E) => V === E.name);
        if (L)
          return L.rtype === "promise" ? (E) => n.nativePromise(d, V.toString(), E) : (E, P) => n.nativeCallback(d, V.toString(), E, P);
        if (k)
          return (A = k[V]) === null || A === void 0 ? void 0 : A.bind(k);
      } else {
        if (k)
          return (M = k[V]) === null || M === void 0 ? void 0 : M.bind(k);
        throw new ds(`"${d}" plugin is not implemented on ${g}`, Rr.Unimplemented);
      }
    }, I = (k) => {
      let V;
      const A = (...M) => {
        const L = w().then((E) => {
          const P = _(E, k);
          if (P) {
            const O = P(...M);
            return V = O?.remove, O;
          } else
            throw new ds(`"${d}.${k}()" is not implemented on ${g}`, Rr.Unimplemented);
        });
        return k === "addListener" && (L.remove = async () => V()), L;
      };
      return A.toString = () => `${k.toString()}() { [capacitor code] }`, Object.defineProperty(A, "name", {
        value: k,
        writable: !1,
        configurable: !1
      }), A;
    }, C = I("addListener"), b = I("removeListener"), p = (k, V) => {
      const A = C({ eventName: k }, V), M = async () => {
        const E = await A;
        b({
          eventName: k,
          callbackId: E
        }, V);
      }, L = new Promise((E) => A.then(() => E({ remove: M })));
      return L.remove = async () => {
        console.warn("Using addListener() without 'await' is deprecated."), await M();
      }, L;
    }, x = new Proxy({}, {
      get(k, V) {
        switch (V) {
          // https://github.com/facebook/react/issues/20030
          case "$$typeof":
            return;
          case "toJSON":
            return () => ({});
          case "addListener":
            return m ? p : C;
          case "removeListener":
            return b;
          default:
            return I(V);
        }
      }
    });
    return a[d] = x, u.set(d, {
      name: d,
      proxy: x,
      platforms: /* @__PURE__ */ new Set([...Object.keys(f), ...m ? [g] : []])
    }), x;
  };
  return n.convertFileSrc || (n.convertFileSrc = (d) => d), n.getPlatform = r, n.handleError = s, n.isNativePlatform = l, n.isPluginAvailable = i, n.registerPlugin = c, n.Exception = ds, n.DEBUG = !!n.DEBUG, n.isLoggingEnabled = !!n.isLoggingEnabled, n;
}, pk = (e) => e.Capacitor = bk(e), Vl = /* @__PURE__ */ pk(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {}), ac = Vl.registerPlugin;
class rc {
  constructor() {
    this.listeners = {}, this.retainedEventArguments = {}, this.windowListeners = {};
  }
  addListener(t, n) {
    let a = !1;
    this.listeners[t] || (this.listeners[t] = [], a = !0), this.listeners[t].push(n);
    const l = this.windowListeners[t];
    l && !l.registered && this.addWindowListener(l), a && this.sendRetainedArgumentsForEvent(t);
    const i = async () => this.removeListener(t, n);
    return Promise.resolve({ remove: i });
  }
  async removeAllListeners() {
    this.listeners = {};
    for (const t in this.windowListeners)
      this.removeWindowListener(this.windowListeners[t]);
    this.windowListeners = {};
  }
  notifyListeners(t, n, a) {
    const r = this.listeners[t];
    if (!r) {
      if (a) {
        let l = this.retainedEventArguments[t];
        l || (l = []), l.push(n), this.retainedEventArguments[t] = l;
      }
      return;
    }
    r.forEach((l) => l(n));
  }
  hasListeners(t) {
    var n;
    return !!(!((n = this.listeners[t]) === null || n === void 0) && n.length);
  }
  registerWindowListener(t, n) {
    this.windowListeners[n] = {
      registered: !1,
      windowEventName: t,
      pluginEventName: n,
      handler: (a) => {
        this.notifyListeners(n, a);
      }
    };
  }
  unimplemented(t = "not implemented") {
    return new Vl.Exception(t, Rr.Unimplemented);
  }
  unavailable(t = "not available") {
    return new Vl.Exception(t, Rr.Unavailable);
  }
  async removeListener(t, n) {
    const a = this.listeners[t];
    if (!a)
      return;
    const r = a.indexOf(n);
    this.listeners[t].splice(r, 1), this.listeners[t].length || this.removeWindowListener(this.windowListeners[t]);
  }
  addWindowListener(t) {
    window.addEventListener(t.windowEventName, t.handler), t.registered = !0;
  }
  removeWindowListener(t) {
    t && (window.removeEventListener(t.windowEventName, t.handler), t.registered = !1);
  }
  sendRetainedArgumentsForEvent(t) {
    const n = this.retainedEventArguments[t];
    n && (delete this.retainedEventArguments[t], n.forEach((a) => {
      this.notifyListeners(t, a);
    }));
  }
}
const Hd = (e) => encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape), zd = (e) => e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
class wk extends rc {
  async getCookies() {
    const t = document.cookie, n = {};
    return t.split(";").forEach((a) => {
      if (a.length <= 0)
        return;
      let [r, l] = a.replace(/=/, "CAP_COOKIE").split("CAP_COOKIE");
      r = zd(r).trim(), l = zd(l).trim(), n[r] = l;
    }), n;
  }
  async setCookie(t) {
    try {
      const n = Hd(t.key), a = Hd(t.value), r = t.expires ? `; expires=${t.expires.replace("expires=", "")}` : "", l = (t.path || "/").replace("path=", ""), i = t.url != null && t.url.length > 0 ? `domain=${t.url}` : "";
      document.cookie = `${n}=${a || ""}${r}; path=${l}; ${i};`;
    } catch (n) {
      return Promise.reject(n);
    }
  }
  async deleteCookie(t) {
    try {
      document.cookie = `${t.key}=; Max-Age=0`;
    } catch (n) {
      return Promise.reject(n);
    }
  }
  async clearCookies() {
    try {
      const t = document.cookie.split(";") || [];
      for (const n of t)
        document.cookie = n.replace(/^ +/, "").replace(/=.*/, `=;expires=${(/* @__PURE__ */ new Date()).toUTCString()};path=/`);
    } catch (t) {
      return Promise.reject(t);
    }
  }
  async clearAllCookies() {
    try {
      await this.clearCookies();
    } catch (t) {
      return Promise.reject(t);
    }
  }
}
ac("CapacitorCookies", {
  web: () => new wk()
});
const kk = async (e) => new Promise((t, n) => {
  const a = new FileReader();
  a.onload = () => {
    const r = a.result;
    t(r.indexOf(",") >= 0 ? r.split(",")[1] : r);
  }, a.onerror = (r) => n(r), a.readAsDataURL(e);
}), Sk = (e = {}) => {
  const t = Object.keys(e);
  return Object.keys(e).map((r) => r.toLocaleLowerCase()).reduce((r, l, i) => (r[l] = e[t[i]], r), {});
}, xk = (e, t = !0) => e ? Object.entries(e).reduce((a, r) => {
  const [l, i] = r;
  let o, s;
  return Array.isArray(i) ? (s = "", i.forEach((u) => {
    o = t ? encodeURIComponent(u) : u, s += `${l}=${o}&`;
  }), s.slice(0, -1)) : (o = t ? encodeURIComponent(i) : i, s = `${l}=${o}`), `${a}&${s}`;
}, "").substr(1) : null, Ck = (e, t = {}) => {
  const n = Object.assign({ method: e.method || "GET", headers: e.headers }, t), r = Sk(e.headers)["content-type"] || "";
  if (typeof e.data == "string")
    n.body = e.data;
  else if (r.includes("application/x-www-form-urlencoded")) {
    const l = new URLSearchParams();
    for (const [i, o] of Object.entries(e.data || {}))
      l.set(i, o);
    n.body = l.toString();
  } else if (r.includes("multipart/form-data") || e.data instanceof FormData) {
    const l = new FormData();
    if (e.data instanceof FormData)
      e.data.forEach((o, s) => {
        l.append(s, o);
      });
    else
      for (const o of Object.keys(e.data))
        l.append(o, e.data[o]);
    n.body = l;
    const i = new Headers(n.headers);
    i.delete("content-type"), n.headers = i;
  } else (r.includes("application/json") || typeof e.data == "object") && (n.body = JSON.stringify(e.data));
  return n;
};
class _k extends rc {
  /**
   * Perform an Http request given a set of options
   * @param options Options to build the HTTP request
   */
  async request(t) {
    const n = Ck(t, t.webFetchExtra), a = xk(t.params, t.shouldEncodeUrlParams), r = a ? `${t.url}?${a}` : t.url, l = await fetch(r, n), i = l.headers.get("content-type") || "";
    let { responseType: o = "text" } = l.ok ? t : {};
    i.includes("application/json") && (o = "json");
    let s, u;
    switch (o) {
      case "arraybuffer":
      case "blob":
        u = await l.blob(), s = await kk(u);
        break;
      case "json":
        s = await l.json();
        break;
      default:
        s = await l.text();
    }
    const c = {};
    return l.headers.forEach((d, f) => {
      c[f] = d;
    }), {
      data: s,
      headers: c,
      status: l.status,
      url: l.url
    };
  }
  /**
   * Perform an Http GET request given a set of options
   * @param options Options to build the HTTP request
   */
  async get(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "GET" }));
  }
  /**
   * Perform an Http POST request given a set of options
   * @param options Options to build the HTTP request
   */
  async post(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "POST" }));
  }
  /**
   * Perform an Http PUT request given a set of options
   * @param options Options to build the HTTP request
   */
  async put(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "PUT" }));
  }
  /**
   * Perform an Http PATCH request given a set of options
   * @param options Options to build the HTTP request
   */
  async patch(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "PATCH" }));
  }
  /**
   * Perform an Http DELETE request given a set of options
   * @param options Options to build the HTTP request
   */
  async delete(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "DELETE" }));
  }
}
ac("CapacitorHttp", {
  web: () => new _k()
});
var jd;
(function(e) {
  e.Dark = "DARK", e.Light = "LIGHT", e.Default = "DEFAULT";
})(jd || (jd = {}));
var Gd;
(function(e) {
  e.StatusBar = "StatusBar", e.NavigationBar = "NavigationBar";
})(Gd || (Gd = {}));
class Tk extends rc {
  async setStyle() {
    this.unavailable("not available for web");
  }
  async setAnimation() {
    this.unavailable("not available for web");
  }
  async show() {
    this.unavailable("not available for web");
  }
  async hide() {
    this.unavailable("not available for web");
  }
}
ac("SystemBars", {
  web: () => new Tk()
});
const Ik = "application/json";
class Ak {
  /** @type {Pick<PromiseWithResolvers<boolean>, 'resolve' | 'reject'>[]} */
  #n = [];
  /** @type {KeycloakAdapter} */
  #t;
  /** @type {boolean} */
  #a = !0;
  /** @type {CallbackStorage} */
  #u;
  #i = this.#w(console.info);
  #f = this.#w(console.warn);
  /** @type {LoginIframe} */
  #e = {
    enable: !0,
    callbackList: [],
    interval: 5
  };
  /** @type {KeycloakConfig} config */
  #l;
  didInitialize = !1;
  authenticated = !1;
  loginRequired = !1;
  /** @type {KeycloakResponseMode} */
  responseMode = "fragment";
  /** @type {KeycloakResponseType} */
  responseType = "code";
  /** @type {KeycloakFlow} */
  flow = "standard";
  /** @type {number?} */
  timeSkew = null;
  /** @type {string=} */
  redirectUri;
  /** @type {string=} */
  silentCheckSsoRedirectUri;
  /** @type {boolean} */
  silentCheckSsoFallback = !0;
  /** @type {KeycloakPkceMethod} */
  pkceMethod = "S256";
  enableLogging = !1;
  /** @type {'GET' | 'POST'} */
  logoutMethod = "GET";
  /** @type {string=} */
  scope;
  messageReceiveTimeout = 1e4;
  /** @type {string=} */
  idToken;
  /** @type {KeycloakTokenParsed=} */
  idTokenParsed;
  /** @type {string=} */
  token;
  /** @type {KeycloakTokenParsed=} */
  tokenParsed;
  /** @type {string=} */
  refreshToken;
  /** @type {KeycloakTokenParsed=} */
  refreshTokenParsed;
  /** @type {string=} */
  clientId;
  /** @type {string=} */
  sessionId;
  /** @type {string=} */
  subject;
  /** @type {string=} */
  authServerUrl;
  /** @type {string=} */
  realm;
  /** @type {KeycloakRoles=} */
  realmAccess;
  /** @type {KeycloakResourceAccess=} */
  resourceAccess;
  /** @type {KeycloakProfile=} */
  profile;
  /** @type {{}=} */
  userInfo;
  /** @type {Endpoints} */
  endpoints;
  /** @type {number=} */
  tokenTimeoutHandle;
  /** @type {() => void=} */
  onAuthSuccess;
  /** @type {(errorData?: KeycloakError) => void=} */
  onAuthError;
  /** @type {() => void=} */
  onAuthRefreshSuccess;
  /** @type {() => void=} */
  onAuthRefreshError;
  /** @type {() => void=} */
  onTokenExpired;
  /** @type {() => void=} */
  onAuthLogout;
  /** @type {(authenticated: boolean) => void=} */
  onReady;
  /** @type {(status: 'success' | 'cancelled' | 'error', action: string) => void=} */
  onActionUpdate;
  /**
   * @param {KeycloakConfig} config
   */
  constructor(t) {
    if (typeof t != "string" && !Ws(t))
      throw new Error("The 'Keycloak' constructor must be provided with a configuration object, or a URL to a JSON configuration file.");
    if (Ws(t)) {
      const n = "oidcProvider" in t ? ["clientId"] : ["url", "realm", "clientId"];
      for (const a of n)
        if (!(a in t))
          throw new Error(`The configuration object is missing the required '${a}' property.`);
    }
    globalThis.isSecureContext || this.#f(
      `[KEYCLOAK] Keycloak JS must be used in a 'secure context' to function properly as it relies on browser APIs that are otherwise not available.
Continuing to run your application insecurely will lead to unexpected behavior and breakage.

For more information see: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts`
    ), this.#l = t;
  }
  /**
   * @param {KeycloakInitOptions} initOptions
   * @returns {Promise<boolean>}
   */
  init = async (t = {}) => {
    if (this.didInitialize)
      throw new Error("A 'Keycloak' instance can only be initialized once.");
    this.didInitialize = !0, this.#u = Lk();
    const n = ["default", "cordova", "cordova-native"];
    if (typeof t.adapter == "string" && n.includes(t.adapter) ? this.#t = this.#v(t.adapter) : typeof t.adapter == "object" ? this.#t = t.adapter : "Cordova" in window || "cordova" in window ? this.#t = this.#v("cordova") : this.#t = this.#v("default"), typeof t.useNonce < "u" && (this.#a = t.useNonce), typeof t.checkLoginIframe < "u" && (this.#e.enable = t.checkLoginIframe), t.checkLoginIframeInterval && (this.#e.interval = t.checkLoginIframeInterval), t.onLoad === "login-required" && (this.loginRequired = !0), t.responseMode)
      if (t.responseMode === "query" || t.responseMode === "fragment")
        this.responseMode = t.responseMode;
      else
        throw new Error("Invalid value for responseMode");
    if (t.flow) {
      switch (t.flow) {
        case "standard":
          this.responseType = "code";
          break;
        case "implicit":
          this.responseType = "id_token token";
          break;
        case "hybrid":
          this.responseType = "code id_token token";
          break;
        default:
          throw new Error("Invalid value for flow");
      }
      this.flow = t.flow;
    }
    if (typeof t.timeSkew == "number" && (this.timeSkew = t.timeSkew), t.redirectUri && (this.redirectUri = t.redirectUri), t.silentCheckSsoRedirectUri && (this.silentCheckSsoRedirectUri = t.silentCheckSsoRedirectUri), typeof t.silentCheckSsoFallback == "boolean" && (this.silentCheckSsoFallback = t.silentCheckSsoFallback), typeof t.pkceMethod < "u") {
      if (t.pkceMethod !== "S256" && t.pkceMethod !== !1)
        throw new TypeError(`Invalid value for pkceMethod', expected 'S256' or false but got ${t.pkceMethod}.`);
      this.pkceMethod = t.pkceMethod;
    }
    return typeof t.enableLogging == "boolean" && (this.enableLogging = t.enableLogging), t.logoutMethod === "POST" && (this.logoutMethod = "POST"), typeof t.scope == "string" && (this.scope = t.scope), typeof t.messageReceiveTimeout == "number" && t.messageReceiveTimeout > 0 && (this.messageReceiveTimeout = t.messageReceiveTimeout), await this.#C(), await this.#T(), await this.#I(t), this.onReady?.(this.authenticated), this.authenticated;
  };
  /**
   * @param {"default" | "cordova" | "cordova-native"} type
   * @returns {KeycloakAdapter}
   */
  #v(t) {
    if (t === "default")
      return this.#k();
    if (t === "cordova")
      return this.#e.enable = !1, this.#S();
    if (t === "cordova-native")
      return this.#e.enable = !1, this.#x();
    throw new Error("invalid adapter type: " + t);
  }
  /**
   * @returns {KeycloakAdapter}
   */
  #k() {
    const t = (n) => n?.redirectUri || this.redirectUri || globalThis.location.href;
    return {
      login: async (n) => (window.location.assign(await this.createLoginUrl(n)), await new Promise(() => {
      })),
      logout: async (n) => {
        if ((n?.logoutMethod ?? this.logoutMethod) === "GET") {
          window.location.replace(this.createLogoutUrl(n));
          return;
        }
        const r = document.createElement("form");
        r.setAttribute("method", "POST"), r.setAttribute("action", this.createLogoutUrl(n)), r.style.display = "none";
        const l = {
          id_token_hint: this.idToken,
          client_id: this.clientId,
          post_logout_redirect_uri: t(n)
        };
        for (const [i, o] of Object.entries(l)) {
          const s = document.createElement("input");
          s.setAttribute("type", "hidden"), s.setAttribute("name", i), s.setAttribute(
            "value",
            /** @type {string} */
            o
          ), r.appendChild(s);
        }
        document.body.appendChild(r), r.submit();
      },
      register: async (n) => (window.location.assign(await this.createRegisterUrl(n)), await new Promise(() => {
      })),
      accountManagement: async () => {
        const n = this.createAccountUrl();
        if (typeof n < "u")
          window.location.href = n;
        else
          throw new Error("Not supported by the OIDC server");
        return await new Promise(() => {
        });
      },
      redirectUri: t
    };
  }
  /**
   * @returns {KeycloakAdapter}
   */
  #S() {
    const t = (i, o, s) => window.cordova && window.cordova.InAppBrowser ? window.cordova.InAppBrowser.open(i, o, s) : window.open(i, o, s), n = (i) => i && i.cordovaOptions ? Object.keys(i.cordovaOptions).reduce((o, s) => (o[s] = i.cordovaOptions[s], o), {}) : {}, a = (i) => Object.keys(i).reduce((o, s) => (o.push(s + "=" + i[s]), o), []).join(","), r = (i) => {
      const o = n(i);
      return o.location = "no", i && i.prompt === "none" && (o.hidden = "yes"), a(o);
    }, l = () => this.redirectUri || "http://localhost";
    return {
      login: async (i) => {
        const o = r(i), s = await this.createLoginUrl(i), u = t(s, "_blank", o);
        let c = !1, d = !1;
        function f() {
          d = !0, u.close();
        }
        return await new Promise((v, g) => {
          u.addEventListener("loadstart", async (m) => {
            if (m.url.indexOf(l()) === 0) {
              const h = this.#o(m.url);
              try {
                await this.#s(h), v();
              } catch (w) {
                g(w);
              }
              f(), c = !0;
            }
          }), u.addEventListener("loaderror", async (m) => {
            if (!c)
              if (m.url.indexOf(l()) === 0) {
                const h = this.#o(m.url);
                try {
                  await this.#s(h), v();
                } catch (w) {
                  g(w);
                }
                f(), c = !0;
              } else
                g(new Error("Unable to process login.")), f();
          }), u.addEventListener("exit", function(m) {
            d || g(new Error("User closed the login window."));
          });
        });
      },
      logout: async (i) => {
        const o = this.createLogoutUrl(i), s = t(o, "_blank", "location=no,hidden=yes,clearcache=yes");
        let u = !1;
        s.addEventListener("loadstart", (c) => {
          c.url.indexOf(l()) === 0 && s.close();
        }), s.addEventListener("loaderror", (c) => {
          c.url.indexOf(l()) === 0 || (u = !0), s.close();
        }), await new Promise((c, d) => {
          s.addEventListener("exit", () => {
            u ? d(new Error("User closed the login window.")) : (this.clearToken(), c());
          });
        });
      },
      register: async (i) => {
        const o = await this.createRegisterUrl(), s = r(i), u = t(o, "_blank", s);
        await new Promise((d, f) => {
          u.addEventListener("loadstart", async (v) => {
            if (v.url.indexOf(l()) === 0) {
              u.close();
              const g = this.#o(v.url);
              try {
                await this.#s(g), d();
              } catch (m) {
                f(m);
              }
            }
          });
        });
      },
      accountManagement: async () => {
        const i = this.createAccountUrl();
        if (typeof i < "u") {
          const o = t(i, "_blank", "location=no");
          o.addEventListener("loadstart", function(s) {
            s.url.indexOf(l()) === 0 && o.close();
          });
        } else
          throw new Error("Not supported by the OIDC server");
      },
      redirectUri: () => l()
    };
  }
  /**
   * @returns {KeycloakAdapter}
   */
  #x() {
    return {
      login: async (t) => {
        const n = await this.createLoginUrl(t);
        await new Promise((a, r) => {
          universalLinks.subscribe("keycloak", async (l) => {
            universalLinks.unsubscribe("keycloak"), window.cordova.plugins.browsertab.close();
            const i = this.#o(l.url);
            try {
              await this.#s(i), a();
            } catch (o) {
              r(o);
            }
          }), window.cordova.plugins.browsertab.openUrl(n);
        });
      },
      logout: async (t) => {
        const n = this.createLogoutUrl(t);
        await new Promise((a) => {
          universalLinks.subscribe("keycloak", () => {
            universalLinks.unsubscribe("keycloak"), window.cordova.plugins.browsertab.close(), this.clearToken(), a();
          }), window.cordova.plugins.browsertab.openUrl(n);
        });
      },
      register: async (t) => {
        const n = await this.createRegisterUrl(t);
        await new Promise((a, r) => {
          universalLinks.subscribe("keycloak", async (l) => {
            universalLinks.unsubscribe("keycloak"), window.cordova.plugins.browsertab.close();
            const i = this.#o(l.url);
            try {
              await this.#s(i), a();
            } catch (o) {
              r(o);
            }
          }), window.cordova.plugins.browsertab.openUrl(n);
        });
      },
      accountManagement: async () => {
        const t = this.createAccountUrl();
        if (typeof t < "u")
          window.cordova.plugins.browsertab.openUrl(t);
        else
          throw new Error("Not supported by the OIDC server");
      },
      redirectUri: (t) => t && t.redirectUri ? t.redirectUri : this.redirectUri ? this.redirectUri : "http://localhost"
    };
  }
  /**
   * @returns {Promise<void>}
   */
  async #C() {
    if (typeof this.#l == "string") {
      const t = await Wk(this.#l);
      this.authServerUrl = t["auth-server-url"], this.realm = t.realm, this.clientId = t.resource, this.#g();
    } else
      this.clientId = this.#l.clientId, "oidcProvider" in this.#l ? await this.#_(this.#l.oidcProvider) : (this.authServerUrl = this.#l.url, this.realm = this.#l.realm, this.#g());
  }
  /**
   * @returns {void}
   */
  #g() {
    this.endpoints = {
      authorize: () => this.#r() + "/protocol/openid-connect/auth",
      token: () => this.#r() + "/protocol/openid-connect/token",
      logout: () => this.#r() + "/protocol/openid-connect/logout",
      checkSessionIframe: () => this.#r() + "/protocol/openid-connect/login-status-iframe.html",
      thirdPartyCookiesIframe: () => this.#r() + "/protocol/openid-connect/3p-cookies/step1.html",
      register: () => this.#r() + "/protocol/openid-connect/registrations",
      userinfo: () => this.#r() + "/protocol/openid-connect/userinfo"
    };
  }
  /**
   * @param {string | OpenIdProviderMetadata} oidcProvider
   * @returns {Promise<void>}
   */
  async #_(t) {
    if (typeof t == "string") {
      const n = `${Kd(t)}/.well-known/openid-configuration`, a = await Hk(n);
      this.#y(a);
    } else
      this.#y(t);
  }
  /**
   * @param {OpenIdProviderMetadata} config
   * @returns {void}
   */
  #y(t) {
    this.endpoints = {
      authorize() {
        return t.authorization_endpoint;
      },
      token() {
        return t.token_endpoint;
      },
      logout() {
        if (!t.end_session_endpoint)
          throw new Error("Not supported by the OIDC server");
        return t.end_session_endpoint;
      },
      checkSessionIframe() {
        if (!t.check_session_iframe)
          throw new Error("Not supported by the OIDC server");
        return t.check_session_iframe;
      },
      register() {
        throw new Error('Redirection to "Register user" page not supported in standard OIDC mode');
      },
      userinfo() {
        if (!t.userinfo_endpoint)
          throw new Error("Not supported by the OIDC server");
        return t.userinfo_endpoint;
      }
    };
  }
  /**
   * @returns {Promise<void>}
   */
  async #T() {
    if (!this.#e.enable && !this.silentCheckSsoRedirectUri || typeof this.endpoints.thirdPartyCookiesIframe != "function")
      return;
    const t = document.createElement("iframe");
    t.setAttribute("src", this.endpoints.thirdPartyCookiesIframe()), t.setAttribute("sandbox", "allow-storage-access-by-user-activation allow-scripts allow-same-origin"), t.setAttribute("title", "keycloak-3p-check-iframe"), t.style.display = "none", document.body.appendChild(t);
    const n = new Promise((a) => {
      const r = (l) => {
        t.contentWindow === l.source && (l.data !== "supported" && l.data !== "unsupported" || (l.data === "unsupported" && (this.#f(
          `[KEYCLOAK] Your browser is blocking access to 3rd-party cookies, this means:

 - It is not possible to retrieve tokens without redirecting to the Keycloak server (a.k.a. no support for silent authentication).
 - It is not possible to automatically detect changes to the session status (such as the user logging out in another tab).

For more information see: https://www.keycloak.org/securing-apps/javascript-adapter#_modern_browsers`
        ), this.#e.enable = !1, this.silentCheckSsoFallback && (this.silentCheckSsoRedirectUri = void 0)), document.body.removeChild(t), window.removeEventListener("message", r), a()));
      };
      window.addEventListener("message", r, !1);
    });
    return await Dk(n, this.messageReceiveTimeout, "Timeout when waiting for 3rd party check iframe message.");
  }
  /**
   * @param {KeycloakInitOptions} initOptions
   * @returns {Promise<void>}
   */
  async #I(t) {
    const n = this.#o(window.location.href);
    if (n?.newUrl && window.history.replaceState(window.history.state, "", n.newUrl), n && n.valid) {
      await this.#m(), await this.#s(n);
      return;
    }
    const a = async (l) => {
      const i = {};
      l || (i.prompt = "none"), t.locale && (i.locale = t.locale), await this.login(i);
    }, r = async () => {
      switch (t.onLoad) {
        case "check-sso":
          this.#e.enable ? (await this.#m(), await this.#c() || (this.silentCheckSsoRedirectUri ? await this.#b() : await a(!1))) : this.silentCheckSsoRedirectUri ? await this.#b() : await a(!1);
          break;
        case "login-required":
          await a(!0);
          break;
        default:
          throw new Error("Invalid value for onLoad");
      }
    };
    if (t.token && t.refreshToken)
      if (this.#d(t.token, t.refreshToken, t.idToken), this.#e.enable)
        await this.#m(), await this.#c() && (this.onAuthSuccess?.(), this.#h());
      else
        try {
          await this.updateToken(-1), this.onAuthSuccess?.();
        } catch (l) {
          if (this.onAuthError?.(), t.onLoad)
            await r();
          else
            throw l;
        }
    else t.onLoad && await r();
  }
  /**
   * @returns {Promise<void>}
   */
  async #m() {
    if (!this.#e.enable || this.#e.iframe)
      return;
    const t = document.createElement("iframe");
    this.#e.iframe = t, t.setAttribute("src", this.endpoints.checkSessionIframe()), t.setAttribute("sandbox", "allow-storage-access-by-user-activation allow-scripts allow-same-origin"), t.setAttribute("title", "keycloak-session-iframe"), t.style.display = "none", document.body.appendChild(t);
    const n = (r) => {
      if (r.origin !== this.#e.iframeOrigin || this.#e.iframe?.contentWindow !== r.source || !(r.data === "unchanged" || r.data === "changed" || r.data === "error"))
        return;
      r.data !== "unchanged" && this.clearToken();
      const l = this.#e.callbackList;
      this.#e.callbackList = [];
      for (const i of l.reverse())
        r.data === "error" ? i(new Error("Error while checking login iframe")) : i(null, r.data === "unchanged");
    };
    window.addEventListener("message", n, !1), await new Promise((r) => {
      t.addEventListener("load", () => {
        const l = this.endpoints.authorize();
        l.startsWith("/") ? this.#e.iframeOrigin = globalThis.location.origin : this.#e.iframeOrigin = new URL(l).origin, r();
      });
    });
  }
  /**
   * @returns {Promise<boolean | undefined>}
   */
  async #c() {
    if (!this.#e.iframe || !this.#e.iframeOrigin)
      return;
    const t = `${this.clientId} ${this.sessionId ? this.sessionId : ""}`, n = this.#e.iframeOrigin;
    return await new Promise((r, l) => {
      const i = (o, s) => o ? l(o) : r(
        /** @type {boolean} */
        s
      );
      this.#e.callbackList.push(i), this.#e.callbackList.length === 1 && this.#e.iframe?.contentWindow?.postMessage(t, n);
    });
  }
  /**
   * @returns {Promise<void>}
   */
  async #b() {
    const t = document.createElement("iframe"), n = await this.createLoginUrl({ prompt: "none", redirectUri: this.silentCheckSsoRedirectUri });
    return t.setAttribute("src", n), t.setAttribute("sandbox", "allow-storage-access-by-user-activation allow-scripts allow-same-origin"), t.setAttribute("title", "keycloak-silent-check-sso"), t.style.display = "none", document.body.appendChild(t), await new Promise((a, r) => {
      const l = async (i) => {
        if (i.origin !== window.location.origin || t.contentWindow !== i.source)
          return;
        const o = this.#o(i.data);
        try {
          await this.#s(o), a();
        } catch (s) {
          r(s);
        }
        document.body.removeChild(t), window.removeEventListener("message", l);
      };
      window.addEventListener("message", l);
    });
  }
  /**
   * @param {string} url
   */
  #o(t) {
    const n = this.#A(t);
    if (!n)
      return;
    const a = this.#u.get(n.state);
    return a && (n.valid = !0, n.redirectUri = a.redirectUri, n.storedNonce = a.nonce, n.prompt = a.prompt, n.pkceCodeVerifier = a.pkceCodeVerifier, n.loginOptions = a.loginOptions), n;
  }
  /**
   * @param {string} urlString
   */
  #A(t) {
    let n = [];
    switch (this.flow) {
      case "standard":
        n = ["code", "state", "session_state", "kc_action_status", "kc_action", "iss"];
        break;
      case "implicit":
        n = ["access_token", "token_type", "id_token", "state", "session_state", "expires_in", "kc_action_status", "kc_action", "iss"];
        break;
      case "hybrid":
        n = ["access_token", "token_type", "id_token", "code", "state", "session_state", "expires_in", "kc_action_status", "kc_action", "iss"];
        break;
    }
    n.push("error"), n.push("error_description"), n.push("error_uri");
    const a = new URL(t);
    let r = "", l;
    if (this.responseMode === "query" && a.searchParams.size > 0 ? (l = this.#p(a.search, n), a.search = l.paramsString, r = a.toString()) : this.responseMode === "fragment" && a.hash.length > 0 && (l = this.#p(a.hash.substring(1), n), a.hash = l.paramsString, r = a.toString()), l?.oauthParams) {
      if (this.flow === "standard" || this.flow === "hybrid") {
        if ((l.oauthParams.code || l.oauthParams.error) && l.oauthParams.state)
          return l.oauthParams.newUrl = r, l.oauthParams;
      } else if (this.flow === "implicit" && (l.oauthParams.access_token || l.oauthParams.error) && l.oauthParams.state)
        return l.oauthParams.newUrl = r, l.oauthParams;
    }
  }
  /**
   * @typedef {Object} ParsedCallbackParams
   * @property {string} paramsString
   * @property {Record<string, string | undefined>} oauthParams
   */
  /**
   * @param {string} paramsString
   * @param {string[]} supportedParams
   * @returns {ParsedCallbackParams}
   */
  #p(t, n) {
    const a = t.split("&"), r = {};
    let l = "";
    for (const i of a.reverse()) {
      const o = new URLSearchParams(i).entries().next().value;
      if (!o) {
        l = "&" + l;
        continue;
      }
      const [s, u] = o;
      n.includes(s) && !(s in r) ? r[s] = u : l = l.length === 0 ? i : i + "&" + l;
    }
    return {
      paramsString: l,
      oauthParams: r
    };
  }
  async #s(t) {
    const { code: n, error: a, prompt: r } = t;
    let l = (/* @__PURE__ */ new Date()).getTime();
    const i = (o, s, u) => {
      if (l = (l + (/* @__PURE__ */ new Date()).getTime()) / 2, this.#d(o, s, u, l), this.#a && this.idTokenParsed && this.idTokenParsed.nonce !== t.storedNonce)
        throw this.#i("[KEYCLOAK] Invalid nonce, clearing token"), this.clearToken(), new Error("Invalid nonce.");
    };
    if (t.kc_action_status && this.onActionUpdate && this.onActionUpdate(t.kc_action_status, t.kc_action), a) {
      if (r !== "none")
        if (t.error_description && t.error_description === "authentication_expired")
          await this.login(t.loginOptions);
        else {
          const o = { error: a, error_description: t.error_description };
          throw this.onAuthError?.(o), o;
        }
      return;
    } else this.flow !== "standard" && (t.access_token || t.id_token) && (i(t.access_token, void 0, t.id_token), this.onAuthSuccess?.());
    if (this.flow !== "implicit" && n)
      try {
        const o = await zk(
          this.endpoints.token(),
          n,
          /** @type {string} */
          this.clientId,
          t.redirectUri,
          t.pkceCodeVerifier
        );
        i(o.access_token, o.refresh_token, o.id_token), this.flow === "standard" && this.onAuthSuccess?.(), this.#h();
      } catch (o) {
        throw this.onAuthError?.(), o;
      }
  }
  async #h() {
    this.#e.enable && this.token && (await qk(this.#e.interval * 1e3), await this.#c() && await this.#h());
  }
  /**
   * @param {KeycloakLoginOptions} [options]
   * @returns {Promise<void>}
   */
  login = (t) => this.#t.login(t);
  /**
   * @param {KeycloakLoginOptions} [options]
   * @returns {Promise<string>}
   */
  createLoginUrl = async (t) => {
    const n = qd(), a = qd(), r = this.#t.redirectUri(t), l = {
      state: n,
      nonce: a,
      redirectUri: r,
      loginOptions: t
    };
    t?.prompt && (l.prompt = t.prompt);
    const i = t?.action === "register" ? this.endpoints.register() : this.endpoints.authorize();
    let o = t?.scope || this.scope;
    const s = o ? o.split(" ") : [];
    s.includes("openid") || s.unshift("openid"), o = s.join(" ");
    const u = new URLSearchParams([
      [
        "client_id",
        /** @type {string} */
        this.clientId
      ],
      ["redirect_uri", r],
      ["state", n],
      ["response_mode", this.responseMode],
      ["response_type", this.responseType],
      ["scope", o]
    ]);
    if (this.#a && u.append("nonce", a), t?.prompt && u.append("prompt", t.prompt), typeof t?.maxAge == "number" && u.append("max_age", t.maxAge.toString()), t?.loginHint && u.append("login_hint", t.loginHint), t?.idpHint && u.append("kc_idp_hint", t.idpHint), t?.action && t.action !== "register" && u.append("kc_action", t.action), t?.locale && u.append("ui_locales", t.locale), t?.acr && u.append("claims", Pk(t.acr)), t?.acrValues && u.append("acr_values", t.acrValues), this.pkceMethod)
      try {
        const c = Vk(96), d = await Ek(this.pkceMethod, c);
        l.pkceCodeVerifier = c, u.append("code_challenge", d), u.append("code_challenge_method", this.pkceMethod);
      } catch (c) {
        throw new Error("Failed to generate PKCE challenge.", { cause: c });
      }
    return this.#u.add(l), `${i}?${u.toString()}`;
  };
  /**
   * @param {KeycloakLogoutOptions} [options]
   * @returns {Promise<void>}
   */
  logout = (t) => this.#t.logout(t);
  /**
   * @param {KeycloakLogoutOptions} [options]
   * @returns {string}
   */
  createLogoutUrl = (t) => {
    const n = t?.logoutMethod ?? this.logoutMethod, a = this.endpoints.logout();
    if (n === "POST")
      return a;
    const r = new URLSearchParams([
      [
        "client_id",
        /** @type {string} */
        this.clientId
      ],
      ["post_logout_redirect_uri", this.#t.redirectUri(t)]
    ]);
    return this.idToken && r.append("id_token_hint", this.idToken), `${a}?${r.toString()}`;
  };
  /**
   * @param {KeycloakRegisterOptions} [options]
   * @returns {Promise<void>}
   */
  register = (t) => this.#t.register(t);
  /**
   * @param {KeycloakRegisterOptions} [options]
   * @returns {Promise<string>}
   */
  createRegisterUrl = (t) => this.createLoginUrl({ ...t, action: "register" });
  /**
   * @param {KeycloakAccountOptions} [options]
   * @returns {string}
   */
  createAccountUrl = (t) => {
    const n = this.#r();
    if (!n)
      throw new Error("Unable to create account URL, make sure the adapter is not configured using a generic OIDC provider.");
    const a = new URLSearchParams([
      [
        "referrer",
        /** @type {string} */
        this.clientId
      ],
      ["referrer_uri", this.#t.redirectUri(t)]
    ]);
    return `${n}/account?${a.toString()}`;
  };
  /**
   * @returns {Promise<void>}
   */
  accountManagement = () => this.#t.accountManagement();
  /**
   * @param {string} role
   * @returns {boolean}
   */
  hasRealmRole = (t) => {
    const n = this.realmAccess;
    return !!n && n.roles.indexOf(t) >= 0;
  };
  /**
   * @param {string} role
   * @param {string} [resource]
   * @returns {boolean}
   */
  hasResourceRole = (t, n) => {
    if (!this.resourceAccess)
      return !1;
    const a = this.resourceAccess[n || /** @type {string} */
    this.clientId];
    return !!a && a.roles.indexOf(t) >= 0;
  };
  /**
   * @returns {Promise<KeycloakProfile>}
   */
  loadUserProfile = async () => {
    const t = this.#r();
    if (!t)
      throw new Error("Unable to load user profile, make sure the adapter is not configured using a generic OIDC provider.");
    const n = `${t}/account`, a = await $r(n, {
      headers: [Yd(this.token)]
    });
    return this.profile = a;
  };
  /**
   * @returns {Promise<{}>}
   */
  loadUserInfo = async () => {
    const t = this.endpoints.userinfo(), n = await $r(t, {
      headers: [Yd(this.token)]
    });
    return this.userInfo = n;
  };
  /**
   * @param {number} [minValidity]
   * @returns {boolean}
   */
  isTokenExpired = (t) => {
    if (!this.tokenParsed || !this.refreshToken && this.flow !== "implicit")
      throw new Error("Not authenticated");
    if (this.timeSkew == null)
      return this.#i("[KEYCLOAK] Unable to determine if token is expired as timeskew is not set"), !0;
    if (typeof this.tokenParsed.exp != "number")
      return !1;
    let n = this.tokenParsed.exp - Math.ceil((/* @__PURE__ */ new Date()).getTime() / 1e3) + this.timeSkew;
    if (t) {
      if (isNaN(t))
        throw new Error("Invalid minValidity");
      n -= t;
    }
    return n < 0;
  };
  /**
   * @param {number} minValidity
   * @returns {Promise<boolean>}
   */
  updateToken = async (t) => {
    if (!this.refreshToken)
      throw new Error("Unable to update token, no refresh token available.");
    t = t || 5, this.#e.enable && await this.#c();
    let n = !1;
    if (t === -1 ? (n = !0, this.#i("[KEYCLOAK] Refreshing token: forced refresh")) : (!this.tokenParsed || this.isTokenExpired(t)) && (n = !0, this.#i("[KEYCLOAK] Refreshing token: token expired")), !n)
      return !1;
    const { promise: a, resolve: r, reject: l } = Promise.withResolvers();
    if (this.#n.push({ resolve: r, reject: l }), this.#n.length === 1) {
      const i = this.endpoints.token();
      let o = (/* @__PURE__ */ new Date()).getTime();
      try {
        const s = await jk(
          i,
          this.refreshToken,
          /** @type {string} */
          this.clientId
        );
        this.#i("[KEYCLOAK] Token refreshed"), o = (o + (/* @__PURE__ */ new Date()).getTime()) / 2, this.#d(s.access_token, s.refresh_token, s.id_token, o), this.onAuthRefreshSuccess?.();
        for (let u = this.#n.pop(); u != null; u = this.#n.pop())
          u.resolve(!0);
      } catch (s) {
        this.#f("[KEYCLOAK] Failed to refresh token"), s instanceof km && s.response.status === 400 && this.clearToken(), this.onAuthRefreshError?.();
        for (let u = this.#n.pop(); u != null; u = this.#n.pop())
          u.reject(s);
      }
    }
    return await a;
  };
  clearToken = () => {
    this.token && (this.#d(), this.onAuthLogout?.(), this.loginRequired && this.login());
  };
  /**
   * @param {string} [token]
   * @param {string} [refreshToken]
   * @param {string} [idToken]
   * @param {number} [timeLocal]
   */
  #d(t, n, a, r) {
    if (this.tokenTimeoutHandle && (clearTimeout(this.tokenTimeoutHandle), this.tokenTimeoutHandle = void 0), n ? (this.refreshToken = n, this.refreshTokenParsed = fs(n)) : (delete this.refreshToken, delete this.refreshTokenParsed), a ? (this.idToken = a, this.idTokenParsed = fs(a)) : (delete this.idToken, delete this.idTokenParsed), t) {
      if (this.token = t, this.tokenParsed = fs(t), this.sessionId = this.tokenParsed.sid, this.authenticated = !0, this.subject = this.tokenParsed.sub, this.realmAccess = this.tokenParsed.realm_access, this.resourceAccess = this.tokenParsed.resource_access, r && (this.timeSkew = Math.floor(r / 1e3) - this.tokenParsed.iat), this.timeSkew !== null && (this.#i("[KEYCLOAK] Estimated time difference between browser and server is " + this.timeSkew + " seconds"), this.onTokenExpired)) {
        const l = (this.tokenParsed.exp - (/* @__PURE__ */ new Date()).getTime() / 1e3 + this.timeSkew) * 1e3;
        this.#i("[KEYCLOAK] Token expires in " + Math.round(l / 1e3) + " s"), l <= 0 ? this.onTokenExpired() : this.tokenTimeoutHandle = window.setTimeout(this.onTokenExpired, l);
      }
    } else
      delete this.token, delete this.tokenParsed, delete this.subject, delete this.realmAccess, delete this.resourceAccess, this.authenticated = !1;
  }
  /**
   * @returns {string=}
   */
  #r() {
    if (!(typeof this.authServerUrl > "u"))
      return `${Kd(this.authServerUrl)}/realms/${encodeURIComponent(
        /** @type {string} */
        this.realm
      )}`;
  }
  /**
   * @param {Function} fn
   * @returns {(message: string) => void}
   */
  #w(t) {
    return (n) => {
      this.enableLogging && t.call(console, n);
    };
  }
}
function qd() {
  if (typeof crypto > "u" || typeof crypto.randomUUID > "u")
    throw new Error("Web Crypto API is not available.");
  return crypto.randomUUID();
}
function Pk(e) {
  return JSON.stringify({
    id_token: {
      acr: e
    }
  });
}
function Vk(e) {
  return Mk(e, "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789");
}
async function Ek(e, t) {
  if (e !== "S256")
    throw new TypeError(`Invalid value for 'pkceMethod', expected 'S256' but got '${e}'.`);
  const n = new Uint8Array(await $k(t));
  return Rk(n).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function Mk(e, t) {
  const n = Ok(e), a = new Array(e);
  for (let r = 0; r < e; r++)
    a[r] = t.charCodeAt(n[r] % t.length);
  return String.fromCharCode.apply(null, a);
}
function Ok(e) {
  if (typeof crypto > "u" || typeof crypto.getRandomValues > "u")
    throw new Error("Web Crypto API is not available.");
  return crypto.getRandomValues(new Uint8Array(e));
}
function Dk(e, t, n) {
  let a;
  const r = new Promise(function(l, i) {
    a = window.setTimeout(function() {
      i(new Error(n));
    }, t);
  });
  return Promise.race([e, r]).finally(function() {
    clearTimeout(a);
  });
}
function Lk() {
  try {
    return new Nk();
  } catch {
    return new Fk();
  }
}
const Dr = "kc-callback-";
class Nk {
  constructor() {
    globalThis.localStorage.setItem("kc-test", "test"), globalThis.localStorage.removeItem("kc-test");
  }
  /**
   * @param {string} [state]
   * @returns {CallbackState | null}
   */
  get(t) {
    if (!t)
      return null;
    this.#n();
    const n = Dr + t, a = globalThis.localStorage.getItem(n);
    return a ? (globalThis.localStorage.removeItem(n), JSON.parse(a)) : null;
  }
  /**
   * @param {CallbackState} state
   */
  add(t) {
    this.#n();
    const n = Dr + t.state, a = JSON.stringify({
      ...t,
      // Set the expiry time to 1 hour from now.
      expires: Date.now() + 3600 * 1e3
    });
    try {
      globalThis.localStorage.setItem(n, a);
    } catch {
      this.#t(), globalThis.localStorage.setItem(n, a);
    }
  }
  /**
   * Clears all values from local storage that are no longer valid.
   */
  #n() {
    const t = Date.now();
    for (const [n, a] of this.#a()) {
      const r = this.#u(a);
      (r === null || r < t) && globalThis.localStorage.removeItem(n);
    }
  }
  /**
   * Clears all known values from local storage.
   */
  #t() {
    for (const [t] of this.#a())
      globalThis.localStorage.removeItem(t);
  }
  /**
   * Gets all entries stored in local storage that are known to be managed by this class.
   * @returns {[string, string][]} An array of key-value pairs.
   */
  #a() {
    return Object.entries(globalThis.localStorage).filter(([t]) => t.startsWith(Dr));
  }
  /**
   * Parses the expiry time from a value stored in local storage.
   * @param {string} value
   * @returns {number | null} The expiry time in milliseconds, or `null` if the value is malformed.
   */
  #u(t) {
    let n;
    try {
      n = JSON.parse(t);
    } catch {
      return null;
    }
    return Ws(n) && "expires" in n && typeof n.expires == "number" ? n.expires : null;
  }
}
class Fk {
  /**
   * @param {string} [state]
   * @returns {CallbackState | null}
   */
  get(t) {
    if (!t)
      return null;
    const n = this.#n(Dr + t);
    return this.#t(Dr + t, "", this.#a(-100)), n ? JSON.parse(n) : null;
  }
  /**
   * @param {CallbackState} state
   */
  add(t) {
    this.#t(Dr + t.state, JSON.stringify(t), this.#a(60));
  }
  /**
   * @param {string} key
   * @returns
   */
  #n(t) {
    const n = t + "=", a = document.cookie.split(";");
    for (let r = 0; r < a.length; r++) {
      let l = a[r];
      for (; l.charAt(0) === " "; )
        l = l.substring(1);
      if (l.indexOf(n) === 0)
        return l.substring(n.length, l.length);
    }
    return "";
  }
  /**
   * @param {string} key
   * @param {string} value
   * @param {Date} expirationDate
   */
  #t(t, n, a) {
    const r = t + "=" + n + "; expires=" + a.toUTCString() + "; ";
    document.cookie = r;
  }
  /**
   * @param {number} minutes
   * @returns {Date}
   */
  #a(t) {
    const n = /* @__PURE__ */ new Date();
    return n.setTime(n.getTime() + t * 60 * 1e3), n;
  }
}
function Rk(e) {
  const t = String.fromCodePoint(...e);
  return btoa(t);
}
async function $k(e) {
  const n = new TextEncoder().encode(e);
  if (typeof crypto > "u" || typeof crypto.subtle > "u")
    throw new Error("Web Crypto API is not available.");
  return await crypto.subtle.digest("SHA-256", n);
}
function fs(e) {
  const [, t] = e.split(".");
  if (typeof t != "string")
    throw new Error("Unable to decode token, payload not found.");
  let n;
  try {
    n = Bk(t);
  } catch (a) {
    throw new Error("Unable to decode token, payload is not a valid Base64URL value.", { cause: a });
  }
  try {
    return JSON.parse(n);
  } catch (a) {
    throw new Error("Unable to decode token, payload is not a valid JSON value.", { cause: a });
  }
}
function Bk(e) {
  let t = e.replaceAll("-", "+").replaceAll("_", "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("Input is not of the correct length.");
  }
  try {
    return Uk(t);
  } catch {
    return atob(t);
  }
}
function Uk(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, n) => {
    let a = n.charCodeAt(0).toString(16).toUpperCase();
    return a.length < 2 && (a = "0" + a), "%" + a;
  }));
}
function Ws(e) {
  return typeof e == "object" && e !== null;
}
async function Wk(e) {
  return await $r(e);
}
async function Hk(e) {
  return await $r(e);
}
async function zk(e, t, n, a, r) {
  const l = new URLSearchParams([
    ["code", t],
    ["grant_type", "authorization_code"],
    ["client_id", n],
    ["redirect_uri", a]
  ]);
  return r && l.append("code_verifier", r), await $r(e, {
    method: "POST",
    credentials: "include",
    body: l
  });
}
async function jk(e, t, n) {
  const a = new URLSearchParams([
    ["grant_type", "refresh_token"],
    ["refresh_token", t],
    ["client_id", n]
  ]);
  return await $r(e, {
    method: "POST",
    credentials: "include",
    body: a
  });
}
async function $r(e, t = {}) {
  const n = new Headers(t.headers);
  return n.set("Accept", Ik), await (await Gk(e, {
    ...t,
    headers: n
  })).json();
}
async function Gk(e, t) {
  const n = await fetch(e, t);
  if (!n.ok)
    throw new km("Server responded with an invalid status.", { response: n });
  return n;
}
function Yd(e) {
  if (!e)
    throw new Error("Unable to build authorization header, token is not set, make sure the user is authenticated.");
  return ["Authorization", `bearer ${e}`];
}
function Kd(e) {
  return e.endsWith("/") ? e.slice(0, -1) : e;
}
class km extends Error {
  /** @type {Response} */
  response;
  /**
   * @param {string} message
   * @param {NetworkErrorOptions} options
   */
  constructor(t, n) {
    super(t, n), this.response = n.response;
  }
}
const qk = (e) => new Promise((t) => setTimeout(t, e));
class Yk extends Ak {
  constructor(t) {
    super(t);
  }
  /**
   * A custom initialization method that wraps the original `init` method to add logging
   * and URL cleanup logic.
   * @param {KeycloakInitOptions} [initOptions] - The initialization options.
   * @param {Router} [router] - The Vue router instance, used to clean the URL after processing.
   * @returns {Promise<boolean>} A promise that resolves with the authentication status.
   */
  async customInit(t, n) {
    await n?.isReady(), t ? t.enableLogging = !0 : t = { enableLogging: !0 };
    try {
      const a = await this.init(t);
      return n && (n.currentRoute.value.hash.includes("error=") || n.currentRoute.value.hash.includes("state=")) && await n.replace({
        hash: ""
      }), a;
    } catch (a) {
      throw a;
    }
  }
}
class Kk {
  keycloak;
  refreshTokenInterval;
  initialisationPromise;
  appId;
  constructor(t, n, a, r) {
    this.keycloak = new Yk({
      url: t,
      realm: n,
      clientId: a
    }), this.appId = r, this.refreshTokenInterval = setInterval(async () => {
      this.isAuthenticated() && await this.refreshToken();
    }, 6e4);
  }
  init(t) {
    if (!this.initialisationPromise) {
      const n = {
        onLoad: "check-sso",
        messageReceiveTimeout: 5e3
      };
      Vl.isNativePlatform() ? (n.redirectUri = this.getRedirectUri(), n.checkLoginIframe = !1, n.pkceMethod = "S256") : (n.redirectUri = this.getRedirectUri(), n.checkLoginIframe = !1, n.pkceMethod = "S256");
      try {
        this.initialisationPromise = this.keycloak.customInit(n, t);
      } catch (a) {
        throw console.error("Failed to initialise auth service", a), a;
      }
    }
    return this.initialisationPromise;
  }
  async isReady() {
    if (!this.initialisationPromise)
      return !1;
    try {
      return await this.initialisationPromise;
    } catch (t) {
      return console.error("Failed to initialise auth service", t), !1;
    }
  }
  async refreshToken() {
    try {
      await this.keycloak.updateToken(60);
    } catch (t) {
      console.error("Failed to refresh token", t);
    }
  }
  isAuthenticated() {
    return this.keycloak.authenticated ?? !1;
  }
  async startSignupProcess(t, n) {
    await this.keycloak.register({
      redirectUri: this.getRedirectUri(t),
      loginHint: n
    });
  }
  async startLoginProcess(t) {
    const n = this.getRedirectUri(t);
    await this.keycloak.login({
      redirectUri: n
    });
  }
  async logout() {
    await this.keycloak.logout({
      redirectUri: this.getRedirectUri()
    });
  }
  getToken() {
    return this.keycloak.token;
  }
  getRedirectUri(t) {
    return Vl.isNativePlatform() ? `${this.appId}://auth-callback` : t;
  }
}
class Zk {
  services = /* @__PURE__ */ new Map();
  // Lazy load service instance
  getService(t, n, ...a) {
    if (!this.services.has(t)) {
      const r = new n(...a);
      this.services.set(t, r);
    }
    return this.services.get(t);
  }
}
const vl = new Zk();
class Jk extends Error {
  constructor(t) {
    super(t), this.name = "ActionFailedError";
  }
}
class xo {
  authService;
  serviceStore;
  constructor(t, n) {
    this.authService = n, this.serviceStore = t;
  }
  async getAuthHeaders(t) {
    const n = qh();
    let a;
    if (t || await n.awaitInit(), n.isAnonymous) {
      if (!n.anonymousToken && !await n.createAnonymousUser(this.serviceStore))
        throw new Jk("Failed to create anonymous user");
      a = n.anonymousToken;
    } else
      a = this.authService.getToken();
    return { Authorization: `Bearer ${a}` };
  }
}
function Sm(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Xk } = Object.prototype, { getPrototypeOf: lc } = Object, { iterator: Co, toStringTag: xm } = Symbol, _o = /* @__PURE__ */ ((e) => (t) => {
  const n = Xk.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Hn = (e) => (e = e.toLowerCase(), (t) => _o(t) === e), To = (e) => (t) => typeof t === e, { isArray: el } = Array, Br = To("undefined");
function ql(e) {
  return e !== null && !Br(e) && e.constructor !== null && !Br(e.constructor) && dn(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Cm = Hn("ArrayBuffer");
function Qk(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Cm(e.buffer), t;
}
const eS = To("string"), dn = To("function"), _m = To("number"), Yl = (e) => e !== null && typeof e == "object", tS = (e) => e === !0 || e === !1, Ri = (e) => {
  if (_o(e) !== "object")
    return !1;
  const t = lc(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(xm in e) && !(Co in e);
}, nS = (e) => {
  if (!Yl(e) || ql(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, aS = Hn("Date"), rS = Hn("File"), lS = Hn("Blob"), iS = Hn("FileList"), oS = (e) => Yl(e) && dn(e.pipe), sS = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || dn(e.append) && ((t = _o(e)) === "formdata" || // detect form-data instance
  t === "object" && dn(e.toString) && e.toString() === "[object FormData]"));
}, uS = Hn("URLSearchParams"), [cS, dS, fS, vS] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Hn), mS = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Kl(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let a, r;
  if (typeof e != "object" && (e = [e]), el(e))
    for (a = 0, r = e.length; a < r; a++)
      t.call(null, e[a], a, e);
  else {
    if (ql(e))
      return;
    const l = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = l.length;
    let o;
    for (a = 0; a < i; a++)
      o = l[a], t.call(null, e[o], o, e);
  }
}
function Tm(e, t) {
  if (ql(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let a = n.length, r;
  for (; a-- > 0; )
    if (r = n[a], t === r.toLowerCase())
      return r;
  return null;
}
const Ha = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Im = (e) => !Br(e) && e !== Ha;
function Hs() {
  const { caseless: e, skipUndefined: t } = Im(this) && this || {}, n = {}, a = (r, l) => {
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    const i = e && Tm(n, l) || l;
    Ri(n[i]) && Ri(r) ? n[i] = Hs(n[i], r) : Ri(r) ? n[i] = Hs({}, r) : el(r) ? n[i] = r.slice() : (!t || !Br(r)) && (n[i] = r);
  };
  for (let r = 0, l = arguments.length; r < l; r++)
    arguments[r] && Kl(arguments[r], a);
  return n;
}
const hS = (e, t, n, { allOwnKeys: a } = {}) => (Kl(
  t,
  (r, l) => {
    n && dn(r) ? Object.defineProperty(e, l, {
      value: Sm(r, n),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, l, {
      value: r,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: a }
), e), gS = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), yS = (e, t, n, a) => {
  e.prototype = Object.create(
    t.prototype,
    a
  ), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, bS = (e, t, n, a) => {
  let r, l, i;
  const o = {};
  if (t = t || {}, e == null) return t;
  do {
    for (r = Object.getOwnPropertyNames(e), l = r.length; l-- > 0; )
      i = r[l], (!a || a(i, e, t)) && !o[i] && (t[i] = e[i], o[i] = !0);
    e = n !== !1 && lc(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, pS = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const a = e.indexOf(t, n);
  return a !== -1 && a === n;
}, wS = (e) => {
  if (!e) return null;
  if (el(e)) return e;
  let t = e.length;
  if (!_m(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, kS = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && lc(Uint8Array)), SS = (e, t) => {
  const a = (e && e[Co]).call(e);
  let r;
  for (; (r = a.next()) && !r.done; ) {
    const l = r.value;
    t.call(e, l[0], l[1]);
  }
}, xS = (e, t) => {
  let n;
  const a = [];
  for (; (n = e.exec(t)) !== null; )
    a.push(n);
  return a;
}, CS = Hn("HTMLFormElement"), _S = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(n, a, r) {
  return a.toUpperCase() + r;
}), Zd = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), TS = Hn("RegExp"), Am = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), a = {};
  Kl(n, (r, l) => {
    let i;
    (i = t(r, l, e)) !== !1 && (a[l] = i || r);
  }), Object.defineProperties(e, a);
}, IS = (e) => {
  Am(e, (t, n) => {
    if (dn(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const a = e[n];
    if (dn(a)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, AS = (e, t) => {
  const n = {}, a = (r) => {
    r.forEach((l) => {
      n[l] = !0;
    });
  };
  return el(e) ? a(e) : a(String(e).split(t)), n;
}, PS = () => {
}, VS = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function ES(e) {
  return !!(e && dn(e.append) && e[xm] === "FormData" && e[Co]);
}
const MS = (e) => {
  const t = new Array(10), n = (a, r) => {
    if (Yl(a)) {
      if (t.indexOf(a) >= 0)
        return;
      if (ql(a))
        return a;
      if (!("toJSON" in a)) {
        t[r] = a;
        const l = el(a) ? [] : {};
        return Kl(a, (i, o) => {
          const s = n(i, r + 1);
          !Br(s) && (l[o] = s);
        }), t[r] = void 0, l;
      }
    }
    return a;
  };
  return n(e, 0);
}, OS = Hn("AsyncFunction"), DS = (e) => e && (Yl(e) || dn(e)) && dn(e.then) && dn(e.catch), Pm = ((e, t) => e ? setImmediate : t ? ((n, a) => (Ha.addEventListener(
  "message",
  ({ source: r, data: l }) => {
    r === Ha && l === n && a.length && a.shift()();
  },
  !1
), (r) => {
  a.push(r), Ha.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(typeof setImmediate == "function", dn(Ha.postMessage)), LS = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ha) : typeof process < "u" && process.nextTick || Pm, NS = (e) => e != null && dn(e[Co]), ee = {
  isArray: el,
  isArrayBuffer: Cm,
  isBuffer: ql,
  isFormData: sS,
  isArrayBufferView: Qk,
  isString: eS,
  isNumber: _m,
  isBoolean: tS,
  isObject: Yl,
  isPlainObject: Ri,
  isEmptyObject: nS,
  isReadableStream: cS,
  isRequest: dS,
  isResponse: fS,
  isHeaders: vS,
  isUndefined: Br,
  isDate: aS,
  isFile: rS,
  isBlob: lS,
  isRegExp: TS,
  isFunction: dn,
  isStream: oS,
  isURLSearchParams: uS,
  isTypedArray: kS,
  isFileList: iS,
  forEach: Kl,
  merge: Hs,
  extend: hS,
  trim: mS,
  stripBOM: gS,
  inherits: yS,
  toFlatObject: bS,
  kindOf: _o,
  kindOfTest: Hn,
  endsWith: pS,
  toArray: wS,
  forEachEntry: SS,
  matchAll: xS,
  isHTMLForm: CS,
  hasOwnProperty: Zd,
  hasOwnProp: Zd,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Am,
  freezeMethods: IS,
  toObjectSet: AS,
  toCamelCase: _S,
  noop: PS,
  toFiniteNumber: VS,
  findKey: Tm,
  global: Ha,
  isContextDefined: Im,
  isSpecCompliantForm: ES,
  toJSONObject: MS,
  isAsyncFn: OS,
  isThenable: DS,
  setImmediate: Pm,
  asap: LS,
  isIterable: NS
};
let Ve = class Vm extends Error {
  static from(t, n, a, r, l, i) {
    const o = new Vm(t.message, n || t.code, a, r, l);
    return o.cause = t, o.name = t.name, i && Object.assign(o, i), o;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(t, n, a, r, l) {
    super(t), this.name = "AxiosError", this.isAxiosError = !0, n && (this.code = n), a && (this.config = a), r && (this.request = r), l && (this.response = l, this.status = l.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ee.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
Ve.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
Ve.ERR_BAD_OPTION = "ERR_BAD_OPTION";
Ve.ECONNABORTED = "ECONNABORTED";
Ve.ETIMEDOUT = "ETIMEDOUT";
Ve.ERR_NETWORK = "ERR_NETWORK";
Ve.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
Ve.ERR_DEPRECATED = "ERR_DEPRECATED";
Ve.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
Ve.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
Ve.ERR_CANCELED = "ERR_CANCELED";
Ve.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
Ve.ERR_INVALID_URL = "ERR_INVALID_URL";
const FS = null;
function zs(e) {
  return ee.isPlainObject(e) || ee.isArray(e);
}
function Em(e) {
  return ee.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Jd(e, t, n) {
  return e ? e.concat(t).map(function(r, l) {
    return r = Em(r), !n && l ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
function RS(e) {
  return ee.isArray(e) && !e.some(zs);
}
const $S = ee.toFlatObject(ee, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Io(e, t, n) {
  if (!ee.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = ee.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, h) {
    return !ee.isUndefined(h[m]);
  });
  const a = n.metaTokens, r = n.visitor || c, l = n.dots, i = n.indexes, s = (n.Blob || typeof Blob < "u" && Blob) && ee.isSpecCompliantForm(t);
  if (!ee.isFunction(r))
    throw new TypeError("visitor must be a function");
  function u(g) {
    if (g === null) return "";
    if (ee.isDate(g))
      return g.toISOString();
    if (ee.isBoolean(g))
      return g.toString();
    if (!s && ee.isBlob(g))
      throw new Ve("Blob is not supported. Use a Buffer instead.");
    return ee.isArrayBuffer(g) || ee.isTypedArray(g) ? s && typeof Blob == "function" ? new Blob([g]) : Buffer.from(g) : g;
  }
  function c(g, m, h) {
    let w = g;
    if (g && !h && typeof g == "object") {
      if (ee.endsWith(m, "{}"))
        m = a ? m : m.slice(0, -2), g = JSON.stringify(g);
      else if (ee.isArray(g) && RS(g) || (ee.isFileList(g) || ee.endsWith(m, "[]")) && (w = ee.toArray(g)))
        return m = Em(m), w.forEach(function(I, C) {
          !(ee.isUndefined(I) || I === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Jd([m], C, l) : i === null ? m : m + "[]",
            u(I)
          );
        }), !1;
    }
    return zs(g) ? !0 : (t.append(Jd(h, m, l), u(g)), !1);
  }
  const d = [], f = Object.assign($S, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: zs
  });
  function v(g, m) {
    if (!ee.isUndefined(g)) {
      if (d.indexOf(g) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      d.push(g), ee.forEach(g, function(w, _) {
        (!(ee.isUndefined(w) || w === null) && r.call(
          t,
          w,
          ee.isString(_) ? _.trim() : _,
          m,
          f
        )) === !0 && v(w, m ? m.concat(_) : [_]);
      }), d.pop();
    }
  }
  if (!ee.isObject(e))
    throw new TypeError("data must be an object");
  return v(e), t;
}
function Xd(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(a) {
    return t[a];
  });
}
function ic(e, t) {
  this._pairs = [], e && Io(e, this, t);
}
const Mm = ic.prototype;
Mm.append = function(t, n) {
  this._pairs.push([t, n]);
};
Mm.toString = function(t) {
  const n = t ? function(a) {
    return t.call(this, a, Xd);
  } : Xd;
  return this._pairs.map(function(r) {
    return n(r[0]) + "=" + n(r[1]);
  }, "").join("&");
};
function BS(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Om(e, t, n) {
  if (!t)
    return e;
  const a = n && n.encode || BS, r = ee.isFunction(n) ? {
    serialize: n
  } : n, l = r && r.serialize;
  let i;
  if (l ? i = l(t, r) : i = ee.isURLSearchParams(t) ? t.toString() : new ic(t, r).toString(a), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Qd {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, a) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: a ? a.synchronous : !1,
      runWhen: a ? a.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    ee.forEach(this.handlers, function(a) {
      a !== null && t(a);
    });
  }
}
const oc = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, US = typeof URLSearchParams < "u" ? URLSearchParams : ic, WS = typeof FormData < "u" ? FormData : null, HS = typeof Blob < "u" ? Blob : null, zS = {
  isBrowser: !0,
  classes: {
    URLSearchParams: US,
    FormData: WS,
    Blob: HS
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, sc = typeof window < "u" && typeof document < "u", js = typeof navigator == "object" && navigator || void 0, jS = sc && (!js || ["ReactNative", "NativeScript", "NS"].indexOf(js.product) < 0), GS = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", qS = sc && window.location.href || "http://localhost", YS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: sc,
  hasStandardBrowserEnv: jS,
  hasStandardBrowserWebWorkerEnv: GS,
  navigator: js,
  origin: qS
}, Symbol.toStringTag, { value: "Module" })), Zt = {
  ...YS,
  ...zS
};
function KS(e, t) {
  return Io(e, new Zt.classes.URLSearchParams(), {
    visitor: function(n, a, r, l) {
      return Zt.isNode && ee.isBuffer(n) ? (this.append(a, n.toString("base64")), !1) : l.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function ZS(e) {
  return ee.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function JS(e) {
  const t = {}, n = Object.keys(e);
  let a;
  const r = n.length;
  let l;
  for (a = 0; a < r; a++)
    l = n[a], t[l] = e[l];
  return t;
}
function Dm(e) {
  function t(n, a, r, l) {
    let i = n[l++];
    if (i === "__proto__") return !0;
    const o = Number.isFinite(+i), s = l >= n.length;
    return i = !i && ee.isArray(r) ? r.length : i, s ? (ee.hasOwnProp(r, i) ? r[i] = [r[i], a] : r[i] = a, !o) : ((!r[i] || !ee.isObject(r[i])) && (r[i] = []), t(n, a, r[i], l) && ee.isArray(r[i]) && (r[i] = JS(r[i])), !o);
  }
  if (ee.isFormData(e) && ee.isFunction(e.entries)) {
    const n = {};
    return ee.forEachEntry(e, (a, r) => {
      t(ZS(a), r, n, 0);
    }), n;
  }
  return null;
}
function XS(e, t, n) {
  if (ee.isString(e))
    try {
      return (t || JSON.parse)(e), ee.trim(e);
    } catch (a) {
      if (a.name !== "SyntaxError")
        throw a;
    }
  return (n || JSON.stringify)(e);
}
const Zl = {
  transitional: oc,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const a = n.getContentType() || "", r = a.indexOf("application/json") > -1, l = ee.isObject(t);
    if (l && ee.isHTMLForm(t) && (t = new FormData(t)), ee.isFormData(t))
      return r ? JSON.stringify(Dm(t)) : t;
    if (ee.isArrayBuffer(t) || ee.isBuffer(t) || ee.isStream(t) || ee.isFile(t) || ee.isBlob(t) || ee.isReadableStream(t))
      return t;
    if (ee.isArrayBufferView(t))
      return t.buffer;
    if (ee.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let o;
    if (l) {
      if (a.indexOf("application/x-www-form-urlencoded") > -1)
        return KS(t, this.formSerializer).toString();
      if ((o = ee.isFileList(t)) || a.indexOf("multipart/form-data") > -1) {
        const s = this.env && this.env.FormData;
        return Io(
          o ? { "files[]": t } : t,
          s && new s(),
          this.formSerializer
        );
      }
    }
    return l || r ? (n.setContentType("application/json", !1), XS(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Zl.transitional, a = n && n.forcedJSONParsing, r = this.responseType === "json";
    if (ee.isResponse(t) || ee.isReadableStream(t))
      return t;
    if (t && ee.isString(t) && (a && !this.responseType || r)) {
      const i = !(n && n.silentJSONParsing) && r;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (o) {
        if (i)
          throw o.name === "SyntaxError" ? Ve.from(o, Ve.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Zt.classes.FormData,
    Blob: Zt.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ee.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Zl.headers[e] = {};
});
const QS = ee.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), e0 = (e) => {
  const t = {};
  let n, a, r;
  return e && e.split(`
`).forEach(function(i) {
    r = i.indexOf(":"), n = i.substring(0, r).trim().toLowerCase(), a = i.substring(r + 1).trim(), !(!n || t[n] && QS[n]) && (n === "set-cookie" ? t[n] ? t[n].push(a) : t[n] = [a] : t[n] = t[n] ? t[n] + ", " + a : a);
  }), t;
}, ef = /* @__PURE__ */ Symbol("internals");
function ml(e) {
  return e && String(e).trim().toLowerCase();
}
function $i(e) {
  return e === !1 || e == null ? e : ee.isArray(e) ? e.map($i) : String(e);
}
function t0(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let a;
  for (; a = n.exec(e); )
    t[a[1]] = a[2];
  return t;
}
const n0 = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function vs(e, t, n, a, r) {
  if (ee.isFunction(a))
    return a.call(this, t, n);
  if (r && (t = n), !!ee.isString(t)) {
    if (ee.isString(a))
      return t.indexOf(a) !== -1;
    if (ee.isRegExp(a))
      return a.test(t);
  }
}
function a0(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, a) => n.toUpperCase() + a);
}
function r0(e, t) {
  const n = ee.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((a) => {
    Object.defineProperty(e, a + n, {
      value: function(r, l, i) {
        return this[a].call(this, t, r, l, i);
      },
      configurable: !0
    });
  });
}
let fn = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, a) {
    const r = this;
    function l(o, s, u) {
      const c = ml(s);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const d = ee.findKey(r, c);
      (!d || r[d] === void 0 || u === !0 || u === void 0 && r[d] !== !1) && (r[d || s] = $i(o));
    }
    const i = (o, s) => ee.forEach(o, (u, c) => l(u, c, s));
    if (ee.isPlainObject(t) || t instanceof this.constructor)
      i(t, n);
    else if (ee.isString(t) && (t = t.trim()) && !n0(t))
      i(e0(t), n);
    else if (ee.isObject(t) && ee.isIterable(t)) {
      let o = {}, s, u;
      for (const c of t) {
        if (!ee.isArray(c))
          throw TypeError("Object iterator must return a key-value pair");
        o[u = c[0]] = (s = o[u]) ? ee.isArray(s) ? [...s, c[1]] : [s, c[1]] : c[1];
      }
      i(o, n);
    } else
      t != null && l(n, t, a);
    return this;
  }
  get(t, n) {
    if (t = ml(t), t) {
      const a = ee.findKey(this, t);
      if (a) {
        const r = this[a];
        if (!n)
          return r;
        if (n === !0)
          return t0(r);
        if (ee.isFunction(n))
          return n.call(this, r, a);
        if (ee.isRegExp(n))
          return n.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = ml(t), t) {
      const a = ee.findKey(this, t);
      return !!(a && this[a] !== void 0 && (!n || vs(this, this[a], a, n)));
    }
    return !1;
  }
  delete(t, n) {
    const a = this;
    let r = !1;
    function l(i) {
      if (i = ml(i), i) {
        const o = ee.findKey(a, i);
        o && (!n || vs(a, a[o], o, n)) && (delete a[o], r = !0);
      }
    }
    return ee.isArray(t) ? t.forEach(l) : l(t), r;
  }
  clear(t) {
    const n = Object.keys(this);
    let a = n.length, r = !1;
    for (; a--; ) {
      const l = n[a];
      (!t || vs(this, this[l], l, t, !0)) && (delete this[l], r = !0);
    }
    return r;
  }
  normalize(t) {
    const n = this, a = {};
    return ee.forEach(this, (r, l) => {
      const i = ee.findKey(a, l);
      if (i) {
        n[i] = $i(r), delete n[l];
        return;
      }
      const o = t ? a0(l) : String(l).trim();
      o !== l && delete n[l], n[o] = $i(r), a[o] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return ee.forEach(this, (a, r) => {
      a != null && a !== !1 && (n[r] = t && ee.isArray(a) ? a.join(", ") : a);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const a = new this(t);
    return n.forEach((r) => a.set(r)), a;
  }
  static accessor(t) {
    const a = (this[ef] = this[ef] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function l(i) {
      const o = ml(i);
      a[o] || (r0(r, i), a[o] = !0);
    }
    return ee.isArray(t) ? t.forEach(l) : l(t), this;
  }
};
fn.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ee.reduceDescriptors(fn.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(a) {
      this[n] = a;
    }
  };
});
ee.freezeMethods(fn);
function ms(e, t) {
  const n = this || Zl, a = t || n, r = fn.from(a.headers);
  let l = a.data;
  return ee.forEach(e, function(o) {
    l = o.call(n, l, r.normalize(), t ? t.status : void 0);
  }), r.normalize(), l;
}
function Lm(e) {
  return !!(e && e.__CANCEL__);
}
let Jl = class extends Ve {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(t, n, a) {
    super(t ?? "canceled", Ve.ERR_CANCELED, n, a), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Nm(e, t, n) {
  const a = n.config.validateStatus;
  !n.status || !a || a(n.status) ? e(n) : t(new Ve(
    "Request failed with status code " + n.status,
    [Ve.ERR_BAD_REQUEST, Ve.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function l0(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function i0(e, t) {
  e = e || 10;
  const n = new Array(e), a = new Array(e);
  let r = 0, l = 0, i;
  return t = t !== void 0 ? t : 1e3, function(s) {
    const u = Date.now(), c = a[l];
    i || (i = u), n[r] = s, a[r] = u;
    let d = l, f = 0;
    for (; d !== r; )
      f += n[d++], d = d % e;
    if (r = (r + 1) % e, r === l && (l = (l + 1) % e), u - i < t)
      return;
    const v = c && u - c;
    return v ? Math.round(f * 1e3 / v) : void 0;
  };
}
function o0(e, t) {
  let n = 0, a = 1e3 / t, r, l;
  const i = (u, c = Date.now()) => {
    n = c, r = null, l && (clearTimeout(l), l = null), e(...u);
  };
  return [(...u) => {
    const c = Date.now(), d = c - n;
    d >= a ? i(u, c) : (r = u, l || (l = setTimeout(() => {
      l = null, i(r);
    }, a - d)));
  }, () => r && i(r)];
}
const Qi = (e, t, n = 3) => {
  let a = 0;
  const r = i0(50, 250);
  return o0((l) => {
    const i = l.loaded, o = l.lengthComputable ? l.total : void 0, s = i - a, u = r(s), c = i <= o;
    a = i;
    const d = {
      loaded: i,
      total: o,
      progress: o ? i / o : void 0,
      bytes: s,
      rate: u || void 0,
      estimated: u && o && c ? (o - i) / u : void 0,
      event: l,
      lengthComputable: o != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, tf = (e, t) => {
  const n = e != null;
  return [(a) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: a
  }), t[1]];
}, nf = (e) => (...t) => ee.asap(() => e(...t)), s0 = Zt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, Zt.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(Zt.origin),
  Zt.navigator && /(msie|trident)/i.test(Zt.navigator.userAgent)
) : () => !0, u0 = Zt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, a, r, l, i) {
      if (typeof document > "u") return;
      const o = [`${e}=${encodeURIComponent(t)}`];
      ee.isNumber(n) && o.push(`expires=${new Date(n).toUTCString()}`), ee.isString(a) && o.push(`path=${a}`), ee.isString(r) && o.push(`domain=${r}`), l === !0 && o.push("secure"), ee.isString(i) && o.push(`SameSite=${i}`), document.cookie = o.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return t ? decodeURIComponent(t[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function c0(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function d0(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Fm(e, t, n) {
  let a = !c0(t);
  return e && (a || n == !1) ? d0(e, t) : t;
}
const af = (e) => e instanceof fn ? { ...e } : e;
function Xa(e, t) {
  t = t || {};
  const n = {};
  function a(u, c, d, f) {
    return ee.isPlainObject(u) && ee.isPlainObject(c) ? ee.merge.call({ caseless: f }, u, c) : ee.isPlainObject(c) ? ee.merge({}, c) : ee.isArray(c) ? c.slice() : c;
  }
  function r(u, c, d, f) {
    if (ee.isUndefined(c)) {
      if (!ee.isUndefined(u))
        return a(void 0, u, d, f);
    } else return a(u, c, d, f);
  }
  function l(u, c) {
    if (!ee.isUndefined(c))
      return a(void 0, c);
  }
  function i(u, c) {
    if (ee.isUndefined(c)) {
      if (!ee.isUndefined(u))
        return a(void 0, u);
    } else return a(void 0, c);
  }
  function o(u, c, d) {
    if (d in t)
      return a(u, c);
    if (d in e)
      return a(void 0, u);
  }
  const s = {
    url: l,
    method: l,
    data: l,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: o,
    headers: (u, c, d) => r(af(u), af(c), d, !0)
  };
  return ee.forEach(
    Object.keys({ ...e, ...t }),
    function(c) {
      if (c === "__proto__" || c === "constructor" || c === "prototype")
        return;
      const d = ee.hasOwnProp(s, c) ? s[c] : r, f = d(e[c], t[c], c);
      ee.isUndefined(f) && d !== o || (n[c] = f);
    }
  ), n;
}
const Rm = (e) => {
  const t = Xa({}, e);
  let { data: n, withXSRFToken: a, xsrfHeaderName: r, xsrfCookieName: l, headers: i, auth: o } = t;
  if (t.headers = i = fn.from(i), t.url = Om(Fm(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), o && i.set(
    "Authorization",
    "Basic " + btoa((o.username || "") + ":" + (o.password ? unescape(encodeURIComponent(o.password)) : ""))
  ), ee.isFormData(n)) {
    if (Zt.hasStandardBrowserEnv || Zt.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if (ee.isFunction(n.getHeaders)) {
      const s = n.getHeaders(), u = ["content-type", "content-length"];
      Object.entries(s).forEach(([c, d]) => {
        u.includes(c.toLowerCase()) && i.set(c, d);
      });
    }
  }
  if (Zt.hasStandardBrowserEnv && (a && ee.isFunction(a) && (a = a(t)), a || a !== !1 && s0(t.url))) {
    const s = r && l && u0.read(l);
    s && i.set(r, s);
  }
  return t;
}, f0 = typeof XMLHttpRequest < "u", v0 = f0 && function(e) {
  return new Promise(function(n, a) {
    const r = Rm(e);
    let l = r.data;
    const i = fn.from(r.headers).normalize();
    let { responseType: o, onUploadProgress: s, onDownloadProgress: u } = r, c, d, f, v, g;
    function m() {
      v && v(), g && g(), r.cancelToken && r.cancelToken.unsubscribe(c), r.signal && r.signal.removeEventListener("abort", c);
    }
    let h = new XMLHttpRequest();
    h.open(r.method.toUpperCase(), r.url, !0), h.timeout = r.timeout;
    function w() {
      if (!h)
        return;
      const I = fn.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), b = {
        data: !o || o === "text" || o === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: I,
        config: e,
        request: h
      };
      Nm(function(x) {
        n(x), m();
      }, function(x) {
        a(x), m();
      }, b), h = null;
    }
    "onloadend" in h ? h.onloadend = w : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(w);
    }, h.onabort = function() {
      h && (a(new Ve("Request aborted", Ve.ECONNABORTED, e, h)), h = null);
    }, h.onerror = function(C) {
      const b = C && C.message ? C.message : "Network Error", p = new Ve(b, Ve.ERR_NETWORK, e, h);
      p.event = C || null, a(p), h = null;
    }, h.ontimeout = function() {
      let C = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const b = r.transitional || oc;
      r.timeoutErrorMessage && (C = r.timeoutErrorMessage), a(new Ve(
        C,
        b.clarifyTimeoutError ? Ve.ETIMEDOUT : Ve.ECONNABORTED,
        e,
        h
      )), h = null;
    }, l === void 0 && i.setContentType(null), "setRequestHeader" in h && ee.forEach(i.toJSON(), function(C, b) {
      h.setRequestHeader(b, C);
    }), ee.isUndefined(r.withCredentials) || (h.withCredentials = !!r.withCredentials), o && o !== "json" && (h.responseType = r.responseType), u && ([f, g] = Qi(u, !0), h.addEventListener("progress", f)), s && h.upload && ([d, v] = Qi(s), h.upload.addEventListener("progress", d), h.upload.addEventListener("loadend", v)), (r.cancelToken || r.signal) && (c = (I) => {
      h && (a(!I || I.type ? new Jl(null, e, h) : I), h.abort(), h = null);
    }, r.cancelToken && r.cancelToken.subscribe(c), r.signal && (r.signal.aborted ? c() : r.signal.addEventListener("abort", c)));
    const _ = l0(r.url);
    if (_ && Zt.protocols.indexOf(_) === -1) {
      a(new Ve("Unsupported protocol " + _ + ":", Ve.ERR_BAD_REQUEST, e));
      return;
    }
    h.send(l || null);
  });
}, m0 = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let a = new AbortController(), r;
    const l = function(u) {
      if (!r) {
        r = !0, o();
        const c = u instanceof Error ? u : this.reason;
        a.abort(c instanceof Ve ? c : new Jl(c instanceof Error ? c.message : c));
      }
    };
    let i = t && setTimeout(() => {
      i = null, l(new Ve(`timeout of ${t}ms exceeded`, Ve.ETIMEDOUT));
    }, t);
    const o = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(l) : u.removeEventListener("abort", l);
      }), e = null);
    };
    e.forEach((u) => u.addEventListener("abort", l));
    const { signal: s } = a;
    return s.unsubscribe = () => ee.asap(o), s;
  }
}, h0 = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let a = 0, r;
  for (; a < n; )
    r = a + t, yield e.slice(a, r), a = r;
}, g0 = async function* (e, t) {
  for await (const n of y0(e))
    yield* h0(n, t);
}, y0 = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: a } = await t.read();
      if (n)
        break;
      yield a;
    }
  } finally {
    await t.cancel();
  }
}, rf = (e, t, n, a) => {
  const r = g0(e, t);
  let l = 0, i, o = (s) => {
    i || (i = !0, a && a(s));
  };
  return new ReadableStream({
    async pull(s) {
      try {
        const { done: u, value: c } = await r.next();
        if (u) {
          o(), s.close();
          return;
        }
        let d = c.byteLength;
        if (n) {
          let f = l += d;
          n(f);
        }
        s.enqueue(new Uint8Array(c));
      } catch (u) {
        throw o(u), u;
      }
    },
    cancel(s) {
      return o(s), r.return();
    }
  }, {
    highWaterMark: 2
  });
}, lf = 64 * 1024, { isFunction: _i } = ee, b0 = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(ee.global), {
  ReadableStream: of,
  TextEncoder: sf
} = ee.global, uf = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, p0 = (e) => {
  e = ee.merge.call({
    skipUndefined: !0
  }, b0, e);
  const { fetch: t, Request: n, Response: a } = e, r = t ? _i(t) : typeof fetch == "function", l = _i(n), i = _i(a);
  if (!r)
    return !1;
  const o = r && _i(of), s = r && (typeof sf == "function" ? /* @__PURE__ */ ((g) => (m) => g.encode(m))(new sf()) : async (g) => new Uint8Array(await new n(g).arrayBuffer())), u = l && o && uf(() => {
    let g = !1;
    const m = new n(Zt.origin, {
      body: new of(),
      method: "POST",
      get duplex() {
        return g = !0, "half";
      }
    }).headers.has("Content-Type");
    return g && !m;
  }), c = i && o && uf(() => ee.isReadableStream(new a("").body)), d = {
    stream: c && ((g) => g.body)
  };
  r && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((g) => {
    !d[g] && (d[g] = (m, h) => {
      let w = m && m[g];
      if (w)
        return w.call(m);
      throw new Ve(`Response type '${g}' is not supported`, Ve.ERR_NOT_SUPPORT, h);
    });
  });
  const f = async (g) => {
    if (g == null)
      return 0;
    if (ee.isBlob(g))
      return g.size;
    if (ee.isSpecCompliantForm(g))
      return (await new n(Zt.origin, {
        method: "POST",
        body: g
      }).arrayBuffer()).byteLength;
    if (ee.isArrayBufferView(g) || ee.isArrayBuffer(g))
      return g.byteLength;
    if (ee.isURLSearchParams(g) && (g = g + ""), ee.isString(g))
      return (await s(g)).byteLength;
  }, v = async (g, m) => {
    const h = ee.toFiniteNumber(g.getContentLength());
    return h ?? f(m);
  };
  return async (g) => {
    let {
      url: m,
      method: h,
      data: w,
      signal: _,
      cancelToken: I,
      timeout: C,
      onDownloadProgress: b,
      onUploadProgress: p,
      responseType: x,
      headers: k,
      withCredentials: V = "same-origin",
      fetchOptions: A
    } = Rm(g), M = t || fetch;
    x = x ? (x + "").toLowerCase() : "text";
    let L = m0([_, I && I.toAbortSignal()], C), E = null;
    const P = L && L.unsubscribe && (() => {
      L.unsubscribe();
    });
    let O;
    try {
      if (p && u && h !== "get" && h !== "head" && (O = await v(k, w)) !== 0) {
        let j = new n(m, {
          method: "POST",
          body: w,
          duplex: "half"
        }), H;
        if (ee.isFormData(w) && (H = j.headers.get("content-type")) && k.setContentType(H), j.body) {
          const [$, z] = tf(
            O,
            Qi(nf(p))
          );
          w = rf(j.body, lf, $, z);
        }
      }
      ee.isString(V) || (V = V ? "include" : "omit");
      const F = l && "credentials" in n.prototype, B = {
        ...A,
        signal: L,
        method: h.toUpperCase(),
        headers: k.normalize().toJSON(),
        body: w,
        duplex: "half",
        credentials: F ? V : void 0
      };
      E = l && new n(m, B);
      let N = await (l ? M(E, A) : M(m, B));
      const W = c && (x === "stream" || x === "response");
      if (c && (b || W && P)) {
        const j = {};
        ["status", "statusText", "headers"].forEach((te) => {
          j[te] = N[te];
        });
        const H = ee.toFiniteNumber(N.headers.get("content-length")), [$, z] = b && tf(
          H,
          Qi(nf(b), !0)
        ) || [];
        N = new a(
          rf(N.body, lf, $, () => {
            z && z(), P && P();
          }),
          j
        );
      }
      x = x || "text";
      let R = await d[ee.findKey(d, x) || "text"](N, g);
      return !W && P && P(), await new Promise((j, H) => {
        Nm(j, H, {
          data: R,
          headers: fn.from(N.headers),
          status: N.status,
          statusText: N.statusText,
          config: g,
          request: E
        });
      });
    } catch (F) {
      throw P && P(), F && F.name === "TypeError" && /Load failed|fetch/i.test(F.message) ? Object.assign(
        new Ve("Network Error", Ve.ERR_NETWORK, g, E, F && F.response),
        {
          cause: F.cause || F
        }
      ) : Ve.from(F, F && F.code, g, E, F && F.response);
    }
  };
}, w0 = /* @__PURE__ */ new Map(), $m = (e) => {
  let t = e && e.env || {};
  const { fetch: n, Request: a, Response: r } = t, l = [
    a,
    r,
    n
  ];
  let i = l.length, o = i, s, u, c = w0;
  for (; o--; )
    s = l[o], u = c.get(s), u === void 0 && c.set(s, u = o ? /* @__PURE__ */ new Map() : p0(t)), c = u;
  return u;
};
$m();
const uc = {
  http: FS,
  xhr: v0,
  fetch: {
    get: $m
  }
};
ee.forEach(uc, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const cf = (e) => `- ${e}`, k0 = (e) => ee.isFunction(e) || e === null || e === !1;
function S0(e, t) {
  e = ee.isArray(e) ? e : [e];
  const { length: n } = e;
  let a, r;
  const l = {};
  for (let i = 0; i < n; i++) {
    a = e[i];
    let o;
    if (r = a, !k0(a) && (r = uc[(o = String(a)).toLowerCase()], r === void 0))
      throw new Ve(`Unknown adapter '${o}'`);
    if (r && (ee.isFunction(r) || (r = r.get(t))))
      break;
    l[o || "#" + i] = r;
  }
  if (!r) {
    const i = Object.entries(l).map(
      ([s, u]) => `adapter ${s} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let o = n ? i.length > 1 ? `since :
` + i.map(cf).join(`
`) : " " + cf(i[0]) : "as no adapter specified";
    throw new Ve(
      "There is no suitable adapter to dispatch the request " + o,
      "ERR_NOT_SUPPORT"
    );
  }
  return r;
}
const Bm = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: S0,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: uc
};
function hs(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Jl(null, e);
}
function df(e) {
  return hs(e), e.headers = fn.from(e.headers), e.data = ms.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Bm.getAdapter(e.adapter || Zl.adapter, e)(e).then(function(a) {
    return hs(e), a.data = ms.call(
      e,
      e.transformResponse,
      a
    ), a.headers = fn.from(a.headers), a;
  }, function(a) {
    return Lm(a) || (hs(e), a && a.response && (a.response.data = ms.call(
      e,
      e.transformResponse,
      a.response
    ), a.response.headers = fn.from(a.response.headers))), Promise.reject(a);
  });
}
const Um = "1.13.5", Ao = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Ao[e] = function(a) {
    return typeof a === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ff = {};
Ao.transitional = function(t, n, a) {
  function r(l, i) {
    return "[Axios v" + Um + "] Transitional option '" + l + "'" + i + (a ? ". " + a : "");
  }
  return (l, i, o) => {
    if (t === !1)
      throw new Ve(
        r(i, " has been removed" + (n ? " in " + n : "")),
        Ve.ERR_DEPRECATED
      );
    return n && !ff[i] && (ff[i] = !0, console.warn(
      r(
        i,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(l, i, o) : !0;
  };
};
Ao.spelling = function(t) {
  return (n, a) => (console.warn(`${a} is likely a misspelling of ${t}`), !0);
};
function x0(e, t, n) {
  if (typeof e != "object")
    throw new Ve("options must be an object", Ve.ERR_BAD_OPTION_VALUE);
  const a = Object.keys(e);
  let r = a.length;
  for (; r-- > 0; ) {
    const l = a[r], i = t[l];
    if (i) {
      const o = e[l], s = o === void 0 || i(o, l, e);
      if (s !== !0)
        throw new Ve("option " + l + " must be " + s, Ve.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new Ve("Unknown option " + l, Ve.ERR_BAD_OPTION);
  }
}
const Bi = {
  assertOptions: x0,
  validators: Ao
}, _n = Bi.validators;
let qa = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Qd(),
      response: new Qd()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (a) {
      if (a instanceof Error) {
        let r = {};
        Error.captureStackTrace ? Error.captureStackTrace(r) : r = new Error();
        const l = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          a.stack ? l && !String(a.stack).endsWith(l.replace(/^.+\n.+\n/, "")) && (a.stack += `
` + l) : a.stack = l;
        } catch {
        }
      }
      throw a;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Xa(this.defaults, n);
    const { transitional: a, paramsSerializer: r, headers: l } = n;
    a !== void 0 && Bi.assertOptions(a, {
      silentJSONParsing: _n.transitional(_n.boolean),
      forcedJSONParsing: _n.transitional(_n.boolean),
      clarifyTimeoutError: _n.transitional(_n.boolean),
      legacyInterceptorReqResOrdering: _n.transitional(_n.boolean)
    }, !1), r != null && (ee.isFunction(r) ? n.paramsSerializer = {
      serialize: r
    } : Bi.assertOptions(r, {
      encode: _n.function,
      serialize: _n.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Bi.assertOptions(n, {
      baseUrl: _n.spelling("baseURL"),
      withXsrfToken: _n.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = l && ee.merge(
      l.common,
      l[n.method]
    );
    l && ee.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (g) => {
        delete l[g];
      }
    ), n.headers = fn.concat(i, l);
    const o = [];
    let s = !0;
    this.interceptors.request.forEach(function(m) {
      if (typeof m.runWhen == "function" && m.runWhen(n) === !1)
        return;
      s = s && m.synchronous;
      const h = n.transitional || oc;
      h && h.legacyInterceptorReqResOrdering ? o.unshift(m.fulfilled, m.rejected) : o.push(m.fulfilled, m.rejected);
    });
    const u = [];
    this.interceptors.response.forEach(function(m) {
      u.push(m.fulfilled, m.rejected);
    });
    let c, d = 0, f;
    if (!s) {
      const g = [df.bind(this), void 0];
      for (g.unshift(...o), g.push(...u), f = g.length, c = Promise.resolve(n); d < f; )
        c = c.then(g[d++], g[d++]);
      return c;
    }
    f = o.length;
    let v = n;
    for (; d < f; ) {
      const g = o[d++], m = o[d++];
      try {
        v = g(v);
      } catch (h) {
        m.call(this, h);
        break;
      }
    }
    try {
      c = df.call(this, v);
    } catch (g) {
      return Promise.reject(g);
    }
    for (d = 0, f = u.length; d < f; )
      c = c.then(u[d++], u[d++]);
    return c;
  }
  getUri(t) {
    t = Xa(this.defaults, t);
    const n = Fm(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Om(n, t.params, t.paramsSerializer);
  }
};
ee.forEach(["delete", "get", "head", "options"], function(t) {
  qa.prototype[t] = function(n, a) {
    return this.request(Xa(a || {}, {
      method: t,
      url: n,
      data: (a || {}).data
    }));
  };
});
ee.forEach(["post", "put", "patch"], function(t) {
  function n(a) {
    return function(l, i, o) {
      return this.request(Xa(o || {}, {
        method: t,
        headers: a ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: l,
        data: i
      }));
    };
  }
  qa.prototype[t] = n(), qa.prototype[t + "Form"] = n(!0);
});
let C0 = class Wm {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(l) {
      n = l;
    });
    const a = this;
    this.promise.then((r) => {
      if (!a._listeners) return;
      let l = a._listeners.length;
      for (; l-- > 0; )
        a._listeners[l](r);
      a._listeners = null;
    }), this.promise.then = (r) => {
      let l;
      const i = new Promise((o) => {
        a.subscribe(o), l = o;
      }).then(r);
      return i.cancel = function() {
        a.unsubscribe(l);
      }, i;
    }, t(function(l, i, o) {
      a.reason || (a.reason = new Jl(l, i, o), n(a.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (a) => {
      t.abort(a);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Wm(function(r) {
        t = r;
      }),
      cancel: t
    };
  }
};
function _0(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function T0(e) {
  return ee.isObject(e) && e.isAxiosError === !0;
}
const Gs = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Gs).forEach(([e, t]) => {
  Gs[t] = e;
});
function Hm(e) {
  const t = new qa(e), n = Sm(qa.prototype.request, t);
  return ee.extend(n, qa.prototype, t, { allOwnKeys: !0 }), ee.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(r) {
    return Hm(Xa(e, r));
  }, n;
}
const Vt = Hm(Zl);
Vt.Axios = qa;
Vt.CanceledError = Jl;
Vt.CancelToken = C0;
Vt.isCancel = Lm;
Vt.VERSION = Um;
Vt.toFormData = Io;
Vt.AxiosError = Ve;
Vt.Cancel = Vt.CanceledError;
Vt.all = function(t) {
  return Promise.all(t);
};
Vt.spread = _0;
Vt.isAxiosError = T0;
Vt.mergeConfig = Xa;
Vt.AxiosHeaders = fn;
Vt.formToJSON = (e) => Dm(ee.isHTMLForm(e) ? new FormData(e) : e);
Vt.getAdapter = Bm.getAdapter;
Vt.HttpStatusCode = Gs;
Vt.default = Vt;
const {
  Axios: oL,
  AxiosError: sL,
  CanceledError: uL,
  isCancel: cL,
  CancelToken: dL,
  VERSION: fL,
  all: vL,
  Cancel: mL,
  isAxiosError: hL,
  spread: gL,
  toFormData: yL,
  AxiosHeaders: bL,
  HttpStatusCode: pL,
  formToJSON: wL,
  getAdapter: kL,
  mergeConfig: SL
} = Vt;
class ur extends Error {
}
class I0 extends ur {
  constructor(t) {
    super(`Invalid DateTime: ${t.toMessage()}`);
  }
}
class A0 extends ur {
  constructor(t) {
    super(`Invalid Interval: ${t.toMessage()}`);
  }
}
class P0 extends ur {
  constructor(t) {
    super(`Invalid Duration: ${t.toMessage()}`);
  }
}
class Er extends ur {
}
class zm extends ur {
  constructor(t) {
    super(`Invalid unit ${t}`);
  }
}
class Kt extends ur {
}
class ga extends ur {
  constructor() {
    super("Zone is an abstract class");
  }
}
const pe = "numeric", $n = "short", wn = "long", eo = {
  year: pe,
  month: pe,
  day: pe
}, jm = {
  year: pe,
  month: $n,
  day: pe
}, V0 = {
  year: pe,
  month: $n,
  day: pe,
  weekday: $n
}, Gm = {
  year: pe,
  month: wn,
  day: pe
}, qm = {
  year: pe,
  month: wn,
  day: pe,
  weekday: wn
}, Ym = {
  hour: pe,
  minute: pe
}, Km = {
  hour: pe,
  minute: pe,
  second: pe
}, Zm = {
  hour: pe,
  minute: pe,
  second: pe,
  timeZoneName: $n
}, Jm = {
  hour: pe,
  minute: pe,
  second: pe,
  timeZoneName: wn
}, Xm = {
  hour: pe,
  minute: pe,
  hourCycle: "h23"
}, Qm = {
  hour: pe,
  minute: pe,
  second: pe,
  hourCycle: "h23"
}, eh = {
  hour: pe,
  minute: pe,
  second: pe,
  hourCycle: "h23",
  timeZoneName: $n
}, th = {
  hour: pe,
  minute: pe,
  second: pe,
  hourCycle: "h23",
  timeZoneName: wn
}, nh = {
  year: pe,
  month: pe,
  day: pe,
  hour: pe,
  minute: pe
}, ah = {
  year: pe,
  month: pe,
  day: pe,
  hour: pe,
  minute: pe,
  second: pe
}, rh = {
  year: pe,
  month: $n,
  day: pe,
  hour: pe,
  minute: pe
}, lh = {
  year: pe,
  month: $n,
  day: pe,
  hour: pe,
  minute: pe,
  second: pe
}, E0 = {
  year: pe,
  month: $n,
  day: pe,
  weekday: $n,
  hour: pe,
  minute: pe
}, ih = {
  year: pe,
  month: wn,
  day: pe,
  hour: pe,
  minute: pe,
  timeZoneName: $n
}, oh = {
  year: pe,
  month: wn,
  day: pe,
  hour: pe,
  minute: pe,
  second: pe,
  timeZoneName: $n
}, sh = {
  year: pe,
  month: wn,
  day: pe,
  weekday: wn,
  hour: pe,
  minute: pe,
  timeZoneName: wn
}, uh = {
  year: pe,
  month: wn,
  day: pe,
  weekday: wn,
  hour: pe,
  minute: pe,
  second: pe,
  timeZoneName: wn
};
class Xl {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ga();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ga();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ga();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, n) {
    throw new ga();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    throw new ga();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    throw new ga();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    throw new ga();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ga();
  }
}
let gs = null;
class Po extends Xl {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return gs === null && (gs = new Po()), gs;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(t, { format: n, locale: a }) {
    return wh(t, n, a);
  }
  /** @override **/
  formatOffset(t, n) {
    return Tl(this.offset(t), n);
  }
  /** @override **/
  offset(t) {
    return -new Date(t).getTimezoneOffset();
  }
  /** @override **/
  equals(t) {
    return t.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
const qs = /* @__PURE__ */ new Map();
function M0(e) {
  let t = qs.get(e);
  return t === void 0 && (t = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  }), qs.set(e, t)), t;
}
const O0 = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function D0(e, t) {
  const n = e.format(t).replace(/\u200E/g, ""), a = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, r, l, i, o, s, u, c] = a;
  return [i, r, l, o, s, u, c];
}
function L0(e, t) {
  const n = e.formatToParts(t), a = [];
  for (let r = 0; r < n.length; r++) {
    const { type: l, value: i } = n[r], o = O0[l];
    l === "era" ? a[o] = i : Oe(o) || (a[o] = parseInt(i, 10));
  }
  return a;
}
const ys = /* @__PURE__ */ new Map();
class oa extends Xl {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(t) {
    let n = ys.get(t);
    return n === void 0 && ys.set(t, n = new oa(t)), n;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ys.clear(), qs.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(t) {
    return this.isValidZone(t);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(t) {
    if (!t)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: t }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(t) {
    super(), this.zoneName = t, this.valid = oa.isValidZone(t);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, { format: n, locale: a }) {
    return wh(t, n, a, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    return Tl(this.offset(t), n);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    if (!this.valid) return NaN;
    const n = new Date(t);
    if (isNaN(n)) return NaN;
    const a = M0(this.name);
    let [r, l, i, o, s, u, c] = a.formatToParts ? L0(a, n) : D0(a, n);
    o === "BC" && (r = -Math.abs(r) + 1);
    const f = Eo({
      year: r,
      month: l,
      day: i,
      hour: s === 24 ? 0 : s,
      minute: u,
      second: c,
      millisecond: 0
    });
    let v = +n;
    const g = v % 1e3;
    return v -= g >= 0 ? g : 1e3 + g, (f - v) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    return t.type === "iana" && t.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let vf = {};
function N0(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let a = vf[n];
  return a || (a = new Intl.ListFormat(e, t), vf[n] = a), a;
}
const Ys = /* @__PURE__ */ new Map();
function Ks(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let a = Ys.get(n);
  return a === void 0 && (a = new Intl.DateTimeFormat(e, t), Ys.set(n, a)), a;
}
const Zs = /* @__PURE__ */ new Map();
function F0(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let a = Zs.get(n);
  return a === void 0 && (a = new Intl.NumberFormat(e, t), Zs.set(n, a)), a;
}
const Js = /* @__PURE__ */ new Map();
function R0(e, t = {}) {
  const { base: n, ...a } = t, r = JSON.stringify([e, a]);
  let l = Js.get(r);
  return l === void 0 && (l = new Intl.RelativeTimeFormat(e, t), Js.set(r, l)), l;
}
let bl = null;
function $0() {
  return bl || (bl = new Intl.DateTimeFormat().resolvedOptions().locale, bl);
}
const Xs = /* @__PURE__ */ new Map();
function ch(e) {
  let t = Xs.get(e);
  return t === void 0 && (t = new Intl.DateTimeFormat(e).resolvedOptions(), Xs.set(e, t)), t;
}
const Qs = /* @__PURE__ */ new Map();
function B0(e) {
  let t = Qs.get(e);
  if (!t) {
    const n = new Intl.Locale(e);
    t = "getWeekInfo" in n ? n.getWeekInfo() : n.weekInfo, "minimalDays" in t || (t = { ...dh, ...t }), Qs.set(e, t);
  }
  return t;
}
function U0(e) {
  const t = e.indexOf("-x-");
  t !== -1 && (e = e.substring(0, t));
  const n = e.indexOf("-u-");
  if (n === -1)
    return [e];
  {
    let a, r;
    try {
      a = Ks(e).resolvedOptions(), r = e;
    } catch {
      const s = e.substring(0, n);
      a = Ks(s).resolvedOptions(), r = s;
    }
    const { numberingSystem: l, calendar: i } = a;
    return [r, l, i];
  }
}
function W0(e, t, n) {
  return (n || t) && (e.includes("-u-") || (e += "-u"), n && (e += `-ca-${n}`), t && (e += `-nu-${t}`)), e;
}
function H0(e) {
  const t = [];
  for (let n = 1; n <= 12; n++) {
    const a = Me.utc(2009, n, 1);
    t.push(e(a));
  }
  return t;
}
function z0(e) {
  const t = [];
  for (let n = 1; n <= 7; n++) {
    const a = Me.utc(2016, 11, 13 + n);
    t.push(e(a));
  }
  return t;
}
function Ti(e, t, n, a) {
  const r = e.listingMode();
  return r === "error" ? null : r === "en" ? n(t) : a(t);
}
function j0(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || ch(e.locale).numberingSystem === "latn";
}
class G0 {
  constructor(t, n, a) {
    this.padTo = a.padTo || 0, this.floor = a.floor || !1;
    const { padTo: r, floor: l, ...i } = a;
    if (!n || Object.keys(i).length > 0) {
      const o = { useGrouping: !1, ...a };
      a.padTo > 0 && (o.minimumIntegerDigits = a.padTo), this.inf = F0(t, o);
    }
  }
  format(t) {
    if (this.inf) {
      const n = this.floor ? Math.floor(t) : t;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(t) : mc(t, 3);
      return Dt(n, this.padTo);
    }
  }
}
class q0 {
  constructor(t, n, a) {
    this.opts = a, this.originalZone = void 0;
    let r;
    if (this.opts.timeZone)
      this.dt = t;
    else if (t.zone.type === "fixed") {
      const i = -1 * (t.offset / 60), o = i >= 0 ? `Etc/GMT+${i}` : `Etc/GMT${i}`;
      t.offset !== 0 && oa.create(o).valid ? (r = o, this.dt = t) : (r = "UTC", this.dt = t.offset === 0 ? t : t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    } else t.zone.type === "system" ? this.dt = t : t.zone.type === "iana" ? (this.dt = t, r = t.zone.name) : (r = "UTC", this.dt = t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    const l = { ...this.opts };
    l.timeZone = l.timeZone || r, this.dtf = Ks(n, l);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: t }) => t).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const t = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? t.map((n) => {
      if (n.type === "timeZoneName") {
        const a = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...n,
          value: a
        };
      } else
        return n;
    }) : t;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class Y0 {
  constructor(t, n, a) {
    this.opts = { style: "long", ...a }, !n && bh() && (this.rtf = R0(t, a));
  }
  format(t, n) {
    return this.rtf ? this.rtf.format(t, n) : gx(n, t, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(t, n) {
    return this.rtf ? this.rtf.formatToParts(t, n) : [];
  }
}
const dh = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class tt {
  static fromOpts(t) {
    return tt.create(
      t.locale,
      t.numberingSystem,
      t.outputCalendar,
      t.weekSettings,
      t.defaultToEN
    );
  }
  static create(t, n, a, r, l = !1) {
    const i = t || Tt.defaultLocale, o = i || (l ? "en-US" : $0()), s = n || Tt.defaultNumberingSystem, u = a || Tt.defaultOutputCalendar, c = tu(r) || Tt.defaultWeekSettings;
    return new tt(o, s, u, c, i);
  }
  static resetCache() {
    bl = null, Ys.clear(), Zs.clear(), Js.clear(), Xs.clear(), Qs.clear();
  }
  static fromObject({ locale: t, numberingSystem: n, outputCalendar: a, weekSettings: r } = {}) {
    return tt.create(t, n, a, r);
  }
  constructor(t, n, a, r, l) {
    const [i, o, s] = U0(t);
    this.locale = i, this.numberingSystem = n || o || null, this.outputCalendar = a || s || null, this.weekSettings = r, this.intl = W0(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = l, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = j0(this)), this.fastNumbersCached;
  }
  listingMode() {
    const t = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return t && n ? "en" : "intl";
  }
  clone(t) {
    return !t || Object.getOwnPropertyNames(t).length === 0 ? this : tt.create(
      t.locale || this.specifiedLocale,
      t.numberingSystem || this.numberingSystem,
      t.outputCalendar || this.outputCalendar,
      tu(t.weekSettings) || this.weekSettings,
      t.defaultToEN || !1
    );
  }
  redefaultToEN(t = {}) {
    return this.clone({ ...t, defaultToEN: !0 });
  }
  redefaultToSystem(t = {}) {
    return this.clone({ ...t, defaultToEN: !1 });
  }
  months(t, n = !1) {
    return Ti(this, t, xh, () => {
      const a = this.intl === "ja" || this.intl.startsWith("ja-");
      n &= !a;
      const r = n ? { month: t, day: "numeric" } : { month: t }, l = n ? "format" : "standalone";
      if (!this.monthsCache[l][t]) {
        const i = a ? (o) => this.dtFormatter(o, r).format() : (o) => this.extract(o, r, "month");
        this.monthsCache[l][t] = H0(i);
      }
      return this.monthsCache[l][t];
    });
  }
  weekdays(t, n = !1) {
    return Ti(this, t, Th, () => {
      const a = n ? { weekday: t, year: "numeric", month: "long", day: "numeric" } : { weekday: t }, r = n ? "format" : "standalone";
      return this.weekdaysCache[r][t] || (this.weekdaysCache[r][t] = z0(
        (l) => this.extract(l, a, "weekday")
      )), this.weekdaysCache[r][t];
    });
  }
  meridiems() {
    return Ti(
      this,
      void 0,
      () => Ih,
      () => {
        if (!this.meridiemCache) {
          const t = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [Me.utc(2016, 11, 13, 9), Me.utc(2016, 11, 13, 19)].map(
            (n) => this.extract(n, t, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(t) {
    return Ti(this, t, Ah, () => {
      const n = { era: t };
      return this.eraCache[t] || (this.eraCache[t] = [Me.utc(-40, 1, 1), Me.utc(2017, 1, 1)].map(
        (a) => this.extract(a, n, "era")
      )), this.eraCache[t];
    });
  }
  extract(t, n, a) {
    const r = this.dtFormatter(t, n), l = r.formatToParts(), i = l.find((o) => o.type.toLowerCase() === a);
    return i ? i.value : null;
  }
  numberFormatter(t = {}) {
    return new G0(this.intl, t.forceSimple || this.fastNumbers, t);
  }
  dtFormatter(t, n = {}) {
    return new q0(t, this.intl, n);
  }
  relFormatter(t = {}) {
    return new Y0(this.intl, this.isEnglish(), t);
  }
  listFormatter(t = {}) {
    return N0(this.intl, t);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || ch(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : ph() ? B0(this.locale) : dh;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(t) {
    return this.locale === t.locale && this.numberingSystem === t.numberingSystem && this.outputCalendar === t.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let bs = null;
class nn extends Xl {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return bs === null && (bs = new nn(0)), bs;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(t) {
    return t === 0 ? nn.utcInstance : new nn(t);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(t) {
    if (t) {
      const n = t.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new nn(Mo(n[1], n[2]));
    }
    return null;
  }
  constructor(t) {
    super(), this.fixed = t;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Tl(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Tl(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    return Tl(this.fixed, n);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    return t.type === "fixed" && t.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class K0 extends Xl {
  constructor(t) {
    super(), this.zoneName = t;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function ba(e, t) {
  if (Oe(e) || e === null)
    return t;
  if (e instanceof Xl)
    return e;
  if (tx(e)) {
    const n = e.toLowerCase();
    return n === "default" ? t : n === "local" || n === "system" ? Po.instance : n === "utc" || n === "gmt" ? nn.utcInstance : nn.parseSpecifier(n) || oa.create(e);
  } else return Sa(e) ? nn.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new K0(e);
}
const cc = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, mf = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, Z0 = cc.hanidec.replace(/[\[|\]]/g, "").split("");
function J0(e) {
  let t = parseInt(e, 10);
  if (isNaN(t)) {
    t = "";
    for (let n = 0; n < e.length; n++) {
      const a = e.charCodeAt(n);
      if (e[n].search(cc.hanidec) !== -1)
        t += Z0.indexOf(e[n]);
      else
        for (const r in mf) {
          const [l, i] = mf[r];
          a >= l && a <= i && (t += a - l);
        }
    }
    return parseInt(t, 10);
  } else
    return t;
}
const eu = /* @__PURE__ */ new Map();
function X0() {
  eu.clear();
}
function Mn({ numberingSystem: e }, t = "") {
  const n = e || "latn";
  let a = eu.get(n);
  a === void 0 && (a = /* @__PURE__ */ new Map(), eu.set(n, a));
  let r = a.get(t);
  return r === void 0 && (r = new RegExp(`${cc[n]}${t}`), a.set(t, r)), r;
}
let hf = () => Date.now(), gf = "system", yf = null, bf = null, pf = null, wf = 60, kf, Sf = null;
class Tt {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return hf;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(t) {
    hf = t;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(t) {
    gf = t;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return ba(gf, Po.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return yf;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(t) {
    yf = t;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return bf;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(t) {
    bf = t;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return pf;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(t) {
    pf = t;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return Sf;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(t) {
    Sf = tu(t);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return wf;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(t) {
    wf = t % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return kf;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    kf = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    tt.resetCache(), oa.resetCache(), Me.resetCache(), X0();
  }
}
class Ln {
  constructor(t, n) {
    this.reason = t, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const fh = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], vh = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function In(e, t) {
  return new Ln(
    "unit out of range",
    `you specified ${t} (of type ${typeof t}) as a ${e}, which is invalid`
  );
}
function dc(e, t, n) {
  const a = new Date(Date.UTC(e, t - 1, n));
  e < 100 && e >= 0 && a.setUTCFullYear(a.getUTCFullYear() - 1900);
  const r = a.getUTCDay();
  return r === 0 ? 7 : r;
}
function mh(e, t, n) {
  return n + (Ql(e) ? vh : fh)[t - 1];
}
function hh(e, t) {
  const n = Ql(e) ? vh : fh, a = n.findIndex((l) => l < t), r = t - n[a];
  return { month: a + 1, day: r };
}
function fc(e, t) {
  return (e - t + 7) % 7 + 1;
}
function to(e, t = 4, n = 1) {
  const { year: a, month: r, day: l } = e, i = mh(a, r, l), o = fc(dc(a, r, l), n);
  let s = Math.floor((i - o + 14 - t) / 7), u;
  return s < 1 ? (u = a - 1, s = El(u, t, n)) : s > El(a, t, n) ? (u = a + 1, s = 1) : u = a, { weekYear: u, weekNumber: s, weekday: o, ...Oo(e) };
}
function xf(e, t = 4, n = 1) {
  const { weekYear: a, weekNumber: r, weekday: l } = e, i = fc(dc(a, 1, t), n), o = Lr(a);
  let s = r * 7 + l - i - 7 + t, u;
  s < 1 ? (u = a - 1, s += Lr(u)) : s > o ? (u = a + 1, s -= Lr(a)) : u = a;
  const { month: c, day: d } = hh(u, s);
  return { year: u, month: c, day: d, ...Oo(e) };
}
function ps(e) {
  const { year: t, month: n, day: a } = e, r = mh(t, n, a);
  return { year: t, ordinal: r, ...Oo(e) };
}
function Cf(e) {
  const { year: t, ordinal: n } = e, { month: a, day: r } = hh(t, n);
  return { year: t, month: a, day: r, ...Oo(e) };
}
function _f(e, t) {
  if (!Oe(e.localWeekday) || !Oe(e.localWeekNumber) || !Oe(e.localWeekYear)) {
    if (!Oe(e.weekday) || !Oe(e.weekNumber) || !Oe(e.weekYear))
      throw new Er(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return Oe(e.localWeekday) || (e.weekday = e.localWeekday), Oe(e.localWeekNumber) || (e.weekNumber = e.localWeekNumber), Oe(e.localWeekYear) || (e.weekYear = e.localWeekYear), delete e.localWeekday, delete e.localWeekNumber, delete e.localWeekYear, {
      minDaysInFirstWeek: t.getMinDaysInFirstWeek(),
      startOfWeek: t.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function Q0(e, t = 4, n = 1) {
  const a = Vo(e.weekYear), r = An(
    e.weekNumber,
    1,
    El(e.weekYear, t, n)
  ), l = An(e.weekday, 1, 7);
  return a ? r ? l ? !1 : In("weekday", e.weekday) : In("week", e.weekNumber) : In("weekYear", e.weekYear);
}
function ex(e) {
  const t = Vo(e.year), n = An(e.ordinal, 1, Lr(e.year));
  return t ? n ? !1 : In("ordinal", e.ordinal) : In("year", e.year);
}
function gh(e) {
  const t = Vo(e.year), n = An(e.month, 1, 12), a = An(e.day, 1, no(e.year, e.month));
  return t ? n ? a ? !1 : In("day", e.day) : In("month", e.month) : In("year", e.year);
}
function yh(e) {
  const { hour: t, minute: n, second: a, millisecond: r } = e, l = An(t, 0, 23) || t === 24 && n === 0 && a === 0 && r === 0, i = An(n, 0, 59), o = An(a, 0, 59), s = An(r, 0, 999);
  return l ? i ? o ? s ? !1 : In("millisecond", r) : In("second", a) : In("minute", n) : In("hour", t);
}
function Oe(e) {
  return typeof e > "u";
}
function Sa(e) {
  return typeof e == "number";
}
function Vo(e) {
  return typeof e == "number" && e % 1 === 0;
}
function tx(e) {
  return typeof e == "string";
}
function nx(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function bh() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function ph() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function ax(e) {
  return Array.isArray(e) ? e : [e];
}
function Tf(e, t, n) {
  if (e.length !== 0)
    return e.reduce((a, r) => {
      const l = [t(r), r];
      return a && n(a[0], l[0]) === a[0] ? a : l;
    }, null)[1];
}
function rx(e, t) {
  return t.reduce((n, a) => (n[a] = e[a], n), {});
}
function Ur(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function tu(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new Kt("Week settings must be an object");
  if (!An(e.firstDay, 1, 7) || !An(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((t) => !An(t, 1, 7)))
    throw new Kt("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function An(e, t, n) {
  return Vo(e) && e >= t && e <= n;
}
function lx(e, t) {
  return e - t * Math.floor(e / t);
}
function Dt(e, t = 2) {
  const n = e < 0;
  let a;
  return n ? a = "-" + ("" + -e).padStart(t, "0") : a = ("" + e).padStart(t, "0"), a;
}
function ya(e) {
  if (!(Oe(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function Ra(e) {
  if (!(Oe(e) || e === null || e === ""))
    return parseFloat(e);
}
function vc(e) {
  if (!(Oe(e) || e === null || e === "")) {
    const t = parseFloat("0." + e) * 1e3;
    return Math.floor(t);
  }
}
function mc(e, t, n = "round") {
  const a = 10 ** t;
  switch (n) {
    case "expand":
      return e > 0 ? Math.ceil(e * a) / a : Math.floor(e * a) / a;
    case "trunc":
      return Math.trunc(e * a) / a;
    case "round":
      return Math.round(e * a) / a;
    case "floor":
      return Math.floor(e * a) / a;
    case "ceil":
      return Math.ceil(e * a) / a;
    default:
      throw new RangeError(`Value rounding ${n} is out of range`);
  }
}
function Ql(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function Lr(e) {
  return Ql(e) ? 366 : 365;
}
function no(e, t) {
  const n = lx(t - 1, 12) + 1, a = e + (t - n) / 12;
  return n === 2 ? Ql(a) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function Eo(e) {
  let t = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (t = new Date(t), t.setUTCFullYear(e.year, e.month - 1, e.day)), +t;
}
function If(e, t, n) {
  return -fc(dc(e, 1, t), n) + t - 1;
}
function El(e, t = 4, n = 1) {
  const a = If(e, t, n), r = If(e + 1, t, n);
  return (Lr(e) - a + r) / 7;
}
function nu(e) {
  return e > 99 ? e : e > Tt.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function wh(e, t, n, a = null) {
  const r = new Date(e), l = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  a && (l.timeZone = a);
  const i = { timeZoneName: t, ...l }, o = new Intl.DateTimeFormat(n, i).formatToParts(r).find((s) => s.type.toLowerCase() === "timezonename");
  return o ? o.value : null;
}
function Mo(e, t) {
  let n = parseInt(e, 10);
  Number.isNaN(n) && (n = 0);
  const a = parseInt(t, 10) || 0, r = n < 0 || Object.is(n, -0) ? -a : a;
  return n * 60 + r;
}
function kh(e) {
  const t = Number(e);
  if (typeof e == "boolean" || e === "" || !Number.isFinite(t))
    throw new Kt(`Invalid unit value ${e}`);
  return t;
}
function ao(e, t) {
  const n = {};
  for (const a in e)
    if (Ur(e, a)) {
      const r = e[a];
      if (r == null) continue;
      n[t(a)] = kh(r);
    }
  return n;
}
function Tl(e, t) {
  const n = Math.trunc(Math.abs(e / 60)), a = Math.trunc(Math.abs(e % 60)), r = e >= 0 ? "+" : "-";
  switch (t) {
    case "short":
      return `${r}${Dt(n, 2)}:${Dt(a, 2)}`;
    case "narrow":
      return `${r}${n}${a > 0 ? `:${a}` : ""}`;
    case "techie":
      return `${r}${Dt(n, 2)}${Dt(a, 2)}`;
    default:
      throw new RangeError(`Value format ${t} is out of range for property format`);
  }
}
function Oo(e) {
  return rx(e, ["hour", "minute", "second", "millisecond"]);
}
const ix = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], Sh = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], ox = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function xh(e) {
  switch (e) {
    case "narrow":
      return [...ox];
    case "short":
      return [...Sh];
    case "long":
      return [...ix];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const Ch = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], _h = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], sx = ["M", "T", "W", "T", "F", "S", "S"];
function Th(e) {
  switch (e) {
    case "narrow":
      return [...sx];
    case "short":
      return [..._h];
    case "long":
      return [...Ch];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const Ih = ["AM", "PM"], ux = ["Before Christ", "Anno Domini"], cx = ["BC", "AD"], dx = ["B", "A"];
function Ah(e) {
  switch (e) {
    case "narrow":
      return [...dx];
    case "short":
      return [...cx];
    case "long":
      return [...ux];
    default:
      return null;
  }
}
function fx(e) {
  return Ih[e.hour < 12 ? 0 : 1];
}
function vx(e, t) {
  return Th(t)[e.weekday - 1];
}
function mx(e, t) {
  return xh(t)[e.month - 1];
}
function hx(e, t) {
  return Ah(t)[e.year < 0 ? 0 : 1];
}
function gx(e, t, n = "always", a = !1) {
  const r = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, l = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (n === "auto" && l) {
    const d = e === "days";
    switch (t) {
      case 1:
        return d ? "tomorrow" : `next ${r[e][0]}`;
      case -1:
        return d ? "yesterday" : `last ${r[e][0]}`;
      case 0:
        return d ? "today" : `this ${r[e][0]}`;
    }
  }
  const i = Object.is(t, -0) || t < 0, o = Math.abs(t), s = o === 1, u = r[e], c = a ? s ? u[1] : u[2] || u[1] : s ? r[e][0] : e;
  return i ? `${o} ${c} ago` : `in ${o} ${c}`;
}
function Af(e, t) {
  let n = "";
  for (const a of e)
    a.literal ? n += a.val : n += t(a.val);
  return n;
}
const yx = {
  D: eo,
  DD: jm,
  DDD: Gm,
  DDDD: qm,
  t: Ym,
  tt: Km,
  ttt: Zm,
  tttt: Jm,
  T: Xm,
  TT: Qm,
  TTT: eh,
  TTTT: th,
  f: nh,
  ff: rh,
  fff: ih,
  ffff: sh,
  F: ah,
  FF: lh,
  FFF: oh,
  FFFF: uh
};
class Jt {
  static create(t, n = {}) {
    return new Jt(t, n);
  }
  static parseFormat(t) {
    let n = null, a = "", r = !1;
    const l = [];
    for (let i = 0; i < t.length; i++) {
      const o = t.charAt(i);
      o === "'" ? ((a.length > 0 || r) && l.push({
        literal: r || /^\s+$/.test(a),
        val: a === "" ? "'" : a
      }), n = null, a = "", r = !r) : r || o === n ? a += o : (a.length > 0 && l.push({ literal: /^\s+$/.test(a), val: a }), a = o, n = o);
    }
    return a.length > 0 && l.push({ literal: r || /^\s+$/.test(a), val: a }), l;
  }
  static macroTokenToFormatOpts(t) {
    return yx[t];
  }
  constructor(t, n) {
    this.opts = n, this.loc = t, this.systemLoc = null;
  }
  formatWithSystemDefault(t, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(t, { ...this.opts, ...n }).format();
  }
  dtFormatter(t, n = {}) {
    return this.loc.dtFormatter(t, { ...this.opts, ...n });
  }
  formatDateTime(t, n) {
    return this.dtFormatter(t, n).format();
  }
  formatDateTimeParts(t, n) {
    return this.dtFormatter(t, n).formatToParts();
  }
  formatInterval(t, n) {
    return this.dtFormatter(t.start, n).dtf.formatRange(t.start.toJSDate(), t.end.toJSDate());
  }
  resolvedOptions(t, n) {
    return this.dtFormatter(t, n).resolvedOptions();
  }
  num(t, n = 0, a = void 0) {
    if (this.opts.forceSimple)
      return Dt(t, n);
    const r = { ...this.opts };
    return n > 0 && (r.padTo = n), a && (r.signDisplay = a), this.loc.numberFormatter(r).format(t);
  }
  formatDateTimeFromString(t, n) {
    const a = this.loc.listingMode() === "en", r = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", l = (v, g) => this.loc.extract(t, v, g), i = (v) => t.isOffsetFixed && t.offset === 0 && v.allowZ ? "Z" : t.isValid ? t.zone.formatOffset(t.ts, v.format) : "", o = () => a ? fx(t) : l({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), s = (v, g) => a ? mx(t, v) : l(g ? { month: v } : { month: v, day: "numeric" }, "month"), u = (v, g) => a ? vx(t, v) : l(
      g ? { weekday: v } : { weekday: v, month: "long", day: "numeric" },
      "weekday"
    ), c = (v) => {
      const g = Jt.macroTokenToFormatOpts(v);
      return g ? this.formatWithSystemDefault(t, g) : v;
    }, d = (v) => a ? hx(t, v) : l({ era: v }, "era"), f = (v) => {
      switch (v) {
        // ms
        case "S":
          return this.num(t.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(t.millisecond, 3);
        // seconds
        case "s":
          return this.num(t.second);
        case "ss":
          return this.num(t.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(t.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(t.millisecond / 100));
        // minutes
        case "m":
          return this.num(t.minute);
        case "mm":
          return this.num(t.minute, 2);
        // hours
        case "h":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12);
        case "hh":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12, 2);
        case "H":
          return this.num(t.hour);
        case "HH":
          return this.num(t.hour, 2);
        // offset
        case "Z":
          return i({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return i({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return i({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return t.zone.offsetName(t.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return t.zone.offsetName(t.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return t.zoneName;
        // meridiems
        case "a":
          return o();
        // dates
        case "d":
          return r ? l({ day: "numeric" }, "day") : this.num(t.day);
        case "dd":
          return r ? l({ day: "2-digit" }, "day") : this.num(t.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(t.weekday);
        case "ccc":
          return u("short", !0);
        case "cccc":
          return u("long", !0);
        case "ccccc":
          return u("narrow", !0);
        // weekdays - format
        case "E":
          return this.num(t.weekday);
        case "EEE":
          return u("short", !1);
        case "EEEE":
          return u("long", !1);
        case "EEEEE":
          return u("narrow", !1);
        // months - standalone
        case "L":
          return r ? l({ month: "numeric", day: "numeric" }, "month") : this.num(t.month);
        case "LL":
          return r ? l({ month: "2-digit", day: "numeric" }, "month") : this.num(t.month, 2);
        case "LLL":
          return s("short", !0);
        case "LLLL":
          return s("long", !0);
        case "LLLLL":
          return s("narrow", !0);
        // months - format
        case "M":
          return r ? l({ month: "numeric" }, "month") : this.num(t.month);
        case "MM":
          return r ? l({ month: "2-digit" }, "month") : this.num(t.month, 2);
        case "MMM":
          return s("short", !1);
        case "MMMM":
          return s("long", !1);
        case "MMMMM":
          return s("narrow", !1);
        // years
        case "y":
          return r ? l({ year: "numeric" }, "year") : this.num(t.year);
        case "yy":
          return r ? l({ year: "2-digit" }, "year") : this.num(t.year.toString().slice(-2), 2);
        case "yyyy":
          return r ? l({ year: "numeric" }, "year") : this.num(t.year, 4);
        case "yyyyyy":
          return r ? l({ year: "numeric" }, "year") : this.num(t.year, 6);
        // eras
        case "G":
          return d("short");
        case "GG":
          return d("long");
        case "GGGGG":
          return d("narrow");
        case "kk":
          return this.num(t.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(t.weekYear, 4);
        case "W":
          return this.num(t.weekNumber);
        case "WW":
          return this.num(t.weekNumber, 2);
        case "n":
          return this.num(t.localWeekNumber);
        case "nn":
          return this.num(t.localWeekNumber, 2);
        case "ii":
          return this.num(t.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(t.localWeekYear, 4);
        case "o":
          return this.num(t.ordinal);
        case "ooo":
          return this.num(t.ordinal, 3);
        case "q":
          return this.num(t.quarter);
        case "qq":
          return this.num(t.quarter, 2);
        case "X":
          return this.num(Math.floor(t.ts / 1e3));
        case "x":
          return this.num(t.ts);
        default:
          return c(v);
      }
    };
    return Af(Jt.parseFormat(n), f);
  }
  formatDurationFromString(t, n) {
    const a = this.opts.signMode === "negativeLargestOnly" ? -1 : 1, r = (c) => {
      switch (c[0]) {
        case "S":
          return "milliseconds";
        case "s":
          return "seconds";
        case "m":
          return "minutes";
        case "h":
          return "hours";
        case "d":
          return "days";
        case "w":
          return "weeks";
        case "M":
          return "months";
        case "y":
          return "years";
        default:
          return null;
      }
    }, l = (c, d) => (f) => {
      const v = r(f);
      if (v) {
        const g = d.isNegativeDuration && v !== d.largestUnit ? a : 1;
        let m;
        return this.opts.signMode === "negativeLargestOnly" && v !== d.largestUnit ? m = "never" : this.opts.signMode === "all" ? m = "always" : m = "auto", this.num(c.get(v) * g, f.length, m);
      } else
        return f;
    }, i = Jt.parseFormat(n), o = i.reduce(
      (c, { literal: d, val: f }) => d ? c : c.concat(f),
      []
    ), s = t.shiftTo(...o.map(r).filter((c) => c)), u = {
      isNegativeDuration: s < 0,
      // this relies on "collapsed" being based on "shiftTo", which builds up the object
      // in order
      largestUnit: Object.keys(s.values)[0]
    };
    return Af(i, l(s, u));
  }
}
const Ph = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function tl(...e) {
  const t = e.reduce((n, a) => n + a.source, "");
  return RegExp(`^${t}$`);
}
function nl(...e) {
  return (t) => e.reduce(
    ([n, a, r], l) => {
      const [i, o, s] = l(t, r);
      return [{ ...n, ...i }, o || a, s];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function al(e, ...t) {
  if (e == null)
    return [null, null];
  for (const [n, a] of t) {
    const r = n.exec(e);
    if (r)
      return a(r);
  }
  return [null, null];
}
function Vh(...e) {
  return (t, n) => {
    const a = {};
    let r;
    for (r = 0; r < e.length; r++)
      a[e[r]] = ya(t[n + r]);
    return [a, null, n + r];
  };
}
const Eh = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/, bx = `(?:${Eh.source}?(?:\\[(${Ph.source})\\])?)?`, hc = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, Mh = RegExp(`${hc.source}${bx}`), gc = RegExp(`(?:[Tt]${Mh.source})?`), px = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, wx = /(\d{4})-?W(\d\d)(?:-?(\d))?/, kx = /(\d{4})-?(\d{3})/, Sx = Vh("weekYear", "weekNumber", "weekDay"), xx = Vh("year", "ordinal"), Cx = /(\d{4})-(\d\d)-(\d\d)/, Oh = RegExp(
  `${hc.source} ?(?:${Eh.source}|(${Ph.source}))?`
), _x = RegExp(`(?: ${Oh.source})?`);
function Nr(e, t, n) {
  const a = e[t];
  return Oe(a) ? n : ya(a);
}
function Tx(e, t) {
  return [{
    year: Nr(e, t),
    month: Nr(e, t + 1, 1),
    day: Nr(e, t + 2, 1)
  }, null, t + 3];
}
function rl(e, t) {
  return [{
    hours: Nr(e, t, 0),
    minutes: Nr(e, t + 1, 0),
    seconds: Nr(e, t + 2, 0),
    milliseconds: vc(e[t + 3])
  }, null, t + 4];
}
function ei(e, t) {
  const n = !e[t] && !e[t + 1], a = Mo(e[t + 1], e[t + 2]), r = n ? null : nn.instance(a);
  return [{}, r, t + 3];
}
function ti(e, t) {
  const n = e[t] ? oa.create(e[t]) : null;
  return [{}, n, t + 1];
}
const Ix = RegExp(`^T?${hc.source}$`), Ax = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function Px(e) {
  const [t, n, a, r, l, i, o, s, u] = e, c = t[0] === "-", d = s && s[0] === "-", f = (v, g = !1) => v !== void 0 && (g || v && c) ? -v : v;
  return [
    {
      years: f(Ra(n)),
      months: f(Ra(a)),
      weeks: f(Ra(r)),
      days: f(Ra(l)),
      hours: f(Ra(i)),
      minutes: f(Ra(o)),
      seconds: f(Ra(s), s === "-0"),
      milliseconds: f(vc(u), d)
    }
  ];
}
const Vx = {
  GMT: 0,
  EDT: -240,
  EST: -300,
  CDT: -300,
  CST: -360,
  MDT: -360,
  MST: -420,
  PDT: -420,
  PST: -480
};
function yc(e, t, n, a, r, l, i) {
  const o = {
    year: t.length === 2 ? nu(ya(t)) : ya(t),
    month: Sh.indexOf(n) + 1,
    day: ya(a),
    hour: ya(r),
    minute: ya(l)
  };
  return i && (o.second = ya(i)), e && (o.weekday = e.length > 3 ? Ch.indexOf(e) + 1 : _h.indexOf(e) + 1), o;
}
const Ex = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function Mx(e) {
  const [
    ,
    t,
    n,
    a,
    r,
    l,
    i,
    o,
    s,
    u,
    c,
    d
  ] = e, f = yc(t, r, a, n, l, i, o);
  let v;
  return s ? v = Vx[s] : u ? v = 0 : v = Mo(c, d), [f, new nn(v)];
}
function Ox(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const Dx = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, Lx = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, Nx = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function Pf(e) {
  const [, t, n, a, r, l, i, o] = e;
  return [yc(t, r, a, n, l, i, o), nn.utcInstance];
}
function Fx(e) {
  const [, t, n, a, r, l, i, o] = e;
  return [yc(t, o, n, a, r, l, i), nn.utcInstance];
}
const Rx = tl(px, gc), $x = tl(wx, gc), Bx = tl(kx, gc), Ux = tl(Mh), Dh = nl(
  Tx,
  rl,
  ei,
  ti
), Wx = nl(
  Sx,
  rl,
  ei,
  ti
), Hx = nl(
  xx,
  rl,
  ei,
  ti
), zx = nl(
  rl,
  ei,
  ti
);
function jx(e) {
  return al(
    e,
    [Rx, Dh],
    [$x, Wx],
    [Bx, Hx],
    [Ux, zx]
  );
}
function Gx(e) {
  return al(Ox(e), [Ex, Mx]);
}
function qx(e) {
  return al(
    e,
    [Dx, Pf],
    [Lx, Pf],
    [Nx, Fx]
  );
}
function Yx(e) {
  return al(e, [Ax, Px]);
}
const Kx = nl(rl);
function Zx(e) {
  return al(e, [Ix, Kx]);
}
const Jx = tl(Cx, _x), Xx = tl(Oh), Qx = nl(
  rl,
  ei,
  ti
);
function eC(e) {
  return al(
    e,
    [Jx, Dh],
    [Xx, Qx]
  );
}
const Vf = "Invalid Duration", Lh = {
  weeks: {
    days: 7,
    hours: 168,
    minutes: 10080,
    seconds: 10080 * 60,
    milliseconds: 10080 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 1440,
    seconds: 1440 * 60,
    milliseconds: 1440 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 3600, milliseconds: 3600 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, tC = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 2184,
    minutes: 2184 * 60,
    seconds: 2184 * 60 * 60,
    milliseconds: 2184 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 720,
    minutes: 720 * 60,
    seconds: 720 * 60 * 60,
    milliseconds: 720 * 60 * 60 * 1e3
  },
  ...Lh
}, Tn = 146097 / 400, Sr = 146097 / 4800, nC = {
  years: {
    quarters: 4,
    months: 12,
    weeks: Tn / 7,
    days: Tn,
    hours: Tn * 24,
    minutes: Tn * 24 * 60,
    seconds: Tn * 24 * 60 * 60,
    milliseconds: Tn * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: Tn / 28,
    days: Tn / 4,
    hours: Tn * 24 / 4,
    minutes: Tn * 24 * 60 / 4,
    seconds: Tn * 24 * 60 * 60 / 4,
    milliseconds: Tn * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: Sr / 7,
    days: Sr,
    hours: Sr * 24,
    minutes: Sr * 24 * 60,
    seconds: Sr * 24 * 60 * 60,
    milliseconds: Sr * 24 * 60 * 60 * 1e3
  },
  ...Lh
}, za = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], aC = za.slice(0).reverse();
function ta(e, t, n = !1) {
  const a = {
    values: n ? t.values : { ...e.values, ...t.values || {} },
    loc: e.loc.clone(t.loc),
    conversionAccuracy: t.conversionAccuracy || e.conversionAccuracy,
    matrix: t.matrix || e.matrix
  };
  return new Ye(a);
}
function Nh(e, t) {
  let n = t.milliseconds ?? 0;
  for (const a of aC.slice(1))
    t[a] && (n += t[a] * e[a].milliseconds);
  return n;
}
function Ef(e, t) {
  const n = Nh(e, t) < 0 ? -1 : 1;
  za.reduceRight((a, r) => {
    if (Oe(t[r]))
      return a;
    if (a) {
      const l = t[a] * n, i = e[r][a], o = Math.floor(l / i);
      t[r] += o * n, t[a] -= o * i * n;
    }
    return r;
  }, null), za.reduce((a, r) => {
    if (Oe(t[r]))
      return a;
    if (a) {
      const l = t[a] % 1;
      t[a] -= l, t[r] += l * e[a][r];
    }
    return r;
  }, null);
}
function Mf(e) {
  const t = {};
  for (const [n, a] of Object.entries(e))
    a !== 0 && (t[n] = a);
  return t;
}
class Ye {
  /**
   * @private
   */
  constructor(t) {
    const n = t.conversionAccuracy === "longterm" || !1;
    let a = n ? nC : tC;
    t.matrix && (a = t.matrix), this.values = t.values, this.loc = t.loc || tt.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = t.invalid || null, this.matrix = a, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(t, n) {
    return Ye.fromObject({ milliseconds: t }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(t, n = {}) {
    if (t == null || typeof t != "object")
      throw new Kt(
        `Duration.fromObject: argument expected to be an object, got ${t === null ? "null" : typeof t}`
      );
    return new Ye({
      values: ao(t, Ye.normalizeUnit),
      loc: tt.fromObject(n),
      conversionAccuracy: n.conversionAccuracy,
      matrix: n.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(t) {
    if (Sa(t))
      return Ye.fromMillis(t);
    if (Ye.isDuration(t))
      return t;
    if (typeof t == "object")
      return Ye.fromObject(t);
    throw new Kt(
      `Unknown duration argument ${t} of type ${typeof t}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(t, n) {
    const [a] = Yx(t);
    return a ? Ye.fromObject(a, n) : Ye.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(t, n) {
    const [a] = Zx(t);
    return a ? Ye.fromObject(a, n) : Ye.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new Kt("need to specify a reason the Duration is invalid");
    const a = t instanceof Ln ? t : new Ln(t, n);
    if (Tt.throwOnInvalid)
      throw new P0(a);
    return new Ye({ invalid: a });
  }
  /**
   * @private
   */
  static normalizeUnit(t) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[t && t.toLowerCase()];
    if (!n) throw new zm(t);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(t) {
    return t && t.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */
  toFormat(t, n = {}) {
    const a = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? Jt.create(this.loc, a).formatDurationFromString(this, t) : Vf;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */
  toHuman(t = {}) {
    if (!this.isValid) return Vf;
    const n = t.showZeros !== !1, a = za.map((r) => {
      const l = this.values[r];
      return Oe(l) || l === 0 && !n ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...t, unit: r.slice(0, -1) }).format(l);
    }).filter((r) => r);
    return this.loc.listFormatter({ type: "conjunction", style: t.listStyle || "narrow", ...t }).format(a);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let t = "P";
    return this.years !== 0 && (t += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (t += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (t += this.weeks + "W"), this.days !== 0 && (t += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (t += "T"), this.hours !== 0 && (t += this.hours + "H"), this.minutes !== 0 && (t += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (t += mc(this.seconds + this.milliseconds / 1e3, 3) + "S"), t === "P" && (t += "T0S"), t;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(t = {}) {
    if (!this.isValid) return null;
    const n = this.toMillis();
    return n < 0 || n >= 864e5 ? null : (t = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...t,
      includeOffset: !1
    }, Me.fromMillis(n, { zone: "UTC" }).toISOTime(t));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? Nh(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(t) {
    if (!this.isValid) return this;
    const n = Ye.fromDurationLike(t), a = {};
    for (const r of za)
      (Ur(n.values, r) || Ur(this.values, r)) && (a[r] = n.get(r) + this.get(r));
    return ta(this, { values: a }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(t) {
    if (!this.isValid) return this;
    const n = Ye.fromDurationLike(t);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(t) {
    if (!this.isValid) return this;
    const n = {};
    for (const a of Object.keys(this.values))
      n[a] = kh(t(this.values[a], a));
    return ta(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(t) {
    return this[Ye.normalizeUnit(t)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(t) {
    if (!this.isValid) return this;
    const n = { ...this.values, ...ao(t, Ye.normalizeUnit) };
    return ta(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: t, numberingSystem: n, conversionAccuracy: a, matrix: r } = {}) {
    const i = { loc: this.loc.clone({ locale: t, numberingSystem: n }), matrix: r, conversionAccuracy: a };
    return ta(this, i);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(t) {
    return this.isValid ? this.shiftTo(t).get(t) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const t = this.toObject();
    return Ef(this.matrix, t), ta(this, { values: t }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const t = Mf(this.normalize().shiftToAll().toObject());
    return ta(this, { values: t }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...t) {
    if (!this.isValid) return this;
    if (t.length === 0)
      return this;
    t = t.map((i) => Ye.normalizeUnit(i));
    const n = {}, a = {}, r = this.toObject();
    let l;
    for (const i of za)
      if (t.indexOf(i) >= 0) {
        l = i;
        let o = 0;
        for (const u in a)
          o += this.matrix[u][i] * a[u], a[u] = 0;
        Sa(r[i]) && (o += r[i]);
        const s = Math.trunc(o);
        n[i] = s, a[i] = (o * 1e3 - s * 1e3) / 1e3;
      } else Sa(r[i]) && (a[i] = r[i]);
    for (const i in a)
      a[i] !== 0 && (n[l] += i === l ? a[i] : a[i] / this.matrix[l][i]);
    return Ef(this.matrix, n), ta(this, { values: n }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const t = {};
    for (const n of Object.keys(this.values))
      t[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return ta(this, { values: t }, !0);
  }
  /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */
  removeZeros() {
    if (!this.isValid) return this;
    const t = Mf(this.values);
    return ta(this, { values: t }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(t) {
    if (!this.isValid || !t.isValid || !this.loc.equals(t.loc))
      return !1;
    function n(a, r) {
      return a === void 0 || a === 0 ? r === void 0 || r === 0 : a === r;
    }
    for (const a of za)
      if (!n(this.values[a], t.values[a]))
        return !1;
    return !0;
  }
}
const xr = "Invalid Interval";
function rC(e, t) {
  return !e || !e.isValid ? _t.invalid("missing or invalid start") : !t || !t.isValid ? _t.invalid("missing or invalid end") : t < e ? _t.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${t.toISO()}`
  ) : null;
}
class _t {
  /**
   * @private
   */
  constructor(t) {
    this.s = t.start, this.e = t.end, this.invalid = t.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new Kt("need to specify a reason the Interval is invalid");
    const a = t instanceof Ln ? t : new Ln(t, n);
    if (Tt.throwOnInvalid)
      throw new A0(a);
    return new _t({ invalid: a });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(t, n) {
    const a = hl(t), r = hl(n), l = rC(a, r);
    return l ?? new _t({
      start: a,
      end: r
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(t, n) {
    const a = Ye.fromDurationLike(n), r = hl(t);
    return _t.fromDateTimes(r, r.plus(a));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(t, n) {
    const a = Ye.fromDurationLike(n), r = hl(t);
    return _t.fromDateTimes(r.minus(a), r);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(t, n) {
    const [a, r] = (t || "").split("/", 2);
    if (a && r) {
      let l, i;
      try {
        l = Me.fromISO(a, n), i = l.isValid;
      } catch {
        i = !1;
      }
      let o, s;
      try {
        o = Me.fromISO(r, n), s = o.isValid;
      } catch {
        s = !1;
      }
      if (i && s)
        return _t.fromDateTimes(l, o);
      if (i) {
        const u = Ye.fromISO(r, n);
        if (u.isValid)
          return _t.after(l, u);
      } else if (s) {
        const u = Ye.fromISO(a, n);
        if (u.isValid)
          return _t.before(o, u);
      }
    }
    return _t.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(t) {
    return t && t.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid && this.e ? this.e.minus(1) : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(t = "milliseconds") {
    return this.isValid ? this.toDuration(t).get(t) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(t = "milliseconds", n) {
    if (!this.isValid) return NaN;
    const a = this.start.startOf(t, n);
    let r;
    return n?.useLocaleWeeks ? r = this.end.reconfigure({ locale: a.locale }) : r = this.end, r = r.startOf(t, n), Math.floor(r.diff(a, t).get(t)) + (r.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(t) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, t) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(t) {
    return this.isValid ? this.s > t : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(t) {
    return this.isValid ? this.e <= t : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(t) {
    return this.isValid ? this.s <= t && this.e > t : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: t, end: n } = {}) {
    return this.isValid ? _t.fromDateTimes(t || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...t) {
    if (!this.isValid) return [];
    const n = t.map(hl).filter((i) => this.contains(i)).sort((i, o) => i.toMillis() - o.toMillis()), a = [];
    let { s: r } = this, l = 0;
    for (; r < this.e; ) {
      const i = n[l] || this.e, o = +i > +this.e ? this.e : i;
      a.push(_t.fromDateTimes(r, o)), r = o, l += 1;
    }
    return a;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(t) {
    const n = Ye.fromDurationLike(t);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: a } = this, r = 1, l;
    const i = [];
    for (; a < this.e; ) {
      const o = this.start.plus(n.mapUnits((s) => s * r));
      l = +o > +this.e ? this.e : o, i.push(_t.fromDateTimes(a, l)), a = l, r += 1;
    }
    return i;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(t) {
    return this.isValid ? this.splitBy(this.length() / t).slice(0, t) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(t) {
    return this.e > t.s && this.s < t.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(t) {
    return this.isValid ? +this.e == +t.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(t) {
    return this.isValid ? +t.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(t) {
    return this.isValid ? this.s <= t.s && this.e >= t.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(t) {
    return !this.isValid || !t.isValid ? !1 : this.s.equals(t.s) && this.e.equals(t.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(t) {
    if (!this.isValid) return this;
    const n = this.s > t.s ? this.s : t.s, a = this.e < t.e ? this.e : t.e;
    return n >= a ? null : _t.fromDateTimes(n, a);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(t) {
    if (!this.isValid) return this;
    const n = this.s < t.s ? this.s : t.s, a = this.e > t.e ? this.e : t.e;
    return _t.fromDateTimes(n, a);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(t) {
    const [n, a] = t.sort((r, l) => r.s - l.s).reduce(
      ([r, l], i) => l ? l.overlaps(i) || l.abutsStart(i) ? [r, l.union(i)] : [r.concat([l]), i] : [r, i],
      [[], null]
    );
    return a && n.push(a), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(t) {
    let n = null, a = 0;
    const r = [], l = t.map((s) => [
      { time: s.s, type: "s" },
      { time: s.e, type: "e" }
    ]), i = Array.prototype.concat(...l), o = i.sort((s, u) => s.time - u.time);
    for (const s of o)
      a += s.type === "s" ? 1 : -1, a === 1 ? n = s.time : (n && +n != +s.time && r.push(_t.fromDateTimes(n, s.time)), n = null);
    return _t.merge(r);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...t) {
    return _t.xor([this].concat(t)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : xr;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(t = eo, n = {}) {
    return this.isValid ? Jt.create(this.s.loc.clone(n), t).formatInterval(this) : xr;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(t) {
    return this.isValid ? `${this.s.toISO(t)}/${this.e.toISO(t)}` : xr;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : xr;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(t) {
    return this.isValid ? `${this.s.toISOTime(t)}/${this.e.toISOTime(t)}` : xr;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(t, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(t)}${n}${this.e.toFormat(t)}` : xr;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(t, n) {
    return this.isValid ? this.e.diff(this.s, t, n) : Ye.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(t) {
    return _t.fromDateTimes(t(this.s), t(this.e));
  }
}
class Ii {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(t = Tt.defaultZone) {
    const n = Me.now().setZone(t).set({ month: 12 });
    return !t.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(t) {
    return oa.isValidZone(t);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(t) {
    return ba(t, Tt.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || tt.create(t)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || tt.create(t)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: t = null, locObj: n = null } = {}) {
    return (n || tt.create(t)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(t = "long", { locale: n = null, numberingSystem: a = null, locObj: r = null, outputCalendar: l = "gregory" } = {}) {
    return (r || tt.create(n, a, l)).months(t);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(t = "long", { locale: n = null, numberingSystem: a = null, locObj: r = null, outputCalendar: l = "gregory" } = {}) {
    return (r || tt.create(n, a, l)).months(t, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(t = "long", { locale: n = null, numberingSystem: a = null, locObj: r = null } = {}) {
    return (r || tt.create(n, a, null)).weekdays(t);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(t = "long", { locale: n = null, numberingSystem: a = null, locObj: r = null } = {}) {
    return (r || tt.create(n, a, null)).weekdays(t, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: t = null } = {}) {
    return tt.create(t).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(t = "short", { locale: n = null } = {}) {
    return tt.create(n, null, "gregory").eras(t);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: bh(), localeWeek: ph() };
  }
}
function Of(e, t) {
  const n = (r) => r.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), a = n(t) - n(e);
  return Math.floor(Ye.fromMillis(a).as("days"));
}
function lC(e, t, n) {
  const a = [
    ["years", (s, u) => u.year - s.year],
    ["quarters", (s, u) => u.quarter - s.quarter + (u.year - s.year) * 4],
    ["months", (s, u) => u.month - s.month + (u.year - s.year) * 12],
    [
      "weeks",
      (s, u) => {
        const c = Of(s, u);
        return (c - c % 7) / 7;
      }
    ],
    ["days", Of]
  ], r = {}, l = e;
  let i, o;
  for (const [s, u] of a)
    n.indexOf(s) >= 0 && (i = s, r[s] = u(e, t), o = l.plus(r), o > t ? (r[s]--, e = l.plus(r), e > t && (o = e, r[s]--, e = l.plus(r))) : e = o);
  return [e, r, o, i];
}
function iC(e, t, n, a) {
  let [r, l, i, o] = lC(e, t, n);
  const s = t - r, u = n.filter(
    (d) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(d) >= 0
  );
  u.length === 0 && (i < t && (i = r.plus({ [o]: 1 })), i !== r && (l[o] = (l[o] || 0) + s / (i - r)));
  const c = Ye.fromObject(l, a);
  return u.length > 0 ? Ye.fromMillis(s, a).shiftTo(...u).plus(c) : c;
}
const oC = "missing Intl.DateTimeFormat.formatToParts support";
function et(e, t = (n) => n) {
  return { regex: e, deser: ([n]) => t(J0(n)) };
}
const sC = " ", Fh = `[ ${sC}]`, Rh = new RegExp(Fh, "g");
function uC(e) {
  return e.replace(/\./g, "\\.?").replace(Rh, Fh);
}
function Df(e) {
  return e.replace(/\./g, "").replace(Rh, " ").toLowerCase();
}
function On(e, t) {
  return e === null ? null : {
    regex: RegExp(e.map(uC).join("|")),
    deser: ([n]) => e.findIndex((a) => Df(n) === Df(a)) + t
  };
}
function Lf(e, t) {
  return { regex: e, deser: ([, n, a]) => Mo(n, a), groups: t };
}
function Ai(e) {
  return { regex: e, deser: ([t]) => t };
}
function cC(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function dC(e, t) {
  const n = Mn(t), a = Mn(t, "{2}"), r = Mn(t, "{3}"), l = Mn(t, "{4}"), i = Mn(t, "{6}"), o = Mn(t, "{1,2}"), s = Mn(t, "{1,3}"), u = Mn(t, "{1,6}"), c = Mn(t, "{1,9}"), d = Mn(t, "{2,4}"), f = Mn(t, "{4,6}"), v = (h) => ({ regex: RegExp(cC(h.val)), deser: ([w]) => w, literal: !0 }), m = ((h) => {
    if (e.literal)
      return v(h);
    switch (h.val) {
      // era
      case "G":
        return On(t.eras("short"), 0);
      case "GG":
        return On(t.eras("long"), 0);
      // years
      case "y":
        return et(u);
      case "yy":
        return et(d, nu);
      case "yyyy":
        return et(l);
      case "yyyyy":
        return et(f);
      case "yyyyyy":
        return et(i);
      // months
      case "M":
        return et(o);
      case "MM":
        return et(a);
      case "MMM":
        return On(t.months("short", !0), 1);
      case "MMMM":
        return On(t.months("long", !0), 1);
      case "L":
        return et(o);
      case "LL":
        return et(a);
      case "LLL":
        return On(t.months("short", !1), 1);
      case "LLLL":
        return On(t.months("long", !1), 1);
      // dates
      case "d":
        return et(o);
      case "dd":
        return et(a);
      // ordinals
      case "o":
        return et(s);
      case "ooo":
        return et(r);
      // time
      case "HH":
        return et(a);
      case "H":
        return et(o);
      case "hh":
        return et(a);
      case "h":
        return et(o);
      case "mm":
        return et(a);
      case "m":
        return et(o);
      case "q":
        return et(o);
      case "qq":
        return et(a);
      case "s":
        return et(o);
      case "ss":
        return et(a);
      case "S":
        return et(s);
      case "SSS":
        return et(r);
      case "u":
        return Ai(c);
      case "uu":
        return Ai(o);
      case "uuu":
        return et(n);
      // meridiem
      case "a":
        return On(t.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return et(l);
      case "kk":
        return et(d, nu);
      // weekNumber (W)
      case "W":
        return et(o);
      case "WW":
        return et(a);
      // weekdays
      case "E":
      case "c":
        return et(n);
      case "EEE":
        return On(t.weekdays("short", !1), 1);
      case "EEEE":
        return On(t.weekdays("long", !1), 1);
      case "ccc":
        return On(t.weekdays("short", !0), 1);
      case "cccc":
        return On(t.weekdays("long", !0), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return Lf(new RegExp(`([+-]${o.source})(?::(${a.source}))?`), 2);
      case "ZZZ":
        return Lf(new RegExp(`([+-]${o.source})(${a.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return Ai(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return Ai(/[^\S\n\r]/);
      default:
        return v(h);
    }
  })(e) || {
    invalidReason: oC
  };
  return m.token = e, m;
}
const fC = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function vC(e, t, n) {
  const { type: a, value: r } = e;
  if (a === "literal") {
    const s = /^\s+$/.test(r);
    return {
      literal: !s,
      val: s ? " " : r
    };
  }
  const l = t[a];
  let i = a;
  a === "hour" && (t.hour12 != null ? i = t.hour12 ? "hour12" : "hour24" : t.hourCycle != null ? t.hourCycle === "h11" || t.hourCycle === "h12" ? i = "hour12" : i = "hour24" : i = n.hour12 ? "hour12" : "hour24");
  let o = fC[i];
  if (typeof o == "object" && (o = o[l]), o)
    return {
      literal: !1,
      val: o
    };
}
function mC(e) {
  return [`^${e.map((n) => n.regex).reduce((n, a) => `${n}(${a.source})`, "")}$`, e];
}
function hC(e, t, n) {
  const a = e.match(t);
  if (a) {
    const r = {};
    let l = 1;
    for (const i in n)
      if (Ur(n, i)) {
        const o = n[i], s = o.groups ? o.groups + 1 : 1;
        !o.literal && o.token && (r[o.token.val[0]] = o.deser(a.slice(l, l + s))), l += s;
      }
    return [a, r];
  } else
    return [a, {}];
}
function gC(e) {
  const t = (l) => {
    switch (l) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, a;
  return Oe(e.z) || (n = oa.create(e.z)), Oe(e.Z) || (n || (n = new nn(e.Z)), a = e.Z), Oe(e.q) || (e.M = (e.q - 1) * 3 + 1), Oe(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), Oe(e.u) || (e.S = vc(e.u)), [Object.keys(e).reduce((l, i) => {
    const o = t(i);
    return o && (l[o] = e[i]), l;
  }, {}), n, a];
}
let ws = null;
function yC() {
  return ws || (ws = Me.fromMillis(1555555555555)), ws;
}
function bC(e, t) {
  if (e.literal)
    return e;
  const n = Jt.macroTokenToFormatOpts(e.val), a = Wh(n, t);
  return a == null || a.includes(void 0) ? e : a;
}
function $h(e, t) {
  return Array.prototype.concat(...e.map((n) => bC(n, t)));
}
class Bh {
  constructor(t, n) {
    if (this.locale = t, this.format = n, this.tokens = $h(Jt.parseFormat(n), t), this.units = this.tokens.map((a) => dC(a, t)), this.disqualifyingUnit = this.units.find((a) => a.invalidReason), !this.disqualifyingUnit) {
      const [a, r] = mC(this.units);
      this.regex = RegExp(a, "i"), this.handlers = r;
    }
  }
  explainFromTokens(t) {
    if (this.isValid) {
      const [n, a] = hC(t, this.regex, this.handlers), [r, l, i] = a ? gC(a) : [null, null, void 0];
      if (Ur(a, "a") && Ur(a, "H"))
        throw new Er(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: t,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: n,
        matches: a,
        result: r,
        zone: l,
        specificOffset: i
      };
    } else
      return { input: t, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function Uh(e, t, n) {
  return new Bh(e, n).explainFromTokens(t);
}
function pC(e, t, n) {
  const { result: a, zone: r, specificOffset: l, invalidReason: i } = Uh(e, t, n);
  return [a, r, l, i];
}
function Wh(e, t) {
  if (!e)
    return null;
  const a = Jt.create(t, e).dtFormatter(yC()), r = a.formatToParts(), l = a.resolvedOptions();
  return r.map((i) => vC(i, e, l));
}
const ks = "Invalid DateTime", Nf = 864e13;
function pl(e) {
  return new Ln("unsupported zone", `the zone "${e.name}" is not supported`);
}
function Ss(e) {
  return e.weekData === null && (e.weekData = to(e.c)), e.weekData;
}
function xs(e) {
  return e.localWeekData === null && (e.localWeekData = to(
    e.c,
    e.loc.getMinDaysInFirstWeek(),
    e.loc.getStartOfWeek()
  )), e.localWeekData;
}
function $a(e, t) {
  const n = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new Me({ ...n, ...t, old: n });
}
function Hh(e, t, n) {
  let a = e - t * 60 * 1e3;
  const r = n.offset(a);
  if (t === r)
    return [a, t];
  a -= (r - t) * 60 * 1e3;
  const l = n.offset(a);
  return r === l ? [a, r] : [e - Math.min(r, l) * 60 * 1e3, Math.max(r, l)];
}
function Pi(e, t) {
  e += t * 60 * 1e3;
  const n = new Date(e);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function Ui(e, t, n) {
  return Hh(Eo(e), t, n);
}
function Ff(e, t) {
  const n = e.o, a = e.c.year + Math.trunc(t.years), r = e.c.month + Math.trunc(t.months) + Math.trunc(t.quarters) * 3, l = {
    ...e.c,
    year: a,
    month: r,
    day: Math.min(e.c.day, no(a, r)) + Math.trunc(t.days) + Math.trunc(t.weeks) * 7
  }, i = Ye.fromObject({
    years: t.years - Math.trunc(t.years),
    quarters: t.quarters - Math.trunc(t.quarters),
    months: t.months - Math.trunc(t.months),
    weeks: t.weeks - Math.trunc(t.weeks),
    days: t.days - Math.trunc(t.days),
    hours: t.hours,
    minutes: t.minutes,
    seconds: t.seconds,
    milliseconds: t.milliseconds
  }).as("milliseconds"), o = Eo(l);
  let [s, u] = Hh(o, n, e.zone);
  return i !== 0 && (s += i, u = e.zone.offset(s)), { ts: s, o: u };
}
function Cr(e, t, n, a, r, l) {
  const { setZone: i, zone: o } = n;
  if (e && Object.keys(e).length !== 0 || t) {
    const s = t || o, u = Me.fromObject(e, {
      ...n,
      zone: s,
      specificOffset: l
    });
    return i ? u : u.setZone(o);
  } else
    return Me.invalid(
      new Ln("unparsable", `the input "${r}" can't be parsed as ${a}`)
    );
}
function Vi(e, t, n = !0) {
  return e.isValid ? Jt.create(tt.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(e, t) : null;
}
function Cs(e, t, n) {
  const a = e.c.year > 9999 || e.c.year < 0;
  let r = "";
  if (a && e.c.year >= 0 && (r += "+"), r += Dt(e.c.year, a ? 6 : 4), n === "year") return r;
  if (t) {
    if (r += "-", r += Dt(e.c.month), n === "month") return r;
    r += "-";
  } else if (r += Dt(e.c.month), n === "month") return r;
  return r += Dt(e.c.day), r;
}
function Rf(e, t, n, a, r, l, i) {
  let o = !n || e.c.millisecond !== 0 || e.c.second !== 0, s = "";
  switch (i) {
    case "day":
    case "month":
    case "year":
      break;
    default:
      if (s += Dt(e.c.hour), i === "hour") break;
      if (t) {
        if (s += ":", s += Dt(e.c.minute), i === "minute") break;
        o && (s += ":", s += Dt(e.c.second));
      } else {
        if (s += Dt(e.c.minute), i === "minute") break;
        o && (s += Dt(e.c.second));
      }
      if (i === "second") break;
      o && (!a || e.c.millisecond !== 0) && (s += ".", s += Dt(e.c.millisecond, 3));
  }
  return r && (e.isOffsetFixed && e.offset === 0 && !l ? s += "Z" : e.o < 0 ? (s += "-", s += Dt(Math.trunc(-e.o / 60)), s += ":", s += Dt(Math.trunc(-e.o % 60))) : (s += "+", s += Dt(Math.trunc(e.o / 60)), s += ":", s += Dt(Math.trunc(e.o % 60)))), l && (s += "[" + e.zone.ianaName + "]"), s;
}
const zh = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, wC = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, kC = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Wi = ["year", "month", "day", "hour", "minute", "second", "millisecond"], SC = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], xC = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function Hi(e) {
  const t = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!t) throw new zm(e);
  return t;
}
function $f(e) {
  switch (e.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return Hi(e);
  }
}
function CC(e) {
  if (wl === void 0 && (wl = Tt.now()), e.type !== "iana")
    return e.offset(wl);
  const t = e.name;
  let n = au.get(t);
  return n === void 0 && (n = e.offset(wl), au.set(t, n)), n;
}
function Bf(e, t) {
  const n = ba(t.zone, Tt.defaultZone);
  if (!n.isValid)
    return Me.invalid(pl(n));
  const a = tt.fromObject(t);
  let r, l;
  if (Oe(e.year))
    r = Tt.now();
  else {
    for (const s of Wi)
      Oe(e[s]) && (e[s] = zh[s]);
    const i = gh(e) || yh(e);
    if (i)
      return Me.invalid(i);
    const o = CC(n);
    [r, l] = Ui(e, o, n);
  }
  return new Me({ ts: r, zone: n, loc: a, o: l });
}
function Uf(e, t, n) {
  const a = Oe(n.round) ? !0 : n.round, r = Oe(n.rounding) ? "trunc" : n.rounding, l = (o, s) => (o = mc(o, a || n.calendary ? 0 : 2, n.calendary ? "round" : r), t.loc.clone(n).relFormatter(n).format(o, s)), i = (o) => n.calendary ? t.hasSame(e, o) ? 0 : t.startOf(o).diff(e.startOf(o), o).get(o) : t.diff(e, o).get(o);
  if (n.unit)
    return l(i(n.unit), n.unit);
  for (const o of n.units) {
    const s = i(o);
    if (Math.abs(s) >= 1)
      return l(s, o);
  }
  return l(e > t ? -0 : 0, n.units[n.units.length - 1]);
}
function Wf(e) {
  let t = {}, n;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (t = e[e.length - 1], n = Array.from(e).slice(0, e.length - 1)) : n = Array.from(e), [t, n];
}
let wl;
const au = /* @__PURE__ */ new Map();
class Me {
  /**
   * @access private
   */
  constructor(t) {
    const n = t.zone || Tt.defaultZone;
    let a = t.invalid || (Number.isNaN(t.ts) ? new Ln("invalid input") : null) || (n.isValid ? null : pl(n));
    this.ts = Oe(t.ts) ? Tt.now() : t.ts;
    let r = null, l = null;
    if (!a)
      if (t.old && t.old.ts === this.ts && t.old.zone.equals(n))
        [r, l] = [t.old.c, t.old.o];
      else {
        const o = Sa(t.o) && !t.old ? t.o : n.offset(this.ts);
        r = Pi(this.ts, o), a = Number.isNaN(r.year) ? new Ln("invalid input") : null, r = a ? null : r, l = a ? null : o;
      }
    this._zone = n, this.loc = t.loc || tt.create(), this.invalid = a, this.weekData = null, this.localWeekData = null, this.c = r, this.o = l, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new Me({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [t, n] = Wf(arguments), [a, r, l, i, o, s, u] = n;
    return Bf({ year: a, month: r, day: l, hour: i, minute: o, second: s, millisecond: u }, t);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [t, n] = Wf(arguments), [a, r, l, i, o, s, u] = n;
    return t.zone = nn.utcInstance, Bf({ year: a, month: r, day: l, hour: i, minute: o, second: s, millisecond: u }, t);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(t, n = {}) {
    const a = nx(t) ? t.valueOf() : NaN;
    if (Number.isNaN(a))
      return Me.invalid("invalid input");
    const r = ba(n.zone, Tt.defaultZone);
    return r.isValid ? new Me({
      ts: a,
      zone: r,
      loc: tt.fromObject(n)
    }) : Me.invalid(pl(r));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(t, n = {}) {
    if (Sa(t))
      return t < -Nf || t > Nf ? Me.invalid("Timestamp out of range") : new Me({
        ts: t,
        zone: ba(n.zone, Tt.defaultZone),
        loc: tt.fromObject(n)
      });
    throw new Kt(
      `fromMillis requires a numerical input, but received a ${typeof t} with value ${t}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(t, n = {}) {
    if (Sa(t))
      return new Me({
        ts: t * 1e3,
        zone: ba(n.zone, Tt.defaultZone),
        loc: tt.fromObject(n)
      });
    throw new Kt("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(t, n = {}) {
    t = t || {};
    const a = ba(n.zone, Tt.defaultZone);
    if (!a.isValid)
      return Me.invalid(pl(a));
    const r = tt.fromObject(n), l = ao(t, $f), { minDaysInFirstWeek: i, startOfWeek: o } = _f(l, r), s = Tt.now(), u = Oe(n.specificOffset) ? a.offset(s) : n.specificOffset, c = !Oe(l.ordinal), d = !Oe(l.year), f = !Oe(l.month) || !Oe(l.day), v = d || f, g = l.weekYear || l.weekNumber;
    if ((v || c) && g)
      throw new Er(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (f && c)
      throw new Er("Can't mix ordinal dates with month/day");
    const m = g || l.weekday && !v;
    let h, w, _ = Pi(s, u);
    m ? (h = SC, w = wC, _ = to(_, i, o)) : c ? (h = xC, w = kC, _ = ps(_)) : (h = Wi, w = zh);
    let I = !1;
    for (const A of h) {
      const M = l[A];
      Oe(M) ? I ? l[A] = w[A] : l[A] = _[A] : I = !0;
    }
    const C = m ? Q0(l, i, o) : c ? ex(l) : gh(l), b = C || yh(l);
    if (b)
      return Me.invalid(b);
    const p = m ? xf(l, i, o) : c ? Cf(l) : l, [x, k] = Ui(p, u, a), V = new Me({
      ts: x,
      zone: a,
      o: k,
      loc: r
    });
    return l.weekday && v && t.weekday !== V.weekday ? Me.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${l.weekday} and a date of ${V.toISO()}`
    ) : V.isValid ? V : Me.invalid(V.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(t, n = {}) {
    const [a, r] = jx(t);
    return Cr(a, r, n, "ISO 8601", t);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(t, n = {}) {
    const [a, r] = Gx(t);
    return Cr(a, r, n, "RFC 2822", t);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(t, n = {}) {
    const [a, r] = qx(t);
    return Cr(a, r, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(t, n, a = {}) {
    if (Oe(t) || Oe(n))
      throw new Kt("fromFormat requires an input string and a format");
    const { locale: r = null, numberingSystem: l = null } = a, i = tt.fromOpts({
      locale: r,
      numberingSystem: l,
      defaultToEN: !0
    }), [o, s, u, c] = pC(i, t, n);
    return c ? Me.invalid(c) : Cr(o, s, a, `format ${n}`, t, u);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(t, n, a = {}) {
    return Me.fromFormat(t, n, a);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(t, n = {}) {
    const [a, r] = eC(t);
    return Cr(a, r, n, "SQL", t);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new Kt("need to specify a reason the DateTime is invalid");
    const a = t instanceof Ln ? t : new Ln(t, n);
    if (Tt.throwOnInvalid)
      throw new I0(a);
    return new Me({ invalid: a });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(t) {
    return t && t.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(t, n = {}) {
    const a = Wh(t, tt.fromObject(n));
    return a ? a.map((r) => r ? r.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(t, n = {}) {
    return $h(Jt.parseFormat(t), tt.fromObject(n)).map((r) => r.val).join("");
  }
  static resetCache() {
    wl = void 0, au.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(t) {
    return this[t];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? Ss(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? Ss(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? Ss(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? xs(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? xs(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? xs(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? ps(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Ii.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Ii.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Ii.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Ii.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const t = 864e5, n = 6e4, a = Eo(this.c), r = this.zone.offset(a - t), l = this.zone.offset(a + t), i = this.zone.offset(a - r * n), o = this.zone.offset(a - l * n);
    if (i === o)
      return [this];
    const s = a - i * n, u = a - o * n, c = Pi(s, i), d = Pi(u, o);
    return c.hour === d.hour && c.minute === d.minute && c.second === d.second && c.millisecond === d.millisecond ? [$a(this, { ts: s }), $a(this, { ts: u })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Ql(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return no(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? Lr(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? El(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? El(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(t = {}) {
    const { locale: n, numberingSystem: a, calendar: r } = Jt.create(
      this.loc.clone(t),
      t
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: a, outputCalendar: r };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(t = 0, n = {}) {
    return this.setZone(nn.instance(t), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Tt.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(t, { keepLocalTime: n = !1, keepCalendarTime: a = !1 } = {}) {
    if (t = ba(t, Tt.defaultZone), t.equals(this.zone))
      return this;
    if (t.isValid) {
      let r = this.ts;
      if (n || a) {
        const l = t.offset(this.ts), i = this.toObject();
        [r] = Ui(i, l, t);
      }
      return $a(this, { ts: r, zone: t });
    } else
      return Me.invalid(pl(t));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: t, numberingSystem: n, outputCalendar: a } = {}) {
    const r = this.loc.clone({ locale: t, numberingSystem: n, outputCalendar: a });
    return $a(this, { loc: r });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(t) {
    return this.reconfigure({ locale: t });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(t) {
    if (!this.isValid) return this;
    const n = ao(t, $f), { minDaysInFirstWeek: a, startOfWeek: r } = _f(n, this.loc), l = !Oe(n.weekYear) || !Oe(n.weekNumber) || !Oe(n.weekday), i = !Oe(n.ordinal), o = !Oe(n.year), s = !Oe(n.month) || !Oe(n.day), u = o || s, c = n.weekYear || n.weekNumber;
    if ((u || i) && c)
      throw new Er(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (s && i)
      throw new Er("Can't mix ordinal dates with month/day");
    let d;
    l ? d = xf(
      { ...to(this.c, a, r), ...n },
      a,
      r
    ) : Oe(n.ordinal) ? (d = { ...this.toObject(), ...n }, Oe(n.day) && (d.day = Math.min(no(d.year, d.month), d.day))) : d = Cf({ ...ps(this.c), ...n });
    const [f, v] = Ui(d, this.o, this.zone);
    return $a(this, { ts: f, o: v });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(t) {
    if (!this.isValid) return this;
    const n = Ye.fromDurationLike(t);
    return $a(this, Ff(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(t) {
    if (!this.isValid) return this;
    const n = Ye.fromDurationLike(t).negate();
    return $a(this, Ff(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(t, { useLocaleWeeks: n = !1 } = {}) {
    if (!this.isValid) return this;
    const a = {}, r = Ye.normalizeUnit(t);
    switch (r) {
      case "years":
        a.month = 1;
      // falls through
      case "quarters":
      case "months":
        a.day = 1;
      // falls through
      case "weeks":
      case "days":
        a.hour = 0;
      // falls through
      case "hours":
        a.minute = 0;
      // falls through
      case "minutes":
        a.second = 0;
      // falls through
      case "seconds":
        a.millisecond = 0;
        break;
    }
    if (r === "weeks")
      if (n) {
        const l = this.loc.getStartOfWeek(), { weekday: i } = this;
        i < l && (a.weekNumber = this.weekNumber - 1), a.weekday = l;
      } else
        a.weekday = 1;
    if (r === "quarters") {
      const l = Math.ceil(this.month / 3);
      a.month = (l - 1) * 3 + 1;
    }
    return this.set(a);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(t, n) {
    return this.isValid ? this.plus({ [t]: 1 }).startOf(t, n).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(t, n = {}) {
    return this.isValid ? Jt.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, t) : ks;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(t = eo, n = {}) {
    return this.isValid ? Jt.create(this.loc.clone(n), t).formatDateTime(this) : ks;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(t = {}) {
    return this.isValid ? Jt.create(this.loc.clone(t), t).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */
  toISO({
    format: t = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: a = !1,
    includeOffset: r = !0,
    extendedZone: l = !1,
    precision: i = "milliseconds"
  } = {}) {
    if (!this.isValid)
      return null;
    i = Hi(i);
    const o = t === "extended";
    let s = Cs(this, o, i);
    return Wi.indexOf(i) >= 3 && (s += "T"), s += Rf(
      this,
      o,
      n,
      a,
      r,
      l,
      i
    ), s;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */
  toISODate({ format: t = "extended", precision: n = "day" } = {}) {
    return this.isValid ? Cs(this, t === "extended", Hi(n)) : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return Vi(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: t = !1,
    suppressSeconds: n = !1,
    includeOffset: a = !0,
    includePrefix: r = !1,
    extendedZone: l = !1,
    format: i = "extended",
    precision: o = "milliseconds"
  } = {}) {
    return this.isValid ? (o = Hi(o), (r && Wi.indexOf(o) >= 3 ? "T" : "") + Rf(
      this,
      i === "extended",
      n,
      t,
      a,
      l,
      o
    )) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return Vi(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return Vi(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    return this.isValid ? Cs(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: t = !0, includeZone: n = !1, includeOffsetSpace: a = !0 } = {}) {
    let r = "HH:mm:ss.SSS";
    return (n || t) && (a && (r += " "), n ? r += "z" : t && (r += "ZZ")), Vi(this, r, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(t = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(t)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : ks;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(t = {}) {
    if (!this.isValid) return {};
    const n = { ...this.c };
    return t.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(t, n = "milliseconds", a = {}) {
    if (!this.isValid || !t.isValid)
      return Ye.invalid("created by diffing an invalid DateTime");
    const r = { locale: this.locale, numberingSystem: this.numberingSystem, ...a }, l = ax(n).map(Ye.normalizeUnit), i = t.valueOf() > this.valueOf(), o = i ? this : t, s = i ? t : this, u = iC(o, s, l, r);
    return i ? u.negate() : u;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(t = "milliseconds", n = {}) {
    return this.diff(Me.now(), t, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(t) {
    return this.isValid ? _t.fromDateTimes(this, t) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(t, n, a) {
    if (!this.isValid) return !1;
    const r = t.valueOf(), l = this.setZone(t.zone, { keepLocalTime: !0 });
    return l.startOf(n, a) <= r && r <= l.endOf(n, a);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(t) {
    return this.isValid && t.isValid && this.valueOf() === t.valueOf() && this.zone.equals(t.zone) && this.loc.equals(t.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(t = {}) {
    if (!this.isValid) return null;
    const n = t.base || Me.fromObject({}, { zone: this.zone }), a = t.padding ? this < n ? -t.padding : t.padding : 0;
    let r = ["years", "months", "days", "hours", "minutes", "seconds"], l = t.unit;
    return Array.isArray(t.unit) && (r = t.unit, l = void 0), Uf(n, this.plus(a), {
      ...t,
      numeric: "always",
      units: r,
      unit: l
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(t = {}) {
    return this.isValid ? Uf(t.base || Me.fromObject({}, { zone: this.zone }), this, {
      ...t,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...t) {
    if (!t.every(Me.isDateTime))
      throw new Kt("min requires all arguments be DateTimes");
    return Tf(t, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...t) {
    if (!t.every(Me.isDateTime))
      throw new Kt("max requires all arguments be DateTimes");
    return Tf(t, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(t, n, a = {}) {
    const { locale: r = null, numberingSystem: l = null } = a, i = tt.fromOpts({
      locale: r,
      numberingSystem: l,
      defaultToEN: !0
    });
    return Uh(i, t, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(t, n, a = {}) {
    return Me.fromFormatExplain(t, n, a);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(t, n = {}) {
    const { locale: a = null, numberingSystem: r = null } = n, l = tt.fromOpts({
      locale: a,
      numberingSystem: r,
      defaultToEN: !0
    });
    return new Bh(l, t);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(t, n, a = {}) {
    if (Oe(t) || Oe(n))
      throw new Kt(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: r = null, numberingSystem: l = null } = a, i = tt.fromOpts({
      locale: r,
      numberingSystem: l,
      defaultToEN: !0
    });
    if (!i.equals(n.locale))
      throw new Kt(
        `fromFormatParser called with a locale of ${i}, but the format parser was created for ${n.locale}`
      );
    const { result: o, zone: s, specificOffset: u, invalidReason: c } = n.explainFromTokens(t);
    return c ? Me.invalid(c) : Cr(
      o,
      s,
      a,
      `format ${n.format}`,
      t,
      u
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return eo;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return jm;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return V0;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return Gm;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return qm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return Ym;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return Km;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return Zm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return Jm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return Xm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return Qm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return eh;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return th;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return nh;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return ah;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return rh;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return lh;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return E0;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return ih;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return oh;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return sh;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return uh;
  }
}
function hl(e) {
  if (Me.isDateTime(e))
    return e;
  if (e && e.valueOf && Sa(e.valueOf()))
    return Me.fromJSDate(e);
  if (e && typeof e == "object")
    return Me.fromObject(e);
  throw new Kt(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
const Ze = Vt.create({
  baseURL: void 0,
  headers: {
    "Content-type": "application/json"
  }
});
Ze.interceptors.request.use(
  (e) => {
    const t = (a) => {
      for (const r in a)
        a.hasOwnProperty(r) && (Me.isDateTime(a[r]) ? a[r] = a[r].toUTC().toISO() : a[r] instanceof Date && (a[r] = Me.fromJSDate(a[r]).toUTC().toISO()));
    }, n = (a) => {
      for (const r in a)
        a.hasOwnProperty(r) && (r === "initialState" || r === "isEditingMode" ? a[r] = void 0 : a[r] instanceof Je && n(a[r]));
    };
    return e.data instanceof Je && (e.data = e.data.clone(), n(e.data)), t(e.data), e;
  },
  (e) => Promise.reject(e)
);
Ze.interceptors.response.use(
  (e) => e,
  async (e) => Promise.reject(e)
);
var _C = Object.defineProperty, jh = (e, t, n, a) => {
  for (var r = void 0, l = e.length - 1, i; l >= 0; l--)
    (i = e[l]) && (r = i(t, n, r) || r);
  return r && _C(t, n, r), r;
};
class wa extends Je {
  id;
  title;
}
jh([
  Qr()
], wa.prototype, "id");
jh([
  wo(),
  zw(255)
], wa.prototype, "title");
class TC extends xo {
  backendURL;
  constructor(t, n, a) {
    super(t, n), this.backendURL = a;
  }
  async getTales() {
    const t = await this.getAuthHeaders(), n = await Ze.get(`${this.backendURL}/tale`, { headers: t });
    return Je.fromPaginatedJson(n.data, wa);
  }
  async getTale(t) {
    const n = await this.getAuthHeaders(), a = await Ze.get(`${this.backendURL}/tale/${t}`, { headers: n });
    return Je.fromJson(a.data, wa);
  }
  async createTale(t) {
    const n = await this.getAuthHeaders(), a = await Ze.post(`${this.backendURL}/tale`, t, { headers: n });
    return Je.fromJson(a.data, wa);
  }
  async updateTale(t, n) {
    const a = await this.getAuthHeaders(), r = await Ze.put(`${this.backendURL}/tale/${t}`, n, {
      headers: a
    });
    return Je.fromJson(r.data, wa);
  }
  async deleteTale(t) {
    const n = await this.getAuthHeaders();
    await Ze.delete(`${this.backendURL}/tale/${t}`, { headers: n });
  }
}
class IC extends xo {
  backendURL;
  constructor(t, n, a) {
    super(t, n), this.backendURL = a;
  }
  async getTeams(t, n, a) {
    const r = await this.getAuthHeaders(), l = { page: t, pageSize: n }, i = a?.id ? `${this.backendURL}/workspace/${a.id}/team` : `${this.backendURL}/team`, o = await Ze.get(i, { headers: r, params: l });
    return Je.fromPaginatedJson(o.data, pa);
  }
  async getTeam(t) {
    const n = await this.getAuthHeaders(), a = await Ze.get(`${this.backendURL}/team/${t}`, { headers: n });
    return Je.fromJson(a.data, pa);
  }
  async createTeam(t) {
    const n = await this.getAuthHeaders(), a = await Ze.post(`${this.backendURL}/team`, t, { headers: n });
    return Je.fromJson(a.data, pa);
  }
  async updateTeam(t, n) {
    const a = await this.getAuthHeaders(), r = await Ze.put(`${this.backendURL}/team/${t}`, n, {
      headers: a
    });
    return Je.fromJson(r.data, pa);
  }
  async deleteTeam(t) {
    const n = await this.getAuthHeaders();
    await Ze.delete(`${this.backendURL}/team/${t}`, { headers: n });
  }
  async addTeamToWorkspace(t, n) {
    const a = await this.getAuthHeaders();
    await Ze.post(`${this.backendURL}/workspace/${n.id}/team`, t, {
      headers: a
    });
  }
  async removeTeamFromWorkspace(t, n) {
    const a = await this.getAuthHeaders();
    await Ze.delete(`${this.backendURL}/workspace/${n.id}/team/${t.id}`, {
      headers: a
    });
  }
  async getTeamMembers(t, n, a) {
    const r = await this.getAuthHeaders(), l = { page: n, pageSize: a }, i = await Ze.get(`${this.backendURL}/team/${t}/member`, {
      headers: r,
      params: l
    });
    return Je.fromPaginatedJson(i.data, Ga);
  }
  async addTeamMember(t, n) {
    const a = await this.getAuthHeaders(), r = await Ze.post(
      `${this.backendURL}/team/${t}/member`,
      n,
      {
        headers: a
      }
    );
    return Je.fromJson(r.data, Ga);
  }
  async updateTeamMember(t, n, a) {
    const r = await this.getAuthHeaders(), l = await Ze.put(
      `${this.backendURL}/team/${t}/member/${n}`,
      a,
      { headers: r }
    );
    return Je.fromJson(l.data, Ga);
  }
  async removeTeamMember(t, n) {
    const a = await this.getAuthHeaders();
    await Ze.delete(`${this.backendURL}/team/${t}/member/${n}`, { headers: a });
  }
}
var AC = Object.defineProperty, Gh = (e, t, n, a) => {
  for (var r = void 0, l = e.length - 1, i; l >= 0; l--)
    (i = e[l]) && (r = i(t, n, r) || r);
  return r && AC(t, n, r), r;
};
class bc extends Je {
  team;
  workspace;
}
Gh([
  Da()
], bc.prototype, "team");
Gh([
  Da()
], bc.prototype, "workspace");
var PC = Object.defineProperty, pc = (e, t, n, a) => {
  for (var r = void 0, l = e.length - 1, i; l >= 0; l--)
    (i = e[l]) && (r = i(t, n, r) || r);
  return r && PC(t, n, r), r;
};
class Wr extends Je {
  id;
  username;
  emailAddress;
}
pc([
  Qr()
], Wr.prototype, "id");
pc([
  Da(),
  wo()
], Wr.prototype, "username");
pc([
  Da(),
  ec()
], Wr.prototype, "emailAddress");
class VC extends xo {
  backendURL;
  constructor(t, n, a) {
    super(t, n), this.backendURL = a;
  }
  async getCurrentUser() {
    const t = await this.getAuthHeaders(!0), n = await Ze.get(`${this.backendURL}/user/me`, { headers: t });
    return Je.fromJson(n.data, Wr);
  }
  async getLastSelection() {
    const t = await this.getAuthHeaders(!0), n = await Ze.get(`${this.backendURL}/user/me/last-selection`, {
      headers: t
    });
    return Je.fromJson(n.data, bc);
  }
  async updateLastSelection(t, n) {
    const a = await this.getAuthHeaders(!0);
    await Ze.post(
      `${this.backendURL}/user/me/last-selection`,
      { team: t, workspace: n },
      { headers: a }
    );
  }
  // The bearer token contains the authenticated user token. If the user is being upgraded from an
  // anonymous account, the anonymous JWT is forwarded in the request body so the backend can merge
  // the two identities.
  async createUser(t) {
    const n = await this.getAuthHeaders(!0), a = t ? { anonymousToken: t } : void 0, r = await Ze.post(`${this.backendURL}/user/me`, a, { headers: n });
    return Je.fromJson(r.data, Wr);
  }
  async createAnonymousUserToken() {
    return (await Ze.post(`${this.backendURL}/user/anonymous`)).data;
  }
}
class EC extends xo {
  backendURL;
  constructor(t, n, a) {
    super(t, n), this.backendURL = a;
  }
  async getWorkspaces(t, n) {
    const a = await this.getAuthHeaders(), r = { page: t, pageSize: n }, l = await Ze.get(`${this.backendURL}/workspace`, { headers: a, params: r });
    return Je.fromPaginatedJson(l.data, Wa);
  }
  async getWorkspace(t) {
    const n = await this.getAuthHeaders(), a = await Ze.get(`${this.backendURL}/workspace/${t}`, {
      headers: n
    });
    return Je.fromJson(a.data, Wa);
  }
  async createWorkspace(t) {
    const n = await this.getAuthHeaders(), a = await Ze.post(`${this.backendURL}/workspace`, t, {
      headers: n
    });
    return Je.fromJson(a.data, Wa);
  }
  async updateWorkspace(t, n) {
    const a = await this.getAuthHeaders(), r = await Ze.put(
      `${this.backendURL}/workspace/${t}`,
      n,
      { headers: a }
    );
    return Je.fromJson(r.data, Wa);
  }
  async deleteWorkspace(t) {
    const n = await this.getAuthHeaders();
    await Ze.delete(`${this.backendURL}/workspace/${t}`, { headers: n });
  }
  async getWorkspaceMembers(t, n, a) {
    const r = await this.getAuthHeaders(), l = { page: n, pageSize: a }, i = await Ze.get(`${this.backendURL}/workspace/${t}/member`, {
      headers: r,
      params: l
    });
    return Je.fromPaginatedJson(i.data, Cl);
  }
  async addWorkspaceMember(t, n) {
    const a = await this.getAuthHeaders(), r = await Ze.post(
      `${this.backendURL}/workspace/${t}/member`,
      n,
      {
        headers: a
      }
    );
    return Je.fromJson(r.data, Cl);
  }
  async removeWorkspaceMember(t, n) {
    const a = await this.getAuthHeaders();
    await Ze.delete(`${this.backendURL}/workspace/${t}/member/${n}`, {
      headers: a
    });
  }
  async updateWorkspaceMember(t, n, a) {
    const r = await this.getAuthHeaders(), l = await Ze.put(
      `${this.backendURL}/workspace/${t}/member/${n}`,
      a,
      { headers: r }
    );
    return Je.fromJson(l.data, Cl);
  }
}
const MC = ir("serviceStore", {
  state: () => ({}),
  getters: {
    authService() {
      return vl.getService(
        "authService",
        Kk,
        mk,
        hk,
        gk,
        vk
      );
    },
    userService() {
      return vl.getService(
        "userService",
        VC,
        this,
        this.authService,
        Ci
      );
    },
    taleService() {
      return vl.getService(
        "taleService",
        TC,
        this,
        this.authService,
        Ci
      );
    },
    teamService() {
      return vl.getService(
        "teamService",
        IC,
        this,
        this.authService,
        Ci
      );
    },
    workspaceService() {
      return vl.getService(
        "workspaceService",
        EC,
        this,
        this.authService,
        Ci
      );
    }
  },
  actions: {}
});
class Hf extends Error {
  constructor(t) {
    super(t), this.name = "AuthorizationError";
  }
}
const wc = "an", OC = () => {
  if (!(typeof window > "u" || !window.localStorage))
    try {
      return window.localStorage.getItem(wc) ?? void 0;
    } catch {
      return;
    }
}, DC = (e) => {
  if (!(typeof window > "u" || !window.localStorage))
    try {
      window.localStorage.setItem(wc, e);
    } catch {
    }
}, zf = () => {
  if (!(typeof window > "u" || !window.localStorage))
    try {
      window.localStorage.removeItem(wc);
    } catch {
    }
}, qh = ir("user", {
  state: () => ({
    user: new Wr(),
    isAuthenticated: !1,
    isLoading: !1,
    anonymousToken: void 0,
    authenticatedToken: void 0,
    initialisationPromise: void 0
  }),
  getters: {
    isLoggedIn() {
      return this.isAuthenticated;
    },
    isAnonymous() {
      return !this.isAuthenticated;
    },
    isLoadingUser() {
      return this.isLoading;
    },
    isLoggedInAndValid() {
      return this.isLoggedIn && !!this.user?.id && typeof this.user?.id == "string" && this.user?.id.length > 0;
    },
    getToken() {
      return this.authenticatedToken || this.anonymousToken;
    }
  },
  actions: {
    async awaitInit() {
      this.initialisationPromise && await this.initialisationPromise;
    },
    async init(e, t) {
      if (this.initialisationPromise)
        return this.initialisationPromise;
      const n = async () => {
        this.isLoading = !0;
        try {
          try {
            await e.authService.init(t), this.isAuthenticated = e.authService.isAuthenticated();
          } catch {
            Vr().queueMessage({
              title: "Failed to initialise user",
              message: "Please try again later",
              type: "error"
            });
          }
          if (this.anonymousToken = OC(), this.isAuthenticated) {
            this.authenticatedToken = e.authService.keycloak.token;
            try {
              await this.loadUser(e);
            } catch (a) {
              a instanceof Hf ? await this.createLoggedInUser(e) ? (zf(), this.anonymousToken = void 0) : (Vr().queueMessage({
                title: "Failed to create user",
                message: "Please try to refresh the page and try again later",
                type: "error"
              }), await t.push({ name: gt.UNEXPECTED_ERROR })) : (Vr().queueMessage({
                title: "Failed to load user",
                message: "Please try to refresh the page and try again later",
                type: "error"
              }), await t.push({ name: gt.UNEXPECTED_ERROR }));
            }
          }
          this.isLoggedInAndValid && (zf(), this.anonymousToken = void 0);
        } finally {
          this.isLoading = !1;
        }
      };
      return this.initialisationPromise = n(), this.initialisationPromise;
    },
    async loadUser(e) {
      if (this.isAnonymous)
        return !1;
      let t;
      try {
        t = await e.userService.getCurrentUser();
      } catch (n) {
        throw n?.response?.status && n.response.status === 401 ? new Hf("Failed to load user") : n;
      }
      if ((await t.validate()).length === 0)
        this.user = t;
      else
        return !1;
      return !0;
    },
    async createLoggedInUser(e) {
      if (this.isAnonymous)
        return !1;
      try {
        const t = await e.userService.createUser(this.anonymousToken);
        if ((await t.validate()).length === 0)
          this.user = t;
        else
          return !1;
      } catch {
        return !1;
      }
      return !0;
    },
    async createAnonymousUser(e) {
      if (this.isLoggedIn)
        return !1;
      if (this.isAnonymous && !this.anonymousToken)
        try {
          const t = await e.userService.createAnonymousUserToken();
          DC(t), this.anonymousToken = t;
        } catch {
          return Vr().queueMessage({
            title: "Failed to create anonymous user",
            message: "Please try to refresh the page",
            type: "error"
          }), !1;
        }
      return !0;
    }
  }
}), LC = { class: "text-h5 text-medium-emphasis ps-2" }, NC = { class: "text-medium-emphasis mb-4" }, FC = { class: "mb-2" }, RC = { class: "text-caption" }, $C = { class: "text-h5 text-medium-emphasis ps-2" }, BC = { class: "text-medium-emphasis mb-4" }, UC = { class: "mb-2" }, WC = { class: "text-caption" }, HC = /* @__PURE__ */ Qt({
  __name: "TeamAndWorkspaceManagementListItems",
  setup(e) {
    const { t } = mn(), n = Jr(), a = _l(), r = qh(), l = Le("serviceStore"), i = G(!0), o = G(""), s = G(!1), u = G(""), c = G(!1), d = async () => {
      if (!o.value || !l)
        return;
      const _ = new pa();
      _.name = o.value, _.workspace = a.workspace ?? void 0;
      try {
        const I = await l.teamService.createTeam(_);
        f(), a.workspace && await l.teamService.addTeamToWorkspace(I, a.workspace), await a.loadTeams(l, 0, a.workspace), await a.selectTeam(l, I), await n.push({ name: gt.TEAM_MANAGEMENT, params: { teamId: I.id } });
      } catch (I) {
        console.error("Failed to create team", I);
      }
    }, f = () => {
      o.value = "", s.value = !1;
    }, v = async () => {
      if (!u.value || !l)
        return;
      const _ = new Wa();
      _.name = u.value;
      try {
        const I = await l.workspaceService.createWorkspace(_);
        g(), await a.loadWorkspaces(l, 0), await a.selectWorkspace(l, I), await n.push({
          name: gt.WORKSPACE_MANAGEMENT,
          params: { workspaceId: I.id }
        });
      } catch (I) {
        console.error("Failed to create workspace", I);
      }
    }, g = () => {
      u.value = "", c.value = !1;
    }, m = async () => {
      l && await a.selectTeam(l, null);
    }, h = async (_) => {
      l && await a.selectTeam(l, _);
    }, w = async () => {
      if (!l) {
        i.value = !1;
        return;
      }
      try {
        await r.init(l, n), r.isLoggedInAndValid && (await a.loadWorkspaces(l, 0), await a.loadTeams(l, 0), await a.loadLastSelection(l));
      } catch (_) {
        console.error("Failed to fetch teams", _);
      }
      i.value = !1;
    };
    return bt(() => {
      w();
    }), (_, I) => {
      const C = de("v-skeleton-loader"), b = de("v-btn"), p = de("v-icon"), x = de("v-card-title"), k = de("v-divider"), V = de("v-text-field"), A = de("v-card-text"), M = de("v-card-actions"), L = de("v-card"), E = de("v-dialog"), P = de("v-list-item"), O = de("v-list"), F = de("v-menu"), B = de("v-btn-group");
      return i.value ? (ge(), _e(C, {
        key: 0,
        type: "list-item-three-line"
      })) : Z(r).isLoggedInAndValid ? (ge(), _e(O, { key: 1 }, {
        default: q(() => [
          y(P, null, {
            title: q(() => [
              we(ce(Z(t)("general.selectedWorkspace")), 1)
            ]),
            subtitle: q(() => [
              y(B, {
                density: "comfortable",
                divided: ""
              }, {
                default: q(() => [
                  Z(a).workspace?.id ? (ge(), _e(b, {
                    key: 0,
                    class: "pe-2",
                    to: {
                      name: Z(gt).WORKSPACE_MANAGEMENT,
                      params: { workspaceId: Z(a).workspace.id }
                    }
                  }, {
                    default: q(() => [
                      we(ce(Z(a).workspace.name), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])) : (ge(), _e(b, { key: 1 }, {
                    default: q(() => [
                      we(ce(Z(t)("general.none")), 1)
                    ]),
                    _: 1
                  })),
                  y(b, {
                    size: "small",
                    icon: ""
                  }, {
                    default: q(() => [
                      y(p, { icon: "mdi-menu-down" }),
                      y(F, {
                        activator: "parent",
                        location: "bottom end",
                        transition: "fade-transition"
                      }, {
                        default: q(() => [
                          y(O, {
                            density: "compact",
                            "min-width": "250",
                            rounded: "lg",
                            slim: ""
                          }, {
                            default: q(() => [
                              y(P, {
                                "prepend-icon": "mdi-plus",
                                link: ""
                              }, {
                                title: q(() => [
                                  we(ce(Z(t)("general.create")), 1)
                                ]),
                                default: q(() => [
                                  y(E, {
                                    activator: "parent",
                                    "max-width": "500"
                                  }, {
                                    default: q(({ isActive: N }) => [
                                      y(L, { rounded: "lg" }, {
                                        default: q(() => [
                                          y(x, { class: "d-flex justify-space-between align-center" }, {
                                            default: q(() => [
                                              S("div", LC, ce(Z(t)("general.createWorkspace")), 1),
                                              y(b, {
                                                icon: "mdi-close",
                                                variant: "text",
                                                onClick: () => {
                                                  N.value = !1, g();
                                                }
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          y(k, { class: "mb-4" }),
                                          y(A, null, {
                                            default: q(() => [
                                              S("div", NC, ce(Z(t)("general.createWorkspaceWhy")), 1),
                                              S("div", FC, ce(Z(t)("general.name")), 1),
                                              y(V, {
                                                modelValue: u.value,
                                                "onUpdate:modelValue": I[0] || (I[0] = (W) => u.value = W),
                                                placeholder: Z(t)("general.workspaceNameExample"),
                                                counter: 50,
                                                "persistent-counter": ""
                                              }, null, 8, ["modelValue", "placeholder"])
                                            ]),
                                            _: 1
                                          }),
                                          y(k, { class: "mt-2" }),
                                          y(M, { class: "my-2 d-flex justify-end" }, {
                                            default: q(() => [
                                              y(b, {
                                                class: "text-none",
                                                rounded: "xl",
                                                text: "Cancel",
                                                onClick: () => {
                                                  N.value = !1, g();
                                                }
                                              }, null, 8, ["onClick"]),
                                              y(b, {
                                                class: "text-none",
                                                color: "primary",
                                                rounded: "xl",
                                                variant: "flat",
                                                onClick: () => {
                                                  N.value = !1, v();
                                                }
                                              }, {
                                                default: q(() => [
                                                  we(ce(Z(t)("general.create")), 1)
                                                ]),
                                                _: 1
                                              }, 8, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              Z(l) ? (ge(), _e(P, {
                                key: 0,
                                onClick: I[1] || (I[1] = (N) => Z(a).selectWorkspace(Z(l), null)),
                                to: { name: Z(gt).HOME }
                              }, {
                                title: q(() => [
                                  we(ce(Z(t)("general.selectNone")), 1)
                                ]),
                                _: 1
                              }, 8, ["to"])) : ot("", !0),
                              Z(l) ? (ge(!0), yt(fe, { key: 1 }, ia(Z(a).workspacesAvailable, (N) => (ge(), _e(P, {
                                key: N.id,
                                onClick: (W) => Z(a).selectWorkspace(Z(l), N),
                                to: {
                                  name: Z(gt).WORKSPACE_MANAGEMENT,
                                  params: { workspaceId: N.id }
                                }
                              }, {
                                title: q(() => [
                                  we(ce(N.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "to"]))), 128)) : ot("", !0),
                              y(k, { class: "my-2" }),
                              Z(a).allWorkspacesLoaded ? (ge(), _e(P, {
                                key: 2,
                                "min-height": "24"
                              }, {
                                subtitle: q(() => [
                                  S("div", RC, ce(Z(t)("general.allLoaded")), 1)
                                ]),
                                _: 1
                              })) : Z(l) ? (ge(), _e(P, {
                                key: 3,
                                onClick: I[2] || (I[2] = (N) => Z(a).loadWorkspaces(Z(l), Z(a).lastWorkspacePageLoaded + 1))
                              }, {
                                default: q(() => [
                                  we(ce(Z(t)("general.loadMore")), 1)
                                ]),
                                _: 1
                              })) : ot("", !0)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          y(P, null, {
            title: q(() => [
              we(ce(Z(t)("general.selectedTeam")), 1)
            ]),
            subtitle: q(() => [
              y(B, {
                density: "comfortable",
                divided: ""
              }, {
                default: q(() => [
                  Z(a).selected?.id ? (ge(), _e(b, {
                    key: 0,
                    class: "pe-2",
                    to: { name: Z(gt).TEAM_MANAGEMENT, params: { teamId: Z(a).selected.id } }
                  }, {
                    default: q(() => [
                      we(ce(Z(a).selected.name), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])) : (ge(), _e(b, { key: 1 }, {
                    default: q(() => [
                      we(ce(Z(t)("general.none")), 1)
                    ]),
                    _: 1
                  })),
                  y(b, {
                    size: "small",
                    icon: ""
                  }, {
                    default: q(() => [
                      y(p, { icon: "mdi-menu-down" }),
                      y(F, {
                        activator: "parent",
                        location: "bottom end",
                        transition: "fade-transition"
                      }, {
                        default: q(() => [
                          y(O, {
                            density: "compact",
                            "min-width": "250",
                            rounded: "lg",
                            slim: ""
                          }, {
                            default: q(() => [
                              y(P, {
                                "prepend-icon": "mdi-plus",
                                link: ""
                              }, {
                                title: q(() => [
                                  we(ce(Z(t)("general.create")), 1)
                                ]),
                                default: q(() => [
                                  y(E, {
                                    activator: "parent",
                                    "max-width": "500"
                                  }, {
                                    default: q(({ isActive: N }) => [
                                      y(L, { rounded: "lg" }, {
                                        default: q(() => [
                                          y(x, { class: "d-flex justify-space-between align-center" }, {
                                            default: q(() => [
                                              S("div", $C, ce(Z(t)("general.createTeam")), 1),
                                              y(b, {
                                                icon: "mdi-close",
                                                variant: "text",
                                                onClick: () => {
                                                  N.value = !1, f();
                                                }
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          y(k, { class: "mb-4" }),
                                          y(A, null, {
                                            default: q(() => [
                                              S("div", BC, ce(Z(t)("general.createTeamWhy")), 1),
                                              S("div", UC, ce(Z(t)("general.name")), 1),
                                              y(V, {
                                                modelValue: o.value,
                                                "onUpdate:modelValue": I[3] || (I[3] = (W) => o.value = W),
                                                placeholder: Z(t)("general.teamNameExample"),
                                                counter: 50,
                                                "persistent-counter": ""
                                              }, null, 8, ["modelValue", "placeholder"])
                                            ]),
                                            _: 1
                                          }),
                                          y(k, { class: "mt-2" }),
                                          y(M, { class: "my-2 d-flex justify-end" }, {
                                            default: q(() => [
                                              y(b, {
                                                class: "text-none",
                                                rounded: "xl",
                                                text: "Cancel",
                                                onClick: () => {
                                                  N.value = !1, f();
                                                }
                                              }, null, 8, ["onClick"]),
                                              y(b, {
                                                class: "text-none",
                                                color: "primary",
                                                rounded: "xl",
                                                variant: "flat",
                                                onClick: () => {
                                                  N.value = !1, d();
                                                }
                                              }, {
                                                default: q(() => [
                                                  we(ce(Z(t)("general.create")), 1)
                                                ]),
                                                _: 1
                                              }, 8, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              y(P, {
                                onClick: m,
                                to: { name: Z(gt).HOME }
                              }, {
                                title: q(() => [
                                  we(ce(Z(t)("general.selectNone")), 1)
                                ]),
                                _: 1
                              }, 8, ["to"]),
                              (ge(!0), yt(fe, null, ia(Z(a).teamsAvailable, (N) => (ge(), _e(P, {
                                key: N.id,
                                onClick: () => h(N),
                                to: { name: Z(gt).TEAM_MANAGEMENT, params: { teamId: N.id } }
                              }, {
                                title: q(() => [
                                  we(ce(N.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "to"]))), 128)),
                              y(k, { class: "my-2" }),
                              Z(a).allTeamsLoaded ? (ge(), _e(P, {
                                key: 0,
                                "min-height": "24"
                              }, {
                                subtitle: q(() => [
                                  S("div", WC, ce(Z(t)("general.allLoaded")), 1)
                                ]),
                                _: 1
                              })) : Z(l) ? (ge(), _e(P, {
                                key: 1,
                                onClick: I[4] || (I[4] = (N) => Z(a).loadTeams(Z(l), Z(a).lastPageLoaded + 1))
                              }, {
                                default: q(() => [
                                  we(ce(Z(t)("general.loadMore")), 1)
                                ]),
                                _: 1
                              })) : ot("", !0)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })) : ot("", !0);
    };
  }
}), jf = 80, zC = /* @__PURE__ */ Qt({
  __name: "SwipeToRefresh",
  props: {
    mainContent: {
      type: Object,
      required: !0
    },
    isNative: {
      type: Boolean,
      required: !0
    }
  },
  emits: ["refresh"],
  setup(e, { emit: t }) {
    const n = e, a = t, { mainContent: r, isNative: l } = Kr(n), i = G(0), o = G(!1);
    let s = 0, u = 0, c = null, d = null;
    const f = T(() => {
      const w = o.value || i.value === 0 ? "transform 0.3s ease-out" : "none";
      return {
        transform: `translateY(${i.value}px)`,
        transition: w
      };
    }), v = T(() => {
      const w = i.value * 4, _ = o.value || i.value === 0 ? "transform 0.3s ease-out" : "none";
      return {
        transform: `rotate(${w}deg)`,
        transition: _
      };
    }), g = (w) => {
      d = null, c && c.scrollTop === 0 && !o.value ? w.touches[0] && (s = w.touches[0].clientY, u = w.touches[0].clientX) : (s = 0, u = 0);
    }, m = (w) => {
      if (!s || o.value || !w.touches[0])
        return;
      const _ = w.touches[0].clientY, I = w.touches[0].clientX, C = _ - s, b = I - u;
      d || (Math.abs(C) > 5 || Math.abs(b) > 5) && (Math.abs(C) > Math.abs(b) ? d = "vertical" : d = "horizontal"), d !== "horizontal" && (C > 0 ? (w.preventDefault(), i.value = Math.pow(C, 0.85)) : i.value = 0);
    }, h = () => {
      d = null, !o.value && (i.value > jf ? (o.value = !0, i.value = jf, a("refresh", () => {
        o.value = !1, i.value = 0;
      })) : i.value = 0, s = 0, u = 0);
    };
    return ne(
      r,
      (w) => {
        l.value && (c && (c.removeEventListener("touchstart", g), c.removeEventListener("touchmove", m), c.removeEventListener("touchend", h)), c = w?.$el ?? null, c && (c.addEventListener("touchstart", g, { passive: !0 }), c.addEventListener("touchmove", m, { passive: !1 }), c.addEventListener("touchend", h, { passive: !0 })));
      },
      { immediate: !0 }
    ), lm(() => {
      l.value && c && (c.removeEventListener("touchstart", g), c.removeEventListener("touchmove", m), c.removeEventListener("touchend", h));
    }), (w, _) => {
      const I = de("v-progress-circular");
      return Z(l) ? (ge(), yt("div", {
        key: 0,
        class: "pull-to-refresh-indicator",
        style: le(f.value)
      }, [
        o.value ? (ge(), _e(I, {
          key: 0,
          indeterminate: "",
          color: "primary",
          size: "24"
        })) : i.value > 0 ? (ge(), _e(I, {
          key: 1,
          "model-value": 90,
          color: "primary",
          size: "24",
          style: le(v.value)
        }, null, 8, ["style"])) : ot("", !0)
      ], 4)) : ot("", !0);
    };
  }
}), jC = /* @__PURE__ */ Zn(zC, [["__scopeId", "data-v-92a9890c"]]), GC = /* @__PURE__ */ Qt({
  __name: "TutorialReplayFab",
  props: {
    show: { type: Boolean }
  },
  emits: ["click"],
  setup(e) {
    const { t } = mn();
    return (n, a) => {
      const r = de("v-btn");
      return e.show ? (ge(), _e(r, {
        key: 0,
        type: "button",
        color: "surface-variant",
        variant: "tonal",
        size: "small",
        elevation: "4",
        icon: "mdi-school-outline",
        class: "tutorial-replay-fab bp-fab-enter",
        "data-guide": "replay-tutorial-fab",
        "aria-label": Z(t)("general.replayTutorialAria"),
        onClick: a[0] || (a[0] = (l) => n.$emit("click"))
      }, null, 8, ["aria-label"])) : ot("", !0);
    };
  }
}), Yh = /* @__PURE__ */ Zn(GC, [["__scopeId", "data-v-0234a9d7"]]), qC = ir("tutorial", {
  state: () => ({
    activeTourId: null,
    steps: [],
    currentIndex: 0,
    visible: !1
  }),
  getters: {
    currentStep(e) {
      return e.steps[e.currentIndex] ?? null;
    },
    totalSteps(e) {
      return e.steps.length;
    },
    isFirstStep(e) {
      return e.currentIndex <= 0;
    },
    isLastStep(e) {
      return e.currentIndex >= e.steps.length - 1;
    }
  },
  actions: {
    /**
     * Register a tour. Replaces any previously registered steps.
     * Does not start the tour automatically; call `start()` afterwards.
     */
    registerTour(e, t) {
      const n = [...t].sort((a, r) => a.stepNumber - r.stepNumber);
      this.activeTourId = e, this.steps = n, this.currentIndex = 0, this.visible = !1;
    },
    /**
     * Unregister the currently active tour (or only if ids match when provided).
     * Useful on page unmount so replay controls do not leak to other pages.
     */
    unregisterTour(e) {
      e && this.activeTourId !== e || (this.visible = !1, this.currentIndex = 0, this.steps = [], this.activeTourId = null);
    },
    /**
     * Start the registered tour (opened only when the user explicitly asks, e.g. replay).
     */
    start() {
      !this.activeTourId || this.steps.length === 0 || (this.currentIndex = 0, this.visible = !0);
    },
    next() {
      this.currentIndex < this.steps.length - 1 ? this.currentIndex += 1 : this.complete();
    },
    previous() {
      this.currentIndex > 0 && (this.currentIndex -= 1);
    },
    goTo(e) {
      e >= 0 && e < this.steps.length && (this.currentIndex = e);
    },
    /** Mark the tour finished and hide the overlay. */
    complete() {
      this.visible = !1;
    },
    /** Same as complete() but used when the user dismisses early. */
    skip() {
      this.visible = !1;
    }
  }
}), Ei = 12, _r = 12, Gf = 18, YC = 2500, KC = 50;
function Kh() {
  const e = G(null), t = G(null), n = G("centered"), a = G(0), r = G(0), l = G(0), i = G(null);
  let o = null, s = null, u = null, c = null, d = null, f = null;
  const v = () => {
    o && (o.disconnect(), o = null), u && (u.disconnect(), u = null), c = null;
  }, g = () => {
    s && (s.disconnect(), s = null);
  }, m = () => {
    d !== null && (window.clearTimeout(d), d = null), f !== null && (window.clearInterval(f), f = null);
  }, h = (N) => {
    const W = N.getBoundingClientRect();
    return { top: W.top, left: W.left, width: W.width, height: W.height };
  }, w = () => {
    if (!i.value) return;
    const N = i.value.getBoundingClientRect();
    t.value = { width: N.width, height: N.height };
  }, _ = (N) => {
    v(), c = N, o = new ResizeObserver(() => {
      c && (e.value = h(c));
    }), o.observe(N), u = new MutationObserver(() => {
      c && (e.value = h(c));
    }), u.observe(document.body, {
      attributes: !0,
      childList: !0,
      subtree: !0
    });
  }, I = () => {
    g(), i.value && (s = new ResizeObserver(() => {
      w();
    }), s.observe(i.value));
  }, C = (N, W, R) => R < W ? W : Math.min(Math.max(N, W), R), b = (N) => {
    const W = window.innerWidth, R = window.innerHeight;
    n.value = "centered", a.value = Math.max(_r, (R - N.height) / 2), r.value = Math.max(_r, (W - N.width) / 2);
  }, p = () => {
    const N = t.value;
    if (!N) return;
    const W = e.value;
    if (!W) {
      b(N);
      return;
    }
    const R = window.innerWidth, j = window.innerHeight, H = W.top - Ei - _r, $ = j - (W.top + W.height) - Ei - _r;
    let z;
    if (N.height <= $)
      z = "below";
    else if (N.height <= H)
      z = "above";
    else {
      b(N);
      return;
    }
    const te = z === "below" ? W.top + W.height + Ei : W.top - Ei - N.height, me = W.left + W.width / 2, Q = _r, ie = R - N.width - _r, ke = C(me - N.width / 2, Q, ie), ye = C(me - ke, Gf, N.width - Gf);
    n.value = z, a.value = te, r.value = ke, l.value = ye;
  }, x = () => {
    c ? e.value = h(c) : p();
  }, k = (N) => new Promise((W) => {
    m();
    const R = document.querySelector(N);
    if (R) {
      W(R);
      return;
    }
    f = window.setInterval(() => {
      const j = document.querySelector(N);
      j && (m(), W(j));
    }, KC), d = window.setTimeout(() => {
      m(), W(null);
    }, YC);
  }), V = async (N) => {
    if (m(), v(), !N)
      return e.value = null, n.value = "centered", await Se(), w(), !0;
    const W = await k(N);
    return W ? (W.scrollIntoView({ block: "center", behavior: "smooth" }), await Se(), await new Promise((R) => window.setTimeout(R, 220)), e.value = h(W), _(W), await Se(), w(), p(), !0) : !1;
  }, A = () => {
    window.addEventListener("resize", x), window.addEventListener("scroll", x, !0);
  }, M = () => {
    window.removeEventListener("resize", x), window.removeEventListener("scroll", x, !0);
  }, L = () => {
    M(), v(), g(), m(), e.value = null, t.value = null;
  }, E = (N) => {
    let W = null;
    N && (N instanceof HTMLElement ? W = N : "$el" in N && N.$el instanceof HTMLElement && (W = N.$el)), i.value = W, i.value ? (w(), I()) : g();
  }, P = T(() => n.value === "centered"), O = T(() => t.value !== null), F = T(() => ({
    top: `${a.value}px`,
    left: `${r.value}px`,
    transform: "none"
  })), B = T(() => ({
    left: `${l.value}px`
  }));
  return ne([e, t], () => {
    p();
  }), Ft(() => {
    L();
  }), {
    targetRect: e,
    cardSize: t,
    placement: n,
    cardTop: a,
    cardLeft: r,
    arrowLeft: l,
    cardEl: i,
    isCentered: P,
    isReady: O,
    cardStyle: F,
    arrowStyle: B,
    onCardRef: E,
    positionToTarget: V,
    startListening: A,
    stopListening: M,
    cleanup: L,
    measureCard: w,
    recomputePosition: p,
    cleanupTargetObservers: v,
    cleanupWaiters: m
  };
}
const ZC = {
  key: 0,
  class: "tt-tutorial-root",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "tt-tutorial-title",
  "aria-describedby": "tt-tutorial-description"
}, JC = { class: "tt-tutorial-card__progress" }, XC = {
  id: "tt-tutorial-title",
  class: "text-h6 font-weight-bold tt-tutorial-card__title"
}, QC = {
  id: "tt-tutorial-description",
  class: "text-body-2 text-medium-emphasis tt-tutorial-card__description"
}, e1 = { class: "tt-tutorial-card__actions" }, t1 = /* @__PURE__ */ Qt({
  __name: "TutorialDisplayer",
  setup(e) {
    const { t } = mn(), n = qC(), {
      placement: a,
      isCentered: r,
      isReady: l,
      cardStyle: i,
      arrowStyle: o,
      onCardRef: s,
      positionToTarget: u,
      startListening: c,
      stopListening: d,
      cleanup: f,
      cleanupTargetObservers: v,
      cleanupWaiters: g
    } = Kh(), m = T(() => n.visible), h = T(() => n.currentStep), w = T(
      () => !!n.activeTourId && n.steps.length > 0
    ), _ = T(
      () => !n.visible && w.value
    ), I = T(() => n.isFirstStep), C = T(() => n.isLastStep), b = T(() => n.totalSteps), p = T(() => n.currentIndex + 1), x = T(() => h.value?.allowManualNext !== !1);
    let k = null;
    const V = async () => {
      if (k === null) return;
      const N = n.steps[k] ?? null;
      if (k = null, N?.onLeave)
        try {
          await N.onLeave();
        } catch (W) {
          console.error("[TutorialDisplayer] step.onLeave threw:", W);
        }
    }, A = async () => {
      const N = h.value;
      if (N && (k = n.currentIndex, N.onEnter))
        try {
          await N.onEnter();
        } catch (W) {
          console.error("[TutorialDisplayer] step.onEnter threw:", W);
        }
    }, M = async () => {
      g(), v(), await V();
      const N = h.value;
      if (!N) return;
      await A(), await Se(), await u(N.targetSelector) || (console.error(
        `[TutorialDisplayer] Step ${N.stepNumber} target "${N.targetSelector}" not found. Skipping.`
      ), await V(), n.isLastStep ? n.complete() : n.next());
    }, L = () => {
      x.value && n.next();
    }, E = () => {
      n.previous();
    }, P = () => {
      n.skip();
    }, O = () => {
      n.start();
    }, F = (N) => {
      if (m.value)
        if (N.key === "Escape")
          N.preventDefault(), n.skip();
        else if (N.key === "ArrowRight" || N.key === "Enter") {
          if (!x.value) return;
          N.preventDefault(), n.next();
        } else N.key === "ArrowLeft" && (N.preventDefault(), n.previous());
    }, B = (N) => {
      typeof document > "u" || (document.documentElement.style.overflow = N ? "hidden" : "", document.body.style.overflow = N ? "hidden" : "");
    };
    return ne(m, (N) => {
      N ? (B(!0), window.addEventListener("keydown", F), c(), M()) : (B(!1), window.removeEventListener("keydown", F), d(), f(), V());
    }), ne(
      () => n.currentIndex,
      () => {
        m.value && M();
      }
    ), Ft(() => {
      V(), B(!1), window.removeEventListener("keydown", F);
    }), (N, W) => {
      const R = de("v-btn"), j = de("v-spacer"), H = de("v-sheet");
      return ge(), _e(Ku, { to: "body" }, [
        y(Yh, {
          show: _.value,
          onClick: O
        }, null, 8, ["show"]),
        y(Rn, { name: "tt-tutorial-fade" }, {
          default: q(() => [
            m.value && h.value ? (ge(), yt("div", ZC, [
              y(H, {
                ref: Z(s),
                class: J(["tt-tutorial-card", {
                  "tt-tutorial-card--centered": Z(r),
                  "tt-tutorial-card--placed": !Z(r),
                  "tt-tutorial-card--ready": Z(l)
                }]),
                elevation: "12",
                rounded: "xl",
                style: le(Z(i))
              }, {
                default: q(() => [
                  Z(r) ? ot("", !0) : (ge(), yt("div", {
                    key: 0,
                    class: J(["tt-tutorial-arrow", Z(a) === "below" ? "tt-tutorial-arrow--up" : "tt-tutorial-arrow--down"]),
                    style: le(Z(o)),
                    "aria-hidden": "true"
                  }, null, 6)),
                  y(Rn, {
                    name: "tt-tutorial-content",
                    mode: "out-in"
                  }, {
                    default: q(() => [
                      (ge(), yt("div", {
                        key: p.value,
                        class: "tt-tutorial-card__inner"
                      }, [
                        S("div", JC, ce(Z(t)("general.tutorialProgress", { current: p.value, total: b.value })), 1),
                        S("h2", XC, ce(h.value.title), 1),
                        S("p", QC, ce(h.value.description), 1),
                        S("div", e1, [
                          C.value ? ot("", !0) : (ge(), _e(R, {
                            key: 0,
                            variant: "text",
                            size: "small",
                            onClick: P
                          }, {
                            default: q(() => [
                              we(ce(Z(t)("general.tutorialSkip")), 1)
                            ]),
                            _: 1
                          })),
                          y(j),
                          I.value ? ot("", !0) : (ge(), _e(R, {
                            key: 1,
                            variant: "outlined",
                            size: "small",
                            onClick: E
                          }, {
                            default: q(() => [
                              we(ce(Z(t)("general.tutorialBack")), 1)
                            ]),
                            _: 1
                          })),
                          x.value ? (ge(), _e(R, {
                            key: 2,
                            color: "primary",
                            variant: "elevated",
                            size: "small",
                            onClick: L
                          }, {
                            default: q(() => [
                              we(ce(C.value ? Z(t)("general.tutorialDone") : Z(t)("general.tutorialNext")), 1)
                            ]),
                            _: 1
                          })) : ot("", !0)
                        ])
                      ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class", "style"])
            ])) : ot("", !0)
          ]),
          _: 1
        })
      ]);
    };
  }
}), n1 = /* @__PURE__ */ Zn(t1, [["__scopeId", "data-v-6f7bf1eb"]]), Zh = "blueprint.smartGuide.completedGuides";
var a1 = /* @__PURE__ */ ((e) => (e.Off = "off", e.Configured = "configured", e.Waiting = "waiting", e.Suggesting = "suggesting", e))(a1 || {});
const r1 = () => {
  if (typeof window > "u" || !window.localStorage) return [];
  try {
    const e = window.localStorage.getItem(Zh);
    if (!e) return [];
    const t = JSON.parse(e);
    return Array.isArray(t) ? t.map((n) => {
      if (!n || typeof n != "object") return null;
      const a = n, r = a.id, l = a.actionsShown;
      if (typeof r != "string" || !Array.isArray(l)) return null;
      const i = l.filter((o) => typeof o == "string");
      return { id: r, actionsShown: i };
    }).filter((n) => n !== null) : [];
  } catch {
    return [];
  }
}, qf = (e) => {
  if (!(typeof window > "u" || !window.localStorage))
    try {
      window.localStorage.setItem(Zh, JSON.stringify(e));
    } catch {
    }
}, l1 = ir("smartGuide", {
  state: () => ({
    pageId: null,
    actions: [],
    completedPositions: /* @__PURE__ */ new Set(),
    status: "off",
    currentSuggestion: null,
    completedGuides: r1()
  }),
  getters: {
    pendingActions(e) {
      return e.actions.filter((t) => !e.completedPositions.has(t.actionPosition)).sort((t, n) => t.actionPosition - n.actionPosition);
    },
    nextAction() {
      return this.pendingActions[0];
    },
    isSuggesting(e) {
      return e.status === "suggesting";
    },
    /** Whether this `actionKey` was already shown at least once for this guide (persisted). */
    hasShownAction(e) {
      return (t, n) => e.completedGuides.find((r) => r.id === t)?.actionsShown.includes(n) ?? !1;
    }
  },
  actions: {
    _idleTimerId: null,
    _actionsShownForGuide(e) {
      return this.completedGuides.find((t) => t.id === e)?.actionsShown ?? [];
    },
    /**
     * Replace the active guide with only actions not yet persisted for this guide id.
     * Sets status to `Configured`; call `start()` after to begin idle timers.
     */
    registerActions(e, t) {
      const n = this._actionsShownForGuide(e), a = t.filter((r) => r.actionKey && !n.includes(r.actionKey));
      a.length !== 0 && (this._clearTimer(), this.pageId = e, this.actions = [...a].sort((r, l) => r.actionPosition - l.actionPosition), this.completedPositions = /* @__PURE__ */ new Set(), this.currentSuggestion = null, this.status = "configured");
    },
    start() {
      if (!(this.status !== "configured" && this.status !== "waiting")) {
        if (!this.nextAction) {
          this._shutdown();
          return;
        }
        this.status = "waiting", this._startIdleTimer();
      }
    },
    markActionAsDone(e) {
      if (this.status !== "off") {
        if (this.completedPositions = /* @__PURE__ */ new Set([...this.completedPositions, e]), this.status === "suggesting" && this.currentSuggestion?.actionPosition === e) {
          this.currentSuggestion = null, this._scheduleNextOrShutdown();
          return;
        }
        if (this.status === "waiting") {
          if (!this.nextAction) {
            this._shutdown();
            return;
          }
          this._clearTimer(), this._startIdleTimer();
        }
      }
    },
    dismiss() {
      this.status !== "suggesting" || !this.currentSuggestion || this.markActionAsDone(this.currentSuggestion.actionPosition);
    },
    shutdown() {
      this._shutdown();
    },
    /** Forget persisted keys for one guide, or clear all smart-guide persistence. */
    resetCompletedGuide(e) {
      e ? this.completedGuides = this.completedGuides.filter((t) => t.id !== e) : this.completedGuides = [], qf(this.completedGuides);
    },
    _persistActionShown(e, t) {
      if (!e || !t)
        return;
      const n = this.completedGuides.findIndex((a) => a.id === e);
      if (n === -1)
        this.completedGuides = [...this.completedGuides, { id: e, actionsShown: [t] }];
      else {
        const a = this.completedGuides[n];
        if (!a || a.actionsShown.includes(t))
          return;
        const r = [...this.completedGuides];
        r[n] = { id: a.id, actionsShown: [...a.actionsShown, t] }, this.completedGuides = r;
      }
      qf(this.completedGuides);
    },
    _scheduleNextOrShutdown() {
      this.nextAction ? (this.status = "waiting", this._startIdleTimer()) : this._shutdown();
    },
    _startIdleTimer() {
      this._clearTimer();
      const e = this.nextAction;
      e && (this._idleTimerId = setTimeout(() => {
        if (this.completedPositions.has(e.actionPosition)) {
          this._scheduleNextOrShutdown();
          return;
        }
        this.currentSuggestion = e, this.status = "suggesting", this._persistActionShown(this.pageId, e.actionKey);
      }, e.idleTimeMs));
    },
    _clearTimer() {
      this._idleTimerId !== null && (clearTimeout(this._idleTimerId), this._idleTimerId = null);
    },
    _shutdown() {
      this._clearTimer(), this.currentSuggestion = null, this.status = "off", this.pageId = null, this.actions = [], this.completedPositions = /* @__PURE__ */ new Set();
    }
  }
}), i1 = { class: "sg-card__inner" }, o1 = { class: "sg-card__icon-row" }, s1 = { class: "sg-card__hint-label" }, u1 = {
  id: "sg-title",
  class: "text-subtitle-1 font-weight-bold sg-card__title"
}, c1 = {
  id: "sg-description",
  class: "text-body-2 text-medium-emphasis sg-card__description"
}, d1 = { class: "sg-card__actions" }, f1 = /* @__PURE__ */ Qt({
  __name: "SmartGuideDisplayer",
  setup(e) {
    const { t } = mn(), n = l1(), {
      placement: a,
      isCentered: r,
      isReady: l,
      cardStyle: i,
      arrowStyle: o,
      onCardRef: s,
      positionToTarget: u,
      startListening: c,
      stopListening: d,
      cleanup: f
    } = Kh(), v = T(() => n.isSuggesting), g = T(() => n.currentSuggestion), m = () => {
      n.dismiss();
    }, h = (_) => {
      v.value && _.key === "Escape" && (_.preventDefault(), n.dismiss());
    }, w = async () => {
      const _ = g.value;
      _ && (await Se(), await u(_.targetSelector));
    };
    return ne(v, (_) => {
      _ ? (window.addEventListener("keydown", h), c(), w()) : (window.removeEventListener("keydown", h), d(), f());
    }), ne(g, (_) => {
      _ && v.value && w();
    }), Ft(() => {
      window.removeEventListener("keydown", h);
    }), (_, I) => {
      const C = de("v-icon"), b = de("v-spacer"), p = de("v-btn"), x = de("v-sheet");
      return ge(), _e(Ku, { to: "body" }, [
        y(Rn, { name: "sg-fade" }, {
          default: q(() => [
            v.value && g.value ? (ge(), yt("div", {
              key: g.value.actionKey,
              class: "sg-root",
              role: "tooltip",
              "aria-labelledby": "sg-title",
              "aria-describedby": "sg-description"
            }, [
              y(x, {
                ref: Z(s),
                class: J(["sg-card", {
                  "sg-card--centered": Z(r),
                  "sg-card--placed": !Z(r),
                  "sg-card--ready": Z(l)
                }]),
                elevation: "8",
                rounded: "xl",
                style: le(Z(i))
              }, {
                default: q(() => [
                  Z(r) ? ot("", !0) : (ge(), yt("div", {
                    key: 0,
                    class: J(["sg-arrow", Z(a) === "below" ? "sg-arrow--up" : "sg-arrow--down"]),
                    style: le(Z(o)),
                    "aria-hidden": "true"
                  }, null, 6)),
                  S("div", i1, [
                    S("div", o1, [
                      y(C, {
                        icon: "mdi-lightbulb-outline",
                        size: "18",
                        color: "primary"
                      }),
                      S("span", s1, ce(Z(t)("general.smartGuideHint")), 1),
                      y(b),
                      y(p, {
                        icon: "mdi-close",
                        variant: "text",
                        size: "x-small",
                        density: "compact",
                        "aria-label": Z(t)("general.close"),
                        onClick: m
                      }, null, 8, ["aria-label"])
                    ]),
                    S("h3", u1, ce(g.value.title), 1),
                    S("p", c1, ce(g.value.description), 1),
                    S("div", d1, [
                      y(p, {
                        variant: "text",
                        size: "small",
                        color: "primary",
                        onClick: m
                      }, {
                        default: q(() => [
                          we(ce(Z(t)("general.smartGuideDismiss")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["class", "style"])
            ])) : ot("", !0)
          ]),
          _: 1
        })
      ]);
    };
  }
}), v1 = /* @__PURE__ */ Zn(f1, [["__scopeId", "data-v-886059fe"]]), m1 = {
  badge: "شارة",
  open: "Open",
  close: "إغلاق",
  dismiss: "Dismiss",
  confirmEdit: {
    ok: "OK",
    cancel: "Cancel"
  },
  dataIterator: {
    noResultsText: "لم يتم إيجاد نتائج",
    loadingText: "يتم جلب العناصر..."
  },
  dataTable: {
    itemsPerPageText: "عدد الصفوف لكل صفحة:",
    ariaLabel: {
      sortDescending: "مرتب تنازلياً.",
      sortAscending: "مرتب تصاعدياً.",
      sortNone: "غير مرتب.",
      activateNone: "نشط لإزالة الترتيب.",
      activateDescending: "نشط للترتيب تنازلياً.",
      activateAscending: "نشط للترتيب تصاعدياً."
    },
    sortBy: "رتب حسب"
  },
  dataFooter: {
    itemsPerPageText: "عدد العناصر لكل صفحة:",
    itemsPerPageAll: "الكل",
    nextPage: "الصفحة التالية",
    prevPage: "الصفحة السابقة",
    firstPage: "الصفحة الأولى",
    lastPage: "الصفحة الأخيرة",
    pageText: "{0}-{1} من {2}"
  },
  dateRangeInput: {
    divider: "to"
  },
  datePicker: {
    itemsSelected: "{0} محدد",
    range: {
      title: "اختر التواريخ",
      header: "أدخل التواريخ"
    },
    title: "اختر التاريخ",
    header: "أدخل التاريخ",
    input: {
      placeholder: "أدخل التاريخ"
    },
    ariaLabel: {
      previousMonth: "الشهر السابق",
      nextMonth: "الشهر التالي",
      selectYear: "اختر السنة",
      previousYear: "السنة السابقة",
      nextYear: "السنة التالية",
      selectMonth: "اختر الشهر",
      selectDate: "{0}",
      currentDate: "اليوم، {0}"
    }
  },
  noDataText: "لا توجد بيانات",
  carousel: {
    prev: "المعروض السابق",
    next: "المعروض التالي",
    ariaLabel: {
      delimiter: "المعروض رقم {0} من {1}"
    }
  },
  calendar: {
    moreEvents: "{0} أكثر",
    today: "Today"
  },
  input: {
    clear: "Clear {0}",
    prependAction: "{0} prepended action",
    appendAction: "{0} appended action",
    otp: "Please enter OTP character {0}"
  },
  fileInput: {
    counter: "{0} ملفات",
    counterSize: "{0} ملفات ({1} في المجموع)"
  },
  fileUpload: {
    title: "Drag and drop files here",
    divider: "or",
    browse: "Browse Files"
  },
  timePicker: {
    am: "صباحاً",
    pm: "مساءً",
    title: "حدد الوقت",
    hour: "ساعة",
    minute: "دقائق",
    second: "ثواني",
    notAllowed: "القيمة غير مسموح بها"
  },
  pagination: {
    ariaLabel: {
      root: "الإنتقال بين الصفحات",
      next: "الصفحة التالية",
      previous: "الصفحة السابقة",
      page: "{0} انتقل إلى الصفحة",
      currentPage: "{0} الصفحة الحالية رقمها",
      first: "First page",
      last: "Last page"
    }
  },
  stepper: {
    next: "Next",
    prev: "Previous"
  },
  rating: {
    ariaLabel: {
      item: "القييم {0} من {1}"
    }
  },
  loading: "Loading...",
  infiniteScroll: {
    loadMore: "Load more",
    empty: "No more"
  },
  rules: {
    required: "هذه الخانة مطلوبه",
    email: "يرجى إدخال بريد إلكتروني صالح",
    number: "هذه الخانة يمكن أن تحتوي على أرقام فقط",
    integer: "هذه الخانة يمكن أن تحتوي على أعداد صحيحة فقط",
    capital: "هذه الخانة يمكن أن تحتوي على أحرف كبيرة فقط",
    maxLength: "يجب أن تدخل بحد أقصى {0} حرف",
    minLength: "يجب أن تدخل بحد أدنى {0} حرف",
    strictLength: "طول الحقل المدخل غير صالح",
    exclude: "الحرف {0} غير مسموح به",
    notEmpty: "يرجى اختيار قيمة واحدة على الأقل",
    pattern: "تنسيق غير صالح"
  },
  command: {
    search: "اكتب أمراً أو ابحث..."
  },
  hotkey: {
    then: "ثم",
    ctrl: "Ctrl",
    command: "Command",
    shift: "Shift",
    alt: "Alt",
    option: "Option",
    enter: "Enter",
    escape: "Escape",
    upArrow: "السهم العلوي",
    downArrow: "السهم السفلي",
    leftArrow: "السهم الأيسر",
    rightArrow: "السهم الأيمن",
    backspace: "مسافة للخلف",
    space: "مسافة",
    plus: "زائد",
    shortcut: "اختصار لوحة المفاتيح: {0}",
    or: "or"
  },
  video: {
    play: "تشغيل",
    pause: "إيقاف مؤقت",
    seek: "بحث",
    volume: "مستوى الصوت",
    showVolume: "إظهار التحكم في مستوى الصوت",
    mute: "كتم الصوت",
    unmute: "إلغاء كتم الصوت",
    enterFullscreen: "ملء الشاشة",
    exitFullscreen: "الخروج من وضع ملء الشاشة"
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: "اختيار لون من الشاشة",
      hueSlider: "درجة اللون",
      alphaSlider: "الشفافية",
      redInput: "أحمر",
      greenInput: "أخضر",
      blueInput: "أزرق",
      alphaInput: "الشفافية",
      hueInput: "درجة اللون",
      saturationInput: "التشبع اللوني",
      lightnessInput: "السطوع",
      hexInput: "قيمة HEX",
      hexaInput: "قيمة HEX مع الشفافية",
      changeFormat: "تغيير تنسيق اللون"
    }
  }
}, h1 = {
  badge: "Abzeichen",
  open: "Öffnen",
  close: "Schließen",
  dismiss: "Verwerfen",
  confirmEdit: {
    ok: "OK",
    cancel: "Abbrechen"
  },
  dataIterator: {
    noResultsText: "Keine Elemente gefunden",
    loadingText: "Lade Elemente..."
  },
  dataTable: {
    itemsPerPageText: "Zeilen pro Seite:",
    ariaLabel: {
      sortDescending: "Absteigend sortiert.",
      sortAscending: "Aufsteigend sortiert.",
      sortNone: "Nicht sortiert.",
      activateNone: "Aktivieren um Sortierung zu entfernen.",
      activateDescending: "Aktivieren um absteigend zu sortieren.",
      activateAscending: "Aktivieren um aufsteigend zu sortieren."
    },
    sortBy: "Sortiere nach"
  },
  dataFooter: {
    itemsPerPageText: "Elemente pro Seite:",
    itemsPerPageAll: "Alle",
    nextPage: "Nächste Seite",
    prevPage: "Vorherige Seite",
    firstPage: "Erste Seite",
    lastPage: "Letzte Seite",
    pageText: "{0}-{1} von {2}"
  },
  dateRangeInput: {
    divider: "bis"
  },
  datePicker: {
    itemsSelected: "{0} ausgewählt",
    range: {
      title: "Daten auswählen",
      header: "Daten eingeben"
    },
    title: "Datum auswählen",
    header: "Datum eingeben",
    input: {
      placeholder: "Datum eingeben"
    },
    ariaLabel: {
      previousMonth: "Vorheriger Monat",
      nextMonth: "Nächster Monat",
      selectYear: "Jahr auswählen",
      previousYear: "Vorheriges Jahr",
      nextYear: "Nächstes Jahr",
      selectMonth: "Monat auswählen",
      selectDate: "{0}",
      currentDate: "Heute, {0}"
    }
  },
  noDataText: "Keine Daten vorhanden",
  carousel: {
    prev: "Vorheriges Bild",
    next: "Nächstes Bild",
    ariaLabel: {
      delimiter: "Element {0} von {1}"
    }
  },
  calendar: {
    moreEvents: "{0} mehr",
    today: "Heute"
  },
  input: {
    clear: "{0} leeren",
    prependAction: "{0} vorangestellte Aktion",
    appendAction: "{0} angehängte Aktion",
    otp: "Bitte OTP-Zeichen {0} eingeben"
  },
  fileInput: {
    counter: "{0} Dateien",
    counterSize: "{0} Dateien ({1} gesamt)"
  },
  fileUpload: {
    title: "Datei hier ablegen",
    divider: "oder",
    browse: "Dateien durchsuchen"
  },
  timePicker: {
    am: "AM",
    pm: "PM",
    title: "Uhrzeit auswählen",
    hour: "Stunde",
    minute: "Minuten",
    second: "Sekunden",
    notAllowed: "Wert ist nicht erlaubt"
  },
  pagination: {
    ariaLabel: {
      root: "Seitennavigation",
      next: "Nächste Seite",
      previous: "Vorherige Seite",
      page: "Gehe zu Seite {0}",
      currentPage: "Aktuelle Seite, Seite {0}",
      first: "Erste Seite",
      last: "Letzte Seite"
    }
  },
  stepper: {
    next: "Weiter",
    prev: "Zurück"
  },
  rating: {
    ariaLabel: {
      item: "Bewertung {0} von {1}"
    }
  },
  loading: "Laden...",
  infiniteScroll: {
    loadMore: "Mehr laden",
    empty: "Nichts weiteres"
  },
  rules: {
    required: "Dieses Feld ist erforderlich",
    email: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    number: "Dieses Feld darf nur Zahlen enthalten",
    integer: "Dieses Feld darf nur Ganzzahlen enthalten",
    capital: "Dieses Feld darf nur Großbuchstaben enthalten",
    maxLength: "Sie dürfen maximal {0} Zeichen eingeben",
    minLength: "Sie müssen mindestens {0} Zeichen eingeben",
    strictLength: "Die Länge des eingegebenen Feldes ist ungültig",
    exclude: "Das Zeichen {0} ist nicht erlaubt",
    notEmpty: "Bitte wählen Sie mindestens einen Wert aus",
    pattern: "Ungültiges Format"
  },
  command: {
    search: "Geben Sie einen Befehl ein oder suchen Sie..."
  },
  hotkey: {
    then: "dann",
    ctrl: "Ctrl",
    command: "Command",
    shift: "Shift",
    alt: "Alt",
    option: "Option",
    enter: "Eingabe",
    escape: "Escape",
    upArrow: "Pfeil nach oben",
    downArrow: "Pfeil nach unten",
    leftArrow: "Pfeil nach links",
    rightArrow: "Pfeil nach rechts",
    backspace: "Rücktaste",
    space: "Leertaste",
    plus: "plus",
    shortcut: "Tastenkürzel: {0}",
    or: "oder"
  },
  video: {
    play: "Abspielen",
    pause: "Pause",
    seek: "Suchen",
    volume: "Lautstärke",
    showVolume: "Lautstärkeregler anzeigen",
    mute: "Stummschalten",
    unmute: "Stummschaltung aufheben",
    enterFullscreen: "Vollbild",
    exitFullscreen: "Vollbild beenden"
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: "Farbe vom Bildschirm auswählen",
      hueSlider: "Farbton",
      alphaSlider: "Transparenz",
      redInput: "Rot",
      greenInput: "Grün",
      blueInput: "Blau",
      alphaInput: "Transparenz",
      hueInput: "Farbton",
      saturationInput: "Sättigung",
      lightnessInput: "Helligkeit",
      hexInput: "HEX-Wert",
      hexaInput: "HEX-Wert mit Transparenz",
      changeFormat: "Farbformat ändern"
    }
  }
}, g1 = {
  badge: "Badge",
  open: "Open",
  close: "Close",
  dismiss: "Dismiss",
  confirmEdit: {
    ok: "OK",
    cancel: "Cancel"
  },
  dataIterator: {
    noResultsText: "No matching records found",
    loadingText: "Loading items..."
  },
  dataTable: {
    itemsPerPageText: "Rows per page:",
    ariaLabel: {
      sortDescending: "Sorted descending.",
      sortAscending: "Sorted ascending.",
      sortNone: "Not sorted.",
      activateNone: "Activate to remove sorting.",
      activateDescending: "Activate to sort descending.",
      activateAscending: "Activate to sort ascending."
    },
    sortBy: "Sort by"
  },
  dataFooter: {
    itemsPerPageText: "Items per page:",
    itemsPerPageAll: "All",
    nextPage: "Next page",
    prevPage: "Previous page",
    firstPage: "First page",
    lastPage: "Last page",
    pageText: "{0}-{1} of {2}"
  },
  dateRangeInput: {
    divider: "to"
  },
  datePicker: {
    itemsSelected: "{0} selected",
    range: {
      title: "Select dates",
      header: "Enter dates"
    },
    title: "Select date",
    header: "Enter date",
    input: {
      placeholder: "Enter date"
    },
    ariaLabel: {
      previousMonth: "Previous month",
      nextMonth: "Next month",
      selectYear: "Select year",
      previousYear: "Previous year",
      nextYear: "Next year",
      selectMonth: "Select month",
      selectDate: "{0}",
      // Full date format
      currentDate: "Today, {0}"
    }
  },
  noDataText: "No data available",
  carousel: {
    prev: "Previous visual",
    next: "Next visual",
    ariaLabel: {
      delimiter: "Carousel slide {0} of {1}"
    }
  },
  calendar: {
    moreEvents: "{0} more",
    today: "Today"
  },
  input: {
    clear: "Clear {0}",
    prependAction: "{0} prepended action",
    appendAction: "{0} appended action",
    otp: "Please enter OTP character {0}"
  },
  fileInput: {
    counter: "{0} files",
    counterSize: "{0} files ({1} in total)"
  },
  fileUpload: {
    title: "Drag and drop files here",
    divider: "or",
    browse: "Browse Files"
  },
  timePicker: {
    am: "AM",
    pm: "PM",
    title: "Select Time",
    hour: "Hour",
    minute: "Minute",
    second: "Second",
    notAllowed: "Value is not allowed"
  },
  pagination: {
    ariaLabel: {
      root: "Pagination Navigation",
      next: "Next page",
      previous: "Previous page",
      page: "Go to page {0}",
      currentPage: "Page {0}, Current page",
      first: "First page",
      last: "Last page"
    }
  },
  stepper: {
    next: "Next",
    prev: "Previous"
  },
  rating: {
    ariaLabel: {
      item: "Rating {0} of {1}"
    }
  },
  loading: "Loading...",
  infiniteScroll: {
    loadMore: "Load more",
    empty: "No more"
  },
  rules: {
    required: "This field is required",
    email: "Please enter a valid email",
    number: "This field can only contain numbers",
    integer: "This field can only contain integer values",
    capital: "This field can only contain uppercase letters",
    maxLength: "You must enter a maximum of {0} characters",
    minLength: "You must enter a minimum of {0} characters",
    strictLength: "The length of the entered field is invalid",
    exclude: "The {0} character is not allowed",
    notEmpty: "Please choose at least one value",
    pattern: "Invalid format"
  },
  command: {
    search: "Type a command or search..."
  },
  hotkey: {
    then: "then",
    ctrl: "Ctrl",
    command: "Command",
    space: "Space",
    shift: "Shift",
    alt: "Alt",
    enter: "Enter",
    escape: "Escape",
    upArrow: "Up Arrow",
    downArrow: "Down Arrow",
    leftArrow: "Left Arrow",
    rightArrow: "Right Arrow",
    backspace: "Backspace",
    option: "Option",
    plus: "plus",
    shortcut: "Keyboard shortcut: {0}",
    or: "or"
  },
  video: {
    play: "Play",
    pause: "Pause",
    seek: "Seek",
    volume: "Volume",
    showVolume: "Show volume control",
    mute: "Mute",
    unmute: "Unmute",
    enterFullscreen: "Full screen",
    exitFullscreen: "Exit full screen"
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: "Select color with eyedropper",
      hueSlider: "Hue",
      alphaSlider: "Alpha",
      redInput: "Red value",
      greenInput: "Green value",
      blueInput: "Blue value",
      alphaInput: "Alpha value",
      hueInput: "Hue value",
      saturationInput: "Saturation value",
      lightnessInput: "Lightness value",
      hexInput: "HEX value",
      hexaInput: "HEX with alpha value",
      changeFormat: "Change color format"
    }
  }
}, y1 = {
  badge: "Placa",
  open: "Abrir",
  close: "Cerrar",
  dismiss: "Descartar",
  confirmEdit: {
    ok: "OK",
    cancel: "Cancelar"
  },
  dataIterator: {
    noResultsText: "Ningún elemento coincide con la búsqueda",
    loadingText: "Cargando..."
  },
  dataTable: {
    itemsPerPageText: "Filas por página:",
    ariaLabel: {
      sortDescending: "Orden descendente.",
      sortAscending: "Orden ascendente.",
      sortNone: "Sin ordenar.",
      activateNone: "Pulse para quitar orden.",
      activateDescending: "Pulse para ordenar de forma descendente.",
      activateAscending: "Pulse para ordenar de forma ascendente."
    },
    sortBy: "Ordenado por"
  },
  dataFooter: {
    itemsPerPageText: "Elementos por página:",
    itemsPerPageAll: "Todos",
    nextPage: "Página siguiente",
    prevPage: "Página anterior",
    firstPage: "Primera página",
    lastPage: "Última página",
    pageText: "{0}-{1} de {2}"
  },
  dateRangeInput: {
    divider: "a"
  },
  datePicker: {
    itemsSelected: "{0} seleccionados",
    range: {
      title: "Seleccionar fechas",
      header: "Introducir fechas"
    },
    title: "Seleccionar fecha",
    header: "Introducir fecha",
    input: {
      placeholder: "Introducir fecha"
    },
    ariaLabel: {
      previousMonth: "Mes anterior",
      nextMonth: "Mes siguiente",
      selectYear: "Seleccionar año",
      previousYear: "Año anterior",
      nextYear: "Año siguiente",
      selectMonth: "Seleccionar mes",
      selectDate: "{0}",
      currentDate: "Hoy, {0}"
    }
  },
  noDataText: "No hay datos disponibles",
  carousel: {
    prev: "Visual anterior",
    next: "Visual siguiente",
    ariaLabel: {
      delimiter: "Visual {0} de {1}"
    }
  },
  calendar: {
    moreEvents: "{0} más",
    today: "Hoy"
  },
  input: {
    clear: "Borrar {0}",
    prependAction: "{0} acción adelantada",
    appendAction: "{0} acción añadida",
    otp: "Por favor, introduzca el carácter OTP {0}"
  },
  fileInput: {
    counter: "{0} archivos",
    counterSize: "{0} archivos ({1} en total)"
  },
  fileUpload: {
    title: "Arrastra y suelta archivos aquí",
    divider: "o",
    browse: "Explorar archivos"
  },
  timePicker: {
    am: "AM",
    pm: "PM",
    title: "Seleccionar hora",
    hour: "Hora",
    minute: "Minutos",
    second: "Segundos",
    notAllowed: "El valor no está permitido"
  },
  pagination: {
    ariaLabel: {
      root: "Navegación de paginación",
      next: "Página siguiente",
      previous: "Página anterior",
      page: "Ir a la página {0}",
      currentPage: "Página actual, página {0}",
      first: "Primera página",
      last: "Última página"
    }
  },
  stepper: {
    next: "Siguiente",
    prev: "Anterior"
  },
  rating: {
    ariaLabel: {
      item: "Puntuación {0} de {1}"
    }
  },
  loading: "Cargando...",
  infiniteScroll: {
    loadMore: "Cargar más",
    empty: "No hay más"
  },
  rules: {
    required: "Este campo es obligatorio",
    email: "Por favor, introduce un correo electrónico válido",
    number: "Este campo solo puede contener números",
    integer: "Este campo solo puede contener valores enteros",
    capital: "Este campo solo puede contener letras mayúsculas",
    maxLength: "Debes introducir un máximo de {0} caracteres",
    minLength: "Debes introducir un mínimo de {0} caracteres",
    strictLength: "La longitud del campo introducido no es válida",
    exclude: "El carácter {0} no está permitido",
    notEmpty: "Por favor, elige al menos un valor",
    pattern: "Formato inválido"
  },
  command: {
    search: "Escribe un comando o busca..."
  },
  hotkey: {
    then: "luego",
    ctrl: "Ctrl",
    command: "Command",
    shift: "Shift",
    alt: "Alt",
    option: "Option",
    enter: "Intro",
    escape: "Escape",
    upArrow: "Flecha arriba",
    downArrow: "Flecha abajo",
    leftArrow: "Flecha izquierda",
    rightArrow: "Flecha derecha",
    backspace: "Retroceso",
    space: "Espacio",
    plus: "más",
    shortcut: "Atajo de teclado: {0}",
    or: "o"
  },
  video: {
    play: "Reproducir",
    pause: "Pausa",
    seek: "Buscar",
    volume: "Volumen",
    showVolume: "Mostrar control de volumen",
    mute: "Silenciar",
    unmute: "Activar sonido",
    enterFullscreen: "Pantalla completa",
    exitFullscreen: "Salir de pantalla completa"
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: "Seleccionar color de la pantalla",
      hueSlider: "Tono",
      alphaSlider: "Alfa",
      redInput: "Rojo",
      greenInput: "Verde",
      blueInput: "Azul",
      alphaInput: "Alfa",
      hueInput: "Tono",
      saturationInput: "Saturación",
      lightnessInput: "Luminosidad",
      hexInput: "Valor HEX",
      hexaInput: "Valor HEX con alfa",
      changeFormat: "Cambiar formato de color"
    }
  }
}, b1 = {
  badge: "Badge",
  open: "Ouvrir",
  close: "Fermer",
  dismiss: "Ignorer",
  confirmEdit: {
    ok: "OK",
    cancel: "Annuler"
  },
  dataIterator: {
    noResultsText: "Aucun enregistrement correspondant trouvé",
    loadingText: "Chargement de l'élément..."
  },
  dataTable: {
    itemsPerPageText: "Lignes par page :",
    ariaLabel: {
      sortDescending: "Tri décroissant.",
      sortAscending: "Tri croissant.",
      sortNone: "Non trié.",
      activateNone: "Activer pour supprimer le tri.",
      activateDescending: "Activer pour trier par ordre décroissant.",
      activateAscending: "Activer pour trier par ordre croissant."
    },
    sortBy: "Trier par"
  },
  dataFooter: {
    itemsPerPageText: "Éléments par page :",
    itemsPerPageAll: "Tous",
    nextPage: "Page suivante",
    prevPage: "Page précédente",
    firstPage: "Première page",
    lastPage: "Dernière page",
    pageText: "{0}-{1} de {2}"
  },
  dateRangeInput: {
    divider: "à"
  },
  datePicker: {
    itemsSelected: "{0} sélectionné(s)",
    range: {
      title: "Sélectionner des dates",
      header: "Entrer des dates"
    },
    title: "Sélectionner une date",
    header: "Entrer une date",
    input: {
      placeholder: "Entrer une date"
    },
    ariaLabel: {
      previousMonth: "Mois précédent",
      nextMonth: "Mois suivant",
      selectYear: "Sélectionner une année",
      previousYear: "Année précédente",
      nextYear: "Année suivante",
      selectMonth: "Sélectionner un mois",
      selectDate: "{0}",
      currentDate: "Aujourd'hui, {0}"
    }
  },
  noDataText: "Aucune donnée disponible",
  carousel: {
    prev: "Visuel précédent",
    next: "Visuel suivant",
    ariaLabel: {
      delimiter: "Diapositive {0} de {1}"
    }
  },
  calendar: {
    moreEvents: "{0} de plus",
    today: "Aujourd'hui"
  },
  input: {
    clear: "Vider {0}",
    prependAction: "{0} action avant",
    appendAction: "{0} action après",
    otp: "Caractère {0} du mot de passe à usage unique"
  },
  fileInput: {
    counter: "{0} fichier(s)",
    counterSize: "{0} fichier(s) ({1} au total)"
  },
  fileUpload: {
    title: "Glissez-déposez des fichiers ici",
    divider: "ou",
    browse: "Parcourir les fichiers"
  },
  timePicker: {
    am: "AM",
    pm: "PM",
    title: "Sélectionner une heure",
    hour: "Heure",
    minute: "Minute",
    second: "Seconde",
    notAllowed: "La valeur n'est pas autorisée"
  },
  pagination: {
    ariaLabel: {
      root: "Navigation de pagination",
      next: "Page suivante",
      previous: "Page précédente",
      page: "Aller à la page {0}",
      currentPage: "Page actuelle, Page {0}",
      first: "Première page",
      last: "Dernière page"
    }
  },
  stepper: {
    next: "Suivant",
    prev: "Précédent"
  },
  rating: {
    ariaLabel: {
      item: "Note de {0} sur {1}"
    }
  },
  loading: "Chargement...",
  infiniteScroll: {
    loadMore: "Charger plus",
    empty: "Aucune donnée supplémentaire"
  },
  rules: {
    required: "Ce champ est requis",
    email: "Veuillez entrer une adresse email valide",
    number: "Ce champ ne peut contenir que des chiffres",
    integer: "Ce champ ne peut contenir que des valeurs entières",
    capital: "Ce champ ne peut contenir que des lettres majuscules",
    maxLength: "Vous devez entrer un maximum de {0} caractères",
    minLength: "Vous devez entrer un minimum de {0} caractères",
    strictLength: "La longueur du champ entré est invalide",
    exclude: "Le caractère {0} n’est pas autorisé",
    notEmpty: "Veuillez choisir au moins une valeur",
    pattern: "Format invalide"
  },
  command: {
    search: "Tapez une commande ou recherchez..."
  },
  hotkey: {
    then: "puis",
    ctrl: "Ctrl",
    command: "Command",
    shift: "Shift",
    alt: "Alt",
    option: "Option",
    enter: "Entrée",
    escape: "Échap",
    upArrow: "Flèche haut",
    downArrow: "Flèche bas",
    leftArrow: "Flèche gauche",
    rightArrow: "Flèche droite",
    backspace: "Retour",
    space: "Espace",
    plus: "plus",
    shortcut: "Raccourci clavier : {0}",
    or: "ou"
  },
  video: {
    play: "Lire",
    pause: "Pause",
    seek: "Chercher",
    volume: "Volume",
    showVolume: "Afficher le contrôle du volume",
    mute: "Muet",
    unmute: "Activer le son",
    enterFullscreen: "Plein écran",
    exitFullscreen: "Quitter le plein écran"
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: "Sélectionner une couleur à l'écran",
      hueSlider: "Teinte",
      alphaSlider: "Opacité",
      redInput: "Rouge",
      greenInput: "Vert",
      blueInput: "Bleu",
      alphaInput: "Opacité",
      hueInput: "Teinte",
      saturationInput: "Saturation",
      lightnessInput: "Luminosité",
      hexInput: "Valeur HEX",
      hexaInput: "Valeur HEX avec opacité",
      changeFormat: "Changer le format de couleur"
    }
  }
}, p1 = {
  create: "إنشاء",
  tutorialBack: "رجوع",
  tutorialDone: "فهمت",
  tutorialNext: "التالي",
  tutorialProgress: "{current} من {total}",
  replayTutorialAria: "إعادة تشغيل الدليل",
  tutorialSkip: "تخطي",
  smartGuideHint: "نصيحة",
  smartGuideDismiss: "فهمت"
}, w1 = {
  welcome: "مرحبا",
  beeText1: "بزز... هل تريد مني مساعدتك في إنشاء بعض المهام؟",
  beeText2: "ألق نظرة على حقل النص أدناه. سيعطيك بعض التلميحات حول كيفية البدء",
  beeText3: "بزز... أنا نحلة مشغولة، لكن يمكنني مساعدتك في إنشاء بعض المهام",
  task: "المهمة",
  taskExample1: "تنظيف الحمام",
  taskExample2: "تحضير الوجبات",
  taskExample3: "الذهاب إلى السوبرماركت",
  taskExample4: "غسيل الملابس"
}, k1 = {
  create: "Erstellen",
  tutorialBack: "Zurück",
  tutorialDone: "Verstanden",
  tutorialNext: "Weiter",
  tutorialProgress: "{current} von {total}",
  replayTutorialAria: "Tutorial erneut abspielen",
  tutorialSkip: "Überspringen",
  smartGuideHint: "Tipp",
  smartGuideDismiss: "Verstanden"
}, S1 = {
  welcome: "Willkommen",
  beeText1: "Bzz... Möchtest du, dass ich dir helfe, einige Aufgaben zu erstellen?",
  beeText2: "Schau dir das Textfeld unten an. Es gibt dir einen Hinweis, wie du anfangen kannst",
  beeText3: "Bzzz... Ich bin eine fleißige Biene, aber ich kann dir helfen, einige Aufgaben zu erstellen",
  task: "Aufgabe",
  taskExample1: "Das Badezimmer putzen",
  taskExample2: "Mahlzeiten vorbereiten",
  taskExample3: "Einkauf im Supermarkt",
  taskExample4: "Wäsche waschen"
}, x1 = {
  email: "E-Mail-Adresse",
  memberEmail: "E-Mail-Adresse des Mitglieds",
  roles: "Rollen"
}, C1 = {
  missingCat: "Vermisste Katze",
  ifFound1: "Wenn gefunden, bitte zurückbringen",
  ifFound2: "zum nächsten Katzencafé.",
  oops: "Hoppla! Im Wald verlaufen!",
  error: "404 - Nicht gefunden",
  errorDetails: "Wir haben überall gesucht, aber die Seite, die Sie gesucht haben, konnte nicht gefunden werden."
}, _1 = {
  members: "Mitglieder des Teams",
  newTeamMember: "Neues Teammitglied erstellen",
  title: "Teamverwaltung",
  totalMembers: "Gesamtmitglieder"
}, T1 = {
  oops: "Hoppla! Wir drehen uns im Kreis!",
  error: "500 - Unerwarteter Fehler",
  errorDetails: "Etwas ist furchtbar schiefgelaufen. Anscheinend ist es nicht Ihre Schuld... oder doch?"
}, I1 = {
  email: "Ungültige E-Mail-Adresse",
  noChangesDetected: "Keine Änderungen erkannt"
}, A1 = {
  addingTeamToWorkspace: "Team zum Arbeitsbereich hinzufügen",
  members: "Mitglieder des Arbeitsbereichs",
  newWorkspaceMember: "Neues Arbeitsbereich-Mitglied hinzufügen",
  noTeamHeadline: "Der Arbeitsbereich wurde erfolgreich erstellt!",
  noTeamTitle: "Noch keine Teams im Arbeitsbereich.",
  noTeamCaption: "Sie können eines der bereits erstellten verwaisten Teams hinzufügen, indem Sie auf die Schaltfläche unten oder das Pluszeichen oben klicken.",
  searchOrphanTeams: "Verwaiste Teams suchen",
  title: "Arbeitsbereichsverwaltung",
  totalMembers: "Gesamtmitglieder",
  workspaceTeams: "Teams im Arbeitsbereich"
}, P1 = {
  add: "Add",
  admin: "Admin",
  allLoaded: "Displaying all items",
  appName: "TailTale",
  basic: "Basic",
  cancel: "Cancel",
  close: "Close",
  create: "Create",
  createWorkspace: "Create Workspace",
  createWorkspaceWhy: "Create a new workspace to group your teams under the same umbrella.",
  goBackHome: "Go back home",
  edit: "Edit",
  error: "Error",
  loadMore: "Load more...",
  login: "Log in",
  logout: "Log out",
  name: "Name",
  none: "None",
  remove: "Remove",
  save: "Save",
  search: "Search",
  selectNone: "Select None",
  selectedTeam: "Selected Team",
  selectedWorkspace: "Selected Workspace",
  teamNameExample: "Product, Sales, etc.",
  tutorialBack: "Back",
  tutorialDone: "Got it",
  tutorialNext: "Next",
  tutorialProgress: "{current} of {total}",
  replayTutorialAria: "Replay tutorial",
  tutorialSkip: "Skip",
  smartGuideHint: "Tip",
  smartGuideDismiss: "Got it",
  update: "Update",
  workspaceNameExample: "Jira, Slack, etc."
}, V1 = {
  welcome: "Welcome",
  beeText1: "Bzz... Do you want me to help you create some tasks?",
  beeText2: "Take a look at the text field bellow. it will give you some hint on how to start",
  beeText3: "Bzzz... I am a busy bee, but I can help you create some tasks",
  errorCreatingTale: "Unexpected error creating a task",
  task: "Task",
  taskExample1: "Cleaning the bathroom",
  taskExample2: "Meal prep",
  taskExample3: "Supermarket run",
  taskExample4: "Laundry"
}, E1 = {
  email: "Email address",
  memberEmail: "Member's email address",
  roles: "Roles"
}, M1 = {
  missingCat: "Missing Cat",
  ifFound1: "If found, please return",
  ifFound2: "to the nearest cat cafe.",
  oops: "Opps! Lost in the woods!",
  error: "404 - Not Found",
  errorDetails: "We searched high and low, but we could not find the page you were looking for."
}, O1 = {
  members: "Members of the team",
  newTeamMember: "Creating new team member",
  title: "Team management",
  totalMembers: "Total members"
}, D1 = {
  oops: "Oops! We've gone in circles!",
  error: "500 - Unexpected Error",
  errorDetails: "Something went terribly wrong. Looks like it's not your fault... or is it?"
}, L1 = {
  email: "Invalid email address",
  noChangesDetected: "No changes detected"
}, N1 = {
  addingTeamToWorkspace: "Adding team to workspace",
  members: "Members of the workspace",
  newWorkspaceMember: "Adding new workspace member",
  noTeamHeadline: "Workspace was created successfully!",
  noTeamTitle: "No teams in the workspace yet.",
  noTeamCaption: "You can add one of the orphaned teams already created by clicking the button below or the plus sign above.",
  searchOrphanTeams: "Search for orphaned teams",
  title: "Workspace management",
  totalMembers: "Total members",
  workspaceTeams: "Teams in the workspace"
}, F1 = {
  create: "Crear",
  tutorialBack: "Atrás",
  tutorialDone: "Entendido",
  tutorialNext: "Siguiente",
  tutorialProgress: "{current} de {total}",
  replayTutorialAria: "Repetir tutorial",
  tutorialSkip: "Omitir",
  smartGuideHint: "Consejo",
  smartGuideDismiss: "Entendido"
}, R1 = {
  welcome: "Bienvenido",
  beeText1: "Bzz... ¿Quieres que te ayude a crear algunas tareas?",
  beeText2: "Echa un vistazo al campo de texto a continuación. te dará una pista sobre cómo empezar",
  beeText3: "Bzzz... Soy una abeja ocupada, pero puedo ayudarte a crear algunas tareas",
  task: "Tarea",
  taskExample1: "Limpiar el baño",
  taskExample2: "Preparación de comidas",
  taskExample3: "Ir al supermercado",
  taskExample4: "Lavar la ropa"
}, $1 = {
  email: "Dirección de correo electrónico",
  memberEmail: "Correo electrónico del miembro",
  roles: "Roles"
}, B1 = {
  missingCat: "Gato desaparecido",
  ifFound1: "Si lo encuentra, por favor devuélvalo",
  ifFound2: "al café de gatos más cercano.",
  oops: "¡Ups! ¡Perdido en el bosque!",
  error: "404 - No encontrado",
  errorDetails: "Buscamos por todas partes, pero no pudimos encontrar la página que estabas buscando."
}, U1 = {
  members: "Miembros del equipo",
  newTeamMember: "Creando nuevo miembro del equipo",
  title: "Gestión de equipo",
  totalMembers: "Total de miembros"
}, W1 = {
  oops: "¡Ups! ¡Estamos dando vueltas en círculos!",
  error: "500 - Error inesperado",
  errorDetails: "Algo salió terriblemente mal. Parece que no es tu culpa... ¿o sí?"
}, H1 = {
  email: "Dirección de correo electrónico inválida",
  noChangesDetected: "No se detectaron cambios"
}, z1 = {
  addingTeamToWorkspace: "Añadiendo equipo al espacio de trabajo",
  members: "Miembros del espacio de trabajo",
  newWorkspaceMember: "Añadiendo nuevo miembro al espacio de trabajo",
  noTeamHeadline: "¡El espacio de trabajo se creó exitosamente!",
  noTeamTitle: "Aún no hay equipos en el espacio de trabajo.",
  noTeamCaption: "Puedes añadir uno de los equipos huérfanos ya creados haciendo clic en el botón de abajo o el signo más de arriba.",
  searchOrphanTeams: "Buscar equipos huérfanos",
  title: "Gestión del espacio de trabajo",
  totalMembers: "Total de miembros",
  workspaceTeams: "Equipos en el espacio de trabajo"
}, j1 = {
  create: "Créer",
  tutorialBack: "Retour",
  tutorialDone: "Compris",
  tutorialNext: "Suivant",
  tutorialProgress: "{current} sur {total}",
  replayTutorialAria: "Relancer le tutoriel",
  tutorialSkip: "Passer",
  smartGuideHint: "Astuce",
  smartGuideDismiss: "Compris"
}, G1 = {
  welcome: "Bienvenue",
  beeText1: "Bzz... Voulez-vous que je vous aide à créer des tâches ?",
  beeText2: "Jetez un œil au champ de texte ci-dessous. il vous donnera quelques indices sur la façon de commencer",
  beeText3: "Bzzz... Je suis une abeille occupée, mais je peux vous aider à créer des tâches",
  task: "Tâche",
  taskExample1: "Nettoyer la salle de bain",
  taskExample2: "Préparation des repas",
  taskExample3: "Course au supermarché",
  taskExample4: "Lessive"
}, q1 = {
  email: "Adresse e-mail",
  memberEmail: "Adresse e-mail du membre",
  roles: "Rôles"
}, Y1 = {
  missingCat: "Chat disparu",
  ifFound1: "Si vous le trouvez, veuillez le ramener",
  ifFound2: "au café à chats le plus proche.",
  oops: "Oups ! Perdu dans la forêt !",
  error: "404 - Page introuvable",
  errorDetails: "Nous avons cherché partout, mais nous n'avons pas pu trouver la page que vous recherchiez."
}, K1 = {
  members: "Membres de l'équipe",
  newTeamMember: "Création d'un nouveau membre d'équipe",
  title: "Gestion de l'équipe",
  totalMembers: "Nombre total de membres"
}, Z1 = {
  oops: "Oups ! Nous tournons en rond !",
  error: "500 - Erreur inattendue",
  errorDetails: "Quelque chose a terriblement mal tourné. Il semble que ce ne soit pas votre faute... ou peut-être que si ?"
}, J1 = {
  email: "Adresse e-mail invalide",
  noChangesDetected: "Aucun changement détecté"
}, X1 = {
  addingTeamToWorkspace: "Ajout d'une équipe à l'espace de travail",
  members: "Membres de l'espace de travail",
  newWorkspaceMember: "Ajout d'un nouveau membre à l'espace de travail",
  noTeamHeadline: "L'espace de travail a été créé avec succès !",
  noTeamTitle: "Aucune équipe dans l'espace de travail pour le moment.",
  noTeamCaption: "Vous pouvez ajouter l'une des équipes orphelines déjà créées en cliquant sur le bouton ci-dessous ou le signe plus ci-dessus.",
  searchOrphanTeams: "Rechercher des équipes orphelines",
  title: "Gestion de l'espace de travail",
  totalMembers: "Nombre total de membres",
  workspaceTeams: "Équipes de l'espace de travail"
}, Q1 = {
  ar: {
    $vuetify: m1,
    general: p1,
    home: w1,
    languageName: "العربية",
    selectLanguage: "اختر اللغة"
  },
  de: {
    $vuetify: h1,
    general: k1,
    home: S1,
    notfound: C1,
    unexpected: T1,
    teamManagement: _1,
    workspaceManagement: A1,
    memberManagement: x1,
    validationError: I1,
    languageName: "Deutsch",
    selectLanguage: "Sprache auswählen"
  },
  en: {
    $vuetify: g1,
    general: P1,
    home: V1,
    notfound: M1,
    unexpected: D1,
    teamManagement: O1,
    workspaceManagement: N1,
    memberManagement: E1,
    validationError: L1,
    languageName: "English",
    selectLanguage: "Select Language"
  },
  es: {
    $vuetify: y1,
    general: F1,
    home: R1,
    notfound: B1,
    unexpected: W1,
    teamManagement: U1,
    workspaceManagement: z1,
    memberManagement: $1,
    validationError: H1,
    languageName: "Español",
    selectLanguage: "Seleccionar idioma"
  },
  fr: {
    $vuetify: b1,
    general: j1,
    home: G1,
    notfound: Y1,
    unexpected: Z1,
    teamManagement: K1,
    workspaceManagement: X1,
    memberManagement: q1,
    validationError: J1,
    languageName: "Français",
    selectLanguage: "Choisir la langue"
  }
}, Jh = "en";
function Xh(e, t) {
  const n = { ...e };
  for (const a in t)
    t[a] instanceof Object && a in e ? n[a] = Xh(e[a], t[a]) : n[a] = t[a];
  return n;
}
function xL(e) {
  const {
    additionalMessages: t = {},
    supportedLanguages: n,
    defaultLanguage: a = Jh
  } = e, r = { ...Q1 };
  return Object.keys(t).forEach((i) => {
    i in r ? r[i] = Xh(r[i], t[i]) : r[i] = t[i];
  }), Xp({
    legacy: !1,
    // Use Composition API
    locale: a,
    fallbackLocale: a,
    messages: r,
    availableLocales: n
    // Set available locales directly
  });
}
function CL(e = ["en", "fr", "de", "es", "ar"]) {
  return ir("language", {
    state: () => ({
      currentLanguage: Jh,
      supportedLanguages: e
    }),
    actions: {
      setLanguage(t) {
        this.supportedLanguages.includes(t) ? this.currentLanguage = t : console.warn(`Language ${t} is not supported`);
      }
    }
  });
}
const sn = {
  connectionReady: "connection_ready",
  shopJoined: "shopJoined",
  joinShopRejected: "joinShopRejected",
  customerJoined: "customerJoined",
  customerLeft: "customerLeft",
  onlineCustomers: "onlineCustomers"
}, _L = {
  joinShop: "joinShop",
  subscribeToShop: "subscribeToShop"
}, TL = {
  missingIcon: "missingIcon",
  invalidIcon: "invalidIcon",
  iconTaken: "iconTaken"
}, e_ = new Set(
  Object.values(sn)
);
function IL(e) {
  return e_.has(e.event);
}
function t_(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = e;
  return typeof t.reason == "string" && typeof t.shopId == "string";
}
function n_(e) {
  return !e || typeof e != "object" ? !1 : typeof e.icon == "string";
}
function Yf(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = e;
  return typeof t.userId == "string" && typeof t.icon == "string" && typeof t.connectedAt == "number";
}
function a_(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = e;
  return typeof t.userId == "string" && typeof t.shopId == "string";
}
function AL(e) {
  switch (e.event) {
    case sn.connectionReady:
      return { event: sn.connectionReady, data: e.data };
    case sn.shopJoined:
      return n_(e.data) ? { event: sn.shopJoined, data: e.data } : null;
    case sn.joinShopRejected:
      return t_(e.data) ? { event: sn.joinShopRejected, data: e.data } : null;
    case sn.customerJoined:
      return Yf(e.data) ? { event: sn.customerJoined, data: e.data } : null;
    case sn.customerLeft:
      return a_(e.data) ? { event: sn.customerLeft, data: e.data } : null;
    case sn.onlineCustomers:
      return Array.isArray(e.data) && e.data.every(Yf) ? { event: sn.onlineCustomers, data: e.data } : null;
    default:
      return null;
  }
}
var r_ = /* @__PURE__ */ ((e) => (e[e.Unauthorized = 4401] = "Unauthorized", e[e.Forbidden = 4403] = "Forbidden", e))(r_ || {});
class PL {
  socket = null;
  url;
  tokenProvider = null;
  reconnectionTimer = null;
  connectionInFlight = !1;
  stopped = !1;
  reconnectAttempts = 0;
  consecutiveAuthFailures = 0;
  initialReconnectDelayMs;
  maxReconnectDelayMs;
  maxAuthFailures;
  maxReconnectAttempts;
  role;
  disableCustomerTtl;
  onMessage = null;
  onOpen = null;
  onClose = null;
  onError = null;
  onReady = null;
  /** Fired when the service permanently gives up reconnecting. */
  onPermanentDisconnect = null;
  /** Fired whenever the next reconnect is scheduled, with attempt count and delay. */
  onReconnectScheduled = null;
  constructor(t, n = {}) {
    this.url = t.replace(/^http/, "ws") + "/ws", this.initialReconnectDelayMs = n.initialReconnectDelayMs ?? 1e3, this.maxReconnectDelayMs = n.maxReconnectDelayMs ?? 3e4, this.maxAuthFailures = n.maxAuthFailures ?? 3, this.maxReconnectAttempts = n.maxReconnectAttempts ?? Number.POSITIVE_INFINITY, this.role = n.role, this.disableCustomerTtl = n.disableCustomerTtl ?? !1;
  }
  /**
   * Begin connecting. The provider is invoked before each (re)connect so the
   * connection always uses a fresh token.
   */
  connect(t) {
    this.tokenProvider = t, this.stopped = !1, this.reconnectAttempts = 0, this.consecutiveAuthFailures = 0, this._setupWebSocket();
  }
  disconnect() {
    if (this.stopped = !0, this.reconnectionTimer && (clearTimeout(this.reconnectionTimer), this.reconnectionTimer = null), this.socket) {
      try {
        this.socket.close();
      } catch {
      }
      this.socket = null;
    }
  }
  send(t, n) {
    const a = { event: t, data: n };
    this.socket?.readyState === WebSocket.OPEN ? this.socket.send(JSON.stringify(a)) : console.error("WebSocket is not open. Cannot send message.");
  }
  sendShopMessage(t, n) {
    this.send(t, n);
  }
  async _setupWebSocket() {
    if (this.stopped || this.connectionInFlight) return;
    if (!this.tokenProvider) {
      console.error("No token provider configured. Cannot establish WebSocket connection.");
      return;
    }
    this.connectionInFlight = !0;
    let t;
    try {
      t = await this.tokenProvider();
    } catch (a) {
      console.error("Token provider threw while preparing WebSocket connection:", a);
    } finally {
      this.connectionInFlight = !1;
    }
    if (this.stopped) return;
    if (!t) {
      console.error("Token provider returned no token. Scheduling reconnect."), this._scheduleReconnect();
      return;
    }
    let n;
    try {
      let a = `${this.url}?token=${encodeURIComponent(t)}`;
      this.role && (a += `&role=${encodeURIComponent(this.role)}`), this.disableCustomerTtl && (a += "&disableCustomerTtl=true"), n = new WebSocket(a);
    } catch (a) {
      console.error("Failed to construct WebSocket:", a), this._scheduleReconnect();
      return;
    }
    this.socket = n, n.onopen = () => {
      console.log("WebSocket connection established"), this.onOpen && this.onOpen();
    }, n.onmessage = (a) => {
      try {
        const r = JSON.parse(a.data);
        if (r.event === sn.connectionReady) {
          this.reconnectAttempts = 0, this.consecutiveAuthFailures = 0, this.onReady && this.onReady();
          return;
        }
        this.onMessage && this.onMessage(r);
      } catch (r) {
        console.error("Error parsing WebSocket message:", r);
      }
    }, n.onerror = (a) => {
      console.error("WebSocket error:", a), this.onError && this.onError(a);
    }, n.onclose = (a) => {
      if (console.log(
        `WebSocket connection closed (code=${a.code}, reason=${a.reason || "n/a"})`
      ), this.socket === n && (this.socket = null), this.onClose && this.onClose(a), this.stopped) return;
      const r = a.code === 4401 || a.code === 4403;
      if (a.code === 4403) {
        console.error("WebSocket closed with Forbidden (4403); not reconnecting."), this.stopped = !0, this.onPermanentDisconnect && this.onPermanentDisconnect("auth");
        return;
      }
      if (r && (this.consecutiveAuthFailures += 1, this.consecutiveAuthFailures >= this.maxAuthFailures)) {
        console.error(
          `Giving up WebSocket reconnects after ${this.consecutiveAuthFailures} consecutive auth failures.`
        ), this.stopped = !0, this.onPermanentDisconnect && this.onPermanentDisconnect("auth");
        return;
      }
      this._scheduleReconnect();
    };
  }
  _scheduleReconnect() {
    if (this.stopped) return;
    if (this.reconnectAttempts >= this.maxReconnectAttempts) {
      console.error("Max WebSocket reconnect attempts reached, giving up."), this.stopped = !0, this.onPermanentDisconnect && this.onPermanentDisconnect("maxAttempts");
      return;
    }
    this.reconnectAttempts += 1;
    const t = Math.min(
      this.maxReconnectDelayMs,
      this.initialReconnectDelayMs * Math.pow(2, this.reconnectAttempts - 1)
    ), n = Math.floor(t / 2 + Math.random() * (t / 2));
    console.log(
      `Scheduling WebSocket reconnect attempt #${this.reconnectAttempts} in ${n}ms`
    ), this.onReconnectScheduled && this.onReconnectScheduled(this.reconnectAttempts, n), this.reconnectionTimer && clearTimeout(this.reconnectionTimer), this.reconnectionTimer = setTimeout(() => {
      this.reconnectionTimer = null, this._setupWebSocket();
    }, n);
  }
}
function U(e, t) {
  return (n) => Object.keys(e).reduce((a, r) => {
    const i = typeof e[r] == "object" && e[r] != null && !Array.isArray(e[r]) ? e[r] : {
      type: e[r]
    };
    return n && r in n ? a[r] = {
      ...i,
      default: n[r]
    } : a[r] = i, t && !a[r].source && (a[r].source = t), a;
  }, {});
}
const ve = U({
  class: [String, Array, Object],
  style: {
    type: [String, Array, Object],
    default: null
  }
}, "component");
function jt(e) {
  go(`Vuetify: ${e}`);
}
function ni(e) {
  go(`Vuetify error: ${e}`);
}
function l_(e, t) {
  t = Array.isArray(t) ? t.slice(0, -1).map((n) => `'${n}'`).join(", ") + ` or '${t.at(-1)}'` : `'${t}'`, go(`[Vuetify UPGRADE] '${e}' is deprecated, use ${t} instead.`);
}
const wt = typeof window < "u", kc = wt && "IntersectionObserver" in window, Kf = wt && "EyeDropper" in window, Qh = wt && "matchMedia" in window && typeof window.matchMedia == "function", Gn = () => Qh && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
function Zf(e, t, n) {
  i_(e, t), t.set(e, n);
}
function i_(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Jf(e, t, n) {
  return e.set(eg(e, t), n), n;
}
function na(e, t) {
  return e.get(eg(e, t));
}
function eg(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function tg(e, t, n) {
  const a = t.length - 1;
  if (a < 0) return e === void 0 ? n : e;
  for (let r = 0; r < a; r++) {
    if (e == null)
      return n;
    e = e[t[r]];
  }
  return e == null || e[t[a]] === void 0 ? n : e[t[a]];
}
function Ml(e, t, n) {
  return e == null || !t || typeof t != "string" ? n : e[t] !== void 0 ? e[t] : (t = t.replace(/\[(\w+)\]/g, ".$1"), t = t.replace(/^\./, ""), tg(e, t.split("."), n));
}
function pt(e, t, n) {
  if (t === !0) return e === void 0 ? n : e;
  if (t == null || typeof t == "boolean") return n;
  if (e !== Object(e)) {
    if (typeof t != "function") return n;
    const r = t(e, n);
    return typeof r > "u" ? n : r;
  }
  if (typeof t == "string") return Ml(e, t, n);
  if (Array.isArray(t)) return tg(e, t, n);
  if (typeof t != "function") return n;
  const a = t(e, n);
  return typeof a > "u" ? n : a;
}
function ka(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return Array.from({
    length: e
  }, (n, a) => t + a);
}
function re(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "px";
  if (e == null || e === "")
    return;
  const n = Number(e);
  return isNaN(n) ? String(e) : isFinite(n) ? `${n}${t}` : void 0;
}
function Qa(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function ru(e) {
  let t;
  return e !== null && typeof e == "object" && ((t = Object.getPrototypeOf(e)) === Object.prototype || t === null);
}
function Sc(e) {
  if (e && "$el" in e) {
    const t = e.$el;
    return t?.nodeType === Node.TEXT_NODE ? t.nextElementSibling : t;
  }
  return e;
}
const lu = Object.freeze({
  enter: "Enter",
  tab: "Tab",
  delete: "Delete",
  esc: "Escape",
  space: "Space",
  up: "ArrowUp",
  down: "ArrowDown",
  left: "ArrowLeft",
  right: "ArrowRight",
  end: "End",
  home: "Home",
  del: "Delete",
  backspace: "Backspace",
  insert: "Insert",
  pageup: "PageUp",
  pagedown: "PageDown",
  shift: "Shift"
});
function ng(e) {
  return Object.keys(e);
}
function ja(e, t) {
  return t.every((n) => e.hasOwnProperty(n));
}
function an(e, t) {
  const n = {};
  for (const a of t)
    Object.prototype.hasOwnProperty.call(e, a) && (n[a] = e[a]);
  return n;
}
function iu(e, t, n) {
  const a = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  for (const l in e)
    t.some((i) => i instanceof RegExp ? i.test(l) : i === l) ? a[l] = e[l] : r[l] = e[l];
  return [a, r];
}
function Pe(e, t) {
  const n = {
    ...e
  };
  return t.forEach((a) => delete n[a]), n;
}
const ag = /^on[^a-z]/, xc = (e) => ag.test(e), o_ = ["onAfterscriptexecute", "onAnimationcancel", "onAnimationend", "onAnimationiteration", "onAnimationstart", "onAuxclick", "onBeforeinput", "onBeforescriptexecute", "onChange", "onClick", "onCompositionend", "onCompositionstart", "onCompositionupdate", "onContextmenu", "onCopy", "onCut", "onDblclick", "onFocusin", "onFocusout", "onFullscreenchange", "onFullscreenerror", "onGesturechange", "onGestureend", "onGesturestart", "onGotpointercapture", "onInput", "onKeydown", "onKeypress", "onKeyup", "onLostpointercapture", "onMousedown", "onMousemove", "onMouseout", "onMouseover", "onMouseup", "onMousewheel", "onPaste", "onPointercancel", "onPointerdown", "onPointerenter", "onPointerleave", "onPointermove", "onPointerout", "onPointerover", "onPointerup", "onReset", "onSelect", "onSubmit", "onTouchcancel", "onTouchend", "onTouchmove", "onTouchstart", "onTransitioncancel", "onTransitionend", "onTransitionrun", "onTransitionstart", "onWheel"], s_ = ["ArrowUp", "ArrowDown", "ArrowRight", "ArrowLeft", "Enter", "Escape", "Tab", " "];
function u_(e) {
  return e.isComposing && s_.includes(e.key);
}
function Jn(e) {
  const [t, n] = iu(e, [ag]), a = Pe(t, o_), [r, l] = iu(n, ["class", "style", "id", "inert", /^data-/]);
  return Object.assign(r, t), Object.assign(l, a), [r, l];
}
function rt(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function rg(e, t) {
  let n = 0;
  const a = function() {
    for (var r = arguments.length, l = new Array(r), i = 0; i < r; i++)
      l[i] = arguments[i];
    clearTimeout(n), n = setTimeout(() => e(...l), Z(t));
  };
  return a.clear = () => {
    clearTimeout(n);
  }, a.immediate = e, a;
}
function Xe(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return Math.max(t, Math.min(n, e));
}
function Xf(e) {
  const t = e.toString().trim();
  return t.includes(".") ? t.length - t.indexOf(".") - 1 : 0;
}
function Qf(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
  return e + n.repeat(Math.max(0, t - e.length));
}
function c_(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  const n = [];
  let a = 0;
  for (; a < e.length; )
    n.push(e.substr(a, t)), a += t;
  return n;
}
function ev(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e3;
  if (e < t)
    return `${e} B`;
  const n = t === 1024 ? ["Ki", "Mi", "Gi"] : ["k", "M", "G"];
  let a = -1;
  for (; Math.abs(e) >= t && a < n.length - 1; )
    e /= t, ++a;
  return `${e.toFixed(1)} ${n[a]}B`;
}
function jn() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
  const a = {};
  for (const r in e)
    a[r] = e[r];
  for (const r in t) {
    const l = e[r], i = t[r];
    if (ru(l) && ru(i)) {
      a[r] = jn(l, i, n);
      continue;
    }
    if (n && Array.isArray(l) && Array.isArray(i)) {
      a[r] = n(l, i);
      continue;
    }
    a[r] = i;
  }
  return a;
}
function lg(e) {
  return e.map((t) => t.type === fe ? lg(t.children) : t).flat();
}
function Ya() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  if (Ya.cache.has(e)) return Ya.cache.get(e);
  const t = e.replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase();
  return Ya.cache.set(e, t), t;
}
Ya.cache = /* @__PURE__ */ new Map();
function Mr(e, t) {
  if (!t || typeof t != "object") return [];
  if (Array.isArray(t))
    return t.map((n) => Mr(e, n)).flat(1);
  if (t.suspense)
    return Mr(e, t.ssContent);
  if (Array.isArray(t.children))
    return t.children.map((n) => Mr(e, n)).flat(1);
  if (t.component) {
    if (Object.getOwnPropertyDescriptor(t.component.provides, e))
      return [t.component];
    if (t.component.subTree)
      return Mr(e, t.component.subTree).flat(1);
  }
  return [];
}
var Tr = /* @__PURE__ */ new WeakMap(), Ba = /* @__PURE__ */ new WeakMap();
class ig {
  constructor(t) {
    Zf(this, Tr, []), Zf(this, Ba, 0), this.size = t;
  }
  get isFull() {
    return na(Tr, this).length === this.size;
  }
  push(t) {
    na(Tr, this)[na(Ba, this)] = t, Jf(Ba, this, (na(Ba, this) + 1) % this.size);
  }
  values() {
    return na(Tr, this).slice(na(Ba, this)).concat(na(Tr, this).slice(0, na(Ba, this)));
  }
  clear() {
    na(Tr, this).length = 0, Jf(Ba, this, 0);
  }
}
function d_(e) {
  return "touches" in e ? {
    clientX: e.touches[0].clientX,
    clientY: e.touches[0].clientY
  } : {
    clientX: e.clientX,
    clientY: e.clientY
  };
}
function Cc(e) {
  const t = cn({});
  ft(() => {
    const a = e();
    for (const r in a)
      t[r] = a[r];
  }, {
    flush: "sync"
  });
  const n = {};
  for (const a in t)
    n[a] = D(() => t[a]);
  return n;
}
function ro(e, t) {
  return e.includes(t);
}
function og(e) {
  return e[2].toLowerCase() + e.slice(3);
}
const Ut = () => [Function, Array];
function tv(e, t) {
  return t = "on" + Zr(t), !!(e[t] || e[`${t}Once`] || e[`${t}Capture`] || e[`${t}OnceCapture`] || e[`${t}CaptureOnce`]);
}
function ai(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  if (Array.isArray(e))
    for (const r of e)
      r(...n);
  else typeof e == "function" && e(...n);
}
function xa(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  const n = ["button", "[href]", 'input:not([type="hidden"])', "select", "textarea", "details:not(:has(> summary))", "details > summary", "[tabindex]", '[contenteditable]:not([contenteditable="false"])', "audio[controls]", "video[controls]"].map((r) => `${r}${t ? ':not([tabindex="-1"])' : ""}:not([disabled], [inert])`).join(", ");
  let a;
  try {
    a = [...e.querySelectorAll(n)];
  } catch (r) {
    return ni(String(r)), [];
  }
  return a.filter((r) => !r.closest("[inert]")).filter((r) => !!r.offsetParent || r.getClientRects().length > 0).filter((r) => !r.parentElement?.closest("details:not([open])") || r.tagName === "SUMMARY" && r.parentElement?.tagName === "DETAILS");
}
function sg(e, t, n) {
  let a, r = e.indexOf(document.activeElement);
  const l = t === "next" ? 1 : -1;
  do
    r += l, a = e[r];
  while ((!a || a.offsetParent == null || !(n?.(a) ?? !0)) && r < e.length && r >= 0);
  return a;
}
function Ka(e, t) {
  const n = xa(e);
  if (t == null)
    (e === document.activeElement || !e.contains(document.activeElement)) && n[0]?.focus();
  else if (t === "first")
    n[0]?.focus();
  else if (t === "last")
    n.at(-1)?.focus();
  else if (typeof t == "number")
    n[t]?.focus();
  else {
    const a = sg(n, t);
    a ? a.focus() : Ka(e, t === "next" ? "first" : "last");
  }
}
function kl(e) {
  return e == null || typeof e == "string" && e.trim() === "";
}
function Do() {
}
function Hr(e, t) {
  if (!(wt && typeof CSS < "u" && typeof CSS.supports < "u" && CSS.supports(`selector(${t})`))) return null;
  try {
    return !!e && e.matches(t);
  } catch {
    return null;
  }
}
function Lo(e) {
  return e.some((t) => Wp(t) ? t.type === Hp ? !1 : t.type !== fe || Lo(t.children) : !0) ? e : null;
}
function Mi(e, t, n) {
  return e?.(t) ?? n?.(t);
}
function f_(e, t) {
  if (!wt || e === 0)
    return t(), () => {
    };
  const n = window.setTimeout(t, e);
  return () => window.clearTimeout(n);
}
function v_(e, t) {
  const n = e.clientX, a = e.clientY, r = t.getBoundingClientRect(), l = r.left, i = r.top, o = r.right, s = r.bottom;
  return n >= l && n <= o && a >= i && a <= s;
}
function Ol() {
  const e = ae(), t = (n) => {
    e.value = n;
  };
  return Object.defineProperty(t, "value", {
    enumerable: !0,
    get: () => e.value,
    set: (n) => e.value = n
  }), Object.defineProperty(t, "el", {
    enumerable: !0,
    get: () => Sc(e.value)
  }), t;
}
function zr(e) {
  const t = e.key.length === 1, n = !e.ctrlKey && !e.metaKey && !e.altKey;
  return t && n;
}
function Ta(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "bigint";
}
function lo(e) {
  return "\\^$*+?.()|{}[]".includes(e) ? `\\${e}` : e;
}
function m_(e, t, n) {
  const a = new RegExp(`[\\d\\-${lo(n)}]`), r = e.split("").filter((i) => a.test(i)).filter((i, o, s) => o === 0 && /[-]/.test(i) || // sign allowed at the start
  i === n && o === s.indexOf(i) || // decimal separator allowed only once
  /\d/.test(i)).join("");
  if (t === 0)
    return r.split(n)[0];
  const l = new RegExp(`${lo(n)}\\d`);
  if (t !== null && l.test(r)) {
    const i = r.split(n);
    return [i[0], i[1].substring(0, t)].join(n);
  }
  return r;
}
function h_(e) {
  const t = {};
  for (const n in e)
    t[im(n)] = e[n];
  return t;
}
function g_(e) {
  const t = ["checked", "disabled"];
  return Object.fromEntries(Object.entries(e).filter((n) => {
    let [a, r] = n;
    return t.includes(a) ? !!r : r !== void 0;
  }));
}
function nv(e) {
  const t = (n) => Array.isArray(n) ? n.map((a) => t(a)) : qi(n) || Bp(n) || Up(n) ? t(it(n)) : ru(n) ? Object.keys(n).reduce((a, r) => (a[r] = t(n[r]), a), {}) : n;
  return t(e);
}
const ug = ["top", "bottom"], y_ = ["start", "end", "left", "right"];
function ou(e, t) {
  let [n, a] = e.split(" ");
  return a || (a = ro(ug, n) ? "start" : ro(y_, n) ? "top" : "center"), {
    side: su(n, t),
    align: su(a, t)
  };
}
function su(e, t) {
  return e === "start" ? t ? "right" : "left" : e === "end" ? t ? "left" : "right" : e;
}
function _s(e) {
  return {
    side: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.side],
    align: e.align
  };
}
function Ts(e) {
  return {
    side: e.side,
    align: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.align]
  };
}
function av(e) {
  return {
    side: e.align,
    align: e.side
  };
}
function rv(e) {
  return ro(ug, e.side) ? "y" : "x";
}
class Pn {
  constructor(t) {
    const n = document.body.currentCSSZoom ?? 1, a = t instanceof Element, r = a ? 1 + (1 - n) / n : 1, {
      x: l,
      y: i,
      width: o,
      height: s
    } = a ? t.getBoundingClientRect() : t;
    this.x = l * r, this.y = i * r, this.width = o * r, this.height = s * r;
  }
  get top() {
    return this.y;
  }
  get bottom() {
    return this.y + this.height;
  }
  get left() {
    return this.x;
  }
  get right() {
    return this.x + this.width;
  }
}
function lv(e, t) {
  return {
    x: {
      before: Math.max(0, t.left - e.left),
      after: Math.max(0, e.right - t.right)
    },
    y: {
      before: Math.max(0, t.top - e.top),
      after: Math.max(0, e.bottom - t.bottom)
    }
  };
}
function cg(e) {
  if (Array.isArray(e)) {
    const t = document.body.currentCSSZoom ?? 1, n = 1 + (1 - t) / t;
    return new Pn({
      x: e[0] * n,
      y: e[1] * n,
      width: 0 * n,
      height: 0 * n
    });
  } else
    return new Pn(e);
}
function b_(e) {
  if (e === document.documentElement)
    if (visualViewport) {
      const t = document.body.currentCSSZoom ?? 1;
      return new Pn({
        x: visualViewport.scale > 1 ? 0 : visualViewport.offsetLeft,
        y: visualViewport.scale > 1 ? 0 : visualViewport.offsetTop,
        width: visualViewport.width * visualViewport.scale / t,
        height: visualViewport.height * visualViewport.scale / t
      });
    } else
      return new Pn({
        x: 0,
        y: 0,
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight
      });
  else
    return new Pn(e);
}
function _c(e) {
  const t = new Pn(e), n = getComputedStyle(e), a = n.transform;
  if (a) {
    let r, l, i, o, s;
    if (a.startsWith("matrix3d("))
      r = a.slice(9, -1).split(/, /), l = Number(r[0]), i = Number(r[5]), o = Number(r[12]), s = Number(r[13]);
    else if (a.startsWith("matrix("))
      r = a.slice(7, -1).split(/, /), l = Number(r[0]), i = Number(r[3]), o = Number(r[4]), s = Number(r[5]);
    else
      return new Pn(t);
    const u = n.transformOrigin, c = t.x - o - (1 - l) * parseFloat(u), d = t.y - s - (1 - i) * parseFloat(u.slice(u.indexOf(" ") + 1)), f = l ? t.width / l : e.offsetWidth + 1, v = i ? t.height / i : e.offsetHeight + 1;
    return new Pn({
      x: c,
      y: d,
      width: f,
      height: v
    });
  } else
    return new Pn(t);
}
function aa(e, t, n) {
  if (typeof e.animate > "u") return {
    finished: Promise.resolve()
  };
  let a;
  try {
    a = e.animate(t, n);
  } catch {
    return {
      finished: Promise.resolve()
    };
  }
  return typeof a.finished > "u" && (a.finished = new Promise((r) => {
    a.onfinish = () => {
      r(a);
    };
  })), a;
}
const zi = /* @__PURE__ */ new WeakMap();
function p_(e, t) {
  Object.keys(t).forEach((n) => {
    if (xc(n)) {
      const a = og(n), r = zi.get(e);
      if (t[n] == null)
        r?.forEach((l) => {
          const [i, o] = l;
          i === a && (e.removeEventListener(a, o), r.delete(l));
        });
      else if (!r || ![...r].some((l) => l[0] === a && l[1] === t[n])) {
        e.addEventListener(a, t[n]);
        const l = r || /* @__PURE__ */ new Set();
        l.add([a, t[n]]), zi.has(e) || zi.set(e, l);
      }
    } else
      t[n] == null ? e.removeAttribute(n) : e.setAttribute(n, t[n]);
  });
}
function w_(e, t) {
  Object.keys(t).forEach((n) => {
    if (xc(n)) {
      const a = og(n), r = zi.get(e);
      r?.forEach((l) => {
        const [i, o] = l;
        i === a && (e.removeEventListener(a, o), r.delete(l));
      });
    } else
      e.removeAttribute(n);
  });
}
const Ir = 2.4, iv = 0.2126729, ov = 0.7151522, sv = 0.072175, k_ = 0.55, S_ = 0.58, x_ = 0.57, C_ = 0.62, Oi = 0.03, uv = 1.45, __ = 5e-4, T_ = 1.25, I_ = 1.25, cv = 0.078, dv = 12.82051282051282, Di = 0.06, fv = 1e-3;
function vv(e, t) {
  const n = (e.r / 255) ** Ir, a = (e.g / 255) ** Ir, r = (e.b / 255) ** Ir, l = (t.r / 255) ** Ir, i = (t.g / 255) ** Ir, o = (t.b / 255) ** Ir;
  let s = n * iv + a * ov + r * sv, u = l * iv + i * ov + o * sv;
  if (s <= Oi && (s += (Oi - s) ** uv), u <= Oi && (u += (Oi - u) ** uv), Math.abs(u - s) < __) return 0;
  let c;
  if (u > s) {
    const d = (u ** k_ - s ** S_) * T_;
    c = d < fv ? 0 : d < cv ? d - d * dv * Di : d - Di;
  } else {
    const d = (u ** C_ - s ** x_) * I_;
    c = d > -fv ? 0 : d > -cv ? d - d * dv * Di : d + Di;
  }
  return c * 100;
}
const A_ = [[0.4124, 0.3576, 0.1805], [0.2126, 0.7152, 0.0722], [0.0193, 0.1192, 0.9505]], P_ = (e) => e <= 0.04045 ? e / 12.92 : ((e + 0.055) / 1.055) ** 2.4;
function V_(e) {
  let {
    r: t,
    g: n,
    b: a
  } = e;
  const r = [0, 0, 0], l = P_, i = A_;
  t = l(t / 255), n = l(n / 255), a = l(a / 255);
  for (let o = 0; o < 3; ++o)
    r[o] = i[o][0] * t + i[o][1] * n + i[o][2] * a;
  return r;
}
function uu(e) {
  return !!e && /^(#|var\(--|(rgb|hsl)a?\()/.test(e);
}
function E_(e) {
  return uu(e) && !/^((rgb|hsl)a?\()?var\(--/.test(e);
}
const mv = /^(?<fn>(?:rgb|hsl)a?)\((?<values>.+)\)/, M_ = {
  rgb: (e, t, n, a) => ({
    r: e,
    g: t,
    b: n,
    a
  }),
  rgba: (e, t, n, a) => ({
    r: e,
    g: t,
    b: n,
    a
  }),
  hsl: (e, t, n, a) => hv({
    h: e,
    s: t,
    l: n,
    a
  }),
  hsla: (e, t, n, a) => hv({
    h: e,
    s: t,
    l: n,
    a
  }),
  hsv: (e, t, n, a) => qn({
    h: e,
    s: t,
    v: n,
    a
  }),
  hsva: (e, t, n, a) => qn({
    h: e,
    s: t,
    v: n,
    a
  })
};
function ra(e) {
  if (typeof e == "number")
    return (isNaN(e) || e < 0 || e > 16777215) && jt(`'${e}' is not a valid hex color`), {
      r: (e & 16711680) >> 16,
      g: (e & 65280) >> 8,
      b: e & 255
    };
  if (typeof e == "string" && mv.test(e)) {
    const {
      groups: t
    } = e.match(mv), {
      fn: n,
      values: a
    } = t, r = a.split(/,\s*|\s*\/\s*|\s+/).map((l, i) => l.endsWith("%") || // unitless slv are %
    i > 0 && i < 3 && ["hsl", "hsla", "hsv", "hsva"].includes(n) ? parseFloat(l) / 100 : parseFloat(l));
    return M_[n](...r);
  } else if (typeof e == "string") {
    let t = e.startsWith("#") ? e.slice(1) : e;
    [3, 4].includes(t.length) ? t = t.split("").map((a) => a + a).join("") : [6, 8].includes(t.length) || jt(`'${e}' is not a valid hex(a) color`);
    const n = parseInt(t, 16);
    return (isNaN(n) || n < 0 || n > 4294967295) && jt(`'${e}' is not a valid hex(a) color`), vg(t);
  } else if (typeof e == "object") {
    if (ja(e, ["r", "g", "b"]))
      return e;
    if (ja(e, ["h", "s", "l"]))
      return qn(Tc(e));
    if (ja(e, ["h", "s", "v"]))
      return qn(e);
  }
  throw new TypeError(`Invalid color: ${e == null ? e : String(e) || e.constructor.name}
Expected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number`);
}
function qn(e) {
  const {
    h: t,
    s: n,
    v: a,
    a: r
  } = e, l = (o) => {
    const s = (o + t / 60) % 6;
    return a - a * n * Math.max(Math.min(s, 4 - s, 1), 0);
  }, i = [l(5), l(3), l(1)].map((o) => Math.round(o * 255));
  return {
    r: i[0],
    g: i[1],
    b: i[2],
    a: r
  };
}
function hv(e) {
  return qn(Tc(e));
}
function ri(e) {
  if (!e) return {
    h: 0,
    s: 1,
    v: 1,
    a: 1
  };
  const t = e.r / 255, n = e.g / 255, a = e.b / 255, r = Math.max(t, n, a), l = Math.min(t, n, a);
  let i = 0;
  r !== l && (r === t ? i = 60 * (0 + (n - a) / (r - l)) : r === n ? i = 60 * (2 + (a - t) / (r - l)) : r === a && (i = 60 * (4 + (t - n) / (r - l)))), i < 0 && (i = i + 360);
  const o = r === 0 ? 0 : (r - l) / r, s = [i, o, r];
  return {
    h: s[0],
    s: s[1],
    v: s[2],
    a: e.a
  };
}
function cu(e) {
  const {
    h: t,
    s: n,
    v: a,
    a: r
  } = e, l = a - a * n / 2, i = l === 1 || l === 0 ? 0 : (a - l) / Math.min(l, 1 - l);
  return {
    h: t,
    s: i,
    l,
    a: r
  };
}
function Tc(e) {
  const {
    h: t,
    s: n,
    l: a,
    a: r
  } = e, l = a + n * Math.min(a, 1 - a), i = l === 0 ? 0 : 2 - 2 * a / l;
  return {
    h: t,
    s: i,
    v: l,
    a: r
  };
}
function dg(e) {
  let {
    r: t,
    g: n,
    b: a,
    a: r
  } = e;
  return r === void 0 ? `rgb(${t}, ${n}, ${a})` : `rgba(${t}, ${n}, ${a}, ${r})`;
}
function fg(e) {
  return dg(qn(e));
}
function Li(e) {
  const t = Math.round(e).toString(16);
  return ("00".substr(0, 2 - t.length) + t).toUpperCase();
}
function O_(e) {
  let {
    r: t,
    g: n,
    b: a,
    a: r
  } = e;
  return `#${[Li(t), Li(n), Li(a), r !== void 0 ? Li(Math.round(r * 255)) : ""].join("")}`;
}
function vg(e) {
  e = L_(e);
  let [t, n, a, r] = c_(e, 2).map((l) => parseInt(l, 16));
  return r = r === void 0 ? r : r / 255, {
    r: t,
    g: n,
    b: a,
    a: r
  };
}
function D_(e) {
  const t = vg(e);
  return ri(t);
}
function mg(e) {
  return O_(qn(e));
}
function L_(e) {
  return e.startsWith("#") && (e = e.slice(1)), e = e.replace(/([^0-9a-f])/gi, "F"), (e.length === 3 || e.length === 4) && (e = e.split("").map((t) => t + t).join("")), e.length !== 6 && (e = Qf(Qf(e, 6), 8, "F")), e;
}
function gv(e) {
  const t = ra(e);
  return V_(t)[1];
}
function N_(e, t) {
  const n = gv(e), a = gv(t), r = Math.max(n, a), l = Math.min(n, a);
  return (r + 0.05) / (l + 0.05);
}
function F_(e) {
  const t = Math.abs(vv(ra(0), ra(e)));
  return Math.abs(vv(ra(16777215), ra(e))) > Math.min(t, 50) ? "#fff" : "#000";
}
function kt(e, t) {
  const n = zp();
  if (!n)
    throw new Error(`[Vuetify] ${e} must be called from inside a setup function`);
  return n;
}
function Xn() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "composables";
  const t = kt(e).type;
  return Ya(t?.aliasName || t?.name);
}
function R_(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : kt("injectSelf");
  const {
    provides: n
  } = t;
  if (n && e in n)
    return n[e];
}
const io = /* @__PURE__ */ Symbol.for("vuetify:defaults");
function Ic() {
  const e = Le(io);
  if (!e) throw new Error("[Vuetify] Could not find defaults instance");
  return e;
}
function vt(e, t) {
  const n = Ic(), a = G(e), r = T(() => {
    if (Z(t?.disabled)) return n.value;
    const i = Z(t?.scoped), o = Z(t?.reset), s = Z(t?.root);
    if (a.value == null && !(i || o || s)) return n.value;
    let u = jn(a.value, {
      prev: n.value
    });
    if (i) return u;
    if (o || s) {
      const c = Number(o || 1 / 0);
      for (let d = 0; d <= c && !(!u || !("prev" in u)); d++)
        u = u.prev;
      return u && typeof s == "string" && s in u && (u = jn(jn(u, {
        prev: u
      }), u[s])), u;
    }
    return u.prev ? jn(u.prev, u) : u;
  });
  return st(io, r), r;
}
function $_(e, t) {
  return e.props && (typeof e.props[t] < "u" || typeof e.props[Ya(t)] < "u");
}
function B_() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ic();
  const a = kt("useDefaults");
  if (t = t ?? a.type.name ?? a.type.__name, !t)
    throw new Error("[Vuetify] Could not determine component name");
  const r = T(() => n.value?.[e._as ?? t]), l = new Proxy(e, {
    get(s, u) {
      const c = Reflect.get(s, u);
      if (u === "class" || u === "style")
        return [r.value?.[u], c].filter((v) => v != null);
      if ($_(a.vnode, u)) return c;
      const d = r.value?.[u];
      if (d !== void 0) return d;
      const f = n.value?.global?.[u];
      return f !== void 0 ? f : c;
    }
  }), i = ae();
  ft(() => {
    if (r.value) {
      const s = Object.entries(r.value).filter((u) => {
        let [c] = u;
        return c.startsWith(c[0].toUpperCase());
      });
      i.value = s.length ? Object.fromEntries(s) : void 0;
    } else
      i.value = void 0;
  });
  function o() {
    const s = R_(io, a);
    st(io, T(() => i.value ? jn(s?.value ?? {}, i.value) : s?.value));
  }
  return {
    props: l,
    provideSubDefaults: o
  };
}
function rn(e) {
  if (e._setup = e._setup ?? e.setup, !e.name)
    return jt("The component is missing an explicit name, unable to generate default prop value"), e;
  if (e._setup) {
    e.props = U(e.props ?? {}, e.name)();
    const t = Object.keys(e.props).filter((n) => n !== "class" && n !== "style");
    e.filterProps = function(a) {
      return an(a, t);
    }, e.props._as = String, e.setup = function(a, r) {
      const l = Ic();
      if (!l.value) return e._setup(a, r);
      const {
        props: i,
        provideSubDefaults: o
      } = B_(a, a._as ?? e.name, l), s = e._setup(i, r);
      return o(), s;
    };
  }
  return e;
}
function K() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  return (t) => (e ? rn : Qt)(t);
}
function U_(e, t) {
  return t.props = e, t;
}
function ca(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "div", n = arguments.length > 2 ? arguments[2] : void 0;
  return K()({
    name: n ?? Zr(im(e.replace(/__/g, "-"))),
    props: {
      tag: {
        type: String,
        default: t
      },
      ...ve()
    },
    setup(a, r) {
      let {
        slots: l
      } = r;
      return () => Oa(a.tag, {
        class: [e, a.class],
        style: a.style
      }, l.default?.());
    }
  });
}
function W_(e, t, n, a) {
  if (!n || Ta(e) || Ta(t)) return;
  const r = n.get(e);
  if (r)
    r.set(t, a);
  else {
    const l = /* @__PURE__ */ new WeakMap();
    l.set(t, a), n.set(e, l);
  }
}
function H_(e, t, n) {
  if (!n || Ta(e) || Ta(t)) return null;
  const a = n.get(e)?.get(t);
  if (typeof a == "boolean") return a;
  const r = n.get(t)?.get(e);
  return typeof r == "boolean" ? r : null;
}
function Lt(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : /* @__PURE__ */ new WeakMap();
  if (e === t) return !0;
  if (e instanceof Date && t instanceof Date && e.getTime() !== t.getTime() || e !== Object(e) || t !== Object(t))
    return !1;
  const a = Object.keys(e);
  if (a.length !== Object.keys(t).length)
    return !1;
  const r = H_(e, t, n);
  return r || (W_(e, t, n, !0), a.every((l) => Lt(e[l], t[l], n)));
}
function hg(e) {
  if (typeof e.getRootNode != "function") {
    for (; e.parentNode; ) e = e.parentNode;
    return e !== document ? null : document;
  }
  const t = e.getRootNode();
  return t !== document && t.getRootNode({
    composed: !0
  }) !== document ? null : t;
}
const Dl = "cubic-bezier(0.4, 0, 0.2, 1)", yv = "cubic-bezier(0.0, 0, 0.2, 1)", bv = "cubic-bezier(0.4, 0, 1, 1)", z_ = {
  linear: (e) => e,
  easeInQuad: (e) => e ** 2,
  easeOutQuad: (e) => e * (2 - e),
  easeInOutQuad: (e) => e < 0.5 ? 2 * e ** 2 : -1 + (4 - 2 * e) * e,
  easeInCubic: (e) => e ** 3,
  easeOutCubic: (e) => --e ** 3 + 1,
  easeInOutCubic: (e) => e < 0.5 ? 4 * e ** 3 : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1,
  easeInQuart: (e) => e ** 4,
  easeOutQuart: (e) => 1 - --e ** 4,
  easeInOutQuart: (e) => e < 0.5 ? 8 * e ** 4 : 1 - 8 * --e ** 4,
  easeInQuint: (e) => e ** 5,
  easeOutQuint: (e) => 1 + --e ** 5,
  easeInOutQuint: (e) => e < 0.5 ? 16 * e ** 5 : 1 + 16 * --e ** 5,
  instant: (e) => 1
};
function bn(e, t, n) {
  return Object.keys(e).filter((a) => xc(a) && a.endsWith(t)).reduce((a, r) => (a[r.slice(0, -t.length)] = (l) => ai(e[r], l, n(l)), a), {});
}
function No(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  for (; e; ) {
    if (t ? j_(e) : Ac(e)) return e;
    e = e.parentElement;
  }
  return document.scrollingElement;
}
function oo(e, t) {
  const n = [];
  if (t && e && !t.contains(e)) return n;
  for (; e && (Ac(e) && n.push(e), e !== t); )
    e = e.parentElement;
  return n;
}
function Ac(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE) return !1;
  const t = window.getComputedStyle(e), n = t.overflowY === "scroll" || t.overflowY === "auto" && e.scrollHeight > e.clientHeight, a = t.overflowX === "scroll" || t.overflowX === "auto" && e.scrollWidth > e.clientWidth;
  return n || a;
}
function j_(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE) return !1;
  const t = window.getComputedStyle(e);
  return ["scroll", "auto"].includes(t.overflowY);
}
function G_(e) {
  let {
    depth: t,
    isLast: n,
    isLastGroup: a,
    leafLinks: r,
    separateRoots: l,
    parentIndentLines: i,
    variant: o
  } = e;
  const s = n && (!a || l || t > 1);
  return !i || !t ? {
    leaf: void 0,
    node: void 0,
    children: i,
    footer: i && (!s || o === "simple") ? [...i, l ? "none" : "line"] : ["none"]
  } : o === "simple" ? {
    leaf: [...i, "line"],
    node: [...i, "line"],
    children: [...i, "line"],
    footer: [...i, "line", "line"]
  } : {
    leaf: [...i, s ? "last-leaf" : "leaf", ...r ? ["leaf-link"] : []],
    node: [...i, s ? "last-leaf" : "leaf"],
    children: [...i, s ? "none" : "line"],
    footer: [...i, s ? "none" : "line"]
  };
}
function q_(e) {
  for (; e; ) {
    if (window.getComputedStyle(e).position === "fixed")
      return !0;
    e = e.offsetParent;
  }
  return !1;
}
function X(e) {
  const t = kt("useRender");
  t.render = e;
}
function Y_(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    leading: !0,
    trailing: !0
  }, a = 0, r = 0, l = !1, i = 0;
  function o() {
    clearTimeout(a), l = !1, i = 0;
  }
  const s = function() {
    for (var u = arguments.length, c = new Array(u), d = 0; d < u; d++)
      c[d] = arguments[d];
    clearTimeout(a);
    const f = Date.now();
    i || (i = f);
    const v = f - Math.max(i, r);
    function g() {
      r = Date.now(), a = setTimeout(o, t), e(...c);
    }
    l ? v >= t ? g() : n.trailing && (a = setTimeout(g, t - v)) : (l = !0, n.leading && g());
  };
  return s.clear = o, s.immediate = e, s;
}
function Vn(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "content";
  const n = Ol(), a = G();
  if (wt) {
    const r = new ResizeObserver((l) => {
      e?.(l, r), l.length && (t === "content" ? a.value = l[0].contentRect : a.value = l[0].target.getBoundingClientRect());
    });
    Ft(() => {
      r.disconnect();
    }), ne(() => n.el, (l, i) => {
      i && (r.unobserve(i), a.value = void 0), l && r.observe(l);
    }, {
      flush: "post"
    });
  }
  return {
    resizeRef: n,
    contentRect: yo(a)
  };
}
const Ll = /* @__PURE__ */ Symbol.for("vuetify:layout"), gg = /* @__PURE__ */ Symbol.for("vuetify:layout-item"), pv = 1e3, yg = U({
  overlaps: {
    type: Array,
    default: () => []
  },
  fullHeight: Boolean
}, "layout"), cr = U({
  name: {
    type: String
  },
  order: {
    type: [Number, String],
    default: 0
  },
  absolute: Boolean
}, "layout-item");
function bg() {
  const e = Le(Ll);
  if (!e) throw new Error("[Vuetify] Could not find injected layout");
  return {
    getLayoutItem: e.getLayoutItem,
    mainRect: e.mainRect,
    mainStyles: e.mainStyles
  };
}
function dr(e) {
  const t = Le(Ll);
  if (!t) throw new Error("[Vuetify] Could not find injected layout");
  const n = e.id ?? `layout-item-${Rt()}`, a = kt("useLayoutItem");
  st(gg, {
    id: n
  });
  const r = ae(!1);
  om(() => r.value = !0), jp(() => r.value = !1);
  const {
    layoutItemStyles: l,
    layoutItemScrimStyles: i
  } = t.register(a, {
    ...e,
    active: T(() => r.value ? !1 : e.active.value),
    id: n
  });
  return Ft(() => t.unregister(n)), {
    layoutItemStyles: l,
    layoutRect: t.layoutRect,
    layoutItemScrimStyles: i
  };
}
const K_ = (e, t, n, a) => {
  let r = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };
  const l = [{
    id: "",
    layer: {
      ...r
    }
  }];
  for (const i of e) {
    const o = t.get(i), s = n.get(i), u = a.get(i);
    if (!o || !s || !u) continue;
    const c = {
      ...r,
      [o.value]: parseInt(r[o.value], 10) + (u.value ? parseInt(s.value, 10) : 0)
    };
    l.push({
      id: i,
      layer: c
    }), r = c;
  }
  return l;
};
function pg(e) {
  const t = Le(Ll, null), n = T(() => t ? t.rootZIndex.value - 100 : pv), a = G([]), r = cn(/* @__PURE__ */ new Map()), l = cn(/* @__PURE__ */ new Map()), i = cn(/* @__PURE__ */ new Map()), o = cn(/* @__PURE__ */ new Map()), s = cn(/* @__PURE__ */ new Map()), {
    resizeRef: u,
    contentRect: c
  } = Vn(), d = T(() => {
    const p = /* @__PURE__ */ new Map(), x = e.overlaps ?? [];
    for (const k of x.filter((V) => V.includes(":"))) {
      const [V, A] = k.split(":");
      if (!a.value.includes(V) || !a.value.includes(A)) continue;
      const M = r.get(V), L = r.get(A), E = l.get(V), P = l.get(A);
      !M || !L || !E || !P || (p.set(A, {
        position: M.value,
        amount: parseInt(E.value, 10)
      }), p.set(V, {
        position: L.value,
        amount: -parseInt(P.value, 10)
      }));
    }
    return p;
  }), f = T(() => {
    const p = [...new Set([...i.values()].map((k) => k.value))].sort((k, V) => k - V), x = [];
    for (const k of p) {
      const V = a.value.filter((A) => i.get(A)?.value === k);
      x.push(...V);
    }
    return K_(x, r, l, o);
  }), v = T(() => !Array.from(s.values()).some((p) => p.value)), g = T(() => f.value[f.value.length - 1].layer), m = D(() => ({
    "--v-layout-left": re(g.value.left),
    "--v-layout-right": re(g.value.right),
    "--v-layout-top": re(g.value.top),
    "--v-layout-bottom": re(g.value.bottom),
    ...v.value ? void 0 : {
      transition: "none"
    }
  })), h = T(() => f.value.slice(1).map((p, x) => {
    let {
      id: k
    } = p;
    const {
      layer: V
    } = f.value[x], A = l.get(k), M = r.get(k);
    return {
      id: k,
      ...V,
      size: Number(A.value),
      position: M.value
    };
  })), w = (p) => h.value.find((x) => x.id === p), _ = kt("createLayout"), I = ae(!1);
  bt(() => {
    I.value = !0;
  }), st(Ll, {
    register: (p, x) => {
      let {
        id: k,
        order: V,
        position: A,
        layoutSize: M,
        elementSize: L,
        active: E,
        disableTransitions: P,
        absolute: O
      } = x;
      i.set(k, V), r.set(k, A), l.set(k, M), o.set(k, E), P && s.set(k, P);
      const B = Mr(gg, _?.vnode).indexOf(p);
      B > -1 ? a.value.splice(B, 0, k) : a.value.push(k);
      const N = T(() => h.value.findIndex((H) => H.id === k)), W = T(() => n.value + f.value.length * 2 - N.value * 2), R = T(() => {
        const H = A.value === "left" || A.value === "right", $ = A.value === "right", z = A.value === "bottom", te = L.value ?? M.value, me = te === 0 ? "%" : "px", Q = {
          [A.value]: 0,
          zIndex: W.value,
          transform: `translate${H ? "X" : "Y"}(${(E.value ? 0 : -(te === 0 ? 100 : te)) * ($ || z ? -1 : 1)}${me})`,
          position: O.value || n.value !== pv ? "absolute" : "fixed",
          ...v.value ? void 0 : {
            transition: "none"
          }
        };
        if (!I.value) return Q;
        const ie = h.value[N.value];
        ie || jt(`[Vuetify] Could not find layout item "${k}"`);
        const ke = d.value.get(k);
        return ke && (ie[ke.position] += ke.amount), {
          ...Q,
          height: H ? `calc(100% - ${ie.top}px - ${ie.bottom}px)` : L.value ? `${L.value}px` : void 0,
          left: $ ? void 0 : `${ie.left}px`,
          right: $ ? `${ie.right}px` : void 0,
          top: A.value !== "bottom" ? `${ie.top}px` : void 0,
          bottom: A.value !== "top" ? `${ie.bottom}px` : void 0,
          width: H ? L.value ? `${L.value}px` : void 0 : `calc(100% - ${ie.left}px - ${ie.right}px)`
        };
      }), j = T(() => ({
        zIndex: W.value - 1
      }));
      return {
        layoutItemStyles: R,
        layoutItemScrimStyles: j,
        zIndex: W
      };
    },
    unregister: (p) => {
      i.delete(p), r.delete(p), l.delete(p), o.delete(p), s.delete(p), a.value = a.value.filter((x) => x !== p);
    },
    mainRect: g,
    mainStyles: m,
    getLayoutItem: w,
    items: h,
    layoutRect: c,
    rootZIndex: n
  });
  const C = D(() => ["v-layout", {
    "v-layout--full-height": e.fullHeight
  }]), b = D(() => ({
    zIndex: t ? n.value : void 0,
    position: t ? "relative" : void 0,
    overflow: t ? "hidden" : void 0
  }));
  return {
    layoutClasses: C,
    layoutStyles: b,
    getLayoutItem: w,
    items: h,
    layoutRect: c,
    layoutRef: u
  };
}
function Wt(e, t) {
  let n;
  function a() {
    n = bo(), n.run(() => t.length ? t(() => {
      n?.stop(), a();
    }) : t());
  }
  ne(e, (r) => {
    r && !n ? a() : r || (n?.stop(), n = void 0);
  }, {
    immediate: !0
  }), It(() => {
    n?.stop();
  });
}
function he(e, t, n) {
  let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (d) => d, r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (d) => d;
  const l = kt("useProxiedModel"), i = G(e[t] !== void 0 ? e[t] : n), o = Ya(t), u = o !== t ? T(() => (e[t], !!((l.vnode.props?.hasOwnProperty(t) || l.vnode.props?.hasOwnProperty(o)) && (l.vnode.props?.hasOwnProperty(`onUpdate:${t}`) || l.vnode.props?.hasOwnProperty(`onUpdate:${o}`))))) : T(() => (e[t], !!(l.vnode.props?.hasOwnProperty(t) && l.vnode.props?.hasOwnProperty(`onUpdate:${t}`))));
  Wt(() => !u.value, () => {
    ne(() => e[t], (d) => {
      i.value = d;
    });
  });
  const c = T({
    get() {
      const d = e[t];
      return a(u.value ? d : i.value);
    },
    set(d) {
      const f = r(d), v = it(u.value ? e[t] : i.value);
      v === f || a(v) === d || (i.value = f, l?.emit(`update:${t}`, f));
    }
  });
  return Object.defineProperty(c, "externalValue", {
    get: () => u.value ? e[t] : i.value
  }), c;
}
const so = /* @__PURE__ */ Symbol.for("vuetify:locale");
function Ke() {
  const e = Le(so);
  if (!e) throw new Error("[Vuetify] Could not find injected locale instance");
  return e;
}
function wg(e) {
  const t = Le(so);
  if (!t) throw new Error("[Vuetify] Could not find injected locale instance");
  const n = t.provide(e), a = Z_(n, t.rtl, e), r = {
    ...n,
    ...a
  };
  return st(so, r), r;
}
function Z_(e, t, n) {
  const a = T(() => n.rtl ?? t.value[e.current.value] ?? !1);
  return {
    isRtl: a,
    rtl: t,
    rtlClasses: D(() => `v-locale--is-${a.value ? "rtl" : "ltr"}`)
  };
}
function At() {
  const e = Le(so);
  if (!e) throw new Error("[Vuetify] Could not find injected rtl instance");
  return {
    isRtl: e.isRtl,
    rtlClasses: e.rtlClasses
  };
}
const du = /* @__PURE__ */ Symbol.for("vuetify:theme"), Re = U({
  theme: String
}, "theme");
function Ge(e) {
  kt("provideTheme");
  const t = Le(du, null);
  if (!t) throw new Error("Could not find Vuetify theme injection");
  const n = D(() => e.theme ?? t.name.value), a = D(() => t.themes.value[n.value]), r = D(() => t.isDisabled ? void 0 : `${t.prefix}theme--${n.value}`), l = {
    ...t,
    name: n,
    current: a,
    themeClasses: r
  };
  return st(du, l), l;
}
function Fo() {
  kt("useTheme");
  const e = Le(du, null);
  if (!e) throw new Error("Could not find Vuetify theme injection");
  return e;
}
const J_ = U({
  ...ve(),
  ...Pe(yg(), ["fullHeight"]),
  ...Re()
}, "VApp"), X_ = K()({
  name: "VApp",
  props: J_(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = Ge(e), {
      layoutClasses: r,
      getLayoutItem: l,
      items: i,
      layoutRef: o
    } = pg({
      ...e,
      fullHeight: !0
    }), {
      rtlClasses: s
    } = At();
    return X(() => S("div", {
      ref: o,
      class: J(["v-application", a.themeClasses.value, r.value, s.value, e.class]),
      style: le([e.style])
    }, [S("div", {
      class: "v-application__wrap"
    }, [n.default?.()])])), {
      getLayoutItem: l,
      items: i,
      theme: a
    };
  }
}), Ie = U({
  tag: {
    type: [String, Object, Function],
    default: "div"
  }
}, "tag"), kg = U({
  text: String,
  ...ve(),
  ...Ie()
}, "VToolbarTitle"), Pc = K()({
  name: "VToolbarTitle",
  props: kg(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => {
      const a = !!(n.default || n.text || e.text);
      return y(e.tag, {
        class: J(["v-toolbar-title", e.class]),
        style: le(e.style)
      }, {
        default: () => [a && S("div", {
          class: "v-toolbar-title__placeholder"
        }, [n.text ? n.text() : e.text, n.default?.()])]
      });
    }), {};
  }
}), Q_ = U({
  disabled: Boolean,
  group: Boolean,
  hideOnLeave: Boolean,
  leaveAbsolute: Boolean,
  mode: String,
  origin: String
}, "transition");
function Sn(e, t, n) {
  return K()({
    name: e,
    props: Q_({
      mode: n,
      origin: t
    }),
    setup(a, r) {
      let {
        slots: l
      } = r;
      const i = {
        onBeforeEnter(o) {
          a.origin && (o.style.transformOrigin = a.origin);
        },
        onLeave(o) {
          if (a.leaveAbsolute) {
            const {
              offsetTop: s,
              offsetLeft: u,
              offsetWidth: c,
              offsetHeight: d
            } = o;
            o._transitionInitialStyles = {
              position: o.style.position,
              top: o.style.top,
              left: o.style.left,
              width: o.style.width,
              height: o.style.height
            }, o.style.position = "absolute", o.style.top = `${s}px`, o.style.left = `${u}px`, o.style.width = `${c}px`, o.style.height = `${d}px`;
          }
          a.hideOnLeave && o.style.setProperty("display", "none", "important");
        },
        onAfterLeave(o) {
          if (a.leaveAbsolute && o?._transitionInitialStyles) {
            const {
              position: s,
              top: u,
              left: c,
              width: d,
              height: f
            } = o._transitionInitialStyles;
            delete o._transitionInitialStyles, o.style.position = s || "", o.style.top = u || "", o.style.left = c || "", o.style.width = d || "", o.style.height = f || "";
          }
        }
      };
      return () => {
        const o = a.group ? Zu : Rn;
        return Oa(o, {
          name: a.disabled ? "" : e,
          css: !a.disabled,
          ...a.group ? void 0 : {
            mode: a.mode
          },
          ...a.disabled ? {} : i
        }, l.default);
      };
    }
  });
}
function Vc(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "in-out";
  return K()({
    name: e,
    props: {
      mode: {
        type: String,
        default: n
      },
      disabled: {
        type: Boolean,
        default: Gn()
      },
      group: Boolean,
      hideOnLeave: Boolean
    },
    setup(a, r) {
      let {
        slots: l
      } = r;
      const i = a.group ? Zu : Rn;
      return () => Oa(i, {
        name: a.disabled ? "" : e,
        css: !a.disabled,
        // mode: props.mode, // TODO: vuejs/vue-next#3104
        ...a.disabled ? {} : {
          ...t,
          onLeave: (o) => {
            a.hideOnLeave ? o.style.setProperty("display", "none", "important") : t.onLeave?.(o);
          }
        }
      }, l.default);
    }
  });
}
function Ec() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "y";
  return {
    onBeforeEnter(r) {
      r._parent = r.parentNode, r._initialStyle = {
        transition: r.style.transition,
        overflow: r.style.overflow,
        width: r.style.width,
        height: r.style.height
      };
    },
    onEnter(r) {
      const l = r._initialStyle;
      if (!l) return;
      r.style.setProperty("transition", "none", "important"), r.style.overflow = "hidden";
      const i = `${r.offsetWidth}px`, o = `${r.offsetHeight}px`;
      ["x", "both"].includes(t) && (r.style.width = "0"), ["y", "both"].includes(t) && (r.style.height = "0"), r.offsetHeight, r.style.transition = l.transition, e && r._parent && r._parent.classList.add(e), requestAnimationFrame(() => {
        ["x", "both"].includes(t) && (r.style.width = i), ["y", "both"].includes(t) && (r.style.height = o);
      });
    },
    onAfterEnter: a,
    onEnterCancelled: a,
    onLeave(r) {
      r._initialStyle = {
        transition: "",
        overflow: r.style.overflow,
        width: r.style.width,
        height: r.style.height
      }, r.style.overflow = "hidden", ["x", "both"].includes(t) && (r.style.width = `${r.offsetWidth}px`), ["y", "both"].includes(t) && (r.style.height = `${r.offsetHeight}px`), r.offsetHeight, requestAnimationFrame(() => {
        ["x", "both"].includes(t) && (r.style.width = "0"), ["y", "both"].includes(t) && (r.style.height = "0");
      });
    },
    onAfterLeave: n,
    onLeaveCancelled: n
  };
  function n(r) {
    e && r._parent && r._parent.classList.remove(e), a(r);
  }
  function a(r) {
    if (!r._initialStyle) return;
    const {
      width: l,
      height: i
    } = r._initialStyle;
    r.style.overflow = r._initialStyle.overflow, l != null && ["x", "both"].includes(t) && (r.style.width = l), i != null && ["y", "both"].includes(t) && (r.style.height = i), delete r._initialStyle;
  }
}
const eT = U({
  target: [Object, Array]
}, "v-dialog-transition"), Is = /* @__PURE__ */ new WeakMap(), Ro = K()({
  name: "VDialogTransition",
  props: eT(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = {
      onBeforeEnter(r) {
        r.style.pointerEvents = "none", r.style.visibility = "hidden";
      },
      async onEnter(r, l) {
        await new Promise((f) => requestAnimationFrame(f)), await new Promise((f) => requestAnimationFrame(f)), r.style.visibility = "";
        const i = kv(e.target, r), {
          x: o,
          y: s,
          sx: u,
          sy: c,
          speed: d
        } = i;
        if (Is.set(r, i), Gn())
          aa(r, [{
            opacity: 0
          }, {}], {
            duration: 125 * d,
            easing: yv
          }).finished.then(() => l());
        else {
          const f = aa(r, [{
            transform: `translate(${o}px, ${s}px) scale(${u}, ${c})`,
            opacity: 0
          }, {}], {
            duration: 225 * d,
            easing: yv
          });
          wv(r)?.forEach((v) => {
            aa(v, [{
              opacity: 0
            }, {
              opacity: 0,
              offset: 0.33
            }, {}], {
              duration: 450 * d,
              easing: Dl
            });
          }), f.finished.then(() => l());
        }
      },
      onAfterEnter(r) {
        r.style.removeProperty("pointer-events");
      },
      onBeforeLeave(r) {
        r.style.pointerEvents = "none";
      },
      async onLeave(r, l) {
        await new Promise((f) => requestAnimationFrame(f));
        let i;
        !Is.has(r) || Array.isArray(e.target) || e.target.offsetParent || e.target.getClientRects().length ? i = kv(e.target, r) : i = Is.get(r);
        const {
          x: o,
          y: s,
          sx: u,
          sy: c,
          speed: d
        } = i;
        Gn() ? aa(r, [{}, {
          opacity: 0
        }], {
          duration: 85 * d,
          easing: bv
        }).finished.then(() => l()) : (aa(r, [{}, {
          transform: `translate(${o}px, ${s}px) scale(${u}, ${c})`,
          opacity: 0
        }], {
          duration: 125 * d,
          easing: bv
        }).finished.then(() => l()), wv(r)?.forEach((v) => {
          aa(v, [{}, {
            opacity: 0,
            offset: 0.2
          }, {
            opacity: 0
          }], {
            duration: 250 * d,
            easing: Dl
          });
        }));
      },
      onAfterLeave(r) {
        r.style.removeProperty("pointer-events");
      }
    };
    return () => e.target ? y(Rn, Y({
      name: "dialog-transition"
    }, a, {
      css: !1
    }), n) : y(Rn, {
      name: "dialog-transition"
    }, n);
  }
});
function wv(e) {
  const t = e.querySelector(":scope > .v-card, :scope > .v-sheet, :scope > .v-list")?.children;
  return t && [...t];
}
function kv(e, t) {
  const n = cg(e), a = _c(t), [r, l] = getComputedStyle(t).transformOrigin.split(" ").map((w) => parseFloat(w)), [i, o] = getComputedStyle(t).getPropertyValue("--v-overlay-anchor-origin").split(" ");
  let s = n.left + n.width / 2;
  i === "left" || o === "left" ? s -= n.width / 2 : (i === "right" || o === "right") && (s += n.width / 2);
  let u = n.top + n.height / 2;
  i === "top" || o === "top" ? u -= n.height / 2 : (i === "bottom" || o === "bottom") && (u += n.height / 2);
  const c = n.width / a.width, d = n.height / a.height, f = Math.max(1, c, d), v = c / f || 0, g = d / f || 0, m = a.width * a.height / (window.innerWidth * window.innerHeight), h = m > 0.12 ? Math.min(1.5, (m - 0.12) * 10 + 1) : 1;
  return {
    x: s - (r + a.left),
    y: u - (l + a.top),
    sx: v,
    sy: g,
    speed: h
  };
}
const tT = Sn("fab-transition", "center center", "out-in"), nT = Sn("dialog-bottom-transition"), aT = Sn("dialog-top-transition"), Nl = Sn("fade-transition"), Mc = Sn("scale-transition"), rT = Sn("scroll-x-transition"), lT = Sn("scroll-x-reverse-transition"), iT = Sn("scroll-y-transition"), oT = Sn("scroll-y-reverse-transition"), sT = Sn("slide-x-transition"), uT = Sn("slide-x-reverse-transition"), Oc = Sn("slide-y-transition"), cT = Sn("slide-y-reverse-transition"), $o = Vc("expand-transition", Ec()), Dc = Vc("expand-x-transition", Ec("", "x")), dT = Vc("expand-both-transition", Ec("", "both")), fT = U({
  defaults: Object,
  disabled: Boolean,
  reset: [Number, String],
  root: [Boolean, String],
  scoped: Boolean
}, "VDefaultsProvider"), Ae = K(!1)({
  name: "VDefaultsProvider",
  props: fT(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      defaults: a,
      disabled: r,
      reset: l,
      root: i,
      scoped: o
    } = Kr(e);
    return vt(a, {
      reset: l,
      root: i,
      scoped: o,
      disabled: r
    }), () => n.default?.();
  }
}), St = U({
  height: [Number, String],
  maxHeight: [Number, String],
  maxWidth: [Number, String],
  minHeight: [Number, String],
  minWidth: [Number, String],
  width: [Number, String]
}, "dimension");
function xt(e) {
  return {
    dimensionStyles: T(() => {
      const n = {}, a = re(e.height), r = re(e.maxHeight), l = re(e.maxWidth), i = re(e.minHeight), o = re(e.minWidth), s = re(e.width);
      return a != null && (n.height = a), r != null && (n.maxHeight = r), l != null && (n.maxWidth = l), i != null && (n.minHeight = i), o != null && (n.minWidth = o), s != null && (n.width = s), n;
    })
  };
}
function vT(e) {
  return {
    aspectStyles: T(() => {
      const t = Number(e.aspectRatio);
      return t ? {
        paddingBottom: String(1 / t * 100) + "%"
      } : void 0;
    })
  };
}
const Sg = U({
  aspectRatio: [String, Number],
  contentClass: null,
  inline: Boolean,
  ...ve(),
  ...St()
}, "VResponsive"), fu = K()({
  name: "VResponsive",
  props: Sg(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      aspectStyles: a
    } = vT(e), {
      dimensionStyles: r
    } = xt(e);
    return X(() => S("div", {
      class: J(["v-responsive", {
        "v-responsive--inline": e.inline
      }, e.class]),
      style: le([r.value, e.style])
    }, [S("div", {
      class: "v-responsive__sizer",
      style: le(a.value)
    }, null), n.additional?.(), n.default && S("div", {
      class: J(["v-responsive__content", e.contentClass])
    }, [n.default()])])), {};
  }
});
function Lc(e) {
  return Cc(() => {
    const {
      class: t,
      style: n
    } = xg(e);
    return {
      colorClasses: t,
      colorStyles: n
    };
  });
}
function Nt(e) {
  const {
    colorClasses: t,
    colorStyles: n
  } = Lc(() => ({
    text: nt(e)
  }));
  return {
    textColorClasses: t,
    textColorStyles: n
  };
}
function qe(e) {
  const {
    colorClasses: t,
    colorStyles: n
  } = Lc(() => ({
    background: nt(e)
  }));
  return {
    backgroundColorClasses: t,
    backgroundColorStyles: n
  };
}
function mT(e) {
  return {
    text: typeof e.text == "string" ? e.text.replace(/^text-/, "") : e.text,
    background: typeof e.background == "string" ? e.background.replace(/^bg-/, "") : e.background
  };
}
function xg(e) {
  const t = mT(nt(e)), n = [], a = {};
  if (t.background)
    if (uu(t.background)) {
      if (a.backgroundColor = t.background, !t.text && E_(t.background)) {
        const r = ra(t.background);
        if (r.a == null || r.a === 1) {
          const l = F_(r);
          a.color = l, a.caretColor = l;
        }
      }
    } else
      n.push(`bg-${t.background}`);
  return t.text && (uu(t.text) ? (a.color = t.text, a.caretColor = t.text) : n.push(`text-${t.text}`)), {
    class: n,
    style: a
  };
}
const lt = U({
  rounded: {
    type: [Boolean, Number, String],
    default: void 0
  },
  tile: Boolean
}, "rounded");
function ut(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Xn();
  return {
    roundedClasses: T(() => {
      const a = qi(e) ? e.value : e.rounded, r = qi(e) ? !1 : e.tile, l = [];
      if (r || a === !1)
        l.push("rounded-0");
      else if (a === !0 || a === "")
        l.push(`${t}--rounded`);
      else if (typeof a == "string" || a === 0)
        for (const i of String(a).split(" "))
          l.push(`rounded-${i}`);
      return l;
    })
  };
}
const da = U({
  transition: {
    type: null,
    default: "fade-transition",
    validator: (e) => e !== !0
  }
}, "transition"), Xt = (e, t) => {
  let {
    slots: n
  } = t;
  const {
    transition: a,
    disabled: r,
    group: l,
    ...i
  } = e, {
    component: o = l ? Zu : Rn,
    ...s
  } = Qa(a) ? a : {};
  let u;
  return Qa(a) ? u = Y(s, g_({
    disabled: r,
    group: l
  }), i) : u = Y({
    name: r || !a ? "" : a
  }, i), Oa(o, u, n);
};
function Sv(e, t) {
  if (!kc) return;
  const n = t.modifiers || {}, a = t.value, {
    handler: r,
    options: l
  } = typeof a == "object" ? a : {
    handler: a,
    options: {}
  }, i = new IntersectionObserver(function() {
    let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s = arguments.length > 1 ? arguments[1] : void 0;
    const u = e._observe?.[t.instance.$.uid];
    if (!u) return;
    const c = o.some((d) => d.isIntersecting);
    r && (!n.quiet || u.init) && (!n.once || c || u.init) && r(c, o, s), c && n.once ? vu(e, t) : u.init = !0;
  }, l);
  e._observe = Object(e._observe), e._observe[t.instance.$.uid] = {
    init: !1,
    observer: i
  }, i.observe(e);
}
function vu(e, t) {
  const n = e._observe?.[t.instance.$.uid];
  n && (n.observer.unobserve(e), delete e._observe[t.instance.$.uid]);
}
const Bn = {
  mounted: Sv,
  unmounted: vu,
  updated: (e, t) => {
    e._observe?.[t.instance.$.uid] && (vu(e, t), Sv(e, t));
  }
}, Cg = U({
  absolute: Boolean,
  alt: String,
  cover: Boolean,
  color: String,
  draggable: {
    type: [Boolean, String],
    default: void 0
  },
  eager: Boolean,
  gradient: String,
  imageClass: null,
  lazySrc: String,
  options: {
    type: Object,
    // For more information on types, navigate to:
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    default: () => ({
      root: void 0,
      rootMargin: void 0,
      threshold: void 0
    })
  },
  sizes: String,
  src: {
    type: [String, Object],
    default: ""
  },
  crossorigin: String,
  referrerpolicy: String,
  srcset: String,
  position: String,
  ...Sg(),
  ...ve(),
  ...lt(),
  ...da()
}, "VImg"), sa = K()({
  name: "VImg",
  directives: {
    vIntersect: Bn
  },
  props: Cg(),
  emits: {
    loadstart: (e) => !0,
    load: (e) => !0,
    error: (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const {
      backgroundColorClasses: r,
      backgroundColorStyles: l
    } = qe(() => e.color), {
      roundedClasses: i
    } = ut(e), o = kt("VImg"), s = ae(""), u = G(), c = ae(e.eager ? "loading" : "idle"), d = ae(), f = ae(), v = T(() => e.src && typeof e.src == "object" ? {
      src: e.src.src,
      srcset: e.srcset || e.src.srcset,
      lazySrc: e.lazySrc || e.src.lazySrc,
      aspect: Number(e.aspectRatio || e.src.aspect || 0)
    } : {
      src: e.src,
      srcset: e.srcset,
      lazySrc: e.lazySrc,
      aspect: Number(e.aspectRatio || 0)
    }), g = T(() => v.value.aspect || d.value / f.value || 0);
    ne(() => e.src, () => {
      m(c.value !== "idle");
    }), ne(g, (L, E) => {
      !L && E && u.value && C(u.value);
    }), Gl(() => m());
    function m(L) {
      if (!(e.eager && L) && !(kc && !L && !e.eager)) {
        if (c.value = "loading", v.value.lazySrc) {
          const E = new Image();
          E.src = v.value.lazySrc, C(E, null);
        }
        v.value.src && Se(() => {
          n("loadstart", u.value?.currentSrc || v.value.src), setTimeout(() => {
            if (!o.isUnmounted)
              if (u.value?.complete) {
                if (u.value.naturalWidth || w(), c.value === "error") return;
                g.value || C(u.value, null), c.value === "loading" && h();
              } else
                g.value || C(u.value), _();
          });
        });
      }
    }
    function h() {
      o.isUnmounted || (_(), C(u.value), c.value = "loaded", n("load", u.value?.currentSrc || v.value.src));
    }
    function w() {
      o.isUnmounted || (c.value = "error", n("error", u.value?.currentSrc || v.value.src));
    }
    function _() {
      const L = u.value;
      L && (s.value = L.currentSrc || L.src);
    }
    let I = -1;
    Ft(() => {
      clearTimeout(I);
    });
    function C(L) {
      let E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      const P = () => {
        if (clearTimeout(I), o.isUnmounted) return;
        const {
          naturalHeight: O,
          naturalWidth: F
        } = L;
        O || F ? (d.value = F, f.value = O) : !L.complete && c.value === "loading" && E != null ? I = window.setTimeout(P, E) : (L.currentSrc.endsWith(".svg") || L.currentSrc.startsWith("data:image/svg+xml")) && (d.value = 1, f.value = 1);
      };
      P();
    }
    const b = D(() => ({
      "v-img__img--cover": e.cover,
      "v-img__img--contain": !e.cover
    })), p = () => {
      if (!v.value.src || c.value === "idle") return null;
      const L = S("img", {
        class: J(["v-img__img", b.value, e.imageClass]),
        style: {
          objectPosition: e.position
        },
        crossorigin: e.crossorigin,
        src: v.value.src,
        srcset: v.value.srcset,
        alt: e.alt,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable,
        sizes: e.sizes,
        ref: u,
        onLoad: h,
        onError: w
      }, null), E = a.sources?.();
      return y(Xt, {
        transition: e.transition,
        appear: !0
      }, {
        default: () => [at(E ? S("picture", {
          class: "v-img__picture"
        }, [E, L]) : L, [[Wn, c.value === "loaded"]])]
      });
    }, x = () => y(Xt, {
      transition: e.transition
    }, {
      default: () => [v.value.lazySrc && c.value !== "loaded" && S("img", {
        class: J(["v-img__img", "v-img__img--preload", b.value]),
        style: {
          objectPosition: e.position
        },
        crossorigin: e.crossorigin,
        src: v.value.lazySrc,
        alt: e.alt,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable
      }, null)]
    }), k = () => a.placeholder ? y(Xt, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [(c.value === "loading" || c.value === "error" && !a.error) && S("div", {
        class: "v-img__placeholder"
      }, [a.placeholder()])]
    }) : null, V = () => a.error ? y(Xt, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [c.value === "error" && S("div", {
        class: "v-img__error"
      }, [a.error()])]
    }) : null, A = () => e.gradient ? S("div", {
      class: "v-img__gradient",
      style: {
        backgroundImage: `linear-gradient(${e.gradient})`
      }
    }, null) : null, M = ae(!1);
    {
      const L = ne(g, (E) => {
        E && (requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            M.value = !0;
          });
        }), L());
      });
    }
    return X(() => {
      const L = fu.filterProps(e);
      return at(y(fu, Y({
        class: ["v-img", {
          "v-img--absolute": e.absolute,
          "v-img--booting": !M.value,
          "v-img--fit-content": e.width === "fit-content"
        }, r.value, i.value, e.class],
        style: [{
          width: re(e.width === "auto" ? d.value : e.width)
        }, l.value, e.style]
      }, L, {
        aspectRatio: g.value,
        "aria-label": e.alt,
        role: e.alt ? "img" : void 0
      }), {
        additional: () => S(fe, null, [y(p, null, null), y(x, null, null), y(A, null, null), y(k, null, null), y(V, null, null)]),
        default: a.default
      }), [[Bn, {
        handler: m,
        options: e.options
      }, null, {
        once: !0
      }]]);
    }), {
      currentSrc: s,
      image: u,
      state: c,
      naturalWidth: d,
      naturalHeight: f
    };
  }
}), qt = U({
  border: [Boolean, Number, String]
}, "border");
function en(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Xn();
  return {
    borderClasses: T(() => {
      const a = e.border;
      return a === !0 || a === "" ? `${t}--border` : typeof a == "string" || a === 0 ? String(a).split(" ").map((r) => `border-${r}`) : [];
    })
  };
}
const Ct = U({
  elevation: {
    type: [Number, String],
    validator(e) {
      const t = parseInt(e);
      return !isNaN(t) && t >= 0 && // Material Design has a maximum elevation of 24
      // https://material.io/design/environment/elevation.html#default-elevations
      t <= 24;
    }
  }
}, "elevation");
function Et(e) {
  return {
    elevationClasses: D(() => {
      const n = qi(e) ? e.value : e.elevation;
      return n == null ? [] : [`elevation-${n}`];
    })
  };
}
const xv = {
  center: "center",
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, Qn = U({
  location: String
}, "location");
function La(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = arguments.length > 2 ? arguments[2] : void 0;
  const {
    isRtl: a
  } = At();
  return {
    locationStyles: T(() => {
      if (!e.location) return {};
      const {
        side: l,
        align: i
      } = ou(e.location.split(" ").length > 1 ? e.location : `${e.location} center`, a.value);
      function o(u) {
        return n ? n(u) : 0;
      }
      const s = {};
      return l !== "center" && (t ? s[xv[l]] = `calc(100% - ${o(l)}px)` : s[l] = 0), i !== "center" ? t ? s[xv[i]] = `calc(100% - ${o(i)}px)` : s[i] = 0 : (l === "center" ? s.top = s.left = "50%" : s[{
        top: "left",
        bottom: "left",
        left: "top",
        right: "top"
      }[l]] = "50%", s.transform = {
        top: "translateX(-50%)",
        bottom: "translateX(-50%)",
        left: "translateY(-50%)",
        right: "translateY(-50%)",
        center: "translate(-50%, -50%)"
      }[l]), s;
    })
  };
}
const hT = [null, "prominent", "default", "comfortable", "compact"], _g = U({
  absolute: Boolean,
  collapse: Boolean,
  collapsePosition: {
    type: String,
    default: "start"
  },
  color: String,
  density: {
    type: String,
    default: "default",
    validator: (e) => hT.includes(e)
  },
  extended: {
    type: Boolean,
    default: null
  },
  extensionHeight: {
    type: [Number, String],
    default: 48
  },
  flat: Boolean,
  floating: Boolean,
  height: {
    type: [Number, String],
    default: 64
  },
  image: String,
  title: String,
  ...qt(),
  ...ve(),
  ...Ct(),
  ...Qn(),
  ...lt(),
  ...Ie({
    tag: "header"
  }),
  ...Re()
}, "VToolbar"), mu = K()({
  name: "VToolbar",
  props: _g(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      backgroundColorClasses: a,
      backgroundColorStyles: r
    } = qe(() => e.color), {
      borderClasses: l
    } = en(e), {
      elevationClasses: i
    } = Et(e), {
      locationStyles: o
    } = La(e), {
      roundedClasses: s
    } = ut(e), {
      themeClasses: u
    } = Ge(e), {
      rtlClasses: c
    } = At(), d = ae(e.extended === null ? !!n.extension?.() : e.extended), f = T(() => parseInt(Number(e.height) + (e.density === "prominent" ? Number(e.height) : 0) - (e.density === "comfortable" ? 8 : 0) - (e.density === "compact" ? 16 : 0), 10)), v = T(() => d.value ? parseInt(Number(e.extensionHeight) + (e.density === "prominent" ? Number(e.extensionHeight) : 0) - (e.density === "comfortable" ? 4 : 0) - (e.density === "compact" ? 8 : 0), 10) : 0);
    return vt({
      VBtn: {
        variant: "text"
      }
    }), X(() => {
      const g = !!(e.title || n.title), m = !!(n.image || e.image), h = n.extension?.();
      return d.value = e.extended === null ? !!h : e.extended, y(e.tag, {
        class: J(["v-toolbar", `v-toolbar--collapse-${e.collapsePosition}`, {
          "v-toolbar--absolute": e.absolute,
          "v-toolbar--collapse": e.collapse,
          "v-toolbar--flat": e.flat,
          "v-toolbar--floating": e.floating,
          [`v-toolbar--density-${e.density}`]: !0
        }, a.value, l.value, i.value, s.value, u.value, c.value, e.class]),
        style: le([r.value, o.value, e.style])
      }, {
        default: () => [m && S("div", {
          key: "image",
          class: "v-toolbar__image"
        }, [n.image ? y(Ae, {
          key: "image-defaults",
          disabled: !e.image,
          defaults: {
            VImg: {
              cover: !0,
              src: e.image
            }
          }
        }, n.image) : y(sa, {
          key: "image-img",
          cover: !0,
          src: e.image
        }, null)]), y(Ae, {
          defaults: {
            VTabs: {
              height: re(f.value)
            }
          }
        }, {
          default: () => [S("div", {
            class: "v-toolbar__content",
            style: {
              height: re(f.value)
            }
          }, [n.prepend && S("div", {
            class: "v-toolbar__prepend"
          }, [n.prepend?.()]), g && y(Pc, {
            key: "title",
            text: e.title
          }, {
            text: n.title
          }), n.default?.(), n.append && S("div", {
            class: "v-toolbar__append"
          }, [n.append?.()])])]
        }), y(Ae, {
          defaults: {
            VTabs: {
              height: re(v.value)
            }
          }
        }, {
          default: () => [y($o, null, {
            default: () => [d.value && S("div", {
              class: "v-toolbar__extension",
              style: {
                height: re(v.value)
              }
            }, [h])]
          })]
        })]
      });
    }), {
      contentHeight: f,
      extensionHeight: v
    };
  }
}), gT = U({
  scrollTarget: {
    type: String
  },
  scrollThreshold: {
    type: [String, Number],
    default: 300
  }
}, "scroll");
function yT(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    canScroll: n,
    layoutSize: a
  } = t;
  let r = 0, l = 0;
  const i = G(null), o = ae(0), s = ae(0), u = ae(0), c = ae(!1), d = ae(!1), f = ae(!1), v = ae(!1), g = ae(!0), m = T(() => Number(e.scrollThreshold)), h = T(() => Xe((m.value - o.value) / m.value || 0));
  function w(b) {
    const p = "window" in b ? window.innerHeight : b.clientHeight, x = "window" in b ? document.documentElement.scrollHeight : b.scrollHeight;
    return {
      clientHeight: p,
      scrollHeight: x
    };
  }
  function _() {
    const b = i.value;
    if (!b) return;
    const {
      clientHeight: p,
      scrollHeight: x
    } = w(b), k = x - p, V = a?.value || 0, A = m.value + V;
    g.value = k > A;
  }
  function I() {
    _();
  }
  function C() {
    const b = i.value;
    if (!b || n && !n.value) return;
    r = o.value, o.value = "window" in b ? b.pageYOffset : b.scrollTop;
    const p = b instanceof Window ? document.documentElement.scrollHeight : b.scrollHeight;
    l !== p && (p > l && _(), l = p), d.value = o.value < r, u.value = Math.abs(o.value - m.value);
    const {
      clientHeight: x,
      scrollHeight: k
    } = w(b), V = o.value + x >= k - 5;
    !d.value && V && o.value >= m.value && g.value && (v.value = !0);
    const A = Math.abs(o.value - r) > 100, M = o.value <= 5;
    (d.value && r - o.value > 1 && !V || A && o.value < m.value || M) && (v.value = !1), f.value = V;
  }
  return ne(d, () => {
    s.value = s.value || o.value;
  }), ne(c, () => {
    s.value = 0;
  }), bt(() => {
    ne(() => e.scrollTarget, (b) => {
      const p = b ? document.querySelector(b) : window;
      if (!p) {
        jt(`Unable to locate element with identifier ${b}`);
        return;
      }
      p !== i.value && (i.value?.removeEventListener("scroll", C), i.value = p, i.value.addEventListener("scroll", C, {
        passive: !0
      }), Promise.resolve().then(() => {
        _();
      }));
    }, {
      immediate: !0
    }), window.addEventListener("resize", I, {
      passive: !0
    });
  }), Ft(() => {
    i.value?.removeEventListener("scroll", C), window.removeEventListener("resize", I);
  }), n && ne(n, C, {
    immediate: !0
  }), {
    scrollThreshold: m,
    currentScroll: o,
    currentThreshold: u,
    isScrollActive: c,
    scrollRatio: h,
    // required only for testing
    // probably can be removed
    // later (2 chars chlng)
    isScrollingUp: d,
    savedScroll: s,
    isAtBottom: f,
    reachedBottomWhileScrollingDown: v,
    hasEnoughScrollableSpace: g
  };
}
function fr() {
  const e = ae(!1);
  return bt(() => {
    window.requestAnimationFrame(() => {
      e.value = !0;
    });
  }), {
    ssrBootStyles: D(() => e.value ? void 0 : {
      transition: "none !important"
    }),
    isBooted: yo(e)
  };
}
const bT = U({
  scrollBehavior: String,
  modelValue: {
    type: Boolean,
    default: !0
  },
  location: {
    type: String,
    default: "top",
    validator: (e) => ["top", "bottom"].includes(e)
  },
  ...Pe(_g(), ["location"]),
  ...cr(),
  ...gT(),
  height: {
    type: [Number, String],
    default: 64
  }
}, "VAppBar"), pT = K()({
  name: "VAppBar",
  props: bT(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = G(), r = he(e, "modelValue"), l = T(() => {
      const p = new Set(e.scrollBehavior?.split(" ") ?? []);
      return {
        hide: p.has("hide"),
        fullyHide: p.has("fully-hide"),
        inverted: p.has("inverted"),
        collapse: p.has("collapse"),
        elevate: p.has("elevate"),
        fadeImage: p.has("fade-image")
        // shrink: behavior.has('shrink'),
      };
    }), i = T(() => {
      const p = l.value;
      return p.hide || p.fullyHide || p.inverted || p.collapse || p.elevate || p.fadeImage || // behavior.shrink ||
      !r.value;
    }), o = T(() => {
      const p = a.value?.contentHeight ?? 0, x = a.value?.extensionHeight ?? 0;
      return p + x;
    }), {
      currentScroll: s,
      scrollThreshold: u,
      isScrollingUp: c,
      scrollRatio: d,
      isAtBottom: f,
      reachedBottomWhileScrollingDown: v,
      hasEnoughScrollableSpace: g
    } = yT(e, {
      canScroll: i,
      layoutSize: o
    }), m = D(() => l.value.hide || l.value.fullyHide), h = T(() => e.collapse || l.value.collapse && (l.value.inverted ? d.value > 0 : d.value === 0)), w = T(() => e.flat || l.value.fullyHide && !r.value || l.value.elevate && (l.value.inverted ? s.value > 0 : s.value === 0)), _ = T(() => l.value.fadeImage ? l.value.inverted ? 1 - d.value : d.value : void 0), I = T(() => {
      if (l.value.hide && l.value.inverted) return 0;
      const p = a.value?.contentHeight ?? 0, x = a.value?.extensionHeight ?? 0;
      return m.value ? s.value < u.value || l.value.fullyHide ? p + x : p : p + x;
    });
    Wt(() => !!e.scrollBehavior, () => {
      ft(() => {
        if (!m.value) {
          r.value = !0;
          return;
        }
        if (l.value.inverted) {
          r.value = s.value > u.value;
          return;
        }
        if (!g.value) {
          r.value = !0;
          return;
        }
        if (v.value) {
          r.value = !1;
          return;
        }
        r.value = c.value && !f.value || s.value < u.value;
      });
    });
    const {
      ssrBootStyles: C
    } = fr(), {
      layoutItemStyles: b
    } = dr({
      id: e.name,
      order: T(() => parseInt(e.order, 10)),
      position: D(() => e.location),
      layoutSize: I,
      elementSize: ae(void 0),
      active: r,
      absolute: D(() => e.absolute)
    });
    return X(() => {
      const p = Pe(mu.filterProps(e), ["location"]);
      return y(mu, Y({
        ref: a,
        class: ["v-app-bar", {
          "v-app-bar--bottom": e.location === "bottom"
        }, e.class],
        style: [{
          ...b.value,
          "--v-toolbar-image-opacity": _.value,
          height: void 0,
          ...C.value
        }, e.style]
      }, p, {
        collapse: h.value,
        flat: w.value
      }), n);
    }), {};
  }
}), wT = [null, "default", "comfortable", "compact"], mt = U({
  density: {
    type: String,
    default: "default",
    validator: (e) => wT.includes(e)
  }
}, "density");
function zt(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Xn();
  return {
    densityClasses: D(() => `${t}--density-${e.density}`)
  };
}
const kT = ["elevated", "flat", "tonal", "outlined", "text", "plain"];
function fa(e, t) {
  return S(fe, null, [e && S("span", {
    key: "overlay",
    class: J(`${t}__overlay`)
  }, null), S("span", {
    key: "underlay",
    class: J(`${t}__underlay`)
  }, null)]);
}
const xn = U({
  color: String,
  variant: {
    type: String,
    default: "elevated",
    validator: (e) => kT.includes(e)
  }
}, "variant");
function va(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Xn();
  const n = D(() => {
    const {
      variant: l
    } = nt(e);
    return `${t}--variant-${l}`;
  }), {
    colorClasses: a,
    colorStyles: r
  } = Lc(() => {
    const {
      variant: l,
      color: i
    } = nt(e);
    return {
      [["elevated", "flat"].includes(l) ? "background" : "text"]: i
    };
  });
  return {
    colorClasses: a,
    colorStyles: r,
    variantClasses: n
  };
}
const Tg = U({
  baseColor: String,
  divided: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  ...qt(),
  ...ve(),
  ...mt(),
  ...Ct(),
  ...lt(),
  ...Ie(),
  ...Re(),
  ...xn()
}, "VBtnGroup"), hu = K()({
  name: "VBtnGroup",
  props: Tg(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: a
    } = Ge(e), {
      densityClasses: r
    } = zt(e), {
      borderClasses: l
    } = en(e), {
      elevationClasses: i
    } = Et(e), {
      roundedClasses: o
    } = ut(e);
    vt({
      VBtn: {
        height: D(() => e.direction === "horizontal" ? "auto" : null),
        baseColor: D(() => e.baseColor),
        color: D(() => e.color),
        density: D(() => e.density),
        flat: !0,
        variant: D(() => e.variant)
      }
    }), X(() => y(e.tag, {
      class: J(["v-btn-group", `v-btn-group--${e.direction}`, {
        "v-btn-group--divided": e.divided
      }, a.value, l.value, r.value, i.value, o.value, e.class]),
      style: le(e.style)
    }, n));
  }
}), vr = U({
  modelValue: {
    type: null,
    default: void 0
  },
  multiple: Boolean,
  mandatory: [Boolean, String],
  max: Number,
  selectedClass: String,
  disabled: Boolean
}, "group"), mr = U({
  value: null,
  disabled: Boolean,
  selectedClass: String
}, "group-item");
function Ia(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  const a = kt("useGroupItem");
  if (!a)
    throw new Error("[Vuetify] useGroupItem composable must be used inside a component setup function");
  const r = Rt();
  st(/* @__PURE__ */ Symbol.for(`${t.description}:id`), r);
  const l = Le(t, null);
  if (!l) {
    if (!n) return l;
    throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${t.description}`);
  }
  const i = D(() => e.value), o = T(() => !!(l.disabled.value || e.disabled));
  function s() {
    l?.register({
      id: r,
      value: i,
      disabled: o
    }, a);
  }
  function u() {
    l?.unregister(r);
  }
  s(), Ft(() => u());
  const c = T(() => l.isSelected(r)), d = T(() => l.items.value[0].id === r), f = T(() => l.items.value[l.items.value.length - 1].id === r), v = T(() => c.value && [l.selectedClass.value, e.selectedClass]);
  return ne(c, (g) => {
    a.emit("group:selected", {
      value: g
    });
  }, {
    flush: "sync"
  }), {
    id: r,
    isSelected: c,
    isFirst: d,
    isLast: f,
    toggle: () => l.select(r, !c.value),
    select: (g) => l.select(r, g),
    selectedClass: v,
    value: i,
    disabled: o,
    group: l,
    register: s,
    unregister: u
  };
}
function Na(e, t) {
  let n = !1;
  const a = cn([]), r = he(e, "modelValue", [], (f) => f === void 0 ? [] : Ig(a, f === null ? [null] : rt(f)), (f) => {
    const v = xT(a, f);
    return e.multiple ? v : v[0];
  }), l = kt("useGroup");
  function i(f, v) {
    const g = f, m = /* @__PURE__ */ Symbol.for(`${t.description}:id`), w = Mr(m, l?.vnode).indexOf(v);
    Z(g.value) === void 0 && (g.value = w, g.useIndexAsValue = !0), w > -1 ? a.splice(w, 0, g) : a.push(g);
  }
  function o(f) {
    if (n) return;
    s();
    const v = a.findIndex((g) => g.id === f);
    a.splice(v, 1);
  }
  function s() {
    const f = a.find((v) => !v.disabled);
    f && e.mandatory === "force" && !r.value.length && (r.value = [f.id]);
  }
  bt(() => {
    s();
  }), Ft(() => {
    n = !0;
  }), sm(() => {
    for (let f = 0; f < a.length; f++)
      a[f].useIndexAsValue && (a[f].value = f);
  });
  function u(f, v) {
    const g = a.find((m) => m.id === f);
    if (!(v && g?.disabled))
      if (e.multiple) {
        const m = r.value.slice(), h = m.findIndex((_) => _ === f), w = ~h;
        if (v = v ?? !w, w && e.mandatory && m.length <= 1 || !w && e.max != null && m.length + 1 > e.max) return;
        h < 0 && v ? m.push(f) : h >= 0 && !v && m.splice(h, 1), r.value = m;
      } else {
        const m = r.value.includes(f);
        if (e.mandatory && m || !m && !v) return;
        r.value = v ?? !m ? [f] : [];
      }
  }
  function c(f) {
    if (e.multiple && jt('This method is not supported when using "multiple" prop'), r.value.length) {
      const v = r.value[0], g = a.findIndex((w) => w.id === v);
      let m = (g + f) % a.length, h = a[m];
      for (; h.disabled && m !== g; )
        m = (m + f) % a.length, h = a[m];
      if (h.disabled) return;
      r.value = [a[m].id];
    } else {
      const v = a.find((g) => !g.disabled);
      v && (r.value = [v.id]);
    }
  }
  const d = {
    register: i,
    unregister: o,
    selected: r,
    select: u,
    disabled: D(() => e.disabled),
    prev: () => c(a.length - 1),
    next: () => c(1),
    isSelected: (f) => r.value.includes(f),
    selectedClass: D(() => e.selectedClass),
    items: D(() => a),
    getItemIndex: (f) => ST(a, f)
  };
  return st(t, d), d;
}
function ST(e, t) {
  const n = Ig(e, [t]);
  return n.length ? e.findIndex((a) => a.id === n[0]) : -1;
}
function Ig(e, t) {
  const n = [];
  return t.forEach((a) => {
    const r = e.find((i) => Lt(a, i.value)), l = e[a];
    r?.value !== void 0 ? n.push(r.id) : l?.useIndexAsValue && n.push(l.id);
  }), n;
}
function xT(e, t) {
  const n = [];
  return t.forEach((a) => {
    const r = e.findIndex((l) => l.id === a);
    if (~r) {
      const l = e[r];
      n.push(l.value !== void 0 ? l.value : r);
    }
  }), n;
}
const Nc = /* @__PURE__ */ Symbol.for("vuetify:v-btn-toggle"), CT = U({
  ...Tg(),
  ...vr()
}, "VBtnToggle"), _T = K()({
  name: "VBtnToggle",
  props: CT(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      isSelected: a,
      next: r,
      prev: l,
      select: i,
      selected: o
    } = Na(e, Nc);
    return X(() => {
      const s = hu.filterProps(e);
      return y(hu, Y({
        class: ["v-btn-toggle", e.class]
      }, s, {
        style: e.style
      }), {
        default: () => [n.default?.({
          isSelected: a,
          next: r,
          prev: l,
          select: i,
          selected: o
        })]
      });
    }), {
      next: r,
      prev: l,
      select: i
    };
  }
}), be = [String, Function, Object, Array], TT = /* @__PURE__ */ Symbol.for("vuetify:icons"), Bo = U({
  icon: {
    type: be
  },
  // Could not remove this and use makeTagProps, types complained because it is not required
  tag: {
    type: [String, Object, Function],
    required: !0
  }
}, "icon"), gu = K()({
  name: "VComponentIcon",
  props: Bo(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return () => {
      const a = e.icon;
      return y(e.tag, null, {
        default: () => [e.icon ? y(a, null, null) : n.default?.()]
      });
    };
  }
}), Ag = rn({
  name: "VSvgIcon",
  inheritAttrs: !1,
  props: Bo(),
  setup(e, t) {
    let {
      attrs: n
    } = t;
    return () => y(e.tag, Y(n, {
      style: null
    }), {
      default: () => [S("svg", {
        class: "v-icon__svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        role: "img",
        "aria-hidden": "true"
      }, [Array.isArray(e.icon) ? e.icon.map((a) => Array.isArray(a) ? S("path", {
        d: a[0],
        "fill-opacity": a[1]
      }, null) : S("path", {
        d: a
      }, null)) : S("path", {
        d: e.icon
      }, null)])]
    });
  }
}), IT = rn({
  name: "VLigatureIcon",
  props: Bo(),
  setup(e) {
    return () => y(e.tag, null, {
      default: () => [e.icon]
    });
  }
}), Pg = rn({
  name: "VClassIcon",
  props: Bo(),
  setup(e) {
    return () => y(e.tag, {
      class: J(e.icon)
    }, null);
  }
}), AT = (e) => {
  const t = Le(TT);
  if (!t) throw new Error("Missing Vuetify Icons provide!");
  return {
    iconData: T(() => {
      const a = nt(e);
      if (!a) return {
        component: gu
      };
      let r = a;
      if (typeof r == "string" && (r = r.trim(), r.startsWith("$") && (r = t.aliases?.[r.slice(1)])), r || jt(`Could not find aliased icon "${a}"`), Array.isArray(r))
        return {
          component: Ag,
          icon: r
        };
      if (typeof r != "string")
        return {
          component: gu,
          icon: r
        };
      const l = Object.keys(t.sets).find((s) => typeof r == "string" && r.startsWith(`${s}:`)), i = l ? r.slice(l.length + 1) : r;
      return {
        component: t.sets[l ?? t.defaultSet].component,
        icon: i
      };
    })
  };
}, PT = ["x-small", "small", "default", "large", "x-large"], ea = U({
  size: {
    type: [String, Number],
    default: "default"
  }
}, "size");
function ll(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Xn();
  return Cc(() => {
    const n = e.size;
    let a, r;
    return ro(PT, n) ? a = `${t}--size-${n}` : n && (r = {
      width: re(n),
      height: re(n)
    }), {
      sizeClasses: a,
      sizeStyles: r
    };
  });
}
const VT = U({
  color: String,
  disabled: Boolean,
  start: Boolean,
  end: Boolean,
  icon: be,
  opacity: [String, Number],
  ...ve(),
  ...ea(),
  ...Ie({
    tag: "i"
  }),
  ...Re()
}, "VIcon"), ze = K()({
  name: "VIcon",
  props: VT(),
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const r = ae(), {
      themeClasses: l
    } = Fo(), {
      iconData: i
    } = AT(() => r.value || e.icon), {
      sizeClasses: o
    } = ll(e), {
      textColorClasses: s,
      textColorStyles: u
    } = Nt(() => e.color);
    return X(() => {
      const c = a.default?.();
      c && (r.value = lg(c).filter((f) => f.type === Gp && f.children && typeof f.children == "string")[0]?.children);
      const d = !!(n.onClick || n.onClickOnce);
      return y(i.value.component, {
        tag: e.tag,
        icon: i.value.icon,
        class: J(["v-icon", "notranslate", l.value, o.value, s.value, {
          "v-icon--clickable": d,
          "v-icon--disabled": e.disabled,
          "v-icon--start": e.start,
          "v-icon--end": e.end
        }, e.class]),
        style: le([{
          "--v-icon-opacity": e.opacity
        }, o.value ? void 0 : {
          fontSize: re(e.size),
          height: re(e.size),
          width: re(e.size)
        }, u.value, e.style]),
        role: d ? "button" : void 0,
        "aria-hidden": !d,
        tabindex: d ? e.disabled ? -1 : 0 : void 0
      }, {
        default: () => [c]
      });
    }), {};
  }
});
function li(e, t) {
  const n = G(), a = ae(!1);
  if (kc) {
    const r = new IntersectionObserver((l) => {
      a.value = !!l.find((i) => i.isIntersecting);
    }, t);
    It(() => {
      r.disconnect();
    }), ne(n, (l, i) => {
      i && (r.unobserve(i), a.value = !1), l && r.observe(l);
    }, {
      flush: "post"
    });
  }
  return {
    intersectionRef: n,
    isIntersecting: a
  };
}
const ET = U({
  reveal: {
    type: [Boolean, Object],
    default: !1
  }
}, "reveal");
function MT(e) {
  const n = D(() => typeof e.reveal == "object" ? Math.max(0, Number(e.reveal.duration ?? 900)) : 900), a = ae(e.reveal ? "initial" : "disabled");
  return bt(async () => {
    e.reveal && (a.value = "initial", await new Promise((r) => requestAnimationFrame(r)), a.value = "pending", await new Promise((r) => setTimeout(r, n.value)), a.value = "done");
  }), {
    duration: n,
    state: a
  };
}
const OT = U({
  bgColor: String,
  color: String,
  indeterminate: [Boolean, String],
  rounded: Boolean,
  modelValue: {
    type: [Number, String],
    default: 0
  },
  rotate: {
    type: [Number, String],
    default: 0
  },
  width: {
    type: [Number, String],
    default: 4
  },
  ...ve(),
  ...ET(),
  ...ea(),
  ...Ie({
    tag: "div"
  }),
  ...Re()
}, "VProgressCircular"), Aa = K()({
  name: "VProgressCircular",
  props: OT(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = 20, r = 2 * Math.PI * a, l = G(), {
      themeClasses: i
    } = Ge(e), {
      sizeClasses: o,
      sizeStyles: s
    } = ll(e), {
      textColorClasses: u,
      textColorStyles: c
    } = Nt(() => e.color), {
      textColorClasses: d,
      textColorStyles: f
    } = Nt(() => e.bgColor), {
      intersectionRef: v,
      isIntersecting: g
    } = li(), {
      resizeRef: m,
      contentRect: h
    } = Vn(), {
      state: w,
      duration: _
    } = MT(e), I = D(() => w.value === "initial" ? 0 : Xe(parseFloat(e.modelValue), 0, 100)), C = D(() => Number(e.width)), b = D(() => s.value ? Number(e.size) : h.value ? h.value.width : Math.max(C.value, 32)), p = D(() => a / (1 - C.value / b.value) * 2), x = D(() => C.value / b.value * p.value), k = D(() => {
      const A = (100 - I.value) / 100 * r;
      return e.rounded && I.value > 0 && I.value < 100 ? re(Math.min(r - 0.01, A + x.value)) : re(A);
    }), V = T(() => {
      const A = Number(e.rotate);
      return e.rounded ? A + x.value / 2 / r * 360 : A;
    });
    return ft(() => {
      v.value = l.value, m.value = l.value;
    }), X(() => y(e.tag, {
      ref: l,
      class: J(["v-progress-circular", {
        "v-progress-circular--indeterminate": !!e.indeterminate,
        "v-progress-circular--visible": g.value,
        "v-progress-circular--disable-shrink": e.indeterminate && (e.indeterminate === "disable-shrink" || Gn()),
        "v-progress-circular--revealing": ["initial", "pending"].includes(w.value)
      }, i.value, o.value, u.value, e.class]),
      style: le([s.value, c.value, {
        "--progress-reveal-duration": `${_.value}ms`
      }, e.style]),
      role: "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-valuenow": e.indeterminate ? void 0 : I.value
    }, {
      default: () => [S("svg", {
        style: {
          transform: `rotate(calc(-90deg + ${V.value}deg))`
        },
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: `0 0 ${p.value} ${p.value}`
      }, [S("circle", {
        class: J(["v-progress-circular__underlay", d.value]),
        style: le(f.value),
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: a,
        "stroke-width": x.value,
        "stroke-dasharray": r,
        "stroke-dashoffset": 0
      }, null), S("circle", {
        class: "v-progress-circular__overlay",
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: a,
        "stroke-width": x.value,
        "stroke-dasharray": r,
        "stroke-dashoffset": k.value,
        "stroke-linecap": e.rounded ? "round" : void 0
      }, null)]), n.default && S("div", {
        class: "v-progress-circular__content"
      }, [n.default({
        value: I.value
      })])]
    })), {};
  }
}), DT = U({
  chunkCount: {
    type: [Number, String],
    default: null
  },
  chunkWidth: {
    type: [Number, String],
    default: null
  },
  chunkGap: {
    type: [Number, String],
    default: 4
  }
}, "chunks");
function LT(e, t) {
  const n = D(() => !!e.chunkCount || !!e.chunkWidth), a = T(() => {
    const o = nt(t);
    if (!o)
      return 0;
    if (!e.chunkCount)
      return Number(e.chunkWidth);
    const s = Number(e.chunkCount);
    return (o - Number(e.chunkGap) * (s - 1)) / s;
  }), r = D(() => Number(e.chunkGap)), l = T(() => {
    if (!n.value)
      return {};
    const o = re(r.value), s = re(a.value);
    return {
      maskRepeat: "repeat-x",
      maskImage: `linear-gradient(90deg, #000, #000 ${s}, transparent ${s}, transparent)`,
      maskSize: `calc(${s} + ${o}) 100%`
    };
  });
  function i(o) {
    const s = nt(t);
    if (!s)
      return o;
    const u = 100 * r.value / s, c = 100 * (a.value + r.value) / s, d = Math.floor((o + u) / c);
    return Xe(0, d * c - u / 2, 100);
  }
  return {
    hasChunks: n,
    chunksMaskStyles: l,
    snapValueToChunk: i
  };
}
const NT = U({
  absolute: Boolean,
  active: {
    type: Boolean,
    default: !0
  },
  bgColor: String,
  bgOpacity: [Number, String],
  bufferValue: {
    type: [Number, String],
    default: 0
  },
  bufferColor: String,
  bufferOpacity: [Number, String],
  clickable: Boolean,
  color: String,
  height: {
    type: [Number, String],
    default: 4
  },
  indeterminate: Boolean,
  max: {
    type: [Number, String],
    default: 100
  },
  modelValue: {
    type: [Number, String],
    default: 0
  },
  opacity: [Number, String],
  reverse: Boolean,
  stream: Boolean,
  striped: Boolean,
  roundedBar: Boolean,
  ...DT(),
  ...ve(),
  ...Qn({
    location: "top"
  }),
  ...lt(),
  ...Ie(),
  ...Re()
}, "VProgressLinear"), Uo = K()({
  name: "VProgressLinear",
  props: NT(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = G(), r = he(e, "modelValue"), {
      isRtl: l,
      rtlClasses: i
    } = At(), {
      themeClasses: o
    } = Ge(e), {
      locationStyles: s
    } = La(e), {
      textColorClasses: u,
      textColorStyles: c
    } = Nt(() => e.color), {
      backgroundColorClasses: d,
      backgroundColorStyles: f
    } = qe(() => e.bgColor || e.color), {
      backgroundColorClasses: v,
      backgroundColorStyles: g
    } = qe(() => e.bufferColor || e.bgColor || e.color), {
      backgroundColorClasses: m,
      backgroundColorStyles: h
    } = qe(() => e.color), {
      roundedClasses: w
    } = ut(e), {
      intersectionRef: _,
      isIntersecting: I
    } = li(), C = T(() => parseFloat(e.max)), b = T(() => parseFloat(e.height)), p = T(() => Xe(parseFloat(e.bufferValue) / C.value * 100, 0, 100)), x = T(() => Xe(parseFloat(r.value) / C.value * 100, 0, 100)), k = T(() => l.value !== e.reverse), V = T(() => e.indeterminate ? "fade-transition" : "slide-x-transition"), A = ae(0), {
      hasChunks: M,
      chunksMaskStyles: L,
      snapValueToChunk: E
    } = LT(e, A);
    Wt(M, () => {
      const {
        resizeRef: B
      } = Vn((N) => A.value = N[0].contentRect.width);
      ft(() => B.value = a.value);
    });
    const P = T(() => M.value ? E(p.value) : p.value), O = T(() => M.value ? E(x.value) : x.value);
    function F(B) {
      if (!_.value) return;
      const {
        left: N,
        right: W,
        width: R
      } = _.value.getBoundingClientRect(), j = k.value ? R - B.clientX + (W - R) : B.clientX - N;
      r.value = Math.round(j / R * C.value);
    }
    return ft(() => {
      _.value = a.value;
    }), X(() => y(e.tag, {
      ref: a,
      class: J(["v-progress-linear", {
        "v-progress-linear--absolute": e.absolute,
        "v-progress-linear--active": e.active && I.value,
        "v-progress-linear--reverse": k.value,
        "v-progress-linear--rounded": e.rounded,
        "v-progress-linear--rounded-bar": e.roundedBar,
        "v-progress-linear--striped": e.striped,
        "v-progress-linear--clickable": e.clickable
      }, w.value, o.value, i.value, e.class]),
      style: le([{
        bottom: e.location === "bottom" ? 0 : void 0,
        top: e.location === "top" ? 0 : void 0,
        height: e.active ? re(b.value) : 0,
        "--v-progress-linear-height": re(b.value),
        ...e.absolute ? s.value : {}
      }, L.value, e.style]),
      role: "progressbar",
      "aria-hidden": e.active ? "false" : "true",
      "aria-valuemin": "0",
      "aria-valuemax": e.max,
      "aria-valuenow": e.indeterminate ? void 0 : Math.min(parseFloat(r.value), C.value),
      onClick: e.clickable && F
    }, {
      default: () => [e.stream && S("div", {
        key: "stream",
        class: J(["v-progress-linear__stream", u.value]),
        style: {
          ...c.value,
          [k.value ? "left" : "right"]: re(-b.value),
          borderTop: `${re(b.value / 2)} dotted`,
          opacity: parseFloat(e.bufferOpacity),
          top: `calc(50% - ${re(b.value / 4)})`,
          width: re(100 - p.value, "%"),
          "--v-progress-linear-stream-to": re(b.value * (k.value ? 1 : -1))
        }
      }, null), S("div", {
        class: J(["v-progress-linear__background", d.value]),
        style: le([f.value, {
          opacity: parseFloat(e.bgOpacity),
          width: e.stream ? 0 : void 0
        }])
      }, null), S("div", {
        class: J(["v-progress-linear__buffer", v.value]),
        style: le([g.value, {
          opacity: parseFloat(e.bufferOpacity),
          width: re(P.value, "%")
        }])
      }, null), y(Rn, {
        name: V.value
      }, {
        default: () => [e.indeterminate ? S("div", {
          class: "v-progress-linear__indeterminate"
        }, [["long", "short"].map((B) => S("div", {
          key: B,
          class: J(["v-progress-linear__indeterminate", B, m.value]),
          style: le(h.value)
        }, null))]) : S("div", {
          class: J(["v-progress-linear__determinate", m.value]),
          style: le([h.value, {
            width: re(O.value, "%")
          }])
        }, null)]
      }), n.default && S("div", {
        class: "v-progress-linear__content"
      }, [n.default({
        value: x.value,
        buffer: p.value
      })])]
    })), {};
  }
}), Wo = U({
  loading: [Boolean, String]
}, "loader");
function ii(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Xn();
  return {
    loaderClasses: D(() => ({
      [`${t}--loading`]: e.loading
    }))
  };
}
function oi(e, t) {
  let {
    slots: n
  } = t;
  return S("div", {
    class: J(`${e.name}__loader`)
  }, [n.default?.({
    color: e.color,
    isActive: e.active
  }) || y(Uo, {
    absolute: e.absolute,
    active: e.active,
    color: e.color,
    height: "2",
    indeterminate: !0
  }, null)]);
}
const FT = ["static", "relative", "fixed", "absolute", "sticky"], il = U({
  position: {
    type: String,
    validator: (
      /* istanbul ignore next */
      (e) => FT.includes(e)
    )
  }
}, "position");
function ol(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Xn();
  return {
    positionClasses: D(() => e.position ? `${t}--${e.position}` : void 0)
  };
}
function RT() {
  const e = kt("useRoute");
  return T(() => e?.proxy?.$route);
}
function Vg() {
  return kt("useRouter")?.proxy?.$router;
}
function si(e, t) {
  const n = qp("RouterLink"), a = D(() => !!(e.href || e.to)), r = T(() => a?.value || tv(t, "click") || tv(e, "click"));
  if (typeof n == "string" || !("useLink" in n)) {
    const d = D(() => e.href);
    return {
      isLink: a,
      isRouterLink: D(() => !1),
      isClickable: r,
      href: d,
      linkProps: cn({
        href: d
      }),
      route: D(() => {
      }),
      navigate: D(() => {
      })
    };
  }
  const l = n.useLink({
    to: D(() => e.to || ""),
    replace: D(() => e.replace)
  }), i = T(() => e.to ? l : void 0), o = RT(), s = T(() => i.value ? e.exact ? o.value ? i.value.isExactActive?.value && Lt(i.value.route.value.query, o.value.query) : i.value.isExactActive?.value ?? !1 : i.value.isActive?.value ?? !1 : !1), u = T(() => e.to ? i.value?.route.value.href : e.href), c = D(() => !!e.to);
  return {
    isLink: a,
    isRouterLink: c,
    isClickable: r,
    isActive: s,
    route: D(() => i.value?.route.value),
    navigate: D(() => i.value?.navigate),
    href: u,
    linkProps: cn({
      href: u,
      "aria-current": D(() => s.value ? "page" : void 0),
      "aria-disabled": D(() => e.disabled && a.value ? "true" : void 0),
      tabindex: D(() => e.disabled && a.value ? "-1" : void 0)
    })
  };
}
const ui = U({
  href: String,
  replace: Boolean,
  to: [String, Object],
  exact: Boolean
}, "router");
let As = !1;
function $T(e, t) {
  let n = !1, a, r;
  wt && e?.beforeEach && (Se(() => {
    window.addEventListener("popstate", l), a = e.beforeEach((i, o, s) => {
      As ? n ? t(s) : s() : setTimeout(() => n ? t(s) : s()), As = !0;
    }), r = e?.afterEach(() => {
      As = !1;
    });
  }), It(() => {
    window.removeEventListener("popstate", l), a?.(), r?.();
  }));
  function l(i) {
    i.state?.replaced || (n = !0, setTimeout(() => n = !1));
  }
}
function BT(e, t) {
  ne(() => e.isActive?.value, (n) => {
    e.isLink.value && n != null && t && Se(() => {
      t(n);
    });
  }, {
    immediate: !0
  });
}
const yu = /* @__PURE__ */ Symbol("rippleStop"), UT = 80;
function Cv(e, t) {
  e.style.transform = t, e.style.webkitTransform = t;
}
function bu(e) {
  return e.constructor.name === "TouchEvent";
}
function Eg(e) {
  return e.constructor.name === "KeyboardEvent";
}
const WT = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = 0, r = 0;
  if (!Eg(e)) {
    const d = t.getBoundingClientRect(), f = bu(e) ? e.touches[e.touches.length - 1] : e;
    a = f.clientX - d.left, r = f.clientY - d.top;
  }
  let l = 0, i = 0.3;
  t._ripple?.circle ? (i = 0.15, l = t.clientWidth / 2, l = n.center ? l : l + Math.sqrt((a - l) ** 2 + (r - l) ** 2) / 4) : l = Math.sqrt(t.clientWidth ** 2 + t.clientHeight ** 2) / 2;
  const o = `${(t.clientWidth - l * 2) / 2}px`, s = `${(t.clientHeight - l * 2) / 2}px`, u = n.center ? o : `${a - l}px`, c = n.center ? s : `${r - l}px`;
  return {
    radius: l,
    scale: i,
    x: u,
    y: c,
    centerX: o,
    centerY: s
  };
}, uo = {
  /* eslint-disable max-statements */
  show(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!t?._ripple?.enabled)
      return;
    const a = document.createElement("span"), r = document.createElement("span");
    a.appendChild(r), a.className = "v-ripple__container", n.class && (a.className += ` ${n.class}`);
    const {
      radius: l,
      scale: i,
      x: o,
      y: s,
      centerX: u,
      centerY: c
    } = WT(e, t, n), d = `${l * 2}px`;
    r.className = "v-ripple__animation", r.style.width = d, r.style.height = d, t.appendChild(a);
    const f = window.getComputedStyle(t);
    f && f.position === "static" && (t.style.position = "relative", t.dataset.previousPosition = "static"), r.classList.add("v-ripple__animation--enter"), r.classList.add("v-ripple__animation--visible"), Cv(r, `translate(${o}, ${s}) scale3d(${i},${i},${i})`), r.dataset.activated = String(performance.now()), requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        r.classList.remove("v-ripple__animation--enter"), r.classList.add("v-ripple__animation--in"), Cv(r, `translate(${u}, ${c}) scale3d(1,1,1)`);
      });
    });
  },
  hide(e) {
    if (!e?._ripple?.enabled) return;
    const t = e.getElementsByClassName("v-ripple__animation");
    if (t.length === 0) return;
    const n = Array.from(t).findLast((l) => !l.dataset.isHiding);
    if (n) n.dataset.isHiding = "true";
    else return;
    const a = performance.now() - Number(n.dataset.activated), r = Math.max(250 - a, 0);
    setTimeout(() => {
      n.classList.remove("v-ripple__animation--in"), n.classList.add("v-ripple__animation--out"), setTimeout(() => {
        e.getElementsByClassName("v-ripple__animation").length === 1 && e.dataset.previousPosition && (e.style.position = e.dataset.previousPosition, delete e.dataset.previousPosition), n.parentNode?.parentNode === e && e.removeChild(n.parentNode);
      }, 300);
    }, r);
  }
};
function Mg(e) {
  return typeof e > "u" || !!e;
}
function Fl(e) {
  const t = {}, n = e.currentTarget;
  if (!(!n?._ripple || n._ripple.touched || e[yu])) {
    if (e[yu] = !0, bu(e))
      n._ripple.touched = !0, n._ripple.isTouch = !0;
    else if (n._ripple.isTouch) return;
    if (t.center = n._ripple.centered || Eg(e), n._ripple.class && (t.class = n._ripple.class), bu(e)) {
      if (n._ripple.showTimerCommit) return;
      n._ripple.showTimerCommit = () => {
        uo.show(e, n, t);
      }, n._ripple.showTimer = window.setTimeout(() => {
        n?._ripple?.showTimerCommit && (n._ripple.showTimerCommit(), n._ripple.showTimerCommit = null);
      }, UT);
    } else
      uo.show(e, n, t);
  }
}
function co(e) {
  e[yu] = !0;
}
function yn(e) {
  const t = e.currentTarget;
  if (t?._ripple) {
    if (window.clearTimeout(t._ripple.showTimer), e.type === "touchend" && t._ripple.showTimerCommit) {
      t._ripple.showTimerCommit(), t._ripple.showTimerCommit = null, t._ripple.showTimer = window.setTimeout(() => {
        yn(e);
      });
      return;
    }
    window.setTimeout(() => {
      t._ripple && (t._ripple.touched = !1);
    }), uo.hide(t);
  }
}
function Og(e) {
  const t = e.currentTarget;
  t?._ripple && (t._ripple.showTimerCommit && (t._ripple.showTimerCommit = null), window.clearTimeout(t._ripple.showTimer));
}
let Rl = !1;
function HT(e, t) {
  !Rl && t.includes(e.key) && (Rl = !0, Fl(e));
}
function Dg(e) {
  Rl = !1, yn(e);
}
function Lg(e) {
  Rl && (Rl = !1, yn(e));
}
function Ng(e, t, n) {
  const {
    value: a,
    modifiers: r
  } = t, l = Mg(a);
  l || uo.hide(e), e._ripple = e._ripple ?? {}, e._ripple.enabled = l, e._ripple.centered = r.center, e._ripple.circle = r.circle;
  const i = Qa(a) ? a : {};
  i.class && (e._ripple.class = i.class);
  const o = i.keys ?? ["Enter", "Space"];
  if (e._ripple.keyDownHandler = (s) => HT(s, o), l && !n) {
    if (r.stop) {
      e.addEventListener("touchstart", co, {
        passive: !0
      }), e.addEventListener("mousedown", co);
      return;
    }
    e.addEventListener("touchstart", Fl, {
      passive: !0
    }), e.addEventListener("touchend", yn, {
      passive: !0
    }), e.addEventListener("touchmove", Og, {
      passive: !0
    }), e.addEventListener("touchcancel", yn), e.addEventListener("mousedown", Fl), e.addEventListener("mouseup", yn), e.addEventListener("mouseleave", yn), e.addEventListener("keydown", e._ripple.keyDownHandler), e.addEventListener("keyup", Dg), e.addEventListener("blur", Lg), e.addEventListener("dragstart", yn, {
      passive: !0
    });
  } else !l && n && Fg(e);
}
function Fg(e) {
  e.removeEventListener("touchstart", co), e.removeEventListener("mousedown", co), e.removeEventListener("touchstart", Fl), e.removeEventListener("touchend", yn), e.removeEventListener("touchmove", Og), e.removeEventListener("touchcancel", yn), e.removeEventListener("mousedown", Fl), e.removeEventListener("mouseup", yn), e.removeEventListener("mouseleave", yn), e._ripple?.keyDownHandler && e.removeEventListener("keydown", e._ripple.keyDownHandler), e.removeEventListener("keyup", Dg), e.removeEventListener("blur", Lg), e.removeEventListener("dragstart", yn);
}
function zT(e, t) {
  Ng(e, t, !1);
}
function jT(e) {
  Fg(e), delete e._ripple;
}
function GT(e, t) {
  if (t.value === t.oldValue)
    return;
  const n = Mg(t.oldValue);
  Ng(e, t, n);
}
const Ht = {
  mounted: zT,
  unmounted: jT,
  updated: GT
}, Ho = U({
  active: {
    type: Boolean,
    default: void 0
  },
  activeColor: String,
  baseColor: String,
  symbol: {
    type: null,
    default: Nc
  },
  flat: Boolean,
  icon: [Boolean, String, Function, Object],
  prependIcon: be,
  appendIcon: be,
  block: Boolean,
  readonly: Boolean,
  slim: Boolean,
  stacked: Boolean,
  spaced: String,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  text: {
    type: [String, Number, Boolean],
    default: void 0
  },
  ...qt(),
  ...ve(),
  ...mt(),
  ...St(),
  ...Ct(),
  ...mr(),
  ...Wo(),
  ...Qn(),
  ...il(),
  ...lt(),
  ...ui(),
  ...ea(),
  ...Ie({
    tag: "button"
  }),
  ...Re(),
  ...xn({
    variant: "elevated"
  })
}, "VBtn"), De = K()({
  name: "VBtn",
  props: Ho(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const {
      themeClasses: r
    } = Ge(e), {
      borderClasses: l
    } = en(e), {
      densityClasses: i
    } = zt(e), {
      dimensionStyles: o
    } = xt(e), {
      elevationClasses: s
    } = Et(e), {
      loaderClasses: u
    } = ii(e), {
      locationStyles: c
    } = La(e), {
      positionClasses: d
    } = ol(e), {
      roundedClasses: f
    } = ut(e), {
      sizeClasses: v,
      sizeStyles: g
    } = ll(e), m = Ia(e, e.symbol, !1), h = si(e, n), w = T(() => e.active !== void 0 ? e.active : h.isRouterLink.value ? h.isActive?.value : m?.isSelected.value), _ = D(() => w.value ? e.activeColor ?? e.color : e.color), I = T(() => ({
      color: m?.isSelected.value && (!h.isLink.value || h.isActive?.value) || !m || h.isActive?.value ? _.value ?? e.baseColor : e.baseColor,
      variant: e.variant
    })), {
      colorClasses: C,
      colorStyles: b,
      variantClasses: p
    } = va(I), x = T(() => m?.disabled.value || e.disabled), k = D(() => e.variant === "elevated" && !(e.disabled || e.flat || e.border)), V = T(() => {
      if (!(e.value === void 0 || typeof e.value == "symbol"))
        return Object(e.value) === e.value ? JSON.stringify(e.value, null, 0) : e.value;
    });
    function A(M) {
      x.value || h.isLink.value && (M.metaKey || M.ctrlKey || M.shiftKey || M.button !== 0 || n.target === "_blank") || (h.isRouterLink.value ? h.navigate.value?.(M) : m?.toggle());
    }
    return BT(h, m?.select), X(() => {
      const M = h.isLink.value ? "a" : e.tag, L = !!(e.prependIcon || a.prepend), E = !!(e.appendIcon || a.append), P = !!(e.icon && e.icon !== !0);
      return at(y(M, Y(h.linkProps, {
        type: M === "a" ? void 0 : "button",
        class: ["v-btn", m?.selectedClass.value, {
          "v-btn--active": w.value,
          "v-btn--block": e.block,
          "v-btn--disabled": x.value,
          "v-btn--elevated": k.value,
          "v-btn--flat": e.flat,
          "v-btn--icon": !!e.icon,
          "v-btn--loading": e.loading,
          "v-btn--readonly": e.readonly,
          "v-btn--slim": e.slim,
          "v-btn--stacked": e.stacked
        }, e.spaced ? ["v-btn--spaced", `v-btn--spaced-${e.spaced}`] : [], r.value, l.value, C.value, i.value, s.value, u.value, d.value, f.value, v.value, p.value, e.class],
        style: [b.value, o.value, c.value, g.value, e.style],
        "aria-busy": e.loading ? !0 : void 0,
        disabled: x.value && M !== "a" || void 0,
        tabindex: e.loading || e.readonly ? -1 : void 0,
        onClick: A,
        value: V.value
      }), {
        default: () => [fa(!0, "v-btn"), !e.icon && L && S("span", {
          key: "prepend",
          class: "v-btn__prepend"
        }, [a.prepend ? y(Ae, {
          key: "prepend-defaults",
          disabled: !e.prependIcon,
          defaults: {
            VIcon: {
              icon: e.prependIcon
            }
          }
        }, a.prepend) : y(ze, {
          key: "prepend-icon",
          icon: e.prependIcon
        }, null)]), S("span", {
          class: "v-btn__content",
          "data-no-activator": ""
        }, [!a.default && P ? y(ze, {
          key: "content-icon",
          icon: e.icon
        }, null) : y(Ae, {
          key: "content-defaults",
          disabled: !P,
          defaults: {
            VIcon: {
              icon: e.icon
            }
          }
        }, {
          default: () => [a.default?.() ?? ce(e.text)]
        })]), !e.icon && E && S("span", {
          key: "append",
          class: "v-btn__append"
        }, [a.append ? y(Ae, {
          key: "append-defaults",
          disabled: !e.appendIcon,
          defaults: {
            VIcon: {
              icon: e.appendIcon
            }
          }
        }, a.append) : y(ze, {
          key: "append-icon",
          icon: e.appendIcon
        }, null)]), !!e.loading && S("span", {
          key: "loader",
          class: "v-btn__loader"
        }, [a.loader?.() ?? y(Aa, {
          color: typeof e.loading == "boolean" ? void 0 : e.loading,
          indeterminate: !0,
          width: "2"
        }, null)])]
      }), [[Ht, !x.value && e.ripple, "", {
        center: !!e.icon
      }]]);
    }), {
      group: m
    };
  }
}), qT = U({
  ...Pe(Ho({
    icon: "$menu",
    variant: "text"
  }), ["spaced"])
}, "VAppBarNavIcon"), YT = K()({
  name: "VAppBarNavIcon",
  props: qT(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => y(De, Y(e, {
      class: ["v-app-bar-nav-icon"]
    }), n)), {};
  }
}), KT = K()({
  name: "VAppBarTitle",
  props: kg(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => y(Pc, Y(e, {
      class: "v-app-bar-title"
    }), n)), {};
  }
}), Rg = ca("v-alert-title"), $g = U({
  iconSize: [Number, String],
  iconSizes: {
    type: Array,
    default: () => [["x-small", 10], ["small", 16], ["default", 24], ["large", 28], ["x-large", 32]]
  }
}, "iconSize");
function Bg(e, t) {
  return {
    iconSize: T(() => {
      const a = new Map(e.iconSizes), r = e.iconSize ?? t() ?? "default";
      return a.has(r) ? a.get(r) : r;
    })
  };
}
const ZT = ["success", "info", "warning", "error"], JT = U({
  border: {
    type: [Boolean, String],
    validator: (e) => typeof e == "boolean" || ["top", "end", "bottom", "start"].includes(e)
  },
  borderColor: String,
  closable: Boolean,
  closeIcon: {
    type: be,
    default: "$close"
  },
  closeLabel: {
    type: String,
    default: "$vuetify.close"
  },
  icon: {
    type: [Boolean, String, Function, Object],
    default: null
  },
  modelValue: {
    type: Boolean,
    default: !0
  },
  prominent: Boolean,
  title: String,
  text: String,
  type: {
    type: String,
    validator: (e) => ZT.includes(e)
  },
  ...ve(),
  ...mt(),
  ...St(),
  ...Ct(),
  ...$g(),
  ...Qn(),
  ...il(),
  ...lt(),
  ...Ie(),
  ...Re(),
  ...xn({
    variant: "flat"
  })
}, "VAlert"), XT = K()({
  name: "VAlert",
  props: JT(),
  emits: {
    "click:close": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const r = he(e, "modelValue"), l = D(() => {
      if (e.icon !== !1)
        return e.type ? e.icon ?? `$${e.type}` : e.icon;
    }), {
      iconSize: i
    } = Bg(e, () => e.prominent ? 44 : void 0), {
      themeClasses: o
    } = Ge(e), {
      colorClasses: s,
      colorStyles: u,
      variantClasses: c
    } = va(() => ({
      color: e.color ?? e.type,
      variant: e.variant
    })), {
      densityClasses: d
    } = zt(e), {
      dimensionStyles: f
    } = xt(e), {
      elevationClasses: v
    } = Et(e), {
      locationStyles: g
    } = La(e), {
      positionClasses: m
    } = ol(e), {
      roundedClasses: h
    } = ut(e), {
      textColorClasses: w,
      textColorStyles: _
    } = Nt(() => e.borderColor), {
      t: I
    } = Ke(), C = D(() => ({
      "aria-label": I(e.closeLabel),
      onClick(b) {
        r.value = !1, n("click:close", b);
      }
    }));
    return () => {
      const b = !!(a.prepend || l.value), p = !!(a.title || e.title), x = !!(a.close || e.closable), k = {
        density: e.density,
        icon: l.value,
        size: e.iconSize || e.prominent ? i.value : void 0
      };
      return r.value && y(e.tag, {
        class: J(["v-alert", e.border && {
          "v-alert--border": !!e.border,
          [`v-alert--border-${e.border === !0 ? "start" : e.border}`]: !0
        }, {
          "v-alert--prominent": e.prominent
        }, o.value, s.value, d.value, v.value, m.value, h.value, c.value, e.class]),
        style: le([u.value, f.value, g.value, e.style]),
        role: "alert"
      }, {
        default: () => [fa(!1, "v-alert"), e.border && S("div", {
          key: "border",
          class: J(["v-alert__border", w.value]),
          style: le(_.value)
        }, null), b && S("div", {
          key: "prepend",
          class: "v-alert__prepend"
        }, [a.prepend ? y(Ae, {
          key: "prepend-defaults",
          disabled: !l.value,
          defaults: {
            VIcon: {
              ...k
            }
          }
        }, a.prepend) : y(ze, Y({
          key: "prepend-icon"
        }, k), null)]), S("div", {
          class: "v-alert__content"
        }, [p && y(Rg, {
          key: "title"
        }, {
          default: () => [a.title?.() ?? e.title]
        }), a.text?.() ?? e.text, a.default?.()]), a.append && S("div", {
          key: "append",
          class: "v-alert__append"
        }, [a.append()]), x && S("div", {
          key: "close",
          class: "v-alert__close"
        }, [a.close ? y(Ae, {
          key: "close-defaults",
          defaults: {
            VBtn: {
              icon: e.closeIcon,
              size: "x-small",
              variant: "text"
            }
          }
        }, {
          default: () => [a.close?.({
            props: C.value
          })]
        }) : y(De, Y({
          key: "close-btn",
          icon: e.closeIcon,
          size: "x-small",
          variant: "text"
        }, C.value), null)])]
      });
    };
  }
}), QT = U({
  start: Boolean,
  end: Boolean,
  icon: be,
  image: String,
  text: String,
  ...qt(),
  ...ve(),
  ...mt(),
  ...lt(),
  ...ea(),
  ...Ie(),
  ...Re(),
  ...xn({
    variant: "flat"
  })
}, "VAvatar"), kn = K()({
  name: "VAvatar",
  props: QT(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: a
    } = Ge(e), {
      borderClasses: r
    } = en(e), {
      colorClasses: l,
      colorStyles: i,
      variantClasses: o
    } = va(e), {
      densityClasses: s
    } = zt(e), {
      roundedClasses: u
    } = ut(e), {
      sizeClasses: c,
      sizeStyles: d
    } = ll(e);
    return X(() => y(e.tag, {
      class: J(["v-avatar", {
        "v-avatar--start": e.start,
        "v-avatar--end": e.end
      }, a.value, r.value, l.value, s.value, u.value, c.value, o.value, e.class]),
      style: le([i.value, d.value, e.style])
    }, {
      default: () => [n.default ? y(Ae, {
        key: "content-defaults",
        defaults: {
          VImg: {
            cover: !0,
            src: e.image
          },
          VIcon: {
            icon: e.icon
          }
        }
      }, {
        default: () => [n.default()]
      }) : e.image ? y(sa, {
        key: "image",
        src: e.image,
        alt: "",
        cover: !0
      }, null) : e.icon ? y(ze, {
        key: "icon",
        icon: e.icon
      }, null) : e.text, fa(!1, "v-avatar")]
    })), {};
  }
}), eI = U({
  text: String,
  onClick: Ut(),
  ...ve(),
  ...Re()
}, "VLabel"), sl = K()({
  name: "VLabel",
  props: eI(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => S("label", {
      class: J(["v-label", {
        "v-label--clickable": !!e.onClick
      }, e.class]),
      style: le(e.style),
      onClick: e.onClick
    }, [e.text, n.default?.()])), {};
  }
}), Ug = /* @__PURE__ */ Symbol.for("vuetify:selection-control-group"), Fc = U({
  color: String,
  disabled: {
    type: Boolean,
    default: null
  },
  defaultsTarget: String,
  error: Boolean,
  id: String,
  inline: Boolean,
  falseIcon: be,
  trueIcon: be,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  multiple: {
    type: Boolean,
    default: null
  },
  name: String,
  readonly: {
    type: Boolean,
    default: null
  },
  modelValue: null,
  type: String,
  valueComparator: {
    type: Function,
    default: Lt
  },
  ...ve(),
  ...mt(),
  ...Re()
}, "SelectionControlGroup"), tI = U({
  ...Fc({
    defaultsTarget: "VSelectionControl"
  })
}, "VSelectionControlGroup"), Wg = K()({
  name: "VSelectionControlGroup",
  props: tI(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = he(e, "modelValue"), r = Rt(), l = D(() => e.id || `v-selection-control-group-${r}`), i = D(() => e.name || l.value), o = /* @__PURE__ */ new Set();
    return st(Ug, {
      modelValue: a,
      forceUpdate: () => {
        o.forEach((s) => s());
      },
      onForceUpdate: (s) => {
        o.add(s), It(() => {
          o.delete(s);
        });
      }
    }), vt({
      [e.defaultsTarget]: {
        color: D(() => e.color),
        disabled: D(() => e.disabled),
        density: D(() => e.density),
        error: D(() => e.error),
        inline: D(() => e.inline),
        modelValue: a,
        multiple: D(() => !!e.multiple || e.multiple == null && Array.isArray(a.value)),
        name: i,
        falseIcon: D(() => e.falseIcon),
        trueIcon: D(() => e.trueIcon),
        readonly: D(() => e.readonly),
        ripple: D(() => e.ripple),
        type: D(() => e.type),
        valueComparator: D(() => e.valueComparator)
      }
    }), X(() => S("div", {
      class: J(["v-selection-control-group", {
        "v-selection-control-group--inline": e.inline
      }, e.class]),
      style: le(e.style),
      role: e.type === "radio" ? "radiogroup" : void 0
    }, [n.default?.()])), {};
  }
}), zo = U({
  label: String,
  baseColor: String,
  trueValue: null,
  falseValue: null,
  value: null,
  ...ve(),
  ...Fc()
}, "VSelectionControl");
function nI(e) {
  const t = Le(Ug, void 0), {
    densityClasses: n
  } = zt(e), a = he(e, "modelValue"), r = T(() => e.trueValue !== void 0 ? e.trueValue : e.value !== void 0 ? e.value : !0), l = T(() => e.falseValue !== void 0 ? e.falseValue : !1), i = T(() => !!e.multiple || e.multiple == null && Array.isArray(a.value)), o = T({
    get() {
      const v = t ? t.modelValue.value : a.value;
      return i.value ? rt(v).some((g) => e.valueComparator(g, r.value)) : e.valueComparator(v, r.value);
    },
    set(v) {
      if (e.readonly) return;
      const g = v ? r.value : l.value;
      let m = g;
      i.value && (m = v ? [...rt(a.value), g] : rt(a.value).filter((h) => !e.valueComparator(h, r.value))), t ? t.modelValue.value = m : a.value = m;
    }
  }), {
    textColorClasses: s,
    textColorStyles: u
  } = Nt(() => {
    if (!(e.error || e.disabled))
      return o.value ? e.color : e.baseColor;
  }), {
    backgroundColorClasses: c,
    backgroundColorStyles: d
  } = qe(() => o.value && !e.error && !e.disabled ? e.color : e.baseColor), f = T(() => o.value ? e.trueIcon : e.falseIcon);
  return {
    group: t,
    densityClasses: n,
    trueValue: r,
    falseValue: l,
    model: o,
    textColorClasses: s,
    textColorStyles: u,
    backgroundColorClasses: c,
    backgroundColorStyles: d,
    icon: f
  };
}
const Pa = K()({
  name: "VSelectionControl",
  directives: {
    vRipple: Ht
  },
  inheritAttrs: !1,
  props: zo(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const {
      group: r,
      densityClasses: l,
      icon: i,
      model: o,
      textColorClasses: s,
      textColorStyles: u,
      backgroundColorClasses: c,
      backgroundColorStyles: d,
      trueValue: f
    } = nI(e), v = Rt(), g = ae(!1), m = ae(!1), h = G(), w = D(() => e.id || `input-${v}`), _ = D(() => !e.disabled && !e.readonly);
    r?.onForceUpdate(() => {
      h.value && (h.value.checked = o.value);
    });
    function I(x) {
      _.value && (g.value = !0, Hr(x.target, ":focus-visible") !== !1 && (m.value = !0));
    }
    function C() {
      g.value = !1, m.value = !1;
    }
    function b(x) {
      x.stopPropagation();
    }
    function p(x) {
      if (!_.value) {
        h.value && (h.value.checked = o.value);
        return;
      }
      e.readonly && r && Se(() => r.forceUpdate()), o.value = x.target.checked;
    }
    return X(() => {
      const x = a.label ? a.label({
        label: e.label,
        props: {
          for: w.value
        }
      }) : e.label, [k, V] = Jn(n), A = S("input", Y({
        ref: h,
        checked: o.value,
        disabled: !!e.disabled,
        id: w.value,
        onBlur: C,
        onFocus: I,
        onInput: p,
        "aria-disabled": !!e.disabled,
        "aria-label": e.label,
        type: e.type,
        value: f.value,
        name: e.name,
        "aria-checked": e.type === "checkbox" ? o.value : void 0
      }, V), null);
      return S("div", Y({
        class: ["v-selection-control", {
          "v-selection-control--dirty": o.value,
          "v-selection-control--disabled": e.disabled,
          "v-selection-control--error": e.error,
          "v-selection-control--focused": g.value,
          "v-selection-control--focus-visible": m.value,
          "v-selection-control--inline": e.inline
        }, l.value, e.class]
      }, k, {
        style: e.style
      }), [S("div", {
        class: J(["v-selection-control__wrapper", s.value]),
        style: le(u.value)
      }, [a.default?.({
        backgroundColorClasses: c,
        backgroundColorStyles: d
      }), at(S("div", {
        class: J(["v-selection-control__input"])
      }, [a.input?.({
        model: o,
        textColorClasses: s,
        textColorStyles: u,
        backgroundColorClasses: c,
        backgroundColorStyles: d,
        inputNode: A,
        icon: i.value,
        props: {
          onFocus: I,
          onBlur: C,
          id: w.value
        }
      }) ?? S(fe, null, [i.value && y(ze, {
        key: "icon",
        icon: i.value
      }, null), A])]), [[Ht, !e.disabled && !e.readonly && e.ripple, null, {
        center: !0,
        circle: !0
      }]])]), x && y(sl, {
        for: w.value,
        onClick: b
      }, {
        default: () => [x]
      })]);
    }), {
      isFocused: g,
      input: h
    };
  }
}), Hg = U({
  indeterminate: Boolean,
  indeterminateIcon: {
    type: be,
    default: "$checkboxIndeterminate"
  },
  ...zo({
    falseIcon: "$checkboxOff",
    trueIcon: "$checkboxOn"
  })
}, "VCheckboxBtn"), Un = K()({
  name: "VCheckboxBtn",
  props: Hg(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:indeterminate": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = he(e, "indeterminate"), r = he(e, "modelValue");
    function l(s) {
      a.value && (a.value = !1);
    }
    const i = D(() => a.value ? e.indeterminateIcon : e.falseIcon), o = D(() => a.value ? e.indeterminateIcon : e.trueIcon);
    return X(() => {
      const s = Pe(Pa.filterProps(e), ["modelValue"]);
      return y(Pa, Y(s, {
        modelValue: r.value,
        "onUpdate:modelValue": [(u) => r.value = u, l],
        class: ["v-checkbox-btn", e.class],
        style: e.style,
        type: "checkbox",
        falseIcon: i.value,
        trueIcon: o.value,
        "aria-checked": a.value ? "mixed" : void 0
      }), n);
    }), {};
  }
});
function ci(e) {
  const {
    t
  } = Ke();
  function n(a) {
    let {
      name: r,
      color: l,
      ...i
    } = a;
    const o = {
      prepend: "prependAction",
      prependInner: "prependAction",
      append: "appendAction",
      appendInner: "appendAction",
      clear: "clear"
    }[r], s = e[`onClick:${r}`];
    function u(d) {
      d.key !== "Enter" && d.key !== " " || (d.preventDefault(), d.stopPropagation(), ai(s, new PointerEvent("click", d)));
    }
    const c = s && o ? t(`$vuetify.input.${o}`, e.label ?? "") : void 0;
    return y(ze, Y({
      icon: e[`${r}Icon`],
      "aria-label": c,
      onClick: s,
      onKeydown: u,
      color: l
    }, i), null);
  }
  return {
    InputIcon: n
  };
}
const aI = U({
  active: Boolean,
  color: String,
  messages: {
    type: [Array, String],
    default: () => []
  },
  ...ve(),
  ...da({
    transition: {
      component: Oc,
      leaveAbsolute: !0,
      group: !0
    }
  })
}, "VMessages"), zg = K()({
  name: "VMessages",
  props: aI(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = T(() => rt(e.messages)), {
      textColorClasses: r,
      textColorStyles: l
    } = Nt(() => e.color);
    return X(() => y(Xt, {
      transition: e.transition,
      tag: "div",
      class: J(["v-messages", r.value, e.class]),
      style: le([l.value, e.style])
    }, {
      default: () => [e.active && a.value.map((i, o) => S("div", {
        class: "v-messages__message",
        key: `${o}-${a.value}`
      }, [n.message ? n.message({
        message: i
      }) : i]))]
    })), {};
  }
}), di = U({
  focused: Boolean,
  "onUpdate:focused": Ut()
}, "focus");
function ma(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Xn();
  const n = he(e, "focused"), a = D(() => ({
    [`${t}--focused`]: n.value
  }));
  function r() {
    n.value = !0;
  }
  function l() {
    n.value = !1;
  }
  return {
    focusClasses: a,
    isFocused: n,
    focus: r,
    blur: l
  };
}
const jg = /* @__PURE__ */ Symbol.for("vuetify:form"), rI = U({
  disabled: Boolean,
  fastFail: Boolean,
  readonly: Boolean,
  modelValue: {
    type: Boolean,
    default: null
  },
  validateOn: {
    type: String,
    default: "input"
  }
}, "form");
function lI(e) {
  const t = he(e, "modelValue"), n = D(() => e.disabled), a = D(() => e.readonly), r = ae(!1), l = G([]), i = G([]);
  async function o() {
    const c = [];
    let d = !0;
    i.value = [], r.value = !0;
    for (const f of l.value) {
      const v = await f.validate();
      if (v.length > 0 && (d = !1, c.push({
        id: f.id,
        errorMessages: v
      })), !d && e.fastFail) break;
    }
    return i.value = c, r.value = !1, {
      valid: d,
      errors: i.value
    };
  }
  function s() {
    l.value.forEach((c) => c.reset());
  }
  function u() {
    l.value.forEach((c) => c.resetValidation());
  }
  return ne(l, () => {
    let c = 0, d = 0;
    const f = [];
    for (const v of l.value)
      v.isValid === !1 ? (d++, f.push({
        id: v.id,
        errorMessages: v.errorMessages
      })) : v.isValid === !0 && c++;
    i.value = f, t.value = d > 0 ? !1 : c === l.value.length ? !0 : null;
  }, {
    deep: !0,
    flush: "post"
  }), st(jg, {
    register: (c) => {
      let {
        id: d,
        vm: f,
        validate: v,
        reset: g,
        resetValidation: m
      } = c;
      l.value.some((h) => h.id === d) && jt(`Duplicate input name "${d}"`), l.value.push({
        id: d,
        validate: v,
        reset: g,
        resetValidation: m,
        vm: Yp(f),
        isValid: null,
        errorMessages: []
      });
    },
    unregister: (c) => {
      l.value = l.value.filter((d) => d.id !== c);
    },
    update: (c, d, f) => {
      const v = l.value.find((g) => g.id === c);
      v && (v.isValid = d, v.errorMessages = f);
    },
    isDisabled: n,
    isReadonly: a,
    isValidating: r,
    isValid: t,
    items: l,
    validateOn: D(() => e.validateOn)
  }), {
    errors: i,
    isDisabled: n,
    isReadonly: a,
    isValidating: r,
    isValid: t,
    items: l,
    validate: o,
    reset: s,
    resetValidation: u
  };
}
function ul(e) {
  const t = Le(jg, null);
  return {
    ...t,
    isReadonly: T(() => !!(e?.readonly ?? t?.isReadonly.value)),
    isDisabled: T(() => !!(e?.disabled ?? t?.isDisabled.value))
  };
}
const iI = /* @__PURE__ */ Symbol.for("vuetify:rules");
function oI(e) {
  const t = Le(iI, null);
  if (!e) {
    if (!t)
      throw new Error("Could not find Vuetify rules injection");
    return t.aliases;
  }
  return t?.resolve(e) ?? D(e);
}
const Gg = U({
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  errorMessages: {
    type: [Array, String],
    default: () => []
  },
  maxErrors: {
    type: [Number, String],
    default: 1
  },
  name: String,
  label: String,
  readonly: {
    type: Boolean,
    default: null
  },
  rules: {
    type: Array,
    default: () => []
  },
  modelValue: null,
  validateOn: String,
  validationValue: null,
  ...di()
}, "validation");
function qg(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Xn(), n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Rt();
  const a = he(e, "modelValue"), r = T(() => e.validationValue === void 0 ? a.value : e.validationValue), l = ul(e), i = oI(() => e.rules), o = G([]), s = ae(!0), u = T(() => !!(rt(a.value === "" ? null : a.value).length || rt(r.value === "" ? null : r.value).length)), c = T(() => e.errorMessages?.length ? rt(e.errorMessages).concat(o.value).slice(0, Math.max(0, Number(e.maxErrors))) : o.value), d = T(() => {
    let C = (e.validateOn ?? l.validateOn?.value) || "input";
    C === "lazy" && (C = "input lazy"), C === "eager" && (C = "input eager");
    const b = new Set(C?.split(" ") ?? []);
    return {
      input: b.has("input"),
      blur: b.has("blur") || b.has("input") || b.has("invalid-input"),
      invalidInput: b.has("invalid-input"),
      lazy: b.has("lazy"),
      eager: b.has("eager")
    };
  }), f = T(() => e.error || e.errorMessages?.length ? !1 : e.rules.length ? s.value ? o.value.length || d.value.lazy ? null : !0 : !o.value.length : !0), v = ae(!1), g = T(() => ({
    [`${t}--error`]: f.value === !1,
    [`${t}--dirty`]: u.value,
    [`${t}--disabled`]: l.isDisabled.value,
    [`${t}--readonly`]: l.isReadonly.value
  })), m = kt("validation"), h = T(() => e.name ?? Z(n));
  Gl(() => {
    l.register?.({
      id: h.value,
      vm: m,
      validate: I,
      reset: w,
      resetValidation: _
    });
  }), Ft(() => {
    l.unregister?.(h.value);
  }), bt(async () => {
    d.value.lazy || await I(!d.value.eager), l.update?.(h.value, f.value, c.value);
  }), Wt(() => d.value.input || d.value.invalidInput && f.value === !1, () => {
    ne(r, () => {
      if (r.value != null)
        I();
      else if (e.focused) {
        const C = ne(() => e.focused, (b) => {
          b || I(), C();
        });
      }
    });
  }), Wt(() => d.value.blur, () => {
    ne(() => e.focused, (C) => {
      C || I();
    });
  }), ne([f, c], () => {
    l.update?.(h.value, f.value, c.value);
  });
  async function w() {
    a.value = null, await Se(), await _();
  }
  async function _() {
    s.value = !0, d.value.lazy ? o.value = [] : await I(!d.value.eager);
  }
  async function I() {
    let C = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    const b = [];
    v.value = !0;
    for (const p of i.value) {
      if (b.length >= Number(e.maxErrors ?? 1))
        break;
      const k = await (typeof p == "function" ? p : () => p)(r.value);
      if (k !== !0) {
        if (k !== !1 && typeof k != "string") {
          console.warn(`${k} is not a valid value. Rule functions must return boolean true or a string.`);
          continue;
        }
        b.push(k || "");
      }
    }
    return o.value = b, v.value = !1, s.value = C, o.value;
  }
  return {
    errorMessages: c,
    isDirty: u,
    isDisabled: l.isDisabled,
    isReadonly: l.isReadonly,
    isPristine: s,
    isValid: f,
    isValidating: v,
    reset: w,
    resetValidation: _,
    validate: I,
    validationClasses: g
  };
}
const ha = U({
  id: String,
  appendIcon: be,
  baseColor: String,
  centerAffix: {
    type: Boolean,
    default: !0
  },
  color: String,
  glow: Boolean,
  iconColor: [Boolean, String],
  prependIcon: be,
  hideDetails: [Boolean, String],
  hideSpinButtons: Boolean,
  hint: String,
  persistentHint: Boolean,
  messages: {
    type: [Array, String],
    default: () => []
  },
  direction: {
    type: String,
    default: "horizontal",
    validator: (e) => ["horizontal", "vertical"].includes(e)
  },
  "onClick:prepend": Ut(),
  "onClick:append": Ut(),
  ...ve(),
  ...mt(),
  ...an(St(), ["maxWidth", "minWidth", "width"]),
  ...Re(),
  ...Gg()
}, "VInput"), Gt = K()({
  name: "VInput",
  props: {
    ...ha()
  },
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: a,
      emit: r
    } = t;
    const {
      densityClasses: l
    } = zt(e), {
      dimensionStyles: i
    } = xt(e), {
      themeClasses: o
    } = Ge(e), {
      rtlClasses: s
    } = At(), {
      InputIcon: u
    } = ci(e), c = Rt(), d = T(() => e.id || `input-${c}`), {
      errorMessages: f,
      isDirty: v,
      isDisabled: g,
      isReadonly: m,
      isPristine: h,
      isValid: w,
      isValidating: _,
      reset: I,
      resetValidation: C,
      validate: b,
      validationClasses: p
    } = qg(e, "v-input", d), x = T(() => e.errorMessages?.length || !h.value && f.value.length ? f.value : e.hint && (e.persistentHint || e.focused) ? e.hint : e.messages), k = D(() => x.value.length > 0), V = D(() => !e.hideDetails || e.hideDetails === "auto" && (k.value || !!a.details)), A = T(() => V.value ? `${d.value}-messages` : void 0), M = T(() => ({
      id: d,
      messagesId: A,
      isDirty: v,
      isDisabled: g,
      isReadonly: m,
      isPristine: h,
      isValid: w,
      isValidating: _,
      hasDetails: V,
      reset: I,
      resetValidation: C,
      validate: b
    })), L = D(() => e.error || e.disabled ? void 0 : e.focused ? e.color : e.baseColor), E = D(() => {
      if (e.iconColor)
        return e.iconColor === !0 ? L.value : e.iconColor;
    });
    return X(() => {
      const P = !!(a.prepend || e.prependIcon), O = !!(a.append || e.appendIcon);
      return S("div", {
        class: J(["v-input", `v-input--${e.direction}`, {
          "v-input--center-affix": e.centerAffix,
          "v-input--focused": e.focused,
          "v-input--glow": e.glow,
          "v-input--hide-spin-buttons": e.hideSpinButtons
        }, l.value, o.value, s.value, p.value, e.class]),
        style: le([i.value, e.style])
      }, [P && S("div", {
        key: "prepend",
        class: "v-input__prepend"
      }, [a.prepend ? a.prepend(M.value) : e.prependIcon && y(u, {
        key: "prepend-icon",
        name: "prepend",
        color: E.value
      }, null)]), a.default && S("div", {
        class: "v-input__control"
      }, [a.default?.(M.value)]), O && S("div", {
        key: "append",
        class: "v-input__append"
      }, [a.append ? a.append(M.value) : e.appendIcon && y(u, {
        key: "append-icon",
        name: "append",
        color: E.value
      }, null)]), V.value && S("div", {
        id: A.value,
        class: "v-input__details",
        role: "alert",
        "aria-live": "polite"
      }, [y(zg, {
        active: k.value,
        messages: x.value
      }, {
        message: a.message
      }), a.details?.(M.value)])]);
    }), {
      reset: I,
      resetValidation: C,
      validate: b,
      isValid: w,
      errorMessages: f
    };
  }
}), Ps = /* @__PURE__ */ Symbol("Forwarded refs");
function Vs(e, t) {
  let n = e;
  for (; n; ) {
    const a = Reflect.getOwnPropertyDescriptor(n, t);
    if (a) return a;
    n = Object.getPrototypeOf(n);
  }
}
function Mt(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return e[Ps] = n, new Proxy(e, {
    get(r, l) {
      if (Reflect.has(r, l))
        return Reflect.get(r, l);
      if (!(typeof l == "symbol" || l.startsWith("$") || l.startsWith("__"))) {
        for (const i of n)
          if (i.value && Reflect.has(i.value, l)) {
            const o = Reflect.get(i.value, l);
            return typeof o == "function" ? o.bind(i.value) : o;
          }
      }
    },
    has(r, l) {
      if (Reflect.has(r, l))
        return !0;
      if (typeof l == "symbol" || l.startsWith("$") || l.startsWith("__")) return !1;
      for (const i of n)
        if (i.value && Reflect.has(i.value, l))
          return !0;
      return !1;
    },
    set(r, l, i) {
      if (Reflect.has(r, l))
        return Reflect.set(r, l, i);
      if (typeof l == "symbol" || l.startsWith("$") || l.startsWith("__")) return !1;
      for (const o of n)
        if (o.value && Reflect.has(o.value, l))
          return Reflect.set(o.value, l, i);
      return !1;
    },
    getOwnPropertyDescriptor(r, l) {
      const i = Reflect.getOwnPropertyDescriptor(r, l);
      if (i) return i;
      if (!(typeof l == "symbol" || l.startsWith("$") || l.startsWith("__"))) {
        for (const o of n) {
          if (!o.value) continue;
          const s = Vs(o.value, l) ?? ("_" in o.value ? Vs(o.value._?.setupState, l) : void 0);
          if (s) return s;
        }
        for (const o of n) {
          const s = o.value && o.value[Ps];
          if (!s) continue;
          const u = s.slice();
          for (; u.length; ) {
            const c = u.shift(), d = Vs(c.value, l);
            if (d) return d;
            const f = c.value && c.value[Ps];
            f && u.push(...f);
          }
        }
      }
    }
  });
}
const sI = U({
  ...Pe(ha(), ["direction"]),
  ...Pe(Hg(), ["inline"])
}, "VCheckbox"), uI = K()({
  name: "VCheckbox",
  inheritAttrs: !1,
  props: sI(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:focused": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const r = he(e, "modelValue"), {
      isFocused: l,
      focus: i,
      blur: o
    } = ma(e), s = G(), u = Rt();
    return X(() => {
      const [c, d] = Jn(n), f = Gt.filterProps(e), v = Un.filterProps(e);
      return y(Gt, Y({
        ref: s,
        class: ["v-checkbox", e.class]
      }, c, f, {
        modelValue: r.value,
        "onUpdate:modelValue": (g) => r.value = g,
        id: e.id || `checkbox-${u}`,
        focused: l.value,
        style: e.style
      }), {
        ...a,
        default: (g) => {
          let {
            id: m,
            messagesId: h,
            isDisabled: w,
            isReadonly: _,
            isValid: I
          } = g;
          return y(Un, Y(v, {
            id: m.value,
            "aria-describedby": h.value,
            disabled: w.value,
            readonly: _.value
          }, d, {
            error: I.value === !1,
            modelValue: r.value,
            "onUpdate:modelValue": (C) => r.value = C,
            onFocus: i,
            onBlur: o
          }), a);
        }
      });
    }), Mt({}, s);
  }
}), jo = ["sm", "md", "lg", "xl", "xxl"], cI = /* @__PURE__ */ Symbol.for("vuetify:display"), hr = U({
  mobile: {
    type: Boolean,
    default: !1
  },
  mobileBreakpoint: [Number, String]
}, "display");
function Cn() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    mobile: null
  }, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Xn();
  const n = Le(cI);
  if (!n) throw new Error("Could not find Vuetify display injection");
  const a = T(() => e.mobile ? !0 : typeof e.mobileBreakpoint == "number" ? n.width.value < e.mobileBreakpoint : e.mobileBreakpoint ? n.width.value < n.thresholds.value[e.mobileBreakpoint] : e.mobile === null ? n.mobile.value : !1), r = D(() => t ? {
    [`${t}--mobile`]: a.value
  } : {});
  return {
    ...n,
    displayClasses: r,
    mobile: a
  };
}
const dI = /* @__PURE__ */ Symbol.for("vuetify:goto");
function fI() {
  return {
    container: void 0,
    duration: 300,
    layout: !1,
    offset: 0,
    easing: "easeInOutCubic",
    patterns: z_
  };
}
function vI(e) {
  return Rc(e) ?? (document.scrollingElement || document.body);
}
function Rc(e) {
  return typeof e == "string" ? document.querySelector(e) : Sc(e);
}
function Es(e, t, n) {
  if (typeof e == "number") return t && n ? -e : e;
  let a = Rc(e), r = 0;
  for (; a; )
    r += t ? a.offsetLeft : a.offsetTop, a = a.offsetParent;
  return r;
}
async function _v(e, t, n, a) {
  const r = n ? "scrollLeft" : "scrollTop", l = jn(a?.options ?? fI(), t), i = a?.rtl.value, o = (typeof e == "number" ? e : Rc(e)) ?? 0, s = l.container === "parent" && o instanceof HTMLElement ? o.parentElement : vI(l.container), u = Gn() ? l.patterns.instant : typeof l.easing == "function" ? l.easing : l.patterns[l.easing];
  if (!u) throw new TypeError(`Easing function "${l.easing}" not found.`);
  let c;
  if (typeof o == "number")
    c = Es(o, n, i);
  else if (c = Es(o, n, i) - Es(s, n, i), l.layout) {
    const g = window.getComputedStyle(o).getPropertyValue("--v-layout-top");
    g && (c -= parseInt(g, 10));
  }
  c += l.offset, c = hI(s, c, !!i, !!n);
  const d = s[r] ?? 0;
  if (c === d) return Promise.resolve(c);
  const f = performance.now();
  return new Promise((v) => requestAnimationFrame(function g(m) {
    const w = (m - f) / l.duration, _ = Math.floor(d + (c - d) * u(Xe(w, 0, 1)));
    if (s[r] = _, w >= 1 && Math.abs(_ - s[r]) < 10)
      return v(c);
    if (w > 2)
      return jt("Scroll target is not reachable"), v(s[r]);
    requestAnimationFrame(g);
  }));
}
function mI() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const t = Le(dI), {
    isRtl: n
  } = At();
  if (!t) throw new Error("[Vuetify] Could not find injected goto instance");
  const a = {
    ...t,
    // can be set via VLocaleProvider
    rtl: D(() => t.rtl.value || n.value)
  };
  async function r(l, i) {
    return _v(l, jn(e, i), !1, a);
  }
  return r.horizontal = async (l, i) => _v(l, jn(e, i), !0, a), r;
}
function hI(e, t, n, a) {
  const {
    scrollWidth: r,
    scrollHeight: l
  } = e, [i, o] = e === document.scrollingElement ? [window.innerWidth, window.innerHeight] : [e.offsetWidth, e.offsetHeight];
  let s, u;
  return a ? n ? (s = -(r - i), u = 0) : (s = 0, u = r - i) : (s = 0, u = l + -o), Xe(t, s, u);
}
function gI(e) {
  let {
    selectedElement: t,
    containerElement: n,
    isRtl: a,
    isHorizontal: r
  } = e;
  const l = $l(r, n), i = Yg(r, a, n), o = $l(r, t), s = Kg(r, t), u = o * 0.4;
  return i > s ? s - u : i + l < s + o ? s - l + o + u : i;
}
function yI(e) {
  let {
    selectedElement: t,
    containerElement: n,
    isHorizontal: a
  } = e;
  const r = $l(a, n), l = Kg(a, t), i = $l(a, t);
  return l - r / 2 + i / 2;
}
function Tv(e, t) {
  return t?.[e ? "scrollWidth" : "scrollHeight"] || 0;
}
function bI(e, t) {
  return t?.[e ? "clientWidth" : "clientHeight"] || 0;
}
function Yg(e, t, n) {
  if (!n)
    return 0;
  const {
    scrollLeft: a,
    offsetWidth: r,
    scrollWidth: l
  } = n;
  return e ? t ? l - r + a : a : n.scrollTop;
}
function $l(e, t) {
  return t?.[e ? "offsetWidth" : "offsetHeight"] || 0;
}
function Kg(e, t) {
  return t?.[e ? "offsetLeft" : "offsetTop"] || 0;
}
const $c = /* @__PURE__ */ Symbol.for("vuetify:v-slide-group"), Bc = U({
  centerActive: Boolean,
  scrollToActive: {
    type: Boolean,
    default: !0
  },
  contentClass: null,
  direction: {
    type: String,
    default: "horizontal"
  },
  symbol: {
    type: null,
    default: $c
  },
  nextIcon: {
    type: be,
    default: "$next"
  },
  prevIcon: {
    type: be,
    default: "$prev"
  },
  showArrows: {
    type: [Boolean, String],
    validator: (e) => typeof e == "boolean" || ["always", "desktop", "mobile", "never"].includes(e)
  },
  ...ve(),
  ...hr({
    mobile: null
  }),
  ...Ie(),
  ...vr({
    selectedClass: "v-slide-group-item--active"
  })
}, "VSlideGroup"), Bl = K()({
  name: "VSlideGroup",
  props: Bc(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      isRtl: a
    } = At(), {
      displayClasses: r,
      mobile: l
    } = Cn(e), i = Na(e, e.symbol), o = ae(!1), s = ae(0), u = ae(0), c = ae(0), d = T(() => e.direction === "horizontal"), {
      resizeRef: f,
      contentRect: v
    } = Vn(), {
      resizeRef: g,
      contentRect: m
    } = Vn(), h = mI(), w = T(() => ({
      container: f.el,
      duration: 200,
      easing: "easeOutQuart"
    })), _ = T(() => i.selected.value.length ? i.items.value.findIndex((H) => H.id === i.selected.value[0]) : -1), I = T(() => i.selected.value.length ? i.items.value.findIndex((H) => H.id === i.selected.value[i.selected.value.length - 1]) : -1);
    if (wt) {
      let H = -1;
      ne(() => [i.selected.value, v.value, m.value, d.value], () => {
        cancelAnimationFrame(H), H = requestAnimationFrame(() => {
          if (v.value && m.value) {
            const $ = d.value ? "width" : "height";
            u.value = v.value[$], c.value = m.value[$], o.value = u.value + 1 < c.value;
          }
          if (e.scrollToActive && _.value >= 0 && g.el) {
            const $ = g.el.children[I.value];
            b($, e.centerActive);
          }
        });
      });
    }
    const C = ae(!1);
    function b(H, $) {
      let z = 0;
      $ ? z = yI({
        containerElement: f.el,
        isHorizontal: d.value,
        selectedElement: H
      }) : z = gI({
        containerElement: f.el,
        isHorizontal: d.value,
        isRtl: a.value,
        selectedElement: H
      }), p(z);
    }
    function p(H) {
      if (!wt || !f.el) return;
      const $ = $l(d.value, f.el), z = Yg(d.value, a.value, f.el);
      if (!(Tv(d.value, f.el) <= $ || // Prevent scrolling by only a couple of pixels, which doesn't look smooth
      Math.abs(H - z) < 16)) {
        if (d.value && a.value && f.el) {
          const {
            scrollWidth: me,
            offsetWidth: Q
          } = f.el;
          H = me - Q - H;
        }
        d.value ? h.horizontal(H, w.value) : h(H, w.value);
      }
    }
    function x(H) {
      const {
        scrollTop: $,
        scrollLeft: z
      } = H.target;
      s.value = d.value ? z : $;
    }
    function k(H) {
      if (C.value = !0, !(!o.value || !g.el)) {
        for (const $ of H.composedPath())
          for (const z of g.el.children)
            if (z === $) {
              b(z);
              return;
            }
      }
    }
    function V(H) {
      C.value = !1;
    }
    let A = !1;
    function M(H) {
      !A && !C.value && !(H.relatedTarget && g.el?.contains(H.relatedTarget)) && O(), A = !1;
    }
    function L() {
      A = !0;
    }
    function E(H) {
      if (!g.el) return;
      function $(z) {
        H.preventDefault(), O(z);
      }
      d.value ? H.key === "ArrowRight" ? $(a.value ? "prev" : "next") : H.key === "ArrowLeft" && $(a.value ? "next" : "prev") : H.key === "ArrowDown" ? $("next") : H.key === "ArrowUp" && $("prev"), H.key === "Home" ? $("first") : H.key === "End" && $("last");
    }
    function P(H, $) {
      if (!H) return;
      let z = H;
      do
        z = z?.[$ === "next" ? "nextElementSibling" : "previousElementSibling"];
      while (z?.hasAttribute("disabled"));
      return z;
    }
    function O(H) {
      if (!g.el) return;
      let $;
      if (!H)
        $ = xa(g.el)[0];
      else if (H === "next") {
        if ($ = P(g.el.querySelector(":focus"), H), !$) return O("first");
      } else if (H === "prev") {
        if ($ = P(g.el.querySelector(":focus"), H), !$) return O("last");
      } else H === "first" ? ($ = g.el.firstElementChild, $?.hasAttribute("disabled") && ($ = P($, "next"))) : H === "last" && ($ = g.el.lastElementChild, $?.hasAttribute("disabled") && ($ = P($, "prev")));
      $ && $.focus({
        preventScroll: !0
      });
    }
    function F(H) {
      const $ = d.value && a.value ? -1 : 1, z = (H === "prev" ? -$ : $) * u.value;
      let te = s.value + z;
      if (d.value && a.value && f.el) {
        const {
          scrollWidth: me,
          offsetWidth: Q
        } = f.el;
        te += me - Q;
      }
      p(te);
    }
    const B = T(() => ({
      next: i.next,
      prev: i.prev,
      select: i.select,
      isSelected: i.isSelected
    })), N = T(() => o.value || Math.abs(s.value) > 0), W = T(() => {
      switch (e.showArrows) {
        case "never":
          return !1;
        // Always show arrows on desktop & mobile
        case "always":
          return !0;
        // Always show arrows on desktop
        case "desktop":
          return !l.value;
        // Show arrows on mobile when overflowing.
        // This matches the default 2.2 behavior
        case !0:
          return N.value;
        // Always show on mobile
        case "mobile":
          return l.value || N.value;
        // https://material.io/components/tabs#scrollable-tabs
        // Always show arrows when
        // overflowed on desktop
        default:
          return !l.value && N.value;
      }
    }), R = T(() => Math.abs(s.value) > 1), j = T(() => {
      if (!f.value || !N.value) return !1;
      const H = Tv(d.value, f.el), $ = bI(d.value, f.el);
      return H - $ - Math.abs(s.value) > 1;
    });
    return X(() => y(e.tag, {
      class: J(["v-slide-group", {
        "v-slide-group--vertical": !d.value,
        "v-slide-group--has-affixes": W.value,
        "v-slide-group--is-overflowing": o.value
      }, r.value, e.class]),
      style: le(e.style),
      tabindex: C.value || i.selected.value.length ? -1 : 0,
      onFocus: M
    }, {
      default: () => [W.value && S("div", {
        key: "prev",
        class: J(["v-slide-group__prev", {
          "v-slide-group__prev--disabled": !R.value
        }]),
        onMousedown: L,
        onClick: () => R.value && F("prev")
      }, [n.prev?.(B.value) ?? y(Nl, null, {
        default: () => [y(ze, {
          icon: a.value ? e.nextIcon : e.prevIcon
        }, null)]
      })]), S("div", {
        key: "container",
        ref: f,
        class: J(["v-slide-group__container", e.contentClass]),
        onScroll: x
      }, [S("div", {
        ref: g,
        class: "v-slide-group__content",
        onFocusin: k,
        onFocusout: V,
        onKeydown: E
      }, [n.default?.(B.value)])]), W.value && S("div", {
        key: "next",
        class: J(["v-slide-group__next", {
          "v-slide-group__next--disabled": !j.value
        }]),
        onMousedown: L,
        onClick: () => j.value && F("next")
      }, [n.next?.(B.value) ?? y(Nl, null, {
        default: () => [y(ze, {
          icon: a.value ? e.prevIcon : e.nextIcon
        }, null)]
      })])]
    })), {
      selected: i.selected,
      scrollTo: F,
      scrollOffset: s,
      focus: O,
      hasPrev: R,
      hasNext: j
    };
  }
}), Zg = /* @__PURE__ */ Symbol.for("vuetify:v-chip-group"), pI = U({
  baseColor: String,
  column: Boolean,
  filter: Boolean,
  valueComparator: {
    type: Function,
    default: Lt
  },
  ...Bc({
    scrollToActive: !1
  }),
  ...ve(),
  ...vr({
    selectedClass: "v-chip--selected"
  }),
  ...Ie(),
  ...Re(),
  ...xn({
    variant: "tonal"
  })
}, "VChipGroup"), wI = K()({
  name: "VChipGroup",
  props: pI(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: a
    } = Ge(e), {
      isSelected: r,
      select: l,
      next: i,
      prev: o,
      selected: s
    } = Na(e, Zg);
    return vt({
      VChip: {
        baseColor: D(() => e.baseColor),
        color: D(() => e.color),
        disabled: D(() => e.disabled),
        filter: D(() => e.filter),
        variant: D(() => e.variant)
      }
    }), X(() => {
      const u = Bl.filterProps(e);
      return y(Bl, Y(u, {
        class: ["v-chip-group", {
          "v-chip-group--column": e.column
        }, a.value, e.class],
        style: e.style
      }), {
        default: () => [n.default?.({
          isSelected: r,
          select: l,
          next: i,
          prev: o,
          selected: s.value
        })]
      });
    }), {};
  }
}), kI = U({
  activeClass: String,
  appendAvatar: String,
  appendIcon: be,
  baseColor: String,
  closable: Boolean,
  closeIcon: {
    type: be,
    default: "$delete"
  },
  closeLabel: {
    type: String,
    default: "$vuetify.close"
  },
  draggable: Boolean,
  filter: Boolean,
  filterIcon: {
    type: be,
    default: "$complete"
  },
  label: Boolean,
  link: {
    type: Boolean,
    default: void 0
  },
  pill: Boolean,
  prependAvatar: String,
  prependIcon: be,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  text: {
    type: [String, Number, Boolean],
    default: void 0
  },
  modelValue: {
    type: Boolean,
    default: !0
  },
  onClick: Ut(),
  onClickOnce: Ut(),
  ...qt(),
  ...ve(),
  ...mt(),
  ...Ct(),
  ...mr(),
  ...lt(),
  ...ui(),
  ...ea(),
  ...Ie({
    tag: "span"
  }),
  ...Re(),
  ...xn({
    variant: "tonal"
  })
}, "VChip"), ua = K()({
  name: "VChip",
  directives: {
    vRipple: Ht
  },
  props: kI(),
  emits: {
    "click:close": (e) => !0,
    "update:modelValue": (e) => !0,
    "group:selected": (e) => !0,
    click: (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: a,
      slots: r
    } = t;
    const {
      t: l
    } = Ke(), {
      borderClasses: i
    } = en(e), {
      densityClasses: o
    } = zt(e), {
      elevationClasses: s
    } = Et(e), {
      roundedClasses: u
    } = ut(e), {
      sizeClasses: c
    } = ll(e), {
      themeClasses: d
    } = Ge(e), f = he(e, "modelValue"), v = Ia(e, Zg, !1), g = Ia(e, $c, !1), m = si(e, n), h = D(() => e.link !== !1 && m.isLink.value), w = T(() => !e.disabled && e.link !== !1 && (!!v || e.link || m.isClickable.value)), _ = D(() => ({
      "aria-label": l(e.closeLabel),
      disabled: e.disabled,
      onClick(k) {
        k.preventDefault(), k.stopPropagation(), f.value = !1, a("click:close", k);
      }
    }));
    ne(f, (k) => {
      k ? (v?.register(), g?.register()) : (v?.unregister(), g?.unregister());
    });
    const {
      colorClasses: I,
      colorStyles: C,
      variantClasses: b
    } = va(() => ({
      color: !v || v.isSelected.value ? e.color ?? e.baseColor : e.baseColor,
      variant: e.variant
    }));
    function p(k) {
      a("click", k), w.value && (m.navigate.value?.(k), v?.toggle());
    }
    function x(k) {
      (k.key === "Enter" || k.key === " ") && (k.preventDefault(), p(k));
    }
    return () => {
      const k = m.isLink.value ? "a" : e.tag, V = !!(e.appendIcon || e.appendAvatar), A = !!(V || r.append), M = !!(r.close || e.closable), L = !!(r.filter || e.filter) && v, E = !!(e.prependIcon || e.prependAvatar), P = !!(E || r.prepend);
      return f.value && at(y(k, Y(m.linkProps, {
        class: ["v-chip", {
          "v-chip--disabled": e.disabled,
          "v-chip--label": e.label,
          "v-chip--link": w.value,
          "v-chip--filter": L,
          "v-chip--pill": e.pill,
          [`${e.activeClass}`]: e.activeClass && m.isActive?.value
        }, d.value, i.value, I.value, o.value, s.value, u.value, c.value, b.value, v?.selectedClass.value, e.class],
        style: [C.value, e.style],
        disabled: e.disabled || void 0,
        draggable: e.draggable,
        tabindex: w.value ? 0 : void 0,
        onClick: p,
        onKeydown: w.value && !h.value && x
      }), {
        default: () => [fa(w.value, "v-chip"), L && y(Dc, {
          key: "filter"
        }, {
          default: () => [at(S("div", {
            class: "v-chip__filter"
          }, [r.filter ? y(Ae, {
            key: "filter-defaults",
            disabled: !e.filterIcon,
            defaults: {
              VIcon: {
                icon: e.filterIcon
              }
            }
          }, r.filter) : y(ze, {
            key: "filter-icon",
            icon: e.filterIcon
          }, null)]), [[Wn, v.isSelected.value]])]
        }), P && S("div", {
          key: "prepend",
          class: "v-chip__prepend"
        }, [r.prepend ? y(Ae, {
          key: "prepend-defaults",
          disabled: !E,
          defaults: {
            VAvatar: {
              image: e.prependAvatar,
              start: !0
            },
            VIcon: {
              icon: e.prependIcon,
              start: !0
            }
          }
        }, r.prepend) : S(fe, null, [e.prependIcon && y(ze, {
          key: "prepend-icon",
          icon: e.prependIcon,
          start: !0
        }, null), e.prependAvatar && y(kn, {
          key: "prepend-avatar",
          image: e.prependAvatar,
          start: !0
        }, null)])]), S("div", {
          class: "v-chip__content",
          "data-no-activator": ""
        }, [r.default?.({
          isSelected: v?.isSelected.value,
          selectedClass: v?.selectedClass.value,
          select: v?.select,
          toggle: v?.toggle,
          value: v?.value.value,
          disabled: e.disabled
        }) ?? ce(e.text)]), A && S("div", {
          key: "append",
          class: "v-chip__append"
        }, [r.append ? y(Ae, {
          key: "append-defaults",
          disabled: !V,
          defaults: {
            VAvatar: {
              end: !0,
              image: e.appendAvatar
            },
            VIcon: {
              end: !0,
              icon: e.appendIcon
            }
          }
        }, r.append) : S(fe, null, [e.appendIcon && y(ze, {
          key: "append-icon",
          end: !0,
          icon: e.appendIcon
        }, null), e.appendAvatar && y(kn, {
          key: "append-avatar",
          end: !0,
          image: e.appendAvatar
        }, null)])]), M && S("button", Y({
          key: "close",
          class: "v-chip__close",
          type: "button",
          "data-testid": "close-chip"
        }, _.value), [r.close ? y(Ae, {
          key: "close-defaults",
          defaults: {
            VIcon: {
              icon: e.closeIcon,
              size: "x-small"
            }
          }
        }, r.close) : y(ze, {
          key: "close-icon",
          icon: e.closeIcon,
          size: "x-small"
        }, null)])]
      }), [[Ht, w.value && e.ripple, null]]);
    };
  }
}), SI = ["dotted", "dashed", "solid", "double"], xI = U({
  color: String,
  contentOffset: [Number, String, Array],
  gradient: Boolean,
  inset: Boolean,
  length: [Number, String],
  opacity: [Number, String],
  thickness: [Number, String],
  vertical: Boolean,
  variant: {
    type: String,
    default: "solid",
    validator: (e) => SI.includes(e)
  },
  ...ve(),
  ...Re()
}, "VDivider"), pn = K()({
  name: "VDivider",
  props: xI(),
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const {
      themeClasses: r
    } = Ge(e), {
      textColorClasses: l,
      textColorStyles: i
    } = Nt(() => e.color), o = T(() => {
      const u = {};
      return e.length && (u[e.vertical ? "height" : "width"] = re(e.length)), e.thickness && (u[e.vertical ? "borderRightWidth" : "borderTopWidth"] = re(e.thickness)), u;
    }), s = D(() => {
      const u = Array.isArray(e.contentOffset) ? e.contentOffset[0] : e.contentOffset, c = Array.isArray(e.contentOffset) ? e.contentOffset[1] : 0;
      return {
        marginBlock: e.vertical && u ? re(u) : void 0,
        marginInline: !e.vertical && u ? re(u) : void 0,
        transform: c ? `translate${e.vertical ? "X" : "Y"}(${re(c)})` : void 0
      };
    });
    return X(() => {
      const u = S("hr", {
        class: J([{
          "v-divider": !0,
          "v-divider--gradient": e.gradient && !a.default,
          "v-divider--inset": e.inset,
          "v-divider--vertical": e.vertical
        }, r.value, l.value, e.class]),
        style: le([o.value, i.value, {
          "--v-border-opacity": e.opacity
        }, {
          "border-style": e.variant
        }, e.style]),
        "aria-orientation": !n.role || n.role === "separator" ? e.vertical ? "vertical" : "horizontal" : void 0,
        role: `${n.role || "separator"}`
      }, null);
      return a.default ? S("div", {
        class: J(["v-divider__wrapper", {
          "v-divider__wrapper--gradient": e.gradient,
          "v-divider__wrapper--inset": e.inset,
          "v-divider__wrapper--vertical": e.vertical
        }])
      }, [u, S("div", {
        class: "v-divider__content",
        style: le(s.value)
      }, [a.default()]), u]) : u;
    }), {};
  }
}), pu = /* @__PURE__ */ Symbol.for("vuetify:list");
function Jg() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    filterable: !1
  };
  const t = Le(pu, {
    filterable: !1,
    hasPrepend: ae(!1),
    updateHasPrepend: () => null,
    trackingIndex: ae(-1),
    navigationStrategy: ae("focus"),
    uid: ""
  }), {
    filterable: n,
    trackingIndex: a = t.trackingIndex,
    navigationStrategy: r = t.navigationStrategy,
    uid: l = t.uid || Rt()
  } = e, i = {
    filterable: t.filterable || n,
    hasPrepend: ae(!1),
    updateHasPrepend: (o) => {
      o && (i.hasPrepend.value = o);
    },
    trackingIndex: a,
    navigationStrategy: r,
    uid: l
  };
  return st(pu, i), t;
}
function Xg() {
  return Le(pu, null);
}
const Uc = (e) => {
  const t = {
    activate: (n) => {
      let {
        id: a,
        value: r,
        activated: l
      } = n;
      return a = it(a), e && !r && l.size === 1 && l.has(a) || (r ? l.add(a) : l.delete(a)), l;
    },
    in: (n, a, r) => {
      let l = /* @__PURE__ */ new Set();
      if (n != null)
        for (const i of rt(n))
          l = t.activate({
            id: i,
            value: !0,
            activated: new Set(l),
            children: a,
            parents: r
          });
      return l;
    },
    out: (n) => Array.from(n)
  };
  return t;
}, Qg = (e) => {
  const t = Uc(e);
  return {
    activate: (a) => {
      let {
        activated: r,
        id: l,
        ...i
      } = a;
      l = it(l);
      const o = r.has(l) ? /* @__PURE__ */ new Set([l]) : /* @__PURE__ */ new Set();
      return t.activate({
        ...i,
        id: l,
        activated: o
      });
    },
    in: (a, r, l) => {
      let i = /* @__PURE__ */ new Set();
      if (a != null) {
        const o = rt(a);
        o.length && (i = t.in(o.slice(0, 1), r, l));
      }
      return i;
    },
    out: (a, r, l) => t.out(a, r, l)
  };
}, CI = (e) => {
  const t = Uc(e);
  return {
    activate: (a) => {
      let {
        id: r,
        activated: l,
        children: i,
        ...o
      } = a;
      return r = it(r), i.has(r) ? l : t.activate({
        id: r,
        activated: l,
        children: i,
        ...o
      });
    },
    in: t.in,
    out: t.out
  };
}, _I = (e) => {
  const t = Qg(e);
  return {
    activate: (a) => {
      let {
        id: r,
        activated: l,
        children: i,
        ...o
      } = a;
      return r = it(r), i.has(r) ? l : t.activate({
        id: r,
        activated: l,
        children: i,
        ...o
      });
    },
    in: t.in,
    out: t.out
  };
}, TI = {
  open: (e) => {
    let {
      id: t,
      value: n,
      opened: a,
      parents: r
    } = e;
    if (n) {
      const l = /* @__PURE__ */ new Set();
      l.add(t);
      let i = r.get(t);
      for (; i != null; )
        l.add(i), i = r.get(i);
      return l;
    } else
      return a.delete(t), a;
  },
  select: () => null
}, ey = {
  open: (e) => {
    let {
      id: t,
      value: n,
      opened: a,
      parents: r
    } = e;
    if (n) {
      let l = r.get(t);
      for (a.add(t); l != null && l !== t; )
        a.add(l), l = r.get(l);
      return a;
    } else
      a.delete(t);
    return a;
  },
  select: () => null
}, II = {
  open: ey.open,
  select: (e) => {
    let {
      id: t,
      value: n,
      opened: a,
      parents: r
    } = e;
    if (!n) return a;
    const l = [];
    let i = r.get(t);
    for (; i != null; )
      l.push(i), i = r.get(i);
    return new Set(l);
  }
}, Wc = (e) => {
  const t = {
    select: (n) => {
      let {
        id: a,
        value: r,
        selected: l
      } = n;
      if (a = it(a), e && !r) {
        const i = Array.from(l.entries()).reduce((o, s) => {
          let [u, c] = s;
          return c === "on" && o.push(u), o;
        }, []);
        if (i.length === 1 && i[0] === a) return l;
      }
      return l.set(a, r ? "on" : "off"), l;
    },
    in: (n, a, r, l) => {
      const i = /* @__PURE__ */ new Map();
      for (const o of n || [])
        t.select({
          id: o,
          value: !0,
          selected: i,
          children: a,
          parents: r,
          disabled: l
        });
      return i;
    },
    out: (n) => {
      const a = [];
      for (const [r, l] of n.entries())
        l === "on" && a.push(r);
      return a;
    }
  };
  return t;
}, ty = (e) => {
  const t = Wc(e);
  return {
    select: (a) => {
      let {
        selected: r,
        id: l,
        ...i
      } = a;
      l = it(l);
      const o = r.has(l) ? /* @__PURE__ */ new Map([[l, r.get(l)]]) : /* @__PURE__ */ new Map();
      return t.select({
        ...i,
        id: l,
        selected: o
      });
    },
    in: (a, r, l, i) => a?.length ? t.in(a.slice(0, 1), r, l, i) : /* @__PURE__ */ new Map(),
    out: (a, r, l) => t.out(a, r, l)
  };
}, AI = (e) => {
  const t = Wc(e);
  return {
    select: (a) => {
      let {
        id: r,
        selected: l,
        children: i,
        ...o
      } = a;
      return r = it(r), i.has(r) ? l : t.select({
        id: r,
        selected: l,
        children: i,
        ...o
      });
    },
    in: t.in,
    out: t.out
  };
}, PI = (e) => {
  const t = ty(e);
  return {
    select: (a) => {
      let {
        id: r,
        selected: l,
        children: i,
        ...o
      } = a;
      return r = it(r), i.has(r) ? l : t.select({
        id: r,
        selected: l,
        children: i,
        ...o
      });
    },
    in: t.in,
    out: t.out
  };
}, Hc = (e) => {
  const t = {
    select: (n) => {
      let {
        id: a,
        value: r,
        selected: l,
        children: i,
        parents: o,
        disabled: s
      } = n;
      a = it(a);
      const u = new Map(l), c = [a];
      for (; c.length; ) {
        const f = c.shift();
        s.has(f) || l.set(it(f), r ? "on" : "off"), i.has(f) && c.push(...i.get(f));
      }
      let d = it(o.get(a));
      for (; d; ) {
        let f = !0, v = !0;
        for (const g of i.get(d)) {
          const m = it(g);
          if (!s.has(m) && (l.get(m) !== "on" && (f = !1), l.has(m) && l.get(m) !== "off" && (v = !1), !f && !v))
            break;
        }
        l.set(d, f ? "on" : v ? "off" : "indeterminate"), d = it(o.get(d));
      }
      return e && !r && Array.from(l.entries()).reduce((v, g) => {
        let [m, h] = g;
        return h === "on" && v.push(m), v;
      }, []).length === 0 ? u : l;
    },
    in: (n, a, r) => {
      let l = /* @__PURE__ */ new Map();
      for (const i of n || [])
        l = t.select({
          id: i,
          value: !0,
          selected: l,
          children: a,
          parents: r,
          disabled: /* @__PURE__ */ new Set()
        });
      return l;
    },
    out: (n, a) => {
      const r = [];
      for (const [l, i] of n.entries())
        i === "on" && !a.has(l) && r.push(l);
      return r;
    }
  };
  return t;
}, VI = (e) => {
  const t = Hc(e);
  return {
    select: t.select,
    in: t.in,
    out: (a, r, l) => {
      const i = [];
      for (const [o, s] of a.entries())
        if (s === "on") {
          if (l.has(o)) {
            const u = l.get(o);
            if (a.get(u) === "on") continue;
          }
          i.push(o);
        }
      return i;
    }
  };
}, EI = (e) => {
  const n = {
    select: Hc(e).select,
    in: (a, r, l, i) => {
      let o = /* @__PURE__ */ new Map();
      for (const s of a || [])
        r.has(s) || (o = n.select({
          id: s,
          value: !0,
          selected: o,
          children: r,
          parents: l,
          disabled: i
        }));
      return o;
    },
    out: (a) => {
      const r = [];
      for (const [l, i] of a.entries())
        (i === "on" || i === "indeterminate") && r.push(l);
      return r;
    }
  };
  return n;
}, jr = /* @__PURE__ */ Symbol.for("vuetify:nested"), ny = {
  id: ae(),
  root: {
    itemsRegistration: G("render"),
    register: () => null,
    unregister: () => null,
    updateDisabled: () => null,
    children: G(/* @__PURE__ */ new Map()),
    parents: G(/* @__PURE__ */ new Map()),
    disabled: G(/* @__PURE__ */ new Set()),
    open: () => null,
    openOnSelect: () => null,
    activate: () => null,
    select: () => null,
    activatable: G(!1),
    scrollToActive: G(!1),
    selectable: G(!1),
    opened: G(/* @__PURE__ */ new Set()),
    activated: G(/* @__PURE__ */ new Set()),
    selected: G(/* @__PURE__ */ new Map()),
    selectedValues: G([]),
    getPath: () => []
  }
}, MI = U({
  activatable: Boolean,
  selectable: Boolean,
  activeStrategy: [String, Function, Object],
  selectStrategy: [String, Function, Object],
  openStrategy: [String, Object],
  opened: null,
  activated: null,
  selected: null,
  mandatory: Boolean,
  itemsRegistration: {
    type: String,
    default: "render"
  }
}, "nested"), OI = (e, t) => {
  let {
    items: n,
    returnObject: a,
    scrollToActive: r
  } = t, l = !1;
  const i = ae(/* @__PURE__ */ new Map()), o = ae(/* @__PURE__ */ new Map()), s = ae(/* @__PURE__ */ new Set()), u = he(e, "opened", e.opened, (b) => new Set(Array.isArray(b) ? b.map((p) => it(p)) : b), (b) => [...b.values()]), c = T(() => {
    if (typeof e.activeStrategy == "object") return e.activeStrategy;
    if (typeof e.activeStrategy == "function") return e.activeStrategy(e.mandatory);
    switch (e.activeStrategy) {
      case "leaf":
        return CI(e.mandatory);
      case "single-leaf":
        return _I(e.mandatory);
      case "independent":
        return Uc(e.mandatory);
      default:
        return Qg(e.mandatory);
    }
  }), d = T(() => {
    if (typeof e.selectStrategy == "object") return e.selectStrategy;
    if (typeof e.selectStrategy == "function") return e.selectStrategy(e.mandatory);
    switch (e.selectStrategy) {
      case "single-leaf":
        return PI(e.mandatory);
      case "leaf":
        return AI(e.mandatory);
      case "independent":
        return Wc(e.mandatory);
      case "single-independent":
        return ty(e.mandatory);
      case "trunk":
        return VI(e.mandatory);
      case "branch":
        return EI(e.mandatory);
      default:
        return Hc(e.mandatory);
    }
  }), f = T(() => {
    if (typeof e.openStrategy == "object") return e.openStrategy;
    switch (e.openStrategy) {
      case "list":
        return II;
      case "single":
        return TI;
      default:
        return ey;
    }
  }), v = he(e, "activated", e.activated, (b) => c.value.in(b, i.value, o.value), (b) => c.value.out(b, i.value, o.value)), g = he(e, "selected", e.selected, (b) => d.value.in(b, i.value, o.value, s.value), (b) => d.value.out(b, i.value, o.value));
  Ft(() => {
    l = !0;
  });
  function m(b) {
    const p = [];
    let x = it(b);
    for (; x !== void 0; )
      p.unshift(x), x = o.value.get(x);
    return p;
  }
  const h = kt("nested"), w = /* @__PURE__ */ new Set(), _ = Y_(() => {
    Se(() => {
      i.value = new Map(i.value), o.value = new Map(o.value);
    });
  }, 100);
  ne(() => [n.value, nt(a)], () => {
    e.itemsRegistration === "props" && I();
  }, {
    immediate: !0
  });
  function I() {
    const b = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map(), x = /* @__PURE__ */ new Set(), k = nt(a) ? (M) => it(M.raw) : (M) => M.value, V = [...n.value];
    let A = 0;
    for (; A < V.length; ) {
      const M = V[A++], L = k(M);
      if (M.children) {
        const E = [];
        for (const P of M.children) {
          const O = k(P);
          b.set(O, L), E.push(O), V.push(P);
        }
        p.set(L, E);
      }
      M.props.disabled && x.add(L);
    }
    i.value = p, o.value = b, s.value = x;
  }
  const C = {
    id: ae(),
    root: {
      opened: u,
      activatable: D(() => e.activatable),
      scrollToActive: D(() => nt(r)),
      selectable: D(() => e.selectable),
      activated: v,
      selected: g,
      selectedValues: T(() => {
        const b = [];
        for (const [p, x] of g.value.entries())
          x === "on" && b.push(p);
        return b;
      }),
      itemsRegistration: D(() => e.itemsRegistration),
      register: (b, p, x, k) => {
        if (w.has(b)) {
          const V = m(b).map(String).join(" -> "), A = m(p).concat(b).map(String).join(" -> ");
          ni(`Multiple nodes with the same ID
	${V}
	${A}`);
          return;
        } else
          w.add(b);
        p && b !== p && o.value.set(b, p), x && s.value.add(b), k && i.value.set(b, []), p != null && i.value.set(p, [...i.value.get(p) || [], b]), _();
      },
      unregister: (b) => {
        if (l) return;
        w.delete(b), i.value.delete(b), s.value.delete(b);
        const p = o.value.get(b);
        if (p) {
          const x = i.value.get(p) ?? [];
          i.value.set(p, x.filter((k) => k !== b));
        }
        o.value.delete(b), _();
      },
      updateDisabled: (b, p) => {
        p ? s.value.add(b) : s.value.delete(b);
      },
      open: (b, p, x) => {
        h.emit("click:open", {
          id: b,
          value: p,
          path: m(b),
          event: x
        });
        const k = f.value.open({
          id: b,
          value: p,
          opened: new Set(u.value),
          children: i.value,
          parents: o.value,
          event: x
        });
        k && (u.value = k);
      },
      openOnSelect: (b, p, x) => {
        const k = f.value.select({
          id: b,
          value: p,
          selected: new Map(g.value),
          opened: new Set(u.value),
          children: i.value,
          parents: o.value,
          event: x
        });
        k && (u.value = k);
      },
      select: (b, p, x) => {
        h.emit("click:select", {
          id: b,
          value: p,
          path: m(b),
          event: x
        });
        const k = d.value.select({
          id: b,
          value: p,
          selected: new Map(g.value),
          children: i.value,
          parents: o.value,
          disabled: s.value,
          event: x
        });
        k && (g.value = k), C.root.openOnSelect(b, p, x);
      },
      activate: (b, p, x) => {
        if (!e.activatable)
          return C.root.select(b, !0, x);
        h.emit("click:activate", {
          id: b,
          value: p,
          path: m(b),
          event: x
        });
        const k = c.value.activate({
          id: b,
          value: p,
          activated: new Set(v.value),
          children: i.value,
          parents: o.value,
          event: x
        });
        if (k.size !== v.value.size)
          v.value = k;
        else {
          for (const V of k)
            if (!v.value.has(V)) {
              v.value = k;
              return;
            }
          for (const V of v.value)
            if (!k.has(V)) {
              v.value = k;
              return;
            }
        }
      },
      children: i,
      parents: o,
      disabled: s,
      getPath: m
    }
  };
  return st(jr, C), C.root;
}, ay = (e, t, n) => {
  const a = Le(jr, ny), r = /* @__PURE__ */ Symbol("nested item"), l = T(() => {
    const o = it(nt(e));
    return o !== void 0 ? o : r;
  }), i = {
    ...a,
    id: l,
    open: (o, s) => a.root.open(l.value, o, s),
    openOnSelect: (o, s) => a.root.openOnSelect(l.value, o, s),
    isOpen: T(() => a.root.opened.value.has(l.value)),
    parent: T(() => a.root.parents.value.get(l.value)),
    activate: (o, s) => a.root.activate(l.value, o, s),
    isActivated: T(() => a.root.activated.value.has(l.value)),
    scrollToActive: a.root.scrollToActive,
    select: (o, s) => a.root.select(l.value, o, s),
    isSelected: T(() => a.root.selected.value.get(l.value) === "on"),
    isIndeterminate: T(() => a.root.selected.value.get(l.value) === "indeterminate"),
    isLeaf: T(() => !a.root.children.value.get(l.value)),
    isGroupActivator: a.isGroupActivator
  };
  return Gl(() => {
    a.isGroupActivator || a.root.itemsRegistration.value === "props" || Se(() => {
      a.root.register(l.value, a.id.value, nt(t), n);
    });
  }), Ft(() => {
    a.isGroupActivator || a.root.itemsRegistration.value === "props" || a.root.unregister(l.value);
  }), ne(l, (o, s) => {
    a.isGroupActivator || a.root.itemsRegistration.value === "props" || (a.root.unregister(s), Se(() => {
      a.root.register(o, a.id.value, nt(t), n);
    }));
  }), ne(() => nt(t), (o) => {
    a.root.updateDisabled(l.value, o);
  }), n && st(jr, i), i;
}, DI = () => {
  const e = Le(jr, ny);
  st(jr, {
    ...e,
    isGroupActivator: !0
  });
}, LI = rn({
  name: "VListGroupActivator",
  setup(e, t) {
    let {
      slots: n
    } = t;
    return DI(), () => n.default?.();
  }
}), ry = U({
  /* @deprecated */
  activeColor: String,
  baseColor: String,
  color: String,
  collapseIcon: {
    type: be,
    default: "$collapse"
  },
  disabled: Boolean,
  expandIcon: {
    type: be,
    default: "$expand"
  },
  rawId: [String, Number],
  prependIcon: be,
  appendIcon: be,
  fluid: Boolean,
  subgroup: Boolean,
  title: String,
  value: null,
  ...ve(),
  ...Ie()
}, "VListGroup"), Ul = K()({
  name: "VListGroup",
  props: ry(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      isOpen: a,
      open: r,
      id: l
    } = ay(() => e.value, () => e.disabled, !0), i = T(() => `v-list-group--id-${String(e.rawId ?? l.value)}`), o = Xg(), {
      isBooted: s
    } = fr(), u = Le(jr), c = D(() => u?.root?.itemsRegistration.value === "render");
    function d(m) {
      ["INPUT", "TEXTAREA"].includes(m.target?.tagName) || r(!a.value, m);
    }
    const f = T(() => ({
      onClick: d,
      class: "v-list-group__header",
      id: i.value
    })), v = T(() => a.value ? e.collapseIcon : e.expandIcon), g = T(() => ({
      VListItem: {
        activeColor: e.activeColor,
        baseColor: e.baseColor,
        color: e.color,
        prependIcon: e.prependIcon || e.subgroup && v.value,
        appendIcon: e.appendIcon || !e.subgroup && v.value,
        title: e.title,
        value: e.value
      }
    }));
    return X(() => y(e.tag, {
      class: J(["v-list-group", {
        "v-list-group--prepend": o?.hasPrepend.value,
        "v-list-group--fluid": e.fluid,
        "v-list-group--subgroup": e.subgroup,
        "v-list-group--open": a.value
      }, e.class]),
      style: le(e.style)
    }, {
      default: () => [n.activator && y(Ae, {
        defaults: g.value
      }, {
        default: () => [y(LI, null, {
          default: () => [n.activator({
            props: f.value,
            isOpen: a.value
          })]
        })]
      }), y(Xt, {
        transition: {
          component: $o
        },
        disabled: !s.value
      }, {
        default: () => [c.value ? at(S("div", {
          class: "v-list-group__items",
          role: "group",
          "aria-labelledby": i.value
        }, [n.default?.()]), [[Wn, a.value]]) : a.value && S("div", {
          class: "v-list-group__items",
          role: "group",
          "aria-labelledby": i.value
        }, [n.default?.()])]
      })]
    })), {
      isOpen: a
    };
  }
}), NI = U({
  opacity: [Number, String],
  ...ve(),
  ...Ie()
}, "VListItemSubtitle"), ly = K()({
  name: "VListItemSubtitle",
  props: NI(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => y(e.tag, {
      class: J(["v-list-item-subtitle", e.class]),
      style: le([{
        "--v-list-item-subtitle-opacity": e.opacity
      }, e.style])
    }, n)), {};
  }
}), iy = ca("v-list-item-title"), oy = U({
  active: {
    type: Boolean,
    default: void 0
  },
  activeClass: String,
  /* @deprecated */
  activeColor: String,
  appendAvatar: String,
  appendIcon: be,
  baseColor: String,
  disabled: Boolean,
  lines: [Boolean, String],
  link: {
    type: Boolean,
    default: void 0
  },
  nav: Boolean,
  prependAvatar: String,
  prependIcon: be,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  slim: Boolean,
  prependGap: [Number, String],
  subtitle: {
    type: [String, Number, Boolean],
    default: void 0
  },
  title: {
    type: [String, Number, Boolean],
    default: void 0
  },
  value: null,
  index: Number,
  tabindex: [Number, String],
  onClick: Ut(),
  onClickOnce: Ut(),
  ...qt(),
  ...ve(),
  ...mt(),
  ...St(),
  ...Ct(),
  ...lt(),
  ...ui(),
  ...Ie(),
  ...Re(),
  ...xn({
    variant: "text"
  })
}, "VListItem"), En = K()({
  name: "VListItem",
  directives: {
    vRipple: Ht
  },
  props: oy(),
  emits: {
    click: (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: a,
      emit: r
    } = t;
    const l = si(e, n), i = G(), o = T(() => e.value === void 0 ? l.href.value : e.value), {
      activate: s,
      isActivated: u,
      select: c,
      isOpen: d,
      isSelected: f,
      isIndeterminate: v,
      isGroupActivator: g,
      root: m,
      parent: h,
      openOnSelect: w,
      scrollToActive: _,
      id: I
    } = ay(o, () => e.disabled, !1), C = Xg(), b = T(() => e.active !== !1 && (e.active || l.isActive?.value || (m.activatable.value ? u.value : f.value))), p = D(() => e.link !== !1 && l.isLink.value), x = T(() => !!C && (m.selectable.value || m.activatable.value || e.value != null)), k = T(() => !e.disabled && e.link !== !1 && (e.link || l.isClickable.value || x.value)), V = T(() => C && C.navigationStrategy.value === "track" && e.index !== void 0 && C.trackingIndex.value === e.index), A = T(() => C ? p.value ? "link" : x.value ? "option" : "listitem" : void 0), M = T(() => {
      if (x.value)
        return m.activatable.value ? u.value : m.selectable.value ? f.value : b.value;
    }), L = D(() => e.rounded || e.nav), E = D(() => e.color ?? e.activeColor), P = D(() => ({
      color: b.value ? E.value ?? e.baseColor : e.baseColor,
      variant: e.variant
    }));
    ne(() => l.isActive?.value, (ye) => {
      ye && O();
    }), ne(u, (ye) => {
      !ye || !_ || i.value?.scrollIntoView({
        block: "nearest",
        behavior: "instant"
      });
    }), ne(V, (ye) => {
      ye && i.value?.scrollIntoView({
        block: "nearest",
        behavior: "instant"
      });
    }), Gl(() => {
      l.isActive?.value && Se(() => O());
    });
    function O() {
      h.value != null && m.open(h.value, !0), w(!0);
    }
    const {
      themeClasses: F
    } = Ge(e), {
      borderClasses: B
    } = en(e), {
      colorClasses: N,
      colorStyles: W,
      variantClasses: R
    } = va(P), {
      densityClasses: j
    } = zt(e), {
      dimensionStyles: H
    } = xt(e), {
      elevationClasses: $
    } = Et(e), {
      roundedClasses: z
    } = ut(L), te = D(() => e.lines ? `v-list-item--${e.lines}-line` : void 0), me = D(() => e.ripple !== void 0 && e.ripple && C?.filterable ? {
      keys: ["Enter"]
    } : e.ripple), Q = T(() => ({
      isActive: b.value,
      select: c,
      isOpen: d.value,
      isSelected: f.value,
      isIndeterminate: v.value,
      isDisabled: e.disabled
    }));
    function ie(ye) {
      r("click", ye), !["INPUT", "TEXTAREA"].includes(ye.target?.tagName) && k.value && (l.navigate.value?.(ye), !g && (m.activatable.value ? s(!u.value, ye) : (m.selectable.value || e.value != null && !p.value) && c(!f.value, ye)));
    }
    function ke(ye) {
      const ue = ye.target;
      ["INPUT", "TEXTAREA"].includes(ue.tagName) || (ye.key === "Enter" || ye.key === " " && !C?.filterable) && (ye.preventDefault(), ye.stopPropagation(), ye.target.dispatchEvent(new MouseEvent("click", ye)));
    }
    return X(() => {
      const ye = p.value ? "a" : e.tag, ue = a.title || e.title != null, Te = a.subtitle || e.subtitle != null, je = !!(!!(e.appendAvatar || e.appendIcon) || a.append), Be = !!(!!(e.prependAvatar || e.prependIcon) || a.prepend);
      return C?.updateHasPrepend(Be), e.activeColor && l_("active-color", ["color", "base-color"]), at(y(ye, Y(l.linkProps, {
        ref: i,
        id: e.index !== void 0 && C ? `v-list-item-${C.uid}-${e.index}` : void 0,
        class: ["v-list-item", {
          "v-list-item--active": b.value,
          "v-list-item--disabled": e.disabled,
          "v-list-item--link": k.value,
          "v-list-item--nav": e.nav,
          "v-list-item--prepend": !Be && C?.hasPrepend.value,
          "v-list-item--slim": e.slim,
          "v-list-item--focus-visible": V.value,
          [`${e.activeClass}`]: e.activeClass && b.value
        }, F.value, B.value, N.value, j.value, $.value, te.value, z.value, R.value, e.class],
        style: [{
          "--v-list-prepend-gap": re(e.prependGap)
        }, W.value, H.value, e.style],
        tabindex: e.tabindex ?? (k.value ? C ? -2 : 0 : void 0),
        "aria-selected": M.value,
        role: A.value,
        onClick: ie,
        onKeydown: k.value && !p.value && ke
      }), {
        default: () => [fa(k.value || b.value, "v-list-item"), Be && S("div", {
          key: "prepend",
          class: "v-list-item__prepend"
        }, [a.prepend ? y(Ae, {
          key: "prepend-defaults",
          defaults: {
            VAvatar: {
              density: e.density,
              image: e.prependAvatar
            },
            VIcon: {
              density: e.density,
              icon: e.prependIcon
            },
            VListItemAction: {
              start: !0
            },
            VCheckboxBtn: {
              density: e.density
            }
          }
        }, {
          default: () => [a.prepend?.(Q.value)]
        }) : S(fe, null, [e.prependAvatar && y(kn, {
          key: "prepend-avatar",
          density: e.density,
          image: e.prependAvatar
        }, null), e.prependIcon && y(ze, {
          key: "prepend-icon",
          density: e.density,
          icon: e.prependIcon
        }, null)]), S("div", {
          class: "v-list-item__spacer"
        }, null)]), S("div", {
          class: "v-list-item__content",
          "data-no-activator": ""
        }, [ue && y(iy, {
          key: "title"
        }, {
          default: () => [a.title?.({
            title: e.title
          }) ?? ce(e.title)]
        }), Te && y(ly, {
          key: "subtitle"
        }, {
          default: () => [a.subtitle?.({
            subtitle: e.subtitle
          }) ?? ce(e.subtitle)]
        }), a.default?.(Q.value)]), je && S("div", {
          key: "append",
          class: "v-list-item__append"
        }, [a.append ? y(Ae, {
          key: "append-defaults",
          defaults: {
            VAvatar: {
              density: e.density,
              image: e.appendAvatar
            },
            VIcon: {
              density: e.density,
              icon: e.appendIcon
            },
            VListItemAction: {
              end: !0
            },
            VCheckboxBtn: {
              density: e.density
            }
          }
        }, {
          default: () => [a.append?.(Q.value)]
        }) : S(fe, null, [e.appendIcon && y(ze, {
          key: "append-icon",
          density: e.density,
          icon: e.appendIcon
        }, null), e.appendAvatar && y(kn, {
          key: "append-avatar",
          density: e.density,
          image: e.appendAvatar
        }, null)]), S("div", {
          class: "v-list-item__spacer"
        }, null)])]
      }), [[Ht, k.value && me.value]]);
    }), {
      activate: s,
      isActivated: u,
      isGroupActivator: g,
      isSelected: f,
      list: C,
      select: c,
      root: m,
      id: I,
      link: l
    };
  }
}), FI = U({
  color: String,
  inset: Boolean,
  sticky: Boolean,
  title: String,
  ...ve(),
  ...Ie()
}, "VListSubheader"), cl = K()({
  name: "VListSubheader",
  props: FI(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      textColorClasses: a,
      textColorStyles: r
    } = Nt(() => e.color);
    return X(() => {
      const l = !!(n.default || e.title);
      return y(e.tag, {
        class: J(["v-list-subheader", {
          "v-list-subheader--inset": e.inset,
          "v-list-subheader--sticky": e.sticky
        }, a.value, e.class]),
        style: le([{
          textColorStyles: r
        }, e.style])
      }, {
        default: () => [l && S("div", {
          class: "v-list-subheader__text"
        }, [n.default?.() ?? e.title])]
      });
    }), {};
  }
}), RI = U({
  items: Array,
  returnObject: Boolean
}, "VListChildren"), sy = K()({
  name: "VListChildren",
  props: RI(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return Jg(), () => n.default?.() ?? e.items?.map((a, r) => {
      let {
        children: l,
        props: i,
        type: o,
        raw: s
      } = a;
      if (o === "divider")
        return n.divider?.({
          props: i
        }) ?? y(pn, i, null);
      if (o === "subheader")
        return n.subheader?.({
          props: i
        }) ?? y(cl, i, null);
      const u = {
        subtitle: n.subtitle ? (d) => n.subtitle?.({
          ...d,
          item: s
        }) : void 0,
        prepend: n.prepend ? (d) => n.prepend?.({
          ...d,
          item: s
        }) : void 0,
        append: n.append ? (d) => n.append?.({
          ...d,
          item: s
        }) : void 0,
        title: n.title ? (d) => n.title?.({
          ...d,
          item: s
        }) : void 0
      }, c = Ul.filterProps(i);
      return l ? y(Ul, Y(c, {
        value: e.returnObject ? s : i?.value,
        rawId: i?.value
      }), {
        activator: (d) => {
          let {
            props: f
          } = d;
          const v = Y(i, f, {
            value: e.returnObject ? s : i.value
          });
          return n.header ? n.header({
            props: v
          }) : y(En, Y(v, {
            index: r
          }), u);
        },
        default: () => y(sy, {
          items: l,
          returnObject: e.returnObject
        }, n)
      }) : n.item ? n.item({
        props: {
          ...i,
          index: r
        }
      }) : y(En, Y(i, {
        index: r,
        value: e.returnObject ? s : i.value
      }), u);
    });
  }
}), uy = U({
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: [String, Array, Function],
    default: "title"
  },
  itemValue: {
    type: [String, Array, Function],
    default: "value"
  },
  itemChildren: {
    type: [Boolean, String, Array, Function],
    default: "children"
  },
  itemProps: {
    type: [Boolean, String, Array, Function],
    default: "props"
  },
  itemType: {
    type: [Boolean, String, Array, Function],
    default: "type"
  },
  returnObject: Boolean,
  valueComparator: Function
}, "list-items"), $I = /* @__PURE__ */ new Set(["item", "divider", "subheader"]);
function Dn(e, t) {
  const n = pt(t, e.itemTitle, t), a = pt(t, e.itemValue, n), r = pt(t, e.itemChildren), l = e.itemProps === !0 ? typeof t == "object" && t != null && !Array.isArray(t) ? "children" in t ? Pe(t, ["children"]) : t : void 0 : pt(t, e.itemProps);
  let i = pt(t, e.itemType, "item");
  $I.has(i) || (i = "item");
  const o = {
    title: n,
    value: a,
    ...l
  };
  return {
    type: i,
    title: String(o.title ?? ""),
    value: o.value,
    props: o,
    children: i === "item" && Array.isArray(r) ? cy(e, r) : void 0,
    raw: t
  };
}
Dn.neededProps = ["itemTitle", "itemValue", "itemChildren", "itemProps", "itemType"];
function cy(e, t) {
  const n = an(e, Dn.neededProps), a = [];
  for (const r of t)
    a.push(Dn(n, r));
  return a;
}
function zc(e) {
  const t = T(() => cy(e, e.items)), n = T(() => t.value.some((o) => o.value === null)), a = ae(/* @__PURE__ */ new Map()), r = ae([]);
  ft(() => {
    const o = t.value, s = /* @__PURE__ */ new Map(), u = [];
    for (let c = 0; c < o.length; c++) {
      const d = o[c];
      if (Ta(d.value) || d.value === null) {
        let f = s.get(d.value);
        f || (f = [], s.set(d.value, f)), f.push(d);
      } else
        u.push(d);
    }
    a.value = s, r.value = u;
  });
  function l(o) {
    const s = a.value, u = t.value, c = r.value, d = n.value, f = e.returnObject, v = !!e.valueComparator, g = e.valueComparator || Lt, m = an(e, Dn.neededProps), h = [];
    e: for (const w of o) {
      if (!d && w === null) continue;
      if (f && typeof w == "string") {
        h.push(Dn(m, w));
        continue;
      }
      const _ = s.get(w);
      if (v || !_) {
        for (const I of v ? u : c)
          if (g(w, I.value)) {
            h.push(I);
            continue e;
          }
        h.push(Dn(m, w));
        continue;
      }
      h.push(..._);
    }
    return h;
  }
  function i(o) {
    return e.returnObject ? o.map((s) => {
      let {
        raw: u
      } = s;
      return u;
    }) : o.map((s) => {
      let {
        value: u
      } = s;
      return u;
    });
  }
  return {
    items: t,
    transformIn: l,
    transformOut: i
  };
}
const BI = /* @__PURE__ */ new Set(["item", "divider", "subheader"]);
function UI(e, t) {
  const n = Ta(t) ? t : pt(t, e.itemTitle), a = Ta(t) ? t : pt(t, e.itemValue, void 0), r = pt(t, e.itemChildren), l = e.itemProps === !0 ? Pe(t, ["children"]) : pt(t, e.itemProps);
  let i = pt(t, e.itemType, "item");
  BI.has(i) || (i = "item");
  const o = {
    title: n,
    value: a,
    ...l
  };
  return {
    type: i,
    title: o.title,
    value: o.value,
    props: o,
    children: i === "item" && r ? dy(e, r) : void 0,
    raw: t
  };
}
function dy(e, t) {
  const n = [];
  for (const a of t)
    n.push(UI(e, a));
  return n;
}
function fy(e) {
  return {
    items: T(() => dy(e, e.items))
  };
}
const vy = U({
  baseColor: String,
  /* @deprecated */
  activeColor: String,
  activeClass: String,
  bgColor: String,
  disabled: Boolean,
  filterable: Boolean,
  expandIcon: be,
  collapseIcon: be,
  lines: {
    type: [Boolean, String],
    default: "one"
  },
  slim: Boolean,
  prependGap: [Number, String],
  indent: [Number, String],
  nav: Boolean,
  navigationStrategy: {
    type: String,
    default: "focus"
  },
  navigationIndex: Number,
  "onClick:open": Ut(),
  "onClick:select": Ut(),
  "onUpdate:opened": Ut(),
  ...MI({
    selectStrategy: "single-leaf",
    openStrategy: "list"
  }),
  ...qt(),
  ...ve(),
  ...mt(),
  ...St(),
  ...Ct(),
  ...uy(),
  ...lt(),
  ...Ie(),
  ...Re(),
  ...xn({
    variant: "text"
  })
}, "VList"), Gr = K()({
  name: "VList",
  props: vy(),
  emits: {
    "update:selected": (e) => !0,
    "update:activated": (e) => !0,
    "update:opened": (e) => !0,
    "update:navigationIndex": (e) => !0,
    "click:open": (e) => !0,
    "click:activate": (e) => !0,
    "click:select": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: a,
      emit: r
    } = t;
    const {
      items: l
    } = fy(e), {
      themeClasses: i
    } = Ge(e), {
      backgroundColorClasses: o,
      backgroundColorStyles: s
    } = qe(() => e.bgColor), {
      borderClasses: u
    } = en(e), {
      densityClasses: c
    } = zt(e), {
      dimensionStyles: d
    } = xt(e), {
      elevationClasses: f
    } = Et(e), {
      roundedClasses: v
    } = ut(e), {
      children: g,
      open: m,
      parents: h,
      select: w,
      getPath: _
    } = OI(e, {
      items: l,
      returnObject: D(() => e.returnObject),
      scrollToActive: D(() => e.navigationStrategy === "track")
    }), I = D(() => e.lines ? `v-list--${e.lines}-line` : void 0), C = D(() => e.activeColor), b = D(() => e.baseColor), p = D(() => e.color), x = D(() => e.selectable || e.activatable), k = he(e, "navigationIndex", -1, (j) => j ?? -1), V = Rt();
    Jg({
      filterable: e.filterable,
      trackingIndex: k,
      navigationStrategy: D(() => e.navigationStrategy),
      uid: V
    }), ne(l, () => {
      e.navigationStrategy === "track" && (k.value = -1);
    }), vt({
      VListGroup: {
        activeColor: C,
        baseColor: b,
        color: p,
        expandIcon: D(() => e.expandIcon),
        collapseIcon: D(() => e.collapseIcon)
      },
      VListItem: {
        activeClass: D(() => e.activeClass),
        activeColor: C,
        baseColor: b,
        color: p,
        density: D(() => e.density),
        disabled: D(() => e.disabled),
        lines: D(() => e.lines),
        nav: D(() => e.nav),
        slim: D(() => e.slim),
        variant: D(() => e.variant),
        tabindex: D(() => e.navigationStrategy === "track" ? -1 : void 0)
      }
    });
    const A = ae(!1), M = G();
    function L(j) {
      A.value = !0;
    }
    function E(j) {
      A.value = !1;
    }
    function P(j) {
      e.navigationStrategy === "track" ? ~k.value || (k.value = B("first")) : !A.value && !(j.relatedTarget && M.value?.contains(j.relatedTarget)) && R();
    }
    function O() {
      e.navigationStrategy === "track" && (k.value = -1);
    }
    function F(j) {
      switch (j) {
        case "ArrowDown":
          return "next";
        case "ArrowUp":
          return "prev";
        case "Home":
          return "first";
        case "End":
          return "last";
        default:
          return null;
      }
    }
    function B(j) {
      const H = l.value.length;
      if (H === 0) return -1;
      let $;
      j === "first" ? $ = 0 : j === "last" ? $ = H - 1 : ($ = k.value + (j === "next" ? 1 : -1), $ < 0 && ($ = H - 1), $ >= H && ($ = 0));
      const z = $;
      let te = 0;
      for (; te < H; ) {
        const me = l.value[$];
        if (me && me.type !== "divider" && me.type !== "subheader")
          return $;
        if ($ += j === "next" || j === "first" ? 1 : -1, $ < 0 && ($ = H - 1), $ >= H && ($ = 0), $ === z) return -1;
        te++;
      }
      return -1;
    }
    function N(j) {
      const H = j.target;
      if (!M.value || H.tagName === "INPUT" && ["Home", "End"].includes(j.key) || H.tagName === "TEXTAREA")
        return;
      const $ = F(j.key);
      if ($ !== null)
        if (j.preventDefault(), e.navigationStrategy === "track") {
          const z = B($);
          z !== -1 && (k.value = z);
        } else
          R($);
    }
    function W(j) {
      A.value = !0;
    }
    function R(j) {
      if (M.value)
        return Ka(M.value, j);
    }
    return X(() => {
      const j = x.value ? n.ariaMultiselectable ?? !String(e.selectStrategy).startsWith("single-") : void 0;
      return y(e.tag, {
        ref: M,
        class: J(["v-list", {
          "v-list--disabled": e.disabled,
          "v-list--nav": e.nav,
          "v-list--slim": e.slim
        }, i.value, o.value, u.value, c.value, f.value, I.value, v.value, e.class]),
        style: le([{
          "--v-list-indent": re(e.indent),
          "--v-list-prepend-gap": re(e.prependGap)
        }, s.value, d.value, e.style]),
        tabindex: e.disabled ? -1 : 0,
        role: x.value ? "listbox" : "list",
        "aria-activedescendant": e.navigationStrategy === "track" && k.value >= 0 ? `v-list-item-${V}-${k.value}` : void 0,
        "aria-multiselectable": j,
        onFocusin: L,
        onFocusout: E,
        onFocus: P,
        onBlur: O,
        onKeydown: N,
        onMousedown: W
      }, {
        default: () => [y(sy, {
          items: l.value,
          returnObject: e.returnObject
        }, a)]
      });
    }), {
      open: m,
      select: w,
      focus: R,
      children: g,
      parents: h,
      getPath: _,
      navigationIndex: k
    };
  }
}), WI = ca("v-list-img"), HI = U({
  start: Boolean,
  end: Boolean,
  ...ve(),
  ...Ie()
}, "VListItemAction"), jc = K()({
  name: "VListItemAction",
  props: HI(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => y(e.tag, {
      class: J(["v-list-item-action", {
        "v-list-item-action--start": e.start,
        "v-list-item-action--end": e.end
      }, e.class]),
      style: le(e.style)
    }, n)), {};
  }
}), zI = U({
  start: Boolean,
  end: Boolean,
  ...ve(),
  ...Ie()
}, "VListItemMedia"), jI = K()({
  name: "VListItemMedia",
  props: zI(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => y(e.tag, {
      class: J(["v-list-item-media", {
        "v-list-item-media--start": e.start,
        "v-list-item-media--end": e.end
      }, e.class]),
      style: le(e.style)
    }, n)), {};
  }
});
function Ms(e, t) {
  return {
    x: e.x + t.x,
    y: e.y + t.y
  };
}
function GI(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y
  };
}
function Iv(e, t) {
  if (e.side === "top" || e.side === "bottom") {
    const {
      side: n,
      align: a
    } = e, r = a === "left" ? 0 : a === "center" ? t.width / 2 : a === "right" ? t.width : a, l = n === "top" ? 0 : n === "bottom" ? t.height : n;
    return Ms({
      x: r,
      y: l
    }, t);
  } else if (e.side === "left" || e.side === "right") {
    const {
      side: n,
      align: a
    } = e, r = n === "left" ? 0 : n === "right" ? t.width : n, l = a === "top" ? 0 : a === "center" ? t.height / 2 : a === "bottom" ? t.height : a;
    return Ms({
      x: r,
      y: l
    }, t);
  }
  return Ms({
    x: t.width / 2,
    y: t.height / 2
  }, t);
}
const my = {
  static: KI,
  // specific viewport position, usually centered
  connected: JI
  // connected to a certain element
}, qI = U({
  locationStrategy: {
    type: [String, Function],
    default: "static",
    validator: (e) => typeof e == "function" || e in my
  },
  location: {
    type: String,
    default: "bottom"
  },
  origin: {
    type: String,
    default: "auto"
  },
  offset: [Number, String, Array],
  stickToTarget: Boolean,
  viewportMargin: {
    type: [Number, String],
    default: 12
  }
}, "VOverlay-location-strategies");
function YI(e, t) {
  const n = G({}), a = G();
  wt && Wt(() => !!(t.isActive.value && e.locationStrategy), (o) => {
    ne(() => e.locationStrategy, o), It(() => {
      window.removeEventListener("resize", r), visualViewport?.removeEventListener("resize", l), visualViewport?.removeEventListener("scroll", i), a.value = void 0;
    }), window.addEventListener("resize", r, {
      passive: !0
    }), visualViewport?.addEventListener("resize", l, {
      passive: !0
    }), visualViewport?.addEventListener("scroll", i, {
      passive: !0
    }), typeof e.locationStrategy == "function" ? a.value = e.locationStrategy(t, e, n)?.updateLocation : a.value = my[e.locationStrategy](t, e, n)?.updateLocation;
  });
  function r(o) {
    a.value?.(o);
  }
  function l(o) {
    a.value?.(o);
  }
  function i(o) {
    a.value?.(o);
  }
  return {
    contentStyles: n,
    updateLocation: a
  };
}
function KI() {
}
function ZI(e, t) {
  const n = _c(e);
  return t ? n.x += parseFloat(e.style.right || 0) : n.x -= parseFloat(e.style.left || 0), n.y -= parseFloat(e.style.top || 0), n;
}
function JI(e, t, n) {
  (Array.isArray(e.target.value) || q_(e.target.value)) && Object.assign(n.value, {
    position: "fixed",
    top: 0,
    [e.isRtl.value ? "right" : "left"]: 0
  });
  const {
    preferredAnchor: r,
    preferredOrigin: l
  } = Cc(() => {
    const w = ou(t.location, e.isRtl.value), _ = t.origin === "overlap" ? w : t.origin === "auto" ? _s(w) : ou(t.origin, e.isRtl.value);
    return w.side === _.side && w.align === Ts(_).align ? {
      preferredAnchor: av(w),
      preferredOrigin: av(_)
    } : {
      preferredAnchor: w,
      preferredOrigin: _
    };
  }), [i, o, s, u] = ["minWidth", "minHeight", "maxWidth", "maxHeight"].map((w) => T(() => {
    const _ = parseFloat(t[w]);
    return isNaN(_) ? 1 / 0 : _;
  })), c = T(() => {
    if (Array.isArray(t.offset))
      return t.offset;
    if (typeof t.offset == "string") {
      const w = t.offset.split(" ").map(parseFloat);
      return w.length < 2 && w.push(0), w;
    }
    return typeof t.offset == "number" ? [t.offset, 0] : [0, 0];
  });
  let d = !1, f = -1;
  const v = new ig(4), g = new ResizeObserver(() => {
    if (!d) return;
    if (requestAnimationFrame((_) => {
      _ !== f && v.clear(), requestAnimationFrame((I) => {
        f = I;
      });
    }), v.isFull) {
      const _ = v.values();
      if (Lt(_.at(-1), _.at(-3)) && !Lt(_.at(-1), _.at(-2)))
        return;
    }
    const w = h();
    w && v.push(w.flipped);
  });
  let m = new Pn({
    x: 0,
    y: 0,
    width: 0,
    height: 0
  });
  ne(e.target, (w, _) => {
    _ && !Array.isArray(_) && g.unobserve(_), Array.isArray(w) ? Lt(w, _) || h() : w && g.observe(w);
  }, {
    immediate: !0
  }), ne(e.contentEl, (w, _) => {
    _ && g.unobserve(_), w && g.observe(w);
  }, {
    immediate: !0
  }), It(() => {
    g.disconnect();
  });
  function h() {
    if (d = !1, requestAnimationFrame(() => d = !0), !e.target.value || !e.contentEl.value) return;
    (Array.isArray(e.target.value) || e.target.value.offsetParent || e.target.value.getClientRects().length) && (m = cg(e.target.value));
    const w = ZI(e.contentEl.value, e.isRtl.value), _ = oo(e.contentEl.value), I = Number(t.viewportMargin);
    _.length || (_.push(document.documentElement), e.contentEl.value.style.top && e.contentEl.value.style.left || (w.x -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-x") || 0), w.y -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-y") || 0)));
    const C = _.reduce((E, P) => {
      const O = b_(P);
      return E ? new Pn({
        x: Math.max(E.left, O.left),
        y: Math.max(E.top, O.top),
        width: Math.min(E.right, O.right) - Math.max(E.left, O.left),
        height: Math.min(E.bottom, O.bottom) - Math.max(E.top, O.top)
      }) : O;
    }, void 0);
    t.stickToTarget ? (C.x += Math.min(I, m.x), C.y += Math.min(I, m.y), C.width = Math.max(C.width - I * 2, m.x + m.width - I), C.height = Math.max(C.height - I * 2, m.y + m.height - I)) : (C.x += I, C.y += I, C.width -= I * 2, C.height -= I * 2);
    let b = {
      anchor: r.value,
      origin: l.value
    };
    function p(E) {
      const P = new Pn(w), O = Iv(E.anchor, m), F = Iv(E.origin, P);
      let {
        x: B,
        y: N
      } = GI(O, F);
      switch (E.anchor.side) {
        case "top":
          N -= c.value[0];
          break;
        case "bottom":
          N += c.value[0];
          break;
        case "left":
          B -= c.value[0];
          break;
        case "right":
          B += c.value[0];
          break;
      }
      switch (E.anchor.align) {
        case "top":
          N -= c.value[1];
          break;
        case "bottom":
          N += c.value[1];
          break;
        case "left":
          B -= c.value[1];
          break;
        case "right":
          B += c.value[1];
          break;
      }
      return P.x += B, P.y += N, P.width = Math.min(P.width, s.value), P.height = Math.min(P.height, u.value), {
        overflows: lv(P, C),
        x: B,
        y: N
      };
    }
    let x = 0, k = 0;
    const V = {
      x: 0,
      y: 0
    }, A = {
      x: !1,
      y: !1
    };
    let M = -1;
    for (; ; ) {
      if (M++ > 10) {
        ni("Infinite loop detected in connectedLocationStrategy");
        break;
      }
      const {
        x: E,
        y: P,
        overflows: O
      } = p(b);
      x += E, k += P, w.x += E, w.y += P;
      {
        const F = rv(b.anchor), B = O.x.before || O.x.after, N = O.y.before || O.y.after;
        let W = !1;
        if (["x", "y"].forEach((R) => {
          if (R === "x" && B && !A.x || R === "y" && N && !A.y) {
            const j = {
              anchor: {
                ...b.anchor
              },
              origin: {
                ...b.origin
              }
            }, H = R === "x" ? F === "y" ? Ts : _s : F === "y" ? _s : Ts;
            j.anchor = H(j.anchor), j.origin = H(j.origin);
            const {
              overflows: $
            } = p(j);
            ($[R].before <= O[R].before && $[R].after <= O[R].after || $[R].before + $[R].after < (O[R].before + O[R].after) / 2) && (b = j, W = A[R] = !0);
          }
        }), W) continue;
      }
      O.x.before && (x += O.x.before, w.x += O.x.before), O.x.after && (x -= O.x.after, w.x -= O.x.after), O.y.before && (k += O.y.before, w.y += O.y.before), O.y.after && (k -= O.y.after, w.y -= O.y.after);
      {
        const F = lv(w, C);
        V.x = C.width - F.x.before - F.x.after, V.y = C.height - F.y.before - F.y.after, x += F.x.before, w.x += F.x.before, k += F.y.before, w.y += F.y.before;
      }
      break;
    }
    const L = rv(b.anchor);
    return Object.assign(n.value, {
      "--v-overlay-anchor-origin": `${b.anchor.side} ${b.anchor.align}`,
      transformOrigin: `${b.origin.side} ${b.origin.align}`,
      // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
      top: re(Os(k)),
      left: e.isRtl.value ? void 0 : re(Os(x)),
      right: e.isRtl.value ? re(Os(-x)) : void 0,
      minWidth: re(L === "y" ? Math.min(i.value, m.width) : i.value),
      maxWidth: re(Av(Xe(V.x, i.value === 1 / 0 ? 0 : i.value, s.value))),
      maxHeight: re(Av(Xe(V.y, o.value === 1 / 0 ? 0 : o.value, u.value)))
    }), {
      available: V,
      contentBox: w,
      flipped: A
    };
  }
  return ne(() => [r.value, l.value, t.offset, t.minWidth, t.minHeight, t.maxWidth, t.maxHeight], () => h()), Se(() => {
    const w = h();
    if (!w) return;
    const {
      available: _,
      contentBox: I
    } = w;
    I.height > _.y && requestAnimationFrame(() => {
      h(), requestAnimationFrame(() => {
        h();
      });
    });
  }), {
    updateLocation: h
  };
}
function Os(e) {
  return Math.round(e * devicePixelRatio) / devicePixelRatio;
}
function Av(e) {
  return Math.ceil(e * devicePixelRatio) / devicePixelRatio;
}
let wu = !0;
const fo = [];
function XI(e) {
  !wu || fo.length ? (fo.push(e), ku()) : (wu = !1, e(), ku());
}
let Pv = -1;
function ku() {
  cancelAnimationFrame(Pv), Pv = requestAnimationFrame(() => {
    const e = fo.shift();
    e && e(), fo.length ? ku() : wu = !0;
  });
}
const hy = {
  none: null,
  close: tA,
  block: nA,
  reposition: aA
}, QI = U({
  scrollStrategy: {
    type: [String, Function],
    default: "block",
    validator: (e) => typeof e == "function" || e in hy
  }
}, "VOverlay-scroll-strategies");
function eA(e, t) {
  if (!wt) return;
  let n;
  ft(async () => {
    n?.stop(), t.isActive.value && e.scrollStrategy && (n = bo(), await new Promise((a) => setTimeout(a)), n.active && n.run(() => {
      typeof e.scrollStrategy == "function" ? e.scrollStrategy(t, e, n) : hy[e.scrollStrategy]?.(t, e, n);
    }));
  }), It(() => {
    n?.stop();
  });
}
function tA(e) {
  function t(n) {
    e.isActive.value = !1;
  }
  gy(Gc(e.target.value, e.contentEl.value), t);
}
function nA(e, t) {
  const n = e.root.value?.offsetParent, a = Gc(e.target.value, e.contentEl.value), r = [.../* @__PURE__ */ new Set([...oo(a, t.contained ? n : void 0), ...oo(e.contentEl.value, t.contained ? n : void 0)])].filter((o) => !o.classList.contains("v-overlay-scroll-blocked")), l = window.innerWidth - document.documentElement.offsetWidth, i = ((o) => Ac(o) && o)(n || document.documentElement);
  i && e.root.value.classList.add("v-overlay--scroll-blocked"), r.forEach((o, s) => {
    o.style.setProperty("--v-body-scroll-x", re(-o.scrollLeft)), o.style.setProperty("--v-body-scroll-y", re(-o.scrollTop)), o !== document.documentElement && o.style.setProperty("--v-scrollbar-offset", re(l)), o.classList.add("v-overlay-scroll-blocked");
  }), It(() => {
    r.forEach((o, s) => {
      const u = parseFloat(o.style.getPropertyValue("--v-body-scroll-x")), c = parseFloat(o.style.getPropertyValue("--v-body-scroll-y")), d = o.style.scrollBehavior;
      o.style.scrollBehavior = "auto", o.style.removeProperty("--v-body-scroll-x"), o.style.removeProperty("--v-body-scroll-y"), o.style.removeProperty("--v-scrollbar-offset"), o.classList.remove("v-overlay-scroll-blocked"), o.scrollLeft = -u, o.scrollTop = -c, o.style.scrollBehavior = d;
    }), i && e.root.value.classList.remove("v-overlay--scroll-blocked");
  });
}
function aA(e, t, n) {
  let a = !1, r = -1, l = -1;
  function i(o) {
    XI(() => {
      const s = performance.now();
      e.updateLocation.value?.(o), a = (performance.now() - s) / (1e3 / 60) > 2;
    });
  }
  l = (typeof requestIdleCallback > "u" ? (o) => o() : requestIdleCallback)(() => {
    n.run(() => {
      gy(Gc(e.target.value, e.contentEl.value), (o) => {
        a ? (cancelAnimationFrame(r), r = requestAnimationFrame(() => {
          r = requestAnimationFrame(() => {
            i(o);
          });
        })) : i(o);
      });
    });
  }), It(() => {
    typeof cancelIdleCallback < "u" && cancelIdleCallback(l), cancelAnimationFrame(r);
  });
}
function Gc(e, t) {
  return Array.isArray(e) ? document.elementsFromPoint(...e).find((n) => !t?.contains(n)) : e ?? t;
}
function gy(e, t) {
  const n = [document, ...oo(e)];
  n.forEach((a) => {
    a.addEventListener("scroll", t, {
      passive: !0
    });
  }), It(() => {
    n.forEach((a) => {
      a.removeEventListener("scroll", t);
    });
  });
}
const Su = /* @__PURE__ */ Symbol.for("vuetify:v-menu"), qc = U({
  closeDelay: [Number, String],
  openDelay: [Number, String]
}, "delay");
function Yc(e, t) {
  let n = () => {
  };
  function a(i, o) {
    n?.();
    const s = i ? e.openDelay : e.closeDelay, u = Math.max(o?.minDelay ?? 0, Number(s ?? 0));
    return new Promise((c) => {
      n = f_(u, () => {
        t?.(i), c(i);
      });
    });
  }
  function r() {
    return a(!0);
  }
  function l(i) {
    return a(!1, i);
  }
  return {
    clearDelay: n,
    runOpenDelay: r,
    runCloseDelay: l
  };
}
const rA = U({
  target: [String, Object],
  activator: [String, Object],
  activatorProps: {
    type: Object,
    default: () => ({})
  },
  openOnClick: {
    type: Boolean,
    default: void 0
  },
  openOnHover: Boolean,
  openOnFocus: {
    type: Boolean,
    default: void 0
  },
  closeOnContentClick: Boolean,
  ...qc()
}, "VOverlay-activator");
function lA(e, t) {
  let {
    isActive: n,
    isTop: a,
    contentEl: r
  } = t;
  const l = kt("useActivator"), i = G();
  let o = !1, s = !1, u = !0;
  const c = T(() => e.openOnFocus || e.openOnFocus == null && e.openOnHover), d = T(() => e.openOnClick || e.openOnClick == null && !e.openOnHover && !c.value), {
    runOpenDelay: f,
    runCloseDelay: v
  } = Yc(e, (k) => {
    k === (e.openOnHover && o || c.value && s) && !(e.openOnHover && n.value && !a.value) && (n.value !== k && (u = !0), n.value = k);
  }), g = G(), m = {
    onClick: (k) => {
      k.stopPropagation(), i.value = k.currentTarget || k.target, n.value || (g.value = [k.clientX, k.clientY]), n.value = !n.value;
    },
    onMouseenter: (k) => {
      o = !0, i.value = k.currentTarget || k.target, f();
    },
    onMouseleave: (k) => {
      o = !1, v();
    },
    onFocus: (k) => {
      Hr(k.target, ":focus-visible") !== !1 && (s = !0, k.stopPropagation(), i.value = k.currentTarget || k.target, f());
    },
    onBlur: (k) => {
      s = !1, k.stopPropagation(), v({
        minDelay: 1
      });
    }
  }, h = T(() => {
    const k = {};
    return d.value && (k.onClick = m.onClick), e.openOnHover && (k.onMouseenter = m.onMouseenter, k.onMouseleave = m.onMouseleave), c.value && (k.onFocus = m.onFocus, k.onBlur = m.onBlur), k;
  }), w = T(() => {
    const k = {};
    if (e.openOnHover && (k.onMouseenter = () => {
      o = !0, f();
    }, k.onMouseleave = () => {
      o = !1, v();
    }), c.value && (k.onFocusin = (V) => {
      V.target.matches(":focus-visible") && (s = !0, f());
    }, k.onFocusout = () => {
      s = !1, v({
        minDelay: 1
      });
    }), e.closeOnContentClick) {
      const V = Le(Su, null);
      k.onClick = () => {
        n.value = !1, V?.closeParents();
      };
    }
    return k;
  }), _ = T(() => {
    const k = {};
    return e.openOnHover && (k.onMouseenter = () => {
      u && (o = !0, u = !1, f());
    }, k.onMouseleave = () => {
      o = !1, v();
    }), k;
  });
  ne(a, (k) => {
    k && (e.openOnHover && !o && (!c.value || !s) || c.value && !s && (!e.openOnHover || !o)) && !r.value?.contains(document.activeElement) && (n.value = !1);
  }), ne(n, (k) => {
    k || setTimeout(() => {
      g.value = void 0;
    });
  }, {
    flush: "post"
  });
  const I = Ol();
  ft(() => {
    I.value && Se(() => {
      i.value = I.el;
    });
  });
  const C = Ol(), b = T(() => e.target === "cursor" && g.value ? g.value : C.value ? C.el : yy(e.target, l) || i.value), p = T(() => Array.isArray(b.value) ? void 0 : b.value);
  let x;
  return ne(() => !!e.activator, (k) => {
    k && wt ? (x = bo(), x.run(() => {
      iA(e, l, {
        activatorEl: i,
        activatorEvents: h
      });
    })) : x && x.stop();
  }, {
    flush: "post",
    immediate: !0
  }), It(() => {
    x?.stop();
  }), {
    activatorEl: i,
    activatorRef: I,
    target: b,
    targetEl: p,
    targetRef: C,
    activatorEvents: h,
    contentEvents: w,
    scrimEvents: _
  };
}
function iA(e, t, n) {
  let {
    activatorEl: a,
    activatorEvents: r
  } = n;
  ne(() => e.activator, (s, u) => {
    if (u && s !== u) {
      const c = o(u);
      c && i(c);
    }
    s && Se(() => l());
  }, {
    immediate: !0
  }), ne(() => e.activatorProps, () => {
    l();
  }), It(() => {
    i();
  });
  function l() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : o(), u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    s && p_(s, Y(r.value, u));
  }
  function i() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : o(), u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    s && w_(s, Y(r.value, u));
  }
  function o() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e.activator;
    const u = yy(s, t);
    return a.value = u?.nodeType === Node.ELEMENT_NODE ? u : void 0, a.value;
  }
}
function yy(e, t) {
  if (!e) return;
  let n;
  if (e === "parent") {
    let a = t?.proxy?.$el?.parentNode;
    for (; a?.hasAttribute("data-no-activator"); )
      a = a.parentNode;
    n = a;
  } else typeof e == "string" ? n = document.querySelector(e) : "$el" in e ? n = e.$el : n = e;
  return n;
}
const by = U({
  retainFocus: Boolean,
  captureFocus: Boolean,
  /** @deprecated */
  disableInitialFocus: Boolean
}, "focusTrap"), ji = /* @__PURE__ */ new Map();
let Vv = 0;
function Ev(e) {
  const t = document.activeElement;
  if (e.key !== "Tab" || !t) return;
  const n = Array.from(ji.values()).filter((u) => {
    let {
      isActive: c,
      contentEl: d
    } = u;
    return c.value && d.value?.contains(t);
  }).map((u) => u.contentEl.value);
  let a, r = t.parentElement;
  for (; r; ) {
    if (n.includes(r)) {
      a = r;
      break;
    }
    r = r.parentElement;
  }
  if (!a) return;
  const l = xa(a).filter((u) => u.tabIndex >= 0);
  if (!l.length) return;
  const i = document.activeElement;
  if (l.length === 1 && l[0].classList.contains("v-list") && l[0].contains(i)) {
    e.preventDefault();
    return;
  }
  const o = l[0], s = l[l.length - 1];
  e.shiftKey && (i === o || o.classList.contains("v-list") && o.contains(i)) && (e.preventDefault(), s.focus()), !e.shiftKey && (i === s || s.classList.contains("v-list") && s.contains(i)) && (e.preventDefault(), o.focus());
}
function py(e, t) {
  let {
    isActive: n,
    localTop: a,
    activatorEl: r,
    contentEl: l
  } = t;
  const i = /* @__PURE__ */ Symbol("trap");
  let o = !1, s = -1;
  async function u() {
    o = !0, s = window.setTimeout(() => {
      o = !1;
    }, 100);
  }
  async function c(v) {
    const g = v.relatedTarget, m = v.target;
    document.removeEventListener("pointerdown", u), document.removeEventListener("keydown", d), await Se(), n.value && !o && g !== m && l.value && // We're the menu without open submenus or overlays
    nt(a) && // It isn't the document or the container body
    ![document, l.value].includes(m) && // It isn't inside the container body
    !l.value.contains(m) && xa(l.value)[0]?.focus();
  }
  function d(v) {
    if (v.key === "Tab" && (document.removeEventListener("keydown", d), n.value && l.value && v.target && !l.value.contains(v.target))) {
      const g = xa(document.documentElement);
      if (v.shiftKey && v.target === g.at(0) || !v.shiftKey && v.target === g.at(-1)) {
        const m = xa(l.value);
        m.length > 0 && (v.preventDefault(), m[0].focus());
      }
    }
  }
  const f = D(() => n.value && e.captureFocus && !e.disableInitialFocus);
  wt && (ne(() => e.retainFocus, (v) => {
    v ? ji.set(i, {
      isActive: n,
      contentEl: l
    }) : ji.delete(i);
  }, {
    immediate: !0
  }), ne(f, (v) => {
    v ? (document.addEventListener("pointerdown", u), document.addEventListener("focusin", c, {
      once: !0
    }), document.addEventListener("keydown", d)) : (document.removeEventListener("pointerdown", u), document.removeEventListener("focusin", c), document.removeEventListener("keydown", d));
  }, {
    immediate: !0
  }), Vv++ < 1 && document.addEventListener("keydown", Ev)), It(() => {
    ji.delete(i), clearTimeout(s), document.removeEventListener("pointerdown", u), document.removeEventListener("focusin", c), document.removeEventListener("keydown", d), --Vv < 1 && document.removeEventListener("keydown", Ev);
  });
}
function wy() {
  if (!wt) return ae(!1);
  const {
    ssr: e
  } = Cn();
  if (e) {
    const t = ae(!1);
    return bt(() => {
      t.value = !0;
    }), t;
  } else
    return ae(!0);
}
const Kc = U({
  eager: Boolean
}, "lazy");
function Zc(e, t) {
  const n = ae(!1), a = D(() => n.value || e.eager || t.value);
  ne(t, () => n.value = !0);
  function r() {
    e.eager || (n.value = !1);
  }
  return {
    isBooted: n,
    hasContent: a,
    onAfterLeave: r
  };
}
function gr() {
  const t = kt("useScopeId").vnode.scopeId;
  return {
    scopeId: t ? {
      [t]: ""
    } : void 0
  };
}
const Mv = /* @__PURE__ */ Symbol.for("vuetify:stack"), gl = cn([]);
function oA(e, t, n) {
  const a = kt("useStack"), r = !n, l = Le(Mv, void 0), i = cn({
    activeChildren: /* @__PURE__ */ new Set()
  });
  st(Mv, i);
  const o = ae(Number(nt(t)));
  Wt(e, () => {
    const c = gl.at(-1)?.[1];
    o.value = c ? c + 10 : Number(nt(t)), r && gl.push([a.uid, o.value]), l?.activeChildren.add(a.uid), It(() => {
      if (r) {
        const d = it(gl).findIndex((f) => f[0] === a.uid);
        gl.splice(d, 1);
      }
      l?.activeChildren.delete(a.uid);
    });
  });
  const s = ae(!0);
  r && ft(() => {
    const c = gl.at(-1)?.[0] === a.uid;
    setTimeout(() => s.value = c);
  });
  const u = D(() => !i.activeChildren.size);
  return {
    globalTop: yo(s),
    localTop: u,
    stackStyles: D(() => ({
      zIndex: o.value
    }))
  };
}
function sA(e) {
  return {
    teleportTarget: T(() => {
      const n = e();
      if (n === !0 || !wt) return;
      const a = n === !1 ? document.body : typeof n == "string" ? document.querySelector(n) : n;
      if (a == null) {
        go(`Unable to locate target ${n}`);
        return;
      }
      let r = [...a.children].find((l) => l.matches(".v-overlay-container"));
      return r || (r = document.createElement("div"), r.className = "v-overlay-container", a.appendChild(r)), r;
    })
  };
}
function uA() {
  return !0;
}
function ky(e, t, n) {
  if (!e || Sy(e, n) === !1) return !1;
  const a = hg(t);
  if (typeof ShadowRoot < "u" && a instanceof ShadowRoot && a.host === e.target) return !1;
  const r = (typeof n.value == "object" && n.value.include || (() => []))();
  return r.push(t), !r.some((l) => l?.contains(e.target));
}
function Sy(e, t) {
  return (typeof t.value == "object" && t.value.closeConditional || uA)(e);
}
function cA(e, t, n) {
  const a = typeof n.value == "function" ? n.value : n.value.handler;
  e.shadowTarget = e.target, t._clickOutside.lastMousedownWasOutside && ky(e, t, n) && setTimeout(() => {
    Sy(e, n) && a && a(e);
  }, 0);
}
function Ov(e, t) {
  const n = hg(e);
  t(document), typeof ShadowRoot < "u" && n instanceof ShadowRoot && t(n);
}
const xu = {
  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  mounted(e, t) {
    const n = (r) => cA(r, e, t), a = (r) => {
      e._clickOutside.lastMousedownWasOutside = ky(r, e, t);
    };
    Ov(e, (r) => {
      r.addEventListener("click", n, !0), r.addEventListener("mousedown", a, !0);
    }), e._clickOutside || (e._clickOutside = {
      lastMousedownWasOutside: !1
    }), e._clickOutside[t.instance.$.uid] = {
      onClick: n,
      onMousedown: a
    };
  },
  beforeUnmount(e, t) {
    e._clickOutside && (Ov(e, (n) => {
      if (!n || !e._clickOutside?.[t.instance.$.uid]) return;
      const {
        onClick: a,
        onMousedown: r
      } = e._clickOutside[t.instance.$.uid];
      n.removeEventListener("click", a, !0), n.removeEventListener("mousedown", r, !0);
    }), delete e._clickOutside[t.instance.$.uid]);
  }
};
function dA(e) {
  const {
    modelValue: t,
    color: n,
    ...a
  } = e;
  return y(Rn, {
    name: "fade-transition",
    appear: !0
  }, {
    default: () => [e.modelValue && S("div", Y({
      class: ["v-overlay__scrim", e.color.backgroundColorClasses.value],
      style: e.color.backgroundColorStyles.value
    }, a), null)]
  });
}
const fi = U({
  absolute: Boolean,
  attach: [Boolean, String, Object],
  closeOnBack: {
    type: Boolean,
    default: !0
  },
  contained: Boolean,
  contentClass: null,
  contentProps: null,
  disabled: Boolean,
  opacity: [Number, String],
  noClickAnimation: Boolean,
  modelValue: Boolean,
  persistent: Boolean,
  scrim: {
    type: [Boolean, String],
    default: !0
  },
  zIndex: {
    type: [Number, String],
    default: 2e3
  },
  ...rA(),
  ...ve(),
  ...St(),
  ...Kc(),
  ...qI(),
  ...QI(),
  ...by(),
  ...Re(),
  ...da()
}, "VOverlay"), Yn = K()({
  name: "VOverlay",
  directives: {
    vClickOutside: xu
  },
  inheritAttrs: !1,
  props: {
    _disableGlobalStack: Boolean,
    ...Pe(fi(), ["disableInitialFocus"])
  },
  emits: {
    "click:outside": (e) => !0,
    "update:modelValue": (e) => !0,
    keydown: (e) => !0,
    afterEnter: () => !0,
    afterLeave: () => !0
  },
  setup(e, t) {
    let {
      slots: n,
      attrs: a,
      emit: r
    } = t;
    const l = kt("VOverlay"), i = G(), o = G(), s = G(), u = he(e, "modelValue"), c = T({
      get: () => u.value,
      set: (Q) => {
        Q && e.disabled || (u.value = Q);
      }
    }), {
      themeClasses: d
    } = Ge(e), {
      rtlClasses: f,
      isRtl: v
    } = At(), {
      hasContent: g,
      onAfterLeave: m
    } = Zc(e, c), h = qe(() => typeof e.scrim == "string" ? e.scrim : null), {
      globalTop: w,
      localTop: _,
      stackStyles: I
    } = oA(c, () => e.zIndex, e._disableGlobalStack), {
      activatorEl: C,
      activatorRef: b,
      target: p,
      targetEl: x,
      targetRef: k,
      activatorEvents: V,
      contentEvents: A,
      scrimEvents: M
    } = lA(e, {
      isActive: c,
      isTop: _,
      contentEl: s
    }), {
      teleportTarget: L
    } = sA(() => {
      const Q = e.attach || e.contained;
      if (Q) return Q;
      const ie = C?.value?.getRootNode() || l.proxy?.$el?.getRootNode();
      return ie instanceof ShadowRoot ? ie : !1;
    }), {
      dimensionStyles: E
    } = xt(e), P = wy(), {
      scopeId: O
    } = gr();
    ne(() => e.disabled, (Q) => {
      Q && (c.value = !1);
    });
    const {
      contentStyles: F,
      updateLocation: B
    } = YI(e, {
      isRtl: v,
      contentEl: s,
      target: p,
      isActive: c
    });
    eA(e, {
      root: i,
      contentEl: s,
      targetEl: x,
      target: p,
      isActive: c,
      updateLocation: B
    });
    function N(Q) {
      r("click:outside", Q), e.persistent ? z() : c.value = !1;
    }
    function W(Q) {
      return c.value && _.value && // If using scrim, only close if clicking on it rather than anything opened on top
      (!e.scrim || Q.target === o.value || Q instanceof MouseEvent && Q.shadowTarget === o.value);
    }
    py(e, {
      isActive: c,
      localTop: _,
      contentEl: s,
      activatorEl: C
    }), wt && ne(c, (Q) => {
      Q ? window.addEventListener("keydown", R) : window.removeEventListener("keydown", R);
    }, {
      immediate: !0
    }), Ft(() => {
      wt && window.removeEventListener("keydown", R);
    });
    function R(Q) {
      Q.key === "Escape" && w.value && (s.value?.contains(document.activeElement) || r("keydown", Q), e.persistent ? z() : (c.value = !1, s.value?.contains(document.activeElement) && C.value?.focus()));
    }
    function j(Q) {
      Q.key === "Escape" && !w.value || r("keydown", Q);
    }
    const H = Vg();
    Wt(() => e.closeOnBack, () => {
      $T(H, (Q) => {
        w.value && c.value ? (Q(!1), e.persistent ? z() : c.value = !1) : Q();
      });
    });
    const $ = G();
    ne(() => c.value && (e.absolute || e.contained) && L.value == null, (Q) => {
      if (Q) {
        const ie = No(i.value);
        ie && ie !== document.scrollingElement && ($.value = ie.scrollTop);
      }
    });
    function z() {
      e.noClickAnimation || s.value && aa(s.value, [{
        transformOrigin: "center"
      }, {
        transform: "scale(1.03)"
      }, {
        transformOrigin: "center"
      }], {
        duration: 150,
        easing: Dl
      });
    }
    function te() {
      r("afterEnter");
    }
    function me() {
      m(), r("afterLeave");
    }
    return X(() => S(fe, null, [n.activator?.({
      isActive: c.value,
      targetRef: k,
      props: Y({
        ref: b
      }, V.value, e.activatorProps)
    }), P.value && g.value && y(Ku, {
      disabled: !L.value,
      to: L.value
    }, {
      default: () => [S("div", Y({
        class: ["v-overlay", {
          "v-overlay--absolute": e.absolute || e.contained,
          "v-overlay--active": c.value,
          "v-overlay--contained": e.contained
        }, d.value, f.value, e.class],
        style: [I.value, {
          "--v-overlay-opacity": e.opacity,
          top: re($.value)
        }, e.style],
        ref: i,
        onKeydown: j
      }, O, a), [y(dA, Y({
        color: h,
        modelValue: c.value && !!e.scrim,
        ref: o
      }, M.value), null), y(Xt, {
        appear: !0,
        persisted: !0,
        transition: e.transition,
        target: p.value,
        onAfterEnter: te,
        onAfterLeave: me
      }, {
        default: () => [at(S("div", Y({
          ref: s,
          class: ["v-overlay__content", e.contentClass],
          style: [E.value, F.value]
        }, A.value, e.contentProps), [n.default?.({
          isActive: c
        })]), [[Wn, c.value], [xu, {
          handler: N,
          closeConditional: W,
          include: () => [C.value]
        }]])]
      })])]
    })])), {
      activatorEl: C,
      scrimEl: o,
      target: p,
      animateClick: z,
      contentEl: s,
      rootEl: i,
      globalTop: w,
      localTop: _,
      updateLocation: B
    };
  }
}), xy = U({
  // TODO
  // disableKeys: Boolean,
  id: String,
  submenu: Boolean,
  ...Pe(fi({
    captureFocus: !0,
    closeDelay: 250,
    closeOnContentClick: !0,
    locationStrategy: "connected",
    location: void 0,
    openDelay: 300,
    scrim: !1,
    scrollStrategy: "reposition",
    transition: {
      component: Ro
    }
  }), ["absolute"])
}, "VMenu"), qr = K()({
  name: "VMenu",
  props: xy(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = he(e, "modelValue"), {
      scopeId: r
    } = gr(), {
      isRtl: l
    } = At(), i = Rt(), o = D(() => e.id || `v-menu-${i}`), s = G(), u = Le(Su, null), c = ae(/* @__PURE__ */ new Set());
    st(Su, {
      register() {
        c.value.add(i);
      },
      unregister() {
        c.value.delete(i);
      },
      closeParents(m) {
        setTimeout(() => {
          !c.value.size && !e.persistent && (m == null || s.value?.contentEl && !v_(m, s.value.contentEl)) && (a.value = !1, u?.closeParents());
        }, 40);
      }
    }), Ft(() => u?.unregister()), om(() => a.value = !1), ne(a, (m) => {
      m ? u?.register() : u?.unregister();
    }, {
      immediate: !0
    });
    function d(m) {
      u?.closeParents(m);
    }
    function f(m) {
      if (!e.disabled)
        if (m.key === "Tab" || m.key === "Enter" && !e.closeOnContentClick) {
          if (m.key === "Enter" && (m.target instanceof HTMLTextAreaElement || m.target instanceof HTMLInputElement && m.target.closest("form"))) return;
          m.key === "Enter" && m.preventDefault(), !sg(xa(s.value?.contentEl, !1), m.shiftKey ? "prev" : "next", (w) => w.tabIndex >= 0) && !e.retainFocus && (a.value = !1, s.value?.activatorEl?.focus());
        } else e.submenu && m.key === (l.value ? "ArrowRight" : "ArrowLeft") && (a.value = !1, s.value?.activatorEl?.focus());
    }
    function v(m) {
      if (e.disabled) return;
      const h = s.value?.contentEl;
      h && a.value ? m.key === "ArrowDown" ? (m.preventDefault(), m.stopImmediatePropagation(), Ka(h, "next")) : m.key === "ArrowUp" ? (m.preventDefault(), m.stopImmediatePropagation(), Ka(h, "prev")) : e.submenu && (m.key === (l.value ? "ArrowRight" : "ArrowLeft") ? a.value = !1 : m.key === (l.value ? "ArrowLeft" : "ArrowRight") && (m.preventDefault(), Ka(h, "first"))) : (e.submenu ? m.key === (l.value ? "ArrowLeft" : "ArrowRight") : ["ArrowDown", "ArrowUp"].includes(m.key)) && (a.value = !0, m.preventDefault(), setTimeout(() => setTimeout(() => v(m))));
    }
    const g = T(() => Y({
      "aria-haspopup": "menu",
      "aria-expanded": String(a.value),
      "aria-controls": o.value,
      "aria-owns": o.value,
      onKeydown: v
    }, e.activatorProps));
    return X(() => {
      const m = Yn.filterProps(e);
      return y(Yn, Y({
        ref: s,
        id: o.value,
        class: ["v-menu", e.class],
        style: e.style
      }, m, {
        modelValue: a.value,
        "onUpdate:modelValue": (h) => a.value = h,
        absolute: !0,
        activatorProps: g.value,
        location: e.location ?? (e.submenu ? "end" : "bottom"),
        "onClick:outside": d,
        onKeydown: f
      }, r), {
        activator: n.activator,
        default: function() {
          for (var h = arguments.length, w = new Array(h), _ = 0; _ < h; _++)
            w[_] = arguments[_];
          return y(Ae, {
            root: "VMenu"
          }, {
            default: () => [n.default?.(...w)]
          });
        }
      });
    }), Mt({
      id: o,
      ΨopenChildren: c
    }, s);
  }
}), Jc = U({
  color: String,
  ...qt(),
  ...ve(),
  ...St(),
  ...Ct(),
  ...Qn(),
  ...il(),
  ...lt(),
  ...Ie(),
  ...Re()
}, "VSheet"), Va = K()({
  name: "VSheet",
  props: Jc(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: a
    } = Ge(e), {
      backgroundColorClasses: r,
      backgroundColorStyles: l
    } = qe(() => e.color), {
      borderClasses: i
    } = en(e), {
      dimensionStyles: o
    } = xt(e), {
      elevationClasses: s
    } = Et(e), {
      locationStyles: u
    } = La(e), {
      positionClasses: c
    } = ol(e), {
      roundedClasses: d
    } = ut(e);
    return X(() => y(e.tag, {
      class: J(["v-sheet", a.value, r.value, i.value, s.value, c.value, d.value, e.class]),
      style: le([l.value, o.value, u.value, e.style])
    }, n)), {};
  }
}), fA = U({
  active: Boolean,
  disabled: Boolean,
  max: [Number, String],
  value: {
    type: [Number, String],
    default: 0
  },
  ...ve(),
  ...da({
    transition: {
      component: Oc
    }
  })
}, "VCounter"), Go = K()({
  name: "VCounter",
  functional: !0,
  props: fA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = D(() => e.max ? `${e.value} / ${e.max}` : String(e.value));
    return X(() => y(Xt, {
      transition: e.transition
    }, {
      default: () => [at(S("div", {
        class: J(["v-counter", {
          "text-error": e.max && !e.disabled && parseFloat(e.value) > parseFloat(e.max)
        }, e.class]),
        style: le(e.style)
      }, [n.default ? n.default({
        counter: a.value,
        max: e.max,
        value: e.value
      }) : a.value]), [[Wn, e.active]])]
    })), {};
  }
}), vA = U({
  floating: Boolean,
  ...ve()
}, "VFieldLabel"), Sl = K()({
  name: "VFieldLabel",
  props: vA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => y(sl, {
      class: J(["v-field-label", {
        "v-field-label--floating": e.floating
      }, e.class]),
      style: le(e.style)
    }, n)), {};
  }
}), mA = ["underlined", "outlined", "filled", "solo", "solo-inverted", "solo-filled", "plain"], vi = U({
  appendInnerIcon: be,
  bgColor: String,
  clearable: Boolean,
  clearIcon: {
    type: be,
    default: "$clear"
  },
  active: Boolean,
  centerAffix: {
    type: Boolean,
    default: void 0
  },
  color: String,
  baseColor: String,
  dirty: Boolean,
  disabled: {
    type: Boolean,
    default: null
  },
  glow: Boolean,
  error: Boolean,
  flat: Boolean,
  iconColor: [Boolean, String],
  label: String,
  persistentClear: Boolean,
  prependInnerIcon: be,
  reverse: Boolean,
  singleLine: Boolean,
  variant: {
    type: String,
    default: "filled",
    validator: (e) => mA.includes(e)
  },
  "onClick:clear": Ut(),
  "onClick:appendInner": Ut(),
  "onClick:prependInner": Ut(),
  ...ve(),
  ...Wo(),
  ...lt(),
  ...Re()
}, "VField"), Ea = K()({
  name: "VField",
  inheritAttrs: !1,
  props: {
    id: String,
    details: Boolean,
    labelId: String,
    ...di(),
    ...vi()
  },
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: a,
      slots: r
    } = t;
    const {
      themeClasses: l
    } = Ge(e), {
      loaderClasses: i
    } = ii(e), {
      focusClasses: o,
      isFocused: s,
      focus: u,
      blur: c
    } = ma(e), {
      InputIcon: d
    } = ci(e), {
      roundedClasses: f
    } = ut(e), {
      rtlClasses: v
    } = At(), g = D(() => e.dirty || e.active), m = D(() => !!(e.label || r.label)), h = D(() => !e.singleLine && m.value), w = Rt(), _ = T(() => e.id || `input-${w}`), I = D(() => e.details ? `${_.value}-messages` : void 0), C = G(), b = G(), p = G(), x = T(() => ["plain", "underlined"].includes(e.variant)), k = T(() => e.error || e.disabled ? void 0 : g.value && s.value ? e.color : e.baseColor), V = T(() => {
      if (!(!e.iconColor || e.glow && !s.value))
        return e.iconColor === !0 ? k.value : e.iconColor;
    }), {
      backgroundColorClasses: A,
      backgroundColorStyles: M
    } = qe(() => e.bgColor), {
      textColorClasses: L,
      textColorStyles: E
    } = Nt(k);
    ne(g, (N) => {
      if (h.value && !Gn()) {
        const W = C.value.$el, R = b.value.$el;
        requestAnimationFrame(() => {
          const j = _c(W), H = R.getBoundingClientRect(), $ = H.x - j.x, z = H.y - j.y - (j.height / 2 - H.height / 2), te = H.width / 0.75, me = Math.abs(te - j.width) > 1 ? {
            maxWidth: re(te)
          } : void 0, Q = getComputedStyle(W), ie = getComputedStyle(R), ke = parseFloat(Q.transitionDuration) * 1e3 || 150, ye = parseFloat(ie.getPropertyValue("--v-field-label-scale")), ue = ie.getPropertyValue("color");
          W.style.visibility = "visible", R.style.visibility = "hidden", aa(W, {
            transform: `translate(${$}px, ${z}px) scale(${ye})`,
            color: ue,
            ...me
          }, {
            duration: ke,
            easing: Dl,
            direction: N ? "normal" : "reverse"
          }).finished.then(() => {
            W.style.removeProperty("visibility"), R.style.removeProperty("visibility");
          });
        });
      }
    }, {
      flush: "post"
    });
    const P = T(() => ({
      isActive: g,
      isFocused: s,
      controlRef: p,
      iconColor: V,
      blur: c,
      focus: u
    })), O = D(() => {
      const N = !g.value;
      return {
        "aria-hidden": N,
        for: N ? void 0 : _.value
      };
    }), F = D(() => {
      const N = h.value && g.value;
      return {
        "aria-hidden": N,
        for: N ? void 0 : _.value
      };
    });
    function B(N) {
      N.target !== document.activeElement && N.preventDefault();
    }
    return X(() => {
      const N = e.variant === "outlined", W = !!(r["prepend-inner"] || e.prependInnerIcon), R = !!(e.clearable || r.clear) && !e.disabled, j = !!(r["append-inner"] || e.appendInnerIcon || R), H = () => r.label ? r.label({
        ...P.value,
        label: e.label,
        props: {
          for: _.value
        }
      }) : e.label;
      return S("div", Y({
        class: ["v-field", {
          "v-field--active": g.value,
          "v-field--appended": j,
          "v-field--center-affix": e.centerAffix ?? !x.value,
          "v-field--disabled": e.disabled,
          "v-field--dirty": e.dirty,
          "v-field--error": e.error,
          "v-field--glow": e.glow,
          "v-field--flat": e.flat,
          "v-field--has-background": !!e.bgColor,
          "v-field--persistent-clear": e.persistentClear,
          "v-field--prepended": W,
          "v-field--reverse": e.reverse,
          "v-field--single-line": e.singleLine,
          "v-field--no-label": !H(),
          [`v-field--variant-${e.variant}`]: !0
        }, l.value, A.value, o.value, i.value, f.value, v.value, e.class],
        style: [M.value, e.style],
        onClick: B
      }, n), [S("div", {
        class: "v-field__overlay"
      }, null), y(oi, {
        name: "v-field",
        active: !!e.loading,
        color: e.error ? "error" : typeof e.loading == "string" ? e.loading : e.color
      }, {
        default: r.loader
      }), W && S("div", {
        key: "prepend",
        class: "v-field__prepend-inner"
      }, [r["prepend-inner"] ? r["prepend-inner"](P.value) : e.prependInnerIcon && y(d, {
        key: "prepend-icon",
        name: "prependInner",
        color: V.value
      }, null)]), S("div", {
        class: "v-field__field",
        "data-no-activator": ""
      }, [["filled", "solo", "solo-inverted", "solo-filled"].includes(e.variant) && h.value && y(Sl, Y({
        key: "floating-label",
        ref: b,
        class: [L.value],
        floating: !0
      }, O.value, {
        style: E.value
      }), {
        default: () => [H()]
      }), m.value && y(Sl, Y({
        key: "label",
        ref: C,
        id: e.labelId
      }, F.value), {
        default: () => [H()]
      }), r.default?.({
        ...P.value,
        props: {
          id: _.value,
          class: "v-field__input",
          "aria-describedby": I.value
        },
        focus: u,
        blur: c
      }) ?? S("div", {
        id: _.value,
        class: "v-field__input",
        "aria-describedby": I.value
      }, null)]), R && y(Dc, {
        key: "clear"
      }, {
        default: () => [at(S("div", {
          class: "v-field__clearable",
          onMousedown: ($) => {
            $.preventDefault(), $.stopPropagation();
          }
        }, [y(Ae, {
          defaults: {
            VIcon: {
              icon: e.clearIcon
            }
          }
        }, {
          default: () => [r.clear ? r.clear({
            ...P.value,
            props: {
              onFocus: u,
              onBlur: c,
              onClick: e["onClick:clear"],
              tabindex: -1
            }
          }) : y(d, {
            name: "clear",
            onFocus: u,
            onBlur: c,
            tabindex: -1
          }, null)]
        })]), [[Wn, e.dirty]])]
      }), j && S("div", {
        key: "append",
        class: "v-field__append-inner"
      }, [r["append-inner"] ? r["append-inner"](P.value) : e.appendInnerIcon && y(d, {
        key: "append-icon",
        name: "appendInner",
        color: V.value
      }, null)]), S("div", {
        class: J(["v-field__outline", L.value]),
        style: le(E.value)
      }, [N && S(fe, null, [S("div", {
        class: "v-field__outline__start"
      }, null), h.value && S("div", {
        class: "v-field__outline__notch"
      }, [y(Sl, Y({
        ref: b,
        floating: !0
      }, O.value), {
        default: () => [H()]
      })]), S("div", {
        class: "v-field__outline__end"
      }, null)]), x.value && h.value && y(Sl, Y({
        ref: b,
        floating: !0
      }, O.value), {
        default: () => [H()]
      })])]);
    }), {
      controlRef: p,
      fieldIconColor: V
    };
  }
}), Cy = U({
  autocomplete: String
}, "autocomplete");
function Xc(e) {
  const t = Rt(), n = ae(0), a = D(() => e.autocomplete === "suppress"), r = D(() => {
    if (e.name)
      return a.value ? `${e.name}-${t}-${n.value}` : e.name;
  }), l = D(() => a.value ? "off" : e.autocomplete);
  return {
    isSuppressing: a,
    fieldAutocomplete: l,
    fieldName: r,
    update: () => n.value = (/* @__PURE__ */ new Date()).getTime()
  };
}
function _y(e) {
  function t(n, a) {
    if (!e.autofocus || !n) return;
    const r = a[0].target;
    (r.matches("input,textarea") ? r : r.querySelector("input,textarea"))?.focus();
  }
  return {
    onIntersect: t
  };
}
const hA = ["color", "file", "time", "date", "datetime-local", "week", "month"], mi = U({
  autofocus: Boolean,
  counter: [Boolean, Number, String],
  counterValue: [Number, Function],
  prefix: String,
  placeholder: String,
  persistentPlaceholder: Boolean,
  persistentCounter: Boolean,
  suffix: String,
  role: String,
  type: {
    type: String,
    default: "text"
  },
  modelModifiers: Object,
  ...Cy(),
  ...Pe(ha(), ["direction"]),
  ...vi()
}, "VTextField"), Kn = K()({
  name: "VTextField",
  directives: {
    vIntersect: Bn
  },
  inheritAttrs: !1,
  props: mi(),
  emits: {
    "click:control": (e) => !0,
    "mousedown:control": (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: a,
      slots: r
    } = t;
    const l = he(e, "modelValue", void 0, (x) => Object.is(x, -0) ? "-0" : x), {
      isFocused: i,
      focus: o,
      blur: s
    } = ma(e), {
      onIntersect: u
    } = _y(e), c = T(() => typeof e.counterValue == "function" ? e.counterValue(l.value) : typeof e.counterValue == "number" ? e.counterValue : (l.value ?? "").toString().length), d = T(() => {
      if (n.maxlength) return n.maxlength;
      if (!(!e.counter || typeof e.counter != "number" && typeof e.counter != "string"))
        return e.counter;
    }), f = T(() => ["plain", "underlined"].includes(e.variant)), v = G(), g = G(), m = G(), h = Xc(e), w = T(() => hA.includes(e.type) || e.persistentPlaceholder || i.value || e.active);
    function _() {
      h.isSuppressing.value && h.update(), i.value || o(), Se(() => {
        m.value !== document.activeElement && m.value?.focus();
      });
    }
    function I(x) {
      a("mousedown:control", x), x.target !== m.value && (_(), x.preventDefault());
    }
    function C(x) {
      a("click:control", x);
    }
    function b(x, k) {
      x.stopPropagation(), _(), Se(() => {
        k(), ai(e["onClick:clear"], x);
      });
    }
    function p(x) {
      const k = x.target;
      if (!(e.modelModifiers?.trim && ["text", "search", "password", "tel", "url"].includes(e.type))) {
        l.value = k.value;
        return;
      }
      const V = k.value, A = k.selectionStart, M = k.selectionEnd;
      l.value = V, Se(() => {
        let L = 0;
        V.trimStart().length === k.value.length && (L = V.length - k.value.length), A != null && (k.selectionStart = A - L), M != null && (k.selectionEnd = M - L);
      });
    }
    return X(() => {
      const x = !!(r.counter || e.counter !== !1 && e.counter != null), k = !!(x || r.details), [V, A] = Jn(n), {
        modelValue: M,
        ...L
      } = Gt.filterProps(e), E = Ea.filterProps(e);
      return y(Gt, Y({
        ref: v,
        modelValue: l.value,
        "onUpdate:modelValue": (P) => l.value = P,
        class: ["v-text-field", {
          "v-text-field--prefixed": e.prefix,
          "v-text-field--suffixed": e.suffix,
          "v-input--plain-underlined": f.value
        }, e.class],
        style: e.style
      }, V, L, {
        centerAffix: !f.value,
        focused: i.value
      }), {
        ...r,
        default: (P) => {
          let {
            id: O,
            isDisabled: F,
            isDirty: B,
            isReadonly: N,
            isValid: W,
            hasDetails: R,
            reset: j
          } = P;
          return y(Ea, Y({
            ref: g,
            onMousedown: I,
            onClick: C,
            "onClick:clear": (H) => b(H, j),
            role: e.role
          }, Pe(E, ["onClick:clear"]), {
            id: O.value,
            labelId: `${O.value}-label`,
            active: w.value || B.value,
            dirty: B.value || e.dirty,
            disabled: F.value,
            focused: i.value,
            details: R.value,
            error: W.value === !1
          }), {
            ...r,
            default: (H) => {
              let {
                props: {
                  class: $,
                  ...z
                },
                controlRef: te
              } = H;
              const me = S("input", Y({
                ref: (Q) => m.value = te.value = Q,
                value: l.value,
                onInput: p,
                autofocus: e.autofocus,
                readonly: N.value,
                disabled: F.value,
                name: h.fieldName.value,
                autocomplete: h.fieldAutocomplete.value,
                placeholder: e.placeholder,
                size: 1,
                role: e.role,
                type: e.type,
                onFocus: o,
                onBlur: s,
                "aria-labelledby": `${O.value}-label`
              }, z, A), null);
              return S(fe, null, [e.prefix && S("span", {
                class: "v-text-field__prefix"
              }, [S("span", {
                class: "v-text-field__prefix__text"
              }, [e.prefix])]), at(r.default ? S("div", {
                class: J($),
                "data-no-activator": ""
              }, [r.default({
                id: O
              }), me]) : Kp(me, {
                class: $
              }), [[Bn, u, null, {
                once: !0
              }]]), e.suffix && S("span", {
                class: "v-text-field__suffix"
              }, [S("span", {
                class: "v-text-field__suffix__text"
              }, [e.suffix])])]);
            }
          });
        },
        details: k ? (P) => S(fe, null, [r.details?.(P), x && S(fe, null, [S("span", null, null), y(Go, {
          active: e.persistentCounter || i.value,
          value: c.value,
          max: d.value,
          disabled: e.disabled
        }, r.counter)])]) : void 0
      });
    }), Mt({}, v, g, m);
  }
}), gA = U({
  renderless: Boolean,
  ...ve()
}, "VVirtualScrollItem"), Ty = K()({
  name: "VVirtualScrollItem",
  inheritAttrs: !1,
  props: gA(),
  emits: {
    "update:height": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: a,
      slots: r
    } = t;
    const {
      resizeRef: l,
      contentRect: i
    } = Vn(void 0, "border");
    ne(() => i.value?.height, (o) => {
      o != null && a("update:height", o);
    }), X(() => e.renderless ? S(fe, null, [r.default?.({
      itemRef: l
    })]) : S("div", Y({
      ref: l,
      class: ["v-virtual-scroll__item", e.class],
      style: e.style
    }, n), [r.default?.()]));
  }
}), yA = -1, bA = 1, Ds = 100, Iy = U({
  itemHeight: {
    type: [Number, String],
    default: null
  },
  itemKey: {
    type: [String, Array, Function],
    default: null
  },
  height: [Number, String]
}, "virtual");
function Ay(e, t) {
  const n = Cn(), a = ae(0);
  ft(() => {
    a.value = parseFloat(e.itemHeight || 0);
  });
  const r = ae(0), l = ae(Math.ceil(
    // Assume 16px items filling the entire screen height if
    // not provided. This is probably incorrect but it minimises
    // the chance of ending up with empty space at the bottom.
    // The default value is set here to avoid poisoning getSize()
    (parseInt(e.height) || n.height.value) / (a.value || 16)
  ) || 1), i = ae(0), o = ae(0), s = G(), u = G();
  let c = 0;
  const {
    resizeRef: d,
    contentRect: f
  } = Vn();
  ft(() => {
    d.value = s.value;
  });
  const v = T(() => s.value === document.documentElement ? n.height.value : f.value?.height || parseInt(e.height) || 0), g = T(() => !!(s.value && u.value && v.value && a.value));
  let m = Array.from({
    length: t.value.length
  }), h = Array.from({
    length: t.value.length
  });
  const w = ae(0);
  let _ = -1;
  function I(R) {
    return m[R] || a.value;
  }
  const C = rg(() => {
    const R = performance.now();
    h[0] = 0;
    const j = t.value.length;
    for (let H = 1; H <= j; H++)
      h[H] = (h[H - 1] || 0) + I(H - 1);
    w.value = Math.max(w.value, performance.now() - R);
  }, w), b = ne(g, (R) => {
    R && (b(), c = u.value.offsetTop, C.immediate(), F(), ~_ && Se(() => {
      wt && window.requestAnimationFrame(() => {
        N(_), _ = -1;
      });
    }));
  });
  It(() => {
    C.clear();
  });
  function p(R, j) {
    const H = m[R], $ = a.value;
    a.value = $ ? Math.min(a.value, j) : j, (H !== j || $ !== a.value) && (m[R] = j, C());
  }
  function x(R) {
    R = Xe(R, 0, t.value.length);
    const j = Math.floor(R), H = R % 1, $ = j + 1, z = h[j] || 0, te = h[$] || z;
    return z + (te - z) * H;
  }
  function k(R) {
    return pA(h, R);
  }
  let V = 0, A = 0, M = 0;
  ne(v, (R, j) => {
    F(), R < j && requestAnimationFrame(() => {
      A = 0, F();
    });
  });
  let L = -1;
  function E() {
    if (!s.value || !u.value) return;
    const R = s.value.scrollTop, j = performance.now();
    j - M > 500 ? (A = Math.sign(R - V), c = u.value.offsetTop) : A = R - V, V = R, M = j, window.clearTimeout(L), L = window.setTimeout(P, 500), F();
  }
  function P() {
    !s.value || !u.value || (A = 0, M = 0, window.clearTimeout(L), F());
  }
  let O = -1;
  function F() {
    cancelAnimationFrame(O), O = requestAnimationFrame(B);
  }
  function B() {
    if (!s.value || !v.value || !a.value) return;
    const R = V - c, j = Math.sign(A), H = Math.max(0, R - Ds), $ = Xe(k(H), 0, t.value.length), z = R + v.value + Ds, te = Xe(k(z) + 1, $ + 1, t.value.length);
    if (
      // Only update the side we're scrolling towards,
      // the other side will be updated incidentally
      (j !== yA || $ < r.value) && (j !== bA || te > l.value)
    ) {
      const me = x(r.value) - x($), Q = x(te) - x(l.value);
      Math.max(me, Q) > Ds ? (r.value = $, l.value = te) : ($ <= 0 && (r.value = $), te >= t.value.length && (l.value = te));
    }
    i.value = x(r.value), o.value = x(t.value.length) - x(l.value);
  }
  function N(R) {
    const j = x(R);
    !s.value || R && !j ? _ = R : s.value.scrollTop = j;
  }
  const W = T(() => t.value.slice(r.value, l.value).map((R, j) => {
    const H = j + r.value;
    return {
      raw: R,
      index: H,
      key: pt(R, e.itemKey, H)
    };
  }));
  return ne(t, () => {
    m = Array.from({
      length: t.value.length
    }), h = Array.from({
      length: t.value.length
    }), C.immediate(), F();
  }, {
    deep: 1
  }), {
    calculateVisibleItems: F,
    containerRef: s,
    markerRef: u,
    computedItems: W,
    paddingTop: i,
    paddingBottom: o,
    scrollToIndex: N,
    handleScroll: E,
    handleScrollend: P,
    handleItemResize: p
  };
}
function pA(e, t) {
  let n = e.length - 1, a = 0, r = 0, l = null, i = -1;
  if (e[n] < t)
    return n;
  for (; a <= n; )
    if (r = a + n >> 1, l = e[r], l > t)
      n = r - 1;
    else if (l < t)
      i = r, a = r + 1;
    else return l === t ? r : a;
  return i;
}
const wA = U({
  items: {
    type: Array,
    default: () => []
  },
  renderless: Boolean,
  ...Iy(),
  ...ve(),
  ...St()
}, "VVirtualScroll"), qo = K()({
  name: "VVirtualScroll",
  props: wA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = kt("VVirtualScroll"), {
      dimensionStyles: r
    } = xt(e), {
      calculateVisibleItems: l,
      containerRef: i,
      markerRef: o,
      handleScroll: s,
      handleScrollend: u,
      handleItemResize: c,
      scrollToIndex: d,
      paddingTop: f,
      paddingBottom: v,
      computedItems: g
    } = Ay(e, D(() => e.items));
    return Wt(() => e.renderless, () => {
      function m() {
        const w = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1) ? "addEventListener" : "removeEventListener";
        i.value === document.documentElement ? (document[w]("scroll", s, {
          passive: !0
        }), document[w]("scrollend", u)) : (i.value?.[w]("scroll", s, {
          passive: !0
        }), i.value?.[w]("scrollend", u));
      }
      bt(() => {
        i.value = No(a.vnode.el, !0), m(!0);
      }), It(m);
    }), X(() => {
      const m = g.value.map((h) => y(Ty, {
        key: h.key,
        renderless: e.renderless,
        "onUpdate:height": (w) => c(h.index, w)
      }, {
        default: (w) => n.default?.({
          item: h.raw,
          index: h.index,
          ...w
        })
      }));
      return e.renderless ? S(fe, null, [S("div", {
        ref: o,
        class: "v-virtual-scroll__spacer",
        style: {
          paddingTop: re(f.value)
        }
      }, null), m, S("div", {
        class: "v-virtual-scroll__spacer",
        style: {
          paddingBottom: re(v.value)
        }
      }, null)]) : S("div", {
        ref: i,
        class: J(["v-virtual-scroll", e.class]),
        onScrollPassive: s,
        onScrollend: u,
        style: le([r.value, e.style])
      }, [S("div", {
        ref: o,
        class: "v-virtual-scroll__container",
        style: {
          paddingTop: re(f.value),
          paddingBottom: re(v.value)
        }
      }, [m])]);
    }), {
      calculateVisibleItems: l,
      scrollToIndex: d
    };
  }
});
function Qc(e, t) {
  const n = ae(!1);
  let a;
  function r(o) {
    cancelAnimationFrame(a), n.value = !0, a = requestAnimationFrame(() => {
      a = requestAnimationFrame(() => {
        n.value = !1;
      });
    });
  }
  async function l() {
    await new Promise((o) => requestAnimationFrame(o)), await new Promise((o) => requestAnimationFrame(o)), await new Promise((o) => requestAnimationFrame(o)), await new Promise((o) => {
      if (n.value) {
        const s = ne(n, () => {
          s(), o();
        });
      } else o();
    });
  }
  async function i(o) {
    if (o.key === "Tab" && t.value?.focus(), !["PageDown", "PageUp", "Home", "End"].includes(o.key)) return;
    const s = e.value?.$el;
    if (!s) return;
    (o.key === "Home" || o.key === "End") && s.scrollTo({
      top: o.key === "Home" ? 0 : s.scrollHeight,
      behavior: "smooth"
    }), await l();
    const u = s.querySelectorAll(":scope > :not(.v-virtual-scroll__spacer)");
    if (o.key === "PageDown" || o.key === "Home") {
      const c = s.getBoundingClientRect().top;
      for (const d of u)
        if (d.getBoundingClientRect().top >= c) {
          d.focus();
          break;
        }
    } else {
      const c = s.getBoundingClientRect().bottom;
      for (const d of [...u].reverse())
        if (d.getBoundingClientRect().bottom <= c) {
          d.focus();
          break;
        }
    }
  }
  return {
    onScrollPassive: r,
    onKeydown: i
  };
}
function ed(e) {
  let {
    groups: t,
    onLeave: n
  } = e;
  function a(o) {
    return o.type === "list" ? o.contentRef.value?.$el : o.contentRef.value;
  }
  function r(o) {
    const s = a(o);
    return s ? xa(s) : [];
  }
  function l(o) {
    const s = o.target, u = o.shiftKey ? "backward" : "forward", c = t.map(r), d = t.map((v) => v.type === "list" ? v.contentRef.value?.$el : v.contentRef.value).findIndex((v) => v?.contains(s)), f = i(c, d, u, s);
    if (f === null) {
      const v = t[d], g = c[d];
      (v.type === "list" || (u === "forward" ? g.at(-1) === o.target : g.at(0) === o.target)) && n();
    } else {
      o.preventDefault(), o.stopImmediatePropagation();
      const v = t[f];
      if (v.type === "list" && nt(v.displayItemsCount) > 0)
        v.contentRef.value?.focus(0);
      else {
        const g = u === "forward";
        c[f].at(g ? 0 : -1).focus();
      }
    }
  }
  function i(o, s, u, c) {
    const d = t[s], f = o[s];
    if (d.type !== "list" && !(u === "forward" ? f.at(-1) === c : f.at(0) === c))
      return null;
    const v = u === "forward" ? 1 : -1;
    for (let g = s + v; g >= 0 && g < t.length; g += v) {
      const m = t[g];
      if (o[g].length > 0 || m.type === "list" && nt(m.displayItemsCount) > 0)
        return g;
    }
    return null;
  }
  return {
    onTabKeydown: l
  };
}
const kA = (e, t, n) => {
  if (e == null || t == null) return -1;
  if (!t.length) return 0;
  e = e.toString().toLocaleLowerCase(), t = t.toString().toLocaleLowerCase();
  const a = [];
  let r = e.indexOf(t);
  for (; ~r; )
    a.push([r, r + t.length]), r = e.indexOf(t, r + t.length);
  return a.length ? a : -1;
};
function Ls(e, t) {
  if (!(e == null || typeof e == "boolean" || e === -1))
    return typeof e == "number" ? [[e, e + t.length]] : Array.isArray(e[0]) ? e : [e];
}
const yr = U({
  customFilter: Function,
  customKeyFilter: Object,
  filterKeys: [Array, String],
  filterMode: {
    type: String,
    default: "intersection"
  },
  noFilter: Boolean
}, "filter");
function SA(e, t, n) {
  const a = [], r = n?.default ?? kA, l = n?.filterKeys ? rt(n.filterKeys) : !1, i = Object.keys(n?.customKeyFilter ?? {}).length;
  if (!e?.length) return a;
  let o = [];
  e: for (let s = 0; s < e.length; s++) {
    const [u, c = u] = rt(e[s]), d = {}, f = {};
    let v = -1;
    if ((t || i > 0) && !n?.noFilter) {
      let g = !1;
      if (typeof u == "object") {
        if (u.type === "divider" || u.type === "subheader") {
          (o.at(-1)?.type !== "divider" || u.type !== "subheader") && (o = []), o.push({
            index: s,
            matches: {},
            type: u.type
          });
          continue;
        }
        const w = l || Object.keys(c);
        g = w.length === i;
        for (const _ of w) {
          const I = pt(c, _), C = n?.customKeyFilter?.[_];
          if (v = C ? C(I, t, u) : r(I, t, u), v !== -1 && v !== !1)
            C ? d[_] = Ls(v, t) : f[_] = Ls(v, t);
          else if (n?.filterMode === "every")
            continue e;
        }
      } else
        v = r(u, t, u), v !== -1 && v !== !1 && (f.title = Ls(v, t));
      const m = Object.keys(f).length, h = Object.keys(d).length;
      if (!m && !h || n?.filterMode === "union" && h !== i && !m || n?.filterMode === "intersection" && (h !== i || !m && i > 0 && !g)) continue;
    }
    o.length && (a.push(...o), o = []), a.push({
      index: s,
      matches: {
        ...f,
        ...d
      }
    });
  }
  return a;
}
function br(e, t, n, a) {
  const r = ae([]), l = ae(/* @__PURE__ */ new Map()), i = T(() => a?.transform ? Z(t).map((s) => [s, a.transform(s)]) : Z(t));
  ft(() => {
    const s = typeof n == "function" ? n() : Z(n), u = typeof s != "string" && typeof s != "number" ? "" : String(s), c = SA(i.value, u, {
      customKeyFilter: {
        ...e.customKeyFilter,
        ...Z(a?.customKeyFilter)
      },
      default: e.customFilter,
      filterKeys: e.filterKeys,
      filterMode: e.filterMode,
      noFilter: e.noFilter
    }), d = Z(t), f = [], v = /* @__PURE__ */ new Map();
    c.forEach((g) => {
      let {
        index: m,
        matches: h
      } = g;
      const w = d[m];
      f.push(w), v.set(w.value, h);
    }), r.value = f, l.value = v;
  });
  function o(s) {
    return l.value.get(s.value);
  }
  return {
    filteredItems: r,
    filteredMatches: l,
    getMatches: o
  };
}
function td(e, t, n) {
  return n == null || !n.length ? t : n.map((a, r) => {
    const l = r === 0 ? 0 : n[r - 1][1], i = [S("span", {
      class: J(`${e}__unmask`)
    }, [t.slice(l, a[0])]), S("span", {
      class: J(`${e}__mask`)
    }, [t.slice(a[0], a[1])])];
    return r === n.length - 1 && i.push(S("span", {
      class: J(`${e}__unmask`)
    }, [t.slice(a[1])])), S(fe, null, [i]);
  });
}
const xA = U({
  closeText: {
    type: String,
    default: "$vuetify.close"
  },
  openText: {
    type: String,
    default: "$vuetify.open"
  }
}, "autocomplete");
function nd(e, t) {
  const n = Rt(), a = T(() => `menu-${n}`), r = D(() => nt(t)), l = D(() => a.value);
  return {
    menuId: a,
    ariaExpanded: r,
    ariaControls: l
  };
}
const ad = U({
  chips: Boolean,
  closableChips: Boolean,
  eager: Boolean,
  hideNoData: Boolean,
  hideSelected: Boolean,
  listProps: {
    type: Object
  },
  menu: Boolean,
  menuIcon: {
    type: be,
    default: "$dropdown"
  },
  menuProps: {
    type: Object
  },
  multiple: Boolean,
  noDataText: {
    type: String,
    default: "$vuetify.noDataText"
  },
  openOnClear: Boolean,
  itemColor: String,
  noAutoScroll: Boolean,
  ...xA(),
  ...uy({
    itemChildren: !1
  })
}, "Select"), CA = U({
  search: String,
  ...yr({
    filterKeys: ["title"]
  }),
  ...ad(),
  ...Pe(mi({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty"]),
  ...da({
    transition: {
      component: Ro
    }
  })
}, "VSelect"), rd = K()({
  name: "VSelect",
  props: CA(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:menu": (e) => !0,
    "update:search": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      t: a
    } = Ke(), r = G(), l = G(), i = G(), o = G(), s = G(), {
      items: u,
      transformIn: c,
      transformOut: d
    } = zc(e), f = he(e, "search", ""), {
      filteredItems: v,
      getMatches: g
    } = br(e, u, () => f.value), m = he(e, "modelValue", [], (ue) => c(ue === null ? [null] : rt(ue)), (ue) => {
      const Te = d(ue);
      return e.multiple ? Te : Te[0] ?? null;
    }), h = T(() => typeof e.counterValue == "function" ? e.counterValue(m.value) : typeof e.counterValue == "number" ? e.counterValue : m.value.length), w = ul(e), _ = Xc(e), I = T(() => m.value.map((ue) => ue.value)), C = ae(!1), b = D(() => e.closableChips && !w.isReadonly.value && !w.isDisabled.value), {
      InputIcon: p
    } = ci(e);
    let x = "", k = 0, V;
    const A = T(() => {
      const ue = f.value ? v.value : u.value;
      return e.hideSelected ? ue.filter((Te) => !m.value.some((Ne) => (e.valueComparator || Lt)(Ne, Te))) : ue;
    }), M = T(() => e.hideNoData && !A.value.length || w.isReadonly.value || w.isDisabled.value), L = he(e, "menu"), E = T({
      get: () => L.value,
      set: (ue) => {
        L.value && !ue && l.value?.ΨopenChildren.size || ue && M.value || (L.value = ue);
      }
    }), {
      menuId: P,
      ariaExpanded: O,
      ariaControls: F
    } = nd(e, E), B = T(() => ({
      ...e.menuProps,
      activatorProps: {
        ...e.menuProps?.activatorProps || {},
        "aria-haspopup": "listbox"
        // Set aria-haspopup to 'listbox'
      }
    })), N = G(), W = Qc(N, r), {
      onTabKeydown: R
    } = ed({
      groups: [{
        type: "element",
        contentRef: i
      }, {
        type: "list",
        contentRef: N,
        displayItemsCount: () => A.value.length
      }, {
        type: "element",
        contentRef: o
      }],
      onLeave: () => {
        E.value = !1, r.value?.focus();
      }
    });
    function j(ue) {
      e.openOnClear && (E.value = !0);
    }
    function H() {
      M.value || (E.value = !E.value);
    }
    function $(ue) {
      ue.key === "Tab" && R(ue), N.value?.$el.contains(ue.target) && zr(ue) && z(ue);
    }
    function z(ue) {
      if (!ue.key || w.isReadonly.value) return;
      if (["Enter", " ", "ArrowDown", "ArrowUp", "Home", "End"].includes(ue.key) && ue.preventDefault(), ["Enter", "ArrowDown", " "].includes(ue.key) && (E.value = !0), ["Escape", "Tab"].includes(ue.key) && (E.value = !1), e.clearable && ue.key === "Backspace") {
        ue.preventDefault(), m.value = [], j();
        return;
      }
      ue.key === "Home" ? N.value?.focus("first") : ue.key === "End" && N.value?.focus("last");
      const Te = 1e3;
      if (!zr(ue)) return;
      const Ne = performance.now();
      Ne - V > Te && (x = "", k = 0), x += ue.key.toLowerCase(), V = Ne;
      const je = A.value;
      function xe() {
        let oe = Be();
        return oe || x.at(-1) === x.at(-2) && (x = x.slice(0, -1), k++, oe = Be(), oe) || (k = 0, oe = Be(), oe) ? oe : (x = ue.key.toLowerCase(), Be());
      }
      function Be() {
        for (let oe = k; oe < je.length; oe++) {
          const $e = je[oe];
          if ($e.title.toLowerCase().startsWith(x))
            return [$e, oe];
        }
      }
      const ct = xe();
      if (!ct) return;
      const [Yt, Ue] = ct;
      k = Ue, N.value?.focus(Ue), e.multiple || (m.value = [Yt]);
    }
    function te(ue) {
      let Te = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!ue.props.disabled)
        if (e.multiple) {
          const Ne = m.value.findIndex((xe) => (e.valueComparator || Lt)(xe.value, ue.value)), je = Te ?? !~Ne;
          if (~Ne) {
            const xe = je ? [...m.value, ue] : [...m.value];
            xe.splice(Ne, 1), m.value = xe;
          } else je && (m.value = [...m.value, ue]);
        } else {
          const Ne = Te !== !1;
          m.value = Ne ? [ue] : [], Se(() => {
            E.value = !1;
          });
        }
    }
    function me(ue) {
      const Te = ue.target;
      r.value?.$el.contains(Te) || (E.value = !1);
    }
    function Q() {
      e.eager && s.value?.calculateVisibleItems();
    }
    function ie() {
      f.value = "", C.value && r.value?.focus();
    }
    function ke(ue) {
      C.value = !0;
    }
    function ye(ue) {
      if (ue == null) m.value = [];
      else if (Hr(r.value, ":autofill") || Hr(r.value, ":-webkit-autofill")) {
        const Te = u.value.find((Ne) => Ne.title === ue);
        Te && te(Te);
      } else r.value && (r.value.value = "");
    }
    return ne(E, () => {
      if (!e.hideSelected && E.value && m.value.length) {
        const ue = A.value.findIndex((Te) => m.value.some((Ne) => (e.valueComparator || Lt)(Ne.value, Te.value)));
        wt && !e.noAutoScroll && window.requestAnimationFrame(() => {
          ue >= 0 && s.value?.scrollToIndex(ue);
        });
      }
    }), ne(u, (ue, Te) => {
      E.value || C.value && e.hideNoData && !Te.length && ue.length && (E.value = !0);
    }), X(() => {
      const ue = !!(e.chips || n.chip), Te = !!(!e.hideNoData || A.value.length || n["prepend-item"] || n["append-item"] || n["no-data"]), Ne = m.value.length > 0, je = Kn.filterProps(e), xe = Ne || !C.value && e.label && !e.persistentPlaceholder ? void 0 : e.placeholder, Be = {
        search: f,
        filteredItems: v.value
      };
      return y(Kn, Y({
        ref: r
      }, je, {
        modelValue: m.value.map((ct) => ct.props.title).join(", "),
        name: void 0,
        "onUpdate:modelValue": ye,
        focused: C.value,
        "onUpdate:focused": (ct) => C.value = ct,
        validationValue: m.externalValue,
        counterValue: h.value,
        dirty: Ne,
        class: ["v-select", {
          "v-select--active-menu": E.value,
          "v-select--chips": !!e.chips,
          [`v-select--${e.multiple ? "multiple" : "single"}`]: !0,
          "v-select--selected": m.value.length,
          "v-select--selection-slot": !!n.selection
        }, e.class],
        style: e.style,
        inputmode: "none",
        placeholder: xe,
        "onClick:clear": j,
        "onMousedown:control": H,
        onBlur: me,
        onKeydown: z,
        "aria-expanded": O.value,
        "aria-controls": F.value
      }), {
        ...n,
        default: (ct) => {
          let {
            id: Yt
          } = ct;
          return S(fe, null, [S("select", {
            hidden: !0,
            multiple: e.multiple,
            name: _.fieldName.value
          }, [u.value.map((Ue) => S("option", {
            key: Ue.value,
            value: Ue.value,
            selected: I.value.includes(Ue.value)
          }, null))]), y(qr, Y({
            id: P.value,
            ref: l,
            modelValue: E.value,
            "onUpdate:modelValue": (Ue) => E.value = Ue,
            activator: "parent",
            contentClass: "v-select__content",
            disabled: M.value,
            eager: e.eager,
            maxHeight: 310,
            openOnClick: !1,
            closeOnContentClick: !1,
            transition: e.transition,
            onAfterEnter: Q,
            onAfterLeave: ie
          }, B.value), {
            default: () => [y(Va, {
              onFocusin: ke,
              onKeydown: $
            }, {
              default: () => [n["menu-header"] && S("header", {
                ref: i
              }, [n["menu-header"](Be)]), Te && y(Gr, Y({
                key: "select-list",
                ref: N,
                selected: I.value,
                selectStrategy: e.multiple ? "independent" : "single-independent",
                tabindex: "-1",
                selectable: !!A.value.length,
                "aria-live": "polite",
                "aria-labelledby": `${Yt.value}-label`,
                "aria-multiselectable": e.multiple,
                color: e.itemColor ?? e.color
              }, W, e.listProps), {
                default: () => [n["prepend-item"]?.(), !A.value.length && !e.hideNoData && (n["no-data"]?.() ?? y(En, {
                  key: "no-data",
                  title: a(e.noDataText)
                }, null)), y(qo, {
                  ref: s,
                  renderless: !0,
                  items: A.value,
                  itemKey: "value"
                }, {
                  default: (Ue) => {
                    let {
                      item: oe,
                      index: $e,
                      itemRef: ht
                    } = Ue;
                    const se = h_(oe.props), Ce = Y(oe.props, {
                      ref: ht,
                      key: oe.value,
                      onClick: () => te(oe, null),
                      "aria-posinset": $e + 1,
                      "aria-setsize": A.value.length
                    });
                    return oe.type === "divider" ? n.divider?.({
                      props: oe.raw,
                      index: $e
                    }) ?? y(pn, Y(oe.props, {
                      key: `divider-${$e}`
                    }), null) : oe.type === "subheader" ? n.subheader?.({
                      props: oe.raw,
                      index: $e
                    }) ?? y(cl, Y(oe.props, {
                      key: `subheader-${$e}`
                    }), null) : n.item?.({
                      item: oe,
                      index: $e,
                      props: Ce
                    }) ?? y(En, Y(Ce, {
                      role: "option"
                    }), {
                      prepend: (He) => {
                        let {
                          isSelected: Ee
                        } = He;
                        return S(fe, null, [e.multiple && !e.hideSelected ? y(Un, {
                          key: oe.value,
                          modelValue: Ee,
                          ripple: !1,
                          tabindex: "-1",
                          "aria-hidden": !0,
                          onClick: (Fe) => Fe.preventDefault()
                        }, null) : void 0, se.prependAvatar && y(kn, {
                          image: se.prependAvatar
                        }, null), se.prependIcon && y(ze, {
                          icon: se.prependIcon
                        }, null)]);
                      },
                      title: () => f.value ? td("v-select", oe.title, g(oe)?.title) : oe.title
                    });
                  }
                }), n["append-item"]?.()]
              }), n["menu-footer"] && S("footer", {
                ref: o
              }, [n["menu-footer"](Be)])]
            })]
          }), m.value.map((Ue, oe) => {
            function $e(He) {
              He.stopPropagation(), He.preventDefault(), te(Ue, !1);
            }
            const ht = Y(ua.filterProps(Ue.props), {
              "onClick:close": $e,
              onKeydown(He) {
                He.key !== "Enter" && He.key !== " " || (He.preventDefault(), He.stopPropagation(), $e(He));
              },
              onMousedown(He) {
                He.preventDefault(), He.stopPropagation();
              },
              modelValue: !0,
              "onUpdate:modelValue": void 0
            }), se = ue ? !!n.chip : !!n.selection, Ce = se ? Lo(ue ? n.chip({
              item: Ue,
              index: oe,
              props: ht
            }) : n.selection({
              item: Ue,
              index: oe
            })) : void 0;
            if (!(se && !Ce))
              return S("div", {
                key: Ue.value,
                class: "v-select__selection"
              }, [ue ? n.chip ? y(Ae, {
                key: "chip-defaults",
                defaults: {
                  VChip: {
                    closable: b.value,
                    size: "small",
                    text: Ue.title
                  }
                }
              }, {
                default: () => [Ce]
              }) : y(ua, Y({
                key: "chip",
                closable: b.value,
                size: "small",
                text: Ue.title,
                disabled: Ue.props.disabled
              }, ht), null) : Ce ?? S("span", {
                class: "v-select__selection-text"
              }, [Ue.title, e.multiple && oe < m.value.length - 1 && S("span", {
                class: "v-select__selection-comma"
              }, [we(",")])])]);
          })]);
        },
        "append-inner": function() {
          for (var ct = arguments.length, Yt = new Array(ct), Ue = 0; Ue < ct; Ue++)
            Yt[Ue] = arguments[Ue];
          return S(fe, null, [n["append-inner"]?.(...Yt), e.menuIcon ? y(ze, {
            class: "v-select__menu-icon",
            color: r.value?.fieldIconColor,
            icon: e.menuIcon,
            "aria-hidden": !0
          }, null) : void 0, e.appendInnerIcon && y(p, {
            key: "append-icon",
            name: "appendInner",
            color: Yt[0].iconColor.value
          }, null)]);
        }
      });
    }), Mt({
      isFocused: C,
      menu: E,
      search: f,
      filteredItems: v,
      select: te
    }, r);
  }
}), _A = U({
  autoSelectFirst: {
    type: [Boolean, String]
  },
  clearOnSelect: Boolean,
  search: String,
  ...yr({
    filterKeys: ["title"]
  }),
  ...ad(),
  ...Pe(mi({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty"])
}, "VAutocomplete"), TA = K()({
  name: "VAutocomplete",
  props: _A(),
  emits: {
    "update:focused": (e) => !0,
    "update:search": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:menu": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      t: a
    } = Ke(), r = G(), l = ae(!1), i = ae(!0), o = ae(!1), s = G(), u = G(), c = ae(-1), d = ae(null), {
      items: f,
      transformIn: v,
      transformOut: g
    } = zc(e), {
      textColorClasses: m,
      textColorStyles: h
    } = Nt(() => r.value?.color), {
      InputIcon: w
    } = ci(e), _ = he(e, "search", ""), I = he(e, "modelValue", [], (oe) => v(oe === null ? [null] : rt(oe)), (oe) => {
      const $e = g(oe);
      return e.multiple ? $e : $e[0] ?? null;
    }), C = T(() => typeof e.counterValue == "function" ? e.counterValue(I.value) : typeof e.counterValue == "number" ? e.counterValue : I.value.length), b = ul(e), {
      filteredItems: p,
      getMatches: x
    } = br(e, f, () => d.value ?? (i.value ? "" : _.value)), k = T(() => e.hideSelected && d.value === null ? p.value.filter((oe) => !I.value.some(($e) => $e.value === oe.value)) : p.value), V = D(() => e.closableChips && !b.isReadonly.value && !b.isDisabled.value), A = T(() => !!(e.chips || n.chip)), M = T(() => A.value || !!n.selection), L = T(() => I.value.map((oe) => oe.props.value)), E = T(() => k.value.find((oe) => oe.type === "item" && !oe.props.disabled)), P = T(() => (e.autoSelectFirst === !0 || e.autoSelectFirst === "exact" && _.value === E.value?.title) && k.value.length > 0 && !i.value && !o.value), O = T(() => e.hideNoData && !k.value.length || b.isReadonly.value || b.isDisabled.value), F = he(e, "menu"), B = T({
      get: () => F.value,
      set: (oe) => {
        F.value && !oe && s.value?.ΨopenChildren.size || oe && O.value || (F.value = oe);
      }
    }), {
      menuId: N,
      ariaExpanded: W,
      ariaControls: R
    } = nd(e, B), j = G(), H = G(), $ = G(), z = Qc(j, r), {
      onTabKeydown: te
    } = ed({
      groups: [{
        type: "element",
        contentRef: H
      }, {
        type: "list",
        contentRef: j,
        displayItemsCount: () => k.value.length
      }, {
        type: "element",
        contentRef: $
      }],
      onLeave: () => {
        B.value = !1, r.value?.focus();
      }
    });
    function me(oe) {
      e.openOnClear && (B.value = !0), _.value = "";
    }
    function Q() {
      O.value || (B.value = !0);
    }
    function ie(oe) {
      O.value || (l.value && (oe.preventDefault(), oe.stopPropagation()), B.value = !B.value);
    }
    function ke(oe) {
      oe.key === "Tab" && te(oe), j.value?.$el.contains(oe.target) && (zr(oe) || oe.key === "Backspace") && r.value?.focus();
    }
    function ye(oe) {
      if (b.isReadonly.value) return;
      const $e = r.value?.selectionStart, ht = I.value.length;
      if (["Enter", "ArrowDown", "ArrowUp"].includes(oe.key) && oe.preventDefault(), ["Enter", "ArrowDown"].includes(oe.key) && (B.value = !0), ["Escape"].includes(oe.key) && (B.value = !1), P.value && ["Enter", "Tab"].includes(oe.key) && E.value && !I.value.some((se) => {
        let {
          value: Ce
        } = se;
        return Ce === E.value.value;
      }) && Ue(E.value), oe.key === "ArrowDown" && P.value && j.value?.focus("next"), ["Backspace", "Delete"].includes(oe.key)) {
        if (!e.multiple && M.value && I.value.length > 0 && !_.value) return Ue(I.value[0], !1);
        if (~c.value) {
          oe.preventDefault();
          const se = c.value;
          Ue(I.value[c.value], !1), c.value = se >= ht - 1 ? ht - 2 : se;
        } else oe.key === "Backspace" && !_.value && (c.value = ht - 1);
        return;
      }
      if (e.multiple)
        if (oe.key === "ArrowLeft") {
          if (c.value < 0 && $e && $e > 0) return;
          const se = c.value > -1 ? c.value - 1 : ht - 1;
          if (I.value[se])
            c.value = se;
          else {
            const Ce = _.value?.length ?? null;
            c.value = -1, r.value?.setSelectionRange(Ce, Ce);
          }
        } else if (oe.key === "ArrowRight") {
          if (c.value < 0) return;
          const se = c.value + 1;
          I.value[se] ? c.value = se : (c.value = -1, r.value?.setSelectionRange(0, 0));
        } else ~c.value && zr(oe) && (c.value = -1);
    }
    function ue(oe) {
      if (Hr(r.value, ":autofill") || Hr(r.value, ":-webkit-autofill")) {
        const $e = f.value.find((ht) => ht.title === oe.target.value);
        $e && Ue($e);
      }
    }
    function Te() {
      e.eager && u.value?.calculateVisibleItems();
    }
    function Ne() {
      l.value && (i.value = !0, r.value?.focus()), d.value = null;
    }
    function je(oe) {
      l.value = !0, setTimeout(() => {
        o.value = !0;
      });
    }
    function xe(oe) {
      o.value = !1;
    }
    function Be(oe) {
      (oe == null || oe === "" && !e.multiple && !M.value) && (I.value = []);
    }
    function ct(oe) {
      s.value?.contentEl?.contains(oe.relatedTarget) && (l.value = !0);
    }
    const Yt = ae(!1);
    function Ue(oe) {
      let $e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!(!oe || oe.props.disabled))
        if (e.multiple) {
          const ht = I.value.findIndex((Ce) => (e.valueComparator || Lt)(Ce.value, oe.value)), se = $e ?? !~ht;
          if (~ht) {
            const Ce = se ? [...I.value, oe] : [...I.value];
            Ce.splice(ht, 1), I.value = Ce;
          } else se && (I.value = [...I.value, oe]);
          e.clearOnSelect && (_.value = "");
        } else {
          const ht = $e !== !1;
          I.value = ht ? [oe] : [], d.value = i.value ? "" : _.value ?? "", _.value = ht && !M.value ? oe.title : "", Se(() => {
            B.value = !1, i.value = !0;
          });
        }
    }
    return ne(l, (oe, $e) => {
      oe !== $e && (oe ? (Yt.value = !0, _.value = e.multiple || M.value ? "" : String(I.value.at(-1)?.props.title ?? ""), i.value = !0, Se(() => Yt.value = !1)) : (!e.multiple && _.value == null && (I.value = []), B.value = !1, !i.value && _.value && (d.value = _.value), _.value = "", c.value = -1));
    }), ne(_, (oe) => {
      !l.value || Yt.value || (oe && (B.value = !0), i.value = !oe);
    }), ne(B, (oe) => {
      if (!e.hideSelected && oe && I.value.length && i.value) {
        const $e = k.value.findIndex((ht) => I.value.some((se) => ht.value === se.value));
        wt && window.requestAnimationFrame(() => {
          $e >= 0 && u.value?.scrollToIndex($e);
        });
      }
      oe && (d.value = null);
    }), ne(f, (oe, $e) => {
      B.value || l.value && !$e.length && oe.length && (B.value = !0);
    }), X(() => {
      const oe = !!(!e.hideNoData || k.value.length || n["prepend-item"] || n["append-item"] || n["no-data"]), $e = I.value.length > 0, ht = Kn.filterProps(e), se = {
        search: _,
        filteredItems: p.value
      };
      return y(Kn, Y({
        ref: r
      }, ht, {
        modelValue: _.value,
        "onUpdate:modelValue": [(Ce) => _.value = Ce, Be],
        focused: l.value,
        "onUpdate:focused": (Ce) => l.value = Ce,
        validationValue: I.externalValue,
        counterValue: C.value,
        dirty: $e,
        onChange: ue,
        class: ["v-autocomplete", `v-autocomplete--${e.multiple ? "multiple" : "single"}`, {
          "v-autocomplete--active-menu": B.value,
          "v-autocomplete--chips": !!e.chips,
          "v-autocomplete--selection-slot": !!M.value,
          "v-autocomplete--selecting-index": c.value > -1
        }, e.class],
        style: e.style,
        readonly: b.isReadonly.value,
        placeholder: $e ? void 0 : e.placeholder,
        "onClick:clear": me,
        "onMousedown:control": Q,
        onKeydown: ye,
        onBlur: ct,
        "aria-expanded": W.value,
        "aria-controls": R.value
      }), {
        ...n,
        default: (Ce) => {
          let {
            id: He
          } = Ce;
          return S(fe, null, [y(qr, Y({
            id: N.value,
            ref: s,
            modelValue: B.value,
            "onUpdate:modelValue": (Ee) => B.value = Ee,
            activator: "parent",
            contentClass: "v-autocomplete__content",
            disabled: O.value,
            eager: e.eager,
            maxHeight: 310,
            openOnClick: !1,
            closeOnContentClick: !1,
            onAfterEnter: Te,
            onAfterLeave: Ne
          }, e.menuProps), {
            default: () => [y(Va, {
              onFocusin: je,
              onKeydown: ke
            }, {
              default: () => [n["menu-header"] && S("header", {
                ref: H
              }, [n["menu-header"](se)]), oe && y(Gr, Y({
                key: "autocomplete-list",
                ref: j,
                filterable: !0,
                selected: L.value,
                selectStrategy: e.multiple ? "independent" : "single-independent",
                onMousedown: (Ee) => Ee.preventDefault(),
                onFocusout: xe,
                tabindex: "-1",
                selectable: !!k.value.length,
                "aria-live": "polite",
                "aria-labelledby": `${He.value}-label`,
                "aria-multiselectable": e.multiple,
                color: e.itemColor ?? e.color
              }, z, e.listProps), {
                default: () => [n["prepend-item"]?.(), !k.value.length && !e.hideNoData && (n["no-data"]?.() ?? y(En, {
                  key: "no-data",
                  title: a(e.noDataText)
                }, null)), y(qo, {
                  ref: u,
                  renderless: !0,
                  items: k.value,
                  itemKey: "value"
                }, {
                  default: (Ee) => {
                    let {
                      item: Fe,
                      index: Ot,
                      itemRef: dt
                    } = Ee;
                    const Qe = Y(Fe.props, {
                      ref: dt,
                      key: Fe.value,
                      active: P.value && Fe === E.value ? !0 : void 0,
                      onClick: () => Ue(Fe, null),
                      "aria-posinset": Ot + 1,
                      "aria-setsize": k.value.length
                    });
                    return Fe.type === "divider" ? n.divider?.({
                      props: Fe.raw,
                      index: Ot
                    }) ?? y(pn, Y(Fe.props, {
                      key: `divider-${Ot}`
                    }), null) : Fe.type === "subheader" ? n.subheader?.({
                      props: Fe.raw,
                      index: Ot
                    }) ?? y(cl, Y(Fe.props, {
                      key: `subheader-${Ot}`
                    }), null) : n.item?.({
                      item: Fe,
                      index: Ot,
                      props: Qe
                    }) ?? y(En, Y(Qe, {
                      role: "option"
                    }), {
                      prepend: (tn) => {
                        let {
                          isSelected: $t
                        } = tn;
                        return S(fe, null, [e.multiple && !e.hideSelected ? y(Un, {
                          key: Fe.value,
                          modelValue: $t,
                          ripple: !1,
                          tabindex: "-1",
                          "aria-hidden": !0,
                          onClick: (Fa) => Fa.preventDefault()
                        }, null) : void 0, Fe.props.prependAvatar && y(kn, {
                          image: Fe.props.prependAvatar
                        }, null), Fe.props.prependIcon && y(ze, {
                          icon: Fe.props.prependIcon
                        }, null)]);
                      },
                      title: () => i.value ? Fe.title : td("v-autocomplete", Fe.title, x(Fe)?.title)
                    });
                  }
                }), n["append-item"]?.()]
              }), n["menu-footer"] && S("footer", {
                ref: $
              }, [n["menu-footer"](se)])]
            })]
          }), I.value.map((Ee, Fe) => {
            function Ot($t) {
              $t.stopPropagation(), $t.preventDefault(), Ue(Ee, !1);
            }
            const dt = Y(ua.filterProps(Ee.props), {
              "onClick:close": Ot,
              onKeydown($t) {
                $t.key !== "Enter" && $t.key !== " " || ($t.preventDefault(), $t.stopPropagation(), Ot($t));
              },
              onMousedown($t) {
                $t.preventDefault(), $t.stopPropagation();
              },
              modelValue: !0,
              "onUpdate:modelValue": void 0
            }), Qe = A.value ? !!n.chip : !!n.selection, tn = Qe ? Lo(A.value ? n.chip({
              item: Ee,
              index: Fe,
              props: dt
            }) : n.selection({
              item: Ee,
              index: Fe
            })) : void 0;
            if (!(Qe && !tn))
              return S("div", {
                key: Ee.value,
                class: J(["v-autocomplete__selection", Fe === c.value && ["v-autocomplete__selection--selected", m.value]]),
                style: le(Fe === c.value ? h.value : {})
              }, [A.value ? n.chip ? y(Ae, {
                key: "chip-defaults",
                defaults: {
                  VChip: {
                    closable: V.value,
                    size: "small",
                    text: Ee.title
                  }
                }
              }, {
                default: () => [tn]
              }) : y(ua, Y({
                key: "chip",
                closable: V.value,
                size: "small",
                text: Ee.title,
                disabled: Ee.props.disabled
              }, dt), null) : tn ?? S("span", {
                class: "v-autocomplete__selection-text"
              }, [Ee.title, e.multiple && Fe < I.value.length - 1 && S("span", {
                class: "v-autocomplete__selection-comma"
              }, [we(",")])])]);
          })]);
        },
        "append-inner": function() {
          for (var Ce = arguments.length, He = new Array(Ce), Ee = 0; Ee < Ce; Ee++)
            He[Ee] = arguments[Ee];
          return S(fe, null, [n["append-inner"]?.(...He), e.menuIcon ? y(ze, {
            class: "v-autocomplete__menu-icon",
            color: r.value?.fieldIconColor,
            icon: e.menuIcon,
            onMousedown: ie,
            onClick: Do,
            "aria-hidden": !0,
            tabindex: "-1"
          }, null) : void 0, e.appendInnerIcon && y(w, {
            key: "append-icon",
            name: "appendInner",
            color: He[0].iconColor.value
          }, null)]);
        }
      });
    }), Mt({
      isFocused: l,
      isPristine: i,
      menu: B,
      search: _,
      filteredItems: p,
      select: Ue
    }, r);
  }
}), IA = U({
  bordered: Boolean,
  color: String,
  content: [Number, String],
  dot: Boolean,
  floating: Boolean,
  icon: be,
  inline: Boolean,
  label: {
    type: String,
    default: "$vuetify.badge"
  },
  max: [Number, String],
  modelValue: {
    type: Boolean,
    default: !0
  },
  offsetX: [Number, String],
  offsetY: [Number, String],
  textColor: String,
  ...ve(),
  ...Qn({
    location: "top end"
  }),
  ...lt(),
  ...Ie(),
  ...Re(),
  ...da({
    transition: "scale-rotate-transition"
  }),
  ...St()
}, "VBadge"), Py = K()({
  name: "VBadge",
  inheritAttrs: !1,
  props: IA(),
  setup(e, t) {
    const {
      backgroundColorClasses: n,
      backgroundColorStyles: a
    } = qe(() => e.color), {
      roundedClasses: r
    } = ut(e), {
      t: l
    } = Ke(), {
      textColorClasses: i,
      textColorStyles: o
    } = Nt(() => e.textColor), {
      themeClasses: s
    } = Fo(), {
      locationStyles: u
    } = La(e, !0, (d) => (e.floating ? e.dot ? 2 : 4 : e.dot ? 8 : 12) + (["top", "bottom"].includes(d) ? Number(e.offsetY ?? 0) : ["left", "right"].includes(d) ? Number(e.offsetX ?? 0) : 0)), {
      dimensionStyles: c
    } = xt(e);
    return X(() => {
      const d = Number(e.content), f = !e.max || isNaN(d) ? e.content : d <= Number(e.max) ? d : `${e.max}+`, [v, g] = iu(t.attrs, ["aria-atomic", "aria-label", "aria-live", "role", "title"]);
      return y(e.tag, Y({
        class: ["v-badge", {
          "v-badge--bordered": e.bordered,
          "v-badge--dot": e.dot,
          "v-badge--floating": e.floating,
          "v-badge--inline": e.inline
        }, e.class]
      }, g, {
        style: e.style
      }), {
        default: () => [S("div", {
          class: "v-badge__wrapper"
        }, [t.slots.default?.(), y(Xt, {
          transition: e.transition
        }, {
          default: () => [at(S("span", Y({
            class: ["v-badge__badge", s.value, n.value, r.value, i.value],
            style: [a.value, o.value, c.value, e.inline ? {} : u.value],
            "aria-atomic": "true",
            "aria-label": l(e.label, d),
            "aria-live": "polite",
            role: "status"
          }, v), [e.dot ? void 0 : t.slots.badge ? t.slots.badge?.() : e.icon ? y(ze, {
            icon: e.icon
          }, null) : f]), [[Wn, e.modelValue]])]
        })])]
      });
    }), {};
  }
}), AA = U({
  color: String,
  density: String,
  ...ve()
}, "VBannerActions"), Vy = K()({
  name: "VBannerActions",
  props: AA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return vt({
      VBtn: {
        color: e.color,
        density: e.density,
        slim: !0,
        variant: "text"
      }
    }), X(() => S("div", {
      class: J(["v-banner-actions", e.class]),
      style: le(e.style)
    }, [n.default?.()])), {};
  }
}), Ey = ca("v-banner-text"), PA = U({
  avatar: String,
  bgColor: String,
  color: String,
  icon: be,
  lines: String,
  stacked: Boolean,
  sticky: Boolean,
  text: String,
  ...qt(),
  ...ve(),
  ...mt(),
  ...St(),
  ...hr({
    mobile: null
  }),
  ...Ct(),
  ...Qn(),
  ...il(),
  ...lt(),
  ...Ie(),
  ...Re()
}, "VBanner"), VA = K()({
  name: "VBanner",
  props: PA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      backgroundColorClasses: a,
      backgroundColorStyles: r
    } = qe(() => e.bgColor), {
      borderClasses: l
    } = en(e), {
      densityClasses: i
    } = zt(e), {
      displayClasses: o,
      mobile: s
    } = Cn(e), {
      dimensionStyles: u
    } = xt(e), {
      elevationClasses: c
    } = Et(e), {
      locationStyles: d
    } = La(e), {
      positionClasses: f
    } = ol(e), {
      roundedClasses: v
    } = ut(e), {
      themeClasses: g
    } = Ge(e), m = D(() => e.color), h = D(() => e.density);
    vt({
      VBannerActions: {
        color: m,
        density: h
      }
    }), X(() => {
      const w = !!(e.text || n.text), _ = !!(e.avatar || e.icon), I = !!(_ || n.prepend);
      return y(e.tag, {
        class: J(["v-banner", {
          "v-banner--stacked": e.stacked || s.value,
          "v-banner--sticky": e.sticky,
          [`v-banner--${e.lines}-line`]: !!e.lines
        }, g.value, a.value, l.value, i.value, o.value, c.value, f.value, v.value, e.class]),
        style: le([r.value, u.value, d.value, e.style]),
        role: "banner"
      }, {
        default: () => [I && S("div", {
          key: "prepend",
          class: "v-banner__prepend"
        }, [n.prepend ? y(Ae, {
          key: "prepend-defaults",
          disabled: !_,
          defaults: {
            VAvatar: {
              color: m.value,
              density: h.value,
              icon: e.icon,
              image: e.avatar
            }
          }
        }, n.prepend) : y(kn, {
          key: "prepend-avatar",
          color: m.value,
          density: h.value,
          icon: e.icon,
          image: e.avatar
        }, null)]), S("div", {
          class: "v-banner__content"
        }, [w && y(Ey, {
          key: "text"
        }, {
          default: () => [n.text?.() ?? e.text]
        }), n.default?.()]), n.actions && y(Vy, {
          key: "actions"
        }, n.actions)]
      });
    });
  }
}), EA = U({
  baseColor: String,
  bgColor: String,
  color: String,
  grow: Boolean,
  mode: {
    type: String,
    validator: (e) => !e || ["horizontal", "shift"].includes(e)
  },
  height: {
    type: [Number, String],
    default: 56
  },
  active: {
    type: Boolean,
    default: !0
  },
  ...qt(),
  ...ve(),
  ...mt(),
  ...Ct(),
  ...lt(),
  ...cr({
    name: "bottom-navigation"
  }),
  ...Ie({
    tag: "header"
  }),
  ...vr({
    selectedClass: "v-btn--selected"
  }),
  ...Re()
}, "VBottomNavigation"), MA = K()({
  name: "VBottomNavigation",
  props: EA(),
  emits: {
    "update:active": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: a
    } = Fo(), {
      borderClasses: r
    } = en(e), {
      backgroundColorClasses: l,
      backgroundColorStyles: i
    } = qe(() => e.bgColor), {
      densityClasses: o
    } = zt(e), {
      elevationClasses: s
    } = Et(e), {
      roundedClasses: u
    } = ut(e), {
      ssrBootStyles: c
    } = fr(), d = T(() => Number(e.height) - (e.density === "comfortable" ? 8 : 0) - (e.density === "compact" ? 16 : 0)), f = he(e, "active", e.active), {
      layoutItemStyles: v
    } = dr({
      id: e.name,
      order: T(() => parseInt(e.order, 10)),
      position: D(() => "bottom"),
      layoutSize: D(() => f.value ? d.value : 0),
      elementSize: d,
      active: f,
      absolute: D(() => e.absolute)
    });
    return Na(e, Nc), vt({
      VBtn: {
        baseColor: D(() => e.baseColor),
        color: D(() => e.color),
        density: D(() => e.density),
        stacked: D(() => e.mode !== "horizontal"),
        variant: "text"
      }
    }, {
      scoped: !0
    }), X(() => y(e.tag, {
      class: J(["v-bottom-navigation", {
        "v-bottom-navigation--active": f.value,
        "v-bottom-navigation--grow": e.grow,
        "v-bottom-navigation--shift": e.mode === "shift"
      }, a.value, l.value, r.value, o.value, s.value, u.value, e.class]),
      style: le([i.value, v.value, {
        height: re(d.value)
      }, c.value, e.style])
    }, {
      default: () => [n.default && S("div", {
        class: "v-bottom-navigation__content"
      }, [n.default()])]
    })), {};
  }
}), My = U({
  fullscreen: Boolean,
  scrollable: Boolean,
  ...Pe(fi({
    captureFocus: !0,
    origin: "center center",
    scrollStrategy: "block",
    transition: {
      component: Ro
    },
    zIndex: 2400,
    retainFocus: !0
  }), ["disableInitialFocus"])
}, "VDialog"), Cu = K()({
  name: "VDialog",
  props: My(),
  emits: {
    "update:modelValue": (e) => !0,
    afterEnter: () => !0,
    afterLeave: () => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const r = he(e, "modelValue"), {
      scopeId: l
    } = gr(), i = G();
    function o() {
      n("afterEnter"), (e.scrim || e.retainFocus) && i.value?.contentEl && !i.value.contentEl.contains(document.activeElement) && i.value.contentEl.focus({
        preventScroll: !0
      });
    }
    function s() {
      n("afterLeave");
    }
    return ne(r, async (u) => {
      u || (await Se(), i.value.activatorEl?.focus({
        preventScroll: !0
      }));
    }), X(() => {
      const u = Yn.filterProps(e), c = Y({
        "aria-haspopup": "dialog"
      }, e.activatorProps), d = Y({
        tabindex: -1
      }, e.contentProps);
      return y(Yn, Y({
        ref: i,
        class: ["v-dialog", {
          "v-dialog--fullscreen": e.fullscreen,
          "v-dialog--scrollable": e.scrollable
        }, e.class],
        style: e.style
      }, u, {
        modelValue: r.value,
        "onUpdate:modelValue": (f) => r.value = f,
        "aria-modal": "true",
        activatorProps: c,
        contentProps: d,
        height: e.fullscreen ? void 0 : e.height,
        width: e.fullscreen ? void 0 : e.width,
        maxHeight: e.fullscreen ? void 0 : e.maxHeight,
        maxWidth: e.fullscreen ? void 0 : e.maxWidth,
        role: "dialog",
        onAfterEnter: o,
        onAfterLeave: s
      }, l), {
        activator: a.activator,
        default: function() {
          for (var f = arguments.length, v = new Array(f), g = 0; g < f; g++)
            v[g] = arguments[g];
          return y(Ae, {
            root: "VDialog"
          }, {
            default: () => [a.default?.(...v)]
          });
        }
      });
    }), Mt({}, i);
  }
}), OA = U({
  inset: Boolean,
  ...My({
    transition: "bottom-sheet-transition"
  })
}, "VBottomSheet"), DA = K()({
  name: "VBottomSheet",
  props: OA(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = he(e, "modelValue");
    return X(() => {
      const r = Cu.filterProps(e);
      return y(Cu, Y(r, {
        contentClass: ["v-bottom-sheet__content", e.contentClass],
        modelValue: a.value,
        "onUpdate:modelValue": (l) => a.value = l,
        class: ["v-bottom-sheet", {
          "v-bottom-sheet--inset": e.inset
        }, e.class],
        style: e.style
      }), n);
    }), {};
  }
}), LA = U({
  divider: [Number, String],
  ...ve()
}, "VBreadcrumbsDivider"), Oy = K()({
  name: "VBreadcrumbsDivider",
  props: LA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => S("li", {
      "aria-hidden": "true",
      class: J(["v-breadcrumbs-divider", e.class]),
      style: le(e.style)
    }, [n?.default?.() ?? e.divider])), {};
  }
}), NA = U({
  active: Boolean,
  activeClass: String,
  activeColor: String,
  color: String,
  disabled: Boolean,
  title: String,
  ...ve(),
  ...an(St(), ["width", "maxWidth"]),
  ...ui(),
  ...Ie({
    tag: "li"
  })
}, "VBreadcrumbsItem"), Dy = K()({
  name: "VBreadcrumbsItem",
  props: NA(),
  setup(e, t) {
    let {
      slots: n,
      attrs: a
    } = t;
    const r = si(e, a), l = T(() => e.active || r.isActive?.value), {
      dimensionStyles: i
    } = xt(e), {
      textColorClasses: o,
      textColorStyles: s
    } = Nt(() => l.value ? e.activeColor : e.color);
    return X(() => y(e.tag, {
      class: J(["v-breadcrumbs-item", {
        "v-breadcrumbs-item--active": l.value,
        "v-breadcrumbs-item--disabled": e.disabled,
        [`${e.activeClass}`]: l.value && e.activeClass
      }, o.value, e.class]),
      style: le([s.value, i.value, e.style]),
      "aria-current": l.value ? "page" : void 0
    }, {
      default: () => [r.isLink.value ? S("a", Y({
        class: "v-breadcrumbs-item--link",
        onClick: r.navigate.value
      }, r.linkProps), [n.default?.() ?? e.title]) : n.default?.() ?? e.title]
    })), {};
  }
}), FA = U({
  activeClass: String,
  activeColor: String,
  bgColor: String,
  color: String,
  disabled: Boolean,
  divider: {
    type: String,
    default: "/"
  },
  icon: be,
  items: {
    type: Array,
    default: () => []
  },
  ...ve(),
  ...mt(),
  ...lt(),
  ...Ie({
    tag: "ul"
  })
}, "VBreadcrumbs"), RA = K()({
  name: "VBreadcrumbs",
  props: FA(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      backgroundColorClasses: a,
      backgroundColorStyles: r
    } = qe(() => e.bgColor), {
      densityClasses: l
    } = zt(e), {
      roundedClasses: i
    } = ut(e);
    vt({
      VBreadcrumbsDivider: {
        divider: D(() => e.divider)
      },
      VBreadcrumbsItem: {
        activeClass: D(() => e.activeClass),
        activeColor: D(() => e.activeColor),
        color: D(() => e.color),
        disabled: D(() => e.disabled)
      }
    });
    const o = T(() => e.items.map((s) => typeof s == "string" ? {
      item: {
        title: s
      },
      raw: s
    } : {
      item: s,
      raw: s
    }));
    return X(() => {
      const s = !!(n.prepend || e.icon);
      return y(e.tag, {
        class: J(["v-breadcrumbs", a.value, l.value, i.value, e.class]),
        style: le([r.value, e.style])
      }, {
        default: () => [s && S("li", {
          key: "prepend",
          class: "v-breadcrumbs__prepend"
        }, [n.prepend ? y(Ae, {
          key: "prepend-defaults",
          disabled: !e.icon,
          defaults: {
            VIcon: {
              icon: e.icon,
              start: !0
            }
          }
        }, n.prepend) : y(ze, {
          key: "prepend-icon",
          start: !0,
          icon: e.icon
        }, null)]), o.value.map((u, c, d) => {
          let {
            item: f,
            raw: v
          } = u;
          return S(fe, null, [n.item?.({
            item: f,
            index: c
          }) ?? y(Dy, Y({
            key: c,
            disabled: c >= d.length - 1
          }, typeof f == "string" ? {
            title: f
          } : f), {
            default: n.title ? () => n.title?.({
              item: f,
              index: c
            }) : void 0
          }), c < d.length - 1 && y(Oy, null, {
            default: n.divider ? () => n.divider?.({
              item: v,
              index: c
            }) : void 0
          })]);
        }), n.default?.()]
      });
    }), {};
  }
}), $A = U({
  active: {
    type: Boolean,
    default: void 0
  },
  activeColor: String,
  activeIcon: [String, Function, Object],
  activeVariant: String,
  baseVariant: {
    type: String,
    default: "tonal"
  },
  disabled: Boolean,
  height: [Number, String],
  width: [Number, String],
  hideOverlay: Boolean,
  icon: [String, Function, Object],
  iconColor: String,
  loading: Boolean,
  opacity: [Number, String],
  readonly: Boolean,
  rotate: [Number, String],
  size: {
    type: [Number, String],
    default: "default"
  },
  sizes: {
    type: Array,
    default: () => [["x-small", 16], ["small", 24], ["default", 40], ["large", 48], ["x-large", 56]]
  },
  text: {
    type: [String, Number, Boolean],
    default: void 0
  },
  ...qt(),
  ...ve(),
  ...Ct(),
  ...$g(),
  ...lt(),
  ...Ie({
    tag: "button"
  }),
  ...Re(),
  ...xn({
    variant: "flat"
  })
}, "VIconBtn"), Ly = K()({
  name: "VIconBtn",
  props: $A(),
  emits: {
    "update:active": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const r = he(e, "active"), {
      themeClasses: l
    } = Ge(e), {
      borderClasses: i
    } = en(e), {
      elevationClasses: o
    } = Et(e), {
      roundedClasses: s
    } = ut(e), {
      colorClasses: u,
      colorStyles: c,
      variantClasses: d
    } = va(() => ({
      color: (() => {
        if (!e.disabled)
          return r.value ? e.activeColor ?? e.color ?? "surface-variant" : e.color;
      })(),
      variant: r.value === void 0 ? e.variant : r.value ? e.activeVariant ?? e.variant : e.baseVariant ?? e.variant
    })), f = new Map(e.sizes);
    function v() {
      e.disabled || e.readonly || r.value === void 0 || e.tag === "a" && n.href || (r.value = !r.value);
    }
    return X(() => {
      const g = r.value ? e.activeIcon ?? e.icon : e.icon, m = e.size, w = f.has(m) ? f.get(m) : m, _ = e.height ?? w, I = e.width ?? w, {
        iconSize: C
      } = Bg(e, () => new Map(e.iconSizes).get(m)), b = {
        icon: g,
        size: C.value,
        color: e.iconColor,
        opacity: e.opacity
      };
      return y(e.tag, {
        type: e.tag === "button" ? "button" : void 0,
        class: J([{
          "v-icon-btn": !0,
          "v-icon-btn--active": r.value,
          "v-icon-btn--disabled": e.disabled,
          "v-icon-btn--loading": e.loading,
          "v-icon-btn--readonly": e.readonly,
          [`v-icon-btn--${e.size}`]: !0
        }, l.value, u.value, i.value, o.value, s.value, d.value, e.class]),
        style: le([{
          "--v-icon-btn-rotate": re(e.rotate, "deg"),
          "--v-icon-btn-height": re(_),
          "--v-icon-btn-width": re(I)
        }, c.value, e.style]),
        tabindex: e.disabled || e.readonly ? -1 : 0,
        onClick: v
      }, {
        default: () => [fa(!e.hideOverlay, "v-icon-btn"), S("div", {
          class: "v-icon-btn__content",
          "data-no-activator": ""
        }, [!a.default && g ? y(ze, Y({
          key: "content-icon"
        }, b), null) : y(Ae, {
          key: "content-defaults",
          disabled: !g,
          defaults: {
            VIcon: {
              ...b
            }
          }
        }, {
          default: () => a.default?.() ?? ce(e.text)
        })]), !!e.loading && S("span", {
          key: "loader",
          class: "v-icon-btn__loader"
        }, [a.loader?.() ?? y(Aa, {
          color: typeof e.loading == "boolean" ? void 0 : e.loading,
          indeterminate: "disable-shrink",
          width: "2",
          size: C.value
        }, null)])]
      });
    }), {};
  }
});
function BA(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
const Ny = /^(\d{4})-(\d{1,2})(-(\d{1,2}))?([^\d]+(\d{1,2}))?(:(\d{1,2}))?(:(\d{1,2}))?$/, Fy = /(\d\d?)(:(\d\d?)|)(:(\d\d?)|)/, UA = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], WA = [0, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], HA = 28, zA = 31, ld = 12, Ry = 1, Yo = 1, Ca = 7, Dv = 60, jA = 59, GA = 1440, qA = 24, YA = 23, KA = 0, ZA = 1e4, JA = 100, XA = 100, QA = 1e4;
function eP(e, t, n) {
  const a = vn(e);
  return zy(a, t[0], Hy), Nn(a), n && er(a, n, a.hasTime), a;
}
function tP(e, t, n) {
  const a = vn(e);
  return zy(a, t[t.length - 1]), Nn(a), n && er(a, n, a.hasTime), a;
}
function $y(e) {
  const t = vn(e);
  return t.day = Yo, Ko(t), Nn(t), t;
}
function By(e) {
  const t = vn(e);
  return t.day = od(t.year, t.month), Ko(t), Nn(t), t;
}
function Pr(e) {
  return isFinite(parseInt(e));
}
function nP(e) {
  return typeof e == "number" && isFinite(e) || !!Fy.exec(e) || typeof e == "object" && isFinite(e.hour) && isFinite(e.minute);
}
function Lv(e) {
  if (typeof e == "number")
    return e;
  if (typeof e == "string") {
    const t = Fy.exec(e);
    return t ? parseInt(t[1]) * 60 + parseInt(t[3] || 0) : !1;
  } else return typeof e == "object" ? typeof e.hour != "number" || typeof e.minute != "number" ? !1 : e.hour * 60 + e.minute : !1;
}
function Fr(e) {
  return typeof e == "number" && isFinite(e) || typeof e == "string" && !!Ny.exec(e) || e instanceof Date;
}
function la(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = arguments.length > 2 ? arguments[2] : void 0;
  if (typeof e == "number" && isFinite(e) && (e = new Date(e)), e instanceof Date) {
    const l = id(e);
    return n && er(l, n, l.hasTime), l;
  }
  if (typeof e != "string") {
    if (t)
      throw new Error(`${e} is not a valid timestamp. It must be a Date, number of milliseconds since Epoch, or a string in the format of YYYY-MM-DD or YYYY-MM-DD hh:mm. Zero-padding is optional and seconds are ignored.`);
    return null;
  }
  const a = Ny.exec(e);
  if (!a) {
    if (t)
      throw new Error(`${e} is not a valid timestamp. It must be a Date, number of milliseconds since Epoch, or a string in the format of YYYY-MM-DD or YYYY-MM-DD hh:mm. Zero-padding is optional and seconds are ignored.`);
    return null;
  }
  const r = {
    date: e,
    time: "",
    year: parseInt(a[1]),
    month: parseInt(a[2]),
    day: parseInt(a[4]) || 1,
    hour: parseInt(a[6]) || 0,
    minute: parseInt(a[8]) || 0,
    weekday: 0,
    hasDay: !!a[4],
    hasTime: !!(a[6] && a[8]),
    past: !1,
    present: !1,
    future: !1
  };
  return Ko(r), Nn(r), n && er(r, n, r.hasTime), r;
}
function id(e) {
  return Nn({
    date: "",
    time: "",
    year: e.getFullYear(),
    month: e.getMonth() + 1,
    day: e.getDate(),
    weekday: e.getDay(),
    hour: e.getHours(),
    minute: e.getMinutes(),
    hasDay: !0,
    hasTime: !0,
    past: !1,
    present: !0,
    future: !1
  });
}
function Pt(e) {
  return e.year * ZA + e.month * JA + e.day;
}
function _u(e) {
  return e.hour * XA + e.minute;
}
function Ma(e) {
  return Pt(e) * QA + _u(e);
}
function er(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = Pt(t), r = Pt(e), l = a === r;
  return e.hasTime && n && l && (a = _u(t), r = _u(e), l = a === r), e.past = r < a, e.present = l, e.future = r > a, e;
}
function Nv(e) {
  return e instanceof Date || typeof e == "number" && isFinite(e);
}
function Fv(e, t, n) {
  return e.hasTime !== t && (e.hasTime = t, t || (e.hour = YA, e.minute = jA, e.time = Wy(e))), e;
}
function Uy(e, t, n) {
  return e.hasTime = !0, e.hour = 0, e.minute = 0, Tu(e, t), Nn(e), n && er(e, n, !0), e;
}
function Ko(e) {
  return e.weekday = aP(e), e;
}
function Nn(e) {
  return e.time = Wy(e), e.date = rP(e), e;
}
function aP(e) {
  if (e.hasDay) {
    const t = Math.floor, n = e.day, a = (e.month + 9) % ld + 1, r = t(e.year / 100), l = e.year % 100 - (e.month <= 2 ? 1 : 0);
    return ((n + t(2.6 * a - 0.2) - 2 * r + l + t(l / 4) + t(r / 4)) % 7 + 7) % 7;
  }
  return e.weekday;
}
function od(e, t) {
  return BA(e) ? WA[t] : UA[t];
}
function vn(e) {
  if (e == null) return null;
  const {
    date: t,
    time: n,
    year: a,
    month: r,
    day: l,
    weekday: i,
    hour: o,
    minute: s,
    hasDay: u,
    hasTime: c,
    past: d,
    present: f,
    future: v
  } = e;
  return {
    date: t,
    time: n,
    year: a,
    month: r,
    day: l,
    weekday: i,
    hour: o,
    minute: s,
    hasDay: u,
    hasTime: c,
    past: d,
    present: f,
    future: v
  };
}
function Za(e, t) {
  let n = String(e);
  for (; n.length < t; )
    n = "0" + n;
  return n;
}
function rP(e) {
  let t = `${Za(e.year, 4)}-${Za(e.month, 2)}`;
  return e.hasDay && (t += `-${Za(e.day, 2)}`), t;
}
function Wy(e) {
  return e.hasTime ? `${Za(e.hour, 2)}:${Za(e.minute, 2)}` : "";
}
function Tu(e, t) {
  for (e.minute += t; e.minute >= Dv; )
    e.minute -= Dv, e.hour++, e.hour >= qA && (_a(e), e.hour = KA);
  return e;
}
function _a(e) {
  return e.day++, e.weekday = (e.weekday + 1) % Ca, e.day > HA && e.day > od(e.year, e.month) && (e.day = Yo, e.month++, e.month > ld && (e.month = Ry, e.year++)), e;
}
function Hy(e) {
  return e.day--, e.weekday = (e.weekday + 6) % Ca, e.day < Yo && (e.month--, e.month < Ry && (e.year--, e.month = ld), e.day = od(e.year, e.month)), e;
}
function Ua(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _a, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  for (; --n >= 0; ) t(e);
  return e;
}
function lP(e, t) {
  const n = (t.year - e.year) * 525600, a = (t.month - e.month) * 43800, r = (t.day - e.day) * 1440, l = (t.hour - e.hour) * 60, i = t.minute - e.minute;
  return n + a + r + l + i;
}
function zy(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _a, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 6;
  for (; e.weekday !== t && --a >= 0; ) n(e);
  return e;
}
function iP(e) {
  const t = [1, 1, 1, 1, 1, 1, 1], n = [0, 0, 0, 0, 0, 0, 0];
  for (let a = 0; a < e.length; a++)
    n[e[a]] = 1;
  for (let a = 0; a < Ca; a++) {
    let r = 1;
    for (let l = 1; l < Ca; l++) {
      const i = (a + l) % Ca;
      if (n[i])
        break;
      r++;
    }
    t[a] = n[a] * r;
  }
  return t;
}
function Iu(e) {
  const t = `${Za(e.hour, 2)}:${Za(e.minute, 2)}`, n = e.date;
  return /* @__PURE__ */ new Date(`${n}T${t}:00+00:00`);
}
function vo(e, t, n, a) {
  let r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 42, l = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  const i = Pt(t), o = [];
  let s = vn(e), u = 0, c = u === i;
  if (i < Pt(e))
    throw new Error("End date is earlier than start date.");
  for (; (!c || o.length < l) && o.length < r; ) {
    if (u = Pt(s), c = c || u === i, a[s.weekday] === 0) {
      s = _a(s);
      continue;
    }
    const d = vn(s);
    Nn(d), er(d, n), o.push(d), s = Ua(s, _a, a[s.weekday]);
  }
  if (!o.length) throw new Error("No dates found using specified start date, end date, and weekdays.");
  return o;
}
function oP(e, t, n, a, r) {
  const l = [];
  for (let i = 0; i < a; i++) {
    const o = t + i * n, s = vn(e);
    l.push(Uy(s, o, r));
  }
  return l;
}
function Il(e, t) {
  const n = (a, r) => "";
  return typeof Intl > "u" || typeof Intl.DateTimeFormat > "u" ? n : (a, r) => {
    try {
      return new Intl.DateTimeFormat(e || void 0, t(a, r)).format(Iu(a));
    } catch {
      return "";
    }
  };
}
function sP(e) {
  if (typeof e == "string" && (e = e.split(",")), Array.isArray(e)) {
    const t = e.map((r) => parseInt(r));
    if (t.length > Ca || t.length === 0)
      return !1;
    const n = {};
    let a = !1;
    for (let r = 0; r < t.length; r++) {
      const l = t[r];
      if (!isFinite(l) || l < 0 || l >= Ca)
        return !1;
      if (r > 0) {
        const i = l - t[r - 1];
        if (i < 0) {
          if (a)
            return !1;
          a = !0;
        } else if (i === 0)
          return !1;
      }
      if (n[l])
        return !1;
      n[l] = !0;
    }
    return !0;
  }
  return !1;
}
function uP(e) {
  const t = cn({
    now: la("0000-00-00 00:00", !0),
    today: la("0000-00-00", !0)
  }), n = T(() => e.now && Fr(e.now) ? la(e.now, !0) : null);
  function a() {
    t.now.present = t.today.present = !0, t.now.past = t.today.past = !1, t.now.future = t.today.future = !1;
  }
  function r() {
    return id(/* @__PURE__ */ new Date());
  }
  function l(s, u) {
    s.date !== u.date && (u.year = s.year, u.month = s.month, u.day = s.day, u.weekday = s.weekday, u.date = s.date);
  }
  function i(s, u) {
    s.time !== u.time && (u.hour = s.hour, u.minute = s.minute, u.time = s.time);
  }
  function o() {
    const s = n.value || r();
    l(s, t.now), i(s, t.now), l(s, t.today);
  }
  return ne(n, o), o(), a(), {
    times: t,
    parsedNow: n,
    updateTimes: o,
    setPresent: a,
    getNow: r,
    updateDay: l,
    updateTime: i
  };
}
const cP = /* @__PURE__ */ Symbol.for("vuetify:date-options");
function dP(e, t, n) {
  const a = jy(e, t, n), r = [t];
  for (let l = 1; l < a; l++) {
    const i = e.addDays(t, l);
    r.push(i);
  }
  return n && r.push(e.endOfDay(n)), r;
}
function jy(e, t, n) {
  const a = [`${e.toISO(n ?? t).split("T")[0]}T00:00:00Z`, `${e.toISO(t).split("T")[0]}T00:00:00Z`];
  return typeof e.date() == "string" ? e.getDiff(a[0], a[1], "days") : e.getDiff(e.date(a[0]), e.date(a[1]), "days");
}
function fP(e, t) {
  const n = cn(typeof e.adapter == "function" ? new e.adapter({
    locale: e.locale[t.current.value] ?? t.current.value,
    formats: e.formats
  }) : e.adapter);
  return ne(t.current, (a) => {
    n.locale = e.locale[a] ?? a ?? n.locale;
  }), n;
}
function pr() {
  const e = Le(cP);
  if (!e) throw new Error("[Vuetify] Could not find injected date options");
  const t = Ke();
  return fP(e, t);
}
const Zo = U({
  start: {
    type: [String, Number, Date],
    validate: Fr,
    default: () => id(/* @__PURE__ */ new Date()).date
  },
  end: {
    type: [String, Number, Date],
    validate: Fr
  },
  weekdays: {
    type: [Array, String],
    default: () => [0, 1, 2, 3, 4, 5, 6],
    validate: sP
  },
  firstDayOfWeek: [Number, String],
  firstDayOfYear: [Number, String],
  weekdayFormat: {
    type: Function,
    default: null
  },
  dayFormat: {
    type: Function,
    default: null
  },
  locale: String,
  now: {
    type: String,
    validator: Fr
  },
  type: {
    type: String,
    default: "month"
  }
}, "VCalendar-base");
function sd(e) {
  const {
    times: t,
    updateTimes: n
  } = uP({
    now: e.now
  }), a = wg(e), r = pr(), l = T(() => e.type === "month" ? $y(la(e.start, !0)) : la(e.start, !0)), i = T(() => {
    const C = l.value, b = e.end && la(e.end) || C, p = Ma(b) < Ma(C) ? C : b;
    return e.type === "month" ? By(p) : p;
  }), o = T(() => Fr(e.modelValue) ? la(e.modelValue, !0) : l.value || t.today), s = T(() => {
    const C = Array.isArray(e.weekdays) ? e.weekdays : (e.weekdays || "").split(",").map((p) => parseInt(p, 10)), b = r.toJsDate(r.startOfWeek(r.date(), e.firstDayOfWeek)).getDay();
    return [...C.toSorted().filter((p) => p >= b), ...C.toSorted().filter((p) => p < b)];
  }), u = T(() => {
    const C = o.value, b = parseInt(String(e.categoryDays)) || 1;
    switch (e.type) {
      case "day":
        return [C.weekday];
      case "4day":
        return [C.weekday, (C.weekday + 1) % 7, (C.weekday + 2) % 7, (C.weekday + 3) % 7];
      case "category":
        return Array.from({
          length: b
        }, (p, x) => (C.weekday + x) % 7);
      default:
        return s.value;
    }
  }), c = T(() => iP(s.value)), d = T(() => vo(l.value, i.value, t.today, c.value)), f = T(() => e.dayFormat ? e.dayFormat : Il(a.current.value, () => ({
    timeZone: "UTC",
    day: "numeric"
  }))), v = T(() => e.weekdayFormat ? e.weekdayFormat : Il(a.current.value, (C, b) => ({
    timeZone: "UTC",
    weekday: b ? "short" : "long"
  })));
  function g(C) {
    return xg(C);
  }
  function m(C) {
    let b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return {
      "v-present": C.present,
      "v-past": C.past,
      "v-future": C.future,
      "v-outside": b
    };
  }
  function h(C) {
    return r.getWeek(r.date(C.date), e.firstDayOfWeek, e.firstDayOfYear);
  }
  function w(C) {
    return eP(C, s.value, t.today);
  }
  function _(C) {
    return tP(C, s.value, t.today);
  }
  function I(C) {
    return Il(a.current.value, () => C);
  }
  return {
    times: t,
    locale: a,
    parsedValue: o,
    parsedWeekdays: s,
    effectiveWeekdays: u,
    weekdaySkips: c,
    parsedStart: l,
    parsedEnd: i,
    days: d,
    dayFormatter: f,
    weekdayFormatter: v,
    getColorProps: g,
    getRelativeClasses: m,
    getWeekNumber: h,
    getStartOfWeek: w,
    getEndOfWeek: _,
    getFormatter: I,
    updateTimes: n
  };
}
const Gy = U({
  maxDays: {
    type: Number,
    default: 7
  },
  intervalHeight: {
    type: [Number, String],
    default: 48,
    validate: Pr
  },
  intervalWidth: {
    type: [Number, String],
    default: 60,
    validate: Pr
  },
  intervalMinutes: {
    type: [Number, String],
    default: 60,
    validate: Pr
  },
  firstInterval: {
    type: [Number, String],
    default: 0,
    validate: Pr
  },
  firstTime: {
    type: [Number, String, Object],
    validate: nP
  },
  intervalCount: {
    type: [Number, String],
    default: 24,
    validate: Pr
  },
  intervalFormat: {
    type: Function,
    default: null
  },
  intervalStyle: {
    type: Function,
    default: null
  },
  showIntervalLabel: {
    type: Function,
    default: null
  }
}, "VCalendar-intervals");
function qy(e) {
  const t = sd(e), n = ae(), a = T(() => parseInt(String(e.firstInterval || 0))), r = T(() => parseInt(String(e.intervalMinutes || 60))), l = T(() => parseInt(String(e.intervalCount || 24))), i = T(() => parseFloat(String(e.intervalHeight || 48))), o = T(() => Lv(e.firstTime)), s = T(() => {
    const b = o.value;
    return b !== !1 && b >= 0 && b <= GA ? b : a.value * r.value;
  }), u = T(() => l.value * i.value), c = T(() => vo(t.parsedStart.value, t.parsedEnd.value, t.times.today, t.weekdaySkips.value, e.maxDays)), d = T(() => {
    const b = c.value, p = s.value, x = r.value, k = l.value, V = t.times.now;
    return b.map((A) => oP(A, p, x, k, V));
  }), f = T(() => e.intervalFormat ? e.intervalFormat : Il(t.locale.current.value, (b, p) => p ? b.minute === 0 ? {
    timeZone: "UTC",
    hour: "numeric"
  } : {
    timeZone: "UTC",
    hour: "numeric",
    minute: "2-digit"
  } : {
    timeZone: "UTC",
    hour: "2-digit",
    minute: "2-digit"
  }));
  function v(b) {
    const p = d.value[0][0];
    return !(p.hour === b.hour && p.minute === b.minute);
  }
  function g(b) {
  }
  function m(b, p) {
    const x = vn(p), k = b.currentTarget.getBoundingClientRect(), V = s.value, A = b, M = b, L = A.changedTouches || A.touches, P = ((L && L[0] ? L[0].clientY : M.clientY) - k.top) / i.value, O = Math.floor(P * r.value), F = V + O;
    return Uy(x, F, t.times.now);
  }
  function h(b) {
    const p = vn(b);
    return p.timeToY = I, p.timeDelta = C, p.minutesToPixels = _, p.week = c.value, p.intervalRange = [s.value, s.value + l.value * r.value], p;
  }
  function w(b) {
    const p = I(b), x = n.value;
    return p === !1 || !x ? !1 : (x.scrollTop = p, !0);
  }
  function _(b) {
    return b / r.value * i.value;
  }
  function I(b) {
    let p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    const x = p !== !1;
    let V = C(b, typeof p != "boolean" ? p : void 0);
    return V === !1 || (V *= u.value, x ? V < 0 ? V = 0 : V > u.value && (V = u.value) : V < 0 ? V = V + u.value : V > u.value && (V = V - u.value)), V;
  }
  function C(b, p) {
    let x = Lv(b);
    if (x === !1)
      return !1;
    const k = l.value * r.value;
    if (p && typeof b == "object" && "day" in b) {
      const A = Pt(b), M = Pt(p);
      x += (A - M) * k;
    }
    const V = s.value;
    return (x - V) / k;
  }
  return {
    ...t,
    scrollAreaRef: n,
    parsedFirstInterval: a,
    parsedIntervalMinutes: r,
    parsedIntervalCount: l,
    parsedIntervalHeight: i,
    parsedFirstTime: o,
    firstMinute: s,
    bodyHeight: u,
    days: c,
    intervals: d,
    intervalFormatter: f,
    showIntervalLabelDefault: v,
    intervalStyleDefault: g,
    getTimestampAtEvent: m,
    getSlotScope: h,
    scrollToTime: w,
    minutesToPixels: _,
    timeToY: I,
    timeDelta: C
  };
}
function vP(e, t) {
  const n = t.value, a = {
    passive: !t.modifiers?.active
  };
  window.addEventListener("resize", n, a), e._onResize = Object(e._onResize), e._onResize[t.instance.$.uid] = {
    handler: n,
    options: a
  }, t.modifiers?.quiet || n();
}
function mP(e, t) {
  if (!e._onResize?.[t.instance.$.uid]) return;
  const {
    handler: n,
    options: a
  } = e._onResize[t.instance.$.uid];
  window.removeEventListener("resize", n, a), delete e._onResize[t.instance.$.uid];
}
const Wl = {
  mounted: vP,
  unmounted: mP
}, xl = rn({
  name: "VCalendarDaily",
  directives: {
    vResize: Wl
  },
  props: {
    color: String,
    shortWeekdays: {
      type: Boolean,
      default: !0
    },
    shortIntervals: {
      type: Boolean,
      default: !0
    },
    hideHeader: Boolean,
    ...Zo(),
    ...Gy()
  },
  setup(e, t) {
    let {
      slots: n,
      attrs: a
    } = t;
    const r = G(0), l = G(), i = qy(e);
    function o() {
      Se(s);
    }
    function s() {
      r.value = u();
    }
    function u() {
      return i.scrollAreaRef.value && l.value ? i.scrollAreaRef.value.offsetWidth - l.value.offsetWidth : 0;
    }
    function c() {
      return S("div", {
        class: "v-calendar-daily__head",
        style: {
          marginRight: r.value + "px"
        }
      }, [d(), f()]);
    }
    function d() {
      const E = re(e.intervalWidth);
      return S("div", {
        class: "v-calendar-daily__intervals-head",
        style: {
          width: E
        }
      }, [n["interval-header"]?.()]);
    }
    function f() {
      return i.days.value.map(v);
    }
    function v(E, P) {
      const O = bn(a, ":day", (F) => ({
        nativeEvent: F,
        ...i.getSlotScope(E)
      }));
      return S("div", Y({
        key: E.date,
        class: ["v-calendar-daily_head-day", i.getRelativeClasses(E)]
      }, O), [m(E), h(E), g(E, P)]);
    }
    function g(E, P) {
      return n["day-header"]?.({
        week: i.days.value,
        ...E,
        index: P
      }) ?? [];
    }
    function m(E) {
      const P = E.present ? e.color : void 0;
      return S("div", Y(i.getColorProps({
        text: P
      }), {
        class: "v-calendar-daily_head-weekday"
      }), [i.weekdayFormatter.value(E, e.shortWeekdays)]);
    }
    function h(E) {
      return S("div", {
        class: "v-calendar-daily_head-day-label"
      }, [n["day-label-header"]?.(E) ?? w(E)]);
    }
    function w(E) {
      const P = bn(a, ":date", (O) => ({
        nativeEvent: O,
        ...E
      }));
      return y(Ly, Y({
        active: E.present,
        activeColor: e.color,
        variant: "outlined",
        baseVariant: "text",
        "onUpdate:active": Do
      }, P), {
        default: () => [i.dayFormatter.value(E, !1)]
      });
    }
    function _() {
      return S("div", {
        class: "v-calendar-daily__body"
      }, [I()]);
    }
    function I() {
      return S("div", {
        ref: i.scrollAreaRef,
        class: "v-calendar-daily__scroll-area"
      }, [C()]);
    }
    function C() {
      return S("div", {
        ref: l,
        class: "v-calendar-daily__pane",
        style: {
          height: re(i.bodyHeight.value)
        }
      }, [b()]);
    }
    function b() {
      return S("div", {
        class: "v-calendar-daily__day-container"
      }, [A(), n.days?.() ?? p()]);
    }
    function p() {
      return i.days.value.map((E, P) => {
        const O = bn(a, ":time", (F) => ({
          nativeEvent: F,
          ...i.getSlotScope(i.getTimestampAtEvent(F, E))
        }));
        return S("div", Y({
          key: E.date,
          class: ["v-calendar-daily__day", i.getRelativeClasses(E)]
        }, O), [k(P), x(E)]);
      });
    }
    function x(E) {
      return n["day-body"]?.(i.getSlotScope(E)) ?? [];
    }
    function k(E) {
      return i.intervals.value[E].map(V);
    }
    function V(E) {
      const P = re(e.intervalHeight), O = e.intervalStyle || i.intervalStyleDefault;
      return S("div", {
        class: "v-calendar-daily__day-interval",
        key: E.time,
        style: le([{
          height: P
        }, O(E)])
      }, [n.interval?.(i.getSlotScope(E))]);
    }
    function A() {
      const E = re(e.intervalWidth), P = bn(a, ":interval", (O) => ({
        nativeEvent: O,
        ...i.getTimestampAtEvent(O, i.parsedStart.value)
      }));
      return S("div", Y({
        class: "v-calendar-daily__intervals-body",
        style: {
          width: E
        }
      }, P), [M()]);
    }
    function M() {
      return i.intervals.value.length ? i.intervals.value[0].map(L) : null;
    }
    function L(E) {
      const P = re(e.intervalHeight), O = e.shortIntervals, N = (e.showIntervalLabel || i.showIntervalLabelDefault)(E) ? i.intervalFormatter.value(E, O) : void 0;
      return S("div", {
        key: E.time,
        class: "v-calendar-daily__interval",
        style: {
          height: P
        }
      }, [S("div", {
        class: "v-calendar-daily__interval-text"
      }, [N])]);
    }
    return bt(o), X(() => at(S("div", {
      class: J(["v-calendar-daily", a.class]),
      onDragstart: (E) => E.preventDefault()
    }, [e.hideHeader ? void 0 : c(), _()]), [[Wl, s, void 0, {
      quiet: !0
    }]])), {
      ...i,
      scrollPush: r,
      pane: l,
      init: o,
      onResize: s,
      getScrollPush: u
    };
  }
});
function hP(e, t) {
  return typeof t == "function" ? t(e) : typeof t == "string" && typeof e == "object" && e ? e[t] : typeof e == "string" ? e : "";
}
function Yy(e, t) {
  return typeof e == "string" ? e.split(/\s*,\s/) : Array.isArray(e) ? e.map((n) => {
    if (typeof n == "string") return n;
    const a = typeof n.categoryName == "string" ? n.categoryName : hP(n, t);
    return {
      ...n,
      categoryName: a
    };
  }) : [];
}
const gP = rn({
  name: "VCalendarCategory",
  props: {
    categories: {
      type: [Array, String],
      default: ""
    },
    categoryText: [String, Function],
    categoryForInvalid: {
      type: String,
      default: ""
    },
    ...Zo(),
    ...Gy()
  },
  setup(e, t) {
    let {
      slots: n,
      attrs: a
    } = t;
    const r = qy(e), l = T(() => Yy(e.categories, e.categoryText));
    function i(h, w) {
      const _ = typeof w == "object" && w && w.categoryName === e.categoryForInvalid ? null : w;
      return {
        ...h,
        category: _
      };
    }
    function o(h) {
      return S("div", {
        class: "v-calendar-category__columns"
      }, [l.value.map((w) => s(h, i(h, w)))]);
    }
    function s(h, w) {
      const _ = typeof w.category == "object" ? w.category.categoryName : w.category, I = bn(a, ":dayCategory", () => i(r.getSlotScope(h) || h, w.category));
      return S("div", Y({
        class: "v-calendar-category__column-header"
      }, I), [n.category?.(w) ?? u(_), n["day-header"]?.(w)]);
    }
    function u(h) {
      return S("div", {
        class: "v-calendar-category__category"
      }, [h === null ? e.categoryForInvalid : h]);
    }
    function c() {
      const h = [];
      return r.days.value.forEach((w, _) => {
        const I = new Array(l.value.length || 1);
        I.fill(w), h.push(...I.map((C, b) => d(C, _, b)));
      }), h;
    }
    function d(h, w, _) {
      const I = l.value[_], C = bn(a, ":time", (b) => r.getSlotScope(r.getTimestampAtEvent(b, h)));
      return S("div", Y({
        key: h.date + "-" + _,
        class: ["v-calendar-daily__day", r.getRelativeClasses(h)]
      }, C), [f(w, I), g(h, I)]);
    }
    function f(h, w) {
      return r.intervals.value[h].map((_) => v(_, w));
    }
    function v(h, w) {
      const _ = re(e.intervalHeight), I = e.intervalStyle || r.intervalStyleDefault;
      return S("div", {
        key: h.time,
        class: "v-calendar-daily__day-interval",
        style: le([{
          height: _
        }, I({
          ...h,
          category: w
        })])
      }, [n.interval?.(i(r.getSlotScope(h), w))]);
    }
    function g(h, w) {
      return S("div", {
        class: "v-calendar-category__columns"
      }, [m(h, w)]);
    }
    function m(h, w) {
      const _ = bn(a, ":timeCategory", (I) => i(r.getSlotScope(r.getTimestampAtEvent(I, h)), w));
      return S("div", Y({
        class: "v-calendar-category__column"
      }, _), [n["day-body"]?.(i(r.getSlotScope(h), w))]);
    }
    return X(() => y(xl, Y({
      class: ["v-calendar-daily", "v-calendar-category"]
    }, e), {
      ...n,
      days: c,
      "day-header": o
    })), {
      ...r,
      parsedCategories: l
    };
  }
}), yP = {
  // Modifier aliases (from vue-use, other libraries, and current implementation)
  control: "ctrl",
  command: "cmd",
  option: "alt",
  // Arrow key aliases (common abbreviations)
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright",
  // Other common key aliases
  esc: "escape",
  spacebar: " ",
  space: " ",
  return: "enter",
  del: "delete",
  // Symbol aliases (existing from hotkey-parsing.ts)
  minus: "-",
  hyphen: "-"
};
function Rv(e) {
  const t = e.toLowerCase();
  return yP[t] || t;
}
function Ky(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const n = {
    keys: [],
    separators: []
  };
  if (!e)
    return t || jt("Invalid hotkey combination: empty string provided"), n;
  if (e.length > 1 && // Starts with a single separator followed by a non-separator character (e.g. '+a', '_a')
  ["+", "/", "_"].some((c) => e.startsWith(c)) && !["++", "//", "__"].some((c) => e.startsWith(c)) || // Disallow literal + or _ keys (they require shift)
  e.includes("++") || e.includes("__") || e === "+" || e === "_" || // Ends with a separator that is not part of a doubled literal
  e.length > 1 && (e.endsWith("+") || e.endsWith("_")) && e.at(-2) !== e.at(-1) || // Stand-alone doubled separators (dangling)
  e === "++" || e === "--" || e === "__")
    return t || jt(`Invalid hotkey combination: "${e}" has invalid structure`), n;
  const l = [], i = [];
  let o = "";
  const s = (c) => {
    o && (c && i.push(c), l.push(Rv(o)), o = "");
  };
  for (let c = 0; c < e.length; c++) {
    const d = e[c], f = e[c + 1];
    ["+", "/", "_", "-"].includes(d) ? d === f ? (s(d), l.push(d), c++) : ["+", "/", "_"].includes(d) ? s(d) : o += d : o += d;
  }
  return s(), l.some((c) => c.length > 1 && c.includes("-") && c !== "--") ? (t || jt(`Invalid hotkey combination: "${e}" has invalid structure`), n) : l.length === 0 && e ? {
    keys: [Rv(e)],
    separators: i
  } : {
    keys: l,
    separators: i
  };
}
function bP(e) {
  if (!e)
    return jt("Invalid hotkey sequence: empty string provided"), [];
  const t = e.startsWith("-") && !["---", "--+"].includes(e), n = e.endsWith("-") && !e.endsWith("+-") && !e.endsWith("_-") && e !== "-" && e !== "---";
  if (t || n)
    return jt(`Invalid hotkey sequence: "${e}" contains invalid combinations`), [];
  const a = [];
  let r = "", l = 0;
  for (; l < e.length; ) {
    const u = e[l];
    if (u === "-") {
      const c = e[l - 1], d = l > 1 ? e[l - 2] : void 0;
      ["+", "_"].includes(c) && !["+", "/"].includes(d ?? "") ? (r += u, l++) : (r ? (a.push(r), r = "") : a.push("-"), l++);
    } else
      r += u, l++;
  }
  r && a.push(r);
  const i = [];
  let o = 0;
  for (const u of a)
    u === "-" ? (o % 2 === 0 && i.push("-"), o++) : (o = 0, i.push(u));
  return i.every((u) => Ky(u, !0).keys.length > 0) ? i : (jt(`Invalid hotkey sequence: "${e}" contains invalid combinations`), []);
}
const $v = rn({
  name: "VCalendarWeekly",
  props: {
    minWeeks: {
      validate: Pr,
      default: 1
    },
    monthFormat: Function,
    showWeek: Boolean,
    color: String,
    shortWeekdays: {
      type: Boolean,
      default: !0
    },
    showMonthOnFirst: {
      type: Boolean,
      default: !0
    },
    shortMonths: {
      type: Boolean,
      default: !0
    },
    hideHeader: Boolean,
    ...Zo()
  },
  setup(e, t) {
    let {
      slots: n,
      attrs: a
    } = t;
    const r = sd(e), l = Fo(), i = T(() => parseInt(String(e.minWeeks))), o = T(() => {
      const b = i.value * r.parsedWeekdays.value.length, p = r.getStartOfWeek(r.parsedStart.value), x = r.getEndOfWeek(r.parsedEnd.value);
      return vo(p, x, r.times.today, r.weekdaySkips.value, Number.MAX_SAFE_INTEGER, b);
    }), s = T(() => {
      const b = r.times.today, p = r.getStartOfWeek(b), x = r.getEndOfWeek(b);
      return vo(p, x, b, r.weekdaySkips.value, r.parsedWeekdays.value.length, r.parsedWeekdays.value.length);
    }), u = T(() => e.monthFormat ? e.monthFormat : Il(r.locale.current.value, (b, p) => ({
      timeZone: "UTC",
      month: p ? "short" : "long"
    })));
    function c(b) {
      const p = Pt(b);
      return p < Pt(r.parsedStart.value) || p > Pt(r.parsedEnd.value);
    }
    function d() {
      return S("div", {
        class: "v-calendar-weekly__head",
        role: "row"
      }, [f()]);
    }
    function f() {
      const b = s.value.map(v);
      return e.showWeek && b.unshift(S("div", {
        class: "v-calendar-weekly__head-weeknumber"
      }, null)), b;
    }
    function v(b, p) {
      const x = c(o.value[p]), k = b.present ? e.color : void 0;
      return S("div", Y(r.getColorProps({
        text: k
      }), {
        key: b.date,
        class: ["v-calendar-weekly__head-weekday", r.getRelativeClasses(b, x)],
        role: "columnheader"
      }), [r.weekdayFormatter.value(b, e.shortWeekdays)]);
    }
    function g() {
      const b = o.value, p = r.parsedWeekdays.value.length, x = [];
      for (let k = 0; k < b.length; k += p)
        x.push(m(b.slice(k, k + p), h(b[k])));
      return x;
    }
    function m(b, p) {
      const x = b.map((k, V) => _(k, V, b));
      return e.showWeek && x.unshift(w(p)), S("div", {
        key: b[0].date,
        class: "v-calendar-weekly__week",
        role: "row"
      }, [x]);
    }
    function h(b) {
      return r.getWeekNumber(b);
    }
    function w(b) {
      return S("div", {
        class: "v-calendar-weekly__weeknumber"
      }, [S("small", null, [String(b)])]);
    }
    function _(b, p, x) {
      const k = c(b), V = bn(a, ":day", (A) => ({
        nativeEvent: A,
        ...b
      }));
      return S("div", Y({
        key: b.date,
        class: ["v-calendar-weekly__day", r.getRelativeClasses(b, k)],
        role: "cell"
      }, V), [I(b), n.day?.({
        outside: k,
        index: p,
        week: x,
        ...b
      })]);
    }
    function I(b) {
      return S("div", {
        class: "v-calendar-weekly__day-label"
      }, [n["day-label"]?.(b) ?? C(b)]);
    }
    function C(b) {
      const p = b.day === 1 && e.showMonthOnFirst, x = bn(a, ":date", (k) => ({
        nativeEvent: k,
        ...b
      }));
      return y(Ly, Y({
        active: b.present,
        activeColor: e.color,
        variant: "outlined",
        baseVariant: "text",
        "onUpdate:active": Do
      }, x), {
        default: () => [p ? u.value(b, e.shortMonths) + " " + r.dayFormatter.value(b, !1) : r.dayFormatter.value(b, !1)]
      });
    }
    return X(() => S("div", {
      class: J(["v-calendar-weekly", l.themeClasses.value]),
      onDragstart: (b) => b.preventDefault()
    }, [e.hideHeader ? void 0 : d(), g()])), {
      ...r,
      days: o,
      todayWeek: s,
      monthFormatter: u,
      isOutside: c
    };
  }
}), pP = 864e5;
function Zy(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  const n = e.map((a) => ({
    event: a,
    columnCount: 0,
    column: 0,
    left: 0,
    width: 100
  }));
  return n.sort((a, r) => Math.max(t, a.event.startTimestampIdentifier) - Math.max(t, r.event.startTimestampIdentifier) || r.event.endTimestampIdentifier - a.event.endTimestampIdentifier), n;
}
function Fn(e, t, n, a) {
  return (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0) ? !(e >= a || t <= n) : !(e > a || t < n);
}
function Bv(e) {
  e.forEach((t) => {
    t.visuals.forEach((n) => {
      n.columnCount = e.length;
    });
  });
}
function Jy(e) {
  return [e.startTimestampIdentifier, e.endTimestampIdentifier];
}
function Xy(e) {
  return [e.startIdentifier, e.endIdentifier];
}
function Qy(e, t) {
  return [Math.max(t, e.startTimestampIdentifier), Math.min(t + pP, e.endTimestampIdentifier)];
}
function wP(e, t, n, a) {
  for (let r = 0; r < e.length; r++) {
    const l = e[r];
    let i = !1;
    if (Fn(t, n, l.start, l.end, a))
      for (let o = 0; o < l.visuals.length; o++) {
        const s = l.visuals[o], [u, c] = a ? Jy(s.event) : Xy(s.event);
        if (Fn(t, n, u, c, a)) {
          i = !0;
          break;
        }
      }
    if (!i)
      return r;
  }
  return -1;
}
function eb(e) {
  const t = {
    groups: [],
    min: -1,
    max: -1,
    reset: () => {
      t.groups = [], t.min = t.max = -1;
    },
    getVisuals: function(n, a, r) {
      let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      (n.weekday === e || l) && t.reset();
      const i = Ma(n), o = Zy(a, i);
      return o.forEach((s) => {
        const [u, c] = r ? Jy(s.event) : Xy(s.event);
        t.groups.length > 0 && !Fn(u, c, t.min, t.max, r) && (Bv(t.groups), t.reset());
        let d = wP(t.groups, u, c, r);
        d === -1 && (d = t.groups.length, t.groups.push({
          start: u,
          end: c,
          visuals: []
        }));
        const f = t.groups[d];
        f.visuals.push(s), f.start = Math.min(f.start, u), f.end = Math.max(f.end, c), s.column = d, t.min === -1 ? (t.min = u, t.max = c) : (t.min = Math.min(t.min, u), t.max = Math.max(t.max, c));
      }), Bv(t.groups), r && t.reset(), o;
    }
  };
  return t;
}
const Uv = 100, kP = (e, t, n) => {
  const a = eb(t);
  return (r, l, i, o) => {
    const s = a.getVisuals(r, l, i, o);
    return i && s.forEach((u) => {
      u.left = u.column * Uv / u.columnCount, u.width = Uv / u.columnCount;
    }), s;
  };
}, Ni = 100, SP = 5, xP = 1.7, CP = (e, t, n) => {
  const a = eb(t);
  return (r, l, i, o) => {
    if (!i)
      return a.getVisuals(r, l, i, o);
    const s = Ma(r), u = Zy(l, s), c = EP(u, s);
    for (const d of c) {
      const f = [];
      for (const v of d.visuals) {
        const g = MP(v, s), m = AP(g, f);
        if (m === !1) {
          const h = PP(g, f);
          h && (g.parent = h, g.sibling = Fn(g.start, g.end, h.start, Gi(h.start, n)), g.index = h.index + 1, h.children.push(g));
        } else {
          const [h] = Wv(g, f, m - 1, m - 1), w = Wv(g, f, m + 1, m + f.length, !0);
          g.children = w, g.index = m, h && (g.parent = h, g.sibling = Fn(g.start, g.end, h.start, Gi(h.start, n)), h.children.push(g));
          for (const _ of w)
            _.parent === h && (_.parent = g), _.index - g.index <= 1 && g.sibling && Fn(g.start, Gi(g.start, n), _.start, _.end) && (_.sibling = !0);
        }
        f.push(g);
      }
      _P(f, n);
    }
    return u.sort((d, f) => d.left - f.left || d.event.startTimestampIdentifier - f.event.startTimestampIdentifier), u;
  };
};
function _P(e, t) {
  for (const n of e) {
    const {
      visual: a,
      parent: r
    } = n, l = tb(n) + 1, i = r ? r.visual.left : 0, o = Ni - i, s = Math.min(SP, Ni / l), u = TP(n, e), c = o / (l - n.index + 1), d = o / (l - n.index + (n.sibling ? 1 : 0)) * u;
    r && (a.left = n.sibling ? i + c : i + s), a.width = VP(n, e, t) ? Ni - a.left : Math.min(Ni - a.left, d * xP);
  }
}
function TP(e, t) {
  if (!e.children.length)
    return 1;
  const n = e.index + t.length;
  return e.children.reduce((r, l) => Math.min(r, l.index), n) - e.index;
}
function IP(e, t) {
  const n = [];
  for (const a of t)
    Fn(e.start, e.end, a.start, a.end) && n.push(a.index);
  return n;
}
function AP(e, t) {
  const n = IP(e, t);
  n.sort();
  for (let a = 0; a < n.length; a++)
    if (a < n[a])
      return a;
  return !1;
}
function Wv(e, t, n, a) {
  let r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  const l = [];
  for (const i of t)
    i.index >= n && i.index <= a && Fn(e.start, e.end, i.start, i.end) && l.push(i);
  if (r && l.length > 0) {
    const i = l.reduce((o, s) => Math.min(o, s.index), l[0].index);
    return l.filter((o) => o.index === i);
  }
  return l;
}
function PP(e, t) {
  let n = null;
  for (const a of t)
    Fn(e.start, e.end, a.start, a.end) && (n === null || a.index > n.index) && (n = a);
  return n;
}
function VP(e, t, n) {
  for (const a of t)
    if (a !== e && a.index > e.index && Fn(e.start, Gi(e.start, n), a.start, a.end))
      return !1;
  return !0;
}
function EP(e, t) {
  const n = [];
  for (const a of e) {
    const [r, l] = Qy(a.event, t);
    let i = !1;
    for (const o of n)
      if (Fn(r, l, o.start, o.end)) {
        o.visuals.push(a), o.end = Math.max(o.end, l), i = !0;
        break;
      }
    i || n.push({
      start: r,
      end: l,
      visuals: [a]
    });
  }
  return n;
}
function MP(e, t) {
  const [n, a] = Qy(e.event, t);
  return {
    parent: null,
    sibling: !0,
    index: 0,
    visual: e,
    start: n,
    end: a,
    children: []
  };
}
function tb(e) {
  let t = e.index;
  for (const n of e.children) {
    const a = tb(n);
    a > t && (t = a);
  }
  return t;
}
function Gi(e, t) {
  const n = e % 100, a = n + t, r = Math.floor(a / 60), l = a % 60;
  return e - n + r * 100 + l;
}
const nb = {
  stack: CP,
  column: kP
};
function OP(e, t, n, a) {
  let r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, l = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1;
  const i = e[n], o = e[a], s = la(i, !0), u = o ? la(o, !0) : s, c = Nv(i) ? Fv(s, r) : s, d = Nv(o) ? Fv(u, r) : u, f = Pt(c), v = Ma(c), g = Pt(d), m = c.hasTime ? 0 : 2359, h = Ma(d) + m, w = !c.hasTime;
  return {
    input: e,
    start: c,
    startIdentifier: f,
    startTimestampIdentifier: v,
    end: d,
    endIdentifier: g,
    endTimestampIdentifier: h,
    allDay: w,
    index: t,
    category: l
  };
}
function ud(e, t) {
  return t >= e.startIdentifier && t <= e.endIdentifier;
}
function DP(e, t, n) {
  if (n) {
    const a = Tu(vn(t), n[0]), r = Tu(vn(t), n[1]), l = e.startTimestampIdentifier < Ma(r), i = e.endTimestampIdentifier > Ma(a);
    return l && i;
  }
  return ud(e, Pt(t));
}
function LP(e, t) {
  return e.end.time === "00:00" && e.end.date === t.date && e.start.date !== t.date;
}
function Hv(e, t, n, a) {
  return n === e.startIdentifier || a === t.weekday && ud(e, n);
}
function NP(e, t, n) {
  return t <= e.endIdentifier && n >= e.startIdentifier;
}
const FP = 100, RP = 95, $P = U({
  events: {
    type: Array,
    default: () => []
  },
  eventStart: {
    type: String,
    default: "start"
  },
  eventEnd: {
    type: String,
    default: "end"
  },
  eventTimed: {
    type: [String, Function],
    default: "timed"
  },
  eventCategory: {
    type: [String, Function],
    default: "category"
  },
  eventHeight: {
    type: Number,
    default: 20
  },
  eventColor: {
    type: [String, Function],
    default: "primary"
  },
  eventTextColor: {
    type: [String, Function]
  },
  eventName: {
    type: [String, Function],
    default: "name"
  },
  eventOverlapThreshold: {
    type: [String, Number],
    default: 60
  },
  eventOverlapMode: {
    type: [String, Function],
    default: "stack",
    validate: (e) => e in nb || typeof e == "function"
  },
  eventMore: {
    type: Boolean,
    default: !0
  },
  eventMoreText: {
    type: String,
    default: "$vuetify.calendar.moreEvents"
  },
  eventRipple: {
    type: [Boolean, Object],
    default: null
  },
  eventMarginBottom: {
    type: Number,
    default: 1
  }
}, "VCalendar-events");
function BP(e, t, n) {
  const a = sd(e), r = T(() => !Array.isArray(e.events) || e.events.length === 0), l = T(() => e.type === "category"), i = T(() => typeof e.eventTimed == "function" ? e.eventTimed : (P) => !!P[e.eventTimed]), o = T(() => typeof e.eventCategory == "function" ? e.eventCategory : (P) => P[e.eventCategory]), s = T(() => e.events ? e.events.map((P, O) => OP(P, O, e.eventStart || "", e.eventEnd || "", i.value(P), l.value ? o.value(P) : !1)) : []), u = T(() => parseInt(String(e.eventOverlapThreshold || 0))), c = T(() => typeof e.eventTextColor == "function" ? e.eventTextColor : () => e.eventTextColor), d = T(() => typeof e.eventName == "function" ? e.eventName : (P, O) => P.input[e.eventName] || ""), f = T(() => typeof e.eventOverlapMode == "function" ? e.eventOverlapMode : nb[e.eventOverlapMode]), v = T(() => a.effectiveWeekdays.value);
  function g(P) {
    return typeof e.eventColor == "function" ? e.eventColor(P) : P.color || e.eventColor;
  }
  const m = G([]);
  function h() {
    if (r.value || !e.eventMore)
      return;
    const P = e.eventHeight || 0, O = w();
    for (const F in O) {
      const {
        parent: B,
        events: N,
        more: W
      } = O[F];
      if (!W)
        break;
      const R = B.getBoundingClientRect(), j = N.length - 1, H = N.map((z) => ({
        event: z,
        bottom: z.getBoundingClientRect().bottom
      })).sort((z, te) => z.bottom - te.bottom);
      let $ = 0;
      for (let z = 0; z <= j; z++) {
        const te = H[z].bottom;
        (z === j ? te > R.bottom : te + P > R.bottom) && (H[z].event.style.display = "none", $++);
      }
      $ ? (W.style.display = "", W.innerHTML = a.locale.t(e.eventMoreText, $)) : W.style.display = "none";
    }
  }
  function w() {
    const P = {}, O = m.value;
    return !O || !O.length || O.forEach((F) => {
      const B = F.getAttribute("data-date");
      F.parentElement && B && (B in P || (P[B] = {
        parent: F.parentElement,
        more: null,
        events: []
      }), F.getAttribute("data-more") ? P[B].more = F : (P[B].events.push(F), F.style.display = ""));
    }), P;
  }
  function _(P, O) {
    let {
      event: F
    } = P;
    const B = e.eventHeight || 0, N = e.eventMarginBottom || 0, W = Pt(O), R = O.week, j = W === F.startIdentifier;
    let H = W === F.endIdentifier, $ = RP;
    if (!l.value)
      for (let te = O.index + 1; te < R.length; te++) {
        const me = Pt(R[te]);
        if (F.endIdentifier >= me)
          $ += FP, H = H || me === F.endIdentifier;
        else {
          H = !0;
          break;
        }
      }
    return C(F, {
      eventParsed: F,
      day: O,
      start: j,
      end: H,
      timed: !1
    }, !1, {
      class: ["v-event", {
        "v-event-start": j,
        "v-event-end": H
      }],
      style: {
        height: `${B}px`,
        width: `${$}%`,
        marginBottom: `${N}px`
      },
      "data-date": O.date
    });
  }
  function I(P, O) {
    let {
      event: F,
      left: B,
      width: N
    } = P;
    const W = O.timeDelta(F.start, O), R = O.timeDelta(F.end, O);
    if (R === !1 || W === !1 || R < 0 || W >= 1 || LP(F, O))
      return !1;
    const j = Pt(O), H = F.startIdentifier >= j, $ = F.endIdentifier > j, z = O.timeToY(F.start, O), te = O.timeToY(F.end, O), me = Math.max(e.eventHeight || 0, te - z);
    return C(F, {
      eventParsed: F,
      day: O,
      start: H,
      end: $,
      timed: !0
    }, !0, {
      class: "v-event-timed",
      style: {
        top: `${z}px`,
        height: `${me}px`,
        left: `${B}%`,
        width: `${N}%`
      }
    });
  }
  function C(P, O, F, B) {
    const N = t.event, W = c.value(P.input), R = g(P.input), j = P.start.hour < 12 && P.end.hour >= 12, H = lP(P.start, P.end) <= u.value, $ = (ie, ke) => a.getFormatter({
      timeZone: "UTC",
      hour: "numeric",
      minute: ie.minute > 0 ? "numeric" : void 0
    })(ie, !0), z = () => $(P.start) + " - " + $(P.end), te = () => {
      const ie = d.value(P, F);
      if (P.start.hasTime)
        if (F) {
          const ke = z(), ye = H ? ", " : S("br", null, null);
          return S("span", {
            class: "v-event-summary"
          }, [S("strong", null, [ie]), ye, ke]);
        } else {
          const ke = $(P.start);
          return S("span", {
            class: "v-event-summary"
          }, [S("strong", null, [ke]), we(" "), ie]);
        }
      return S("span", {
        class: "v-event-summary"
      }, [ie]);
    }, me = {
      ...O,
      event: P.input,
      outside: O.day.outside,
      singline: H,
      overlapsNoon: j,
      formatTime: $,
      timeSummary: z,
      eventSummary: te
    }, Q = bn(n, ":event", (ie) => ({
      ...me,
      nativeEvent: ie
    }));
    return at(S("div", Y(a.getColorProps({
      text: W,
      background: R
    }), Q, B, {
      ref_for: !0,
      ref: m
    }), [N?.(me) ?? b(te)]), [[Ht, e.eventRipple ?? !0]]);
  }
  function b(P) {
    return S("div", {
      class: "pl-1"
    }, [P()]);
  }
  function p(P) {
    const O = (e.eventHeight || 0) + (e.eventMarginBottom || 0);
    return S("div", {
      style: {
        height: `${O}px`
      },
      "data-date": P.date,
      ref_for: !0,
      ref: m
    }, null);
  }
  function x(P) {
    const O = e.eventHeight || 0, F = e.eventMarginBottom || 0, B = bn(n, ":more", (N) => ({
      nativeEvent: N,
      ...P
    }));
    return at(S("div", Y({
      class: ["v-event-more pl-1", {
        "v-outside": P.outside
      }],
      "data-date": P.date,
      "data-more": "1",
      style: {
        display: "none",
        height: `${O}px`,
        marginBottom: `${F}px`
      },
      ref_for: !0,
      ref: m
    }, B), null), [[Ht, e.eventRipple ?? !0]]);
  }
  function k() {
    const P = a.days.value, O = Pt(P[0]), F = Pt(P[P.length - 1]);
    return s.value.filter((B) => NP(B, O, F));
  }
  function V(P, O) {
    return !l.value || typeof O == "object" && O.categoryName && O.categoryName === P.category || typeof P.category == "string" && O === P.category || typeof P.category != "string" && O === null;
  }
  function A(P) {
    const O = Pt(P), F = v.value[0];
    return s.value.filter((B) => Hv(B, P, O, F));
  }
  function M(P) {
    const O = Pt(P), F = v.value[0];
    return s.value.filter((B) => B.allDay && (l.value ? ud(B, O) : Hv(B, P, O, F)) && V(B, P.category));
  }
  function L(P) {
    return s.value.filter((O) => !O.allDay && DP(O, P, P.intervalRange) && V(O, P.category));
  }
  function E() {
    if (r.value)
      return {
        ...t
      };
    const P = f.value(s.value, v.value[0], u.value), O = (B) => !!B, F = (B, N, W, R) => {
      const j = N(B), H = P(B, j, R, l.value);
      if (R)
        return H.map((z) => W(z, B)).filter(O);
      const $ = [];
      return H.forEach((z, te) => {
        for (; $.length < z.column; )
          $.push(p(B));
        const me = W(z, B);
        me && $.push(me);
      }), $;
    };
    return {
      ...t,
      day: (B) => {
        let N = F(B, A, _, !1);
        if (N && N.length > 0 && e.eventMore && N.push(x(B)), t.day) {
          const W = t.day(B);
          W && (N = N ? N.concat(W) : W);
        }
        return N;
      },
      "day-header": (B) => {
        let N = F(B, M, _, !1);
        if (t["day-header"]) {
          const W = t["day-header"](B);
          W && (N = N ? N.concat(W) : W);
        }
        return N;
      },
      "day-body": (B) => {
        const N = F(B, L, I, !0);
        let W = [S("div", {
          class: "v-event-timed-container"
        }, [N])];
        if (t["day-body"]) {
          const R = t["day-body"](B);
          R && (W = W.concat(R));
        }
        return W;
      }
    };
  }
  return {
    ...a,
    noEvents: r,
    parsedEvents: s,
    parsedEventOverlapThreshold: u,
    eventTimedFunction: i,
    eventCategoryFunction: o,
    eventTextColorFunction: c,
    eventNameFunction: d,
    eventModeFunction: f,
    eventWeekdays: v,
    categoryMode: l,
    eventColorFunction: g,
    eventsRef: m,
    updateEventVisibility: h,
    getEventsMap: w,
    genDayEvent: _,
    genTimedEvent: I,
    genEvent: C,
    genName: b,
    genPlaceholder: p,
    genMore: x,
    getVisibleEvents: k,
    isEventForCategory: V,
    getEventsForDay: A,
    getEventsForDayAll: M,
    getEventsForDayTimed: L,
    getScopedSlots: E
  };
}
const UP = K()({
  name: "VCalendar",
  directives: {
    vResize: Wl
  },
  props: {
    modelValue: {
      type: [String, Number, Date],
      validate: Fr
    },
    categoryDays: {
      type: [Number, String],
      default: 1,
      validate: (e) => isFinite(parseInt(e)) && parseInt(e) > 0
    },
    categories: {
      type: [Array, String],
      default: ""
    },
    categoryText: {
      type: [String, Function]
    },
    maxDays: {
      type: Number,
      default: 7
    },
    categoryHideDynamic: {
      type: Boolean
    },
    categoryShowAll: {
      type: Boolean
    },
    categoryForInvalid: {
      type: String,
      default: ""
    },
    ...Zo(),
    ...$P()
  },
  setup(e, t) {
    let {
      slots: n,
      attrs: a,
      emit: r
    } = t;
    const l = G(), i = BP(e, n, a), o = G(null), s = G(null), u = T(() => parseInt(String(e.categoryDays)) || 1), c = T(() => Yy(e.categories, e.categoryText)), d = T(() => {
      const p = i.parsedValue.value;
      let x = null, k = e.maxDays, V = c.value, A = p, M = p;
      switch (e.type) {
        case "month":
          x = $v, A = $y(p), M = By(p);
          break;
        case "week":
          x = xl, A = i.getStartOfWeek(p), M = i.getEndOfWeek(p), k = 7;
          break;
        case "day":
          x = xl, k = 1;
          break;
        case "4day":
          x = xl, M = Ua(vn(M), _a, 3), Nn(M), k = 4;
          break;
        case "custom-weekly":
          x = $v, A = i.parsedStart.value || p, M = i.parsedEnd.value;
          break;
        case "custom-daily":
          x = xl, A = i.parsedStart.value || p, M = i.parsedEnd.value;
          break;
        case "category":
          const L = u.value;
          x = gP, M = Ua(vn(M), _a, L), Nn(M), k = L, V = b(V);
          break;
        default:
          const E = e.type;
          throw new Error(`${E} is not a valid Calendar type`);
      }
      return {
        component: x,
        start: A,
        end: M,
        maxDays: k,
        categories: V
      };
    }), f = T(() => i.effectiveWeekdays.value), v = T(() => e.type === "category"), g = T(() => i.getFormatter({
      timeZone: "UTC",
      month: "long"
    })), m = T(() => i.getFormatter({
      timeZone: "UTC",
      month: "short"
    })), h = T(() => {
      const {
        start: p,
        end: x
      } = d.value, k = p.year !== x.year, V = k || p.month !== x.month;
      return k ? m.value(p, !0) + " " + p.year + " - " + m.value(x, !0) + " " + x.year : V ? m.value(p, !0) + " - " + m.value(x, !0) + " " + x.year : g.value(p, !1) + " " + p.year;
    });
    function w() {
      const {
        start: p,
        end: x
      } = d.value;
      (!o.value || !s.value || p.date !== o.value.date || x.date !== s.value.date) && (o.value = p, s.value = x, r("change", {
        start: p,
        end: x
      }));
    }
    function _() {
      let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      const x = vn(i.parsedValue.value), k = p > 0, V = k ? _a : Hy, A = k ? zA : Yo;
      let M = k ? p : -p;
      for (; --M >= 0; )
        switch (e.type) {
          case "month":
            x.day = A, V(x);
            break;
          case "week":
            Ua(x, V, Ca);
            break;
          case "day":
            Ua(x, V, 1);
            break;
          case "4day":
            Ua(x, V, 4);
            break;
          case "category":
            Ua(x, V, u.value);
            break;
        }
      Ko(x), Nn(x), er(x, i.times.now), e.modelValue instanceof Date ? r("update:modelValue", Iu(x)) : typeof e.modelValue == "number" ? r("update:modelValue", Iu(x).getTime()) : r("update:modelValue", x.date), r("moved", x);
    }
    function I() {
      let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      _(p);
    }
    function C() {
      let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      _(-p);
    }
    function b(p) {
      if (!i.noEvents.value) {
        const x = p.reduce((k, V, A) => (typeof V == "object" && V.categoryName ? k[V.categoryName] = {
          index: A,
          count: 0
        } : typeof V == "string" && (k[V] = {
          index: A,
          count: 0
        }), k), {});
        if (!e.categoryHideDynamic || !e.categoryShowAll) {
          let k = p.length;
          i.parsedEvents.value.forEach((V) => {
            let A = V.category;
            typeof A != "string" && (A = e.categoryForInvalid), A && (A in x ? x[A].count++ : e.categoryHideDynamic || (x[A] = {
              index: k++,
              count: 1
            }));
          });
        }
        if (!e.categoryShowAll)
          for (const k in x)
            x[k].count === 0 && delete x[k];
        p = p.filter((k) => typeof k == "object" && k.categoryName ? x.hasOwnProperty(k.categoryName) : typeof k == "string" ? x.hasOwnProperty(k) : !1);
      }
      return p;
    }
    return ne(d, w), bt(() => {
      i.updateEventVisibility(), w();
    }), sm(() => {
      window.requestAnimationFrame(i.updateEventVisibility);
    }), X(() => {
      const {
        start: p,
        end: x,
        maxDays: k,
        component: V,
        categories: A
      } = d.value;
      return at(y(V, Y({
        ref: l,
        class: ["v-calendar", {
          "v-calendar-events": !i.noEvents.value
        }],
        role: "grid"
      }, V.filterProps(e), {
        start: p.date,
        end: x.date,
        maxDays: k,
        weekdays: i.effectiveWeekdays.value,
        categories: A,
        "onClick:date": (M, L) => {
          a["onUpdate:modelValue"] && r("update:modelValue", L.date);
        }
      }), i.getScopedSlots()), [[Wl, i.updateEventVisibility, void 0, {
        quiet: !0
      }]]);
    }), Mt({
      ...i,
      lastStart: o,
      lastEnd: s,
      parsedCategoryDays: u,
      renderProps: d,
      eventWeekdays: f,
      categoryMode: v,
      title: h,
      monthLongFormatter: g,
      monthShortFormatter: m,
      parsedCategories: c,
      checkChange: w,
      move: _,
      next: I,
      prev: C,
      getCategoryList: b
    }, l);
  }
}), WP = U({
  ...ve(),
  ...Ie()
}, "VCardActions"), ab = K()({
  name: "VCardActions",
  props: WP(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return vt({
      VBtn: {
        slim: !0,
        variant: "text"
      }
    }), X(() => y(e.tag, {
      class: J(["v-card-actions", e.class]),
      style: le(e.style)
    }, n)), {};
  }
}), HP = U({
  opacity: [Number, String],
  ...ve(),
  ...Ie()
}, "VCardSubtitle"), rb = K()({
  name: "VCardSubtitle",
  props: HP(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => y(e.tag, {
      class: J(["v-card-subtitle", e.class]),
      style: le([{
        "--v-card-subtitle-opacity": e.opacity
      }, e.style])
    }, n)), {};
  }
}), lb = ca("v-card-title"), zP = U({
  appendAvatar: String,
  appendIcon: be,
  prependAvatar: String,
  prependIcon: be,
  subtitle: {
    type: [String, Number, Boolean],
    default: void 0
  },
  title: {
    type: [String, Number, Boolean],
    default: void 0
  },
  ...ve(),
  ...mt(),
  ...Ie()
}, "VCardItem"), ib = K()({
  name: "VCardItem",
  props: zP(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => {
      const a = !!(e.prependAvatar || e.prependIcon), r = !!(a || n.prepend), l = !!(e.appendAvatar || e.appendIcon), i = !!(l || n.append), o = !!(e.title != null || n.title), s = !!(e.subtitle != null || n.subtitle);
      return y(e.tag, {
        class: J(["v-card-item", e.class]),
        style: le(e.style)
      }, {
        default: () => [r && S("div", {
          key: "prepend",
          class: "v-card-item__prepend"
        }, [n.prepend ? y(Ae, {
          key: "prepend-defaults",
          disabled: !a,
          defaults: {
            VAvatar: {
              density: e.density,
              image: e.prependAvatar
            },
            VIcon: {
              density: e.density,
              icon: e.prependIcon
            }
          }
        }, n.prepend) : S(fe, null, [e.prependAvatar && y(kn, {
          key: "prepend-avatar",
          density: e.density,
          image: e.prependAvatar
        }, null), e.prependIcon && y(ze, {
          key: "prepend-icon",
          density: e.density,
          icon: e.prependIcon
        }, null)])]), S("div", {
          class: "v-card-item__content"
        }, [o && y(lb, {
          key: "title"
        }, {
          default: () => [n.title?.() ?? ce(e.title)]
        }), s && y(rb, {
          key: "subtitle"
        }, {
          default: () => [n.subtitle?.() ?? ce(e.subtitle)]
        }), n.default?.()]), i && S("div", {
          key: "append",
          class: "v-card-item__append"
        }, [n.append ? y(Ae, {
          key: "append-defaults",
          disabled: !l,
          defaults: {
            VAvatar: {
              density: e.density,
              image: e.appendAvatar
            },
            VIcon: {
              density: e.density,
              icon: e.appendIcon
            }
          }
        }, n.append) : S(fe, null, [e.appendIcon && y(ze, {
          key: "append-icon",
          density: e.density,
          icon: e.appendIcon
        }, null), e.appendAvatar && y(kn, {
          key: "append-avatar",
          density: e.density,
          image: e.appendAvatar
        }, null)])])]
      });
    }), {};
  }
}), jP = U({
  opacity: [Number, String],
  ...ve(),
  ...Ie()
}, "VCardText"), ob = K()({
  name: "VCardText",
  props: jP(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => y(e.tag, {
      class: J(["v-card-text", e.class]),
      style: le([{
        "--v-card-text-opacity": e.opacity
      }, e.style])
    }, n)), {};
  }
}), GP = U({
  appendAvatar: String,
  appendIcon: be,
  disabled: Boolean,
  flat: Boolean,
  hover: Boolean,
  image: String,
  link: {
    type: Boolean,
    default: void 0
  },
  prependAvatar: String,
  prependIcon: be,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  subtitle: {
    type: [String, Number, Boolean],
    default: void 0
  },
  text: {
    type: [String, Number, Boolean],
    default: void 0
  },
  title: {
    type: [String, Number, Boolean],
    default: void 0
  },
  ...qt(),
  ...ve(),
  ...mt(),
  ...St(),
  ...Ct(),
  ...Wo(),
  ...Qn(),
  ...il(),
  ...lt(),
  ...ui(),
  ...Ie(),
  ...Re(),
  ...xn({
    variant: "elevated"
  })
}, "VCard"), qP = K()({
  name: "VCard",
  directives: {
    vRipple: Ht
  },
  props: GP(),
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const {
      themeClasses: r
    } = Ge(e), {
      borderClasses: l
    } = en(e), {
      colorClasses: i,
      colorStyles: o,
      variantClasses: s
    } = va(e), {
      densityClasses: u
    } = zt(e), {
      dimensionStyles: c
    } = xt(e), {
      elevationClasses: d
    } = Et(e), {
      loaderClasses: f
    } = ii(e), {
      locationStyles: v
    } = La(e), {
      positionClasses: g
    } = ol(e), {
      roundedClasses: m
    } = ut(e), h = si(e, n), w = ae(void 0);
    return ne(() => e.loading, (_, I) => {
      w.value = !_ && typeof I == "string" ? I : typeof _ == "boolean" ? void 0 : _;
    }, {
      immediate: !0
    }), X(() => {
      const _ = e.link !== !1 && h.isLink.value, I = !e.disabled && e.link !== !1 && (e.link || h.isClickable.value), C = _ ? "a" : e.tag, b = !!(a.title || e.title != null), p = !!(a.subtitle || e.subtitle != null), x = b || p, k = !!(a.append || e.appendAvatar || e.appendIcon), V = !!(a.prepend || e.prependAvatar || e.prependIcon), A = !!(a.image || e.image), M = x || V || k, L = !!(a.text || e.text != null);
      return at(y(C, Y(h.linkProps, {
        class: ["v-card", {
          "v-card--disabled": e.disabled,
          "v-card--flat": e.flat,
          "v-card--hover": e.hover && !(e.disabled || e.flat),
          "v-card--link": I
        }, r.value, l.value, i.value, u.value, d.value, f.value, g.value, m.value, s.value, e.class],
        style: [o.value, c.value, v.value, {
          "--v-card-height": re(e.height)
        }, e.style],
        onClick: I && h.navigate.value,
        tabindex: e.disabled ? -1 : void 0
      }), {
        default: () => [A && S("div", {
          key: "image",
          class: "v-card__image"
        }, [a.image ? y(Ae, {
          key: "image-defaults",
          disabled: !e.image,
          defaults: {
            VImg: {
              cover: !0,
              src: e.image
            }
          }
        }, a.image) : y(sa, {
          key: "image-img",
          cover: !0,
          src: e.image
        }, null)]), y(oi, {
          name: "v-card",
          active: !!e.loading,
          color: w.value
        }, {
          default: a.loader
        }), M && y(ib, {
          key: "item",
          prependAvatar: e.prependAvatar,
          prependIcon: e.prependIcon,
          title: e.title,
          subtitle: e.subtitle,
          appendAvatar: e.appendAvatar,
          appendIcon: e.appendIcon
        }, {
          default: a.item,
          prepend: a.prepend,
          title: a.title,
          subtitle: a.subtitle,
          append: a.append
        }), L && y(ob, {
          key: "text"
        }, {
          default: () => [a.text?.() ?? e.text]
        }), a.default?.(), a.actions && y(ab, null, {
          default: a.actions
        }), fa(I, "v-card")]
      }), [[Ht, I && e.ripple]]);
    }), {};
  }
}), YP = (e) => {
  const {
    touchstartX: t,
    touchendX: n,
    touchstartY: a,
    touchendY: r
  } = e, l = 0.5, i = 16;
  e.offsetX = n - t, e.offsetY = r - a, Math.abs(e.offsetY) < l * Math.abs(e.offsetX) && (e.left && n < t - i && e.left(e), e.right && n > t + i && e.right(e)), Math.abs(e.offsetX) < l * Math.abs(e.offsetY) && (e.up && r < a - i && e.up(e), e.down && r > a + i && e.down(e));
};
function KP(e, t) {
  const n = e.changedTouches[0];
  t.touchstartX = n.clientX, t.touchstartY = n.clientY, t.start?.({
    originalEvent: e,
    ...t
  });
}
function ZP(e, t) {
  const n = e.changedTouches[0];
  t.touchendX = n.clientX, t.touchendY = n.clientY, t.end?.({
    originalEvent: e,
    ...t
  }), YP(t);
}
function JP(e, t) {
  const n = e.changedTouches[0];
  t.touchmoveX = n.clientX, t.touchmoveY = n.clientY, t.move?.({
    originalEvent: e,
    ...t
  });
}
function XP() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const t = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: e.left,
    right: e.right,
    up: e.up,
    down: e.down,
    start: e.start,
    move: e.move,
    end: e.end
  };
  return {
    touchstart: (n) => KP(n, t),
    touchend: (n) => ZP(n, t),
    touchmove: (n) => JP(n, t)
  };
}
function QP(e, t) {
  const n = t.value, a = n?.parent ? e.parentElement : e, r = n?.options ?? {
    passive: !0
  }, l = t.instance?.$.uid;
  if (!a || l === void 0) return;
  const i = XP(t.value);
  a._touchHandlers = a._touchHandlers ?? /* @__PURE__ */ Object.create(null), a._touchHandlers[l] = i, ng(i).forEach((o) => {
    a.addEventListener(o, i[o], r);
  });
}
function eV(e, t) {
  const n = t.value?.parent ? e.parentElement : e, a = t.instance?.$.uid;
  if (!n?._touchHandlers || a === void 0) return;
  const r = n._touchHandlers[a];
  ng(r).forEach((l) => {
    n.removeEventListener(l, r[l]);
  }), delete n._touchHandlers[a];
}
const mo = {
  mounted: QP,
  unmounted: eV
}, sb = /* @__PURE__ */ Symbol.for("vuetify:v-window"), ub = /* @__PURE__ */ Symbol.for("vuetify:v-window-group"), Jo = U({
  continuous: Boolean,
  nextIcon: {
    type: [Boolean, String, Function, Object],
    default: "$next"
  },
  prevIcon: {
    type: [Boolean, String, Function, Object],
    default: "$prev"
  },
  reverse: Boolean,
  showArrows: {
    type: [Boolean, String],
    validator: (e) => typeof e == "boolean" || e === "hover"
  },
  verticalArrows: [Boolean, String],
  touch: {
    type: [Object, Boolean],
    default: void 0
  },
  direction: {
    type: String,
    default: "horizontal"
  },
  modelValue: null,
  disabled: Boolean,
  selectedClass: {
    type: String,
    default: "v-window-item--active"
  },
  // TODO: mandatory should probably not be exposed but do this for now
  mandatory: {
    type: [Boolean, String],
    default: "force"
  },
  crossfade: Boolean,
  transitionDuration: Number,
  ...ve(),
  ...Ie(),
  ...Re()
}, "VWindow"), tr = K()({
  name: "VWindow",
  directives: {
    vTouch: mo
  },
  props: Jo(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: a
    } = Ge(e), {
      isRtl: r
    } = At(), {
      t: l
    } = Ke(), i = Na(e, ub), o = G(), s = T(() => r.value ? !e.reverse : e.reverse), u = ae(!1), c = T(() => {
      if (e.crossfade)
        return "v-window-crossfade-transition";
      const p = e.direction === "vertical" ? "y" : "x", k = (s.value ? !u.value : u.value) ? "-reverse" : "";
      return `v-window-${p}${k}-transition`;
    }), d = ae(0), f = G(void 0), v = T(() => i.items.value.findIndex((p) => i.selected.value.includes(p.id)));
    ne(v, (p, x) => {
      let k;
      const V = {
        left: 0,
        top: 0
      };
      wt && x >= 0 && (k = No(o.value), V.left = k?.scrollLeft, V.top = k?.scrollTop);
      const A = i.items.value.length, M = A - 1;
      A <= 2 ? u.value = p < x : p === M && x === 0 ? u.value = !1 : p === 0 && x === M ? u.value = !0 : u.value = p < x, Se(() => {
        if (!wt || !k) return;
        k.scrollTop !== V.top && k.scrollTo({
          ...V,
          behavior: "instant"
        }), requestAnimationFrame(() => {
          if (!k) return;
          k.scrollTop !== V.top && k.scrollTo({
            ...V,
            behavior: "instant"
          });
        });
      });
    }, {
      flush: "sync"
    }), st(sb, {
      transition: c,
      isReversed: u,
      transitionCount: d,
      transitionHeight: f,
      rootRef: o
    });
    const g = D(() => e.continuous || v.value !== 0), m = D(() => e.continuous || v.value !== i.items.value.length - 1);
    function h() {
      g.value && i.prev();
    }
    function w() {
      m.value && i.next();
    }
    const _ = T(() => {
      const p = [], x = {
        icon: r.value ? e.nextIcon : e.prevIcon,
        class: `v-window__${s.value ? "right" : "left"}`,
        onClick: i.prev,
        "aria-label": l("$vuetify.carousel.prev")
      };
      p.push(g.value ? n.prev ? n.prev({
        props: x
      }) : y(De, x, null) : S("div", null, null));
      const k = {
        icon: r.value ? e.prevIcon : e.nextIcon,
        class: `v-window__${s.value ? "left" : "right"}`,
        onClick: i.next,
        "aria-label": l("$vuetify.carousel.next")
      };
      return p.push(m.value ? n.next ? n.next({
        props: k
      }) : y(De, k, null) : S("div", null, null)), p;
    }), I = T(() => e.touch === !1 ? e.touch : {
      ...{
        left: () => {
          s.value ? h() : w();
        },
        right: () => {
          s.value ? w() : h();
        },
        start: (x) => {
          let {
            originalEvent: k
          } = x;
          k.stopPropagation();
        }
      },
      ...e.touch === !0 ? {} : e.touch
    });
    function C(p) {
      (e.direction === "horizontal" && p.key === "ArrowLeft" || e.direction === "vertical" && p.key === "ArrowUp") && (p.preventDefault(), h(), Se(() => {
        g.value ? b(0) : b(1);
      })), (e.direction === "horizontal" && p.key === "ArrowRight" || e.direction === "vertical" && p.key === "ArrowDown") && (p.preventDefault(), w(), Se(() => {
        m.value ? b(1) : b(0);
      }));
    }
    function b(p) {
      const x = _.value[p];
      if (!x) return;
      (Array.isArray(x) ? x[0] : x).el?.focus();
    }
    return X(() => at(y(e.tag, {
      ref: o,
      class: J(["v-window", {
        "v-window--show-arrows-on-hover": e.showArrows === "hover",
        "v-window--vertical-arrows": !!e.verticalArrows,
        "v-window--crossfade": !!e.crossfade
      }, a.value, e.class]),
      style: le([e.style, {
        "--v-window-transition-duration": Gn() ? null : re(e.transitionDuration, "ms")
      }])
    }, {
      default: () => [S("div", {
        class: "v-window__container",
        style: {
          height: f.value
        }
      }, [n.default?.({
        group: i
      }), e.showArrows !== !1 && S("div", {
        class: J(["v-window__controls", {
          "v-window__controls--left": e.verticalArrows === "left" || e.verticalArrows === !0
        }, {
          "v-window__controls--right": e.verticalArrows === "right"
        }]),
        onKeydown: C
      }, [_.value])]), n.additional?.({
        group: i
      })]
    }), [[mo, I.value]])), {
      group: i
    };
  }
}), tV = U({
  color: String,
  cycle: Boolean,
  delimiterIcon: {
    type: be,
    default: "$delimiter"
  },
  height: {
    type: [Number, String],
    default: 500
  },
  hideDelimiters: Boolean,
  hideDelimiterBackground: Boolean,
  interval: {
    type: [Number, String],
    default: 6e3,
    validator: (e) => Number(e) > 0
  },
  progress: [Boolean, String],
  verticalDelimiters: [Boolean, String],
  ...Jo({
    continuous: !0,
    mandatory: "force",
    showArrows: !0
  })
}, "VCarousel"), nV = K()({
  name: "VCarousel",
  props: tV(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = he(e, "modelValue"), {
      t: r
    } = Ke(), l = G();
    let i = -1;
    ne(a, s), ne(() => e.interval, s), ne(() => e.cycle, (c) => {
      c ? s() : window.clearTimeout(i);
    }), bt(o);
    function o() {
      !e.cycle || !l.value || (i = window.setTimeout(l.value.group.next, Number(e.interval) > 0 ? Number(e.interval) : 6e3));
    }
    function s() {
      window.clearTimeout(i), window.requestAnimationFrame(o);
    }
    function u(c, d) {
      (e.direction === "horizontal" && c.key === "ArrowLeft" || e.direction === "vertical" && c.key === "ArrowUp") && (c.preventDefault(), d.prev(), Se(() => l.value?.$el.querySelector(".v-btn--active")?.focus())), (e.direction === "horizontal" && c.key === "ArrowRight" || e.direction === "vertical" && c.key === "ArrowDown") && (c.preventDefault(), d.next(), Se(() => l.value?.$el.querySelector(".v-btn--active")?.focus()));
    }
    return X(() => {
      const c = tr.filterProps(e);
      return y(tr, Y({
        ref: l
      }, c, {
        modelValue: a.value,
        "onUpdate:modelValue": (d) => a.value = d,
        class: ["v-carousel", {
          "v-carousel--hide-delimiter-background": e.hideDelimiterBackground,
          "v-carousel--vertical-delimiters": e.verticalDelimiters
        }, e.class],
        style: [{
          height: re(e.height)
        }, e.style]
      }), {
        default: n.default,
        additional: (d) => {
          let {
            group: f
          } = d;
          return S(fe, null, [!e.hideDelimiters && S("div", {
            class: "v-carousel__controls",
            style: {
              left: e.verticalDelimiters === "left" && e.verticalDelimiters ? 0 : "auto",
              right: e.verticalDelimiters === "right" ? 0 : "auto"
            }
          }, [f.items.value.length > 0 && y(Ae, {
            defaults: {
              VBtn: {
                color: e.color,
                icon: e.delimiterIcon,
                size: "x-small",
                variant: "text"
              }
            },
            scoped: !0
          }, {
            default: () => [f.items.value.map((v, g) => {
              const m = {
                id: `carousel-item-${v.id}`,
                "aria-label": r("$vuetify.carousel.ariaLabel.delimiter", g + 1, f.items.value.length),
                class: ["v-carousel__controls__item", f.isSelected(v.id) && "v-btn--active"],
                onClick: () => f.select(v.id, !0),
                onKeydown: (h) => u(h, f)
              };
              return n.item ? n.item({
                props: m,
                item: v
              }) : y(De, Y(v, m), null);
            })]
          })]), e.progress && y(Uo, {
            absolute: !0,
            class: "v-carousel__progress",
            color: typeof e.progress == "string" ? e.progress : void 0,
            modelValue: (f.getItemIndex(a.value) + 1) / f.items.value.length * 100
          }, null)]);
        },
        prev: n.prev,
        next: n.next
      });
    }), {};
  }
}), Xo = U({
  reverseTransition: {
    type: [Boolean, String],
    default: void 0
  },
  transition: {
    type: [Boolean, String],
    default: void 0
  },
  ...ve(),
  ...mr(),
  ...Kc()
}, "VWindowItem"), nr = K()({
  name: "VWindowItem",
  directives: {
    vTouch: mo
  },
  props: Xo(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = Le(sb), r = Ia(e, ub), {
      isBooted: l
    } = fr();
    if (!a || !r) throw new Error("[Vuetify] VWindowItem must be used inside VWindow");
    const i = ae(!1), o = T(() => l.value && (a.isReversed.value ? e.reverseTransition !== !1 : e.transition !== !1));
    function s() {
      !i.value || !a || (i.value = !1, a.transitionCount.value > 0 && (a.transitionCount.value -= 1, a.transitionCount.value === 0 && (a.transitionHeight.value = void 0)));
    }
    function u() {
      i.value || !a || (i.value = !0, a.transitionCount.value === 0 && (a.transitionHeight.value = re(a.rootRef.value?.clientHeight)), a.transitionCount.value += 1);
    }
    function c() {
      s();
    }
    function d(g) {
      i.value && Se(() => {
        !o.value || !i.value || !a || (a.transitionHeight.value = re(g.clientHeight));
      });
    }
    const f = T(() => {
      const g = a.isReversed.value ? e.reverseTransition : e.transition;
      return o.value ? {
        name: typeof g != "string" ? a.transition.value : g,
        onBeforeEnter: u,
        onAfterEnter: s,
        onEnterCancelled: c,
        onBeforeLeave: u,
        onAfterLeave: s,
        onLeaveCancelled: c,
        onEnter: d
      } : !1;
    }), {
      hasContent: v
    } = Zc(e, r.isSelected);
    return X(() => y(Xt, {
      transition: f.value,
      disabled: !l.value
    }, {
      default: () => [at(S("div", {
        class: J(["v-window-item", r.selectedClass.value, e.class]),
        style: le(e.style)
      }, [v.value && n.default?.()]), [[Wn, r.isSelected.value]])]
    })), {
      groupItem: r
    };
  }
}), aV = U({
  ...Cg(),
  ...Xo()
}, "VCarouselItem"), rV = K()({
  name: "VCarouselItem",
  inheritAttrs: !1,
  props: aV(),
  setup(e, t) {
    let {
      slots: n,
      attrs: a
    } = t;
    X(() => {
      const r = sa.filterProps(e), l = nr.filterProps(e);
      return y(nr, Y({
        class: ["v-carousel-item", e.class]
      }, l), {
        default: () => [y(sa, Y(a, r), n)]
      });
    });
  }
}), lV = ca("v-code", "code"), iV = U({
  color: {
    type: Object
  },
  disabled: Boolean,
  readonly: Boolean,
  dotSize: {
    type: [Number, String],
    default: 10
  },
  height: {
    type: [Number, String],
    default: 150
  },
  width: {
    type: [Number, String],
    default: 300
  },
  ...ve()
}, "VColorPickerCanvas"), oV = rn({
  name: "VColorPickerCanvas",
  props: iV(),
  emits: {
    "update:color": (e) => !0,
    "update:position": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    const a = ae(!1), r = G(), l = ae(parseFloat(e.width)), i = ae(parseFloat(e.height)), o = G({
      x: 0,
      y: 0
    }), s = D(() => !e.disabled && !e.readonly), u = T({
      get: () => o.value,
      set(w) {
        if (!r.value) return;
        const {
          x: _,
          y: I
        } = w;
        o.value = w, n("update:color", {
          h: e.color?.h ?? 0,
          s: Xe(_, 0, l.value) / l.value,
          v: 1 - Xe(I, 0, i.value) / i.value,
          a: e.color?.a ?? 1
        });
      }
    }), c = T(() => {
      const {
        x: w,
        y: _
      } = u.value, I = parseInt(e.dotSize, 10) / 2;
      return {
        width: re(e.dotSize),
        height: re(e.dotSize),
        transform: `translate(${re(w - I)}, ${re(_ - I)})`
      };
    }), {
      resizeRef: d
    } = Vn((w) => {
      if (!d.el?.offsetParent) return;
      const {
        width: _,
        height: I
      } = w[0].contentRect;
      l.value = Math.round(_), i.value = Math.round(I);
    });
    function f(w, _, I) {
      const {
        left: C,
        top: b,
        width: p,
        height: x
      } = I;
      u.value = {
        x: Xe(w - C, 0, p),
        y: Xe(_ - b, 0, x)
      };
    }
    function v(w) {
      w.type === "mousedown" && w.preventDefault(), s.value && (g(w), window.addEventListener("mousemove", g), window.addEventListener("mouseup", m), window.addEventListener("touchmove", g), window.addEventListener("touchend", m));
    }
    function g(w) {
      if (!s.value || !r.value) return;
      a.value = !0;
      const _ = d_(w);
      f(_.clientX, _.clientY, r.value.getBoundingClientRect());
    }
    function m() {
      window.removeEventListener("mousemove", g), window.removeEventListener("mouseup", m), window.removeEventListener("touchmove", g), window.removeEventListener("touchend", m);
    }
    function h() {
      if (!r.value) return;
      const w = r.value, _ = w.getContext("2d");
      if (!_) return;
      const I = _.createLinearGradient(0, 0, w.width, 0);
      I.addColorStop(0, "hsla(0, 0%, 100%, 1)"), I.addColorStop(1, `hsla(${e.color?.h ?? 0}, 100%, 50%, 1)`), _.fillStyle = I, _.fillRect(0, 0, w.width, w.height);
      const C = _.createLinearGradient(0, 0, 0, w.height);
      C.addColorStop(0, "hsla(0, 0%, 0%, 0)"), C.addColorStop(1, "hsla(0, 0%, 0%, 1)"), _.fillStyle = C, _.fillRect(0, 0, w.width, w.height);
    }
    return ne(() => e.color?.h, h, {
      immediate: !0
    }), ne(() => [l.value, i.value], (w, _) => {
      h(), o.value = {
        x: u.value.x * w[0] / _[0],
        y: u.value.y * w[1] / _[1]
      };
    }, {
      flush: "post"
    }), ne(() => e.color, () => {
      if (a.value) {
        a.value = !1;
        return;
      }
      o.value = e.color ? {
        x: e.color.s * l.value,
        y: (1 - e.color.v) * i.value
      } : {
        x: 0,
        y: 0
      };
    }, {
      deep: !0,
      immediate: !0
    }), bt(() => h()), X(() => S("div", {
      ref: d,
      class: J(["v-color-picker-canvas", e.class]),
      style: le(e.style),
      onMousedown: v,
      onTouchstartPassive: v
    }, [S("canvas", {
      ref: r,
      width: l.value,
      height: i.value
    }, null), e.color && S("div", {
      class: J(["v-color-picker-canvas__dot", {
        "v-color-picker-canvas__dot--disabled": e.disabled
      }]),
      style: le(c.value)
    }, null)])), {};
  }
});
function sV(e, t) {
  if (t) {
    const {
      a: n,
      ...a
    } = e;
    return a;
  }
  return e;
}
function uV(e, t) {
  if (t == null || typeof t == "string") {
    const n = typeof e.a == "number" && e.a < 1;
    if (t?.startsWith("rgb(")) {
      const {
        r,
        g: l,
        b: i,
        a: o
      } = qn(e);
      return `rgb(${r} ${l} ${i}` + (n ? ` / ${o})` : ")");
    } else if (t?.startsWith("hsl(")) {
      const {
        h: r,
        s: l,
        l: i,
        a: o
      } = cu(e);
      return `hsl(${r} ${Math.round(l * 100)} ${Math.round(i * 100)}` + (n ? ` / ${o})` : ")");
    }
    const a = mg(e);
    return e.a === 1 ? a.slice(0, 7) : a;
  }
  if (typeof t == "object") {
    let n;
    return ja(t, ["r", "g", "b"]) ? n = qn(e) : ja(t, ["h", "s", "l"]) ? n = cu(e) : ja(t, ["h", "s", "v"]) && (n = e), sV(n, !ja(t, ["a"]) && e.a === 1);
  }
  return e;
}
const Or = {
  h: 0,
  s: 0,
  v: 0,
  a: 1
}, Au = {
  inputProps: {
    type: "number",
    min: 0
  },
  inputs: [{
    label: "R",
    max: 255,
    step: 1,
    getValue: (e) => Math.round(e.r),
    getColor: (e, t) => ({
      ...e,
      r: Number(t)
    }),
    localeKey: "redInput"
  }, {
    label: "G",
    max: 255,
    step: 1,
    getValue: (e) => Math.round(e.g),
    getColor: (e, t) => ({
      ...e,
      g: Number(t)
    }),
    localeKey: "greenInput"
  }, {
    label: "B",
    max: 255,
    step: 1,
    getValue: (e) => Math.round(e.b),
    getColor: (e, t) => ({
      ...e,
      b: Number(t)
    }),
    localeKey: "blueInput"
  }, {
    label: "A",
    max: 1,
    step: 0.01,
    getValue: (e) => {
      let {
        a: t
      } = e;
      return t != null ? Math.round(t * 100) / 100 : 1;
    },
    getColor: (e, t) => ({
      ...e,
      a: Number(t)
    }),
    localeKey: "alphaInput"
  }],
  to: qn,
  from: ri
}, cV = {
  ...Au,
  inputs: Au.inputs?.slice(0, 3)
}, Pu = {
  inputProps: {
    type: "number",
    min: 0
  },
  inputs: [{
    label: "H",
    max: 360,
    step: 1,
    getValue: (e) => Math.round(e.h),
    getColor: (e, t) => ({
      ...e,
      h: Number(t)
    }),
    localeKey: "hueInput"
  }, {
    label: "S",
    max: 1,
    step: 0.01,
    getValue: (e) => Math.round(e.s * 100) / 100,
    getColor: (e, t) => ({
      ...e,
      s: Number(t)
    }),
    localeKey: "saturationInput"
  }, {
    label: "L",
    max: 1,
    step: 0.01,
    getValue: (e) => Math.round(e.l * 100) / 100,
    getColor: (e, t) => ({
      ...e,
      l: Number(t)
    }),
    localeKey: "lightnessInput"
  }, {
    label: "A",
    max: 1,
    step: 0.01,
    getValue: (e) => {
      let {
        a: t
      } = e;
      return t != null ? Math.round(t * 100) / 100 : 1;
    },
    getColor: (e, t) => ({
      ...e,
      a: Number(t)
    }),
    localeKey: "alphaInput"
  }],
  to: cu,
  from: Tc
}, dV = {
  ...Pu,
  inputs: Pu.inputs.slice(0, 3)
}, cb = {
  inputProps: {
    type: "text"
  },
  inputs: [{
    label: "HEXA",
    getValue: (e) => e,
    getColor: (e, t) => t,
    localeKey: "hexaInput"
  }],
  to: mg,
  from: D_
}, fV = {
  ...cb,
  inputs: [{
    label: "HEX",
    getValue: (e) => e.slice(0, 7),
    getColor: (e, t) => t,
    localeKey: "hexInput"
  }]
}, Ja = {
  rgb: cV,
  rgba: Au,
  hsl: dV,
  hsla: Pu,
  hex: fV,
  hexa: cb
}, vV = (e) => {
  let {
    label: t,
    ...n
  } = e;
  return S("div", {
    class: "v-color-picker-edit__input"
  }, [S("input", am(rm(n)), null), S("span", null, [t])]);
}, mV = U({
  color: Object,
  disabled: Boolean,
  readonly: Boolean,
  mode: {
    type: String,
    default: "rgba",
    validator: (e) => Object.keys(Ja).includes(e)
  },
  modes: {
    type: Array,
    default: () => Object.keys(Ja),
    validator: (e) => Array.isArray(e) && e.every((t) => Object.keys(Ja).includes(t))
  },
  ...ve()
}, "VColorPickerEdit"), hV = rn({
  name: "VColorPickerEdit",
  props: mV(),
  emits: {
    "update:color": (e) => !0,
    "update:mode": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    const {
      t: a
    } = Ke(), r = T(() => e.modes.map((i) => ({
      ...Ja[i],
      name: i
    }))), l = T(() => {
      const i = r.value.find((s) => s.name === e.mode);
      if (!i) return [];
      const o = e.color ? i.to(e.color) : null;
      return i.inputs?.map((s) => {
        let {
          getValue: u,
          getColor: c,
          localeKey: d,
          ...f
        } = s;
        return {
          ...i.inputProps,
          ...f,
          ariaLabel: a(`$vuetify.colorPicker.ariaLabel.${d}`),
          disabled: e.disabled,
          readonly: e.readonly,
          value: o && u(o),
          onChange: (v) => {
            const g = v.target;
            g && n("update:color", i.from(c(o ?? i.to(Or), g.value)));
          }
        };
      });
    });
    return X(() => S("div", {
      class: J(["v-color-picker-edit", e.class]),
      style: le(e.style)
    }, [l.value?.map((i) => y(vV, i, null)), r.value.length > 1 && y(De, {
      icon: "$unfold",
      size: "x-small",
      variant: "plain",
      "aria-label": a("$vuetify.colorPicker.ariaLabel.changeFormat"),
      onClick: () => {
        const i = r.value.findIndex((o) => o.name === e.mode);
        n("update:mode", r.value[(i + 1) % r.value.length].name);
      }
    }, null)])), {};
  }
}), cd = /* @__PURE__ */ Symbol.for("vuetify:v-slider");
function Vu(e, t, n) {
  const a = n === "vertical", r = t.getBoundingClientRect(), l = "touches" in e ? e.touches[0] : e;
  return a ? l.clientY - (r.top + r.height / 2) : l.clientX - (r.left + r.width / 2);
}
function gV(e, t) {
  return "touches" in e && e.touches.length ? e.touches[0][t] : "changedTouches" in e && e.changedTouches.length ? e.changedTouches[0][t] : e[t];
}
const db = U({
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  readonly: {
    type: Boolean,
    default: null
  },
  max: {
    type: [Number, String],
    default: 100
  },
  min: {
    type: [Number, String],
    default: 0
  },
  step: {
    type: [Number, String],
    default: 0
  },
  thumbColor: String,
  thumbLabel: {
    type: [Boolean, String],
    default: void 0,
    validator: (e) => typeof e == "boolean" || e === "always" || e === "hover"
  },
  thumbSize: {
    type: [Number, String],
    default: 20
  },
  showTicks: {
    type: [Boolean, String],
    default: !1,
    validator: (e) => typeof e == "boolean" || e === "always"
  },
  ticks: {
    type: [Array, Object]
  },
  tickSize: {
    type: [Number, String],
    default: 2
  },
  color: String,
  trackColor: String,
  trackFillColor: String,
  trackSize: {
    type: [Number, String],
    default: 4
  },
  direction: {
    type: String,
    default: "horizontal",
    validator: (e) => ["vertical", "horizontal"].includes(e)
  },
  reverse: Boolean,
  noKeyboard: Boolean,
  ...lt(),
  ...Ct({
    elevation: 2
  }),
  ripple: {
    type: Boolean,
    default: !0
  }
}, "Slider"), fb = (e) => {
  const t = T(() => parseFloat(e.min)), n = T(() => parseFloat(e.max)), a = T(() => Number(e.step) > 0 ? parseFloat(e.step) : 0), r = T(() => Math.max(Xf(a.value), Xf(t.value)));
  function l(i) {
    if (i = parseFloat(i), a.value <= 0) return i;
    const o = Xe(i, t.value, n.value), s = t.value % a.value;
    let u = Math.round((o - s) / a.value) * a.value + s;
    return o > u && u + a.value > n.value && (u = n.value), parseFloat(Math.min(u, n.value).toFixed(r.value));
  }
  return {
    min: t,
    max: n,
    step: a,
    decimals: r,
    roundValue: l
  };
}, vb = (e) => {
  let {
    props: t,
    steps: n,
    onSliderStart: a,
    onSliderMove: r,
    onSliderEnd: l,
    getActiveThumb: i
  } = e;
  const o = ul(t), {
    isRtl: s
  } = At(), u = D(() => t.reverse), c = T(() => t.direction === "vertical"), d = T(() => c.value !== u.value), {
    min: f,
    max: v,
    step: g,
    decimals: m,
    roundValue: h
  } = n, w = T(() => parseInt(t.thumbSize, 10)), _ = T(() => parseInt(t.tickSize, 10)), I = T(() => parseInt(t.trackSize, 10)), C = T(() => (v.value - f.value) / g.value), b = T(() => t.error || o.isDisabled.value ? void 0 : t.thumbColor ?? t.color), p = T(() => t.error || o.isDisabled.value ? void 0 : t.thumbColor), x = T(() => t.error || o.isDisabled.value ? void 0 : t.trackColor ?? t.color), k = T(() => t.error || o.isDisabled.value ? void 0 : t.trackFillColor ?? t.color), V = ae(!1), A = ae(0), M = G(), L = G();
  function E(Q) {
    const ie = M.value?.$el;
    if (!ie) return;
    const ke = t.direction === "vertical", ye = ke ? "top" : "left", ue = ke ? "height" : "width", Te = ke ? "clientY" : "clientX", {
      [ye]: Ne,
      [ue]: je
    } = ie.getBoundingClientRect(), xe = gV(Q, Te);
    let Be = Xe((xe - Ne - A.value) / je) || 0;
    return (ke ? d.value : d.value !== s.value) && (Be = 1 - Be), h(f.value + Be * (v.value - f.value));
  }
  const P = (Q) => {
    const ie = E(Q);
    ie != null && l({
      value: ie
    }), V.value = !1, A.value = 0;
  }, O = (Q) => {
    const ie = E(Q);
    L.value = i(Q), L.value && (V.value = !0, L.value.contains(Q.target) ? A.value = Vu(Q, L.value, t.direction) : (A.value = 0, ie != null && r({
      value: ie
    })), ie != null && a({
      value: ie
    }), Se(() => L.value?.focus()));
  }, F = {
    passive: !0,
    capture: !0
  };
  function B(Q) {
    const ie = E(Q);
    ie != null && r({
      value: ie
    });
  }
  function N(Q) {
    Q.stopPropagation(), Q.preventDefault(), P(Q), window.removeEventListener("mousemove", B, F), window.removeEventListener("mouseup", N);
  }
  function W(Q) {
    P(Q), window.removeEventListener("touchmove", B, F), Q.target?.removeEventListener("touchend", W);
  }
  function R(Q) {
    O(Q), window.addEventListener("touchmove", B, F), Q.target?.addEventListener("touchend", W, {
      passive: !1
    });
  }
  function j(Q) {
    Q.button === 0 && (Q.preventDefault(), O(Q), window.addEventListener("mousemove", B, F), window.addEventListener("mouseup", N, {
      passive: !1
    }));
  }
  It(() => {
    window.removeEventListener("touchmove", B), window.removeEventListener("mousemove", B), window.removeEventListener("mouseup", N);
  });
  const H = (Q) => {
    const ie = (Q - f.value) / (v.value - f.value) * 100;
    return Xe(isNaN(ie) ? 0 : ie, 0, 100);
  }, $ = D(() => t.showTicks), z = T(() => $.value ? t.ticks ? Array.isArray(t.ticks) ? t.ticks.map((Q) => ({
    value: Q,
    position: H(Q),
    label: Q.toString()
  })) : Object.keys(t.ticks).map((Q) => ({
    value: parseFloat(Q),
    position: H(parseFloat(Q)),
    label: t.ticks[Q]
  })) : C.value !== 1 / 0 ? ka(C.value + 1).map((Q) => {
    const ie = f.value + Q * g.value;
    return {
      value: ie,
      position: H(ie)
    };
  }) : [] : []), te = T(() => z.value.some((Q) => {
    let {
      label: ie
    } = Q;
    return !!ie;
  })), me = {
    activeThumbRef: L,
    color: D(() => t.color),
    decimals: m,
    disabled: o.isDisabled,
    direction: D(() => t.direction),
    elevation: D(() => t.elevation),
    hasLabels: te,
    isReversed: u,
    indexFromEnd: d,
    min: f,
    max: v,
    mousePressed: V,
    noKeyboard: D(() => t.noKeyboard),
    numTicks: C,
    onSliderMousedown: j,
    onSliderTouchstart: R,
    parsedTicks: z,
    parseMouseMove: E,
    position: H,
    readonly: o.isReadonly,
    rounded: D(() => t.rounded),
    roundValue: h,
    showTicks: $,
    startOffset: A,
    step: g,
    thumbSize: w,
    thumbColor: b,
    thumbLabelColor: p,
    thumbLabel: D(() => t.thumbLabel),
    ticks: D(() => t.ticks),
    tickSize: _,
    trackColor: x,
    trackContainerRef: M,
    trackFillColor: k,
    trackSize: I,
    vertical: c
  };
  return st(cd, me), me;
}, yV = U({
  focused: Boolean,
  max: {
    type: Number,
    required: !0
  },
  min: {
    type: Number,
    required: !0
  },
  modelValue: {
    type: Number,
    required: !0
  },
  position: {
    type: Number,
    required: !0
  },
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  name: String,
  noKeyboard: Boolean,
  ...ve()
}, "VSliderThumb"), Eu = K()({
  name: "VSliderThumb",
  directives: {
    vRipple: Ht
  },
  props: yV(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n,
      emit: a
    } = t;
    const r = Le(cd), {
      isRtl: l,
      rtlClasses: i
    } = At();
    if (!r) throw new Error("[Vuetify] v-slider-thumb must be used inside v-slider or v-range-slider");
    const {
      min: o,
      max: s,
      thumbColor: u,
      thumbLabelColor: c,
      step: d,
      disabled: f,
      thumbSize: v,
      thumbLabel: g,
      direction: m,
      isReversed: h,
      vertical: w,
      readonly: _,
      elevation: I,
      mousePressed: C,
      decimals: b,
      indexFromEnd: p
    } = r, x = ae(!1), k = ae(!1), V = T(() => f.value ? void 0 : I.value), {
      elevationClasses: A
    } = Et(V), {
      textColorClasses: M,
      textColorStyles: L
    } = Nt(u), {
      backgroundColorClasses: E,
      backgroundColorStyles: P
    } = qe(c), {
      pageup: O,
      pagedown: F,
      end: B,
      home: N,
      left: W,
      right: R,
      down: j,
      up: H
    } = lu, $ = [O, F, B, N, W, R, j, H], z = T(() => d.value ? [1, 2, 3] : [1, 5, 10]);
    function te(Q, ie) {
      if (e.noKeyboard || f.value || !$.includes(Q.key)) return;
      Q.preventDefault();
      const ke = d.value || 0.1, ye = (s.value - o.value) / ke;
      if ([W, R, j, H].includes(Q.key)) {
        const Te = (w.value ? [l.value ? W : R, h.value ? j : H] : p.value !== l.value ? [W, H] : [R, H]).includes(Q.key) ? 1 : -1, Ne = Q.shiftKey ? 2 : Q.ctrlKey ? 1 : 0;
        Te === -1 && ie === s.value && !Ne && !Number.isInteger(ye) ? ie = ie - ye % 1 * ke : ie = ie + Te * ke * z.value[Ne];
      } else if (Q.key === N)
        ie = o.value;
      else if (Q.key === B)
        ie = s.value;
      else {
        const ue = Q.key === F ? 1 : -1;
        ie = ie - ue * ke * (ye > 100 ? ye / 10 : 10);
      }
      return Math.max(e.min, Math.min(e.max, ie));
    }
    function me(Q) {
      const ie = te(Q, e.modelValue);
      ie != null && (k.value = !1, a("update:modelValue", ie));
    }
    return ne(() => e.focused, (Q) => {
      Q && (k.value = !1);
    }), X(() => {
      const Q = re(p.value ? 100 - e.position : e.position, "%"), ie = g.value === "always" || g.value === !0 && e.focused || g.value === "hover" && (x.value || e.focused && !k.value);
      return S("div", {
        class: J(["v-slider-thumb", {
          "v-slider-thumb--focused": e.focused,
          "v-slider-thumb--pressed": e.focused && C.value
        }, e.class, i.value]),
        style: le([{
          "--v-slider-thumb-position": Q,
          "--v-slider-thumb-size": re(v.value)
        }, e.style]),
        role: "slider",
        tabindex: f.value ? -1 : 0,
        "aria-label": e.name,
        "aria-valuemin": o.value,
        "aria-valuemax": s.value,
        "aria-valuenow": e.modelValue,
        "aria-readonly": !!_.value,
        "aria-orientation": m.value,
        onKeydown: _.value ? void 0 : me,
        onMouseenter: () => {
          x.value = !0;
        },
        onMouseleave: () => {
          x.value = !1, k.value = !0;
        }
      }, [S("div", {
        class: J(["v-slider-thumb__surface", M.value, A.value]),
        style: le(L.value)
      }, null), at(S("div", {
        class: J(["v-slider-thumb__ripple", M.value]),
        style: le(L.value)
      }, null), [[Ht, e.ripple, null, {
        circle: !0,
        center: !0
      }]]), y(Mc, {
        origin: "bottom center"
      }, {
        default: () => [at(S("div", {
          class: "v-slider-thumb__label-container"
        }, [S("div", {
          class: J(["v-slider-thumb__label", E.value]),
          style: le(P.value)
        }, [S("div", null, [n["thumb-label"]?.({
          modelValue: e.modelValue
        }) ?? e.modelValue.toFixed(d.value ? b.value : 1)]), S("div", {
          class: "v-slider-thumb__label-wedge"
        }, null)])]), [[Wn, ie]])]
      })]);
    }), {};
  }
}), bV = U({
  start: {
    type: Number,
    required: !0
  },
  stop: {
    type: Number,
    required: !0
  },
  ...ve()
}, "VSliderTrack"), mb = K()({
  name: "VSliderTrack",
  props: bV(),
  emits: {},
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = Le(cd);
    if (!a) throw new Error("[Vuetify] v-slider-track must be inside v-slider or v-range-slider");
    const {
      color: r,
      parsedTicks: l,
      rounded: i,
      showTicks: o,
      tickSize: s,
      trackColor: u,
      trackFillColor: c,
      trackSize: d,
      vertical: f,
      min: v,
      max: g,
      indexFromEnd: m
    } = a, {
      roundedClasses: h
    } = ut(i), {
      backgroundColorClasses: w,
      backgroundColorStyles: _
    } = qe(c), {
      backgroundColorClasses: I,
      backgroundColorStyles: C
    } = qe(u), b = T(() => `inset-${f.value ? "block" : "inline"}-${m.value ? "end" : "start"}`), p = T(() => f.value ? "height" : "width"), x = T(() => ({
      [b.value]: "0%",
      [p.value]: "100%"
    })), k = T(() => e.stop - e.start), V = T(() => ({
      [b.value]: re(e.start, "%"),
      [p.value]: re(k.value, "%")
    })), A = T(() => o.value ? (f.value ? l.value.slice().reverse() : l.value).map((L, E) => {
      const P = L.value !== v.value && L.value !== g.value ? re(L.position, "%") : void 0;
      return S("div", {
        key: L.value,
        class: J(["v-slider-track__tick", {
          "v-slider-track__tick--filled": L.position >= e.start && L.position <= e.stop,
          "v-slider-track__tick--first": L.value === v.value,
          "v-slider-track__tick--last": L.value === g.value
        }]),
        style: {
          [b.value]: P
        }
      }, [(L.label || n["tick-label"]) && S("div", {
        class: "v-slider-track__tick-label"
      }, [n["tick-label"]?.({
        tick: L,
        index: E
      }) ?? L.label])]);
    }) : []);
    return X(() => S("div", {
      class: J(["v-slider-track", h.value, e.class]),
      style: le([{
        "--v-slider-track-size": re(d.value),
        "--v-slider-tick-size": re(s.value)
      }, e.style])
    }, [S("div", {
      class: J(["v-slider-track__background", I.value, {
        "v-slider-track__background--opacity": !!r.value || !c.value
      }]),
      style: {
        ...x.value,
        ...C.value
      }
    }, null), S("div", {
      class: J(["v-slider-track__fill", w.value]),
      style: {
        ...V.value,
        ..._.value
      }
    }, null), o.value && S("div", {
      class: J(["v-slider-track__ticks", {
        "v-slider-track__ticks--always-show": o.value === "always"
      }])
    }, [A.value])])), {};
  }
}), pV = U({
  ...di(),
  ...db(),
  ...ha(),
  modelValue: {
    type: [Number, String],
    default: 0
  }
}, "VSlider"), Mu = K()({
  name: "VSlider",
  inheritAttrs: !1,
  props: pV(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    start: (e) => !0,
    end: (e) => !0
  },
  setup(e, t) {
    let {
      slots: n,
      emit: a,
      attrs: r
    } = t;
    const l = G(), i = G(), {
      rtlClasses: o
    } = At(), s = fb(e), u = he(e, "modelValue", void 0, (A) => s.roundValue(A ?? s.min.value)), {
      min: c,
      max: d,
      mousePressed: f,
      roundValue: v,
      onSliderMousedown: g,
      onSliderTouchstart: m,
      trackContainerRef: h,
      position: w,
      hasLabels: _,
      disabled: I,
      readonly: C,
      noKeyboard: b
    } = vb({
      props: e,
      steps: s,
      onSliderStart: () => {
        !I.value && !C.value && a("start", u.value);
      },
      onSliderEnd: (A) => {
        let {
          value: M
        } = A;
        const L = v(M);
        !I.value && !C.value && (u.value = L), a("end", L);
      },
      onSliderMove: (A) => {
        let {
          value: M
        } = A;
        !I.value && !C.value && (u.value = v(M));
      },
      getActiveThumb: () => l.value?.$el
    }), {
      isFocused: p,
      focus: x,
      blur: k
    } = ma(e), V = T(() => w(u.value));
    return X(() => {
      const A = Gt.filterProps(e), [M, L] = Jn(r), E = !!(e.label || n.label || n.prepend);
      return y(Gt, Y({
        ref: i,
        class: ["v-slider", {
          "v-slider--has-labels": !!n["tick-label"] || _.value,
          "v-slider--focused": p.value,
          "v-slider--pressed": f.value,
          "v-slider--disabled": I.value
        }, o.value, e.class],
        style: e.style
      }, A, M, {
        focused: p.value
      }), {
        ...n,
        prepend: E ? (P) => S(fe, null, [n.label?.(P) ?? (e.label ? y(sl, {
          id: P.id.value,
          class: "v-slider__label",
          text: e.label
        }, null) : void 0), n.prepend?.(P)]) : void 0,
        default: (P) => {
          let {
            id: O,
            messagesId: F
          } = P;
          return S("div", {
            class: "v-slider__container",
            onMousedown: C.value ? void 0 : g,
            onTouchstartPassive: C.value ? void 0 : m
          }, [S("input", {
            id: O.value,
            name: e.name || O.value,
            disabled: I.value,
            readonly: C.value,
            tabindex: "-1",
            value: u.value
          }, null), y(mb, {
            ref: h,
            start: 0,
            stop: V.value
          }, {
            "tick-label": n["tick-label"]
          }), y(Eu, Y({
            ref: l,
            "aria-describedby": F.value,
            focused: p.value,
            noKeyboard: b.value,
            min: c.value,
            max: d.value,
            modelValue: u.value,
            "onUpdate:modelValue": (B) => u.value = B,
            position: V.value,
            elevation: e.elevation,
            onFocus: x,
            onBlur: k,
            ripple: e.ripple,
            name: e.name
          }, L), {
            "thumb-label": n["thumb-label"]
          })]);
        }
      });
    }), Mt({
      focus: () => l.value?.$el.focus()
    }, i);
  }
}), hb = U({
  color: {
    type: Object
  },
  disabled: Boolean,
  readonly: Boolean,
  hideAlpha: Boolean,
  hideEyeDropper: Boolean,
  eyeDropperIcon: {
    type: be,
    default: "$eyeDropper"
  },
  ...ve()
}, "VColorPickerPreview"), wV = rn({
  name: "VColorPickerPreview",
  props: hb(),
  emits: {
    "update:color": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    const {
      t: a
    } = Ke(), r = new AbortController(), l = D(() => !e.disabled && !e.readonly);
    lm(() => r.abort());
    async function i() {
      if (!Kf || !l.value) return;
      const o = new window.EyeDropper();
      try {
        const s = await o.open({
          signal: r.signal
        }), u = ri(ra(s.sRGBHex));
        n("update:color", {
          ...e.color ?? Or,
          ...u
        });
      } catch {
      }
    }
    return X(() => S("div", {
      class: J(["v-color-picker-preview", {
        "v-color-picker-preview--hide-alpha": e.hideAlpha
      }, e.class]),
      style: le(e.style)
    }, [Kf && !e.hideEyeDropper && S("div", {
      class: "v-color-picker-preview__eye-dropper",
      key: "eyeDropper"
    }, [y(De, {
      "aria-label": a("$vuetify.colorPicker.ariaLabel.eyedropper"),
      density: "comfortable",
      disabled: e.disabled,
      readonly: e.readonly,
      icon: e.eyeDropperIcon,
      variant: "plain",
      onClick: i
    }, null)]), S("div", {
      class: "v-color-picker-preview__dot"
    }, [S("div", {
      style: {
        background: fg(e.color ?? Or)
      }
    }, null)]), S("div", {
      class: "v-color-picker-preview__sliders"
    }, [y(Mu, {
      class: "v-color-picker-preview__track v-color-picker-preview__hue",
      "aria-label": a("$vuetify.colorPicker.ariaLabel.hueSlider"),
      modelValue: e.color?.h,
      "onUpdate:modelValue": (o) => n("update:color", {
        ...e.color ?? Or,
        h: o
      }),
      step: 1,
      min: 0,
      max: 360,
      disabled: e.disabled,
      readonly: e.readonly,
      thumbSize: 14,
      trackSize: 8,
      trackFillColor: "white",
      hideDetails: !0
    }, null), !e.hideAlpha && y(Mu, {
      class: "v-color-picker-preview__track v-color-picker-preview__alpha",
      "aria-label": a("$vuetify.colorPicker.ariaLabel.alphaSlider"),
      modelValue: e.color?.a ?? 1,
      "onUpdate:modelValue": (o) => n("update:color", {
        ...e.color ?? Or,
        a: o
      }),
      step: 0.01,
      min: 0,
      max: 1,
      disabled: e.disabled,
      readonly: e.readonly,
      thumbSize: 14,
      trackSize: 8,
      trackFillColor: "white",
      hideDetails: !0
    }, null)])])), {};
  }
}), kV = {
  base: "#f44336",
  lighten5: "#ffebee",
  lighten4: "#ffcdd2",
  lighten3: "#ef9a9a",
  lighten2: "#e57373",
  lighten1: "#ef5350",
  darken1: "#e53935",
  darken2: "#d32f2f",
  darken3: "#c62828",
  darken4: "#b71c1c",
  accent1: "#ff8a80",
  accent2: "#ff5252",
  accent3: "#ff1744",
  accent4: "#d50000"
}, SV = {
  base: "#e91e63",
  lighten5: "#fce4ec",
  lighten4: "#f8bbd0",
  lighten3: "#f48fb1",
  lighten2: "#f06292",
  lighten1: "#ec407a",
  darken1: "#d81b60",
  darken2: "#c2185b",
  darken3: "#ad1457",
  darken4: "#880e4f",
  accent1: "#ff80ab",
  accent2: "#ff4081",
  accent3: "#f50057",
  accent4: "#c51162"
}, xV = {
  base: "#9c27b0",
  lighten5: "#f3e5f5",
  lighten4: "#e1bee7",
  lighten3: "#ce93d8",
  lighten2: "#ba68c8",
  lighten1: "#ab47bc",
  darken1: "#8e24aa",
  darken2: "#7b1fa2",
  darken3: "#6a1b9a",
  darken4: "#4a148c",
  accent1: "#ea80fc",
  accent2: "#e040fb",
  accent3: "#d500f9",
  accent4: "#aa00ff"
}, CV = {
  base: "#673ab7",
  lighten5: "#ede7f6",
  lighten4: "#d1c4e9",
  lighten3: "#b39ddb",
  lighten2: "#9575cd",
  lighten1: "#7e57c2",
  darken1: "#5e35b1",
  darken2: "#512da8",
  darken3: "#4527a0",
  darken4: "#311b92",
  accent1: "#b388ff",
  accent2: "#7c4dff",
  accent3: "#651fff",
  accent4: "#6200ea"
}, _V = {
  base: "#3f51b5",
  lighten5: "#e8eaf6",
  lighten4: "#c5cae9",
  lighten3: "#9fa8da",
  lighten2: "#7986cb",
  lighten1: "#5c6bc0",
  darken1: "#3949ab",
  darken2: "#303f9f",
  darken3: "#283593",
  darken4: "#1a237e",
  accent1: "#8c9eff",
  accent2: "#536dfe",
  accent3: "#3d5afe",
  accent4: "#304ffe"
}, TV = {
  base: "#2196f3",
  lighten5: "#e3f2fd",
  lighten4: "#bbdefb",
  lighten3: "#90caf9",
  lighten2: "#64b5f6",
  lighten1: "#42a5f5",
  darken1: "#1e88e5",
  darken2: "#1976d2",
  darken3: "#1565c0",
  darken4: "#0d47a1",
  accent1: "#82b1ff",
  accent2: "#448aff",
  accent3: "#2979ff",
  accent4: "#2962ff"
}, IV = {
  base: "#03a9f4",
  lighten5: "#e1f5fe",
  lighten4: "#b3e5fc",
  lighten3: "#81d4fa",
  lighten2: "#4fc3f7",
  lighten1: "#29b6f6",
  darken1: "#039be5",
  darken2: "#0288d1",
  darken3: "#0277bd",
  darken4: "#01579b",
  accent1: "#80d8ff",
  accent2: "#40c4ff",
  accent3: "#00b0ff",
  accent4: "#0091ea"
}, AV = {
  base: "#00bcd4",
  lighten5: "#e0f7fa",
  lighten4: "#b2ebf2",
  lighten3: "#80deea",
  lighten2: "#4dd0e1",
  lighten1: "#26c6da",
  darken1: "#00acc1",
  darken2: "#0097a7",
  darken3: "#00838f",
  darken4: "#006064",
  accent1: "#84ffff",
  accent2: "#18ffff",
  accent3: "#00e5ff",
  accent4: "#00b8d4"
}, PV = {
  base: "#009688",
  lighten5: "#e0f2f1",
  lighten4: "#b2dfdb",
  lighten3: "#80cbc4",
  lighten2: "#4db6ac",
  lighten1: "#26a69a",
  darken1: "#00897b",
  darken2: "#00796b",
  darken3: "#00695c",
  darken4: "#004d40",
  accent1: "#a7ffeb",
  accent2: "#64ffda",
  accent3: "#1de9b6",
  accent4: "#00bfa5"
}, VV = {
  base: "#4caf50",
  lighten5: "#e8f5e9",
  lighten4: "#c8e6c9",
  lighten3: "#a5d6a7",
  lighten2: "#81c784",
  lighten1: "#66bb6a",
  darken1: "#43a047",
  darken2: "#388e3c",
  darken3: "#2e7d32",
  darken4: "#1b5e20",
  accent1: "#b9f6ca",
  accent2: "#69f0ae",
  accent3: "#00e676",
  accent4: "#00c853"
}, EV = {
  base: "#8bc34a",
  lighten5: "#f1f8e9",
  lighten4: "#dcedc8",
  lighten3: "#c5e1a5",
  lighten2: "#aed581",
  lighten1: "#9ccc65",
  darken1: "#7cb342",
  darken2: "#689f38",
  darken3: "#558b2f",
  darken4: "#33691e",
  accent1: "#ccff90",
  accent2: "#b2ff59",
  accent3: "#76ff03",
  accent4: "#64dd17"
}, MV = {
  base: "#cddc39",
  lighten5: "#f9fbe7",
  lighten4: "#f0f4c3",
  lighten3: "#e6ee9c",
  lighten2: "#dce775",
  lighten1: "#d4e157",
  darken1: "#c0ca33",
  darken2: "#afb42b",
  darken3: "#9e9d24",
  darken4: "#827717",
  accent1: "#f4ff81",
  accent2: "#eeff41",
  accent3: "#c6ff00",
  accent4: "#aeea00"
}, OV = {
  base: "#ffeb3b",
  lighten5: "#fffde7",
  lighten4: "#fff9c4",
  lighten3: "#fff59d",
  lighten2: "#fff176",
  lighten1: "#ffee58",
  darken1: "#fdd835",
  darken2: "#fbc02d",
  darken3: "#f9a825",
  darken4: "#f57f17",
  accent1: "#ffff8d",
  accent2: "#ffff00",
  accent3: "#ffea00",
  accent4: "#ffd600"
}, DV = {
  base: "#ffc107",
  lighten5: "#fff8e1",
  lighten4: "#ffecb3",
  lighten3: "#ffe082",
  lighten2: "#ffd54f",
  lighten1: "#ffca28",
  darken1: "#ffb300",
  darken2: "#ffa000",
  darken3: "#ff8f00",
  darken4: "#ff6f00",
  accent1: "#ffe57f",
  accent2: "#ffd740",
  accent3: "#ffc400",
  accent4: "#ffab00"
}, LV = {
  base: "#ff9800",
  lighten5: "#fff3e0",
  lighten4: "#ffe0b2",
  lighten3: "#ffcc80",
  lighten2: "#ffb74d",
  lighten1: "#ffa726",
  darken1: "#fb8c00",
  darken2: "#f57c00",
  darken3: "#ef6c00",
  darken4: "#e65100",
  accent1: "#ffd180",
  accent2: "#ffab40",
  accent3: "#ff9100",
  accent4: "#ff6d00"
}, NV = {
  base: "#ff5722",
  lighten5: "#fbe9e7",
  lighten4: "#ffccbc",
  lighten3: "#ffab91",
  lighten2: "#ff8a65",
  lighten1: "#ff7043",
  darken1: "#f4511e",
  darken2: "#e64a19",
  darken3: "#d84315",
  darken4: "#bf360c",
  accent1: "#ff9e80",
  accent2: "#ff6e40",
  accent3: "#ff3d00",
  accent4: "#dd2c00"
}, FV = {
  base: "#795548",
  lighten5: "#efebe9",
  lighten4: "#d7ccc8",
  lighten3: "#bcaaa4",
  lighten2: "#a1887f",
  lighten1: "#8d6e63",
  darken1: "#6d4c41",
  darken2: "#5d4037",
  darken3: "#4e342e",
  darken4: "#3e2723"
}, RV = {
  base: "#607d8b",
  lighten5: "#eceff1",
  lighten4: "#cfd8dc",
  lighten3: "#b0bec5",
  lighten2: "#90a4ae",
  lighten1: "#78909c",
  darken1: "#546e7a",
  darken2: "#455a64",
  darken3: "#37474f",
  darken4: "#263238"
}, $V = {
  base: "#9e9e9e",
  lighten5: "#fafafa",
  lighten4: "#f5f5f5",
  lighten3: "#eeeeee",
  lighten2: "#e0e0e0",
  lighten1: "#bdbdbd",
  darken1: "#757575",
  darken2: "#616161",
  darken3: "#424242",
  darken4: "#212121"
}, BV = {
  black: "#000000",
  white: "#ffffff",
  transparent: "#ffffff00"
}, Bt = {
  red: kV,
  pink: SV,
  purple: xV,
  deepPurple: CV,
  indigo: _V,
  blue: TV,
  lightBlue: IV,
  cyan: AV,
  teal: PV,
  green: VV,
  lightGreen: EV,
  lime: MV,
  yellow: OV,
  amber: DV,
  orange: LV,
  deepOrange: NV,
  brown: FV,
  blueGrey: RV,
  grey: $V,
  shades: BV
}, UV = U({
  swatches: {
    type: Array,
    default: () => WV(Bt)
  },
  disabled: Boolean,
  readonly: Boolean,
  color: Object,
  maxHeight: [Number, String],
  ...ve()
}, "VColorPickerSwatches");
function WV(e) {
  return Object.keys(e).map((t) => {
    const n = e[t];
    return n.base ? [n.base, n.darken4, n.darken3, n.darken2, n.darken1, n.lighten1, n.lighten2, n.lighten3, n.lighten4, n.lighten5] : [n.black, n.white, n.transparent];
  });
}
const HV = rn({
  name: "VColorPickerSwatches",
  props: UV(),
  emits: {
    "update:color": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    const a = D(() => !e.disabled && !e.readonly);
    function r(l) {
      !a.value || !l || n("update:color", l);
    }
    return X(() => S("div", {
      class: J(["v-color-picker-swatches", e.class]),
      style: le([{
        maxHeight: re(e.maxHeight)
      }, e.style])
    }, [S("div", null, [e.swatches.map((l) => S("div", {
      class: "v-color-picker-swatches__swatch"
    }, [l.map((i) => {
      const o = ra(i), s = ri(o), u = dg(o);
      return S("div", {
        class: J(["v-color-picker-swatches__color", {
          "v-color-picker-swatches__color--disabled": e.disabled
        }]),
        onClick: () => r(s)
      }, [S("div", {
        style: {
          background: u
        }
      }, [e.color && Lt(e.color, s) ? y(ze, {
        size: "x-small",
        icon: "$success",
        color: N_(i, "#FFFFFF") > 2 ? "white" : "black"
      }, null) : void 0])]);
    })]))])])), {};
  }
}), zV = ca("v-picker-title"), Qo = U({
  bgColor: String,
  divided: Boolean,
  landscape: Boolean,
  title: String,
  hideHeader: Boolean,
  hideTitle: Boolean,
  ...Jc()
}, "VPicker"), Yr = K()({
  name: "VPicker",
  props: Qo(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      backgroundColorClasses: a,
      backgroundColorStyles: r
    } = qe(() => e.color);
    return X(() => {
      const l = Va.filterProps(e), i = !e.hideTitle && !!(e.title || n.title);
      return y(Va, Y(l, {
        color: e.bgColor,
        class: ["v-picker", {
          "v-picker--divided": e.divided,
          "v-picker--landscape": e.landscape,
          "v-picker--with-actions": !!n.actions
        }, e.class],
        style: e.style
      }), {
        default: () => [!e.hideHeader && S("div", {
          key: "header",
          class: J(["v-picker__header-wrapper", a.value]),
          style: le([r.value])
        }, [i && y(zV, {
          key: "picker-title"
        }, {
          default: () => [n.title?.() ?? e.title]
        }), n.header && S("div", {
          class: "v-picker__header"
        }, [n.header()])]), S("div", {
          class: "v-picker__body"
        }, [n.default?.()]), n.actions && y(Ae, {
          defaults: {
            VBtn: {
              slim: !0,
              variant: "text"
            }
          }
        }, {
          default: () => [S("div", {
            class: "v-picker__actions"
          }, [n.actions()])]
        })]
      });
    }), {};
  }
}), jV = U({
  canvasHeight: {
    type: [String, Number],
    default: 150
  },
  disabled: Boolean,
  dotSize: {
    type: [Number, String],
    default: 10
  },
  hideCanvas: Boolean,
  hideSliders: Boolean,
  hideInputs: Boolean,
  mode: {
    type: String,
    default: "rgba",
    validator: (e) => Object.keys(Ja).includes(e)
  },
  modes: {
    type: Array,
    default: () => Object.keys(Ja),
    validator: (e) => Array.isArray(e) && e.every((t) => Object.keys(Ja).includes(t))
  },
  showSwatches: Boolean,
  readonly: Boolean,
  swatches: Array,
  swatchesMaxHeight: {
    type: [Number, String],
    default: 150
  },
  modelValue: {
    type: [Object, String]
  },
  ...Qo({
    hideHeader: !0
  }),
  ...an(hb(), ["hideEyeDropper", "eyeDropperIcon"])
}, "VColorPicker"), GV = rn({
  name: "VColorPicker",
  props: jV(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:mode": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = he(e, "mode"), r = G(null), l = he(e, "modelValue", void 0, (c) => {
      if (c == null || c === "") return null;
      let d;
      try {
        d = ri(ra(c));
      } catch (f) {
        return jt(f), null;
      }
      return d;
    }, (c) => c ? uV(c, e.modelValue) : null), i = T(() => l.value ? {
      ...l.value,
      h: r.value ?? l.value.h
    } : null), {
      rtlClasses: o
    } = At();
    let s = !0;
    ne(l, (c) => {
      if (!s) {
        s = !0;
        return;
      }
      c && (r.value = c.h);
    }, {
      immediate: !0
    });
    const u = (c) => {
      s = !1, r.value = c.h, l.value = c;
    };
    return Gl(() => {
      e.modes.includes(a.value) || (a.value = e.modes[0]);
    }), vt({
      VSlider: {
        color: void 0,
        trackColor: void 0,
        trackFillColor: void 0
      }
    }), X(() => {
      const c = Yr.filterProps(e);
      return y(Yr, Y(c, {
        class: ["v-color-picker", o.value, e.class],
        style: [{
          "--v-color-picker-color-hsv": fg({
            ...i.value ?? Or,
            a: 1
          })
        }, e.style]
      }), {
        ...n,
        default: () => S(fe, null, [!e.hideCanvas && y(oV, {
          key: "canvas",
          color: i.value,
          "onUpdate:color": u,
          disabled: e.disabled,
          readonly: e.readonly,
          dotSize: e.dotSize,
          width: e.width,
          height: e.canvasHeight
        }, null), (!e.hideSliders || !e.hideInputs) && S("div", {
          key: "controls",
          class: "v-color-picker__controls"
        }, [!e.hideSliders && y(wV, {
          key: "preview",
          color: i.value,
          "onUpdate:color": u,
          hideAlpha: !a.value.endsWith("a"),
          disabled: e.disabled,
          readonly: e.readonly,
          hideEyeDropper: e.hideEyeDropper,
          eyeDropperIcon: e.eyeDropperIcon
        }, null), !e.hideInputs && y(hV, {
          key: "edit",
          modes: e.modes,
          mode: a.value,
          "onUpdate:mode": (d) => a.value = d,
          color: i.value,
          "onUpdate:color": u,
          disabled: e.disabled,
          readonly: e.readonly
        }, null)]), e.showSwatches && y(HV, {
          key: "swatches",
          color: i.value,
          "onUpdate:color": u,
          maxHeight: e.swatchesMaxHeight,
          swatches: e.swatches,
          disabled: e.disabled,
          readonly: e.readonly
        }, null)])
      });
    }), {};
  }
}), qV = U({
  alwaysFilter: Boolean,
  autoSelectFirst: {
    type: [Boolean, String]
  },
  clearOnSelect: {
    type: Boolean,
    default: !0
  },
  delimiters: Array,
  ...yr({
    filterKeys: ["title"]
  }),
  ...ad({
    hideNoData: !0,
    returnObject: !0
  }),
  ...Pe(mi({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty"])
}, "VCombobox"), YV = K()({
  name: "VCombobox",
  props: qV(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:search": (e) => !0,
    "update:menu": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const {
      t: r
    } = Ke(), l = G(), i = ae(!1), o = ae(!0), s = ae(!1), u = G(), c = G(), d = ae(-1);
    let f = !1;
    const {
      items: v,
      transformIn: g,
      transformOut: m
    } = zc(e), {
      textColorClasses: h,
      textColorStyles: w
    } = Nt(() => l.value?.color), {
      InputIcon: _
    } = ci(e), I = he(e, "modelValue", [], (se) => g(rt(se)), (se) => {
      const Ce = m(se);
      return e.multiple ? Ce : Ce[0] ?? null;
    }), C = ul(e), b = D(() => e.closableChips && !C.isReadonly.value && !C.isDisabled.value), p = T(() => !!(e.chips || a.chip)), x = T(() => p.value || !!a.selection), k = ae(!e.multiple && !x.value ? I.value[0]?.title ?? "" : ""), V = ae(null), A = T({
      get: () => k.value,
      set: async (se) => {
        if (k.value = se ?? "", se === null || se === "" && !e.multiple && !x.value ? I.value = [] : !e.multiple && !x.value && (I.value = [Dn(e, se)], Se(() => c.value?.scrollToIndex(0))), se && e.multiple && e.delimiters?.length) {
          const Ce = Yt(se);
          Ce.length > 1 && (Ue(Ce), k.value = "");
        }
        se || (d.value = -1), o.value = !se;
      }
    }), M = T(() => typeof e.counterValue == "function" ? e.counterValue(I.value) : typeof e.counterValue == "number" ? e.counterValue : e.multiple ? I.value.length : A.value.length), {
      filteredItems: L,
      getMatches: E
    } = br(e, v, () => V.value ?? (e.alwaysFilter || !o.value ? A.value : "")), P = T(() => e.hideSelected && V.value === null ? L.value.filter((se) => !I.value.some((Ce) => Ce.value === se.value)) : L.value), O = T(() => e.hideNoData && !P.value.length || C.isReadonly.value || C.isDisabled.value), F = he(e, "menu"), B = T({
      get: () => F.value,
      set: (se) => {
        F.value && !se && u.value?.ΨopenChildren.size || se && O.value || (F.value = se);
      }
    }), {
      menuId: N,
      ariaExpanded: W,
      ariaControls: R
    } = nd(e, B);
    ne(k, (se) => {
      f ? Se(() => f = !1) : i.value && !B.value && (B.value = !0), n("update:search", se);
    }), ne(I, (se) => {
      !e.multiple && !x.value && (k.value = se[0]?.title ?? "");
    });
    const j = T(() => I.value.map((se) => se.value)), H = T(() => P.value.find((se) => se.type === "item" && !se.props.disabled)), $ = T(() => (e.autoSelectFirst === !0 || e.autoSelectFirst === "exact" && A.value === H.value?.title) && P.value.length > 0 && !o.value && !s.value), z = G(), te = G(), me = G(), Q = Qc(z, l), {
      onTabKeydown: ie
    } = ed({
      groups: [{
        type: "element",
        contentRef: te
      }, {
        type: "list",
        contentRef: z,
        displayItemsCount: () => P.value.length
      }, {
        type: "element",
        contentRef: me
      }],
      onLeave: () => {
        B.value = !1, l.value?.focus();
      }
    });
    function ke(se) {
      f = !0, Se(() => f = !1), e.openOnClear && (B.value = !0);
    }
    function ye() {
      O.value || (B.value = !0);
    }
    function ue(se) {
      O.value || (i.value && (se.preventDefault(), se.stopPropagation()), B.value = !B.value);
    }
    function Te(se) {
      se.key === "Tab" && ie(se), z.value?.$el.contains(se.target) && (zr(se) || se.key === "Backspace") && l.value?.focus();
    }
    function Ne(se) {
      if (u_(se) || C.isReadonly.value) return;
      const Ce = l.value?.selectionStart, He = I.value.length;
      if (["Enter", "ArrowDown", "ArrowUp"].includes(se.key) && se.preventDefault(), ["Enter", "ArrowDown"].includes(se.key) && (B.value = !0), ["Escape"].includes(se.key) && (B.value = !1), $.value && ["Enter", "Tab"].includes(se.key) && H.value && !I.value.some((Ee) => {
        let {
          value: Fe
        } = Ee;
        return Fe === H.value.value;
      }) && ct(H.value), se.key === "ArrowDown" && $.value && z.value?.focus("next"), se.key === "Enter" && A.value && (ct(Dn(e, A.value), !0, !0), x.value && (k.value = "")), ["Backspace", "Delete"].includes(se.key)) {
        if (!e.multiple && x.value && I.value.length > 0 && !A.value) return ct(I.value[0], !1);
        if (~d.value) {
          se.preventDefault();
          const Ee = d.value;
          ct(I.value[d.value], !1), d.value = Ee >= He - 1 ? He - 2 : Ee;
        } else se.key === "Backspace" && !A.value && (d.value = He - 1);
        return;
      }
      if (e.multiple)
        if (se.key === "ArrowLeft") {
          if (d.value < 0 && Ce && Ce > 0) return;
          const Ee = d.value > -1 ? d.value - 1 : He - 1;
          I.value[Ee] ? d.value = Ee : (d.value = -1, l.value?.setSelectionRange(A.value.length, A.value.length));
        } else if (se.key === "ArrowRight") {
          if (d.value < 0) return;
          const Ee = d.value + 1;
          I.value[Ee] ? d.value = Ee : (d.value = -1, l.value?.setSelectionRange(0, 0));
        } else ~d.value && zr(se) && (d.value = -1);
    }
    function je(se) {
      const Ce = se?.clipboardData?.getData("Text") ?? "", He = Yt(Ce);
      He.length > 1 && e.multiple && (se.preventDefault(), Ue(He));
    }
    function xe() {
      e.eager && c.value?.calculateVisibleItems();
    }
    function Be() {
      i.value && l.value?.focus(), o.value = !0, V.value = null;
    }
    function ct(se) {
      let Ce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, He = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      if (!(!se || se.props.disabled))
        if (e.multiple) {
          const Ee = I.value.findIndex((Ot) => (e.valueComparator || Lt)(Ot.value, se.value)), Fe = Ce ?? !~Ee;
          if (~Ee) {
            const Ot = Fe ? [...I.value, se] : [...I.value];
            Ot.splice(Ee, 1), I.value = Ot;
          } else Fe && (I.value = [...I.value, se]);
          e.clearOnSelect && (A.value = "");
        } else {
          const Ee = Ce !== !1;
          I.value = Ee ? [se] : [], (!o.value || e.alwaysFilter) && k.value && (V.value = k.value), k.value = Ee && !x.value ? se.title : "", Se(() => {
            B.value = He, o.value = !0;
          });
        }
    }
    function Yt(se) {
      const He = [`
`, ...e.delimiters ?? []].map(lo).join("|");
      return se.split(new RegExp(`(?:${He})+`));
    }
    async function Ue(se) {
      for (let Ce of se)
        Ce = Ce.trim(), Ce && (ct(Dn(e, Ce)), await Se());
    }
    function oe(se) {
      i.value = !0, setTimeout(() => {
        s.value = !0;
      });
    }
    function $e(se) {
      s.value = !1;
    }
    function ht(se) {
      u.value?.contentEl?.contains(se.relatedTarget) && (i.value = !0);
    }
    return ne(i, (se, Ce) => {
      if (!(se || se === Ce) && (d.value = -1, B.value = !1, A.value)) {
        if (e.multiple) {
          ct(Dn(e, A.value));
          return;
        }
        if (!x.value) return;
        I.value.some((He) => {
          let {
            title: Ee
          } = He;
          return Ee === A.value;
        }) ? k.value = "" : ct(Dn(e, A.value));
      }
    }), ne(B, (se) => {
      if (!e.hideSelected && se && I.value.length && o.value) {
        const Ce = P.value.findIndex((He) => I.value.some((Ee) => (e.valueComparator || Lt)(Ee.value, He.value)));
        wt && window.requestAnimationFrame(() => {
          Ce >= 0 && c.value?.scrollToIndex(Ce);
        });
      }
      se && (V.value = null);
    }), ne(v, (se, Ce) => {
      B.value || i.value && !Ce.length && se.length && (B.value = !0);
    }), X(() => {
      const se = !!(!e.hideNoData || P.value.length || a["prepend-item"] || a["append-item"] || a["no-data"]), Ce = I.value.length > 0, He = Kn.filterProps(e), Ee = {
        search: A,
        filteredItems: L.value
      };
      return y(Kn, Y({
        ref: l
      }, He, {
        modelValue: A.value,
        "onUpdate:modelValue": (Fe) => A.value = Fe,
        focused: i.value,
        "onUpdate:focused": (Fe) => i.value = Fe,
        validationValue: I.externalValue,
        counterValue: M.value,
        dirty: Ce,
        class: ["v-combobox", {
          "v-combobox--active-menu": B.value,
          "v-combobox--chips": !!e.chips,
          "v-combobox--selection-slot": !!x.value,
          "v-combobox--selecting-index": d.value > -1,
          [`v-combobox--${e.multiple ? "multiple" : "single"}`]: !0
        }, e.class],
        style: e.style,
        readonly: C.isReadonly.value,
        placeholder: Ce ? void 0 : e.placeholder,
        "onClick:clear": ke,
        "onMousedown:control": ye,
        onKeydown: Ne,
        onPaste: je,
        onBlur: ht,
        "aria-expanded": W.value,
        "aria-controls": R.value
      }), {
        ...a,
        default: (Fe) => {
          let {
            id: Ot
          } = Fe;
          return S(fe, null, [y(qr, Y({
            id: N.value,
            ref: u,
            modelValue: B.value,
            "onUpdate:modelValue": (dt) => B.value = dt,
            activator: "parent",
            contentClass: "v-combobox__content",
            disabled: O.value,
            eager: e.eager,
            maxHeight: 310,
            openOnClick: !1,
            closeOnContentClick: !1,
            onAfterEnter: xe,
            onAfterLeave: Be
          }, e.menuProps), {
            default: () => [y(Va, {
              onFocusin: oe,
              onKeydown: Te
            }, {
              default: () => [a["menu-header"] && S("header", {
                ref: te
              }, [a["menu-header"](Ee)]), se && y(Gr, Y({
                key: "combobox-list",
                ref: z,
                filterable: !0,
                selected: j.value,
                selectStrategy: e.multiple ? "independent" : "single-independent",
                onMousedown: (dt) => dt.preventDefault(),
                selectable: !!P.value.length,
                onFocusout: $e,
                tabindex: "-1",
                "aria-live": "polite",
                "aria-labelledby": `${Ot.value}-label`,
                "aria-multiselectable": e.multiple,
                color: e.itemColor ?? e.color
              }, Q, e.listProps), {
                default: () => [a["prepend-item"]?.(), !P.value.length && !e.hideNoData && (a["no-data"]?.() ?? y(En, {
                  key: "no-data",
                  title: r(e.noDataText)
                }, null)), y(qo, {
                  ref: c,
                  renderless: !0,
                  items: P.value,
                  itemKey: "value"
                }, {
                  default: (dt) => {
                    let {
                      item: Qe,
                      index: tn,
                      itemRef: $t
                    } = dt;
                    const Fa = Y(Qe.props, {
                      ref: $t,
                      key: Qe.value,
                      active: $.value && Qe === H.value ? !0 : void 0,
                      onClick: () => ct(Qe, null),
                      "aria-posinset": tn + 1,
                      "aria-setsize": P.value.length
                    });
                    return Qe.type === "divider" ? a.divider?.({
                      props: Qe.raw,
                      index: tn
                    }) ?? y(pn, Y(Qe.props, {
                      key: `divider-${tn}`
                    }), null) : Qe.type === "subheader" ? a.subheader?.({
                      props: Qe.raw,
                      index: tn
                    }) ?? y(cl, Y(Qe.props, {
                      key: `subheader-${tn}`
                    }), null) : a.item?.({
                      item: Qe,
                      index: tn,
                      props: Fa
                    }) ?? y(En, Y(Fa, {
                      role: "option"
                    }), {
                      prepend: (dl) => {
                        let {
                          isSelected: hn
                        } = dl;
                        return S(fe, null, [e.multiple && !e.hideSelected ? y(Un, {
                          key: Qe.value,
                          modelValue: hn,
                          ripple: !1,
                          tabindex: "-1",
                          "aria-hidden": !0,
                          onClick: ($p) => $p.preventDefault()
                        }, null) : void 0, Qe.props.prependAvatar && y(kn, {
                          image: Qe.props.prependAvatar
                        }, null), Qe.props.prependIcon && y(ze, {
                          icon: Qe.props.prependIcon
                        }, null)]);
                      },
                      title: () => o.value ? Qe.title : td("v-combobox", Qe.title, E(Qe)?.title)
                    });
                  }
                }), a["append-item"]?.()]
              }), a["menu-footer"] && S("footer", {
                ref: me
              }, [a["menu-footer"](Ee)])]
            })]
          }), I.value.map((dt, Qe) => {
            function tn(hn) {
              hn.stopPropagation(), hn.preventDefault(), ct(dt, !1);
            }
            const $t = Y(ua.filterProps(dt.props), {
              "onClick:close": tn,
              onKeydown(hn) {
                hn.key !== "Enter" && hn.key !== " " || (hn.preventDefault(), hn.stopPropagation(), tn(hn));
              },
              onMousedown(hn) {
                hn.preventDefault(), hn.stopPropagation();
              },
              modelValue: !0,
              "onUpdate:modelValue": void 0
            }), Fa = p.value ? !!a.chip : !!a.selection, dl = Fa ? Lo(p.value ? a.chip({
              item: dt,
              index: Qe,
              props: $t
            }) : a.selection({
              item: dt,
              index: Qe
            })) : void 0;
            if (!(Fa && !dl))
              return S("div", {
                key: dt.value,
                class: J(["v-combobox__selection", Qe === d.value && ["v-combobox__selection--selected", h.value]]),
                style: le(Qe === d.value ? w.value : {})
              }, [p.value ? a.chip ? y(Ae, {
                key: "chip-defaults",
                defaults: {
                  VChip: {
                    closable: b.value,
                    size: "small",
                    text: dt.title
                  }
                }
              }, {
                default: () => [dl]
              }) : y(ua, Y({
                key: "chip",
                closable: b.value,
                size: "small",
                text: dt.title,
                disabled: dt.props.disabled
              }, $t), null) : dl ?? S("span", {
                class: "v-combobox__selection-text"
              }, [dt.title, e.multiple && Qe < I.value.length - 1 && S("span", {
                class: "v-combobox__selection-comma"
              }, [we(",")])])]);
          })]);
        },
        "append-inner": function() {
          for (var Fe = arguments.length, Ot = new Array(Fe), dt = 0; dt < Fe; dt++)
            Ot[dt] = arguments[dt];
          return S(fe, null, [a["append-inner"]?.(...Ot), (!e.hideNoData || e.items.length) && e.menuIcon ? y(ze, {
            class: "v-combobox__menu-icon",
            color: l.value?.fieldIconColor,
            icon: e.menuIcon,
            onMousedown: ue,
            onClick: Do,
            "aria-hidden": !0,
            tabindex: "-1"
          }, null) : void 0, e.appendInnerIcon && y(_, {
            key: "append-icon",
            name: "appendInner",
            color: Ot[0].iconColor.value
          }, null)]);
        }
      });
    }), Mt({
      isFocused: i,
      isPristine: o,
      menu: B,
      search: A,
      selectionIndex: d,
      filteredItems: L,
      select: ct
    }, l);
  }
}), KV = U({
  modelValue: null,
  color: String,
  cancelText: {
    type: String,
    default: "$vuetify.confirmEdit.cancel"
  },
  okText: {
    type: String,
    default: "$vuetify.confirmEdit.ok"
  },
  disabled: {
    type: [Boolean, Array],
    default: void 0
  },
  hideActions: Boolean
}, "VConfirmEdit"), ZV = K()({
  name: "VConfirmEdit",
  props: KV(),
  emits: {
    cancel: () => !0,
    save: (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const r = he(e, "modelValue"), l = G();
    ft(() => {
      l.value = structuredClone(nv(r.value));
    });
    const {
      t: i
    } = Ke(), o = T(() => Lt(r.value, l.value));
    function s(m) {
      return typeof e.disabled == "boolean" ? e.disabled : Array.isArray(e.disabled) ? e.disabled.includes(m) : o.value;
    }
    const u = T(() => s("save")), c = T(() => s("cancel"));
    function d() {
      r.value = l.value, n("save", l.value);
    }
    function f() {
      l.value = structuredClone(nv(r.value)), n("cancel");
    }
    function v(m) {
      return S(fe, null, [y(De, Y({
        disabled: c.value,
        variant: "text",
        color: e.color,
        onClick: f,
        text: i(e.cancelText)
      }, m), null), y(De, Y({
        disabled: u.value,
        variant: "text",
        color: e.color,
        onClick: d,
        text: i(e.okText)
      }, m), null)]);
    }
    let g = !1;
    return X(() => S(fe, null, [a.default?.({
      model: l,
      save: d,
      cancel: f,
      isPristine: o.value,
      get actions() {
        return g = !0, v;
      }
    }), !e.hideActions && !g && v()])), {
      save: d,
      cancel: f,
      isPristine: o
    };
  }
}), gb = U({
  expandOnClick: Boolean,
  showExpand: Boolean,
  expanded: {
    type: Array,
    default: () => []
  }
}, "DataTable-expand"), yb = /* @__PURE__ */ Symbol.for("vuetify:datatable:expanded");
function es(e) {
  const t = D(() => e.expandOnClick), n = he(e, "expanded", e.expanded, (o) => new Set(o), (o) => [...o.values()]);
  function a(o, s) {
    const u = new Set(n.value), c = it(o.value);
    if (s)
      u.add(c);
    else {
      const d = [...n.value].find((f) => it(f) === c);
      u.delete(d);
    }
    n.value = u;
  }
  function r(o) {
    const s = it(o.value);
    return [...n.value].some((u) => it(u) === s);
  }
  function l(o) {
    a(o, !r(o));
  }
  const i = {
    expand: a,
    expanded: n,
    expandOnClick: t,
    isExpanded: r,
    toggleExpand: l
  };
  return st(yb, i), i;
}
function bb() {
  const e = Le(yb);
  if (!e) throw new Error("foo");
  return e;
}
const dd = U({
  groupBy: {
    type: Array,
    default: () => []
  }
}, "DataTable-group"), pb = /* @__PURE__ */ Symbol.for("vuetify:data-table-group");
function fd(e) {
  return {
    groupBy: he(e, "groupBy")
  };
}
function ts(e) {
  const {
    disableSort: t,
    groupBy: n,
    sortBy: a
  } = e, r = G(/* @__PURE__ */ new Set()), l = T(() => n.value.map((c) => ({
    ...c,
    order: c.order ?? !1
  })).concat(t?.value ? [] : a.value));
  function i(c) {
    return r.value.has(c.id);
  }
  function o(c) {
    const d = new Set(r.value);
    i(c) ? d.delete(c.id) : d.add(c.id), r.value = d;
  }
  function s(c) {
    function d(f) {
      const v = [];
      for (const g of f.items)
        "type" in g && g.type === "group" ? v.push(...d(g)) : v.push(g);
      return [...new Set(v)];
    }
    return d({
      items: c
    });
  }
  const u = {
    sortByWithGroups: l,
    toggleGroup: o,
    opened: r,
    groupBy: n,
    extractRows: s,
    isGroupOpen: i
  };
  return st(pb, u), u;
}
function wb() {
  const e = Le(pb);
  if (!e) throw new Error("Missing group!");
  return e;
}
function JV(e, t) {
  if (!e.length) return [];
  const n = /* @__PURE__ */ new Map();
  for (const a of e) {
    const r = Ml(a.raw, t);
    n.has(r) || n.set(r, []), n.get(r).push(a);
  }
  return n;
}
function kb(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "root";
  if (!t.length) return [];
  const r = JV(e, t[0]), l = [], i = t.slice(1);
  return r.forEach((o, s) => {
    const u = t[0], c = `${a}_${u}_${s}`;
    l.push({
      depth: n,
      id: c,
      key: u,
      value: s,
      items: i.length ? kb(o, i, n + 1, c) : o,
      type: "group"
    });
  }), l;
}
function Sb(e, t, n) {
  const a = [];
  for (const r of e)
    "type" in r && r.type === "group" ? (r.value != null && a.push(r), (t.has(r.id) || r.value == null) && (a.push(...Sb(r.items, t, n)), n && a.push({
      ...r,
      type: "group-summary"
    }))) : a.push(r);
  return a;
}
function ns(e, t, n, a) {
  const r = T(() => t.value.length ? kb(nt(e), t.value.map((i) => i.key)) : []), l = T(() => t.value.length ? Sb(r.value, n.value, nt(a)) : nt(e));
  return {
    groups: r,
    flatItems: l
  };
}
function as(e) {
  let {
    page: t,
    itemsPerPage: n,
    sortBy: a,
    groupBy: r,
    search: l
  } = e;
  const i = kt("VDataTable"), o = () => ({
    page: t.value,
    itemsPerPage: n.value,
    sortBy: a.value,
    groupBy: r.value,
    search: l.value
  });
  let s = null;
  ne(o, (u) => {
    Lt(s, u) || (s && s.search !== u.search && (t.value = 1), i.emit("update:options", u), s = u);
  }, {
    deep: !0,
    immediate: !0
  });
}
const vd = U({
  page: {
    type: [Number, String],
    default: 1
  },
  itemsPerPage: {
    type: [Number, String],
    default: 10
  },
  pageBy: {
    type: String,
    default: "any"
  }
}, "DataTable-paginate"), xb = /* @__PURE__ */ Symbol.for("vuetify:data-table-pagination");
function md(e) {
  const t = he(e, "page", void 0, (a) => Number(a ?? 1)), n = he(e, "itemsPerPage", void 0, (a) => Number(a ?? 10));
  return {
    page: t,
    itemsPerPage: n
  };
}
function hd(e) {
  const {
    page: t,
    itemsPerPage: n,
    itemsLength: a
  } = e, r = T(() => n.value === -1 ? 0 : n.value * (t.value - 1)), l = T(() => n.value === -1 ? a.value : Math.min(a.value, r.value + n.value)), i = T(() => n.value === -1 || a.value === 0 ? 1 : Math.ceil(a.value / n.value));
  ne([t, i], () => {
    t.value > i.value && (t.value = i.value);
  });
  function o(f) {
    n.value = f, t.value = 1;
  }
  function s() {
    t.value = Xe(t.value + 1, 1, i.value);
  }
  function u() {
    t.value = Xe(t.value - 1, 1, i.value);
  }
  function c(f) {
    t.value = Xe(f, 1, i.value);
  }
  const d = {
    page: t,
    itemsPerPage: n,
    startIndex: r,
    stopIndex: l,
    pageCount: i,
    itemsLength: a,
    nextPage: s,
    prevPage: u,
    setPage: c,
    setItemsPerPage: o
  };
  return st(xb, d), d;
}
function XV() {
  const e = Le(xb);
  if (!e) throw new Error("Missing pagination!");
  return e;
}
function Cb(e) {
  const t = kt("usePaginatedItems"), {
    items: n,
    startIndex: a,
    stopIndex: r,
    itemsPerPage: l
  } = e, i = T(() => l.value <= 0 ? nt(n) : nt(n).slice(a.value, r.value));
  return ne(i, (o) => {
    t.emit("update:currentItems", o);
  }, {
    immediate: !0
  }), {
    paginatedItems: i
  };
}
function QV(e) {
  const {
    sortedItems: t,
    paginate: n,
    group: a
  } = e, r = nt(e.pageBy);
  if (r === "item") {
    const {
      paginatedItems: l,
      pageCount: i,
      setItemsPerPage: o
    } = n(t), {
      flatItems: s
    } = a(l);
    return {
      pageCount: i,
      setItemsPerPage: o,
      paginatedItems: s
    };
  }
  if (r === "group") {
    const {
      flatItems: l,
      groups: i
    } = a(t), {
      paginatedItems: o,
      pageCount: s,
      setItemsPerPage: u
    } = n(i), c = T(() => {
      if (!o.value.length) return [];
      const d = o.value.at(0).id, f = o.value.at(-1).id, v = l.value.findIndex((h) => h.type === "group" && h.id === d), g = l.value.findIndex((h) => h.type === "group" && h.id === f), m = l.value.findIndex((h, w) => w > g && h.type === "group" && h.depth === 0);
      return l.value.slice(v, m === -1 ? void 0 : m);
    });
    return {
      pageCount: s,
      setItemsPerPage: u,
      paginatedItems: c
    };
  }
  if (r === "any") {
    const {
      flatItems: l
    } = a(t), {
      paginatedItems: i,
      pageCount: o,
      setItemsPerPage: s
    } = n(l);
    return {
      pageCount: o,
      setItemsPerPage: s,
      paginatedItems: i
    };
  }
  throw new Error(`Unrecognized pagination target ${r}`);
}
const eE = {
  showSelectAll: !1,
  allSelected: () => [],
  select: (e) => {
    let {
      items: t,
      value: n
    } = e;
    return new Set(n ? [t[0]?.value] : []);
  },
  selectAll: (e) => {
    let {
      selected: t
    } = e;
    return t;
  }
}, _b = {
  showSelectAll: !0,
  allSelected: (e) => {
    let {
      currentPage: t
    } = e;
    return t;
  },
  select: (e) => {
    let {
      items: t,
      value: n,
      selected: a
    } = e;
    for (const r of t)
      n ? a.add(r.value) : a.delete(r.value);
    return a;
  },
  selectAll: (e) => {
    let {
      value: t,
      currentPage: n,
      selected: a
    } = e;
    return _b.select({
      items: n,
      value: t,
      selected: a
    });
  }
}, tE = {
  showSelectAll: !0,
  allSelected: (e) => {
    let {
      allItems: t
    } = e;
    return t;
  },
  select: (e) => {
    let {
      items: t,
      value: n,
      selected: a
    } = e;
    for (const r of t)
      n ? a.add(r.value) : a.delete(r.value);
    return a;
  },
  selectAll: (e) => {
    let {
      value: t,
      allItems: n
    } = e;
    return new Set(t ? n.map((a) => a.value) : []);
  }
}, Tb = U({
  showSelect: Boolean,
  selectStrategy: {
    type: [String, Object],
    default: "page"
  },
  modelValue: {
    type: Array,
    default: () => []
  },
  valueComparator: Function
}, "DataTable-select"), Ib = /* @__PURE__ */ Symbol.for("vuetify:data-table-selection");
function rs(e, t) {
  let {
    allItems: n,
    currentPage: a
  } = t;
  const r = he(e, "modelValue", e.modelValue, (_) => {
    const I = e.valueComparator;
    return I ? new Set(rt(_).map((C) => n.value.find((b) => I(C, b.value))?.value ?? C)) : new Set(rt(_).map((C) => Ta(C) ? n.value.find((b) => C === b.value)?.value ?? C : n.value.find((b) => Lt(C, b.value))?.value ?? C));
  }, (_) => [..._.values()]), l = T(() => n.value.filter((_) => _.selectable)), i = T(() => nt(a).filter((_) => _.selectable)), o = T(() => {
    if (typeof e.selectStrategy == "object") return e.selectStrategy;
    switch (e.selectStrategy) {
      case "single":
        return eE;
      case "all":
        return tE;
      default:
        return _b;
    }
  }), s = ae(null);
  function u(_) {
    return rt(_).every((I) => r.value.has(I.value));
  }
  function c(_) {
    return rt(_).some((I) => r.value.has(I.value));
  }
  function d(_, I) {
    const C = o.value.select({
      items: _,
      value: I,
      selected: new Set(r.value)
    });
    r.value = C;
  }
  function f(_, I, C) {
    const b = [], p = nt(a);
    if (I = I ?? p.findIndex((x) => x.value === _.value), e.selectStrategy !== "single" && C?.shiftKey && s.value !== null) {
      const [x, k] = [s.value, I].sort((V, A) => V - A);
      b.push(...p.slice(x, k + 1).filter((V) => V.selectable));
    } else
      b.push(_), s.value = I;
    d(b, !u([_]));
  }
  function v(_) {
    const I = o.value.selectAll({
      value: _,
      allItems: l.value,
      currentPage: i.value,
      selected: new Set(r.value)
    });
    r.value = I;
  }
  const g = T(() => r.value.size > 0), m = T(() => {
    const _ = o.value.allSelected({
      allItems: l.value,
      currentPage: i.value
    });
    return !!_.length && u(_);
  }), h = D(() => o.value.showSelectAll), w = {
    toggleSelect: f,
    select: d,
    selectAll: v,
    isSelected: u,
    isSomeSelected: c,
    someSelected: g,
    allSelected: m,
    showSelectAll: h,
    lastSelectedIndex: s,
    selectStrategy: o
  };
  return st(Ib, w), w;
}
function ls() {
  const e = Le(Ib);
  if (!e) throw new Error("Missing selection!");
  return e;
}
const Ab = U({
  initialSortOrder: {
    type: String,
    default: "asc",
    validator: (e) => !e || ["asc", "desc"].includes(e)
  },
  sortBy: {
    type: Array,
    default: () => []
  },
  customKeySort: Object,
  multiSort: {
    type: [Boolean, Object],
    default: !1
  },
  mustSort: Boolean
}, "DataTable-sort"), Pb = /* @__PURE__ */ Symbol.for("vuetify:data-table-sort");
function is(e) {
  const t = D(() => e.initialSortOrder), n = he(e, "sortBy"), a = D(() => e.mustSort), r = D(() => e.multiSort);
  return {
    initialSortOrder: t,
    sortBy: n,
    multiSort: r,
    mustSort: a
  };
}
function nE(e, t) {
  if (!Qa(e))
    return {
      active: !!e
    };
  const {
    key: n,
    mode: a,
    modifier: r
  } = e, l = r === "alt" && t?.altKey || r === "shift" && t?.shiftKey;
  return {
    active: !n || t?.ctrlKey || t?.metaKey || !1,
    mode: l ? a === "append" ? "prepend" : "append" : a
  };
}
function os(e) {
  const {
    initialSortOrder: t,
    sortBy: n,
    mustSort: a,
    multiSort: r,
    page: l
  } = e, i = (u, c) => {
    if (u.key == null) return;
    let d = n.value.map((m) => ({
      ...m
    })) ?? [];
    const f = d.find((m) => m.key === u.key), v = t.value, g = t.value === "desc" ? "asc" : "desc";
    if (f)
      f.order === g ? a.value && d.length === 1 ? f.order = t.value : d = d.filter((m) => m.key !== u.key) : f.order = g;
    else {
      const {
        active: m,
        mode: h
      } = nE(r.value, c);
      m ? h === "prepend" ? d.unshift({
        key: u.key,
        order: v
      }) : d.push({
        key: u.key,
        order: v
      }) : d = [{
        key: u.key,
        order: v
      }];
    }
    n.value = d, l && (l.value = 1);
  };
  function o(u) {
    return !!n.value.find((c) => c.key === u.key);
  }
  const s = {
    sortBy: n,
    toggleSort: i,
    isSorted: o
  };
  return st(Pb, s), s;
}
function Vb() {
  const e = Le(Pb);
  if (!e) throw new Error("Missing sort!");
  return e;
}
function gd(e, t, n, a) {
  const r = Ke();
  return {
    sortedItems: T(() => n.value.length ? aE(t.value, n.value, r.current.value, {
      transform: a?.transform,
      sortFunctions: {
        ...e.customKeySort,
        ...a?.sortFunctions?.value
      },
      sortRawFunctions: a?.sortRawFunctions?.value
    }) : t.value)
  };
}
function aE(e, t, n, a) {
  const r = new Intl.Collator(n, {
    sensitivity: "accent",
    usage: "sort"
  });
  return e.map((i) => [i, a?.transform ? a.transform(i) : i]).sort((i, o) => {
    for (let s = 0; s < t.length; s++) {
      let u = !1;
      const c = t[s].key, d = t[s].order ?? "asc";
      if (d === !1) continue;
      let f = Ml(i[1], c), v = Ml(o[1], c), g = i[0].raw, m = o[0].raw;
      if (d === "desc" && ([f, v] = [v, f], [g, m] = [m, g]), a?.sortRawFunctions?.[c]) {
        const h = a.sortRawFunctions[c](g, m);
        if (h == null) continue;
        if (u = !0, h) return h;
      }
      if (a?.sortFunctions?.[c]) {
        const h = a.sortFunctions[c](f, v);
        if (h == null) continue;
        if (u = !0, h) return h;
      }
      if (!u && (f instanceof Date && v instanceof Date && (f = f.getTime(), v = v.getTime()), [f, v] = [f, v].map((h) => h != null ? h.toString().toLocaleLowerCase() : h), f !== v))
        return kl(f) && kl(v) ? 0 : kl(f) ? -1 : kl(v) ? 1 : !isNaN(f) && !isNaN(v) ? Number(f) - Number(v) : r.compare(f, v);
    }
    return 0;
  }).map((i) => {
    let [o] = i;
    return o;
  });
}
const rE = U({
  items: {
    type: Array,
    default: () => []
  },
  itemValue: {
    type: [String, Array, Function],
    default: "id"
  },
  itemSelectable: {
    type: [String, Array, Function],
    default: null
  },
  returnObject: Boolean
}, "DataIterator-items");
function lE(e, t) {
  const n = e.returnObject ? t : pt(t, e.itemValue), a = pt(t, e.itemSelectable, !0);
  return {
    type: "item",
    value: n,
    selectable: a,
    raw: t
  };
}
function iE(e, t) {
  const n = [];
  for (const a of t)
    n.push(lE(e, a));
  return n;
}
function oE(e) {
  return {
    items: T(() => iE(e, e.items))
  };
}
const sE = U({
  search: String,
  loading: Boolean,
  itemsLength: [Number, String],
  ...ve(),
  ...rE(),
  ...Tb(),
  ...Ab(),
  ...vd({
    itemsPerPage: 5
  }),
  ...gb(),
  ...dd(),
  ...yr(),
  ...Ie(),
  ...da({
    transition: {
      component: Nl,
      hideOnLeave: !0
    }
  })
}, "VDataIterator"), uE = K()({
  name: "VDataIterator",
  props: sE(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:groupBy": (e) => !0,
    "update:page": (e) => !0,
    "update:itemsPerPage": (e) => !0,
    "update:sortBy": (e) => !0,
    "update:options": (e) => !0,
    "update:expanded": (e) => !0,
    "update:currentItems": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = he(e, "groupBy"), r = D(() => e.search), {
      items: l
    } = oE(e), {
      filteredItems: i
    } = br(e, l, r, {
      transform: (z) => z.raw
    }), {
      initialSortOrder: o,
      sortBy: s,
      multiSort: u,
      mustSort: c
    } = is(e), {
      page: d,
      itemsPerPage: f
    } = md(e), {
      toggleSort: v
    } = os({
      initialSortOrder: o,
      sortBy: s,
      multiSort: u,
      mustSort: c,
      page: d
    }), {
      sortByWithGroups: g,
      opened: m,
      extractRows: h,
      isGroupOpen: w,
      toggleGroup: _
    } = ts({
      groupBy: a,
      sortBy: s
    }), {
      sortedItems: I
    } = gd(e, i, g, {
      transform: (z) => z.raw
    }), {
      flatItems: C
    } = ns(I, a, m, !1), b = D(() => !kl(e.itemsLength)), p = D(() => b.value ? Number(e.itemsLength) : C.value.length), {
      startIndex: x,
      stopIndex: k,
      pageCount: V,
      prevPage: A,
      nextPage: M,
      setItemsPerPage: L,
      setPage: E
    } = hd({
      page: d,
      itemsPerPage: f,
      itemsLength: p
    }), P = ae([]), O = T(() => b.value ? C.value : P.value);
    Wt(() => !b.value, () => {
      const {
        paginatedItems: z
      } = Cb({
        items: C,
        startIndex: x,
        stopIndex: k,
        itemsPerPage: f
      });
      ft(() => {
        P.value = z.value;
      });
    });
    const F = T(() => h(O.value)), {
      isSelected: B,
      select: N,
      selectAll: W,
      toggleSelect: R
    } = rs(e, {
      allItems: l,
      currentPage: F
    }), {
      isExpanded: j,
      toggleExpand: H
    } = es(e);
    as({
      page: d,
      itemsPerPage: f,
      sortBy: s,
      groupBy: a,
      search: r
    });
    const $ = T(() => ({
      page: d.value,
      itemsPerPage: f.value,
      sortBy: s.value,
      pageCount: V.value,
      toggleSort: v,
      prevPage: A,
      nextPage: M,
      setPage: E,
      setItemsPerPage: L,
      isSelected: B,
      select: N,
      selectAll: W,
      toggleSelect: R,
      isExpanded: j,
      toggleExpand: H,
      isGroupOpen: w,
      toggleGroup: _,
      items: F.value,
      itemsCount: i.value.length,
      groupedItems: O.value
    }));
    return X(() => y(e.tag, {
      class: J(["v-data-iterator", {
        "v-data-iterator--loading": e.loading
      }, e.class]),
      style: le(e.style)
    }, {
      default: () => [n.header?.($.value), y(Xt, {
        transition: e.transition
      }, {
        default: () => [e.loading ? y(oi, {
          key: "loader",
          name: "v-data-iterator",
          active: !0
        }, {
          default: (z) => n.loader?.(z)
        }) : S("div", {
          key: "items"
        }, [O.value.length ? n.default?.($.value) : n["no-data"]?.()])]
      }), n.footer?.($.value)]
    })), {};
  }
});
function cE() {
  const e = G([]);
  Zp(() => e.value = []);
  function t(n, a) {
    e.value[a] = n;
  }
  return {
    refs: e,
    updateRef: t
  };
}
const dE = U({
  activeColor: String,
  start: {
    type: [Number, String],
    default: 1
  },
  modelValue: {
    type: Number,
    default: (e) => e.start
  },
  disabled: Boolean,
  length: {
    type: [Number, String],
    default: 1,
    validator: (e) => e % 1 === 0
  },
  totalVisible: [Number, String],
  firstIcon: {
    type: be,
    default: "$first"
  },
  prevIcon: {
    type: be,
    default: "$prev"
  },
  nextIcon: {
    type: be,
    default: "$next"
  },
  lastIcon: {
    type: be,
    default: "$last"
  },
  ariaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.root"
  },
  pageAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.page"
  },
  currentPageAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.currentPage"
  },
  firstAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.first"
  },
  previousAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.previous"
  },
  nextAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.next"
  },
  lastAriaLabel: {
    type: String,
    default: "$vuetify.pagination.ariaLabel.last"
  },
  ellipsis: {
    type: String,
    default: "..."
  },
  showFirstLastPage: Boolean,
  ...qt(),
  ...ve(),
  ...mt(),
  ...Ct(),
  ...lt(),
  ...ea(),
  ...Ie({
    tag: "nav"
  }),
  ...Re(),
  ...xn({
    variant: "text"
  })
}, "VPagination"), Ou = K()({
  name: "VPagination",
  props: dE(),
  emits: {
    "update:modelValue": (e) => !0,
    first: (e) => !0,
    prev: (e) => !0,
    next: (e) => !0,
    last: (e) => !0
  },
  setup(e, t) {
    let {
      slots: n,
      emit: a
    } = t;
    const r = he(e, "modelValue"), {
      t: l,
      n: i
    } = Ke(), {
      isRtl: o
    } = At(), {
      themeClasses: s
    } = Ge(e), {
      width: u
    } = Cn(), c = ae(-1);
    vt(void 0, {
      scoped: !0
    });
    const {
      resizeRef: d
    } = Vn((k) => {
      if (!k.length) return;
      const {
        target: V,
        contentRect: A
      } = k[0], M = V.querySelector(".v-pagination__list > *");
      if (!M) return;
      const L = A.width, E = M.offsetWidth + parseFloat(getComputedStyle(M).marginRight) * 2;
      c.value = m(L, E);
    }), f = T(() => parseInt(e.length, 10)), v = T(() => parseInt(e.start, 10)), g = T(() => e.totalVisible != null ? parseInt(e.totalVisible, 10) : c.value >= 0 ? c.value : m(u.value, 58));
    function m(k, V) {
      const A = e.showFirstLastPage ? 5 : 3;
      return Math.max(0, Math.floor(
        // Round to two decimal places to avoid floating point errors
        Number(((k - V * A) / V).toFixed(2))
      ));
    }
    const h = T(() => {
      if (f.value <= 0 || isNaN(f.value) || f.value > Number.MAX_SAFE_INTEGER) return [];
      if (g.value <= 0) return [];
      if (g.value === 1) return [r.value];
      if (f.value <= g.value)
        return ka(f.value, v.value);
      const k = g.value % 2 === 0, V = k ? g.value / 2 : Math.floor(g.value / 2), A = k ? V : V + 1, M = f.value - V;
      if (A - r.value >= 0)
        return [...ka(Math.max(1, g.value - 1), v.value), e.ellipsis, f.value];
      if (r.value - M >= (k ? 1 : 0)) {
        const L = g.value - 1, E = f.value - L + v.value;
        return [v.value, e.ellipsis, ...ka(L, E)];
      } else {
        const L = Math.max(1, g.value - 2), E = L === 1 ? r.value : r.value - Math.ceil(L / 2) + v.value;
        return [v.value, e.ellipsis, ...ka(L, E), e.ellipsis, f.value];
      }
    });
    function w(k, V, A) {
      k.preventDefault(), r.value = V, A && a(A, V);
    }
    const {
      refs: _,
      updateRef: I
    } = cE();
    vt({
      VPaginationBtn: {
        color: D(() => e.color),
        border: D(() => e.border),
        density: D(() => e.density),
        size: D(() => e.size),
        variant: D(() => e.variant),
        rounded: D(() => e.rounded),
        elevation: D(() => e.elevation)
      }
    });
    const C = T(() => h.value.map((k, V) => {
      const A = (M) => I(M, V);
      if (typeof k == "string")
        return {
          isActive: !1,
          key: `ellipsis-${V}`,
          page: k,
          props: {
            ref: A,
            ellipsis: !0,
            icon: !0,
            disabled: !0
          }
        };
      {
        const M = k === r.value;
        return {
          isActive: M,
          key: k,
          page: i(k),
          props: {
            ref: A,
            ellipsis: !1,
            icon: !0,
            disabled: !!e.disabled || Number(e.length) < 2,
            color: M ? e.activeColor : e.color,
            "aria-current": M,
            "aria-label": l(M ? e.currentPageAriaLabel : e.pageAriaLabel, k),
            onClick: (L) => w(L, k)
          }
        };
      }
    })), b = T(() => {
      const k = !!e.disabled || r.value <= v.value, V = !!e.disabled || r.value >= v.value + f.value - 1;
      return {
        first: e.showFirstLastPage ? {
          icon: o.value ? e.lastIcon : e.firstIcon,
          onClick: (A) => w(A, v.value, "first"),
          disabled: k,
          "aria-label": l(e.firstAriaLabel),
          "aria-disabled": k
        } : void 0,
        prev: {
          icon: o.value ? e.nextIcon : e.prevIcon,
          onClick: (A) => w(A, r.value - 1, "prev"),
          disabled: k,
          "aria-label": l(e.previousAriaLabel),
          "aria-disabled": k
        },
        next: {
          icon: o.value ? e.prevIcon : e.nextIcon,
          onClick: (A) => w(A, r.value + 1, "next"),
          disabled: V,
          "aria-label": l(e.nextAriaLabel),
          "aria-disabled": V
        },
        last: e.showFirstLastPage ? {
          icon: o.value ? e.firstIcon : e.lastIcon,
          onClick: (A) => w(A, v.value + f.value - 1, "last"),
          disabled: V,
          "aria-label": l(e.lastAriaLabel),
          "aria-disabled": V
        } : void 0
      };
    });
    function p() {
      const k = r.value - v.value;
      _.value[k]?.$el.focus();
    }
    function x(k) {
      k.key === lu.left && !e.disabled && r.value > Number(e.start) ? (r.value = r.value - 1, Se(p)) : k.key === lu.right && !e.disabled && r.value < v.value + f.value - 1 && (r.value = r.value + 1, Se(p));
    }
    return X(() => y(e.tag, {
      ref: d,
      class: J(["v-pagination", s.value, e.class]),
      style: le(e.style),
      role: "navigation",
      "aria-label": l(e.ariaLabel),
      onKeydown: x,
      "data-test": "v-pagination-root"
    }, {
      default: () => [S("ul", {
        class: "v-pagination__list"
      }, [e.showFirstLastPage && S("li", {
        key: "first",
        class: "v-pagination__first",
        "data-test": "v-pagination-first"
      }, [n.first ? n.first(b.value.first) : y(De, Y({
        _as: "VPaginationBtn"
      }, b.value.first), null)]), S("li", {
        key: "prev",
        class: "v-pagination__prev",
        "data-test": "v-pagination-prev"
      }, [n.prev ? n.prev(b.value.prev) : y(De, Y({
        _as: "VPaginationBtn"
      }, b.value.prev), null)]), C.value.map((k, V) => S("li", {
        key: k.key,
        class: J(["v-pagination__item", {
          "v-pagination__item--is-active": k.isActive
        }]),
        "data-test": "v-pagination-item"
      }, [n.item ? n.item(k) : y(De, Y({
        _as: "VPaginationBtn"
      }, k.props), {
        default: () => [k.page]
      })])), S("li", {
        key: "next",
        class: "v-pagination__next",
        "data-test": "v-pagination-next"
      }, [n.next ? n.next(b.value.next) : y(De, Y({
        _as: "VPaginationBtn"
      }, b.value.next), null)]), e.showFirstLastPage && S("li", {
        key: "last",
        class: "v-pagination__last",
        "data-test": "v-pagination-last"
      }, [n.last ? n.last(b.value.last) : y(De, Y({
        _as: "VPaginationBtn"
      }, b.value.last), null)])])]
    })), {};
  }
}), yd = U({
  color: String,
  prevIcon: {
    type: be,
    default: "$prev"
  },
  nextIcon: {
    type: be,
    default: "$next"
  },
  firstIcon: {
    type: be,
    default: "$first"
  },
  lastIcon: {
    type: be,
    default: "$last"
  },
  itemsPerPageText: {
    type: String,
    default: "$vuetify.dataFooter.itemsPerPageText"
  },
  pageText: {
    type: String,
    default: "$vuetify.dataFooter.pageText"
  },
  firstPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.firstPage"
  },
  prevPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.prevPage"
  },
  nextPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.nextPage"
  },
  lastPageLabel: {
    type: String,
    default: "$vuetify.dataFooter.lastPage"
  },
  itemsPerPageOptions: {
    type: Array,
    default: () => [{
      value: 10,
      title: "10"
    }, {
      value: 25,
      title: "25"
    }, {
      value: 50,
      title: "50"
    }, {
      value: 100,
      title: "100"
    }, {
      value: -1,
      title: "$vuetify.dataFooter.itemsPerPageAll"
    }]
  },
  showCurrentPage: Boolean
}, "VDataTableFooter"), Hl = K()({
  name: "VDataTableFooter",
  props: yd(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      t: a
    } = Ke(), {
      page: r,
      pageCount: l,
      startIndex: i,
      stopIndex: o,
      itemsLength: s,
      itemsPerPage: u,
      setItemsPerPage: c
    } = XV(), d = T(() => e.itemsPerPageOptions.map((f) => typeof f == "number" ? {
      value: f,
      title: f === -1 ? a("$vuetify.dataFooter.itemsPerPageAll") : String(f)
    } : {
      ...f,
      title: isNaN(Number(f.title)) ? a(f.title) : f.title
    }));
    return X(() => {
      const f = Ou.filterProps(e);
      return S("div", {
        class: "v-data-table-footer"
      }, [n.prepend?.(), S("div", {
        class: "v-data-table-footer__items-per-page"
      }, [S("span", null, [a(e.itemsPerPageText)]), y(rd, {
        items: d.value,
        itemColor: e.color,
        modelValue: u.value,
        "onUpdate:modelValue": (v) => c(Number(v)),
        density: "compact",
        variant: "outlined",
        "aria-label": a(e.itemsPerPageText),
        hideDetails: !0
      }, null)]), S("div", {
        class: "v-data-table-footer__info"
      }, [S("div", null, [a(e.pageText, s.value ? i.value + 1 : 0, o.value, s.value)])]), S("div", {
        class: "v-data-table-footer__pagination"
      }, [y(Ou, Y({
        modelValue: r.value,
        "onUpdate:modelValue": (v) => r.value = v,
        density: "comfortable",
        firstAriaLabel: e.firstPageLabel,
        lastAriaLabel: e.lastPageLabel,
        length: l.value,
        nextAriaLabel: e.nextPageLabel,
        previousAriaLabel: e.prevPageLabel,
        rounded: !0,
        showFirstLastPage: !0,
        totalVisible: e.showCurrentPage ? 1 : 0,
        variant: "plain"
      }, Pe(f, ["color"])), null)])]);
    }), {};
  }
}), zl = U_({
  align: {
    type: String,
    default: "start"
  },
  fixed: {
    type: [Boolean, String],
    default: !1
  },
  fixedOffset: [Number, String],
  fixedEndOffset: [Number, String],
  height: [Number, String],
  lastFixed: Boolean,
  firstFixedEnd: Boolean,
  noPadding: Boolean,
  indent: [Number, String],
  empty: Boolean,
  tag: String,
  width: [Number, String],
  maxWidth: [Number, String],
  nowrap: Boolean
}, (e, t) => {
  let {
    slots: n
  } = t;
  const a = e.tag ?? "td", r = typeof e.fixed == "string" ? e.fixed : e.fixed ? "start" : "none";
  return y(a, {
    class: J(["v-data-table__td", {
      "v-data-table-column--fixed": r === "start",
      "v-data-table-column--fixed-end": r === "end",
      "v-data-table-column--last-fixed": e.lastFixed,
      "v-data-table-column--first-fixed-end": e.firstFixedEnd,
      "v-data-table-column--no-padding": e.noPadding,
      "v-data-table-column--nowrap": e.nowrap,
      "v-data-table-column--empty": e.empty
    }, `v-data-table-column--align-${e.align}`]),
    style: {
      height: re(e.height),
      width: re(e.width),
      maxWidth: re(e.maxWidth),
      left: r === "start" ? re(e.fixedOffset || null) : void 0,
      right: r === "end" ? re(e.fixedEndOffset || null) : void 0,
      paddingInlineStart: e.indent ? re(e.indent) : void 0
    }
  }, {
    default: () => [n.default?.()]
  });
}), fE = U({
  headers: Array
}, "DataTable-header"), Eb = /* @__PURE__ */ Symbol.for("vuetify:data-table-headers"), Mb = {
  title: "",
  sortable: !1
}, vE = {
  ...Mb,
  width: 48
};
function mE() {
  const t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).map((n) => ({
    element: n,
    priority: 0
  }));
  return {
    enqueue: (n, a) => {
      let r = !1;
      for (let l = 0; l < t.length; l++)
        if (t[l].priority > a) {
          t.splice(l, 0, {
            element: n,
            priority: a
          }), r = !0;
          break;
        }
      r || t.push({
        element: n,
        priority: a
      });
    },
    size: () => t.length,
    count: () => {
      let n = 0;
      if (!t.length) return 0;
      const a = Math.floor(t[0].priority);
      for (let r = 0; r < t.length; r++)
        Math.floor(t[r].priority) === a && (n += 1);
      return n;
    },
    dequeue: () => t.shift()
  };
}
function Du(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  if (!e.children)
    t.push(e);
  else
    for (const n of e.children)
      Du(n, t);
  return t;
}
function Ob(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /* @__PURE__ */ new Set();
  for (const n of e)
    n.key && t.add(n.key), n.children && Ob(n.children, t);
  return t;
}
function hE(e) {
  if (e.key) {
    if (e.key === "data-table-group") return Mb;
    if (["data-table-expand", "data-table-select"].includes(e.key)) return vE;
  }
}
function bd(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return e.children ? Math.max(t, ...e.children.map((n) => bd(n, t + 1))) : t;
}
function gE(e) {
  let t = !1;
  function n(l, i) {
    let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "none";
    if (l)
      if (o !== "none" && (l.fixed = o), l.fixed === !0 && (l.fixed = "start"), l.fixed === i)
        if (l.children)
          if (i === "start")
            for (let s = l.children.length - 1; s >= 0; s--)
              n(l.children[s], i, i);
          else
            for (let s = 0; s < l.children.length; s++)
              n(l.children[s], i, i);
        else
          !t && i === "start" ? l.lastFixed = !0 : !t && i === "end" ? l.firstFixedEnd = !0 : isNaN(Number(l.width)) ? ni(`Multiple fixed columns should have a static width (key: ${l.key})`) : l.minWidth = Math.max(Number(l.width) || 0, Number(l.minWidth) || 0), t = !0;
      else if (l.children)
        if (i === "start")
          for (let s = l.children.length - 1; s >= 0; s--)
            n(l.children[s], i);
        else
          for (let s = 0; s < l.children.length; s++)
            n(l.children[s], i);
      else
        t = !1;
  }
  for (let l = e.length - 1; l >= 0; l--)
    n(e[l], "start");
  for (let l = 0; l < e.length; l++)
    n(e[l], "end");
  let a = 0;
  for (let l = 0; l < e.length; l++)
    a = Db(e[l], a);
  let r = 0;
  for (let l = e.length - 1; l >= 0; l--)
    r = Lb(e[l], r);
}
function Db(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!e) return t;
  if (e.children) {
    e.fixedOffset = t;
    for (const n of e.children)
      t = Db(n, t);
  } else e.fixed && e.fixed !== "end" && (e.fixedOffset = t, t += parseFloat(e.width || "0") || 0);
  return t;
}
function Lb(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!e) return t;
  if (e.children) {
    e.fixedEndOffset = t;
    for (const n of e.children)
      t = Lb(n, t);
  } else e.fixed === "end" && (e.fixedEndOffset = t, t += parseFloat(e.width || "0") || 0);
  return t;
}
function yE(e, t) {
  const n = [];
  let a = 0;
  const r = mE(e);
  for (; r.size() > 0; ) {
    let i = r.count();
    const o = [];
    let s = 1;
    for (; i > 0; ) {
      const {
        element: u,
        priority: c
      } = r.dequeue(), d = t - a - bd(u);
      if (o.push({
        ...u,
        rowspan: d ?? 1,
        colspan: u.children ? Du(u).length : 1
      }), u.children)
        for (const f of u.children) {
          const v = c % 1 + s / Math.pow(10, a + 2);
          r.enqueue(f, a + d + v);
        }
      s += 1, i -= 1;
    }
    a += 1, n.push(o);
  }
  return {
    columns: e.map((i) => Du(i)).flat(),
    headers: n
  };
}
function Nb(e) {
  const t = [];
  for (const n of e) {
    const a = {
      ...hE(n),
      ...n
    }, r = a.key ?? (typeof a.value == "string" ? a.value : null), l = a.value ?? r ?? null, i = {
      ...a,
      key: r,
      value: l,
      sortable: a.sortable ?? (a.key != null || !!a.sort),
      children: a.children ? Nb(a.children) : void 0
    };
    t.push(i);
  }
  return t;
}
function pd(e, t) {
  const n = G([]), a = G([]), r = G({}), l = G({}), i = G({});
  ft(() => {
    const u = (e.headers || Object.keys(e.items[0] ?? {}).map((m) => ({
      key: m,
      title: Zr(m)
    }))).slice(), c = Ob(u);
    t?.groupBy?.value.length && !c.has("data-table-group") && u.unshift({
      key: "data-table-group",
      title: "Group"
    }), t?.showSelect?.value && !c.has("data-table-select") && u.unshift({
      key: "data-table-select"
    }), t?.showExpand?.value && !c.has("data-table-expand") && u.push({
      key: "data-table-expand"
    });
    const d = Nb(u);
    gE(d);
    const f = Math.max(...d.map((m) => bd(m))) + 1, v = yE(d, f);
    n.value = v.headers, a.value = v.columns;
    const g = v.headers.flat(1);
    for (const m of g)
      m.key && (m.sortable && (m.sort && (r.value[m.key] = m.sort), m.sortRaw && (l.value[m.key] = m.sortRaw)), m.filter && (i.value[m.key] = m.filter));
  });
  const o = {
    headers: n,
    columns: a,
    sortFunctions: r,
    sortRawFunctions: l,
    filterFunctions: i
  };
  return st(Eb, o), o;
}
function ss() {
  const e = Le(Eb);
  if (!e) throw new Error("Missing headers!");
  return e;
}
const Fb = U({
  color: String,
  disableSort: Boolean,
  fixedHeader: Boolean,
  multiSort: Boolean,
  initialSortOrder: String,
  sortIcon: {
    type: be
    // default: '$sort', // maybe in v4
  },
  sortAscIcon: {
    type: be,
    default: "$sortAsc"
  },
  sortDescIcon: {
    type: be,
    default: "$sortDesc"
  },
  headerProps: {
    type: Object
  },
  /** @deprecated */
  sticky: Boolean,
  ...mt(),
  ...hr(),
  ...Wo()
}, "VDataTableHeaders"), ar = K()({
  name: "VDataTableHeaders",
  props: Fb(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      t: a
    } = Ke(), {
      toggleSort: r,
      sortBy: l,
      isSorted: i
    } = Vb(), {
      someSelected: o,
      allSelected: s,
      selectAll: u,
      showSelectAll: c
    } = ls(), {
      columns: d,
      headers: f
    } = ss(), {
      loaderClasses: v
    } = ii(e);
    function g(V, A) {
      if (!(e.sticky || e.fixedHeader) && !V.fixed) return;
      const M = typeof V.fixed == "string" ? V.fixed : V.fixed ? "start" : "none";
      return {
        position: "sticky",
        left: M === "start" ? re(V.fixedOffset) : void 0,
        right: M === "end" ? re(V.fixedEndOffset) : void 0,
        top: e.sticky || e.fixedHeader ? `calc(var(--v-table-header-height) * ${A})` : void 0
      };
    }
    function m(V, A) {
      V.key === "Enter" && !e.disableSort && r(A, V);
    }
    function h(V) {
      switch (l.value.find((M) => M.key === V.key)?.order) {
        case "asc":
          return e.sortAscIcon;
        case "desc":
          return e.sortDescIcon;
        default:
          return e.sortIcon || (e.initialSortOrder === "asc" ? e.sortAscIcon : e.sortDescIcon);
      }
    }
    const {
      backgroundColorClasses: w,
      backgroundColorStyles: _
    } = qe(() => e.color), {
      displayClasses: I,
      mobile: C
    } = Cn(e), b = T(() => ({
      headers: f.value,
      columns: d.value,
      toggleSort: r,
      isSorted: i,
      sortBy: l.value,
      someSelected: o.value,
      allSelected: s.value,
      selectAll: u,
      getSortIcon: h
    })), p = T(() => ["v-data-table__th", {
      "v-data-table__th--sticky": e.sticky || e.fixedHeader
    }, I.value, v.value]), x = (V) => {
      let {
        column: A,
        x: M,
        y: L
      } = V;
      const E = A.key === "data-table-select" || A.key === "data-table-expand", P = A.key === "data-table-group" && A.width === 0 && !A.title, O = Y(e.headerProps ?? {}, A.headerProps ?? {});
      return y(zl, Y({
        tag: "th",
        align: A.align,
        class: [{
          "v-data-table__th--sortable": A.sortable && !e.disableSort,
          "v-data-table__th--sorted": i(A),
          "v-data-table__th--fixed": A.fixed
        }, ...p.value],
        style: {
          width: re(A.width),
          minWidth: re(A.minWidth),
          maxWidth: re(A.maxWidth),
          ...g(A, L)
        },
        colspan: A.colspan,
        rowspan: A.rowspan,
        fixed: A.fixed,
        nowrap: A.nowrap,
        lastFixed: A.lastFixed,
        firstFixedEnd: A.firstFixedEnd,
        noPadding: E,
        empty: P,
        tabindex: A.sortable ? 0 : void 0,
        onClick: A.sortable ? (F) => r(A, F) : void 0,
        onKeydown: A.sortable ? (F) => m(F, A) : void 0
      }, O), {
        default: () => {
          const F = `header.${A.key}`, B = {
            column: A,
            selectAll: u,
            isSorted: i,
            toggleSort: r,
            sortBy: l.value,
            someSelected: o.value,
            allSelected: s.value,
            getSortIcon: h
          };
          return n[F] ? n[F](B) : P ? "" : A.key === "data-table-select" ? n["header.data-table-select"]?.(B) ?? (c.value && y(Un, {
            color: e.color,
            density: e.density,
            modelValue: s.value,
            indeterminate: o.value && !s.value,
            "onUpdate:modelValue": u
          }, null)) : S("div", {
            class: "v-data-table-header__content"
          }, [S("span", null, [A.title]), A.sortable && !e.disableSort && y(ze, {
            key: "icon",
            class: "v-data-table-header__sort-icon",
            icon: h(A)
          }, null), e.multiSort && i(A) && S("div", {
            key: "badge",
            class: J(["v-data-table-header__sort-badge", ...w.value]),
            style: le(_.value)
          }, [l.value.findIndex((N) => N.key === A.key) + 1])]);
        }
      });
    }, k = () => {
      const V = T(() => d.value.filter((M) => M?.sortable && !e.disableSort)), A = d.value.find((M) => M.key === "data-table-select");
      return y(zl, Y({
        tag: "th",
        class: [...p.value],
        colspan: f.value.length + 1
      }, e.headerProps), {
        default: () => [S("div", {
          class: "v-data-table-header__content"
        }, [y(rd, {
          chips: !0,
          color: e.color,
          class: "v-data-table__td-sort-select",
          clearable: !0,
          density: "default",
          items: V.value,
          label: a("$vuetify.dataTable.sortBy"),
          multiple: e.multiSort,
          variant: "underlined",
          "onClick:clear": () => l.value = []
        }, {
          append: A ? () => y(Un, {
            color: e.color,
            density: "compact",
            modelValue: s.value,
            indeterminate: o.value && !s.value,
            "onUpdate:modelValue": () => u(!s.value)
          }, null) : void 0,
          chip: (M) => y(ua, {
            onClick: M.item.raw?.sortable ? () => r(M.item.raw) : void 0,
            onMousedown: (L) => {
              L.preventDefault(), L.stopPropagation();
            }
          }, {
            default: () => [M.item.title, y(ze, {
              class: J(["v-data-table__td-sort-icon", i(M.item.raw) && "v-data-table__td-sort-icon-active"]),
              icon: h(M.item.raw),
              size: "small"
            }, null)]
          })
        })])]
      });
    };
    X(() => C.value ? S("tr", null, [y(k, null, null)]) : S(fe, null, [n.headers ? n.headers(b.value) : f.value.map((V, A) => S("tr", null, [V.map((M, L) => y(x, {
      column: M,
      x: L,
      y: A
    }, null))])), e.loading && S("tr", {
      class: "v-data-table-progress"
    }, [S("th", {
      colspan: d.value.length
    }, [y(oi, {
      name: "v-data-table-progress",
      absolute: !0,
      active: !0,
      color: typeof e.loading == "boolean" || e.loading === "true" ? e.color : e.loading,
      indeterminate: !0
    }, {
      default: n.loader
    })])])]));
  }
}), Rb = U({
  item: {
    type: Object,
    required: !0
  },
  groupCollapseIcon: {
    type: be,
    default: "$tableGroupCollapse"
  },
  groupExpandIcon: {
    type: be,
    default: "$tableGroupExpand"
  },
  ...mt()
}, "VDataTableGroupHeaderRow"), bE = K()({
  name: "VDataTableGroupHeaderRow",
  props: Rb(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      isGroupOpen: a,
      toggleGroup: r,
      extractRows: l
    } = wb(), {
      isSelected: i,
      isSomeSelected: o,
      select: s
    } = ls(), {
      columns: u
    } = ss(), c = T(() => l([e.item])), d = D(() => u.value.length - (u.value.some((f) => f.key === "data-table-select") ? 1 : 0));
    return () => S("tr", {
      class: "v-data-table-group-header-row",
      style: {
        "--v-data-table-group-header-row-depth": e.item.depth
      }
    }, [u.value.map((f) => {
      if (f.key === "data-table-group") {
        const v = a(e.item) ? e.groupCollapseIcon : e.groupExpandIcon, g = () => r(e.item);
        return n["data-table-group"]?.({
          item: e.item,
          count: c.value.length,
          props: {
            icon: v,
            onClick: g
          }
        }) ?? y(zl, {
          class: "v-data-table-group-header-row__column",
          colspan: d.value
        }, {
          default: () => [y(De, {
            size: "small",
            variant: "text",
            icon: v,
            onClick: g
          }, null), S("span", null, [e.item.value]), S("span", null, [we("("), c.value.length, we(")")])]
        });
      } else if (f.key === "data-table-select") {
        const v = c.value.filter((w) => w.selectable), g = v.length > 0 && i(v), m = o(v) && !g, h = (w) => s(v, w);
        return n["data-table-select"]?.({
          props: {
            modelValue: g,
            indeterminate: m,
            "onUpdate:modelValue": h
          }
        }) ?? y(zl, {
          class: "v-data-table__td--select-row",
          noPadding: !0
        }, {
          default: () => [y(Un, {
            density: e.density,
            disabled: v.length === 0,
            modelValue: g,
            indeterminate: m,
            "onUpdate:modelValue": h
          }, null)]
        });
      }
      return "";
    })]);
  }
}), $b = U({
  color: String,
  index: Number,
  item: Object,
  cellProps: [Object, Function],
  collapseIcon: {
    type: be,
    default: "$collapse"
  },
  expandIcon: {
    type: be,
    default: "$expand"
  },
  onClick: Ut(),
  onContextmenu: Ut(),
  onDblclick: Ut(),
  ...mt(),
  ...hr()
}, "VDataTableRow"), wd = K()({
  name: "VDataTableRow",
  props: $b(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      displayClasses: a,
      mobile: r
    } = Cn(e, "v-data-table__tr"), {
      isSelected: l,
      toggleSelect: i,
      someSelected: o,
      allSelected: s,
      selectAll: u
    } = ls(), {
      isExpanded: c,
      toggleExpand: d
    } = bb(), {
      toggleSort: f,
      sortBy: v,
      isSorted: g
    } = Vb(), {
      columns: m
    } = ss();
    X(() => S("tr", {
      class: J(["v-data-table__tr", {
        "v-data-table__tr--clickable": !!(e.onClick || e.onContextmenu || e.onDblclick)
      }, a.value]),
      onClick: e.onClick,
      onContextmenu: e.onContextmenu,
      onDblclick: e.onDblclick
    }, [e.item && m.value.map((h, w) => {
      const _ = e.item, I = `item.${h.key}`, C = `header.${h.key}`, b = {
        index: e.index,
        item: _.raw,
        internalItem: _,
        value: Ml(_.columns, h.key),
        column: h,
        isSelected: l,
        toggleSelect: i,
        isExpanded: c,
        toggleExpand: d
      }, p = {
        column: h,
        selectAll: u,
        isSorted: g,
        toggleSort: f,
        sortBy: v.value,
        someSelected: o.value,
        allSelected: s.value,
        getSortIcon: () => ""
      }, x = typeof e.cellProps == "function" ? e.cellProps({
        index: b.index,
        item: b.item,
        internalItem: b.internalItem,
        value: b.value,
        column: h
      }) : e.cellProps, k = typeof h.cellProps == "function" ? h.cellProps({
        index: b.index,
        item: b.item,
        internalItem: b.internalItem,
        value: b.value
      }) : h.cellProps, V = h.key === "data-table-select" || h.key === "data-table-expand", A = h.key === "data-table-group" && h.width === 0 && !h.title;
      return y(zl, Y({
        align: h.align,
        indent: h.indent,
        class: {
          "v-data-table__td--expanded-row": h.key === "data-table-expand",
          "v-data-table__td--select-row": h.key === "data-table-select"
        },
        fixed: h.fixed,
        fixedOffset: h.fixedOffset,
        fixedEndOffset: h.fixedEndOffset,
        lastFixed: h.lastFixed,
        firstFixedEnd: h.firstFixedEnd,
        maxWidth: r.value ? void 0 : h.maxWidth,
        noPadding: V,
        empty: A,
        nowrap: h.nowrap,
        width: r.value ? void 0 : h.width
      }, x, k), {
        default: () => {
          if (h.key === "data-table-select")
            return n["item.data-table-select"]?.({
              ...b,
              props: {
                color: e.color,
                disabled: !_.selectable,
                modelValue: l([_]),
                onClick: zn(() => i(_), ["stop"])
              }
            }) ?? y(Un, {
              color: e.color,
              disabled: !_.selectable,
              density: e.density,
              modelValue: l([_]),
              onClick: zn((L) => i(_, e.index, L), ["stop"])
            }, null);
          if (h.key === "data-table-expand")
            return n["item.data-table-expand"]?.({
              ...b,
              props: {
                icon: c(_) ? e.collapseIcon : e.expandIcon,
                size: "small",
                variant: "text",
                onClick: zn(() => d(_), ["stop"])
              }
            }) ?? y(De, {
              icon: c(_) ? e.collapseIcon : e.expandIcon,
              size: "small",
              variant: "text",
              onClick: zn(() => d(_), ["stop"])
            }, null);
          if (n[I] && !r.value) return n[I](b);
          const M = ce(b.value);
          return r.value ? S(fe, null, [S("div", {
            class: "v-data-table__td-title"
          }, [n[C]?.(p) ?? h.title]), S("div", {
            class: "v-data-table__td-value"
          }, [n[I]?.(b) ?? M])]) : M;
        }
      });
    })]));
  }
}), Bb = U({
  color: String,
  loading: [Boolean, String],
  loadingText: {
    type: String,
    default: "$vuetify.dataIterator.loadingText"
  },
  hideNoData: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  noDataText: {
    type: String,
    default: "$vuetify.noDataText"
  },
  rowProps: [Object, Function],
  cellProps: [Object, Function],
  ...an($b(), ["collapseIcon", "expandIcon", "density"]),
  ...an(Rb(), ["groupCollapseIcon", "groupExpandIcon", "density"]),
  ...hr()
}, "VDataTableRows"), rr = K()({
  name: "VDataTableRows",
  inheritAttrs: !1,
  props: Bb(),
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const {
      columns: r
    } = ss(), {
      expandOnClick: l,
      toggleExpand: i,
      isExpanded: o
    } = bb(), {
      isSelected: s,
      toggleSelect: u
    } = ls(), {
      toggleGroup: c,
      isGroupOpen: d
    } = wb(), {
      t: f
    } = Ke(), {
      mobile: v
    } = Cn(e);
    return X(() => {
      const g = an(e, ["groupCollapseIcon", "groupExpandIcon", "density"]);
      return e.loading && (!e.items.length || a.loading) ? S("tr", {
        class: "v-data-table-rows-loading",
        key: "loading"
      }, [S("td", {
        colspan: r.value.length
      }, [a.loading?.() ?? f(e.loadingText)])]) : !e.loading && !e.items.length && !e.hideNoData ? S("tr", {
        class: "v-data-table-rows-no-data",
        key: "no-data"
      }, [S("td", {
        colspan: r.value.length
      }, [a["no-data"]?.() ?? f(e.noDataText)])]) : S(fe, null, [e.items.map((m, h) => {
        if (m.type === "group") {
          const I = {
            index: h,
            item: m,
            columns: r.value,
            isExpanded: o,
            toggleExpand: i,
            isSelected: s,
            toggleSelect: u,
            toggleGroup: c,
            isGroupOpen: d
          };
          return a["group-header"] ? a["group-header"](I) : y(bE, Y({
            key: `group-header_${m.id}`,
            item: m
          }, bn(n, ":groupHeader", () => I), g), a);
        }
        if (m.type === "group-summary") {
          const I = {
            index: h,
            item: m,
            columns: r.value,
            toggleGroup: c
          };
          return a["group-summary"]?.(I) ?? "";
        }
        const w = {
          index: m.virtualIndex ?? h,
          item: m.raw,
          internalItem: m,
          columns: r.value,
          isExpanded: o,
          toggleExpand: i,
          isSelected: s,
          toggleSelect: u
        }, _ = {
          ...w,
          props: Y({
            key: `item_${m.key ?? m.index}`,
            onClick: l.value ? () => {
              i(m);
            } : void 0,
            index: h,
            item: m,
            color: e.color,
            cellProps: e.cellProps,
            collapseIcon: e.collapseIcon,
            expandIcon: e.expandIcon,
            density: e.density,
            mobile: v.value
          }, bn(n, ":row", () => w), typeof e.rowProps == "function" ? e.rowProps({
            item: w.item,
            index: w.index,
            internalItem: w.internalItem
          }) : e.rowProps)
        };
        return S(fe, {
          key: _.props.key
        }, [a.item ? a.item(_) : y(wd, _.props, a), o(m) && a["expanded-row"]?.(w)]);
      })]);
    }), {};
  }
}), Ub = U({
  fixedHeader: Boolean,
  fixedFooter: Boolean,
  height: [Number, String],
  hover: Boolean,
  striped: {
    type: String,
    default: null,
    validator: (e) => ["even", "odd"].includes(e)
  },
  ...ve(),
  ...mt(),
  ...Ie(),
  ...Re()
}, "VTable"), lr = K()({
  name: "VTable",
  props: Ub(),
  setup(e, t) {
    let {
      slots: n,
      emit: a
    } = t;
    const {
      themeClasses: r
    } = Ge(e), {
      densityClasses: l
    } = zt(e);
    return X(() => y(e.tag, {
      class: J(["v-table", {
        "v-table--fixed-height": !!e.height,
        "v-table--fixed-header": e.fixedHeader,
        "v-table--fixed-footer": e.fixedFooter,
        "v-table--has-top": !!n.top,
        "v-table--has-bottom": !!n.bottom,
        "v-table--hover": e.hover,
        "v-table--striped-even": e.striped === "even",
        "v-table--striped-odd": e.striped === "odd"
      }, r.value, l.value, e.class]),
      style: le(e.style)
    }, {
      default: () => [n.top?.(), n.default ? S("div", {
        class: "v-table__wrapper",
        style: {
          height: re(e.height)
        }
      }, [S("table", null, [n.default()])]) : n.wrapper?.(), n.bottom?.()]
    })), {};
  }
}), pE = U({
  items: {
    type: Array,
    default: () => []
  },
  itemValue: {
    type: [String, Array, Function],
    default: "id"
  },
  itemSelectable: {
    type: [String, Array, Function],
    default: null
  },
  rowProps: [Object, Function],
  cellProps: [Object, Function],
  returnObject: Boolean
}, "DataTable-items");
function wE(e, t, n, a) {
  const r = e.returnObject ? t : pt(t, e.itemValue), l = pt(t, e.itemSelectable, !0), i = a.reduce((o, s) => (s.key != null && (o[s.key] = pt(t, s.value)), o), {});
  return {
    type: "item",
    key: e.returnObject ? pt(t, e.itemValue) : r,
    index: n,
    value: r,
    selectable: l,
    columns: i,
    raw: t
  };
}
function kE(e, t, n) {
  return t.map((a, r) => wE(e, a, r, n));
}
function kd(e, t) {
  return {
    items: T(() => kE(e, e.items, t.value))
  };
}
const Sd = U({
  ...Bb(),
  hideDefaultBody: Boolean,
  hideDefaultFooter: Boolean,
  hideDefaultHeader: Boolean,
  width: [String, Number],
  search: String,
  ...gb(),
  ...dd(),
  ...fE(),
  ...pE(),
  ...Tb(),
  ...Ab(),
  ...Pe(Fb(), ["multiSort", "initialSortOrder"]),
  ...Ub()
}, "DataTable"), SE = U({
  ...vd(),
  ...Sd(),
  ...yr(),
  ...yd()
}, "VDataTable"), xE = K()({
  name: "VDataTable",
  props: SE(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:page": (e) => !0,
    "update:itemsPerPage": (e) => !0,
    "update:sortBy": (e) => !0,
    "update:options": (e) => !0,
    "update:groupBy": (e) => !0,
    "update:expanded": (e) => !0,
    "update:currentItems": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const {
      groupBy: r
    } = fd(e), {
      initialSortOrder: l,
      sortBy: i,
      multiSort: o,
      mustSort: s
    } = is(e), {
      page: u,
      itemsPerPage: c
    } = md(e), {
      disableSort: d
    } = Kr(e), {
      columns: f,
      headers: v,
      sortFunctions: g,
      sortRawFunctions: m,
      filterFunctions: h
    } = pd(e, {
      groupBy: r,
      showSelect: D(() => e.showSelect),
      showExpand: D(() => e.showExpand)
    }), {
      items: w
    } = kd(e, f), _ = D(() => e.search), {
      filteredItems: I
    } = br(e, w, _, {
      transform: (te) => te.columns,
      customKeyFilter: h
    }), {
      toggleSort: C
    } = os({
      initialSortOrder: l,
      sortBy: i,
      multiSort: o,
      mustSort: s,
      page: u
    }), {
      sortByWithGroups: b,
      opened: p,
      extractRows: x,
      isGroupOpen: k,
      toggleGroup: V
    } = ts({
      groupBy: r,
      sortBy: i,
      disableSort: d
    }), {
      sortedItems: A
    } = gd(e, I, b, {
      transform: (te) => ({
        ...te.raw,
        ...te.columns
      }),
      sortFunctions: g,
      sortRawFunctions: m
    }), M = T(() => e.pageBy === "auto" ? e.groupBy.length ? "group" : "item" : e.pageBy), {
      pageCount: L,
      setItemsPerPage: E,
      paginatedItems: P
    } = QV({
      pageBy: M,
      sortedItems: A,
      paginate: (te) => {
        const me = T(() => nt(te).length), {
          startIndex: Q,
          stopIndex: ie,
          pageCount: ke,
          setItemsPerPage: ye
        } = hd({
          page: u,
          itemsPerPage: c,
          itemsLength: me
        }), {
          paginatedItems: ue
        } = Cb({
          items: te,
          startIndex: Q,
          stopIndex: ie,
          itemsPerPage: c
        });
        return {
          paginatedItems: ue,
          pageCount: ke,
          setItemsPerPage: ye
        };
      },
      group: (te) => ns(te, r, p, () => !!a["group-summary"])
    }), O = T(() => x(P.value)), {
      isSelected: F,
      select: B,
      selectAll: N,
      toggleSelect: W,
      someSelected: R,
      allSelected: j
    } = rs(e, {
      allItems: w,
      currentPage: O
    }), {
      isExpanded: H,
      toggleExpand: $
    } = es(e);
    as({
      page: u,
      itemsPerPage: c,
      sortBy: i,
      groupBy: r,
      search: _
    }), vt({
      VDataTableRows: {
        hideNoData: D(() => e.hideNoData),
        noDataText: D(() => e.noDataText),
        loading: D(() => e.loading),
        loadingText: D(() => e.loadingText)
      }
    });
    const z = T(() => ({
      page: u.value,
      itemsPerPage: c.value,
      sortBy: i.value,
      pageCount: L.value,
      toggleSort: C,
      setItemsPerPage: E,
      someSelected: R.value,
      allSelected: j.value,
      isSelected: F,
      select: B,
      selectAll: N,
      toggleSelect: W,
      isExpanded: H,
      toggleExpand: $,
      isGroupOpen: k,
      toggleGroup: V,
      items: O.value.map((te) => te.raw),
      internalItems: O.value,
      groupedItems: P.value,
      columns: f.value,
      headers: v.value
    }));
    return X(() => {
      const te = Hl.filterProps(e), me = ar.filterProps(Pe(e, ["multiSort"])), Q = rr.filterProps(e), ie = lr.filterProps(e);
      return y(lr, Y({
        class: ["v-data-table", {
          "v-data-table--show-select": e.showSelect,
          "v-data-table--loading": e.loading
        }, e.class],
        style: e.style
      }, ie, {
        fixedHeader: e.fixedHeader || e.sticky
      }), {
        top: () => a.top?.(z.value),
        default: () => a.default ? a.default(z.value) : S(fe, null, [a.colgroup?.(z.value), !e.hideDefaultHeader && S("thead", {
          key: "thead"
        }, [y(ar, Y(me, {
          multiSort: !!e.multiSort
        }), a)]), a.thead?.(z.value), !e.hideDefaultBody && S("tbody", null, [a["body.prepend"]?.(z.value), a.body ? a.body(z.value) : y(rr, Y(n, Q, {
          items: P.value
        }), a), a["body.append"]?.(z.value)]), a.tbody?.(z.value), a.tfoot?.(z.value)]),
        bottom: () => a.bottom ? a.bottom(z.value) : !e.hideDefaultFooter && S(fe, null, [y(pn, null, null), y(Hl, te, {
          prepend: a["footer.prepend"]
        })])
      });
    }), {};
  }
}), CE = U({
  ...Pe(Sd(), ["hideDefaultFooter"]),
  ...dd(),
  ...Iy(),
  ...yr()
}, "VDataTableVirtual"), _E = K()({
  name: "VDataTableVirtual",
  props: CE(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:sortBy": (e) => !0,
    "update:options": (e) => !0,
    "update:groupBy": (e) => !0,
    "update:expanded": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const {
      groupBy: r
    } = fd(e), {
      initialSortOrder: l,
      sortBy: i,
      multiSort: o,
      mustSort: s
    } = is(e), {
      disableSort: u
    } = Kr(e), {
      columns: c,
      headers: d,
      filterFunctions: f,
      sortFunctions: v,
      sortRawFunctions: g
    } = pd(e, {
      groupBy: r,
      showSelect: D(() => e.showSelect),
      showExpand: D(() => e.showExpand)
    }), {
      items: m
    } = kd(e, c), h = D(() => e.search), {
      filteredItems: w
    } = br(e, m, h, {
      transform: (ue) => ue.columns,
      customKeyFilter: f
    }), {
      toggleSort: _
    } = os({
      initialSortOrder: l,
      sortBy: i,
      multiSort: o,
      mustSort: s
    }), {
      sortByWithGroups: I,
      opened: C,
      extractRows: b,
      isGroupOpen: p,
      toggleGroup: x
    } = ts({
      groupBy: r,
      sortBy: i,
      disableSort: u
    }), {
      sortedItems: k
    } = gd(e, w, I, {
      transform: (ue) => ({
        ...ue.raw,
        ...ue.columns
      }),
      sortFunctions: v,
      sortRawFunctions: g
    }), {
      flatItems: V
    } = ns(k, r, C, () => !!a["group-summary"]), A = T(() => b(V.value)), {
      isSelected: M,
      select: L,
      selectAll: E,
      toggleSelect: P,
      someSelected: O,
      allSelected: F
    } = rs(e, {
      allItems: A,
      currentPage: A
    }), {
      isExpanded: B,
      toggleExpand: N
    } = es(e), {
      containerRef: W,
      markerRef: R,
      paddingTop: j,
      paddingBottom: H,
      computedItems: $,
      handleItemResize: z,
      handleScroll: te,
      handleScrollend: me,
      calculateVisibleItems: Q,
      scrollToIndex: ie
    } = Ay(e, V), ke = T(() => $.value.map((ue) => ({
      ...ue.raw,
      virtualIndex: ue.index
    })));
    as({
      sortBy: i,
      page: ae(1),
      itemsPerPage: ae(-1),
      groupBy: r,
      search: h
    }), vt({
      VDataTableRows: {
        hideNoData: D(() => e.hideNoData),
        noDataText: D(() => e.noDataText),
        loading: D(() => e.loading),
        loadingText: D(() => e.loadingText)
      }
    });
    const ye = T(() => ({
      sortBy: i.value,
      toggleSort: _,
      someSelected: O.value,
      allSelected: F.value,
      isSelected: M,
      select: L,
      selectAll: E,
      toggleSelect: P,
      isExpanded: B,
      toggleExpand: N,
      isGroupOpen: p,
      toggleGroup: x,
      items: A.value.map((ue) => ue.raw),
      internalItems: A.value,
      groupedItems: V.value,
      columns: c.value,
      headers: d.value
    }));
    return X(() => {
      const ue = ar.filterProps(Pe(e, ["multiSort"])), Te = rr.filterProps(e), Ne = lr.filterProps(e);
      return y(lr, Y({
        class: ["v-data-table", {
          "v-data-table--loading": e.loading
        }, e.class],
        style: e.style
      }, Ne, {
        fixedHeader: e.fixedHeader || e.sticky
      }), {
        top: () => a.top?.(ye.value),
        wrapper: () => S("div", {
          ref: W,
          onScrollPassive: te,
          onScrollend: me,
          class: "v-table__wrapper",
          style: {
            height: re(e.height)
          }
        }, [S("table", null, [a.colgroup?.(ye.value), !e.hideDefaultHeader && S("thead", {
          key: "thead"
        }, [y(ar, Y(ue, {
          multiSort: !!e.multiSort
        }), a)]), a.thead?.(ye.value), !e.hideDefaultBody && S("tbody", {
          key: "tbody"
        }, [S("tr", {
          ref: R,
          style: {
            height: re(j.value),
            border: 0
          }
        }, [S("td", {
          colspan: c.value.length,
          style: {
            height: 0,
            border: 0
          }
        }, null)]), a["body.prepend"]?.(ye.value), y(rr, Y(n, Te, {
          items: ke.value
        }), {
          ...a,
          item: (je) => y(Ty, {
            key: je.internalItem.index,
            renderless: !0,
            "onUpdate:height": (xe) => z(je.internalItem.index, xe)
          }, {
            default: (xe) => {
              let {
                itemRef: Be
              } = xe;
              return a.item?.({
                ...je,
                itemRef: Be
              }) ?? y(wd, Y(je.props, {
                ref: Be,
                key: je.internalItem.index,
                index: je.index
              }), a);
            }
          })
        }), a["body.append"]?.(ye.value), S("tr", {
          style: {
            height: re(H.value),
            border: 0
          }
        }, [S("td", {
          colspan: c.value.length,
          style: {
            height: 0,
            border: 0
          }
        }, null)])]), a.tbody?.(ye.value), a.tfoot?.(ye.value)])]),
        bottom: () => a.bottom?.(ye.value)
      });
    }), {
      calculateVisibleItems: Q,
      scrollToIndex: ie
    };
  }
}), TE = U({
  itemsLength: {
    type: [Number, String],
    required: !0
  },
  ...vd(),
  ...Sd(),
  ...yd()
}, "VDataTableServer"), IE = K()({
  name: "VDataTableServer",
  props: TE(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:page": (e) => !0,
    "update:itemsPerPage": (e) => !0,
    "update:sortBy": (e) => !0,
    "update:options": (e) => !0,
    "update:expanded": (e) => !0,
    "update:groupBy": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const {
      groupBy: r
    } = fd(e), {
      initialSortOrder: l,
      sortBy: i,
      multiSort: o,
      mustSort: s
    } = is(e), {
      page: u,
      itemsPerPage: c
    } = md(e), {
      disableSort: d
    } = Kr(e), f = T(() => parseInt(e.itemsLength, 10)), {
      columns: v,
      headers: g
    } = pd(e, {
      groupBy: r,
      showSelect: D(() => e.showSelect),
      showExpand: D(() => e.showExpand)
    }), {
      items: m
    } = kd(e, v), {
      toggleSort: h
    } = os({
      initialSortOrder: l,
      sortBy: i,
      multiSort: o,
      mustSort: s,
      page: u
    }), {
      opened: w,
      isGroupOpen: _,
      toggleGroup: I,
      extractRows: C
    } = ts({
      groupBy: r,
      sortBy: i,
      disableSort: d
    }), {
      pageCount: b,
      setItemsPerPage: p
    } = hd({
      page: u,
      itemsPerPage: c,
      itemsLength: f
    }), {
      flatItems: x
    } = ns(m, r, w, () => !!a["group-summary"]), {
      isSelected: k,
      select: V,
      selectAll: A,
      toggleSelect: M,
      someSelected: L,
      allSelected: E
    } = rs(e, {
      allItems: m,
      currentPage: m
    }), {
      isExpanded: P,
      toggleExpand: O
    } = es(e), F = T(() => C(m.value));
    as({
      page: u,
      itemsPerPage: c,
      sortBy: i,
      groupBy: r,
      search: D(() => e.search)
    }), st("v-data-table", {
      toggleSort: h,
      sortBy: i
    }), vt({
      VDataTableRows: {
        hideNoData: D(() => e.hideNoData),
        noDataText: D(() => e.noDataText),
        loading: D(() => e.loading),
        loadingText: D(() => e.loadingText)
      }
    });
    const B = T(() => ({
      page: u.value,
      itemsPerPage: c.value,
      sortBy: i.value,
      pageCount: b.value,
      toggleSort: h,
      setItemsPerPage: p,
      someSelected: L.value,
      allSelected: E.value,
      isSelected: k,
      select: V,
      selectAll: A,
      toggleSelect: M,
      isExpanded: P,
      toggleExpand: O,
      isGroupOpen: _,
      toggleGroup: I,
      items: F.value.map((N) => N.raw),
      internalItems: F.value,
      groupedItems: x.value,
      columns: v.value,
      headers: g.value
    }));
    X(() => {
      const N = Hl.filterProps(e), W = ar.filterProps(Pe(e, ["multiSort"])), R = rr.filterProps(e), j = lr.filterProps(e);
      return y(lr, Y({
        class: ["v-data-table", {
          "v-data-table--loading": e.loading
        }, e.class],
        style: e.style
      }, j, {
        fixedHeader: e.fixedHeader || e.sticky
      }), {
        top: () => a.top?.(B.value),
        default: () => a.default ? a.default(B.value) : S(fe, null, [a.colgroup?.(B.value), !e.hideDefaultHeader && S("thead", {
          key: "thead",
          class: "v-data-table__thead",
          role: "rowgroup"
        }, [y(ar, Y(W, {
          multiSort: !!e.multiSort
        }), a)]), a.thead?.(B.value), !e.hideDefaultBody && S("tbody", {
          class: "v-data-table__tbody",
          role: "rowgroup"
        }, [a["body.prepend"]?.(B.value), a.body ? a.body(B.value) : y(rr, Y(n, R, {
          items: x.value
        }), a), a["body.append"]?.(B.value)]), a.tbody?.(B.value), a.tfoot?.(B.value)]),
        bottom: () => a.bottom ? a.bottom(B.value) : !e.hideDefaultFooter && S(fe, null, [y(pn, null, null), y(Hl, N, {
          prepend: a["footer.prepend"]
        })])
      });
    });
  }
}), AE = U({
  fluid: {
    type: Boolean,
    default: !1
  },
  ...ve(),
  ...St(),
  ...Ie()
}, "VContainer"), PE = K()({
  name: "VContainer",
  props: AE(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      rtlClasses: a
    } = At(), {
      dimensionStyles: r
    } = xt(e);
    return X(() => y(e.tag, {
      class: J(["v-container", {
        "v-container--fluid": e.fluid
      }, a.value, e.class]),
      style: le([r.value, e.style])
    }, n)), {};
  }
}), Wb = jo.reduce((e, t) => (e[t] = {
  type: [Boolean, String, Number],
  default: !1
}, e), {}), Hb = jo.reduce((e, t) => {
  const n = "offset" + Zr(t);
  return e[n] = {
    type: [String, Number],
    default: null
  }, e;
}, {}), zb = jo.reduce((e, t) => {
  const n = "order" + Zr(t);
  return e[n] = {
    type: [String, Number],
    default: null
  }, e;
}, {}), zv = {
  col: Object.keys(Wb),
  offset: Object.keys(Hb),
  order: Object.keys(zb)
};
function VE(e, t, n) {
  let a = e;
  if (!(n == null || n === !1)) {
    if (t) {
      const r = t.replace(e, "");
      a += `-${r}`;
    }
    return e === "col" && (a = "v-" + a), e === "col" && (n === "" || n === !0) || (a += `-${n}`), a.toLowerCase();
  }
}
const EE = ["auto", "start", "end", "center", "baseline", "stretch"], ME = U({
  cols: {
    type: [Boolean, String, Number],
    default: !1
  },
  ...Wb,
  offset: {
    type: [String, Number],
    default: null
  },
  ...Hb,
  order: {
    type: [String, Number],
    default: null
  },
  ...zb,
  alignSelf: {
    type: String,
    default: null,
    validator: (e) => EE.includes(e)
  },
  ...ve(),
  ...Ie()
}, "VCol"), OE = K()({
  name: "VCol",
  props: ME(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = T(() => {
      const r = [];
      let l;
      for (l in zv)
        zv[l].forEach((o) => {
          const s = e[o], u = VE(l, o, s);
          u && r.push(u);
        });
      const i = r.some((o) => o.startsWith("v-col-"));
      return r.push({
        // Default to .v-col if no other col-{bp}-* classes generated nor `cols` specified.
        "v-col": !i || !e.cols,
        [`v-col-${e.cols}`]: e.cols,
        [`offset-${e.offset}`]: e.offset,
        [`order-${e.order}`]: e.order,
        [`align-self-${e.alignSelf}`]: e.alignSelf
      }), r;
    });
    return () => Oa(e.tag, {
      class: [a.value, e.class],
      style: e.style
    }, n.default?.());
  }
}), xd = ["start", "end", "center"], jb = ["space-between", "space-around", "space-evenly"];
function Cd(e, t) {
  return jo.reduce((n, a) => {
    const r = e + Zr(a);
    return n[r] = t(), n;
  }, {});
}
const DE = [...xd, "baseline", "stretch"], Gb = (e) => DE.includes(e), qb = Cd("align", () => ({
  type: String,
  default: null,
  validator: Gb
})), LE = [...xd, ...jb], Yb = (e) => LE.includes(e), Kb = Cd("justify", () => ({
  type: String,
  default: null,
  validator: Yb
})), NE = [...xd, ...jb, "stretch"], Zb = (e) => NE.includes(e), Jb = Cd("alignContent", () => ({
  type: String,
  default: null,
  validator: Zb
})), jv = {
  align: Object.keys(qb),
  justify: Object.keys(Kb),
  alignContent: Object.keys(Jb)
}, FE = {
  align: "align",
  justify: "justify",
  alignContent: "align-content"
};
function RE(e, t, n) {
  let a = FE[e];
  if (n != null) {
    if (t) {
      const r = t.replace(e, "");
      a += `-${r}`;
    }
    return a += `-${n}`, a.toLowerCase();
  }
}
const $E = U({
  dense: Boolean,
  noGutters: Boolean,
  align: {
    type: String,
    default: null,
    validator: Gb
  },
  ...qb,
  justify: {
    type: String,
    default: null,
    validator: Yb
  },
  ...Kb,
  alignContent: {
    type: String,
    default: null,
    validator: Zb
  },
  ...Jb,
  ...ve(),
  ...Ie()
}, "VRow"), BE = K()({
  name: "VRow",
  props: $E(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = T(() => {
      const r = [];
      let l;
      for (l in jv)
        jv[l].forEach((i) => {
          const o = e[i], s = RE(l, i, o);
          s && r.push(s);
        });
      return r.push({
        "v-row--no-gutters": e.noGutters,
        "v-row--dense": e.dense,
        [`align-${e.align}`]: e.align,
        [`justify-${e.justify}`]: e.justify,
        [`align-content-${e.alignContent}`]: e.alignContent
      }), r;
    });
    return () => Oa(e.tag, {
      class: ["v-row", a.value, e.class],
      style: e.style
    }, n.default?.());
  }
}), Lu = ca("v-spacer", "div", "VSpacer"), Xb = U({
  active: {
    type: [String, Array],
    default: void 0
  },
  controlHeight: [Number, String],
  controlVariant: {
    type: String,
    default: "docked"
  },
  noMonthPicker: Boolean,
  disabled: {
    type: [Boolean, String, Array],
    default: null
  },
  nextIcon: {
    type: be,
    default: "$next"
  },
  prevIcon: {
    type: be,
    default: "$prev"
  },
  modeIcon: {
    type: be,
    default: "$subgroup"
  },
  text: String,
  monthText: String,
  yearText: String,
  viewMode: {
    type: String,
    default: "month"
  }
}, "VDatePickerControls"), Nu = K()({
  name: "VDatePickerControls",
  props: Xb(),
  emits: {
    "click:year": () => !0,
    "click:month": () => !0,
    "click:prev": () => !0,
    "click:next": () => !0,
    "click:prev-year": () => !0,
    "click:next-year": () => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const {
      t: r
    } = Ke(), l = T(() => Array.isArray(e.disabled) ? e.disabled.includes("text") : !!e.disabled), i = T(() => Array.isArray(e.disabled) ? e.disabled.includes("mode") : !!e.disabled), o = T(() => Array.isArray(e.disabled) ? e.disabled.includes("prev-month") : !!e.disabled), s = T(() => Array.isArray(e.disabled) ? e.disabled.includes("next-month") : !!e.disabled), u = T(() => Array.isArray(e.disabled) ? e.disabled.includes("prev-year") : !!e.disabled), c = T(() => Array.isArray(e.disabled) ? e.disabled.includes("next-year") : !!e.disabled);
    function d() {
      n("click:prev");
    }
    function f() {
      n("click:next");
    }
    function v() {
      n("click:prev-year");
    }
    function g() {
      n("click:next-year");
    }
    function m() {
      n("click:year");
    }
    function h() {
      n("click:month");
    }
    return X(() => {
      const w = {
        VBtn: {
          density: "comfortable",
          variant: "text"
        }
      }, _ = y(De, {
        "data-testid": "prev-month",
        disabled: o.value,
        icon: e.prevIcon,
        "aria-label": r("$vuetify.datePicker.ariaLabel.previousMonth"),
        onClick: d
      }, null), I = y(De, {
        "data-testid": "next-month",
        disabled: s.value,
        icon: e.nextIcon,
        "aria-label": r("$vuetify.datePicker.ariaLabel.nextMonth"),
        onClick: f
      }, null), C = y(De, {
        "data-testid": "prev-year",
        disabled: u.value,
        icon: e.prevIcon,
        "aria-label": r("$vuetify.datePicker.ariaLabel.previousYear"),
        onClick: v
      }, null), b = y(De, {
        "data-testid": "next-year",
        disabled: c.value,
        icon: e.nextIcon,
        "aria-label": r("$vuetify.datePicker.ariaLabel.nextYear"),
        onClick: g
      }, null), p = y(De, {
        class: "v-date-picker-controls__only-month-btn",
        "data-testid": "month-btn",
        density: "default",
        disabled: l.value,
        text: e.monthText,
        appendIcon: e.modeIcon,
        rounded: !0,
        "aria-label": r("$vuetify.datePicker.ariaLabel.selectMonth"),
        onClick: h
      }, null), x = y(De, {
        class: "v-date-picker-controls__only-year-btn",
        "data-testid": "year-btn",
        density: "default",
        disabled: i.value,
        text: e.yearText,
        appendIcon: e.modeIcon,
        rounded: !0,
        "aria-label": r("$vuetify.datePicker.ariaLabel.selectYear"),
        onClick: m
      }, null), k = y(De, {
        class: "v-date-picker-controls__year-btn",
        "data-testid": "year-btn",
        density: "default",
        disabled: i.value,
        text: e.text,
        appendIcon: e.modeIcon,
        rounded: !0,
        "aria-label": r("$vuetify.datePicker.ariaLabel.selectYear"),
        onClick: m
      }, null), V = S(fe, null, [y(De, {
        class: "v-date-picker-controls__month-btn",
        "data-testid": "month-btn",
        height: "36",
        disabled: l.value,
        text: e.text,
        rounded: !0,
        "aria-label": r("$vuetify.datePicker.ariaLabel.selectMonth"),
        onClick: h
      }, null), y(De, {
        class: "v-date-picker-controls__mode-btn",
        "data-testid": "year-btn",
        disabled: i.value,
        icon: e.modeIcon,
        "aria-label": r("$vuetify.datePicker.ariaLabel.selectYear"),
        onClick: m
      }, null)]), A = {
        viewMode: e.viewMode,
        disabled: Array.isArray(e.disabled) ? e.disabled : [],
        monthYearText: e.text ?? "",
        monthText: e.monthText ?? "",
        yearText: e.yearText ?? "",
        openMonths: h,
        openYears: m,
        prevMonth: d,
        nextMonth: f,
        prevYear: v,
        nextYear: g
      }, M = S(fe, null, [e.noMonthPicker ? k : V, y(Lu, null, null), S("div", {
        class: "v-date-picker-controls__month"
      }, [_, I])]), L = S(fe, null, [S("div", {
        class: "v-date-picker-controls__month"
      }, [_, p, I]), y(Lu, null, null), S("div", {
        class: "v-date-picker-controls__year"
      }, [C, x, b])]);
      return y(Ae, {
        defaults: w
      }, {
        default: () => [S("div", {
          class: J(["v-date-picker-controls", `v-date-picker-controls--variant-${e.controlVariant}`]),
          style: {
            "--v-date-picker-controls-height": re(e.controlHeight)
          }
        }, [a.default?.(A) ?? S(fe, null, [e.controlVariant === "modal" && M, e.controlVariant === "docked" && L])])]
      });
    }), {};
  }
}), UE = U({
  appendIcon: be,
  color: String,
  header: String,
  transition: String,
  onClick: Ut()
}, "VDatePickerHeader"), Fu = K()({
  name: "VDatePickerHeader",
  props: UE(),
  emits: {
    click: () => !0,
    "click:append": () => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const {
      backgroundColorClasses: r,
      backgroundColorStyles: l
    } = qe(() => e.color);
    function i() {
      n("click");
    }
    function o() {
      n("click:append");
    }
    return X(() => {
      const s = !!(a.default || e.header), u = !!(a.append || e.appendIcon);
      return S("div", {
        class: J(["v-date-picker-header", {
          "v-date-picker-header--clickable": !!e.onClick
        }, r.value]),
        style: le(l.value),
        onClick: i
      }, [a.prepend && S("div", {
        key: "prepend",
        class: "v-date-picker-header__prepend"
      }, [a.prepend()]), s && y(Xt, {
        key: "content",
        name: e.transition
      }, {
        default: () => [S("div", {
          key: e.header,
          class: "v-date-picker-header__content"
        }, [a.default?.() ?? e.header])]
      }), u && S("div", {
        class: "v-date-picker-header__append"
      }, [a.append ? y(Ae, {
        key: "append-defaults",
        disabled: !e.appendIcon,
        defaults: {
          VBtn: {
            icon: e.appendIcon,
            variant: "text"
          }
        }
      }, {
        default: () => [a.append?.()]
      }) : y(De, {
        key: "append-btn",
        icon: e.appendIcon,
        variant: "text",
        onClick: o
      }, null)])]);
    }), {};
  }
}), WE = U({
  allowedDates: [Array, Function],
  disabled: {
    type: Boolean,
    default: null
  },
  displayValue: null,
  modelValue: Array,
  month: [Number, String],
  max: null,
  min: null,
  showAdjacentMonths: Boolean,
  year: [Number, String],
  weekdays: {
    type: Array,
    default: () => [0, 1, 2, 3, 4, 5, 6]
  },
  weeksInMonth: {
    type: String,
    default: "dynamic"
  },
  firstDayOfWeek: {
    type: [Number, String],
    default: void 0
  },
  firstDayOfYear: {
    type: [Number, String],
    default: void 0
  },
  weekdayFormat: String
}, "calendar");
function HE(e) {
  const t = pr(), n = he(e, "modelValue", [], (m) => rt(m).map((h) => t.date(h))), a = T(() => e.displayValue ? t.date(e.displayValue) : n.value.length > 0 ? t.date(n.value[0]) : e.min ? t.date(e.min) : Array.isArray(e.allowedDates) ? t.date(e.allowedDates[0]) : t.date()), r = he(e, "year", void 0, (m) => {
    const h = m != null ? Number(m) : t.getYear(a.value);
    return t.startOfYear(t.setYear(t.date(), h));
  }, (m) => t.getYear(m)), l = he(e, "month", void 0, (m) => {
    const h = m != null ? Number(m) : t.getMonth(a.value), w = t.setYear(t.startOfMonth(t.date()), t.getYear(r.value));
    return t.setMonth(w, h);
  }, (m) => t.getMonth(m)), i = T(() => {
    const m = t.toJsDate(t.startOfWeek(t.date(), e.firstDayOfWeek)).getDay();
    return t.getWeekdays(e.firstDayOfWeek, e.weekdayFormat).filter((h, w) => e.weekdays.includes((w + m) % 7));
  }), o = T(() => {
    const m = t.getWeekArray(l.value, e.firstDayOfWeek), h = m.flat(), w = 42;
    if (e.weeksInMonth === "static" && h.length < w) {
      const _ = h[h.length - 1];
      let I = [];
      for (let C = 1; C <= w - h.length; C++)
        I.push(t.addDays(_, C)), C % 7 === 0 && (m.push(I), I = []);
    }
    return m;
  });
  function s(m, h) {
    return m.filter((w) => e.weekdays.includes(t.toJsDate(w).getDay())).map((w, _) => {
      const I = t.toISO(w), C = !t.isSameMonth(w, l.value), b = t.isSameDay(w, t.startOfMonth(l.value)), p = t.isSameDay(w, t.endOfMonth(l.value)), x = t.isSameDay(w, l.value), k = e.weekdays.length;
      return {
        date: w,
        formatted: t.format(w, "keyboardDate"),
        isAdjacent: C,
        isDisabled: g(w),
        isEnd: p,
        isHidden: C && !e.showAdjacentMonths,
        isSame: x,
        isSelected: n.value.some((V) => t.isSameDay(w, V)),
        isStart: b,
        isToday: t.isSameDay(w, h),
        isWeekEnd: _ % k === k - 1,
        isWeekStart: _ % k === 0,
        isoDate: I,
        localized: t.format(w, "dayOfMonth"),
        month: t.getMonth(w),
        year: t.getYear(w)
      };
    });
  }
  const u = T(() => {
    const m = t.startOfWeek(a.value, e.firstDayOfWeek), h = [];
    for (let _ = 0; _ <= 6; _++)
      h.push(t.addDays(m, _));
    const w = t.date();
    return s(h, w);
  }), c = T(() => {
    const m = o.value.flat(), h = t.date();
    return s(m, h);
  }), d = T(() => o.value.map((m) => m.length ? t.getWeek(m[0], e.firstDayOfWeek, e.firstDayOfYear) : null)), {
    minDate: f,
    maxDate: v
  } = Qb(e);
  function g(m) {
    if (e.disabled) return !0;
    const h = t.date(m);
    return f.value && t.isBefore(t.endOfDay(h), f.value) || v.value && t.isAfter(h, v.value) ? !0 : Array.isArray(e.allowedDates) && e.allowedDates.length > 0 ? !e.allowedDates.some((w) => t.isSameDay(t.date(w), h)) : typeof e.allowedDates == "function" ? !e.allowedDates(h) : !1;
  }
  return {
    displayValue: a,
    daysInMonth: c,
    daysInWeek: u,
    genDays: s,
    model: n,
    weeksInMonth: o,
    weekdayLabels: i,
    weekNumbers: d
  };
}
function Qb(e) {
  const t = pr(), n = T(() => {
    if (!e.min) return null;
    const i = t.date(e.min);
    return t.isValid(i) ? i : null;
  }), a = T(() => {
    if (!e.max) return null;
    const i = t.date(e.max);
    return t.isValid(i) ? i : null;
  });
  function r(i) {
    return n.value && t.isBefore(i, n.value) ? n.value : a.value && t.isAfter(i, a.value) ? a.value : i;
  }
  function l(i) {
    return (!n.value || t.isAfter(i, n.value)) && (!a.value || t.isBefore(i, a.value));
  }
  return {
    minDate: n,
    maxDate: a,
    clampDate: r,
    isInAllowedRange: l
  };
}
const ep = U({
  color: String,
  hideWeekdays: Boolean,
  multiple: [Boolean, Number, String],
  showWeek: Boolean,
  readonly: Boolean,
  transition: {
    type: String,
    default: "picker-transition"
  },
  reverseTransition: {
    type: String,
    default: "picker-reverse-transition"
  },
  events: {
    type: [Array, Function, Object],
    default: () => null
  },
  eventColor: {
    type: [Array, Function, Object, String],
    default: () => null
  },
  ...Pe(WE(), ["displayValue"])
}, "VDatePickerMonth"), Ru = K()({
  name: "VDatePickerMonth",
  props: ep(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:month": (e) => !0,
    "update:year": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const r = G(), {
      t: l
    } = Ke(), {
      daysInMonth: i,
      model: o,
      weekNumbers: s,
      weekdayLabels: u
    } = HE(e), c = pr(), d = ae(), f = ae(), v = ae(!1), g = D(() => v.value ? e.reverseTransition : e.transition);
    e.multiple === "range" && o.value.length > 0 && (d.value = o.value[0], o.value.length > 1 && (f.value = o.value[o.value.length - 1]));
    const m = T(() => {
      const p = ["number", "string"].includes(typeof e.multiple) ? Number(e.multiple) : 1 / 0;
      return o.value.length >= p;
    });
    ne(i, (p, x) => {
      x && (v.value = c.isBefore(p[0].date, x[0].date));
    });
    function h(p) {
      const x = c.startOfDay(p);
      if (o.value.length === 0 ? d.value = void 0 : o.value.length === 1 && (d.value = o.value[0], f.value = void 0), !d.value)
        d.value = x, o.value = [d.value];
      else if (f.value)
        d.value = p, f.value = void 0, o.value = [d.value];
      else {
        if (c.isSameDay(x, d.value)) {
          d.value = void 0, o.value = [];
          return;
        } else c.isBefore(x, d.value) ? (f.value = c.endOfDay(d.value), d.value = x) : f.value = c.endOfDay(x);
        o.value = dP(c, d.value, f.value);
      }
    }
    function w(p) {
      const x = c.format(p.date, "fullDateWithWeekday"), k = p.isToday ? "currentDate" : "selectDate";
      return l(`$vuetify.datePicker.ariaLabel.${k}`, x);
    }
    function _(p) {
      const x = o.value.findIndex((k) => c.isSameDay(k, p));
      if (x === -1)
        o.value = [...o.value, p];
      else {
        const k = [...o.value];
        k.splice(x, 1), o.value = k;
      }
    }
    function I(p) {
      e.multiple === "range" ? h(p) : e.multiple ? _(p) : o.value = [p];
    }
    function C(p) {
      const {
        events: x,
        eventColor: k
      } = e;
      let V, A = [];
      if (Array.isArray(x) ? V = x.includes(p) : x instanceof Function ? V = x(p) || !1 : x ? V = x[p] || !1 : V = !1, V)
        V !== !0 ? A = rt(V) : typeof k == "string" ? A = [k] : typeof k == "function" ? A = rt(k(p)) : Array.isArray(k) ? A = k : typeof k == "object" && k !== null && (A = rt(k[p]));
      else return [];
      return A.length ? A.filter(Boolean).map((M) => typeof M == "string" ? M : "surface-variant") : ["surface-variant"];
    }
    function b(p) {
      const x = C(p);
      return x.length ? S("div", {
        class: "v-date-picker-month__events"
      }, [x.map((k) => y(Py, {
        dot: !0,
        color: k
      }, null))]) : null;
    }
    X(() => S("div", {
      class: "v-date-picker-month",
      style: {
        "--v-date-picker-days-in-week": e.weekdays.length
      }
    }, [e.showWeek && S("div", {
      key: "weeks",
      class: "v-date-picker-month__weeks"
    }, [!e.hideWeekdays && S("div", {
      key: "hide-week-days",
      class: "v-date-picker-month__day"
    }, [we(" ")]), s.value.map((p) => S("div", {
      class: J(["v-date-picker-month__day", "v-date-picker-month__day--adjacent"])
    }, [p]))]), y(Xt, {
      name: g.value
    }, {
      default: () => [S("div", {
        ref: r,
        key: i.value[0].date?.toString(),
        class: "v-date-picker-month__days"
      }, [!e.hideWeekdays && u.value.map((p) => S("div", {
        class: J(["v-date-picker-month__day", "v-date-picker-month__weekday"])
      }, [p])), i.value.map((p, x) => {
        const k = {
          props: {
            class: "v-date-picker-month__day-btn",
            color: p.isSelected || p.isToday ? e.color : void 0,
            disabled: p.isDisabled,
            readonly: e.readonly,
            icon: !0,
            ripple: !1,
            variant: p.isSelected ? "flat" : p.isToday ? "outlined" : "text",
            "aria-label": w(p),
            "aria-current": p.isToday ? "date" : void 0,
            onClick: () => I(p.date)
          },
          item: p,
          i: x
        };
        return m.value && !p.isSelected && (p.isDisabled = !0), S("div", {
          class: J(["v-date-picker-month__day", {
            "v-date-picker-month__day--adjacent": p.isAdjacent,
            "v-date-picker-month__day--hide-adjacent": p.isHidden,
            "v-date-picker-month__day--selected": p.isSelected,
            "v-date-picker-month__day--week-end": p.isWeekEnd,
            "v-date-picker-month__day--week-start": p.isWeekStart
          }]),
          "data-v-date": p.isDisabled ? void 0 : p.isoDate
        }, [(e.showAdjacentMonths || !p.isAdjacent) && (a.day?.(k) ?? y(De, k.props, {
          default: () => [p.localized, b(p.isoDate)]
        }))]);
      })])]
    })]));
  }
}), tp = U({
  color: String,
  height: [String, Number],
  min: null,
  max: null,
  modelValue: Number,
  year: Number,
  allowedMonths: [Array, Function]
}, "VDatePickerMonths"), $u = K()({
  name: "VDatePickerMonths",
  props: tp(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const r = pr(), l = he(e, "modelValue"), i = T(() => {
      let s = r.startOfYear(r.date());
      return e.year && (s = r.setYear(s, e.year)), ka(12).map((u) => {
        const c = r.format(s, "monthShort"), d = r.format(s, "month"), f = !!(!o(u) || e.min && r.isAfter(r.startOfMonth(r.date(e.min)), s) || e.max && r.isAfter(s, r.startOfMonth(r.date(e.max))));
        return s = r.getNextMonth(s), {
          isDisabled: f,
          text: c,
          label: d,
          value: u
        };
      });
    });
    ft(() => {
      l.value = l.value ?? r.getMonth(r.date());
    });
    function o(s) {
      return Array.isArray(e.allowedMonths) && e.allowedMonths.length ? e.allowedMonths.includes(s) : typeof e.allowedMonths == "function" ? e.allowedMonths(s) : !0;
    }
    return X(() => S("div", {
      class: "v-date-picker-months",
      style: {
        height: re(e.height)
      }
    }, [S("div", {
      class: "v-date-picker-months__content"
    }, [i.value.map((s, u) => {
      const c = {
        active: l.value === u,
        ariaLabel: s.label,
        color: l.value === u ? e.color : void 0,
        disabled: s.isDisabled,
        rounded: !0,
        text: s.text,
        variant: l.value === s.value ? "flat" : "text",
        onClick: () => d(u)
      };
      function d(f) {
        if (l.value === f) {
          n("update:modelValue", l.value);
          return;
        }
        l.value = f;
      }
      return a.month?.({
        month: s,
        i: u,
        props: c
      }) ?? y(De, Y({
        key: "month"
      }, c), null);
    })])])), {};
  }
}), np = U({
  color: String,
  height: [String, Number],
  min: null,
  max: null,
  modelValue: Number,
  allowedYears: [Array, Function]
}, "VDatePickerYears"), Bu = K()({
  name: "VDatePickerYears",
  props: np(),
  directives: {
    vIntersect: Bn
  },
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const r = pr(), l = he(e, "modelValue"), i = ae(!1), o = T(() => {
      const f = r.getYear(r.date());
      let v = f - 100, g = f + 52;
      e.min && (v = r.getYear(r.date(e.min))), e.max && (g = r.getYear(r.date(e.max)));
      let m = r.startOfYear(r.date());
      return m = r.setYear(m, v), ka(g - v + 1, v).map((h) => {
        const w = r.format(m, "year");
        return m = r.setYear(m, r.getYear(m) + 1), {
          text: w,
          value: h,
          isDisabled: !d(h)
        };
      });
    });
    ft(() => {
      l.value = l.value ?? r.getYear(r.date());
    });
    const s = Ol(), u = Ol();
    function c() {
      const f = s.el, v = u.el;
      if (!f || !v) return;
      const g = f.getBoundingClientRect(), m = v.getBoundingClientRect();
      f.scrollTop += m.top - g.top - f.clientHeight / 2 + m.height / 2;
    }
    function d(f) {
      return Array.isArray(e.allowedYears) && e.allowedYears.length ? e.allowedYears.includes(f) : typeof e.allowedYears == "function" ? e.allowedYears(f) : !0;
    }
    return X(() => at(S("div", {
      class: "v-date-picker-years",
      ref: s,
      style: {
        height: re(e.height)
      }
    }, [S("div", {
      class: "v-date-picker-years__content",
      onFocus: () => u.el?.focus(),
      onFocusin: () => i.value = !0,
      onFocusout: () => i.value = !1,
      tabindex: i.value ? -1 : 0
    }, [o.value.map((f, v) => {
      const g = {
        ref: l.value === f.value ? u : void 0,
        active: l.value === f.value,
        color: l.value === f.value ? e.color : void 0,
        rounded: !0,
        text: f.text,
        disabled: f.isDisabled,
        variant: l.value === f.value ? "flat" : "text",
        onClick: () => {
          if (l.value === f.value) {
            n("update:modelValue", l.value);
            return;
          }
          l.value = f.value;
        }
      };
      return a.year?.({
        year: f,
        i: v,
        props: g
      }) ?? y(De, Y({
        key: "month"
      }, g), null);
    })])]), [[Bn, {
      handler: c
    }, null, {
      once: !0
    }]])), {};
  }
}), zE = U({
  // TODO: implement in v3.5
  // calendarIcon: {
  //   type: String,
  //   default: '$calendar',
  // },
  // keyboardIcon: {
  //   type: String,
  //   default: '$edit',
  // },
  // inputMode: {
  //   type: String as PropType<'calendar' | 'keyboard'>,
  //   default: 'calendar',
  // },
  // inputText: {
  //   type: String,
  //   default: '$vuetify.datePicker.input.placeholder',
  // },
  // inputPlaceholder: {
  //   type: String,
  //   default: 'dd/mm/yyyy',
  // },
  header: {
    type: String,
    default: "$vuetify.datePicker.header"
  },
  headerColor: String,
  headerDateFormat: {
    type: String,
    default: "normalDateWithWeekday"
  },
  landscapeHeaderWidth: [Number, String],
  ...Pe(Xb(), ["active", "monthText", "yearText"]),
  ...ep({
    weeksInMonth: "static"
  }),
  ...Pe(tp(), ["modelValue"]),
  ...Pe(np(), ["modelValue"]),
  ...Qo({
    title: "$vuetify.datePicker.title"
  }),
  modelValue: null
}, "VDatePicker"), jE = K()({
  name: "VDatePicker",
  props: zE(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:month": (e) => !0,
    "update:year": (e) => !0,
    // 'update:inputMode': (date: any) => true,
    "update:viewMode": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const r = pr(), {
      t: l
    } = Ke(), {
      rtlClasses: i
    } = At(), o = he(e, "modelValue", void 0, (z) => rt(z).map((te) => r.date(te)), (z) => e.multiple ? z : z[0]), s = he(e, "viewMode"), {
      minDate: u,
      maxDate: c,
      clampDate: d
    } = Qb(e), f = T(() => {
      const z = r.date(), te = o.value?.[0] ? r.date(o.value[0]) : d(z);
      return te && r.isValid(te) ? te : z;
    }), v = D(() => e.headerColor ?? e.color), g = he(e, "month"), m = T({
      get: () => Number(g.value ?? r.getMonth(r.startOfMonth(f.value))),
      set: (z) => g.value = z
    }), h = he(e, "year"), w = T({
      get: () => Number(h.value ?? r.getYear(r.startOfYear(r.setMonth(f.value, m.value)))),
      set: (z) => h.value = z
    }), _ = ae(!1), I = T(() => {
      if (e.multiple && o.value.length > 1)
        return l("$vuetify.datePicker.itemsSelected", o.value.length);
      const z = o.value[0] && r.isValid(o.value[0]) ? r.format(r.date(o.value[0]), e.headerDateFormat) : l(e.header);
      return e.landscape && z.split(" ").length === 3 ? z.replace(" ", `
`) : z;
    }), C = D(() => {
      let z = r.date();
      return z = r.setDate(z, 1), z = r.setMonth(z, m.value), z = r.setYear(z, w.value), z;
    }), b = D(() => r.format(C.value, "monthAndYear")), p = D(() => r.format(C.value, "monthShort")), x = D(() => r.format(C.value, "year")), k = D(() => `date-picker-header${_.value ? "-reverse" : ""}-transition`), V = T(() => {
      if (e.disabled) return !0;
      const z = [];
      if (s.value !== "month")
        z.push("prev-month", "next-month", "prev-year", "next-year");
      else {
        let te = r.date();
        if (te = r.startOfMonth(te), te = r.setMonth(te, m.value), te = r.setYear(te, w.value), u.value) {
          const me = r.addDays(r.startOfMonth(te), -1), Q = r.addDays(r.startOfYear(te), -1);
          r.isAfter(u.value, me) && z.push("prev-month"), r.isAfter(u.value, Q) && z.push("prev-year");
        }
        if (c.value) {
          const me = r.addDays(r.endOfMonth(te), 1), Q = r.addDays(r.endOfYear(te), 1);
          r.isAfter(me, c.value) && z.push("next-month"), r.isAfter(Q, c.value) && z.push("next-year");
        }
      }
      return z;
    }), A = T(() => e.allowedYears || E), M = T(() => e.allowedMonths || P);
    function L(z, te) {
      const me = e.allowedDates;
      if (typeof me != "function") return !0;
      const Q = 1 + jy(r, z, te);
      for (let ie = 0; ie < Q; ie++)
        if (me(r.addDays(z, ie))) return !0;
      return !1;
    }
    function E(z) {
      if (typeof e.allowedDates == "function") {
        const te = r.parseISO(`${z}-01-01`);
        return L(te, r.endOfYear(te));
      }
      if (Array.isArray(e.allowedDates) && e.allowedDates.length) {
        for (const te of e.allowedDates)
          if (r.getYear(r.date(te)) === z) return !0;
        return !1;
      }
      return !0;
    }
    function P(z) {
      if (typeof e.allowedDates == "function") {
        const te = String(z + 1).padStart(2, "0"), me = r.parseISO(`${w.value}-${te}-01`);
        return L(me, r.endOfMonth(me));
      }
      if (Array.isArray(e.allowedDates) && e.allowedDates.length) {
        for (const te of e.allowedDates)
          if (r.getYear(r.date(te)) === w.value && r.getMonth(r.date(te)) === z) return !0;
        return !1;
      }
      return !0;
    }
    function O() {
      m.value < 11 ? m.value++ : (w.value++, m.value = 0, $()), H();
    }
    function F() {
      m.value > 0 ? m.value-- : (w.value--, m.value = 11, $()), H();
    }
    function B() {
      if (w.value++, c.value) {
        const z = String(m.value + 1).padStart(2, "0"), te = r.parseISO(`${w.value}-${z}-01`);
        r.isAfter(te, c.value) && (m.value = r.getMonth(c.value));
      }
      $();
    }
    function N() {
      if (w.value--, u.value) {
        const z = String(m.value + 1).padStart(2, "0"), te = r.endOfMonth(r.parseISO(`${w.value}-${z}-01`));
        r.isAfter(u.value, te) && (m.value = r.getMonth(u.value));
      }
      $();
    }
    function W() {
      s.value = "month";
    }
    function R() {
      s.value = s.value === "months" ? "month" : "months";
    }
    function j() {
      s.value = s.value === "year" ? "month" : "year";
    }
    function H() {
      s.value === "months" && R();
    }
    function $() {
      s.value === "year" && j();
    }
    return ne(o, (z, te) => {
      const me = rt(te), Q = rt(z);
      if (!Q.length) return;
      const ie = r.date(me[me.length - 1]), ke = r.date(Q[Q.length - 1]);
      if (r.isSameDay(ie, ke)) return;
      const ye = r.getMonth(ke), ue = r.getYear(ke);
      ye !== m.value && (m.value = ye, H()), ue !== w.value && (w.value = ue, $()), _.value = r.isBefore(ie, ke);
    }), X(() => {
      const z = Yr.filterProps(e), te = Pe(Nu.filterProps(e), ["viewMode"]), me = Fu.filterProps(e), Q = Ru.filterProps(e), ie = Pe($u.filterProps(e), ["modelValue"]), ke = Pe(Bu.filterProps(e), ["modelValue"]), ye = {
        color: v.value,
        header: I.value,
        transition: k.value
      };
      return y(Yr, Y(z, {
        color: v.value,
        class: ["v-date-picker", `v-date-picker--${s.value}`, {
          "v-date-picker--show-week": e.showWeek
        }, i.value, e.class],
        style: [{
          "--v-date-picker-landscape-header-width": re(e.landscapeHeaderWidth)
        }, e.style]
      }), {
        title: () => a.title?.() ?? S("div", {
          class: "v-date-picker__title"
        }, [l(e.title)]),
        header: () => a.header ? y(Ae, {
          defaults: {
            VDatePickerHeader: {
              ...ye
            }
          }
        }, {
          default: () => [a.header?.(ye)]
        }) : y(Fu, Y({
          key: "header"
        }, me, ye, {
          onClick: s.value !== "month" ? W : void 0
        }), {
          prepend: a.prepend,
          append: a.append
        }),
        default: () => S(fe, null, [y(Nu, Y(te, {
          disabled: V.value,
          viewMode: s.value,
          text: b.value,
          monthText: p.value,
          yearText: x.value,
          "onClick:next": O,
          "onClick:prev": F,
          "onClick:nextYear": B,
          "onClick:prevYear": N,
          "onClick:month": R,
          "onClick:year": j
        }), {
          default: a.controls
        }), y(Nl, {
          hideOnLeave: !0
        }, {
          default: () => [s.value === "months" ? y($u, Y({
            key: "date-picker-months"
          }, ie, {
            modelValue: m.value,
            "onUpdate:modelValue": [(ue) => m.value = ue, H],
            min: u.value,
            max: c.value,
            year: w.value,
            allowedMonths: M.value
          }), {
            month: a.month
          }) : s.value === "year" ? y(Bu, Y({
            key: "date-picker-years"
          }, ke, {
            modelValue: w.value,
            "onUpdate:modelValue": [(ue) => w.value = ue, $],
            min: u.value,
            max: c.value,
            allowedYears: A.value
          }), {
            year: a.year
          }) : y(Ru, Y({
            key: "date-picker-month"
          }, Q, {
            modelValue: o.value,
            "onUpdate:modelValue": (ue) => o.value = ue,
            month: m.value,
            "onUpdate:month": [(ue) => m.value = ue, H],
            year: w.value,
            "onUpdate:year": [(ue) => w.value = ue, $],
            min: u.value,
            max: c.value
          }), {
            day: a.day
          })]
        })]),
        actions: a.actions
      });
    }), {};
  }
}), GE = U({
  actionText: String,
  bgColor: String,
  color: String,
  icon: be,
  image: String,
  justify: {
    type: String,
    default: "center"
  },
  headline: String,
  title: String,
  text: String,
  textWidth: {
    type: [Number, String],
    default: 500
  },
  href: String,
  to: String,
  ...ve(),
  ...St(),
  ...ea({
    size: void 0
  }),
  ...Re()
}, "VEmptyState"), qE = K()({
  name: "VEmptyState",
  props: GE(),
  emits: {
    "click:action": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const {
      themeClasses: r
    } = Ge(e), {
      backgroundColorClasses: l,
      backgroundColorStyles: i
    } = qe(() => e.bgColor), {
      dimensionStyles: o
    } = xt(e), {
      displayClasses: s
    } = Cn();
    function u(c) {
      n("click:action", c);
    }
    return X(() => {
      const c = !!(a.actions || e.actionText), d = !!(a.headline || e.headline), f = !!(a.title || e.title), v = !!(a.text || e.text), g = !!(a.media || e.image || e.icon), m = e.size || (e.image ? 200 : 96);
      return S("div", {
        class: J(["v-empty-state", {
          [`v-empty-state--${e.justify}`]: !0
        }, r.value, l.value, s.value, e.class]),
        style: le([i.value, o.value, e.style])
      }, [g && S("div", {
        key: "media",
        class: "v-empty-state__media"
      }, [a.media ? y(Ae, {
        key: "media-defaults",
        defaults: {
          VImg: {
            src: e.image,
            height: m
          },
          VIcon: {
            size: m,
            icon: e.icon
          }
        }
      }, {
        default: () => [a.media()]
      }) : S(fe, null, [e.image ? y(sa, {
        key: "image",
        src: e.image,
        height: m
      }, null) : e.icon ? y(ze, {
        key: "icon",
        color: e.color,
        size: m,
        icon: e.icon
      }, null) : void 0])]), d && S("div", {
        key: "headline",
        class: "v-empty-state__headline"
      }, [a.headline?.() ?? e.headline]), f && S("div", {
        key: "title",
        class: "v-empty-state__title"
      }, [a.title?.() ?? e.title]), v && S("div", {
        key: "text",
        class: "v-empty-state__text",
        style: {
          maxWidth: re(e.textWidth)
        }
      }, [a.text?.() ?? e.text]), a.default && S("div", {
        key: "content",
        class: "v-empty-state__content"
      }, [a.default()]), c && S("div", {
        key: "actions",
        class: "v-empty-state__actions"
      }, [y(Ae, {
        defaults: {
          VBtn: {
            class: "v-empty-state__action-btn",
            color: e.color ?? "surface-variant",
            href: e.href,
            text: e.actionText,
            to: e.to
          }
        }
      }, {
        default: () => [a.actions?.({
          props: {
            onClick: u
          }
        }) ?? y(De, {
          onClick: u
        }, null)]
      })])]);
    }), {};
  }
}), jl = /* @__PURE__ */ Symbol.for("vuetify:v-expansion-panel"), ap = U({
  ...ve(),
  ...Kc()
}, "VExpansionPanelText"), Uu = K()({
  name: "VExpansionPanelText",
  props: ap(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = Le(jl);
    if (!a) throw new Error("[Vuetify] v-expansion-panel-text needs to be placed inside v-expansion-panel");
    const {
      hasContent: r,
      onAfterLeave: l
    } = Zc(e, a.isSelected);
    return X(() => y($o, {
      onAfterLeave: l
    }, {
      default: () => [at(S("div", {
        class: J(["v-expansion-panel-text", e.class]),
        style: le(e.style)
      }, [n.default && r.value && S("div", {
        class: "v-expansion-panel-text__wrapper"
      }, [n.default?.()])]), [[Wn, a.isSelected.value]])]
    })), {};
  }
}), rp = U({
  color: String,
  expandIcon: {
    type: be,
    default: "$expand"
  },
  collapseIcon: {
    type: be,
    default: "$collapse"
  },
  hideActions: Boolean,
  focusable: Boolean,
  static: Boolean,
  ripple: {
    type: [Boolean, Object],
    default: !1
  },
  readonly: Boolean,
  ...ve(),
  ...St()
}, "VExpansionPanelTitle"), Wu = K()({
  name: "VExpansionPanelTitle",
  directives: {
    vRipple: Ht
  },
  props: rp(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = Le(jl);
    if (!a) throw new Error("[Vuetify] v-expansion-panel-title needs to be placed inside v-expansion-panel");
    const {
      backgroundColorClasses: r,
      backgroundColorStyles: l
    } = qe(() => e.color), {
      dimensionStyles: i
    } = xt(e), o = T(() => ({
      collapseIcon: e.collapseIcon,
      disabled: a.disabled.value,
      expanded: a.isSelected.value,
      expandIcon: e.expandIcon,
      readonly: e.readonly
    })), s = D(() => a.isSelected.value ? e.collapseIcon : e.expandIcon);
    return X(() => at(S("button", {
      class: J(["v-expansion-panel-title", {
        "v-expansion-panel-title--active": a.isSelected.value,
        "v-expansion-panel-title--focusable": e.focusable,
        "v-expansion-panel-title--static": e.static
      }, r.value, e.class]),
      style: le([l.value, i.value, e.style]),
      type: "button",
      tabindex: a.disabled.value ? -1 : void 0,
      disabled: a.disabled.value,
      "aria-expanded": a.isSelected.value,
      onClick: e.readonly ? void 0 : a.toggle
    }, [S("span", {
      class: "v-expansion-panel-title__overlay"
    }, null), n.default?.(o.value), !e.hideActions && y(Ae, {
      defaults: {
        VIcon: {
          icon: s.value
        }
      }
    }, {
      default: () => [S("span", {
        class: "v-expansion-panel-title__icon"
      }, [n.actions?.(o.value) ?? y(ze, null, null)])]
    })]), [[Ht, e.ripple]])), {};
  }
}), lp = U({
  title: String,
  text: String,
  bgColor: String,
  ...Ct(),
  ...mr(),
  ...lt(),
  ...Ie(),
  ...rp(),
  ...ap()
}, "VExpansionPanel"), YE = K()({
  name: "VExpansionPanel",
  props: lp(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = Ia(e, jl), {
      backgroundColorClasses: r,
      backgroundColorStyles: l
    } = qe(() => e.bgColor), {
      elevationClasses: i
    } = Et(e), {
      roundedClasses: o
    } = ut(e), s = D(() => a?.disabled.value || e.disabled), u = T(() => a.group.items.value.reduce((f, v, g) => (a.group.selected.value.includes(v.id) && f.push(g), f), [])), c = T(() => {
      const f = a.group.items.value.findIndex((v) => v.id === a.id);
      return !a.isSelected.value && u.value.some((v) => v - f === 1);
    }), d = T(() => {
      const f = a.group.items.value.findIndex((v) => v.id === a.id);
      return !a.isSelected.value && u.value.some((v) => v - f === -1);
    });
    return st(jl, a), X(() => {
      const f = !!(n.text || e.text), v = !!(n.title || e.title), g = Wu.filterProps(e), m = Uu.filterProps(e);
      return y(e.tag, {
        class: J(["v-expansion-panel", {
          "v-expansion-panel--active": a.isSelected.value,
          "v-expansion-panel--before-active": c.value,
          "v-expansion-panel--after-active": d.value,
          "v-expansion-panel--disabled": s.value
        }, o.value, r.value, e.class]),
        style: le([l.value, e.style])
      }, {
        default: () => [S("div", {
          class: J(["v-expansion-panel__shadow", ...i.value])
        }, null), y(Ae, {
          defaults: {
            VExpansionPanelTitle: {
              ...g
            },
            VExpansionPanelText: {
              ...m
            }
          }
        }, {
          default: () => [v && y(Wu, {
            key: "title"
          }, {
            default: () => [n.title ? n.title() : e.title]
          }), f && y(Uu, {
            key: "text"
          }, {
            default: () => [n.text ? n.text() : e.text]
          }), n.default?.()]
        })]
      });
    }), {
      groupItem: a
    };
  }
}), KE = ["default", "accordion", "inset", "popout"], ZE = U({
  flat: Boolean,
  ...vr(),
  ...an(lp(), ["bgColor", "collapseIcon", "color", "eager", "elevation", "expandIcon", "focusable", "hideActions", "readonly", "ripple", "rounded", "tile", "static"]),
  ...Re(),
  ...ve(),
  ...Ie(),
  variant: {
    type: String,
    default: "default",
    validator: (e) => KE.includes(e)
  }
}, "VExpansionPanels"), JE = K()({
  name: "VExpansionPanels",
  props: ZE(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      next: a,
      prev: r
    } = Na(e, jl), {
      themeClasses: l
    } = Ge(e), i = D(() => e.variant && `v-expansion-panels--variant-${e.variant}`);
    return vt({
      VExpansionPanel: {
        bgColor: D(() => e.bgColor),
        collapseIcon: D(() => e.collapseIcon),
        color: D(() => e.color),
        eager: D(() => e.eager),
        elevation: D(() => e.elevation),
        expandIcon: D(() => e.expandIcon),
        focusable: D(() => e.focusable),
        hideActions: D(() => e.hideActions),
        readonly: D(() => e.readonly),
        ripple: D(() => e.ripple),
        rounded: D(() => e.rounded),
        static: D(() => e.static)
      }
    }), X(() => y(e.tag, {
      class: J(["v-expansion-panels", {
        "v-expansion-panels--flat": e.flat,
        "v-expansion-panels--tile": e.tile
      }, l.value, i.value, e.class]),
      style: le(e.style)
    }, {
      default: () => [n.default?.({
        prev: r,
        next: a
      })]
    })), {
      next: a,
      prev: r
    };
  }
}), XE = U({
  app: Boolean,
  appear: Boolean,
  extended: Boolean,
  layout: Boolean,
  offset: Boolean,
  modelValue: {
    type: Boolean,
    default: !0
  },
  ...Pe(Ho({
    active: !0
  }), ["location", "spaced"]),
  ...cr(),
  ...Qn(),
  ...da({
    transition: "fab-transition"
  })
}, "VFab"), QE = K()({
  name: "VFab",
  props: XE(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = he(e, "modelValue"), r = ae(56), l = G(), {
      resizeRef: i
    } = Vn((d) => {
      d.length && (r.value = d[0].target.clientHeight);
    }), o = D(() => e.app || e.absolute), s = T(() => o.value ? e.location?.split(" ").shift() ?? "bottom" : !1), u = T(() => o.value ? e.location?.split(" ")[1] ?? "end" : !1);
    Wt(() => e.app, () => {
      const d = dr({
        id: e.name,
        order: T(() => parseInt(e.order, 10)),
        position: s,
        layoutSize: T(() => e.layout ? r.value + 24 : 0),
        elementSize: T(() => r.value + 24),
        active: T(() => e.app && a.value),
        absolute: D(() => e.absolute)
      });
      ft(() => {
        l.value = d.layoutItemStyles.value;
      });
    });
    const c = G();
    return X(() => {
      const d = De.filterProps(e);
      return S("div", {
        ref: c,
        class: J(["v-fab", {
          "v-fab--absolute": e.absolute,
          "v-fab--app": !!e.app,
          "v-fab--extended": e.extended,
          "v-fab--offset": e.offset,
          [`v-fab--${s.value}`]: o.value,
          [`v-fab--${u.value}`]: o.value
        }, e.class]),
        style: le([e.app ? {
          ...l.value
        } : {
          height: e.absolute ? "100%" : "inherit"
        }, e.style])
      }, [S("div", {
        class: "v-fab__container"
      }, [y(Xt, {
        appear: e.appear,
        transition: e.transition
      }, {
        default: () => [at(y(De, Y({
          ref: i
        }, d, {
          active: void 0,
          location: void 0
        }), n), [[Wn, e.active]])]
      })])]);
    }), {};
  }
});
function eM() {
  function e(n) {
    return [...n.dataTransfer?.items ?? []].filter((r) => r.kind === "file").map((r) => r.webkitGetAsEntry()).filter(Boolean).length > 0 || [...n.dataTransfer?.files ?? []].length > 0;
  }
  async function t(n) {
    const a = [], r = [...n.dataTransfer?.items ?? []].filter((l) => l.kind === "file").map((l) => l.webkitGetAsEntry()).filter(Boolean);
    if (r.length)
      for (const l of r) {
        const i = await ip(l, op(".", l));
        a.push(...i.map((o) => o.file));
      }
    else
      a.push(...n.dataTransfer?.files ?? []);
    return a;
  }
  return {
    handleDrop: t,
    hasFilesOrFolders: e
  };
}
function ip(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return new Promise((n, a) => {
    e.isFile ? e.file((l) => n([{
      file: l,
      path: t
    }]), a) : e.isDirectory && e.createReader().readEntries(async (l) => {
      const i = [];
      for (const o of l)
        i.push(...await ip(o, op(t, o)));
      n(i);
    });
  });
}
function op(e, t) {
  return t.isDirectory ? `${e}/${t.name}` : e;
}
const tM = U({
  filterByType: String
}, "file-accept");
function nM(e) {
  const t = T(() => e.filterByType ? aM(e.filterByType) : null);
  function n(a) {
    if (t.value) {
      const r = a.filter(t.value);
      return {
        accepted: r,
        rejected: a.filter((l) => !r.includes(l))
      };
    }
    return {
      accepted: a,
      rejected: []
    };
  }
  return {
    filterAccepted: n
  };
}
function aM(e) {
  const t = e.split(",").map((l) => l.trim().toLowerCase()), n = t.filter((l) => l.startsWith(".")), a = t.filter((l) => l.endsWith("/*")), r = t.filter((l) => !n.includes(l) && !a.includes(l));
  return (l) => {
    const i = l.name.split(".").at(-1)?.toLowerCase() ?? "", o = l.type.split("/").at(0)?.toLowerCase() ?? "";
    return r.includes(l.type) || n.includes(`.${i}`) || a.includes(`${o}/*`);
  };
}
const rM = U({
  chips: Boolean,
  counter: Boolean,
  counterSizeString: {
    type: String,
    default: "$vuetify.fileInput.counterSize"
  },
  counterString: {
    type: String,
    default: "$vuetify.fileInput.counter"
  },
  hideInput: Boolean,
  multiple: Boolean,
  showSize: {
    type: [Boolean, Number, String],
    default: !1,
    validator: (e) => typeof e == "boolean" || [1e3, 1024].includes(Number(e))
  },
  truncateLength: {
    type: [Number, String],
    default: 22
  },
  ...Pe(ha({
    prependIcon: "$file"
  }), ["direction"]),
  modelValue: {
    type: [Array, Object],
    default: (e) => e.multiple ? [] : null,
    validator: (e) => rt(e).every((t) => t != null && typeof t == "object")
  },
  ...tM(),
  ...vi({
    clearable: !0
  })
}, "VFileInput"), lM = K()({
  name: "VFileInput",
  inheritAttrs: !1,
  props: rM(),
  emits: {
    "click:control": (e) => !0,
    "mousedown:control": (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    rejected: (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: a,
      slots: r
    } = t;
    const {
      t: l
    } = Ke(), {
      filterAccepted: i
    } = nM(e), o = he(e, "modelValue", e.modelValue, (W) => rt(W), (W) => !e.multiple && Array.isArray(W) ? W[0] : W), {
      isFocused: s,
      focus: u,
      blur: c
    } = ma(e), d = T(() => typeof e.showSize != "boolean" ? e.showSize : void 0), f = T(() => (o.value ?? []).reduce((W, R) => {
      let {
        size: j = 0
      } = R;
      return W + j;
    }, 0)), v = T(() => ev(f.value, d.value)), g = T(() => (o.value ?? []).map((W) => {
      const {
        name: R = "",
        size: j = 0
      } = W, H = E(R);
      return e.showSize ? `${H} (${ev(j, d.value)})` : H;
    })), m = T(() => {
      const W = o.value?.length ?? 0;
      return e.showSize ? l(e.counterSizeString, W, v.value) : l(e.counterString, W);
    }), h = G(), w = G(), _ = G(), I = D(() => s.value || e.active), C = T(() => ["plain", "underlined"].includes(e.variant)), b = ae(!1), {
      handleDrop: p,
      hasFilesOrFolders: x
    } = eM();
    function k() {
      _.value !== document.activeElement && _.value?.focus(), s.value || u();
    }
    function V(W) {
      _.value?.click();
    }
    function A(W) {
      a("mousedown:control", W);
    }
    function M(W) {
      _.value?.click(), a("click:control", W);
    }
    function L(W) {
      W.stopPropagation(), k(), Se(() => {
        o.value = [], ai(e["onClick:clear"], W);
      });
    }
    function E(W) {
      if (W.length < Number(e.truncateLength)) return W;
      const R = Math.floor((Number(e.truncateLength) - 1) / 2);
      return `${W.slice(0, R)}…${W.slice(W.length - R)}`;
    }
    function P(W) {
      W.preventDefault(), W.stopImmediatePropagation(), b.value = !0;
    }
    function O(W) {
      W.preventDefault(), b.value = !1;
    }
    async function F(W) {
      if (W.preventDefault(), W.stopImmediatePropagation(), b.value = !1, !_.value || !x(W)) return;
      const R = await p(W);
      N(R);
    }
    function B(W) {
      if (!(!W.target || W.repack))
        if (e.filterByType)
          N([...W.target.files]);
        else {
          const R = W.target;
          o.value = [...R.files ?? []];
        }
    }
    function N(W) {
      const R = new DataTransfer(), {
        accepted: j,
        rejected: H
      } = i(W);
      H.length && a("rejected", H);
      for (const z of j)
        R.items.add(z);
      _.value.files = R.files, o.value = [...R.files];
      const $ = new Event("change", {
        bubbles: !0
      });
      $.repack = !0, _.value.dispatchEvent($);
    }
    return ne(o, (W) => {
      (!Array.isArray(W) || !W.length) && _.value && (_.value.value = "");
    }), X(() => {
      const W = !!(r.counter || e.counter), R = !!(W || r.details), [j, H] = Jn(n), {
        modelValue: $,
        ...z
      } = Gt.filterProps(e), te = {
        ...Ea.filterProps(e),
        "onClick:clear": L
      }, me = n.webkitdirectory !== void 0 && n.webkitdirectory !== !1, Q = n.accept ? String(n.accept) : void 0, ie = me ? void 0 : e.filterByType ?? Q;
      return y(Gt, Y({
        ref: h,
        modelValue: e.multiple ? o.value : o.value[0],
        class: ["v-file-input", {
          "v-file-input--chips": !!e.chips,
          "v-file-input--dragging": b.value,
          "v-file-input--hide": e.hideInput,
          "v-input--plain-underlined": C.value
        }, e.class],
        style: e.style,
        "onClick:prepend": V
      }, j, z, {
        centerAffix: !C.value,
        focused: s.value
      }), {
        ...r,
        default: (ke) => {
          let {
            id: ye,
            isDisabled: ue,
            isDirty: Te,
            isReadonly: Ne,
            isValid: je,
            hasDetails: xe
          } = ke;
          return y(Ea, Y({
            ref: w,
            prependIcon: e.prependIcon,
            onMousedown: A,
            onClick: M,
            "onClick:prependInner": e["onClick:prependInner"],
            "onClick:appendInner": e["onClick:appendInner"]
          }, te, {
            id: ye.value,
            active: I.value || Te.value,
            dirty: Te.value || e.dirty,
            disabled: ue.value,
            focused: s.value,
            details: xe.value,
            error: je.value === !1,
            onDragover: P,
            onDrop: F
          }), {
            ...r,
            default: (Be) => {
              let {
                props: {
                  class: ct,
                  ...Yt
                },
                controlRef: Ue
              } = Be;
              return S(fe, null, [S("input", Y({
                ref: (oe) => _.value = Ue.value = oe,
                type: "file",
                accept: ie,
                readonly: Ne.value,
                disabled: ue.value,
                multiple: e.multiple,
                name: e.name,
                onClick: (oe) => {
                  oe.stopPropagation(), Ne.value && oe.preventDefault(), k();
                },
                onChange: B,
                onDragleave: O,
                onFocus: k,
                onBlur: c
              }, Yt, H), null), S("div", {
                class: J(ct)
              }, [!!o.value?.length && !e.hideInput && (r.selection ? r.selection({
                fileNames: g.value,
                totalBytes: f.value,
                totalBytesReadable: v.value
              }) : e.chips ? g.value.map((oe) => y(ua, {
                key: oe,
                size: "small",
                text: oe
              }, null)) : g.value.join(", "))])]);
            }
          });
        },
        details: R ? (ke) => S(fe, null, [r.details?.(ke), W && S(fe, null, [S("span", null, null), y(Go, {
          active: !!o.value?.length,
          value: m.value,
          disabled: e.disabled
        }, r.counter)])]) : void 0
      });
    }), Mt({}, h, w, _);
  }
}), iM = U({
  app: Boolean,
  color: String,
  height: {
    type: [Number, String],
    default: "auto"
  },
  ...qt(),
  ...ve(),
  ...Ct(),
  ...cr(),
  ...lt(),
  ...Ie({
    tag: "footer"
  }),
  ...Re()
}, "VFooter"), oM = K()({
  name: "VFooter",
  props: iM(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = G(), {
      themeClasses: r
    } = Ge(e), {
      backgroundColorClasses: l,
      backgroundColorStyles: i
    } = qe(() => e.color), {
      borderClasses: o
    } = en(e), {
      elevationClasses: s
    } = Et(e), {
      roundedClasses: u
    } = ut(e), c = ae(32), {
      resizeRef: d
    } = Vn((v) => {
      v.length && (c.value = v[0].target.clientHeight);
    }), f = T(() => e.height === "auto" ? c.value : parseInt(e.height, 10));
    return Wt(() => e.app, () => {
      const v = dr({
        id: e.name,
        order: T(() => parseInt(e.order, 10)),
        position: D(() => "bottom"),
        layoutSize: f,
        elementSize: T(() => e.height === "auto" ? void 0 : f.value),
        active: D(() => e.app),
        absolute: D(() => e.absolute)
      });
      ft(() => {
        a.value = v.layoutItemStyles.value;
      });
    }), X(() => y(e.tag, {
      ref: d,
      class: J(["v-footer", r.value, l.value, o.value, s.value, u.value, e.class]),
      style: le([i.value, e.app ? a.value : {
        height: re(e.height)
      }, e.style])
    }, n)), {};
  }
}), sM = U({
  ...ve(),
  ...rI()
}, "VForm"), uM = K()({
  name: "VForm",
  props: sM(),
  emits: {
    "update:modelValue": (e) => !0,
    submit: (e) => !0
  },
  setup(e, t) {
    let {
      slots: n,
      emit: a
    } = t;
    const r = lI(e), l = G();
    function i(s) {
      s.preventDefault(), r.reset();
    }
    function o(s) {
      const u = s, c = r.validate();
      u.then = c.then.bind(c), u.catch = c.catch.bind(c), u.finally = c.finally.bind(c), a("submit", u), u.defaultPrevented || c.then((d) => {
        let {
          valid: f
        } = d;
        f && l.value?.submit();
      }), u.preventDefault();
    }
    return X(() => S("form", {
      ref: l,
      class: J(["v-form", e.class]),
      style: le(e.style),
      novalidate: !0,
      onReset: i,
      onSubmit: o
    }, [n.default?.(r)])), Mt(r, l);
  }
}), cM = U({
  color: String,
  ...qt(),
  ...ve(),
  ...lt(),
  ...Ie({
    tag: "kbd"
  }),
  ...Re(),
  ...Ct()
}, "VKbd"), Hu = K()({
  name: "VKbd",
  props: cM(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: a
    } = Ge(e), {
      borderClasses: r
    } = en(e), {
      roundedClasses: l
    } = ut(e), {
      backgroundColorClasses: i,
      backgroundColorStyles: o
    } = qe(() => e.color), {
      elevationClasses: s
    } = Et(e);
    return X(() => y(e.tag, {
      class: J(["v-kbd", a.value, i.value, r.value, s.value, l.value, e.class]),
      style: le([o.value, e.style])
    }, n)), {};
  }
});
function sp(e, t, n) {
  const a = n && e.mac ? e.mac : e.default, r = t === "icon" && !a.icon || t === "symbol" && !a.symbol ? "text" : t;
  let l = a[r] ?? a.text;
  return r === "text" && typeof l == "string" && l.startsWith("$") && !l.startsWith("$vuetify.") && (l = l.slice(1).toUpperCase()), r === "icon" ? ["icon", l] : [r, l];
}
const up = {
  ctrl: {
    mac: {
      symbol: "⌃",
      icon: "$ctrl",
      text: "$vuetify.hotkey.ctrl"
    },
    default: {
      text: "Ctrl"
    }
  },
  meta: {
    mac: {
      symbol: "⌘",
      icon: "$command",
      text: "$vuetify.hotkey.command"
    },
    default: {
      text: "Ctrl"
    }
  },
  cmd: {
    mac: {
      symbol: "⌘",
      icon: "$command",
      text: "$vuetify.hotkey.command"
    },
    default: {
      text: "Ctrl"
    }
  },
  shift: {
    mac: {
      symbol: "⇧",
      icon: "$shift",
      text: "$vuetify.hotkey.shift"
    },
    default: {
      text: "Shift"
    }
  },
  alt: {
    mac: {
      symbol: "⌥",
      icon: "$alt",
      text: "$vuetify.hotkey.option"
    },
    default: {
      text: "Alt"
    }
  },
  enter: {
    default: {
      symbol: "↵",
      icon: "$enter",
      text: "$vuetify.hotkey.enter"
    }
  },
  arrowup: {
    default: {
      symbol: "↑",
      icon: "$arrowup",
      text: "$vuetify.hotkey.upArrow"
    }
  },
  arrowdown: {
    default: {
      symbol: "↓",
      icon: "$arrowdown",
      text: "$vuetify.hotkey.downArrow"
    }
  },
  arrowleft: {
    default: {
      symbol: "←",
      icon: "$arrowleft",
      text: "$vuetify.hotkey.leftArrow"
    }
  },
  arrowright: {
    default: {
      symbol: "→",
      icon: "$arrowright",
      text: "$vuetify.hotkey.rightArrow"
    }
  },
  backspace: {
    default: {
      symbol: "⌫",
      icon: "$backspace",
      text: "$vuetify.hotkey.backspace"
    }
  },
  escape: {
    default: {
      text: "$vuetify.hotkey.escape"
    }
  },
  " ": {
    mac: {
      symbol: "␣",
      icon: "$space",
      text: "$vuetify.hotkey.space"
    },
    default: {
      text: "$vuetify.hotkey.space"
    }
  },
  "-": {
    default: {
      text: "-"
    }
  }
}, dM = U({
  // String representing keyboard shortcuts (e.g., "ctrl+k", "meta+shift+p")
  keys: String,
  // How to display keys: 'symbol' uses special characters (⌘, ⌃), 'icon' uses SVG icons, 'text' uses words
  displayMode: {
    type: String,
    default: "icon"
  },
  // Custom key mapping configuration. Users can import and modify the exported hotkeyMap as needed
  keyMap: {
    type: Object,
    default: () => up
  },
  platform: {
    type: String,
    default: "auto"
  },
  inline: Boolean,
  disabled: Boolean,
  prefix: String,
  suffix: String,
  variant: {
    type: String,
    default: "elevated",
    validator: (e) => ["elevated", "flat", "tonal", "outlined", "text", "plain", "contained"].includes(e)
  },
  ...ve(),
  ...Re(),
  ...qt(),
  ...lt(),
  ...Ct(),
  color: String
}, "VHotkey"), Ns = /* @__PURE__ */ Symbol("VHotkey:AND_DELINEATOR"), Fs = /* @__PURE__ */ Symbol("VHotkey:SLASH_DELINEATOR"), Gv = /* @__PURE__ */ Symbol("VHotkey:THEN_DELINEATOR");
function fM(e, t, n) {
  const a = t.toLowerCase();
  if (a in e) {
    const r = sp(e[a], "text", n);
    return typeof r[1] == "string" ? r[1] : String(r[1]);
  }
  return t.toUpperCase();
}
function qv(e, t, n, a) {
  const r = n.toLowerCase();
  if (r in e) {
    const l = sp(e[r], t, a);
    return l[0] === "text" && typeof l[1] == "string" && l[1].startsWith("$") && !l[1].startsWith("$vuetify.") ? ["text", l[1].replace("$", "").toUpperCase(), n] : [...l, n];
  }
  return ["text", n.toUpperCase(), n];
}
const vM = K()({
  name: "VHotkey",
  props: dM(),
  setup(e) {
    const {
      t
    } = Ke(), {
      themeClasses: n
    } = Ge(e), {
      rtlClasses: a
    } = At(), {
      borderClasses: r
    } = en(e), {
      roundedClasses: l
    } = ut(e), {
      elevationClasses: i
    } = Et(e), {
      colorClasses: o,
      colorStyles: s,
      variantClasses: u
    } = va(() => ({
      color: e.color,
      variant: e.variant === "contained" ? "elevated" : e.variant
    })), c = T(() => e.platform === "auto" ? typeof navigator < "u" && /macintosh/i.test(navigator.userAgent) : e.platform === "mac"), d = T(() => e.keys ? e.keys.split(" ").map((w) => {
      const _ = [], I = bP(w);
      for (let C = 0; C < I.length; C++) {
        const b = I[C];
        C > 0 && _.push(Gv);
        const {
          keys: p,
          separators: x
        } = Ky(b);
        for (let k = 0; k < p.length; k++) {
          const V = p[k];
          k > 0 && _.push(x[k - 1] === "/" ? Fs : Ns), _.push(qv(e.keyMap, e.displayMode, V, c.value));
        }
      }
      return _;
    }) : []), f = T(() => {
      if (!e.keys) return "";
      const _ = d.value.map((I) => {
        const C = [];
        for (const b of I)
          if (Array.isArray(b)) {
            const p = b[0] === "icon" || b[0] === "symbol" ? qv(jn(up, e.keyMap), "text", String(b[1]), c.value)[1] : b[1];
            C.push(v(p));
          } else
            b === Ns ? C.push(t("$vuetify.hotkey.plus")) : b === Fs ? C.push(t("$vuetify.hotkey.or")) : b === Gv && C.push(t("$vuetify.hotkey.then"));
        return C.join(" ");
      }).join(", ");
      return t("$vuetify.hotkey.shortcut", _);
    });
    function v(w) {
      return w.startsWith("$vuetify.") ? t(w) : w;
    }
    function g(w) {
      if (e.displayMode === "text") return;
      const _ = fM(e.keyMap, String(w[2]), c.value);
      return v(_);
    }
    function m(w, _) {
      const I = e.variant === "contained", C = I ? "kbd" : Hu, b = ["v-hotkey__key", `v-hotkey__key-${w[0]}`, ...I ? ["v-hotkey__key--nested"] : [r.value, l.value, i.value, o.value]];
      return y(C, {
        key: _,
        class: J(b),
        style: le(I ? void 0 : s.value),
        "aria-hidden": "true",
        title: g(w)
      }, {
        default: () => [w[0] === "icon" ? y(ze, {
          icon: w[1],
          "aria-hidden": "true"
        }, null) : v(w[1])]
      });
    }
    function h(w, _) {
      return S("span", {
        key: _,
        class: "v-hotkey__divider",
        "aria-hidden": "true"
      }, [w === Ns ? "+" : w === Fs ? "/" : t("$vuetify.hotkey.then")]);
    }
    X(() => {
      const w = S(fe, null, [e.prefix && S("span", {
        key: "prefix",
        class: "v-hotkey__prefix"
      }, [e.prefix]), d.value.map((_, I) => S("span", {
        class: "v-hotkey__combination",
        key: I
      }, [_.map((C, b) => Array.isArray(C) ? m(C, b) : h(C, b)), I < d.value.length - 1 && S("span", {
        "aria-hidden": "true"
      }, [we(" ")])])), e.suffix && S("span", {
        key: "suffix",
        class: "v-hotkey__suffix"
      }, [e.suffix])]);
      return S("div", {
        class: J(["v-hotkey", {
          "v-hotkey--disabled": e.disabled,
          "v-hotkey--inline": e.inline,
          "v-hotkey--contained": e.variant === "contained"
        }, n.value, a.value, u.value, e.class]),
        style: le(e.style),
        role: "img",
        "aria-label": f.value
      }, [e.variant !== "contained" ? w : y(Hu, {
        key: "contained",
        class: J(["v-hotkey__contained-wrapper", r.value, l.value, i.value, o.value]),
        style: le(s.value),
        "aria-hidden": "true"
      }, {
        default: () => [w]
      })]);
    });
  }
}), mM = U({
  disabled: Boolean,
  modelValue: {
    type: Boolean,
    default: null
  },
  ...qc()
}, "VHover"), hM = K()({
  name: "VHover",
  props: mM(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = he(e, "modelValue"), {
      runOpenDelay: r,
      runCloseDelay: l
    } = Yc(e, (i) => !e.disabled && (a.value = i));
    return () => n.default?.({
      isHovering: a.value,
      props: {
        onMouseenter: r,
        onMouseleave: l
      }
    });
  }
}), gM = U({
  color: String,
  direction: {
    type: String,
    default: "vertical",
    validator: (e) => ["vertical", "horizontal"].includes(e)
  },
  side: {
    type: String,
    default: "end",
    validator: (e) => ["start", "end", "both"].includes(e)
  },
  mode: {
    type: String,
    default: "intersect",
    validator: (e) => ["intersect", "manual"].includes(e)
  },
  margin: [Number, String],
  loadMoreText: {
    type: String,
    default: "$vuetify.infiniteScroll.loadMore"
  },
  emptyText: {
    type: String,
    default: "$vuetify.infiniteScroll.empty"
  },
  ...St(),
  ...Ie()
}, "VInfiniteScroll"), Yv = rn({
  name: "VInfiniteScrollIntersect",
  props: {
    side: {
      type: String,
      required: !0
    },
    rootMargin: String
  },
  emits: {
    intersect: (e, t) => !0
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    const {
      intersectionRef: a,
      isIntersecting: r
    } = li();
    return ne(r, async (l) => {
      n("intersect", e.side, l);
    }), X(() => S("div", {
      class: "v-infinite-scroll-intersect",
      style: {
        "--v-infinite-margin-size": e.rootMargin
      },
      ref: a
    }, [we(" ")])), {};
  }
}), yM = K()({
  name: "VInfiniteScroll",
  props: gM(),
  emits: {
    load: (e) => !0
  },
  setup(e, t) {
    let {
      slots: n,
      emit: a
    } = t;
    const r = G(), l = ae("ok"), i = ae("ok"), o = T(() => re(e.margin)), s = ae(!1);
    function u(p) {
      if (!r.value) return;
      const x = e.direction === "vertical" ? "scrollTop" : "scrollLeft";
      r.value[x] = p;
    }
    function c() {
      if (!r.value) return 0;
      const p = e.direction === "vertical" ? "scrollTop" : "scrollLeft";
      return r.value[p];
    }
    function d() {
      if (!r.value) return 0;
      const p = e.direction === "vertical" ? "scrollHeight" : "scrollWidth";
      return r.value[p];
    }
    function f() {
      if (!r.value) return 0;
      const p = e.direction === "vertical" ? "clientHeight" : "clientWidth";
      return r.value[p];
    }
    bt(() => {
      r.value && (e.side === "start" ? u(d()) : e.side === "both" && u(d() / 2 - f() / 2));
    });
    function v(p, x) {
      p === "start" ? l.value = x : p === "end" ? i.value = x : p === "both" && (l.value = x, i.value = x);
    }
    function g(p) {
      return p === "start" ? l.value : i.value;
    }
    let m = 0;
    function h(p, x) {
      s.value = x, s.value && w(p);
    }
    function w(p) {
      if (e.mode !== "manual" && !s.value) return;
      const x = g(p);
      if (!r.value || ["empty", "loading"].includes(x)) return;
      m = d(), v(p, "loading");
      function k(V) {
        v(p, V), Se(() => {
          V === "empty" || V === "error" || (V === "ok" && p === "start" && u(d() - m + c()), e.mode !== "manual" && Se(() => {
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                  w(p);
                });
              });
            });
          }));
        });
      }
      a("load", {
        side: p,
        done: k
      });
    }
    const {
      t: _
    } = Ke();
    function I(p, x) {
      if (e.side !== p && e.side !== "both") return;
      const k = () => w(p), V = {
        side: p,
        props: {
          onClick: k,
          color: e.color
        }
      };
      return x === "error" ? n.error?.(V) : x === "empty" ? n.empty?.(V) ?? S("div", null, [_(e.emptyText)]) : e.mode === "manual" ? x === "loading" ? n.loading?.(V) ?? y(Aa, {
        indeterminate: !0,
        color: e.color
      }, null) : n["load-more"]?.(V) ?? y(De, {
        variant: "outlined",
        color: e.color,
        onClick: k
      }, {
        default: () => [_(e.loadMoreText)]
      }) : n.loading?.(V) ?? y(Aa, {
        indeterminate: !0,
        color: e.color
      }, null);
    }
    const {
      dimensionStyles: C
    } = xt(e);
    X(() => {
      const p = e.tag, x = e.side === "start" || e.side === "both", k = e.side === "end" || e.side === "both", V = e.mode === "intersect";
      return y(p, {
        ref: r,
        class: J(["v-infinite-scroll", `v-infinite-scroll--${e.direction}`, {
          "v-infinite-scroll--start": x,
          "v-infinite-scroll--end": k
        }]),
        style: le(C.value)
      }, {
        default: () => [S("div", {
          class: "v-infinite-scroll__side"
        }, [I("start", l.value)]), x && V && y(Yv, {
          key: "start",
          side: "start",
          onIntersect: h,
          rootMargin: o.value
        }, null), n.default?.(), k && V && y(Yv, {
          key: "end",
          side: "end",
          onIntersect: h,
          rootMargin: o.value
        }, null), S("div", {
          class: "v-infinite-scroll__side"
        }, [I("end", i.value)])]
      });
    });
    function b(p) {
      const x = p ?? e.side;
      v(x, "ok"), Se(() => {
        x !== "end" && u(d() - m + c()), e.mode !== "manual" && Se(() => {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                x === "both" ? (w("start"), w("end")) : w(x);
              });
            });
          });
        });
      });
    }
    return {
      reset: b
    };
  }
}), cp = /* @__PURE__ */ Symbol.for("vuetify:v-item-group"), bM = U({
  ...ve(),
  ...vr({
    selectedClass: "v-item--selected"
  }),
  ...Ie(),
  ...Re()
}, "VItemGroup"), pM = K()({
  name: "VItemGroup",
  props: bM(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: a
    } = Ge(e), {
      isSelected: r,
      select: l,
      next: i,
      prev: o,
      selected: s
    } = Na(e, cp);
    return () => y(e.tag, {
      class: J(["v-item-group", a.value, e.class]),
      style: le(e.style)
    }, {
      default: () => [n.default?.({
        isSelected: r,
        select: l,
        next: i,
        prev: o,
        selected: s.value
      })]
    });
  }
}), wM = K()({
  name: "VItem",
  props: mr(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      isSelected: a,
      select: r,
      toggle: l,
      selectedClass: i,
      value: o,
      disabled: s
    } = Ia(e, cp);
    return () => n.default?.({
      isSelected: a.value,
      selectedClass: i.value,
      select: r,
      toggle: l,
      value: o.value,
      disabled: s.value
    });
  }
}), kM = U({
  ...ve(),
  ...St(),
  ...yg()
}, "VLayout"), SM = K()({
  name: "VLayout",
  props: kM(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      layoutClasses: a,
      layoutStyles: r,
      getLayoutItem: l,
      items: i,
      layoutRef: o
    } = pg(e), {
      dimensionStyles: s
    } = xt(e);
    return X(() => S("div", {
      ref: o,
      class: J([a.value, e.class]),
      style: le([s.value, r.value, e.style])
    }, [n.default?.()])), {
      getLayoutItem: l,
      items: i
    };
  }
}), xM = U({
  position: {
    type: String,
    required: !0
  },
  size: {
    type: [Number, String],
    default: 300
  },
  modelValue: Boolean,
  ...ve(),
  ...cr()
}, "VLayoutItem"), CM = K()({
  name: "VLayoutItem",
  props: xM(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      layoutItemStyles: a
    } = dr({
      id: e.name,
      order: T(() => parseInt(e.order, 10)),
      position: D(() => e.position),
      elementSize: D(() => e.size),
      layoutSize: D(() => e.size),
      active: D(() => e.modelValue),
      absolute: D(() => e.absolute)
    });
    return () => S("div", {
      class: J(["v-layout-item", e.class]),
      style: le([a.value, e.style])
    }, [n.default?.()]);
  }
}), _M = U({
  modelValue: Boolean,
  options: {
    type: Object,
    // For more information on types, navigate to:
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    default: () => ({
      root: void 0,
      rootMargin: void 0,
      threshold: void 0
    })
  },
  ...ve(),
  ...St(),
  ...Ie(),
  ...da({
    transition: "fade-transition"
  })
}, "VLazy"), TM = K()({
  name: "VLazy",
  directives: {
    vIntersect: Bn
  },
  props: _M(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      dimensionStyles: a
    } = xt(e), r = he(e, "modelValue");
    function l(i) {
      r.value || (r.value = i);
    }
    return X(() => at(y(e.tag, {
      class: J(["v-lazy", e.class]),
      style: le([a.value, e.style])
    }, {
      default: () => [r.value && y(Xt, {
        transition: e.transition,
        appear: !0
      }, {
        default: () => [n.default?.()]
      })]
    }), [[Bn, {
      handler: l,
      options: e.options
    }, null]])), {};
  }
}), IM = U({
  locale: String,
  fallbackLocale: String,
  messages: Object,
  rtl: {
    type: Boolean,
    default: void 0
  },
  ...ve()
}, "VLocaleProvider"), AM = K()({
  name: "VLocaleProvider",
  props: IM(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      rtlClasses: a
    } = wg(e);
    return X(() => S("div", {
      class: J(["v-locale-provider", a.value, e.class]),
      style: le(e.style)
    }, [n.default?.()])), {};
  }
}), PM = U({
  scrollable: Boolean,
  ...ve(),
  ...St(),
  ...Ie({
    tag: "main"
  })
}, "VMain"), VM = K()({
  name: "VMain",
  props: PM(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      dimensionStyles: a
    } = xt(e), {
      mainStyles: r
    } = bg(), {
      ssrBootStyles: l
    } = fr();
    return X(() => y(e.tag, {
      class: J(["v-main", {
        "v-main--scrollable": e.scrollable
      }, e.class]),
      style: le([r.value, l.value, a.value, e.style])
    }, {
      default: () => [e.scrollable ? S("div", {
        class: "v-main__scroller"
      }, [n.default?.()]) : n.default?.()]
    })), {};
  }
});
function EM(e) {
  let {
    rootEl: t,
    isSticky: n,
    layoutItemStyles: a
  } = e;
  const r = ae(!1), l = ae(0), i = T(() => {
    const u = typeof r.value == "boolean" ? "top" : r.value;
    return [n.value ? {
      top: "auto",
      bottom: "auto",
      height: void 0
    } : void 0, r.value ? {
      [u]: re(l.value)
    } : {
      top: a.value.top
    }];
  });
  bt(() => {
    ne(n, (u) => {
      u ? window.addEventListener("scroll", s, {
        passive: !0
      }) : window.removeEventListener("scroll", s);
    }, {
      immediate: !0
    });
  }), Ft(() => {
    window.removeEventListener("scroll", s);
  });
  let o = 0;
  function s() {
    const u = o > window.scrollY ? "up" : "down", c = t.value.getBoundingClientRect(), d = parseFloat(a.value.top ?? 0), f = window.scrollY - Math.max(0, l.value - d), v = c.height + Math.max(l.value, d) - window.scrollY - window.innerHeight, g = parseFloat(getComputedStyle(t.value).getPropertyValue("--v-body-scroll-y")) || 0;
    c.height < window.innerHeight - d ? (r.value = "top", l.value = d) : u === "up" && r.value === "bottom" || u === "down" && r.value === "top" ? (l.value = window.scrollY + c.top - g, r.value = !0) : u === "down" && v <= 0 ? (l.value = 0, r.value = "bottom") : u === "up" && f <= 0 && (g ? r.value !== "top" && (l.value = -f + g + d, r.value = "top") : (l.value = c.top + f, r.value = "top")), o = window.scrollY;
  }
  return {
    isStuck: r,
    stickyStyles: i
  };
}
const MM = 100, OM = 20;
function Kv(e) {
  return (e < 0 ? -1 : 1) * Math.sqrt(Math.abs(e)) * 1.41421356237;
}
function Zv(e) {
  if (e.length < 2)
    return 0;
  if (e.length === 2)
    return e[1].t === e[0].t ? 0 : (e[1].d - e[0].d) / (e[1].t - e[0].t);
  let t = 0;
  for (let n = e.length - 1; n > 0; n--) {
    if (e[n].t === e[n - 1].t)
      continue;
    const a = Kv(t), r = (e[n].d - e[n - 1].d) / (e[n].t - e[n - 1].t);
    t += (r - a) * Math.abs(r), n === e.length - 1 && (t *= 0.5);
  }
  return Kv(t) * 1e3;
}
function DM() {
  const e = {};
  function t(r) {
    Array.from(r.changedTouches).forEach((l) => {
      (e[l.identifier] ?? (e[l.identifier] = new ig(OM))).push([r.timeStamp, l]);
    });
  }
  function n(r) {
    Array.from(r.changedTouches).forEach((l) => {
      delete e[l.identifier];
    });
  }
  function a(r) {
    const l = e[r]?.values().reverse();
    if (!l)
      throw new Error(`No samples for touch id ${r}`);
    const i = l[0], o = [], s = [];
    for (const u of l) {
      if (i[0] - u[0] > MM) break;
      o.push({
        t: u[0],
        d: u[1].clientX
      }), s.push({
        t: u[0],
        d: u[1].clientY
      });
    }
    return {
      x: Zv(o),
      y: Zv(s),
      get direction() {
        const {
          x: u,
          y: c
        } = this, [d, f] = [Math.abs(u), Math.abs(c)];
        return d > f && u >= 0 ? "right" : d > f && u <= 0 ? "left" : f > d && c >= 0 ? "down" : f > d && c <= 0 ? "up" : LM();
      }
    };
  }
  return {
    addMovement: t,
    endTouch: n,
    getVelocity: a
  };
}
function LM() {
  throw new Error();
}
function NM(e) {
  let {
    el: t,
    isActive: n,
    isTemporary: a,
    width: r,
    touchless: l,
    position: i
  } = e;
  bt(() => {
    window.addEventListener("touchstart", _, {
      passive: !0
    }), window.addEventListener("touchmove", I, {
      passive: !1
    }), window.addEventListener("touchend", C, {
      passive: !0
    });
  }), Ft(() => {
    window.removeEventListener("touchstart", _), window.removeEventListener("touchmove", I), window.removeEventListener("touchend", C);
  });
  const o = T(() => ["left", "right"].includes(i.value)), {
    addMovement: s,
    endTouch: u,
    getVelocity: c
  } = DM();
  let d = !1;
  const f = ae(!1), v = ae(0), g = ae(0);
  let m;
  function h(p, x) {
    return (i.value === "left" ? p : i.value === "right" ? document.documentElement.clientWidth - p : i.value === "top" ? p : i.value === "bottom" ? document.documentElement.clientHeight - p : Ar()) - (x ? r.value : 0);
  }
  function w(p) {
    let x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    const k = i.value === "left" ? (p - g.value) / r.value : i.value === "right" ? (document.documentElement.clientWidth - p - g.value) / r.value : i.value === "top" ? (p - g.value) / r.value : i.value === "bottom" ? (document.documentElement.clientHeight - p - g.value) / r.value : Ar();
    return x ? Xe(k) : k;
  }
  function _(p) {
    if (l.value) return;
    const x = p.changedTouches[0].clientX, k = p.changedTouches[0].clientY, V = 25, A = i.value === "left" ? x < V : i.value === "right" ? x > document.documentElement.clientWidth - V : i.value === "top" ? k < V : i.value === "bottom" ? k > document.documentElement.clientHeight - V : Ar(), M = n.value && (i.value === "left" ? x < r.value : i.value === "right" ? x > document.documentElement.clientWidth - r.value : i.value === "top" ? k < r.value : i.value === "bottom" ? k > document.documentElement.clientHeight - r.value : Ar());
    (A || M || n.value && a.value) && (m = [x, k], g.value = h(o.value ? x : k, n.value), v.value = w(o.value ? x : k), d = g.value > -20 && g.value < 80, u(p), s(p));
  }
  function I(p) {
    const x = p.changedTouches[0].clientX, k = p.changedTouches[0].clientY;
    if (d) {
      if (!p.cancelable) {
        d = !1;
        return;
      }
      const A = Math.abs(x - m[0]), M = Math.abs(k - m[1]);
      (o.value ? A > M && A > 3 : M > A && M > 3) ? (f.value = !0, d = !1) : (o.value ? M : A) > 3 && (d = !1);
    }
    if (!f.value) return;
    p.preventDefault(), s(p);
    const V = w(o.value ? x : k, !1);
    v.value = Math.max(0, Math.min(1, V)), V > 1 ? g.value = h(o.value ? x : k, !0) : V < 0 && (g.value = h(o.value ? x : k, !1));
  }
  function C(p) {
    if (d = !1, !f.value) return;
    s(p), f.value = !1;
    const x = c(p.changedTouches[0].identifier), k = Math.abs(x.x), V = Math.abs(x.y);
    (o.value ? k > V && k > 400 : V > k && V > 3) ? n.value = x.direction === ({
      left: "right",
      right: "left",
      top: "down",
      bottom: "up"
    }[i.value] || Ar()) : n.value = v.value > 0.5;
  }
  const b = T(() => f.value ? {
    transform: i.value === "left" ? `translateX(calc(-100% + ${v.value * r.value}px))` : i.value === "right" ? `translateX(calc(100% - ${v.value * r.value}px))` : i.value === "top" ? `translateY(calc(-100% + ${v.value * r.value}px))` : i.value === "bottom" ? `translateY(calc(100% - ${v.value * r.value}px))` : Ar(),
    transition: "none"
  } : void 0);
  return Wt(f, () => {
    const p = t.value?.style.transform ?? null, x = t.value?.style.transition ?? null;
    ft(() => {
      t.value?.style.setProperty("transform", b.value?.transform || "none"), t.value?.style.setProperty("transition", b.value?.transition || null);
    }), It(() => {
      t.value?.style.setProperty("transform", p), t.value?.style.setProperty("transition", x);
    });
  }), {
    isDragging: f,
    dragProgress: v,
    dragStyles: b
  };
}
function Ar() {
  throw new Error();
}
const FM = ["start", "end", "left", "right", "top", "bottom"], RM = U({
  color: String,
  disableResizeWatcher: Boolean,
  disableRouteWatcher: Boolean,
  expandOnHover: Boolean,
  floating: Boolean,
  modelValue: {
    type: Boolean,
    default: null
  },
  permanent: Boolean,
  rail: {
    type: Boolean,
    default: null
  },
  railWidth: {
    type: [Number, String],
    default: 56
  },
  scrim: {
    type: [Boolean, String],
    default: !0
  },
  image: String,
  temporary: Boolean,
  persistent: Boolean,
  touchless: Boolean,
  width: {
    type: [Number, String],
    default: 256
  },
  location: {
    type: String,
    default: "start",
    validator: (e) => FM.includes(e)
  },
  sticky: Boolean,
  ...qt(),
  ...ve(),
  ...qc(),
  ...hr({
    mobile: null
  }),
  ...Ct(),
  ...cr(),
  ...lt(),
  ...Pe(by(), ["disableInitialFocus"]),
  ...Ie({
    tag: "nav"
  }),
  ...Re()
}, "VNavigationDrawer"), $M = K()({
  name: "VNavigationDrawer",
  props: RM(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:rail": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: a,
      slots: r
    } = t;
    const {
      isRtl: l
    } = At(), {
      themeClasses: i
    } = Ge(e), {
      borderClasses: o
    } = en(e), {
      backgroundColorClasses: s,
      backgroundColorStyles: u
    } = qe(() => e.color), {
      elevationClasses: c
    } = Et(e), {
      displayClasses: d,
      mobile: f
    } = Cn(e), {
      roundedClasses: v
    } = ut(e), g = Vg(), m = he(e, "modelValue", null, (R) => !!R), {
      ssrBootStyles: h
    } = fr(), {
      scopeId: w
    } = gr(), _ = G(), I = ae(!1), {
      runOpenDelay: C,
      runCloseDelay: b
    } = Yc(e, (R) => {
      I.value = R;
    }), p = T(() => e.rail && e.expandOnHover && I.value ? Number(e.width) : Number(e.rail ? e.railWidth : e.width)), x = T(() => su(e.location, l.value)), k = D(() => e.persistent), V = T(() => !e.permanent && (f.value || e.temporary)), A = T(() => e.sticky && !V.value && x.value !== "bottom");
    py(e, {
      isActive: m,
      localTop: V,
      contentEl: _
    }), Wt(() => e.expandOnHover && e.rail != null, () => {
      ne(I, (R) => a("update:rail", !R));
    }), Wt(() => !e.disableResizeWatcher, () => {
      ne(V, (R) => !e.permanent && Se(() => m.value = !R));
    }), Wt(() => !e.disableRouteWatcher && !!g, () => {
      ne(g.currentRoute, () => V.value && (m.value = !1));
    }), ne(() => e.permanent, (R) => {
      R && (m.value = !0);
    }), e.modelValue == null && !V.value && (m.value = e.permanent || !f.value);
    const {
      isDragging: M,
      dragProgress: L
    } = NM({
      el: _,
      isActive: m,
      isTemporary: V,
      width: p,
      touchless: D(() => e.touchless),
      position: x
    }), E = T(() => {
      const R = V.value ? 0 : e.rail && e.expandOnHover ? Number(e.railWidth) : p.value;
      return M.value ? R * L.value : R;
    }), {
      layoutItemStyles: P,
      layoutItemScrimStyles: O
    } = dr({
      id: e.name,
      order: T(() => parseInt(e.order, 10)),
      position: x,
      layoutSize: E,
      elementSize: p,
      active: yo(m),
      disableTransitions: D(() => M.value),
      absolute: T(() => (
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        e.absolute || A.value && typeof F.value != "string"
      ))
    }), {
      isStuck: F,
      stickyStyles: B
    } = EM({
      rootEl: _,
      isSticky: A,
      layoutItemStyles: P
    }), N = qe(() => typeof e.scrim == "string" ? e.scrim : null), W = T(() => ({
      ...M.value ? {
        opacity: L.value * 0.2,
        transition: "none"
      } : void 0,
      ...O.value
    }));
    return vt({
      VList: {
        bgColor: "transparent"
      }
    }), X(() => {
      const R = r.image || e.image;
      return S(fe, null, [y(e.tag, Y({
        ref: _,
        onMouseenter: C,
        onMouseleave: b,
        class: ["v-navigation-drawer", `v-navigation-drawer--${x.value}`, {
          "v-navigation-drawer--expand-on-hover": e.expandOnHover,
          "v-navigation-drawer--floating": e.floating,
          "v-navigation-drawer--is-hovering": I.value,
          "v-navigation-drawer--rail": e.rail,
          "v-navigation-drawer--temporary": V.value,
          "v-navigation-drawer--persistent": k.value,
          "v-navigation-drawer--active": m.value,
          "v-navigation-drawer--sticky": A.value
        }, i.value, s.value, o.value, d.value, c.value, v.value, e.class],
        style: [u.value, P.value, h.value, B.value, e.style],
        inert: !m.value
      }, w, n), {
        default: () => [R && S("div", {
          key: "image",
          class: "v-navigation-drawer__img"
        }, [r.image ? y(Ae, {
          key: "image-defaults",
          disabled: !e.image,
          defaults: {
            VImg: {
              alt: "",
              cover: !0,
              height: "inherit",
              src: e.image
            }
          }
        }, r.image) : y(sa, {
          key: "image-img",
          alt: "",
          cover: !0,
          height: "inherit",
          src: e.image
        }, null)]), r.prepend && S("div", {
          class: "v-navigation-drawer__prepend"
        }, [r.prepend?.()]), S("div", {
          class: "v-navigation-drawer__content"
        }, [r.default?.()]), r.append && S("div", {
          class: "v-navigation-drawer__append"
        }, [r.append?.()])]
      }), y(Rn, {
        name: "fade-transition"
      }, {
        default: () => [V.value && (M.value || m.value) && !!e.scrim && S("div", Y({
          class: ["v-navigation-drawer__scrim", N.backgroundColorClasses.value],
          style: [W.value, N.backgroundColorStyles.value],
          onClick: () => {
            k.value || (m.value = !1);
          }
        }, w), null)]
      })]);
    }), {
      isStuck: F
    };
  }
}), BM = rn({
  name: "VNoSsr",
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = wy();
    return () => a.value && n.default?.();
  }
}), UM = 50, WM = 500;
function HM(e) {
  let {
    toggleUpDown: t
  } = e, n = -1, a = -1;
  It(l);
  function r(o) {
    l(), i(o), window.addEventListener("pointerup", l), document.addEventListener("blur", l), n = window.setTimeout(() => {
      a = window.setInterval(() => i(o), UM);
    }, WM);
  }
  function l() {
    window.clearTimeout(n), window.clearInterval(a), window.removeEventListener("pointerup", l), document.removeEventListener("blur", l);
  }
  It(l);
  function i(o) {
    t(o === "up");
  }
  return {
    holdStart: r,
    holdStop: l
  };
}
const zM = U({
  controlVariant: {
    type: String,
    default: "default"
  },
  inset: Boolean,
  hideInput: Boolean,
  modelValue: {
    type: Number,
    default: null
  },
  min: {
    type: Number,
    default: Number.MIN_SAFE_INTEGER
  },
  max: {
    type: Number,
    default: Number.MAX_SAFE_INTEGER
  },
  step: {
    type: Number,
    default: 1
  },
  precision: {
    type: Number,
    default: 0
  },
  minFractionDigits: {
    type: Number,
    default: null
  },
  decimalSeparator: {
    type: String,
    validator: (e) => !e || e.length === 1
  },
  ...Pe(mi(), ["modelValue", "validationValue"])
}, "VNumberInput"), jM = K()({
  name: "VNumberInput",
  props: {
    ...zM()
  },
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = G(), {
      holdStart: r,
      holdStop: l
    } = HM({
      toggleUpDown: M
    }), i = ul(e), o = T(() => i.isDisabled.value || i.isReadonly.value), s = ae(e.focused), {
      decimalSeparator: u
    } = Ke(), c = T(() => e.decimalSeparator?.[0] || u.value);
    function d($) {
      let z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.precision, te = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
      const me = z == null ? String($) : $.toFixed(z);
      if (s.value && te)
        return Number(me).toString().replace(".", c.value);
      if (e.minFractionDigits === null || z !== null && z < e.minFractionDigits)
        return me.replace(".", c.value);
      let [Q, ie] = me.split(".");
      return ie = (ie ?? "").padEnd(e.minFractionDigits, "0").replace(new RegExp(`(?<=\\d{${e.minFractionDigits}})0+$`, "g"), ""), [Q, ie].filter(Boolean).join(c.value);
    }
    const f = he(e, "modelValue", null, ($) => $ ?? null, ($) => $ == null ? $ ?? null : Xe(Number($), e.min, e.max)), v = ae(null), g = ae(null);
    ne(f, ($) => {
      s.value && !o.value && Number(v.value?.replace(c.value, ".")) === $ || ($ == null ? (v.value = null, g.value = null) : isNaN($) || (v.value = d($), g.value = Number(v.value.replace(c.value, "."))));
    }, {
      immediate: !0
    });
    const m = T({
      get: () => v.value,
      set($) {
        if ($ === null || $ === "") {
          f.value = null, v.value = null, g.value = null;
          return;
        }
        const z = Number($.replace(c.value, "."));
        isNaN(z) || (v.value = $, g.value = z, z <= e.max && z >= e.min && (f.value = z));
      }
    }), h = T(() => {
      if (g.value === null) return !1;
      const $ = Number(v.value?.replace(c.value, "."));
      return $ !== Xe($, e.min, e.max);
    }), w = T(() => o.value ? !1 : (f.value ?? 0) + e.step <= e.max), _ = T(() => o.value ? !1 : (f.value ?? 0) - e.step >= e.min), I = T(() => e.hideInput ? "stacked" : e.controlVariant), C = D(() => I.value === "split" ? "$plus" : "$collapse"), b = D(() => I.value === "split" ? "$minus" : "$expand"), p = D(() => I.value === "split" ? "default" : "small"), x = D(() => I.value === "stacked" ? "auto" : "100%"), k = {
      props: {
        onClick: P,
        onPointerup: O,
        onPointerdown: F,
        onPointercancel: O
      }
    }, V = {
      props: {
        onClick: P,
        onPointerup: O,
        onPointerdown: B,
        onPointercancel: O
      }
    };
    ne(() => e.precision, () => W()), ne(() => e.minFractionDigits, () => W()), bt(() => {
      N();
    });
    function A($) {
      if ($ == null) return 0;
      const z = $.toString(), te = z.indexOf(".");
      return ~te ? z.length - te : 0;
    }
    function M() {
      let $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      if (o.value) return;
      if (f.value == null) {
        m.value = d(Xe(0, e.min, e.max));
        return;
      }
      let z = Math.max(A(f.value), A(e.step));
      e.precision != null && (z = Math.max(z, e.precision)), $ ? w.value && (m.value = d(f.value + e.step, z)) : _.value && (m.value = d(f.value - e.step, z));
    }
    function L($) {
      if (!$.data) return;
      const z = $.target, {
        value: te,
        selectionStart: me,
        selectionEnd: Q
      } = z ?? {}, ie = te ? te.slice(0, me) + $.data + te.slice(Q) : $.data, ke = m_(ie, e.precision, c.value);
      if (new RegExp(`^-?\\d*${lo(c.value)}?\\d*$`).test(ie) || ($.preventDefault(), z.value = ke, Se(() => m.value = ke)), e.precision != null) {
        if (ie.split(c.value)[1]?.length > e.precision) {
          $.preventDefault(), z.value = ke, Se(() => m.value = ke);
          const ye = (me ?? 0) + $.data.length;
          z.setSelectionRange(ye, ye);
        }
        e.precision === 0 && ie.endsWith(c.value) && ($.preventDefault(), z.value = ke, Se(() => m.value = ke));
      }
    }
    async function E($) {
      ["Enter", "ArrowLeft", "ArrowRight", "Backspace", "Delete", "Tab"].includes($.key) || $.ctrlKey || ["ArrowDown", "ArrowUp"].includes($.key) && ($.preventDefault(), $.stopPropagation(), N(), await Se(), $.key === "ArrowDown" ? M(!1) : M());
    }
    function P($) {
      $.stopPropagation();
    }
    function O($) {
      $.currentTarget?.releasePointerCapture($.pointerId), $.preventDefault(), l();
    }
    function F($) {
      $.currentTarget?.setPointerCapture($.pointerId), $.preventDefault(), $.stopPropagation(), r("up");
    }
    function B($) {
      $.currentTarget?.setPointerCapture($.pointerId), $.preventDefault(), $.stopPropagation(), r("down");
    }
    function N() {
      if (o.value || !a.value) return;
      const $ = a.value.value, z = Number($.replace(c.value, "."));
      $ && !isNaN(z) ? m.value = d(Xe(z, e.min, e.max)) : m.value = null;
    }
    function W() {
      o.value || (m.value = f.value !== null && !isNaN(f.value) ? d(f.value, e.precision, !1) : null);
    }
    function R() {
      if (!o.value) {
        if (f.value === null || isNaN(f.value)) {
          m.value = null;
          return;
        }
        m.value = f.value.toString().replace(".", c.value);
      }
    }
    function j() {
      R();
    }
    function H() {
      N();
    }
    return X(() => {
      const {
        modelValue: $,
        type: z,
        ...te
      } = Kn.filterProps(e);
      function me() {
        return n.increment ? y(Ae, {
          key: "increment-defaults",
          defaults: {
            VBtn: {
              disabled: !w.value,
              height: x.value,
              size: p.value,
              icon: C.value,
              variant: "text"
            }
          }
        }, {
          default: () => [n.increment(k)]
        }) : y(De, {
          "aria-hidden": "true",
          "data-testid": "increment",
          disabled: !w.value,
          height: x.value,
          icon: C.value,
          key: "increment-btn",
          onClick: P,
          onPointerdown: F,
          onPointerup: O,
          onPointercancel: O,
          size: p.value,
          variant: "text",
          tabindex: "-1"
        }, null);
      }
      function Q() {
        return n.decrement ? y(Ae, {
          key: "decrement-defaults",
          defaults: {
            VBtn: {
              disabled: !_.value,
              height: x.value,
              size: p.value,
              icon: b.value,
              variant: "text"
            }
          }
        }, {
          default: () => [n.decrement(V)]
        }) : y(De, {
          "aria-hidden": "true",
          "data-testid": "decrement",
          disabled: !_.value,
          height: x.value,
          icon: b.value,
          key: "decrement-btn",
          onClick: P,
          onPointerdown: B,
          onPointerup: O,
          onPointercancel: O,
          size: p.value,
          variant: "text",
          tabindex: "-1"
        }, null);
      }
      function ie() {
        return S("div", {
          class: "v-number-input__control"
        }, [Q(), y(pn, {
          vertical: I.value !== "stacked"
        }, null), me()]);
      }
      function ke() {
        return !e.hideInput && !e.inset ? y(pn, {
          vertical: !0
        }, null) : void 0;
      }
      const ye = I.value === "split" ? S("div", {
        class: "v-number-input__control"
      }, [y(pn, {
        vertical: !0
      }, null), me()]) : e.reverse || I.value === "hidden" ? void 0 : S(fe, null, [ke(), ie()]), ue = n["append-inner"] || ye, Te = I.value === "split" ? S("div", {
        class: "v-number-input__control"
      }, [Q(), y(pn, {
        vertical: !0
      }, null)]) : e.reverse && I.value !== "hidden" ? S(fe, null, [ie(), ke()]) : void 0, Ne = n["prepend-inner"] || Te;
      return y(Kn, Y({
        ref: a
      }, te, {
        modelValue: m.value,
        "onUpdate:modelValue": (je) => m.value = je,
        focused: s.value,
        "onUpdate:focused": (je) => s.value = je,
        validationValue: f.value,
        error: e.error || h.value || void 0,
        onBeforeinput: L,
        onFocus: j,
        onBlur: H,
        onKeydown: E,
        class: ["v-number-input", {
          "v-number-input--default": I.value === "default",
          "v-number-input--hide-input": e.hideInput,
          "v-number-input--inset": e.inset,
          "v-number-input--reverse": e.reverse,
          "v-number-input--split": I.value === "split",
          "v-number-input--stacked": I.value === "stacked"
        }, e.class],
        style: e.style,
        inputmode: "decimal"
      }), {
        ...n,
        "append-inner": ue ? function() {
          for (var je = arguments.length, xe = new Array(je), Be = 0; Be < je; Be++)
            xe[Be] = arguments[Be];
          return S(fe, null, [n["append-inner"]?.(...xe), ye]);
        } : void 0,
        "prepend-inner": Ne ? function() {
          for (var je = arguments.length, xe = new Array(je), Be = 0; Be < je; Be++)
            xe[Be] = arguments[Be];
          return S(fe, null, [Te, n["prepend-inner"]?.(...xe)]);
        } : void 0
      });
    }), Mt({}, a);
  }
}), GM = U({
  autofocus: Boolean,
  divider: String,
  focusAll: Boolean,
  label: {
    type: String,
    default: "$vuetify.input.otp"
  },
  length: {
    type: [Number, String],
    default: 6
  },
  masked: Boolean,
  modelValue: {
    type: [Number, String],
    default: void 0
  },
  placeholder: String,
  type: {
    type: String,
    default: "number"
  },
  ...mt(),
  ...St(),
  ...di(),
  ...an(vi({
    variant: "outlined"
  }), ["baseColor", "bgColor", "class", "color", "disabled", "error", "loading", "rounded", "style", "theme", "variant"])
}, "VOtpInput"), qM = K()({
  name: "VOtpInput",
  props: GM(),
  emits: {
    finish: (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: a,
      slots: r
    } = t;
    const {
      densityClasses: l
    } = zt(e), {
      dimensionStyles: i
    } = xt(e), {
      isFocused: o,
      focus: s,
      blur: u
    } = ma(e), c = he(e, "modelValue", "", (M) => M == null ? [] : String(M).split(""), (M) => M.join("")), {
      t: d
    } = Ke(), f = T(() => Number(e.length)), v = T(() => Array(f.value).fill(0)), g = G(-1), m = G(), h = G([]), w = T(() => h.value[g.value]);
    let _ = !1;
    Wt(() => e.autofocus, () => {
      const M = bo();
      M.run(() => {
        const {
          intersectionRef: L,
          isIntersecting: E
        } = li();
        ft(() => {
          L.value = h.value[0];
        }), ne(E, (P) => {
          P && (L.value?.focus(), M.stop());
        });
      });
    });
    function I() {
      if (A(w.value.value)) {
        w.value.value = "";
        return;
      }
      if (_) return;
      const M = c.value.slice(), L = w.value.value;
      M[g.value] = L;
      let E = null;
      g.value > c.value.length ? E = c.value.length + 1 : g.value + 1 !== f.value && (E = "next"), c.value = M, E && Ka(m.value, E);
    }
    function C() {
      _ = !1, I();
    }
    function b(M) {
      const L = c.value.slice(), E = g.value;
      let P = null;
      ["ArrowLeft", "ArrowRight", "Backspace", "Delete"].includes(M.key) && (M.preventDefault(), M.key === "ArrowLeft" ? P = "prev" : M.key === "ArrowRight" ? P = "next" : ["Backspace", "Delete"].includes(M.key) && (L[g.value] = "", c.value = L, g.value > 0 && M.key === "Backspace" ? P = "prev" : requestAnimationFrame(() => {
        h.value[E]?.select();
      })), requestAnimationFrame(() => {
        P != null && Ka(m.value, P);
      }));
    }
    function p(M, L) {
      L.preventDefault(), L.stopPropagation();
      const E = L?.clipboardData?.getData("Text").trim().slice(0, f.value) ?? "", P = E.length - 1 === -1 ? M : E.length - 1;
      A(E) || (c.value = E.split(""), g.value = P);
    }
    function x() {
      c.value = [];
    }
    function k(M, L) {
      s(), g.value = L;
    }
    function V() {
      u(), g.value = -1;
    }
    function A(M) {
      return e.type === "number" && /[^0-9]/g.test(M);
    }
    return vt({
      VField: {
        color: D(() => e.color),
        bgColor: D(() => e.color),
        baseColor: D(() => e.baseColor),
        disabled: D(() => e.disabled),
        error: D(() => e.error),
        variant: D(() => e.variant),
        rounded: D(() => e.rounded)
      }
    }, {
      scoped: !0
    }), ne(c, (M) => {
      M.length === f.value && a("finish", M.join(""));
    }, {
      deep: !0
    }), ne(g, (M) => {
      M < 0 || Se(() => {
        h.value[M]?.select();
      });
    }), X(() => {
      const [M, L] = Jn(n);
      return S("div", Y({
        class: ["v-otp-input", {
          "v-otp-input--divided": !!e.divider
        }, l.value, e.class],
        style: [e.style]
      }, M), [S("div", {
        ref: m,
        class: "v-otp-input__content",
        style: le([i.value])
      }, [v.value.map((E, P) => S(fe, null, [e.divider && P !== 0 && S("span", {
        class: "v-otp-input__divider"
      }, [e.divider]), y(Ea, {
        focused: o.value && e.focusAll || g.value === P,
        key: P
      }, {
        ...r,
        loader: void 0,
        default: () => S("input", {
          ref: (O) => h.value[P] = O,
          "aria-label": d(e.label, P + 1),
          autofocus: P === 0 && e.autofocus,
          autocomplete: "one-time-code",
          class: J(["v-otp-input__field"]),
          disabled: e.disabled,
          inputmode: e.type === "number" ? "numeric" : "text",
          min: e.type === "number" ? 0 : void 0,
          maxlength: P === 0 ? f.value : "1",
          placeholder: e.placeholder,
          type: e.masked ? "password" : e.type === "number" ? "text" : e.type,
          value: c.value[P],
          onInput: I,
          onFocus: (O) => k(O, P),
          onBlur: V,
          onKeydown: b,
          onCompositionstart: () => _ = !0,
          onCompositionend: C,
          onPaste: (O) => p(P, O)
        }, null)
      })])), S("input", Y({
        class: "v-otp-input-input",
        type: "hidden"
      }, L, {
        value: c.value.join("")
      }), null), y(Yn, {
        contained: !0,
        contentClass: "v-otp-input__loader",
        modelValue: !!e.loading,
        persistent: !0
      }, {
        default: () => [r.loader?.() ?? y(Aa, {
          color: typeof e.loading == "boolean" ? void 0 : e.loading,
          indeterminate: !0,
          size: "24",
          width: "2"
        }, null)]
      }), r.default?.()])]);
    }), {
      blur: () => {
        h.value?.some((M) => M.blur());
      },
      focus: () => {
        h.value?.[0].focus();
      },
      reset: x,
      isFocused: o
    };
  }
});
function YM(e) {
  return Math.floor(Math.abs(e)) * Math.sign(e);
}
const KM = U({
  scale: {
    type: [Number, String],
    default: 0.5
  },
  ...ve()
}, "VParallax"), ZM = K()({
  name: "VParallax",
  props: KM(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      intersectionRef: a,
      isIntersecting: r
    } = li(), {
      resizeRef: l,
      contentRect: i
    } = Vn(), {
      height: o
    } = Cn(), s = G();
    ft(() => {
      a.value = l.value = s.value?.$el;
    });
    let u;
    ne(r, (v) => {
      v ? (u = No(a.value), u = u === document.scrollingElement ? document : u, u.addEventListener("scroll", f, {
        passive: !0
      }), f()) : u.removeEventListener("scroll", f);
    }), Ft(() => {
      u?.removeEventListener("scroll", f);
    }), ne(o, f), ne(() => i.value?.height, f);
    const c = T(() => 1 - Xe(Number(e.scale)));
    let d = -1;
    function f() {
      !r.value || Gn() || (cancelAnimationFrame(d), d = requestAnimationFrame(() => {
        const v = (s.value?.$el).querySelector(".v-img__img");
        if (!v) return;
        const g = u instanceof Document ? document.documentElement.clientHeight : u.clientHeight, m = u instanceof Document ? window.scrollY : u.scrollTop, h = a.value.getBoundingClientRect().top + m, w = i.value.height, _ = h + (w - g) / 2, I = YM((m - _) * c.value), C = Math.max(1, (c.value * (g - w) + w) / w);
        v.style.setProperty("transform", `translateY(${I}px) scale(${C})`);
      }));
    }
    return X(() => y(sa, {
      class: J(["v-parallax", {
        "v-parallax--active": r.value
      }, e.class]),
      style: le(e.style),
      ref: s,
      cover: !0,
      onLoadstart: f,
      onLoad: f
    }, n)), {};
  }
}), JM = U({
  ...zo({
    falseIcon: "$radioOff",
    trueIcon: "$radioOn"
  })
}, "VRadio"), XM = K()({
  name: "VRadio",
  props: JM(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => {
      const a = Pa.filterProps(e);
      return y(Pa, Y(a, {
        class: ["v-radio", e.class],
        style: e.style,
        type: "radio"
      }), n);
    }), {};
  }
}), QM = U({
  height: {
    type: [Number, String],
    default: "auto"
  },
  ...Pe(ha(), ["direction"]),
  ...Pe(Fc(), ["multiple"]),
  trueIcon: {
    type: be,
    default: "$radioOn"
  },
  falseIcon: {
    type: be,
    default: "$radioOff"
  },
  type: {
    type: String,
    default: "radio"
  }
}, "VRadioGroup"), eO = K()({
  name: "VRadioGroup",
  inheritAttrs: !1,
  props: QM(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const r = Rt(), l = T(() => e.id || `radio-group-${r}`), i = he(e, "modelValue"), o = G();
    return X(() => {
      const [s, u] = Jn(n), c = Gt.filterProps(e), d = Pa.filterProps(e), f = a.label ? a.label({
        label: e.label,
        props: {
          for: l.value
        }
      }) : e.label;
      return y(Gt, Y({
        ref: o,
        class: ["v-radio-group", e.class],
        style: e.style
      }, s, c, {
        modelValue: i.value,
        "onUpdate:modelValue": (v) => i.value = v,
        id: l.value
      }), {
        ...a,
        default: (v) => {
          let {
            id: g,
            messagesId: m,
            isDisabled: h,
            isReadonly: w
          } = v;
          return S(fe, null, [f && y(sl, {
            id: g.value
          }, {
            default: () => [f]
          }), y(Wg, Y(d, {
            id: g.value,
            "aria-describedby": m.value,
            defaultsTarget: "VRadio",
            trueIcon: e.trueIcon,
            falseIcon: e.falseIcon,
            type: e.type,
            disabled: h.value,
            readonly: w.value,
            "aria-labelledby": f ? g.value : void 0,
            multiple: !1
          }, u, {
            modelValue: i.value,
            "onUpdate:modelValue": (_) => i.value = _
          }), a)]);
        }
      });
    }), Mt({}, o);
  }
}), tO = U({
  ...di(),
  ...ha(),
  ...db(),
  strict: Boolean,
  modelValue: {
    type: Array,
    default: () => [0, 0]
  }
}, "VRangeSlider"), nO = K()({
  name: "VRangeSlider",
  inheritAttrs: !1,
  props: tO(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    end: (e) => !0,
    start: (e) => !0
  },
  setup(e, t) {
    let {
      slots: n,
      emit: a,
      attrs: r
    } = t;
    const l = G(), i = G(), o = G(), {
      rtlClasses: s
    } = At();
    function u(L) {
      if (!l.value || !i.value) return;
      const E = Vu(L, l.value.$el, e.direction), P = Vu(L, i.value.$el, e.direction), O = Math.abs(E), F = Math.abs(P);
      return O < F || O === F && E < 0 ? l.value.$el : i.value.$el;
    }
    const c = fb(e), d = he(e, "modelValue", void 0, (L) => L?.length ? L.map((E) => c.roundValue(E)) : [0, 0]), {
      activeThumbRef: f,
      hasLabels: v,
      max: g,
      min: m,
      mousePressed: h,
      onSliderMousedown: w,
      onSliderTouchstart: _,
      position: I,
      trackContainerRef: C,
      disabled: b,
      readonly: p
    } = vb({
      props: e,
      steps: c,
      onSliderStart: () => {
        if (b.value || p.value) {
          f.value?.blur();
          return;
        }
        a("start", d.value);
      },
      onSliderEnd: (L) => {
        let {
          value: E
        } = L;
        if (b.value || p.value)
          f.value?.blur();
        else {
          const P = f.value === l.value?.$el ? [E, d.value[1]] : [d.value[0], E];
          !e.strict && P[0] < P[1] && (d.value = P);
        }
        a("end", d.value);
      },
      onSliderMove: (L) => {
        let {
          value: E
        } = L;
        const [P, O] = d.value;
        if (b.value || p.value) {
          f.value?.blur();
          return;
        }
        !e.strict && P === O && P !== m.value && (f.value = E > P ? i.value?.$el : l.value?.$el, f.value?.focus()), f.value === l.value?.$el ? d.value = [Math.min(E, O), O] : d.value = [P, Math.max(P, E)];
      },
      getActiveThumb: u
    }), {
      isFocused: x,
      focus: k,
      blur: V
    } = ma(e), A = T(() => I(d.value[0])), M = T(() => I(d.value[1]));
    return X(() => {
      const L = Gt.filterProps(e), [E, P] = Jn(r), O = !!(e.label || n.label || n.prepend);
      return y(Gt, Y({
        class: ["v-slider", "v-range-slider", {
          "v-slider--has-labels": !!n["tick-label"] || v.value,
          "v-slider--focused": x.value,
          "v-slider--pressed": h.value,
          "v-slider--disabled": b.value
        }, s.value, e.class],
        style: e.style,
        ref: o
      }, L, E, {
        focused: x.value
      }), {
        ...n,
        prepend: O ? (F) => S(fe, null, [n.label?.(F) ?? (e.label ? y(sl, {
          class: "v-slider__label",
          text: e.label
        }, null) : void 0), n.prepend?.(F)]) : void 0,
        default: (F) => {
          let {
            id: B,
            messagesId: N
          } = F;
          return S("div", {
            class: "v-slider__container",
            onMousedown: p.value ? void 0 : w,
            onTouchstartPassive: p.value ? void 0 : _
          }, [S("input", {
            id: `${B.value}_start`,
            name: e.name || B.value,
            disabled: b.value,
            readonly: p.value,
            tabindex: "-1",
            value: d.value[0]
          }, null), S("input", {
            id: `${B.value}_stop`,
            name: e.name || B.value,
            disabled: b.value,
            readonly: p.value,
            tabindex: "-1",
            value: d.value[1]
          }, null), y(mb, {
            ref: C,
            start: A.value,
            stop: M.value
          }, {
            "tick-label": n["tick-label"]
          }), y(Eu, Y({
            ref: l,
            "aria-describedby": N.value,
            focused: x && f.value === l.value?.$el,
            modelValue: d.value[0],
            "onUpdate:modelValue": (W) => d.value = [W, d.value[1]],
            onFocus: (W) => {
              k(), f.value = l.value?.$el, g.value !== m.value && d.value[0] === d.value[1] && d.value[1] === m.value && W.relatedTarget !== i.value?.$el && (l.value?.$el.blur(), i.value?.$el.focus());
            },
            onBlur: () => {
              V(), f.value = void 0;
            },
            min: m.value,
            max: d.value[1],
            position: A.value,
            ripple: e.ripple
          }, P), {
            "thumb-label": n["thumb-label"]
          }), y(Eu, Y({
            ref: i,
            "aria-describedby": N.value,
            focused: x && f.value === i.value?.$el,
            modelValue: d.value[1],
            "onUpdate:modelValue": (W) => d.value = [d.value[0], W],
            onFocus: (W) => {
              k(), f.value = i.value?.$el, g.value !== m.value && d.value[0] === d.value[1] && d.value[0] === g.value && W.relatedTarget !== l.value?.$el && (i.value?.$el.blur(), l.value?.$el.focus());
            },
            onBlur: () => {
              V(), f.value = void 0;
            },
            min: d.value[0],
            max: g.value,
            position: M.value,
            ripple: e.ripple
          }, P), {
            "thumb-label": n["thumb-label"]
          })]);
        }
      });
    }), Mt({
      focus: () => l.value?.$el.focus()
    }, o);
  }
}), aO = U({
  name: String,
  itemAriaLabel: {
    type: String,
    default: "$vuetify.rating.ariaLabel.item"
  },
  activeColor: String,
  color: String,
  clearable: Boolean,
  disabled: Boolean,
  emptyIcon: {
    type: be,
    default: "$ratingEmpty"
  },
  fullIcon: {
    type: be,
    default: "$ratingFull"
  },
  halfIncrements: Boolean,
  hover: Boolean,
  length: {
    type: [Number, String],
    default: 5
  },
  readonly: Boolean,
  modelValue: {
    type: [Number, String],
    default: 0
  },
  itemLabels: Array,
  itemLabelPosition: {
    type: String,
    default: "top",
    validator: (e) => ["top", "bottom"].includes(e)
  },
  ripple: Boolean,
  ...ve(),
  ...mt(),
  ...ea(),
  ...Ie(),
  ...Re()
}, "VRating"), rO = K()({
  name: "VRating",
  props: aO(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      t: a
    } = Ke(), {
      themeClasses: r
    } = Ge(e), l = G(), i = he(e, "modelValue"), o = T(() => Xe(parseFloat(i.value), 0, Number(e.length))), s = T(() => ka(Number(e.length), 1)), u = T(() => s.value.flatMap((C) => e.halfIncrements ? [C - 0.5, C] : [C])), c = ae(-1), d = T(() => u.value.map((C) => {
      const b = e.hover && c.value > -1, p = o.value >= C, x = c.value >= C, V = (b ? x : p) ? e.fullIcon : e.emptyIcon, A = e.activeColor ?? e.color, M = p || x ? A : e.color;
      return {
        isFilled: p,
        isHovered: x,
        icon: V,
        color: M
      };
    })), f = T(() => [0, ...u.value].map((C) => {
      function b() {
        c.value = C;
      }
      function p() {
        c.value = -1;
      }
      function x() {
        e.disabled || e.readonly || (i.value = o.value === C && e.clearable ? 0 : C);
      }
      return {
        onMouseenter: e.hover ? b : void 0,
        onMouseleave: e.hover ? p : void 0,
        onClick: x
      };
    })), v = T(() => e.halfIncrements ? 1 + Math.floor(Math.max(0, Number(i.value ?? 0) - 0.5)) * 2 : Math.floor(Math.max(0, Number(i.value ?? 0) - 1)));
    function g() {
      l.value?.querySelector('[tabindex="0"]')?.focus();
    }
    function m(C) {
      if (e.disabled || e.readonly || C.ctrlKey || C.altKey) return;
      const b = e.halfIncrements ? 0.5 : 1;
      if (C.key === "ArrowRight") {
        const p = Math.min(Number(e.length), Number(i.value ?? 0) + b);
        i.value = p, Se(() => g());
      }
      if (C.key === "ArrowLeft") {
        const p = Math.max(0, Number(i.value ?? 0) - b);
        i.value = p, Se(() => g());
      }
    }
    const h = Rt(), w = T(() => e.name ?? `v-rating-${h}`);
    function _(C) {
      let {
        value: b,
        index: p,
        showStar: x = !0
      } = C;
      const {
        onMouseenter: k,
        onMouseleave: V,
        onClick: A
      } = f.value[p + 1], M = `${w.value}-${String(b).replace(".", "-")}`, L = p === v.value, E = {
        color: d.value[p]?.color,
        density: e.density,
        disabled: e.disabled,
        icon: d.value[p]?.icon,
        ripple: e.ripple,
        size: e.size,
        variant: "plain",
        tabindex: L ? 0 : -1,
        onKeydown: m
      };
      return S(fe, null, [S("label", {
        for: M,
        class: J({
          "v-rating__item--half": e.halfIncrements && b % 1 > 0,
          "v-rating__item--full": e.halfIncrements && b % 1 === 0
        }),
        onMouseenter: k,
        onMouseleave: V,
        onClick: A
      }, [S("span", {
        class: "v-rating__hidden"
      }, [a(e.itemAriaLabel, b, e.length)]), x ? n.item ? n.item({
        ...d.value[p],
        props: E,
        value: b,
        index: p,
        rating: o.value
      }) : y(De, Y({
        "aria-label": a(e.itemAriaLabel, b, e.length)
      }, E), null) : void 0]), S("input", {
        class: "v-rating__hidden",
        name: w.value,
        id: M,
        type: "radio",
        value: b,
        checked: o.value === b,
        tabindex: -1,
        readonly: e.readonly,
        disabled: e.disabled
      }, null)]);
    }
    function I(C) {
      return n["item-label"] ? n["item-label"](C) : C.label ? S("span", null, [C.label]) : S("span", null, [we(" ")]);
    }
    return X(() => {
      const C = !!e.itemLabels?.length || n["item-label"];
      return y(e.tag, {
        class: J(["v-rating", {
          "v-rating--hover": e.hover,
          "v-rating--readonly": e.readonly
        }, r.value, e.class]),
        style: le(e.style),
        ref: l
      }, {
        default: () => [y(_, {
          value: 0,
          index: -1,
          showStar: !1
        }, null), s.value.map((b, p) => S("div", {
          class: "v-rating__wrapper"
        }, [C && e.itemLabelPosition === "top" ? I({
          value: b,
          index: p,
          label: e.itemLabels?.[p]
        }) : void 0, S("div", {
          class: "v-rating__item"
        }, [e.halfIncrements ? S(fe, null, [y(_, {
          value: b - 0.5,
          index: p * 2
        }, null), y(_, {
          value: b,
          index: p * 2 + 1
        }, null)]) : y(_, {
          value: b,
          index: p
        }, null)]), C && e.itemLabelPosition === "bottom" ? I({
          value: b,
          index: p,
          label: e.itemLabels?.[p]
        }) : void 0]))]
      });
    }), {};
  }
}), lO = {
  actions: "button@2",
  article: "heading, paragraph",
  avatar: "avatar",
  button: "button",
  card: "image, heading",
  "card-avatar": "image, list-item-avatar",
  chip: "chip",
  "date-picker": "list-item, heading, divider, date-picker-options, date-picker-days, actions",
  "date-picker-options": "text, avatar@2",
  "date-picker-days": "avatar@28",
  divider: "divider",
  heading: "heading",
  image: "image",
  "list-item": "text",
  "list-item-avatar": "avatar, text",
  "list-item-two-line": "sentences",
  "list-item-avatar-two-line": "avatar, sentences",
  "list-item-three-line": "paragraph",
  "list-item-avatar-three-line": "avatar, paragraph",
  ossein: "ossein",
  paragraph: "text@3",
  sentences: "text@2",
  subtitle: "text",
  table: "table-heading, table-thead, table-tbody, table-tfoot",
  "table-heading": "chip, text",
  "table-thead": "heading@6",
  "table-tbody": "table-row-divider@6",
  "table-row-divider": "table-row, divider",
  "table-row": "text@6",
  "table-tfoot": "text@2, avatar@2",
  text: "text"
};
function iO(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return S("div", {
    class: J(["v-skeleton-loader__bone", `v-skeleton-loader__${e}`])
  }, [t]);
}
function Jv(e) {
  const [t, n] = e.split("@");
  return Array.from({
    length: n
  }).map(() => us(t));
}
function us(e) {
  let t = [];
  if (!e) return t;
  const n = lO[e];
  if (e !== n) {
    if (e.includes(",")) return Xv(e);
    if (e.includes("@")) return Jv(e);
    n.includes(",") ? t = Xv(n) : n.includes("@") ? t = Jv(n) : n && t.push(us(n));
  }
  return [iO(e, t)];
}
function Xv(e) {
  return e.replace(/\s/g, "").split(",").map(us);
}
const oO = U({
  boilerplate: Boolean,
  color: String,
  loading: Boolean,
  loadingText: {
    type: String,
    default: "$vuetify.loading"
  },
  type: {
    type: [String, Array],
    default: "ossein"
  },
  ...St(),
  ...Ct(),
  ...Re()
}, "VSkeletonLoader"), sO = K()({
  name: "VSkeletonLoader",
  inheritAttrs: !1,
  props: oO(),
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const {
      backgroundColorClasses: r,
      backgroundColorStyles: l
    } = qe(() => e.color), {
      dimensionStyles: i
    } = xt(e), {
      elevationClasses: o
    } = Et(e), {
      themeClasses: s
    } = Ge(e), {
      t: u
    } = Ke(), c = T(() => us(rt(e.type).join(",")));
    return X(() => {
      const d = !a.default || e.loading, f = e.boilerplate || !d ? {} : {
        ariaLive: "polite",
        ariaLabel: u(e.loadingText),
        role: "alert"
      };
      return d ? S("div", Y({
        class: ["v-skeleton-loader", {
          "v-skeleton-loader--boilerplate": e.boilerplate
        }, s.value, r.value, o.value],
        style: [l.value, i.value]
      }, f, n), [c.value]) : S(fe, null, [a.default?.()]);
    }), {};
  }
}), uO = K()({
  name: "VSlideGroupItem",
  props: mr(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = Ia(e, $c);
    return () => n.default?.({
      isSelected: a.isSelected.value,
      select: a.select,
      toggle: a.toggle,
      selectedClass: a.selectedClass.value
    });
  }
});
function cO(e) {
  const t = ae(e());
  let n = -1;
  function a() {
    clearInterval(n);
  }
  function r() {
    a(), Se(() => t.value = e());
  }
  function l(i) {
    const o = i ? getComputedStyle(i) : {
      transitionDuration: 0.2
    }, s = parseFloat(o.transitionDuration) * 1e3 || 200;
    if (a(), t.value <= 0) return;
    const u = performance.now();
    n = window.setInterval(() => {
      const c = performance.now() - u + s;
      t.value = Math.max(e() - c, 0), t.value <= 0 && a();
    }, s);
  }
  return It(a), {
    clear: a,
    time: t,
    start: l,
    reset: r
  };
}
const dp = U({
  /* @deprecated */
  multiLine: Boolean,
  text: String,
  timer: [Boolean, String],
  timeout: {
    type: [Number, String],
    default: 5e3
  },
  vertical: Boolean,
  ...Qn({
    location: "bottom"
  }),
  ...il(),
  ...lt(),
  ...xn(),
  ...Re(),
  ...Pe(fi({
    transition: "v-snackbar-transition"
  }), ["persistent", "noClickAnimation", "retainFocus", "captureFocus", "disableInitialFocus", "scrim", "scrollStrategy", "stickToTarget", "viewportMargin"])
}, "VSnackbar"), zu = K()({
  name: "VSnackbar",
  props: dp(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = he(e, "modelValue"), {
      positionClasses: r
    } = ol(e), {
      scopeId: l
    } = gr(), {
      themeClasses: i
    } = Ge(e), {
      colorClasses: o,
      colorStyles: s,
      variantClasses: u
    } = va(e), {
      roundedClasses: c
    } = ut(e), d = cO(() => Number(e.timeout)), f = G(), v = G(), g = ae(!1), m = ae(0), h = G(), w = Le(Ll, void 0);
    Wt(() => !!w, () => {
      const M = bg();
      ft(() => {
        h.value = M.mainStyles.value;
      });
    }), ne(a, I), ne(() => e.timeout, I), bt(() => {
      a.value && I();
    });
    let _ = -1;
    function I() {
      d.reset(), window.clearTimeout(_);
      const M = Number(e.timeout);
      if (!a.value || M === -1) return;
      const L = Sc(v.value);
      d.start(L), _ = window.setTimeout(() => {
        a.value = !1;
      }, M);
    }
    function C() {
      d.reset(), window.clearTimeout(_);
    }
    function b() {
      g.value = !0, C();
    }
    function p() {
      g.value = !1, I();
    }
    function x(M) {
      m.value = M.touches[0].clientY;
    }
    function k(M) {
      Math.abs(m.value - M.changedTouches[0].clientY) > 50 && (a.value = !1);
    }
    function V() {
      g.value && p();
    }
    const A = T(() => e.location.split(" ").reduce((M, L) => (M[`v-snackbar--${L}`] = !0, M), {}));
    return X(() => {
      const M = Yn.filterProps(e), L = !!(n.default || n.text || e.text);
      return y(Yn, Y({
        ref: f,
        class: ["v-snackbar", {
          "v-snackbar--active": a.value,
          "v-snackbar--multi-line": e.multiLine && !e.vertical,
          "v-snackbar--timer": !!e.timer,
          "v-snackbar--vertical": e.vertical
        }, A.value, r.value, e.class],
        style: [h.value, e.style]
      }, M, {
        modelValue: a.value,
        "onUpdate:modelValue": (E) => a.value = E,
        contentProps: Y({
          class: ["v-snackbar__wrapper", i.value, o.value, c.value, u.value],
          style: [s.value],
          onPointerenter: b,
          onPointerleave: p
        }, M.contentProps),
        persistent: !0,
        noClickAnimation: !0,
        scrim: !1,
        scrollStrategy: "none",
        _disableGlobalStack: !0,
        onTouchstartPassive: x,
        onTouchend: k,
        onAfterLeave: V
      }, l), {
        default: () => [fa(!1, "v-snackbar"), e.timer && !g.value && S("div", {
          key: "timer",
          class: "v-snackbar__timer"
        }, [y(Uo, {
          ref: v,
          color: typeof e.timer == "string" ? e.timer : "info",
          max: e.timeout,
          modelValue: d.time.value
        }, null)]), L && S("div", {
          key: "content",
          class: "v-snackbar__content",
          role: "status",
          "aria-live": "polite"
        }, [n.text?.() ?? e.text, n.default?.()]), n.actions && y(Ae, {
          defaults: {
            VBtn: {
              variant: "text",
              ripple: !1,
              slim: !0
            }
          }
        }, {
          default: () => [S("div", {
            class: "v-snackbar__actions"
          }, [n.actions({
            isActive: a
          })])]
        })],
        activator: n.activator
      });
    }), Mt({}, f);
  }
}), dO = U({
  // TODO: Port this to Snackbar on dev
  closable: [Boolean, String],
  closeText: {
    type: String,
    default: "$vuetify.dismiss"
  },
  modelValue: {
    type: Array,
    default: () => []
  },
  ...Pe(dp(), ["modelValue"])
}, "VSnackbarQueue"), fO = K()({
  name: "VSnackbarQueue",
  props: dO(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const {
      t: r
    } = Ke(), l = ae(!1), i = ae(!1), o = ae();
    ne(() => e.modelValue.length, (f, v) => {
      !i.value && f > v && u();
    }), ne(l, (f) => {
      f && (i.value = !0);
    });
    function s() {
      e.modelValue.length ? u() : (o.value = void 0, i.value = !1);
    }
    function u() {
      const [f, ...v] = e.modelValue;
      n("update:modelValue", v), o.value = typeof f == "string" ? {
        text: f
      } : f, Se(() => {
        l.value = !0;
      });
    }
    function c() {
      l.value = !1;
    }
    const d = T(() => ({
      color: typeof e.closable == "string" ? e.closable : void 0,
      text: r(e.closeText)
    }));
    X(() => {
      const f = !!(e.closable || a.actions), {
        modelValue: v,
        ...g
      } = zu.filterProps(e);
      return S(fe, null, [i.value && !!o.value && (a.default ? y(Ae, {
        defaults: {
          VSnackbar: o.value
        }
      }, {
        default: () => [a.default({
          item: o.value
        })]
      }) : y(zu, Y(g, o.value, {
        modelValue: l.value,
        "onUpdate:modelValue": (m) => l.value = m,
        onAfterLeave: s
      }), {
        text: a.text ? () => a.text?.({
          item: o.value
        }) : void 0,
        actions: f ? () => S(fe, null, [a.actions ? y(Ae, {
          defaults: {
            VBtn: d.value
          }
        }, {
          default: () => [a.actions({
            item: o.value,
            props: {
              onClick: c
            }
          })]
        }) : y(De, Y(d.value, {
          onClick: c
        }), null)]) : void 0
      }))]);
    });
  }
}), fp = U({
  autoDraw: Boolean,
  autoDrawDuration: [Number, String],
  autoDrawEasing: {
    type: String,
    default: "ease"
  },
  color: String,
  gradient: {
    type: Array,
    default: () => []
  },
  gradientDirection: {
    type: String,
    validator: (e) => ["top", "bottom", "left", "right"].includes(e),
    default: "top"
  },
  height: {
    type: [String, Number],
    default: 75
  },
  labels: {
    type: Array,
    default: () => []
  },
  labelSize: {
    type: [Number, String],
    default: 7
  },
  lineWidth: {
    type: [String, Number],
    default: 4
  },
  id: String,
  itemValue: {
    type: String,
    default: "value"
  },
  modelValue: {
    type: Array,
    default: () => []
  },
  min: [String, Number],
  max: [String, Number],
  padding: {
    type: [String, Number],
    default: 8
  },
  showLabels: Boolean,
  smooth: [Boolean, String, Number],
  width: {
    type: [Number, String],
    default: 300
  }
}, "Line"), vp = U({
  autoLineWidth: Boolean,
  ...fp()
}, "VBarline"), Qv = K()({
  name: "VBarline",
  props: vp(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = Rt(), r = T(() => e.id || `barline-${a}`), l = T(() => Number(e.autoDrawDuration) || 500), i = T(() => !!(e.showLabels || e.labels.length > 0 || n?.label)), o = T(() => parseFloat(e.lineWidth) || 4), s = T(() => Math.max(e.modelValue.length * o.value, Number(e.width))), u = T(() => ({
      minX: 0,
      maxX: s.value,
      minY: 0,
      maxY: parseInt(e.height, 10)
    })), c = T(() => e.modelValue.map((h) => pt(h, e.itemValue, h)));
    function d(h, w) {
      const {
        minX: _,
        maxX: I,
        minY: C,
        maxY: b
      } = w, p = h.length;
      let x = e.max != null ? Number(e.max) : Math.max(...h), k = e.min != null ? Number(e.min) : Math.min(...h);
      k > 0 && e.min == null && (k = 0), x < 0 && e.max == null && (x = 0);
      const V = I / (p === 1 ? 2 : p), A = (b - C) / (x - k || 1), M = b - Math.abs(k * A);
      return h.map((L, E) => {
        const P = Math.abs(A * L);
        return {
          x: _ + E * V,
          y: M - P + +(L < 0) * P,
          height: P,
          value: L
        };
      });
    }
    const f = T(() => {
      const h = [], w = d(c.value, u.value), _ = w.length;
      for (let I = 0; h.length < _; I++) {
        const C = w[I];
        let b = e.labels[I];
        b || (b = typeof C == "object" ? C.value : C), h.push({
          x: C.x,
          value: String(b)
        });
      }
      return h;
    }), v = T(() => d(c.value, u.value)), g = T(() => v.value.length === 1 ? (u.value.maxX - o.value) / 2 : (Math.abs(v.value[0].x - v.value[1].x) - o.value) / 2), m = T(() => typeof e.smooth == "boolean" ? e.smooth ? 2 : 0 : Number(e.smooth));
    X(() => {
      const h = e.gradient.slice().length ? e.gradient.slice().reverse() : [""];
      return S("svg", {
        display: "block"
      }, [S("defs", null, [S("linearGradient", {
        id: r.value,
        gradientUnits: "userSpaceOnUse",
        x1: e.gradientDirection === "left" ? "100%" : "0",
        y1: e.gradientDirection === "top" ? "100%" : "0",
        x2: e.gradientDirection === "right" ? "100%" : "0",
        y2: e.gradientDirection === "bottom" ? "100%" : "0"
      }, [h.map((w, _) => S("stop", {
        offset: _ / Math.max(h.length - 1, 1),
        "stop-color": w || "currentColor"
      }, null))])]), S("clipPath", {
        id: `${r.value}-clip`
      }, [v.value.map((w) => S("rect", {
        x: w.x + g.value,
        y: w.y,
        width: o.value,
        height: w.height,
        rx: m.value,
        ry: m.value
      }, [e.autoDraw && !Gn() && S(fe, null, [S("animate", {
        attributeName: "y",
        from: w.y + w.height,
        to: w.y,
        dur: `${l.value}ms`,
        fill: "freeze"
      }, null), S("animate", {
        attributeName: "height",
        from: "0",
        to: w.height,
        dur: `${l.value}ms`,
        fill: "freeze"
      }, null)])]))]), i.value && S("g", {
        key: "labels",
        style: {
          textAnchor: "middle",
          dominantBaseline: "mathematical",
          fill: "currentColor"
        }
      }, [f.value.map((w, _) => S("text", {
        x: w.x + g.value + o.value / 2,
        y: parseInt(e.height, 10) - 2 + (parseInt(e.labelSize, 10) || 7 * 0.75),
        "font-size": Number(e.labelSize) || 7
      }, [n.label?.({
        index: _,
        value: w.value
      }) ?? w.value]))]), S("g", {
        "clip-path": `url(#${r.value}-clip)`,
        fill: `url(#${r.value})`
      }, [S("rect", {
        x: 0,
        y: 0,
        width: Math.max(e.modelValue.length * o.value, Number(e.width)),
        height: e.height
      }, null)])]);
    });
  }
});
function vO(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 75;
  if (e.length === 0) return "";
  const r = e.shift(), l = e[e.length - 1];
  return (n ? `M${r.x} ${a - r.x + 2} L${r.x} ${r.y}` : `M${r.x} ${r.y}`) + e.map((i, o) => {
    const s = e[o + 1], u = e[o - 1] || r, c = s && mO(s, i, u);
    if (!s || c)
      return `L${i.x} ${i.y}`;
    const d = Math.min(em(u, i), em(s, i)), v = d / 2 < t ? d / 2 : t, g = tm(u, i, v), m = tm(s, i, v);
    return `L${g.x} ${g.y}S${i.x} ${i.y} ${m.x} ${m.y}`;
  }).join("") + (n ? `L${l.x} ${a - r.x + 2} Z` : "");
}
function Fi(e) {
  return parseInt(e, 10);
}
function mO(e, t, n) {
  return Fi(e.x + n.x) === Fi(2 * t.x) && Fi(e.y + n.y) === Fi(2 * t.y);
}
function em(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function tm(e, t, n) {
  const a = {
    x: e.x - t.x,
    y: e.y - t.y
  }, r = Math.sqrt(a.x * a.x + a.y * a.y), l = {
    x: a.x / r,
    y: a.y / r
  };
  return {
    x: t.x + l.x * n,
    y: t.y + l.y * n
  };
}
const mp = U({
  fill: Boolean,
  ...fp()
}, "VTrendline"), nm = K()({
  name: "VTrendline",
  props: mp(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = Rt(), r = T(() => e.id || `trendline-${a}`), l = T(() => Number(e.autoDrawDuration) || (e.fill ? 500 : 2e3)), i = G(0), o = G(null);
    function s(h, w) {
      const {
        minX: _,
        maxX: I,
        minY: C,
        maxY: b
      } = w;
      h.length === 1 && (h = [h[0], h[0]]);
      const p = h.length, x = e.max != null ? Number(e.max) : Math.max(...h), k = e.min != null ? Number(e.min) : Math.min(...h), V = (I - _) / (p - 1), A = (b - C) / (x - k || 1);
      return h.map((M, L) => ({
        x: _ + L * V,
        y: b - (M - k) * A,
        value: M
      }));
    }
    const u = T(() => !!(e.showLabels || e.labels.length > 0 || n?.label)), c = T(() => parseFloat(e.lineWidth) || 4), d = T(() => Number(e.width)), f = T(() => {
      const h = Number(e.padding);
      return {
        minX: h,
        maxX: d.value - h,
        minY: h,
        maxY: parseInt(e.height, 10) - h
      };
    }), v = T(() => e.modelValue.map((h) => pt(h, e.itemValue, h))), g = T(() => {
      const h = [], w = s(v.value, f.value), _ = w.length;
      for (let I = 0; h.length < _; I++) {
        const C = w[I];
        let b = e.labels[I];
        b || (b = typeof C == "object" ? C.value : C), h.push({
          x: C.x,
          value: String(b)
        });
      }
      return h;
    });
    ne(() => e.modelValue, async () => {
      if (await Se(), !e.autoDraw || !o.value || Gn()) return;
      const h = o.value, w = h.getTotalLength();
      e.fill ? (h.style.transformOrigin = "bottom center", h.style.transition = "none", h.style.transform = "scaleY(0)", h.getBoundingClientRect(), h.style.transition = `transform ${l.value}ms ${e.autoDrawEasing}`, h.style.transform = "scaleY(1)") : (h.style.strokeDasharray = `${w}`, h.style.strokeDashoffset = `${w}`, h.getBoundingClientRect(), h.style.transition = `stroke-dashoffset ${l.value}ms ${e.autoDrawEasing}`, h.style.strokeDashoffset = "0"), i.value = w;
    }, {
      immediate: !0
    });
    function m(h) {
      const w = typeof e.smooth == "boolean" ? e.smooth ? 8 : 0 : Number(e.smooth);
      return vO(s(v.value, f.value), w, h, parseInt(e.height, 10));
    }
    X(() => {
      const h = e.gradient.slice().length ? e.gradient.slice().reverse() : [""];
      return S("svg", {
        display: "block",
        "stroke-width": parseFloat(e.lineWidth) ?? 4
      }, [S("defs", null, [S("linearGradient", {
        id: r.value,
        gradientUnits: "userSpaceOnUse",
        x1: e.gradientDirection === "left" ? "100%" : "0",
        y1: e.gradientDirection === "top" ? "100%" : "0",
        x2: e.gradientDirection === "right" ? "100%" : "0",
        y2: e.gradientDirection === "bottom" ? "100%" : "0"
      }, [h.map((w, _) => S("stop", {
        offset: _ / Math.max(h.length - 1, 1),
        "stop-color": w || "currentColor"
      }, null))])]), u.value && S("g", {
        key: "labels",
        style: {
          textAnchor: "middle",
          dominantBaseline: "mathematical",
          fill: "currentColor"
        }
      }, [g.value.map((w, _) => S("text", {
        x: w.x + c.value / 2 + c.value / 2,
        y: parseInt(e.height, 10) - 4 + (parseInt(e.labelSize, 10) || 7 * 0.75),
        "font-size": Number(e.labelSize) || 7
      }, [n.label?.({
        index: _,
        value: w.value
      }) ?? w.value]))]), S("path", {
        ref: o,
        d: m(e.fill),
        fill: e.fill ? `url(#${r.value})` : "none",
        stroke: e.fill ? "none" : `url(#${r.value})`
      }, null), e.fill && S("path", {
        d: m(!1),
        fill: "none",
        stroke: e.color ?? e.gradient?.[0]
      }, null)]);
    });
  }
}), hO = U({
  type: {
    type: String,
    default: "trend"
  },
  ...vp(),
  ...mp()
}, "VSparkline"), gO = K()({
  name: "VSparkline",
  props: hO(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      textColorClasses: a,
      textColorStyles: r
    } = Nt(() => e.color), l = T(() => !!(e.showLabels || e.labels.length > 0 || n?.label)), i = T(() => {
      let o = parseInt(e.height, 10);
      return l.value && (o += parseInt(e.labelSize, 10) * 1.5), o;
    });
    X(() => {
      const o = e.type === "trend" ? nm : Qv, s = e.type === "trend" ? nm.filterProps(e) : Qv.filterProps(e);
      return y(o, Y({
        key: e.type,
        class: a.value,
        style: r.value,
        viewBox: `0 0 ${e.width} ${parseInt(i.value, 10)}`
      }, s), n);
    });
  }
}), yO = U({
  ...ve(),
  ...xy({
    offset: 8,
    minWidth: 0,
    openDelay: 0,
    closeDelay: 100,
    location: "top center",
    transition: "scale-transition"
  })
}, "VSpeedDial"), bO = K()({
  name: "VSpeedDial",
  props: yO(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = he(e, "modelValue"), r = G(), l = T(() => {
      const [o, s = "center"] = e.location?.split(" ") ?? [];
      return `${o} ${s}`;
    }), i = T(() => ({
      [`v-speed-dial__content--${l.value.replace(" ", "-")}`]: !0
    }));
    return X(() => {
      const o = qr.filterProps(e);
      return y(qr, Y(o, {
        modelValue: a.value,
        "onUpdate:modelValue": (s) => a.value = s,
        class: e.class,
        style: e.style,
        contentClass: ["v-speed-dial__content", i.value, e.contentClass],
        location: l.value,
        ref: r,
        transition: "fade-transition"
      }), {
        ...n,
        default: (s) => y(Ae, {
          defaults: {
            VBtn: {
              size: "small"
            }
          }
        }, {
          default: () => [y(Xt, {
            appear: !0,
            group: !0,
            transition: e.transition
          }, {
            default: () => [n.default?.(s)]
          })]
        })
      });
    }), {};
  }
}), _d = /* @__PURE__ */ Symbol.for("vuetify:v-stepper"), hp = U({
  color: String,
  disabled: {
    type: [Boolean, String],
    default: !1
  },
  prevText: {
    type: String,
    default: "$vuetify.stepper.prev"
  },
  nextText: {
    type: String,
    default: "$vuetify.stepper.next"
  }
}, "VStepperActions"), gp = K()({
  name: "VStepperActions",
  props: hp(),
  emits: {
    "click:prev": () => !0,
    "click:next": () => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const {
      t: r
    } = Ke();
    function l() {
      n("click:prev");
    }
    function i() {
      n("click:next");
    }
    return X(() => {
      const o = {
        onClick: l
      }, s = {
        onClick: i
      };
      return S("div", {
        class: "v-stepper-actions"
      }, [y(Ae, {
        defaults: {
          VBtn: {
            disabled: ["prev", !0].includes(e.disabled),
            text: r(e.prevText),
            variant: "text"
          }
        }
      }, {
        default: () => [a.prev?.({
          props: o
        }) ?? y(De, o, null)]
      }), y(Ae, {
        defaults: {
          VBtn: {
            color: e.color,
            disabled: ["next", !0].includes(e.disabled),
            text: r(e.nextText),
            variant: "tonal"
          }
        }
      }, {
        default: () => [a.next?.({
          props: s
        }) ?? y(De, s, null)]
      })]);
    }), {};
  }
}), yp = ca("v-stepper-header"), pO = U({
  color: String,
  title: String,
  subtitle: String,
  complete: Boolean,
  completeIcon: {
    type: be,
    default: "$complete"
  },
  editable: Boolean,
  editIcon: {
    type: be,
    default: "$edit"
  },
  error: Boolean,
  errorIcon: {
    type: be,
    default: "$error"
  },
  icon: be,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  rules: {
    type: Array,
    default: () => []
  }
}, "StepperItem"), wO = U({
  ...pO(),
  ...mr()
}, "VStepperItem"), bp = K()({
  name: "VStepperItem",
  directives: {
    vRipple: Ht
  },
  props: wO(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = Ia(e, _d, !0), r = T(() => a?.value.value ?? e.value), l = T(() => e.rules.every((f) => f() === !0)), i = T(() => !e.disabled && e.editable), o = T(() => !e.disabled && e.editable), s = T(() => e.error || !l.value), u = T(() => e.complete || e.rules.length > 0 && l.value), c = T(() => s.value ? e.errorIcon : u.value ? e.completeIcon : a.isSelected.value && e.editable ? e.editIcon : e.icon), d = T(() => ({
      canEdit: o.value,
      hasError: s.value,
      hasCompleted: u.value,
      title: e.title,
      subtitle: e.subtitle,
      step: r.value,
      value: e.value
    }));
    return X(() => {
      const f = (!a || a.isSelected.value || u.value || o.value) && !s.value && !e.disabled, v = !!(e.title != null || n.title), g = !!(e.subtitle != null || n.subtitle);
      function m() {
        a?.toggle();
      }
      return at(S("button", {
        class: J(["v-stepper-item", {
          "v-stepper-item--complete": u.value,
          "v-stepper-item--disabled": e.disabled,
          "v-stepper-item--error": s.value
        }, a?.selectedClass.value]),
        disabled: !e.editable,
        type: "button",
        onClick: m
      }, [i.value && fa(!0, "v-stepper-item"), y(kn, {
        key: "stepper-avatar",
        class: "v-stepper-item__avatar",
        color: f ? e.color : void 0,
        size: 24
      }, {
        default: () => [n.icon?.(d.value) ?? (c.value ? y(ze, {
          icon: c.value
        }, null) : r.value)]
      }), S("div", {
        class: "v-stepper-item__content"
      }, [v && S("div", {
        key: "title",
        class: "v-stepper-item__title"
      }, [n.title?.(d.value) ?? e.title]), g && S("div", {
        key: "subtitle",
        class: "v-stepper-item__subtitle"
      }, [n.subtitle?.(d.value) ?? e.subtitle]), n.default?.(d.value)])]), [[Ht, e.editable && e.ripple, null]]);
    }), {};
  }
}), kO = U({
  ...Pe(Jo(), ["continuous", "nextIcon", "prevIcon", "showArrows", "touch", "mandatory"])
}, "VStepperWindow"), pp = K()({
  name: "VStepperWindow",
  props: kO(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = Le(_d, null), r = he(e, "modelValue"), l = T({
      get() {
        return r.value != null || !a ? r.value : a.items.value.find((i) => a.selected.value.includes(i.id))?.value;
      },
      set(i) {
        r.value = i;
      }
    });
    return X(() => {
      const i = tr.filterProps(e);
      return y(tr, Y({
        _as: "VStepperWindow"
      }, i, {
        modelValue: l.value,
        "onUpdate:modelValue": (o) => l.value = o,
        class: ["v-stepper-window", e.class],
        style: e.style,
        mandatory: !1,
        touch: !1
      }), n);
    }), {};
  }
}), SO = U({
  ...Xo()
}, "VStepperWindowItem"), wp = K()({
  name: "VStepperWindowItem",
  props: SO(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => {
      const a = nr.filterProps(e);
      return y(nr, Y({
        _as: "VStepperWindowItem"
      }, a, {
        class: ["v-stepper-window-item", e.class],
        style: e.style
      }), n);
    }), {};
  }
}), xO = U({
  altLabels: Boolean,
  bgColor: String,
  completeIcon: be,
  editIcon: be,
  editable: Boolean,
  errorIcon: be,
  hideActions: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: [String, Array, Function],
    default: "title"
  },
  itemValue: {
    type: [String, Array, Function],
    default: "value"
  },
  itemProps: {
    type: [Boolean, String, Array, Function],
    default: "props"
  },
  nonLinear: Boolean,
  flat: Boolean,
  ...hr()
}, "Stepper"), CO = U({
  ...xO(),
  ...vr({
    mandatory: "force",
    selectedClass: "v-stepper-item--selected"
  }),
  ...Jc(),
  ...an(hp(), ["prevText", "nextText"])
}, "VStepper"), _O = K()({
  name: "VStepper",
  props: CO(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      items: a,
      next: r,
      prev: l,
      selected: i
    } = Na(e, _d), {
      displayClasses: o,
      mobile: s
    } = Cn(e), {
      completeIcon: u,
      editIcon: c,
      errorIcon: d,
      color: f,
      editable: v,
      prevText: g,
      nextText: m
    } = Kr(e), h = T(() => e.items.map((I, C) => {
      const b = pt(I, e.itemTitle, I), p = pt(I, e.itemValue, C + 1), x = e.itemProps === !0 ? I : pt(I, e.itemProps), k = {
        title: b,
        value: p,
        ...x
      };
      return {
        title: k.title,
        value: k.value,
        props: k,
        raw: I
      };
    })), w = T(() => a.value.findIndex((I) => i.value.includes(I.id))), _ = T(() => e.disabled ? e.disabled : w.value === 0 ? "prev" : w.value === a.value.length - 1 ? "next" : !1);
    return vt({
      VStepperItem: {
        editable: v,
        errorIcon: d,
        completeIcon: u,
        editIcon: c,
        prevText: g,
        nextText: m
      },
      VStepperActions: {
        color: f,
        disabled: _,
        prevText: g,
        nextText: m
      }
    }), X(() => {
      const I = Va.filterProps(e), C = !!(n.header || e.items.length), b = e.items.length > 0, p = !e.hideActions && !!(b || n.actions);
      return y(Va, Y(I, {
        color: e.bgColor,
        class: ["v-stepper", {
          "v-stepper--alt-labels": e.altLabels,
          "v-stepper--flat": e.flat,
          "v-stepper--non-linear": e.nonLinear,
          "v-stepper--mobile": s.value
        }, o.value, e.class],
        style: e.style
      }), {
        default: () => [C && y(yp, {
          key: "stepper-header"
        }, {
          default: () => [h.value.map((x, k) => {
            let {
              raw: V,
              ...A
            } = x;
            return S(fe, null, [!!k && y(pn, null, null), y(bp, A.props, {
              default: n[`header-item.${A.value}`] ?? n.header,
              icon: n.icon,
              title: n.title,
              subtitle: n.subtitle
            })]);
          })]
        }), b && y(pp, {
          key: "stepper-window"
        }, {
          default: () => [h.value.map((x) => y(wp, {
            value: x.value
          }, {
            default: () => n[`item.${x.value}`]?.(x) ?? n.item?.(x)
          }))]
        }), n.default?.({
          prev: l,
          next: r
        }), p && (n.actions?.({
          next: r,
          prev: l
        }) ?? y(gp, {
          key: "stepper-actions",
          "onClick:prev": l,
          "onClick:next": r
        }, n))]
      });
    }), {
      prev: l,
      next: r
    };
  }
}), TO = U({
  indeterminate: Boolean,
  inset: Boolean,
  flat: Boolean,
  loading: {
    type: [Boolean, String],
    default: !1
  },
  ...ha(),
  ...zo()
}, "VSwitch"), IO = K()({
  name: "VSwitch",
  inheritAttrs: !1,
  props: TO(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:indeterminate": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const r = he(e, "indeterminate"), l = he(e, "modelValue"), {
      loaderClasses: i
    } = ii(e), {
      isFocused: o,
      focus: s,
      blur: u
    } = ma(e), c = G(), d = G(), f = Qh && window.matchMedia("(forced-colors: active)").matches, v = D(() => typeof e.loading == "string" && e.loading !== "" ? e.loading : e.color), g = Rt(), m = D(() => e.id || `switch-${g}`);
    function h() {
      r.value && (r.value = !1);
    }
    function w(_) {
      _.stopPropagation(), _.preventDefault(), c.value?.input?.click();
    }
    return X(() => {
      const [_, I] = Jn(n), C = Gt.filterProps(e), b = Pa.filterProps(e);
      return y(Gt, Y({
        ref: d,
        class: ["v-switch", {
          "v-switch--flat": e.flat
        }, {
          "v-switch--inset": e.inset
        }, {
          "v-switch--indeterminate": r.value
        }, i.value, e.class]
      }, _, C, {
        modelValue: l.value,
        "onUpdate:modelValue": (p) => l.value = p,
        id: m.value,
        focused: o.value,
        style: e.style
      }), {
        ...a,
        default: (p) => {
          let {
            id: x,
            messagesId: k,
            isDisabled: V,
            isReadonly: A,
            isValid: M
          } = p;
          const L = {
            model: l,
            isValid: M
          };
          return y(Pa, Y({
            ref: c
          }, b, {
            modelValue: l.value,
            "onUpdate:modelValue": [(E) => l.value = E, h],
            id: x.value,
            "aria-describedby": k.value,
            type: "checkbox",
            "aria-checked": r.value ? "mixed" : void 0,
            disabled: V.value,
            readonly: A.value,
            onFocus: s,
            onBlur: u
          }, I), {
            ...a,
            default: (E) => {
              let {
                backgroundColorClasses: P,
                backgroundColorStyles: O
              } = E;
              return S("div", {
                class: J(["v-switch__track", f ? void 0 : P.value]),
                style: le(O.value),
                onClick: w
              }, [a["track-true"] && S("div", {
                key: "prepend",
                class: "v-switch__track-true"
              }, [a["track-true"](L)]), a["track-false"] && S("div", {
                key: "append",
                class: "v-switch__track-false"
              }, [a["track-false"](L)])]);
            },
            input: (E) => {
              let {
                inputNode: P,
                icon: O,
                backgroundColorClasses: F,
                backgroundColorStyles: B
              } = E;
              return S(fe, null, [P, S("div", {
                class: J(["v-switch__thumb", {
                  "v-switch__thumb--filled": O || e.loading
                }, e.inset || f ? void 0 : F.value]),
                style: le(e.inset ? void 0 : B.value)
              }, [a.thumb ? y(Ae, {
                defaults: {
                  VIcon: {
                    icon: O,
                    size: "x-small"
                  }
                }
              }, {
                default: () => [a.thumb({
                  ...L,
                  icon: O
                })]
              }) : y(Mc, null, {
                default: () => [e.loading ? y(oi, {
                  name: "v-switch",
                  active: !0,
                  color: M.value === !1 ? void 0 : v.value
                }, {
                  default: (N) => a.loader ? a.loader(N) : y(Aa, {
                    active: N.isActive,
                    color: N.color,
                    indeterminate: !0,
                    size: "16",
                    width: "2"
                  }, null)
                }) : O && y(ze, {
                  key: String(O),
                  icon: O,
                  size: "x-small"
                }, null)]
              })])]);
            }
          });
        }
      });
    }), Mt({}, d);
  }
}), AO = U({
  color: String,
  height: [Number, String],
  window: Boolean,
  ...ve(),
  ...Ct(),
  ...cr(),
  ...lt(),
  ...Ie(),
  ...Re()
}, "VSystemBar"), PO = K()({
  name: "VSystemBar",
  props: AO(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: a
    } = Ge(e), {
      backgroundColorClasses: r,
      backgroundColorStyles: l
    } = qe(() => e.color), {
      elevationClasses: i
    } = Et(e), {
      roundedClasses: o
    } = ut(e), {
      ssrBootStyles: s
    } = fr(), u = T(() => e.height ?? (e.window ? 32 : 24)), {
      layoutItemStyles: c
    } = dr({
      id: e.name,
      order: T(() => parseInt(e.order, 10)),
      position: ae("top"),
      layoutSize: u,
      elementSize: u,
      active: T(() => !0),
      absolute: D(() => e.absolute)
    });
    return X(() => y(e.tag, {
      class: J(["v-system-bar", {
        "v-system-bar--window": e.window
      }, a.value, r.value, i.value, o.value, e.class]),
      style: le([l.value, c.value, s.value, e.style])
    }, n)), {};
  }
}), Td = /* @__PURE__ */ Symbol.for("vuetify:v-tabs"), kp = U({
  fixed: Boolean,
  sliderColor: String,
  sliderTransition: String,
  sliderTransitionDuration: [String, Number],
  hideSlider: Boolean,
  inset: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  ...Pe(Ho({
    selectedClass: "v-tab--selected",
    variant: "text"
  }), ["active", "block", "flat", "location", "position", "symbol"])
}, "VTab"), Sp = K()({
  name: "VTab",
  props: kp(),
  setup(e, t) {
    let {
      slots: n,
      attrs: a
    } = t;
    const {
      textColorClasses: r,
      textColorStyles: l
    } = Nt(() => e.sliderColor), {
      backgroundColorClasses: i,
      backgroundColorStyles: o
    } = qe(() => e.sliderColor), s = G(), u = G(), c = T(() => e.direction === "horizontal"), d = T(() => s.value?.group?.isSelected.value ?? !1);
    function f(h, w) {
      return {
        opacity: [0, 1]
      };
    }
    function v(h, w) {
      return e.direction === "vertical" ? {
        transform: ["scaleY(0)", "scaleY(1)"]
      } : {
        transform: ["scaleX(0)", "scaleX(1)"]
      };
    }
    function g(h, w) {
      const _ = w.getBoundingClientRect(), I = h.getBoundingClientRect(), C = c.value ? "x" : "y", b = c.value ? "X" : "Y", p = c.value ? "right" : "bottom", x = c.value ? "width" : "height", k = _[C], V = I[C], A = k > V ? _[p] - I[p] : _[C] - I[C], M = Math.sign(A) > 0 ? c.value ? "right" : "bottom" : Math.sign(A) < 0 ? c.value ? "left" : "top" : "center", E = (Math.abs(A) + (Math.sign(A) < 0 ? _[x] : I[x])) / Math.max(_[x], I[x]) || 0, P = _[x] / I[x] || 0, O = 1.5;
      return {
        transform: [`translate${b}(${A}px) scale${b}(${P})`, `translate${b}(${A / O}px) scale${b}(${(E - 1) / O + 1})`, "none"],
        transformOrigin: Array(3).fill(M)
      };
    }
    function m(h) {
      let {
        value: w
      } = h;
      if (w) {
        const _ = s.value?.$el.parentElement?.querySelector(".v-tab--selected .v-tab__slider"), I = u.value;
        if (!_ || !I) return;
        const C = getComputedStyle(_).backgroundColor, b = {
          fade: f,
          grow: v,
          shift: g
        }[e.sliderTransition ?? "shift"] ?? g, p = Number(e.sliderTransitionDuration) || ({
          fade: 400,
          grow: 350,
          shift: 225
        }[e.sliderTransition ?? "shift"] ?? 225);
        aa(I, {
          backgroundColor: [C, C],
          ...b(I, _)
        }, {
          duration: p,
          easing: Dl
        });
      }
    }
    return X(() => {
      const h = De.filterProps(e);
      return y(De, Y({
        symbol: Td,
        ref: s,
        class: ["v-tab", e.class, d.value && e.inset ? i.value : []],
        style: [e.style, d.value && e.inset ? o.value : [], {
          backgroundColor: d.value && e.inset ? "transparent !important" : void 0
        }],
        tabindex: d.value ? 0 : -1,
        role: "tab",
        "aria-selected": String(d.value),
        active: !1
      }, h, a, {
        block: e.fixed,
        maxWidth: e.fixed ? 300 : void 0,
        "onGroup:selected": m
      }), {
        ...n,
        default: () => S(fe, null, [n.default?.() ?? e.text, !e.hideSlider && S("div", {
          ref: u,
          class: J(["v-tab__slider", e.inset ? i.value : r.value]),
          style: le([l.value, e.inset ? o.value : r.value])
        }, null)])
      });
    }), Mt({}, s);
  }
}), VO = U({
  ...Pe(Jo(), ["continuous", "nextIcon", "prevIcon", "showArrows", "touch", "mandatory"])
}, "VTabsWindow"), xp = K()({
  name: "VTabsWindow",
  props: VO(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = Le(Td, null), r = he(e, "modelValue"), l = T({
      get() {
        return r.value != null || !a ? r.value : a.items.value.find((i) => a.selected.value.includes(i.id))?.value;
      },
      set(i) {
        r.value = i;
      }
    });
    return X(() => {
      const i = tr.filterProps(e);
      return y(tr, Y({
        _as: "VTabsWindow"
      }, i, {
        modelValue: l.value,
        "onUpdate:modelValue": (o) => l.value = o,
        class: ["v-tabs-window", e.class],
        style: e.style,
        mandatory: !1,
        touch: !1
      }), n);
    }), {};
  }
}), EO = U({
  ...Xo()
}, "VTabsWindowItem"), Cp = K()({
  name: "VTabsWindowItem",
  props: EO(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return X(() => {
      const a = nr.filterProps(e);
      return y(nr, Y({
        _as: "VTabsWindowItem"
      }, a, {
        class: ["v-tabs-window-item", e.class],
        style: e.style
      }), n);
    }), {};
  }
});
function MO(e) {
  return e ? e.map((t) => Qa(t) ? t : {
    text: t,
    value: t
  }) : [];
}
const OO = U({
  alignTabs: {
    type: String,
    default: "start"
  },
  color: String,
  fixedTabs: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  stacked: Boolean,
  bgColor: String,
  grow: Boolean,
  height: {
    type: [Number, String],
    default: void 0
  },
  hideSlider: Boolean,
  inset: Boolean,
  insetPadding: [String, Number],
  insetRadius: [String, Number],
  sliderColor: String,
  ...an(kp(), ["spaced", "sliderTransition", "sliderTransitionDuration"]),
  ...Bc({
    mandatory: "force",
    selectedClass: "v-tab-item--selected"
  }),
  ...mt(),
  ...Ie()
}, "VTabs"), DO = K()({
  name: "VTabs",
  props: OO(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: a
    } = t;
    const r = he(e, "modelValue"), l = T(() => MO(e.items)), {
      densityClasses: i
    } = zt(e), {
      backgroundColorClasses: o,
      backgroundColorStyles: s
    } = qe(() => e.bgColor), {
      scopeId: u
    } = gr();
    return vt({
      VTab: {
        color: D(e, "color"),
        direction: D(e, "direction"),
        stacked: D(e, "stacked"),
        fixed: D(e, "fixedTabs"),
        inset: D(e, "inset"),
        sliderColor: D(e, "sliderColor"),
        sliderTransition: D(e, "sliderTransition"),
        sliderTransitionDuration: D(e, "sliderTransitionDuration"),
        hideSlider: D(e, "hideSlider")
      }
    }), X(() => {
      const c = Bl.filterProps(e), d = !!(a.window || e.items.length > 0);
      return S(fe, null, [y(Bl, Y(c, {
        modelValue: r.value,
        "onUpdate:modelValue": (f) => r.value = f,
        class: ["v-tabs", `v-tabs--${e.direction}`, `v-tabs--align-tabs-${e.alignTabs}`, {
          "v-tabs--fixed-tabs": e.fixedTabs,
          "v-tabs--grow": e.grow,
          "v-tabs--inset": e.inset,
          "v-tabs--stacked": e.stacked
        }, i.value, o.value, e.class],
        style: [{
          "--v-tabs-height": re(e.height),
          "--v-tabs-inset-padding": e.inset ? re(e.insetPadding) : void 0,
          "--v-tabs-inset-radius": e.inset ? re(e.insetRadius) : void 0
        }, s.value, e.style],
        role: "tablist",
        symbol: Td
      }, u, n), {
        default: a.default ?? (() => l.value.map((f) => a.tab?.({
          item: f
        }) ?? y(Sp, Y(f, {
          key: f.text,
          value: f.value,
          spaced: e.spaced
        }), {
          default: a[`tab.${f.value}`] ? () => a[`tab.${f.value}`]?.({
            item: f
          }) : void 0
        }))),
        prev: a.prev,
        next: a.next
      }), d && y(xp, Y({
        modelValue: r.value,
        "onUpdate:modelValue": (f) => r.value = f,
        key: "tabs-window"
      }, u), {
        default: () => [l.value.map((f) => a.item?.({
          item: f
        }) ?? y(Cp, {
          value: f.value
        }, {
          default: () => a[`item.${f.value}`]?.({
            item: f
          })
        })), a.window?.()]
      })]);
    }), {};
  }
}), LO = U({
  autoGrow: Boolean,
  autofocus: Boolean,
  counter: [Boolean, Number, String],
  counterValue: Function,
  prefix: String,
  placeholder: String,
  persistentPlaceholder: Boolean,
  persistentCounter: Boolean,
  noResize: Boolean,
  rows: {
    type: [Number, String],
    default: 5,
    validator: (e) => !isNaN(parseFloat(e))
  },
  maxHeight: {
    type: [Number, String],
    validator: (e) => !isNaN(parseFloat(e))
  },
  maxRows: {
    type: [Number, String],
    validator: (e) => !isNaN(parseFloat(e))
  },
  suffix: String,
  modelModifiers: Object,
  ...Cy(),
  ...Pe(ha(), ["direction"]),
  ...vi()
}, "VTextarea"), NO = K()({
  name: "VTextarea",
  directives: {
    vIntersect: Bn
  },
  inheritAttrs: !1,
  props: LO(),
  emits: {
    "click:control": (e) => !0,
    "mousedown:control": (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:rows": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: a,
      slots: r
    } = t;
    const l = he(e, "modelValue"), {
      isFocused: i,
      focus: o,
      blur: s
    } = ma(e), {
      onIntersect: u
    } = _y(e), c = T(() => typeof e.counterValue == "function" ? e.counterValue(l.value) : (l.value || "").toString().length), d = T(() => {
      if (n.maxlength) return n.maxlength;
      if (!(!e.counter || typeof e.counter != "number" && typeof e.counter != "string"))
        return e.counter;
    }), f = G(), v = G(), g = ae(""), m = G(), h = G(0), {
      platform: w
    } = Cn(), _ = Xc(e), I = T(() => e.persistentPlaceholder || i.value || e.active);
    function C() {
      _.isSuppressing.value && _.update(), m.value !== document.activeElement && m.value?.focus(), i.value || o();
    }
    function b(P) {
      C(), a("click:control", P);
    }
    function p(P) {
      a("mousedown:control", P);
    }
    function x(P) {
      P.stopPropagation(), C(), Se(() => {
        l.value = "", ai(e["onClick:clear"], P);
      });
    }
    function k(P) {
      const O = P.target;
      if (!e.modelModifiers?.trim) {
        l.value = O.value;
        return;
      }
      const F = O.value, B = O.selectionStart, N = O.selectionEnd;
      l.value = F, Se(() => {
        let W = 0;
        F.trimStart().length === O.value.length && (W = F.length - O.value.length), B != null && (O.selectionStart = B - W), N != null && (O.selectionEnd = N - W);
      });
    }
    const V = G(), A = G(Number(e.rows)), M = T(() => ["plain", "underlined"].includes(e.variant));
    ft(() => {
      e.autoGrow || (A.value = Number(e.rows));
    });
    function L() {
      Se(() => {
        if (!m.value) return;
        if (w.value.firefox) {
          h.value = 12;
          return;
        }
        const {
          offsetWidth: P,
          clientWidth: O
        } = m.value;
        h.value = Math.max(0, P - O);
      }), e.autoGrow && Se(() => {
        if (!V.value || !v.value) return;
        const P = getComputedStyle(V.value), O = getComputedStyle(v.value.$el), F = parseFloat(P.getPropertyValue("--v-field-padding-top")) + parseFloat(P.getPropertyValue("--v-input-padding-top")) + parseFloat(P.getPropertyValue("--v-field-padding-bottom")), B = V.value.scrollHeight, N = parseFloat(P.lineHeight), W = Math.max(parseFloat(e.rows) * N + F, parseFloat(O.getPropertyValue("--v-input-control-height"))), R = e.maxHeight ? parseFloat(e.maxHeight) : parseFloat(e.maxRows) * N + F || 1 / 0, j = Xe(B ?? 0, W, R);
        A.value = Math.floor((j - F) / N), g.value = re(j);
      });
    }
    bt(L), ne(l, L), ne(() => e.rows, L), ne(() => e.maxHeight, L), ne(() => e.maxRows, L), ne(() => e.density, L), ne(A, (P) => {
      a("update:rows", P);
    });
    let E;
    return ne(V, (P) => {
      P ? (E = new ResizeObserver(L), E.observe(V.value)) : E?.disconnect();
    }), Ft(() => {
      E?.disconnect();
    }), X(() => {
      const P = !!(r.counter || e.counter || e.counterValue), O = !!(P || r.details), [F, B] = Jn(n), {
        modelValue: N,
        ...W
      } = Gt.filterProps(e), R = {
        ...Ea.filterProps(e),
        "onClick:clear": x
      };
      return y(Gt, Y({
        ref: f,
        modelValue: l.value,
        "onUpdate:modelValue": (j) => l.value = j,
        class: ["v-textarea v-text-field", {
          "v-textarea--prefixed": e.prefix,
          "v-textarea--suffixed": e.suffix,
          "v-text-field--prefixed": e.prefix,
          "v-text-field--suffixed": e.suffix,
          "v-textarea--auto-grow": e.autoGrow,
          "v-textarea--no-resize": e.noResize || e.autoGrow,
          "v-input--plain-underlined": M.value
        }, e.class],
        style: [{
          "--v-textarea-max-height": e.maxHeight ? re(e.maxHeight) : void 0,
          "--v-textarea-scroll-bar-width": re(h.value)
        }, e.style]
      }, F, W, {
        centerAffix: A.value === 1 && !M.value,
        focused: i.value
      }), {
        ...r,
        default: (j) => {
          let {
            id: H,
            isDisabled: $,
            isDirty: z,
            isReadonly: te,
            isValid: me,
            hasDetails: Q
          } = j;
          return y(Ea, Y({
            ref: v,
            style: {
              "--v-textarea-control-height": g.value
            },
            onClick: b,
            onMousedown: p,
            "onClick:prependInner": e["onClick:prependInner"],
            "onClick:appendInner": e["onClick:appendInner"]
          }, R, {
            id: H.value,
            active: I.value || z.value,
            labelId: `${H.value}-label`,
            centerAffix: A.value === 1 && !M.value,
            dirty: z.value || e.dirty,
            disabled: $.value,
            focused: i.value,
            details: Q.value,
            error: me.value === !1
          }), {
            ...r,
            default: (ie) => {
              let {
                props: {
                  class: ke,
                  ...ye
                },
                controlRef: ue
              } = ie;
              return S(fe, null, [e.prefix && S("span", {
                class: "v-text-field__prefix"
              }, [e.prefix]), at(S("textarea", Y({
                ref: (Te) => m.value = ue.value = Te,
                class: ke,
                value: l.value,
                onInput: k,
                autofocus: e.autofocus,
                readonly: te.value,
                disabled: $.value,
                placeholder: e.placeholder,
                rows: e.rows,
                name: _.fieldName.value,
                autocomplete: _.fieldAutocomplete.value,
                onFocus: C,
                onBlur: s,
                "aria-labelledby": `${H.value}-label`
              }, ye, B), null), [[Bn, {
                handler: u
              }, null, {
                once: !0
              }]]), e.autoGrow && at(S("textarea", {
                class: J([ke, "v-textarea__sizer"]),
                id: `${ye.id}-sizer`,
                "onUpdate:modelValue": (Te) => l.value = Te,
                ref: V,
                readonly: !0,
                "aria-hidden": "true"
              }, null), [[Jp, l.value]]), e.suffix && S("span", {
                class: "v-text-field__suffix"
              }, [e.suffix])]);
            }
          });
        },
        details: O ? (j) => S(fe, null, [r.details?.(j), P && S(fe, null, [S("span", null, null), y(Go, {
          active: e.persistentCounter || i.value,
          value: c.value,
          max: d.value,
          disabled: e.disabled
        }, r.counter)])]) : void 0
      });
    }), Mt({}, f, v, m);
  }
}), FO = U({
  withBackground: Boolean,
  ...ve(),
  ...Re(),
  ...Ie()
}, "VThemeProvider"), RO = K()({
  name: "VThemeProvider",
  props: FO(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: a
    } = Ge(e);
    return () => e.withBackground ? y(e.tag, {
      class: J(["v-theme-provider", a.value, e.class]),
      style: le(e.style)
    }, {
      default: () => [n.default?.()]
    }) : n.default?.();
  }
}), $O = U({
  dotColor: String,
  fillDot: Boolean,
  hideDot: Boolean,
  icon: be,
  iconColor: String,
  lineColor: String,
  ...ve(),
  ...lt(),
  ...ea(),
  ...Ct()
}, "VTimelineDivider"), BO = K()({
  name: "VTimelineDivider",
  props: $O(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      sizeClasses: a,
      sizeStyles: r
    } = ll(e, "v-timeline-divider__dot"), {
      backgroundColorStyles: l,
      backgroundColorClasses: i
    } = qe(() => e.dotColor), {
      roundedClasses: o
    } = ut(e, "v-timeline-divider__dot"), {
      elevationClasses: s
    } = Et(e), {
      backgroundColorClasses: u,
      backgroundColorStyles: c
    } = qe(() => e.lineColor);
    return X(() => S("div", {
      class: J(["v-timeline-divider", {
        "v-timeline-divider--fill-dot": e.fillDot
      }, e.class]),
      style: le(e.style)
    }, [S("div", {
      class: J(["v-timeline-divider__before", u.value]),
      style: le(c.value)
    }, null), !e.hideDot && S("div", {
      key: "dot",
      class: J(["v-timeline-divider__dot", s.value, o.value, a.value]),
      style: le(r.value)
    }, [S("div", {
      class: J(["v-timeline-divider__inner-dot", i.value, o.value]),
      style: le(l.value)
    }, [n.default ? y(Ae, {
      key: "icon-defaults",
      disabled: !e.icon,
      defaults: {
        VIcon: {
          color: e.iconColor,
          icon: e.icon,
          size: e.size
        }
      }
    }, n.default) : y(ze, {
      key: "icon",
      color: e.iconColor,
      icon: e.icon,
      size: e.size
    }, null)])]), S("div", {
      class: J(["v-timeline-divider__after", u.value]),
      style: le(c.value)
    }, null)])), {};
  }
}), _p = U({
  density: String,
  dotColor: String,
  fillDot: Boolean,
  hideDot: Boolean,
  hideOpposite: {
    type: Boolean,
    default: void 0
  },
  icon: be,
  iconColor: String,
  lineInset: [Number, String],
  side: {
    type: String,
    validator: (e) => e == null || ["start", "end"].includes(e)
  },
  ...ve(),
  ...St(),
  ...Ct(),
  ...lt(),
  ...ea(),
  ...Ie()
}, "VTimelineItem"), UO = K()({
  name: "VTimelineItem",
  props: _p(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      dimensionStyles: a
    } = xt(e), r = ae(0), l = G();
    return ne(l, (i) => {
      i && (r.value = i.$el.querySelector(".v-timeline-divider__dot")?.getBoundingClientRect().width ?? 0);
    }, {
      flush: "post"
    }), X(() => S("div", {
      class: J(["v-timeline-item", {
        "v-timeline-item--fill-dot": e.fillDot,
        "v-timeline-item--side-start": e.side === "start",
        "v-timeline-item--side-end": e.side === "end"
      }, e.class]),
      style: le([{
        "--v-timeline-dot-size": re(r.value),
        "--v-timeline-line-inset": e.lineInset ? `calc(var(--v-timeline-dot-size) / 2 + ${re(e.lineInset)})` : re(0)
      }, e.style])
    }, [S("div", {
      class: "v-timeline-item__body",
      style: le(a.value)
    }, [n.default?.()]), y(BO, {
      ref: l,
      hideDot: e.hideDot,
      icon: e.icon,
      iconColor: e.iconColor,
      size: e.size,
      elevation: e.elevation,
      dotColor: e.dotColor,
      fillDot: e.fillDot,
      rounded: e.rounded
    }, {
      default: n.icon
    }), e.density !== "compact" && S("div", {
      class: "v-timeline-item__opposite"
    }, [!e.hideOpposite && n.opposite?.()])])), {};
  }
}), WO = U({
  align: {
    type: String,
    default: "center",
    validator: (e) => ["center", "start"].includes(e)
  },
  direction: {
    type: String,
    default: "vertical",
    validator: (e) => ["vertical", "horizontal"].includes(e)
  },
  justify: {
    type: String,
    default: "auto",
    validator: (e) => ["auto", "center"].includes(e)
  },
  side: {
    type: String,
    validator: (e) => e == null || ["start", "end"].includes(e)
  },
  lineThickness: {
    type: [String, Number],
    default: 2
  },
  lineColor: String,
  truncateLine: {
    type: String,
    validator: (e) => ["start", "end", "both"].includes(e)
  },
  ...an(_p({
    lineInset: 0
  }), ["dotColor", "fillDot", "hideOpposite", "iconColor", "lineInset", "size"]),
  ...ve(),
  ...mt(),
  ...Ie(),
  ...Re()
}, "VTimeline"), HO = K()({
  name: "VTimeline",
  props: WO(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: a
    } = Ge(e), {
      densityClasses: r
    } = zt(e), {
      rtlClasses: l
    } = At();
    vt({
      VTimelineDivider: {
        lineColor: D(() => e.lineColor)
      },
      VTimelineItem: {
        density: D(() => e.density),
        dotColor: D(() => e.dotColor),
        fillDot: D(() => e.fillDot),
        hideOpposite: D(() => e.hideOpposite),
        iconColor: D(() => e.iconColor),
        lineColor: D(() => e.lineColor),
        lineInset: D(() => e.lineInset),
        size: D(() => e.size)
      }
    });
    const i = T(() => {
      const s = e.side ? e.side : e.density !== "default" ? "end" : null;
      return s && `v-timeline--side-${s}`;
    }), o = T(() => {
      const s = ["v-timeline--truncate-line-start", "v-timeline--truncate-line-end"];
      switch (e.truncateLine) {
        case "both":
          return s;
        case "start":
          return s[0];
        case "end":
          return s[1];
        default:
          return null;
      }
    });
    return X(() => y(e.tag, {
      class: J(["v-timeline", `v-timeline--${e.direction}`, `v-timeline--align-${e.align}`, `v-timeline--justify-${e.justify}`, o.value, {
        "v-timeline--inset-line": !!e.lineInset
      }, a.value, r.value, i.value, l.value, e.class]),
      style: le([{
        "--v-timeline-line-thickness": re(e.lineThickness)
      }, e.style])
    }, n)), {};
  }
}), zO = U({
  allowedValues: Function,
  ampm: Boolean,
  color: String,
  disabled: Boolean,
  displayedValue: null,
  double: Boolean,
  format: {
    type: Function,
    default: (e) => e
  },
  max: {
    type: Number,
    required: !0
  },
  min: {
    type: Number,
    required: !0
  },
  scrollable: Boolean,
  readonly: Boolean,
  rotate: {
    type: Number,
    default: 0
  },
  step: {
    type: Number,
    default: 1
  },
  modelValue: {
    type: Number
  }
}, "VTimePickerClock"), ju = K()({
  name: "VTimePickerClock",
  props: zO(),
  emits: {
    change: (e) => !0,
    input: (e) => !0
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    const a = G(null), r = G(null), l = G(void 0), i = G(!1), o = G(null), s = G(null), u = rg((R) => n("change", R), 750), {
      textColorClasses: c,
      textColorStyles: d
    } = Nt(() => e.color), {
      backgroundColorClasses: f,
      backgroundColorStyles: v
    } = qe(() => e.color), g = T(() => e.max - e.min + 1), m = T(() => e.double ? g.value / 2 : g.value), h = T(() => 360 / m.value), w = T(() => h.value * Math.PI / 180), _ = T(() => e.modelValue == null ? e.min : e.modelValue), I = T(() => 0.62), C = T(() => {
      const R = [];
      for (let j = e.min; j <= e.max; j = j + e.step)
        R.push(j);
      return R;
    });
    ne(() => e.modelValue, (R) => {
      l.value = R;
    });
    function b(R) {
      l.value !== R && (l.value = R), n("input", R);
    }
    function p(R) {
      return !e.allowedValues || e.allowedValues(R);
    }
    function x(R) {
      if (!e.scrollable || e.disabled) return;
      R.preventDefault();
      const j = Math.sign(-R.deltaY || 1);
      let H = _.value;
      do
        H = H + j, H = (H - e.min + g.value) % g.value + e.min;
      while (!p(H) && H !== _.value);
      H !== e.displayedValue && b(H), u(H);
    }
    function k(R) {
      return e.double && R - e.min >= m.value;
    }
    function V(R) {
      return k(R) ? I.value : 1;
    }
    function A(R) {
      const j = e.rotate * Math.PI / 180;
      return {
        x: Math.sin((R - e.min) * w.value + j) * V(R),
        y: -Math.cos((R - e.min) * w.value + j) * V(R)
      };
    }
    function M(R, j) {
      const H = (Math.round(R / h.value) + (j ? m.value : 0)) % g.value + e.min;
      return R < 360 - h.value / 2 ? H : j ? e.max - m.value + 1 : e.min;
    }
    function L(R) {
      const {
        x: j,
        y: H
      } = A(R);
      return {
        left: `${Math.round(50 + j * 50)}%`,
        top: `${Math.round(50 + H * 50)}%`
      };
    }
    function E(R, j) {
      const H = j.x - R.x, $ = j.y - R.y;
      return Math.sqrt(H * H + $ * $);
    }
    function P(R, j) {
      const H = 2 * Math.atan2(j.y - R.y - E(R, j), j.x - R.x);
      return Math.abs(H * 180 / Math.PI);
    }
    function O(R) {
      o.value === null && (o.value = R), s.value = R, b(R);
    }
    function F(R) {
      if (R.preventDefault(), !i.value && R.type !== "click" || !a.value) return;
      const {
        width: j,
        top: H,
        left: $
      } = a.value?.getBoundingClientRect(), {
        width: z
      } = r.value?.getBoundingClientRect() ?? {
        width: 0
      }, {
        clientX: te,
        clientY: me
      } = "touches" in R ? R.touches[0] : R, Q = {
        x: j / 2,
        y: -j / 2
      }, ie = {
        x: te - $,
        y: H - me
      }, ke = Math.round(P(Q, ie) - e.rotate + 360) % 360, ye = e.double && E(Q, ie) < (z + z * I.value) / 4, ue = Math.ceil(15 / h.value);
      let Te;
      for (let Ne = 0; Ne < ue; Ne++)
        if (Te = M(ke + Ne * h.value, ye), p(Te) || (Te = M(ke - Ne * h.value, ye), p(Te))) return O(Te);
    }
    function B(R) {
      e.disabled || (R.preventDefault(), window.addEventListener("mousemove", F), window.addEventListener("touchmove", F), window.addEventListener("mouseup", N), window.addEventListener("touchend", N), o.value = null, s.value = null, i.value = !0, F(R));
    }
    function N(R) {
      R.stopPropagation(), W(), i.value = !1, s.value !== null && p(s.value) && n("change", s.value);
    }
    function W() {
      window.removeEventListener("mousemove", F), window.removeEventListener("touchmove", F), window.removeEventListener("mouseup", N), window.removeEventListener("touchend", N);
    }
    It(W), X(() => S("div", {
      class: J([{
        "v-time-picker-clock": !0,
        "v-time-picker-clock--indeterminate": e.modelValue == null,
        "v-time-picker-clock--readonly": e.readonly
      }]),
      onMousedown: B,
      onTouchstart: B,
      onWheel: x,
      ref: a
    }, [S("div", {
      class: "v-time-picker-clock__inner",
      ref: r
    }, [S("div", {
      class: J([{
        "v-time-picker-clock__hand": !0,
        "v-time-picker-clock__hand--inner": k(e.modelValue)
      }, c.value]),
      style: le([{
        transform: `rotate(${e.rotate + h.value * (_.value - e.min)}deg) scaleY(${V(_.value)})`
      }, d.value])
    }, null), C.value.map((R) => {
      const j = R === _.value;
      return S("div", {
        class: J([{
          "v-time-picker-clock__item": !0,
          "v-time-picker-clock__item--active": j,
          "v-time-picker-clock__item--disabled": e.disabled || !p(R)
        }, j && f.value]),
        style: le([L(R), j && v.value])
      }, [S("span", null, [e.format(R)])]);
    })])]));
  }
}), jO = U({
  active: Boolean,
  color: String,
  disabled: Boolean,
  label: String,
  modelValue: String,
  error: String,
  showHint: Boolean,
  readonly: Boolean
}, "VTimePickerField"), Rs = K()({
  name: "VTimePickerField",
  props: jO(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    const {
      textColorClasses: a,
      textColorStyles: r
    } = Nt(() => e.color), l = G(), i = ae(!1);
    function o(s) {
      if (["Backspace", "Delete"].includes(s.key)) {
        s.preventDefault();
        const u = s.target;
        u.value = "", n("update:modelValue", null);
      }
    }
    return X(() => y(Kn, {
      ref: l,
      _as: "VTimePickerField",
      autocomplete: "off",
      class: J(["v-time-picker-controls__time__field", {
        "v-time-picker-controls__time__field--active": e.active
      }, e.active ? a.value : []]),
      style: le(e.active ? r.value : []),
      disabled: e.disabled,
      variant: "solo-filled",
      inputmode: "numeric",
      hideDetails: "auto",
      "aria-label": e.label,
      "aria-invalid": !!e.error,
      "aria-errormessage": e.error,
      error: !!e.error,
      hint: e.showHint ? e.label : void 0,
      persistentHint: !0,
      flat: !0,
      modelValue: e.modelValue ?? (i.value ? "" : "--"),
      "onUpdate:modelValue": (s) => n("update:modelValue", s),
      onKeydown: o,
      onFocus: () => i.value = !0,
      onBlur: () => i.value = !1
    }, null)), Mt({}, l);
  }
});
function gn(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
  return String(e).padStart(t, "0");
}
function Tp(e) {
  return e ? (e - 1) % 12 + 1 : 12;
}
function Al(e, t) {
  return e % 12 + (t === "pm" ? 12 : 0);
}
function yl(e) {
  const t = e.replaceAll(/\D/g, "");
  return t.length > 0 ? Number(t) : null;
}
function GO(e, t, n) {
  {
    if (e === 23 && t)
      return {
        value: 0
      };
    if (e === 0 && !t)
      return {
        value: 23
      };
  }
  return {
    value: e + (t ? 1 : -1)
  };
}
function qO(e, t) {
  return e === 59 && t ? 0 : e === 0 && !t ? 59 : e + (t ? 1 : -1);
}
const Ip = U({
  allowedHours: [Function, Array],
  allowedMinutes: [Function, Array],
  allowedSeconds: [Function, Array],
  max: String,
  min: String
}, "time-validation");
function Ap(e) {
  const t = T(() => {
    const l = e.min ? Number(e.min.split(":")[0]) : 0, i = e.max ? Number(e.max.split(":")[0]) : 23;
    return (o) => o < l || o > i ? !1 : Array.isArray(e.allowedHours) ? e.allowedHours.includes(o) : typeof e.allowedHours == "function" ? e.allowedHours(o) : !0;
  }), n = T(() => {
    const [l, i] = e.min ? e.min.split(":").map(Number) : [0, 0], [o, s] = e.max ? e.max.split(":").map(Number) : [23, 59], u = l * 60 + i, c = o * 60 + s;
    return (d, f) => {
      if (d !== null) {
        const v = 60 * d + f;
        if (v < u || v > c) return !1;
      }
      return Array.isArray(e.allowedMinutes) ? e.allowedMinutes.includes(f) : typeof e.allowedMinutes == "function" ? e.allowedMinutes(f) : !0;
    };
  }), a = T(() => {
    const [l, i, o] = e.min ? e.min.split(":").map(Number) : [0, 0, 0], [s, u, c] = e.max ? e.max.split(":").map(Number) : [23, 59, 59], d = l * 3600 + i * 60 + (o || 0), f = s * 3600 + u * 60 + (c || 0);
    return (v, g, m) => {
      if (v !== null && g !== null) {
        const h = 3600 * v + 60 * g + m;
        if (h < d || h > f) return !1;
      }
      return Array.isArray(e.allowedSeconds) ? e.allowedSeconds.includes(m) : typeof e.allowedSeconds == "function" ? e.allowedSeconds(m) : !0;
    };
  });
  function r(l, i, o) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, u = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    const c = l === "hour" ? t.value : l === "minute" ? (v) => n.value(s, v) : (v) => a.value(s, u, v), d = l === "hour" ? (v) => GO(v, o).value : (v) => qO(v, o), f = l === "hour" ? 24 : 60;
    for (let v = 1; v <= f && (i = d(i), !c(i)); v++)
      ;
    return i;
  }
  return {
    isAllowedHour: t,
    isAllowedMinute: n,
    isAllowedSecond: a,
    findNextAllowed: r
  };
}
const YO = U({
  ampm: Boolean,
  color: String,
  disabled: Boolean,
  inputHints: Boolean,
  hour: [Number, String],
  minute: [Number, String],
  second: [Number, String],
  period: String,
  readonly: Boolean,
  useSeconds: Boolean,
  value: Number,
  viewMode: String,
  ...Ip()
}, "VTimePickerControls"), Gu = K()({
  name: "VTimePickerControls",
  props: YO(),
  emits: {
    "update:period": (e) => !0,
    "update:viewMode": (e) => !0,
    "update:hour": (e) => !0,
    "update:minute": (e) => !0,
    "update:second": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    const {
      t: a
    } = Ke(), {
      isAllowedHour: r,
      isAllowedMinute: l,
      isAllowedSecond: i,
      findNextAllowed: o
    } = Ap(e), s = T(() => e.hour !== null ? e.ampm ? Al(Number(e.hour), e.period ?? "am") : Number(e.hour) : null), u = T(() => e.minute !== null ? Number(e.minute) : null), c = T(() => e.hour === null ? !0 : r.value?.(Number(s.value)) ?? !0), d = T(() => e.minute === null ? !0 : l.value?.(s.value, Number(e.minute)) ?? !0), f = T(() => e.second === null ? !0 : i.value?.(s.value, u.value, Number(e.second)) ?? !0), v = {
      in: (E) => {
        if (E == null || isNaN(Number(E))) return null;
        const P = Number(E);
        return e.ampm ? gn(Tp(P)) : gn(P);
      },
      out: (E) => {
        if (isNaN(Number(E)) || E == null || E === "") return null;
        const P = typeof E == "string" ? yl(E) : Number(E);
        return P === null ? null : e.ampm ? Al(P, e.period ?? "am") : Xe(P, 0, 23);
      }
    }, g = he(e, "hour", void 0, v.in, v.out), m = {
      in: (E) => E != null && !isNaN(Number(E)) ? gn(`${E}`) : null,
      out: (E) => {
        if (isNaN(Number(E)) || E == null || E === "") return null;
        const P = typeof E == "string" ? yl(E) : Number(E);
        return P !== null ? Xe(P, 0, 59) : null;
      }
    }, h = he(e, "minute", void 0, m.in, m.out), w = he(e, "second", void 0, m.in, m.out);
    function _(E) {
      if (!["ArrowUp", "ArrowDown"].includes(E.key)) return;
      E.preventDefault(), E.stopPropagation();
      const P = e.period === "am", O = e.ampm ? Al(Number(g.value ?? 0), P ? "am" : "pm") : Number(g.value ?? 0), F = o("hour", O, E.key === "ArrowUp"), B = P && F >= 12 || !P && F < 12;
      e.ampm && B ? (n("update:period", e.period === "am" ? "pm" : "am"), Se(() => g.value = gn(F))) : g.value = gn(F);
    }
    function I(E) {
      if (!["ArrowUp", "ArrowDown"].includes(E.key)) return;
      E.preventDefault(), E.stopPropagation();
      const P = Number(h.value ?? 0), O = o("minute", P, E.key === "ArrowUp", s.value);
      h.value = gn(O);
    }
    function C(E) {
      if (!["ArrowUp", "ArrowDown"].includes(E.key)) return;
      E.preventDefault(), E.stopPropagation();
      const P = Number(w.value ?? 0), O = o("second", P, E.key === "ArrowUp", s.value, u.value);
      w.value = gn(O);
    }
    function b(E, P, O) {
      return (F) => {
        if (!F.data) return;
        const B = F.target, {
          value: N,
          selectionStart: W,
          selectionEnd: R
        } = B ?? {};
        if (yl(F.data) === null) {
          F.preventDefault();
          return;
        }
        const j = N ? N.slice(0, W) + F.data + N.slice(R) : F.data;
        if (j.length > 2) {
          if (W === R && R === 0 && F.data.trim().startsWith("0")) {
            F.preventDefault(), B.value = j.trim().substring(0, 2), O(B.value), F.data.trim().length === 1 && B.setSelectionRange(1, 1);
            return;
          }
          if (W === R && R === 1 && N.startsWith("0")) {
            F.preventDefault(), B.value = j.trim().substring(0, 2), O(B.value);
            return;
          }
          const $ = e.viewMode === "hour" ? e.ampm ? 12 : 23 : 59;
          if (yl(j) > $) {
            F.preventDefault(), B.value = gn(String(yl(F.data)).substring(0, 2)), O(B.value);
            return;
          }
        }
        const H = E(j);
        P(H) && F.preventDefault();
      };
    }
    function p(E) {
      n("update:period", E);
      const P = o("hour", E === "am" ? 23 : 11, !0);
      Se(() => g.value = gn(P));
    }
    const x = G(), k = G(), V = G();
    ne(() => e.viewMode, (E, P) => {
      switch (P) {
        case "hour":
          x.value.blur();
          break;
        case "minute":
          k.value.blur();
          break;
        case "second":
          V.value.blur();
          break;
      }
    });
    const A = b(v.out, (E) => v.in(E) === g.value, (E) => g.value = E), M = b(m.out, (E) => m.in(E) === h.value, (E) => h.value = E), L = b(m.out, (E) => m.in(E) === w.value, (E) => w.value = E);
    return X(() => S("div", {
      class: "v-time-picker-controls"
    }, [S("div", {
      class: J({
        "v-time-picker-controls__time": !0,
        "v-time-picker-controls__time--with-ampm": e.ampm,
        "v-time-picker-controls__time--with-seconds": e.useSeconds
      })
    }, [y(Rs, {
      ref: x,
      active: e.viewMode === "hour",
      color: e.color,
      disabled: e.disabled,
      label: a("$vuetify.timePicker.hour"),
      showHint: e.inputHints,
      error: c.value ? void 0 : a("$vuetify.timePicker.notAllowed"),
      modelValue: g.value,
      "onUpdate:modelValue": (E) => g.value = E,
      onKeydown: _,
      onBeforeinput: A,
      onFocus: () => n("update:viewMode", "hour")
    }, null), S("span", {
      class: "v-time-picker-controls__time__separator"
    }, [we(":")]), y(Rs, {
      ref: k,
      active: e.viewMode === "minute",
      color: e.color,
      disabled: e.disabled,
      label: a("$vuetify.timePicker.minute"),
      showHint: e.inputHints,
      error: d.value ? void 0 : a("$vuetify.timePicker.notAllowed"),
      modelValue: h.value,
      "onUpdate:modelValue": (E) => h.value = E,
      onKeydown: I,
      onBeforeinput: M,
      onFocus: () => n("update:viewMode", "minute")
    }, null), e.useSeconds && S("span", {
      key: "secondsDivider",
      class: "v-time-picker-controls__time__separator"
    }, [we(":")]), e.useSeconds && S(fe, null, [y(Rs, {
      key: "secondsVal",
      ref: V,
      active: e.viewMode === "second",
      color: e.color,
      disabled: e.disabled,
      label: a("$vuetify.timePicker.second"),
      showHint: e.inputHints,
      error: f.value ? void 0 : a("$vuetify.timePicker.notAllowed"),
      modelValue: w.value,
      "onUpdate:modelValue": (E) => w.value = E,
      onKeydown: C,
      onBeforeinput: L,
      onFocus: () => n("update:viewMode", "second")
    }, null)]), e.ampm && S("div", {
      class: "v-time-picker-controls__ampm"
    }, [y(De, {
      active: e.period === "am",
      color: e.period === "am" ? e.color : void 0,
      class: J({
        "v-time-picker-controls__ampm__am": !0,
        "v-time-picker-controls__ampm__btn": !0,
        "v-time-picker-controls__ampm__btn__active": e.period === "am"
      }),
      disabled: e.disabled,
      text: a("$vuetify.timePicker.am"),
      variant: e.disabled && e.period === "am" ? "elevated" : "tonal",
      onClick: () => e.period !== "am" ? p("am") : null
    }, null), y(De, {
      active: e.period === "pm",
      color: e.period === "pm" ? e.color : void 0,
      class: J({
        "v-time-picker-controls__ampm__pm": !0,
        "v-time-picker-controls__ampm__btn": !0,
        "v-time-picker-controls__ampm__btn__active": e.period === "pm"
      }),
      disabled: e.disabled,
      text: a("$vuetify.timePicker.pm"),
      variant: e.disabled && e.period === "pm" ? "elevated" : "tonal",
      onClick: () => e.period !== "pm" ? p("pm") : null
    }, null)])])])), {};
  }
}), KO = U({
  disabled: Boolean,
  format: {
    type: String,
    default: "ampm"
  },
  viewMode: {
    type: String,
    default: "hour"
  },
  period: {
    type: String,
    default: "am",
    validator: (e) => ["am", "pm"].includes(e)
  },
  modelValue: null,
  readonly: Boolean,
  scrollable: Boolean,
  useSeconds: Boolean,
  variant: {
    type: String,
    default: "dial"
  },
  ...Ip(),
  ...Pe(Qo({
    title: "$vuetify.timePicker.title"
  }), ["landscape"]),
  ...mt()
}, "VTimePicker"), ZO = K()({
  name: "VTimePicker",
  props: KO(),
  emits: {
    "update:hour": (e) => !0,
    "update:minute": (e) => !0,
    "update:period": (e) => !0,
    "update:second": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:viewMode": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: a
    } = t;
    const {
      t: r
    } = Ke(), {
      densityClasses: l
    } = zt(e), i = G(null), o = G(null), s = G(null), u = G(null), c = G(null), d = G(null), f = he(e, "period", "am"), v = he(e, "viewMode", "hour"), g = G(null), m = G(null), h = T(() => e.format === "ampm"), {
      isAllowedHour: w,
      isAllowedMinute: _,
      isAllowedSecond: I
    } = Ap(e), C = D(() => e.modelValue !== null && i.value === null && o.value === null && (!e.useSeconds || s.value === null));
    function b() {
      const A = p();
      A !== null && A !== e.modelValue && n("update:modelValue", A), C.value && n("update:modelValue", null);
    }
    ne(i, b), ne(o, b), ne(s, b), ne(() => e.modelValue, (A) => x(A)), ne(() => e.useSeconds, (A, M) => {
      M && !A && v.value === "second" && (v.value = "minute"), !A && s.value !== null && (s.value = null);
    }), bt(() => {
      x(e.modelValue);
    });
    function p() {
      return i.value != null && o.value != null && (!e.useSeconds || s.value != null) ? `${gn(i.value)}:${gn(o.value)}` + (e.useSeconds ? `:${gn(s.value)}` : "") : null;
    }
    function x(A) {
      if (A == null || A === "")
        i.value = null, o.value = null, s.value = null;
      else if (A instanceof Date)
        i.value = A.getHours(), o.value = A.getMinutes(), s.value = A.getSeconds();
      else {
        const [M, , L, , E, P] = A.trim().toLowerCase().match(/^(\d+):(\d+)(:(\d+))?([ap]m)?$/) || new Array(6);
        i.value = P ? Al(parseInt(M, 10), P) : parseInt(M, 10), o.value = parseInt(L, 10), s.value = parseInt(E || 0, 10);
      }
      f.value = i.value == null || i.value < 12 ? "am" : "pm";
    }
    function k(A) {
      v.value === "hour" ? i.value = h.value ? Al(A, f.value) : A : v.value === "minute" ? o.value = A : s.value = A;
    }
    function V(A) {
      switch (v.value || "hour") {
        case "hour":
          n("update:hour", A);
          break;
        case "minute":
          n("update:minute", A);
          break;
        case "second":
          n("update:second", A);
          break;
      }
      const M = i.value !== null && o.value !== null && (e.useSeconds ? s.value !== null : !0);
      v.value === "hour" ? v.value = "minute" : e.useSeconds && v.value === "minute" && (v.value = "second"), !(i.value === u.value && o.value === c.value && (!e.useSeconds || s.value === d.value) || p() === null) && (u.value = i.value, c.value = o.value, e.useSeconds && (d.value = s.value), M && b());
    }
    X(() => {
      const A = Pe(Yr.filterProps(e), ["hideHeader"]), M = Gu.filterProps(e), L = ju.filterProps(Pe(e, ["format", "modelValue", "min", "max"])), E = v.value === "hour" ? w.value : v.value === "minute" ? (P) => _.value(i.value, P) : (P) => I.value(i.value, o.value, P);
      return y(Yr, Y(A, {
        color: void 0,
        class: ["v-time-picker", `v-time-picker--variant-${e.variant}`, e.class, l.value],
        hideHeader: e.hideHeader && e.variant !== "input",
        style: e.style
      }), {
        title: () => a.title?.() ?? S("div", {
          class: "v-time-picker__title"
        }, [r(e.title)]),
        header: () => y(Gu, Y(M, {
          ampm: h.value,
          hour: i.value,
          minute: o.value,
          period: f.value,
          second: s.value,
          viewMode: v.value,
          inputHints: e.variant === "input",
          "onUpdate:hour": (P) => i.value = P,
          "onUpdate:minute": (P) => o.value = P,
          "onUpdate:second": (P) => s.value = P,
          "onUpdate:period": (P) => f.value = P,
          "onUpdate:viewMode": (P) => v.value = P,
          ref: g
        }), null),
        default: () => y(ju, Y(L, {
          allowedValues: E,
          double: v.value === "hour" && !h.value,
          format: v.value === "hour" ? h.value ? Tp : (P) => P : (P) => gn(P, 2),
          max: v.value === "hour" ? h.value && f.value === "am" ? 11 : 23 : 59,
          min: v.value === "hour" && h.value && f.value === "pm" ? 12 : 0,
          size: 20,
          step: v.value === "hour" ? 1 : 5,
          modelValue: v.value === "hour" ? i.value : v.value === "minute" ? o.value : s.value,
          onChange: V,
          onInput: k,
          ref: m
        }), null),
        actions: a.actions
      });
    });
  }
}), JO = U({
  ...ve(),
  ...xn({
    variant: "text"
  })
}, "VToolbarItems"), XO = K()({
  name: "VToolbarItems",
  props: JO(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return vt({
      VBtn: {
        color: D(() => e.color),
        height: "inherit",
        variant: D(() => e.variant)
      }
    }), X(() => S("div", {
      class: J(["v-toolbar-items", e.class]),
      style: le(e.style)
    }, [n.default?.()])), {};
  }
}), QO = U({
  id: String,
  interactive: Boolean,
  text: String,
  ...Pe(fi({
    closeOnBack: !1,
    location: "end",
    locationStrategy: "connected",
    eager: !0,
    minWidth: 0,
    offset: 10,
    openOnClick: !1,
    openOnHover: !0,
    origin: "auto",
    scrim: !1,
    scrollStrategy: "reposition",
    transition: null
  }), ["absolute", "retainFocus", "captureFocus", "disableInitialFocus"])
}, "VTooltip"), Pp = K()({
  name: "VTooltip",
  props: QO(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = he(e, "modelValue"), {
      scopeId: r
    } = gr(), l = Rt(), i = D(() => e.id || `v-tooltip-${l}`), o = G(), s = T(() => e.location.split(" ").length > 1 ? e.location : e.location + " center"), u = T(() => e.origin === "auto" || e.origin === "overlap" || e.origin.split(" ").length > 1 || e.location.split(" ").length > 1 ? e.origin : e.origin + " center"), c = D(() => e.transition != null ? e.transition : a.value ? "scale-transition" : "fade-transition"), d = T(() => Y({
      "aria-describedby": i.value
    }, e.activatorProps));
    return X(() => {
      const f = Yn.filterProps(e);
      return y(Yn, Y({
        ref: o,
        class: ["v-tooltip", {
          "v-tooltip--interactive": e.interactive
        }, e.class],
        style: e.style,
        id: i.value
      }, f, {
        modelValue: a.value,
        "onUpdate:modelValue": (v) => a.value = v,
        transition: c.value,
        absolute: !0,
        location: s.value,
        origin: u.value,
        role: "tooltip",
        activatorProps: d.value,
        _disableGlobalStack: !0
      }, r), {
        activator: n.activator,
        default: function() {
          for (var v = arguments.length, g = new Array(v), m = 0; m < v; m++)
            g[m] = arguments[m];
          return n.default?.(...g) ?? e.text;
        }
      });
    }), Mt({}, o);
  }
}), eD = U({
  ...Pe(ry({
    collapseIcon: "$treeviewCollapse",
    expandIcon: "$treeviewExpand"
  }), ["subgroup"])
}, "VTreeviewGroup"), qu = K()({
  name: "VTreeviewGroup",
  props: eD(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = G(), r = T(() => a.value?.isOpen ? e.collapseIcon : e.expandIcon), l = T(() => ({
      VTreeviewItem: {
        prependIcon: void 0,
        appendIcon: void 0,
        toggleIcon: r.value
      }
    }));
    return X(() => {
      const i = Ul.filterProps(e);
      return y(Ul, Y(i, {
        ref: a,
        class: ["v-treeview-group", e.class],
        subgroup: !0
      }), {
        ...n,
        activator: n.activator ? (o) => S(fe, null, [y(Ae, {
          defaults: l.value
        }, {
          default: () => [n.activator?.(o)]
        })]) : void 0
      });
    }), {};
  }
}), Vp = /* @__PURE__ */ Symbol.for("vuetify:v-treeview"), Ep = U({
  loading: Boolean,
  hideActions: Boolean,
  hasCustomPrepend: Boolean,
  indentLines: Array,
  toggleIcon: be,
  ...oy({
    slim: !0
  })
}, "VTreeviewItem"), Yu = K()({
  name: "VTreeviewItem",
  props: Ep(),
  emits: {
    toggleExpand: (e) => !0
  },
  setup(e, t) {
    let {
      slots: n,
      emit: a
    } = t;
    const r = Le(Vp, {
      visibleIds: G()
    }).visibleIds, l = G(), i = T(() => l.value?.root.activatable.value && l.value?.isGroupActivator), o = T(() => l.value?.link.isClickable.value || e.value != null && !!l.value?.list), s = T(() => !e.disabled && e.link !== !1 && (e.link || o.value || i.value)), u = T(() => r.value && !r.value.has(it(l.value?.id)));
    function c(f) {
      s.value && i.value && l.value?.activate(!l.value?.isActivated, f);
    }
    function d(f) {
      f.preventDefault(), f.stopPropagation(), a("toggleExpand", f);
    }
    return X(() => {
      const f = En.filterProps(e), v = n.prepend || e.toggleIcon || e.indentLines || e.prependIcon || e.prependAvatar;
      return y(En, Y({
        ref: l
      }, f, {
        active: l.value?.isActivated || void 0,
        class: ["v-treeview-item", {
          "v-treeview-item--activatable-group-activator": i.value,
          "v-treeview-item--filtered": u.value
        }, e.class],
        role: "treeitem",
        ripple: !1,
        onClick: c
      }), {
        ...n,
        prepend: v ? (g) => S(fe, null, [e.indentLines && e.indentLines.length > 0 ? S("div", {
          key: "indent-lines",
          class: "v-treeview-indent-lines",
          style: {
            "--v-indent-parts": e.indentLines.length
          }
        }, [e.indentLines.map((m) => S("div", {
          class: J(`v-treeview-indent-line v-treeview-indent-line--${m}`)
        }, null))]) : "", !e.hideActions && y(jc, {
          start: !0
        }, {
          default: () => [e.toggleIcon ? S(fe, null, [n.toggle ? y(Ae, {
            key: "prepend-defaults",
            defaults: {
              VBtn: {
                density: "compact",
                icon: e.toggleIcon,
                variant: "text",
                loading: e.loading
              },
              VProgressCircular: {
                indeterminate: "disable-shrink",
                size: 20,
                width: 2
              }
            }
          }, {
            default: () => [n.toggle({
              ...g,
              loading: e.loading,
              props: {
                onClick: d
              }
            })]
          }) : y(De, {
            key: "prepend-toggle",
            density: "compact",
            icon: e.toggleIcon,
            loading: e.loading,
            variant: "text",
            onClick: d
          }, {
            loader: () => y(Aa, {
              indeterminate: "disable-shrink",
              size: "20",
              width: "2"
            }, null)
          })]) : S("div", {
            class: "v-treeview-item__level"
          }, null)]
        }), e.hasCustomPrepend ? y(Ae, {
          key: "prepend-defaults",
          defaults: {
            VAvatar: {
              density: e.density,
              image: e.appendAvatar
            },
            VIcon: {
              density: e.density,
              icon: e.appendIcon
            },
            VListItemAction: {
              start: !0
            }
          }
        }, {
          default: () => [n.prepend?.(g)]
        }) : S(fe, null, [n.prepend?.(g), e.prependAvatar && y(kn, {
          key: "prepend-avatar",
          density: e.density,
          image: e.prependAvatar
        }, null), e.prependIcon && y(ze, {
          key: "prepend-icon",
          density: e.density,
          icon: e.prependIcon
        }, null)])]) : void 0
      });
    }), Mt({}, l);
  }
}), Mp = U({
  fluid: Boolean,
  disabled: Boolean,
  loadChildren: Function,
  loadingIcon: {
    type: String,
    default: "$loading"
  },
  items: Array,
  openOnClick: {
    type: Boolean,
    default: void 0
  },
  indeterminateIcon: {
    type: be,
    default: "$checkboxIndeterminate"
  },
  falseIcon: be,
  trueIcon: be,
  returnObject: Boolean,
  activatable: Boolean,
  selectable: Boolean,
  selectedColor: String,
  selectStrategy: [String, Function, Object],
  index: Number,
  isLastGroup: Boolean,
  separateRoots: Boolean,
  parentIndentLines: Array,
  indentLinesVariant: String,
  path: {
    type: Array,
    default: () => []
  },
  ...an(Ep(), ["hideActions"]),
  ...mt()
}, "VTreeviewChildren"), ho = K()({
  name: "VTreeviewChildren",
  props: Mp(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = cn(/* @__PURE__ */ new Set()), r = G([]), l = T(() => !e.disabled && (e.openOnClick != null ? e.openOnClick : e.selectable && !e.activatable));
    async function i(s) {
      try {
        if (!e.items?.length || !e.loadChildren) return;
        s?.children?.length === 0 && (a.add(s.value), await e.loadChildren(s.raw));
      } finally {
        a.delete(s.value);
      }
    }
    function o(s, u) {
      e.selectable && s(u);
    }
    return () => n.default?.() ?? e.items?.map((s, u, c) => {
      const {
        children: d,
        props: f
      } = s, v = a.has(s.value), g = !!c.at(u + 1)?.children, m = e.path?.length ?? 0, h = c.length - 1 === u, w = {
        index: u,
        depth: m,
        isFirst: u === 0,
        isLast: h,
        path: [...e.path, u],
        hideAction: e.hideActions
      }, _ = G_({
        depth: m,
        isLast: h,
        isLastGroup: e.isLastGroup,
        leafLinks: !e.hideActions && !e.fluid,
        separateRoots: e.separateRoots,
        parentIndentLines: e.parentIndentLines,
        variant: e.indentLinesVariant
      }), I = {
        toggle: n.toggle ? (x) => n.toggle?.({
          ...x,
          ...w,
          item: s.raw,
          internalItem: s,
          loading: v
        }) : void 0,
        prepend: (x) => S(fe, null, [e.selectable && (!d || d && !["leaf", "single-leaf"].includes(e.selectStrategy)) && y(jc, {
          start: !0
        }, {
          default: () => [y(Un, {
            key: s.value,
            modelValue: x.isSelected,
            disabled: e.disabled || f.disabled,
            loading: v,
            color: e.selectedColor,
            density: e.density,
            indeterminate: x.isIndeterminate,
            indeterminateIcon: e.indeterminateIcon,
            falseIcon: e.falseIcon,
            trueIcon: e.trueIcon,
            "onUpdate:modelValue": (k) => o(x.select, k),
            onClick: (k) => k.stopPropagation(),
            onKeydown: (k) => {
              ["Enter", "Space"].includes(k.key) && (k.stopPropagation(), o(x.select, x.isSelected));
            }
          }, null)]
        }), n.prepend?.({
          ...x,
          ...w,
          item: s.raw,
          internalItem: s
        })]),
        append: n.append ? (x) => n.append?.({
          ...x,
          ...w,
          item: s.raw,
          internalItem: s
        }) : void 0,
        title: n.title ? (x) => n.title?.({
          ...x,
          item: s.raw,
          internalItem: s
        }) : void 0,
        subtitle: n.subtitle ? (x) => n.subtitle?.({
          ...x,
          item: s.raw,
          internalItem: s
        }) : void 0
      }, C = qu.filterProps(f), b = ho.filterProps({
        ...e,
        ...w
      }), p = {
        hideActions: e.hideActions,
        indentLines: _.footer
      };
      return d ? y(qu, Y(C, {
        value: e.returnObject ? s.raw : C?.value,
        rawId: C?.value
      }), {
        activator: (x) => {
          let {
            props: k,
            isOpen: V
          } = x;
          const A = {
            ...f,
            ...k,
            value: f?.value,
            hideActions: e.hideActions,
            indentLines: _.node,
            ariaExpanded: V,
            onToggleExpand: [() => i(s), k.onClick],
            onClick: e.disabled || f.disabled ? void 0 : l.value ? [() => i(s), k.onClick] : () => o(r.value[u]?.select, !r.value[u]?.isSelected)
          };
          return Mi(n.header, {
            props: A,
            item: s.raw,
            internalItem: s,
            loading: v
          }, () => y(Yu, Y({
            ref: (M) => r.value[u] = M
          }, A, {
            hasCustomPrepend: !!n.prepend,
            value: e.returnObject ? s.raw : f.value,
            loading: v
          }), I));
        },
        default: () => S(fe, null, [y(ho, Y(b, {
          items: d,
          indentLinesVariant: e.indentLinesVariant,
          parentIndentLines: _.children,
          isLastGroup: g,
          returnObject: e.returnObject
        }), n), n.footer?.({
          props: p,
          item: s.raw,
          internalItem: s,
          loading: v
        })])
      }) : Mi(n.item, {
        props: f,
        item: s.raw,
        internalItem: s
      }, () => s.type === "divider" ? Mi(n.divider, {
        props: s.raw
      }, () => y(pn, s.props, null)) : s.type === "subheader" ? Mi(n.subheader, {
        props: s.raw
      }, () => y(cl, s.props, null)) : y(Yu, Y(f, {
        hasCustomPrepend: !!n.prepend,
        hideActions: e.hideActions,
        indentLines: _.leaf,
        value: e.returnObject ? it(s.raw) : f.value
      }), I));
    });
  }
});
function Op(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  for (const n of e)
    t.push(n), n.children && Op(n.children, t);
  return t;
}
const tD = U({
  openAll: Boolean,
  indentLines: [Boolean, String],
  indentLinesColor: String,
  indentLinesOpacity: [String, Number],
  search: String,
  hideNoData: Boolean,
  noDataText: {
    type: String,
    default: "$vuetify.noDataText"
  },
  ...yr({
    filterKeys: ["title"]
  }),
  ...Pe(Mp(), ["index", "path", "indentLinesVariant", "parentIndentLines", "isLastGroup"]),
  ...Pe(vy({
    collapseIcon: "$treeviewCollapse",
    expandIcon: "$treeviewExpand",
    slim: !0
  }), ["nav", "openStrategy"]),
  modelValue: Array
}, "VTreeview"), nD = K()({
  name: "VTreeview",
  props: tD(),
  emits: {
    "update:opened": (e) => !0,
    "update:activated": (e) => !0,
    "update:selected": (e) => !0,
    "update:modelValue": (e) => !0,
    "click:open": (e) => !0,
    "click:select": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n,
      emit: a
    } = t;
    const {
      t: r
    } = Ke(), {
      items: l
    } = fy(e), i = D(() => e.activeColor), o = D(() => e.baseColor), s = D(() => e.color), u = he(e, "activated"), c = he(e, "selected"), d = T({
      get: () => e.modelValue ?? c.value,
      set(C) {
        c.value = C, a("update:modelValue", C);
      }
    }), f = G(), v = T(() => e.openAll ? I(l.value) : e.opened), g = T(() => Op(l.value)), m = D(() => e.search), {
      filteredItems: h
    } = br(e, g, m), w = T(() => {
      if (!m.value) return null;
      const C = f.value?.getPath;
      return C ? new Set(h.value.flatMap((b) => {
        const p = e.returnObject ? b.raw : b.props.value;
        return [...C(p), ..._(p)].map(it);
      })) : null;
    });
    function _(C) {
      const b = [], p = (f.value?.children.get(C) ?? []).slice();
      for (; p.length; ) {
        const x = p.shift();
        x && (b.push(x), p.push(...(f.value?.children.get(x) ?? []).slice()));
      }
      return b;
    }
    function I(C) {
      let b = [];
      for (const p of C)
        p.children && (b.push(e.returnObject ? it(p.raw) : p.value), p.children && (b = b.concat(I(p.children))));
      return b;
    }
    return st(Vp, {
      visibleIds: w
    }), vt({
      VTreeviewGroup: {
        activeColor: i,
        baseColor: o,
        color: s,
        collapseIcon: D(() => e.collapseIcon),
        expandIcon: D(() => e.expandIcon)
      },
      VTreeviewItem: {
        activeClass: D(() => e.activeClass),
        activeColor: i,
        baseColor: o,
        color: s,
        density: D(() => e.density),
        disabled: D(() => e.disabled),
        lines: D(() => e.lines),
        variant: D(() => e.variant)
      }
    }), X(() => {
      const C = Gr.filterProps(e), b = ho.filterProps(e), p = typeof e.indentLines == "boolean" ? "default" : e.indentLines;
      return y(Gr, Y({
        ref: f
      }, C, {
        class: ["v-treeview", {
          "v-treeview--fluid": e.fluid
        }, e.class],
        role: "tree",
        openStrategy: "multiple",
        style: [{
          "--v-treeview-indent-line-color": e.indentLinesColor,
          "--v-treeview-indent-line-opacity": e.indentLinesOpacity
        }, e.style],
        opened: v.value,
        activated: u.value,
        "onUpdate:activated": (x) => u.value = x,
        selected: d.value,
        "onUpdate:selected": (x) => d.value = x
      }), {
        default: () => [w.value?.size === 0 && !e.hideNoData && (n["no-data"]?.() ?? y(En, {
          key: "no-data",
          title: r(e.noDataText)
        }, null)), y(ho, Y(b, {
          density: e.density,
          returnObject: e.returnObject,
          items: l.value,
          parentIndentLines: e.indentLines ? [] : void 0,
          indentLinesVariant: p
        }), n)]
      });
    }), {};
  }
}), aD = K()({
  name: "VValidation",
  props: Gg(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const a = qg(e, "validation");
    return () => n.default?.(a);
  }
}), rD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VAlert: XT,
  VAlertTitle: Rg,
  VApp: X_,
  VAppBar: pT,
  VAppBarNavIcon: YT,
  VAppBarTitle: KT,
  VAutocomplete: TA,
  VAvatar: kn,
  VBadge: Py,
  VBanner: VA,
  VBannerActions: Vy,
  VBannerText: Ey,
  VBottomNavigation: MA,
  VBottomSheet: DA,
  VBreadcrumbs: RA,
  VBreadcrumbsDivider: Oy,
  VBreadcrumbsItem: Dy,
  VBtn: De,
  VBtnGroup: hu,
  VBtnToggle: _T,
  VCalendar: UP,
  VCard: qP,
  VCardActions: ab,
  VCardItem: ib,
  VCardSubtitle: rb,
  VCardText: ob,
  VCardTitle: lb,
  VCarousel: nV,
  VCarouselItem: rV,
  VCheckbox: uI,
  VCheckboxBtn: Un,
  VChip: ua,
  VChipGroup: wI,
  VClassIcon: Pg,
  VCode: lV,
  VCol: OE,
  VColorPicker: GV,
  VCombobox: YV,
  VComponentIcon: gu,
  VConfirmEdit: ZV,
  VContainer: PE,
  VCounter: Go,
  VDataIterator: uE,
  VDataTable: xE,
  VDataTableFooter: Hl,
  VDataTableHeaders: ar,
  VDataTableRow: wd,
  VDataTableRows: rr,
  VDataTableServer: IE,
  VDataTableVirtual: _E,
  VDatePicker: jE,
  VDatePickerControls: Nu,
  VDatePickerHeader: Fu,
  VDatePickerMonth: Ru,
  VDatePickerMonths: $u,
  VDatePickerYears: Bu,
  VDefaultsProvider: Ae,
  VDialog: Cu,
  VDialogBottomTransition: nT,
  VDialogTopTransition: aT,
  VDialogTransition: Ro,
  VDivider: pn,
  VEmptyState: qE,
  VExpandBothTransition: dT,
  VExpandTransition: $o,
  VExpandXTransition: Dc,
  VExpansionPanel: YE,
  VExpansionPanelText: Uu,
  VExpansionPanelTitle: Wu,
  VExpansionPanels: JE,
  VFab: QE,
  VFabTransition: tT,
  VFadeTransition: Nl,
  VField: Ea,
  VFieldLabel: Sl,
  VFileInput: lM,
  VFooter: oM,
  VForm: uM,
  VHotkey: vM,
  VHover: hM,
  VIcon: ze,
  VImg: sa,
  VInfiniteScroll: yM,
  VInput: Gt,
  VItem: wM,
  VItemGroup: pM,
  VKbd: Hu,
  VLabel: sl,
  VLayout: SM,
  VLayoutItem: CM,
  VLazy: TM,
  VLigatureIcon: IT,
  VList: Gr,
  VListGroup: Ul,
  VListImg: WI,
  VListItem: En,
  VListItemAction: jc,
  VListItemMedia: jI,
  VListItemSubtitle: ly,
  VListItemTitle: iy,
  VListSubheader: cl,
  VLocaleProvider: AM,
  VMain: VM,
  VMenu: qr,
  VMessages: zg,
  VNavigationDrawer: $M,
  VNoSsr: BM,
  VNumberInput: jM,
  VOtpInput: qM,
  VOverlay: Yn,
  VPagination: Ou,
  VParallax: ZM,
  VProgressCircular: Aa,
  VProgressLinear: Uo,
  VRadio: XM,
  VRadioGroup: eO,
  VRangeSlider: nO,
  VRating: rO,
  VResponsive: fu,
  VRow: BE,
  VScaleTransition: Mc,
  VScrollXReverseTransition: lT,
  VScrollXTransition: rT,
  VScrollYReverseTransition: oT,
  VScrollYTransition: iT,
  VSelect: rd,
  VSelectionControl: Pa,
  VSelectionControlGroup: Wg,
  VSheet: Va,
  VSkeletonLoader: sO,
  VSlideGroup: Bl,
  VSlideGroupItem: uO,
  VSlideXReverseTransition: uT,
  VSlideXTransition: sT,
  VSlideYReverseTransition: cT,
  VSlideYTransition: Oc,
  VSlider: Mu,
  VSnackbar: zu,
  VSnackbarQueue: fO,
  VSpacer: Lu,
  VSparkline: gO,
  VSpeedDial: bO,
  VStepper: _O,
  VStepperActions: gp,
  VStepperHeader: yp,
  VStepperItem: bp,
  VStepperWindow: pp,
  VStepperWindowItem: wp,
  VSvgIcon: Ag,
  VSwitch: IO,
  VSystemBar: PO,
  VTab: Sp,
  VTable: lr,
  VTabs: DO,
  VTabsWindow: xp,
  VTabsWindowItem: Cp,
  VTextField: Kn,
  VTextarea: NO,
  VThemeProvider: RO,
  VTimePicker: ZO,
  VTimePickerClock: ju,
  VTimePickerControls: Gu,
  VTimeline: HO,
  VTimelineItem: UO,
  VToolbar: mu,
  VToolbarItems: XO,
  VToolbarTitle: Pc,
  VTooltip: Pp,
  VTreeview: nD,
  VTreeviewGroup: qu,
  VTreeviewItem: Yu,
  VValidation: aD,
  VVirtualScroll: qo,
  VWindow: tr,
  VWindowItem: nr
}, Symbol.toStringTag, { value: "Module" }));
function lD(e, t) {
  const n = t.modifiers || {}, a = t.value, {
    once: r,
    immediate: l,
    ...i
  } = n, o = !Object.keys(i).length, {
    handler: s,
    options: u
  } = typeof a == "object" ? a : {
    handler: a,
    options: {
      attributes: i?.attr ?? o,
      characterData: i?.char ?? o,
      childList: i?.child ?? o,
      subtree: i?.sub ?? o
    }
  }, c = new MutationObserver(function() {
    let d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], f = arguments.length > 1 ? arguments[1] : void 0;
    s?.(d, f), r && Dp(e, t);
  });
  l && s?.([], c), e._mutate = Object(e._mutate), e._mutate[t.instance.$.uid] = {
    observer: c
  }, c.observe(e, u);
}
function Dp(e, t) {
  e._mutate?.[t.instance.$.uid] && (e._mutate[t.instance.$.uid].observer.disconnect(), delete e._mutate[t.instance.$.uid]);
}
const iD = {
  mounted: lD,
  unmounted: Dp
};
function Lp(e, t) {
  const {
    self: n = !1
  } = t.modifiers ?? {}, a = t.value, r = typeof a == "object" && a.options || {
    passive: !0
  }, l = typeof a == "function" || "handleEvent" in a ? a : a.handler, i = n ? e : t.arg ? document.querySelector(t.arg) : window;
  i && (i.addEventListener("scroll", l, r), e._onScroll = Object(e._onScroll), e._onScroll[t.instance.$.uid] = {
    handler: l,
    options: r,
    // Don't reference self
    target: n ? void 0 : i
  });
}
function Np(e, t) {
  if (!e._onScroll?.[t.instance.$.uid]) return;
  const {
    handler: n,
    options: a,
    target: r = e
  } = e._onScroll[t.instance.$.uid];
  r.removeEventListener("scroll", n, a), delete e._onScroll[t.instance.$.uid];
}
function oD(e, t) {
  t.value !== t.oldValue && (Np(e, t), Lp(e, t));
}
const sD = {
  mounted: Lp,
  unmounted: Np,
  updated: oD
};
function uD(e, t) {
  const n = typeof e == "string" ? de(e) : e, a = cD(n, t);
  return {
    mounted: a,
    updated: a,
    unmounted(r) {
      um(null, r);
    }
  };
}
function cD(e, t) {
  return function(n, a, r) {
    const l = typeof t == "function" ? t(a) : t, i = a.value?.text ?? a.value ?? l?.text, o = Qa(a.value) ? a.value : {}, s = () => i ?? n.textContent, u = (r.ctx === a.instance.$ ? dD(r, a.instance.$)?.provides : r.ctx?.provides) ?? a.instance.$.provides, c = Oa(e, Y(l, o), s);
    c.appContext = Object.assign(/* @__PURE__ */ Object.create(null), a.instance.$.appContext, {
      provides: u
    }), um(c, n);
  };
}
function dD(e, t) {
  const n = /* @__PURE__ */ new Set(), a = (l) => {
    for (const i of l) {
      if (!i) continue;
      if (i === e || i.el && e.el && i.el === e.el)
        return !0;
      n.add(i);
      let o;
      if (i.suspense ? o = a([i.ssContent]) : Array.isArray(i.children) ? o = a(i.children) : i.component?.vnode && (o = a([i.component?.subTree])), o)
        return o;
      n.delete(i);
    }
    return !1;
  };
  if (!a([t.subTree]))
    return ni("Could not find original vnode, component will not inherit provides"), t;
  const r = Array.from(n).reverse();
  for (const l of r)
    if (l.component)
      return l.component;
  return t;
}
const fD = uD(Pp, (e) => ({
  activator: (Qa(e.value) ? !e.value.text : ["", !1, null].includes(e.value)) ? null : "parent",
  location: e.arg?.replace("-", " "),
  text: typeof e.value == "boolean" ? void 0 : e.value
})), vD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ClickOutside: xu,
  Intersect: Bn,
  Mutate: iD,
  Resize: Wl,
  Ripple: Ht,
  Scroll: sD,
  Tooltip: fD,
  Touch: mo
}, Symbol.toStringTag, { value: "Module" })), mD = {
  collapse: "mdi-chevron-up",
  complete: "mdi-check",
  cancel: "mdi-close-circle",
  close: "mdi-close",
  delete: "mdi-close-circle",
  // delete (e.g. v-chip close)
  clear: "mdi-close-circle",
  success: "mdi-check-circle",
  info: "mdi-information",
  warning: "mdi-alert-circle",
  error: "mdi-close-circle",
  prev: "mdi-chevron-left",
  next: "mdi-chevron-right",
  checkboxOn: "mdi-checkbox-marked",
  checkboxOff: "mdi-checkbox-blank-outline",
  checkboxIndeterminate: "mdi-minus-box",
  delimiter: "mdi-circle",
  // for carousel
  sortAsc: "mdi-arrow-up",
  sortDesc: "mdi-arrow-down",
  expand: "mdi-chevron-down",
  menu: "mdi-menu",
  subgroup: "mdi-menu-down",
  dropdown: "mdi-menu-down",
  radioOn: "mdi-radiobox-marked",
  radioOff: "mdi-radiobox-blank",
  edit: "mdi-pencil",
  ratingEmpty: "mdi-star-outline",
  ratingFull: "mdi-star",
  ratingHalf: "mdi-star-half-full",
  loading: "mdi-cached",
  first: "mdi-page-first",
  last: "mdi-page-last",
  unfold: "mdi-unfold-more-horizontal",
  file: "mdi-paperclip",
  plus: "mdi-plus",
  minus: "mdi-minus",
  calendar: "mdi-calendar",
  treeviewCollapse: "mdi-menu-down",
  treeviewExpand: "mdi-menu-right",
  tableGroupCollapse: "mdi-chevron-down",
  tableGroupExpand: "mdi-chevron-right",
  eyeDropper: "mdi-eyedropper",
  upload: "mdi-cloud-upload",
  color: "mdi-palette",
  command: "mdi-apple-keyboard-command",
  ctrl: "mdi-apple-keyboard-control",
  space: "mdi-keyboard-space",
  shift: "mdi-apple-keyboard-shift",
  alt: "mdi-apple-keyboard-option",
  enter: "mdi-keyboard-return",
  arrowup: "mdi-arrow-up",
  arrowdown: "mdi-arrow-down",
  arrowleft: "mdi-arrow-left",
  arrowright: "mdi-arrow-right",
  backspace: "mdi-backspace",
  play: "mdi-play",
  pause: "mdi-pause",
  fullscreen: "mdi-fullscreen",
  fullscreenExit: "mdi-fullscreen-exit",
  volumeHigh: "mdi-volume-high",
  volumeMedium: "mdi-volume-medium",
  volumeLow: "mdi-volume-low",
  volumeOff: "mdi-volume-variant-off",
  search: "mdi-magnify"
}, hD = {
  // Not using mergeProps here, functional components merge props by default (?)
  component: (e) => Oa(Pg, {
    ...e,
    class: "mdi"
  })
};
function $s(e, t, n) {
  const a = he(e, t);
  return a.value = e[t] ?? n.value, ne(n, (r) => {
    e[t] == null && (a.value = r);
  }), a;
}
function Fp(e) {
  return e(0.1).includes(",") ? "," : ".";
}
function Rp(e) {
  return (t) => {
    const n = $s(t, "locale", e.current), a = $s(t, "fallback", e.fallback), r = $s(t, "messages", e.messages), l = e.useI18n({
      locale: n.value,
      fallbackLocale: a.value,
      messages: r.value,
      useScope: "local",
      legacy: !1,
      inheritLocale: !1
    });
    return ne(n, (i) => {
      l.locale.value = i;
    }), {
      name: "vue-i18n",
      current: n,
      fallback: a,
      messages: r,
      decimalSeparator: D(() => t.decimalSeparator ?? Fp(l.n)),
      t: function(i) {
        for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), u = 1; u < o; u++)
          s[u - 1] = arguments[u];
        return l.t(i, s);
      },
      n: l.n,
      provide: Rp({
        current: n,
        fallback: a,
        messages: r,
        useI18n: e.useI18n
      })
    };
  };
}
function gD(e) {
  let {
    i18n: t,
    useI18n: n
  } = e;
  const a = t.global.locale, r = t.global.fallbackLocale, l = t.global.messages;
  return {
    name: "vue-i18n",
    current: a,
    fallback: r,
    messages: l,
    decimalSeparator: D(() => Fp(t.global.n)),
    t: function(i) {
      for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), u = 1; u < o; u++)
        s[u - 1] = arguments[u];
      return t.global.t(i, s);
    },
    n: t.global.n,
    provide: Rp({
      current: a,
      fallback: r,
      messages: l,
      useI18n: n
    })
  };
}
function VL(e) {
  const t = nw({
    components: rD,
    directives: vD,
    icons: {
      defaultSet: "mdi",
      aliases: mD,
      sets: {
        mdi: hD
      }
    },
    theme: {
      defaultTheme: "light",
      themes: {
        light: {
          colors: {
            primary: Bt.lightBlue.lighten3,
            secondary: Bt.green.lighten3,
            accent: Bt.pink.lighten4,
            background: Bt.grey.lighten5,
            surface: "#FFFFFF",
            error: Bt.red.accent1,
            info: Bt.lightBlue.accent1,
            success: Bt.green.accent3,
            warning: Bt.orange.darken3
          }
        },
        dark: {
          colors: {
            primary: Bt.lightBlue.darken2,
            secondary: Bt.green.darken2,
            accent: Bt.pink.lighten3,
            background: Bt.blueGrey.darken4,
            surface: Bt.blueGrey.darken3,
            error: Bt.red.accent1,
            info: Bt.lightBlue.accent1,
            success: Bt.green.accent3,
            warning: Bt.amber.lighten2
          }
        }
      }
    },
    locale: {
      adapter: gD({ i18n: e, useI18n: mn })
    }
  });
  return {
    ...t,
    install(n, ...a) {
      t.install(n);
    }
  };
}
const yD = {}, bD = { class: "about" };
function pD(e, t) {
  return ge(), yt("div", bD, [...t[0] || (t[0] = [
    S("h1", null, "This is an about page", -1)
  ])]);
}
const wD = /* @__PURE__ */ Zn(yD, [["render", pD]]), kD = /* @__PURE__ */ Qt({
  __name: "HomePage",
  setup(e) {
    const { t } = mn(), n = T(() => [
      t("home.taskExample1"),
      t("home.taskExample2"),
      t("home.taskExample3"),
      t("home.taskExample4")
    ]), a = G(Math.floor(Math.random() * n.value.length)), r = T(() => [t("home.beeText1"), t("home.beeText2"), t("home.beeText3")]), l = G(Math.floor(Math.random() * r.value.length)), i = T(() => n.value[a.value]), o = G(new wa()), s = G(!1), u = T(() => r.value[l.value]), c = () => {
      a.value = (a.value + 1) % n.value.length;
    }, d = MC();
    bt(async () => {
      const v = setInterval(c, 3e3);
      setTimeout(() => {
        s.value = !0;
      }, 2e3);
      const g = setInterval(async () => {
        s.value = !1, setTimeout(() => {
          l.value = (l.value + 1) % r.value.length, s.value = !0;
        }, 2e3);
      }, 15e3);
      Ft(() => {
        clearInterval(v), clearInterval(g);
      });
    });
    const f = async () => {
      try {
        await d.taleService.createTale(o.value);
      } catch {
        Vr().queueMessage({
          type: "error",
          title: t("general.error"),
          message: t("home.errorCreatingTale")
        });
      }
      o.value = new wa();
    };
    return (v, g) => {
      const m = de("v-card-title"), h = de("v-img"), w = de("v-tooltip"), _ = de("v-card-text"), I = de("v-btn"), C = de("v-text-field"), b = de("v-card-actions"), p = de("v-card"), x = de("v-container");
      return ge(), _e(x, { "fill-height": "" }, {
        default: q(() => [
          y(p, {
            class: "mx-auto",
            variant: "elevated",
            "max-width": "400"
          }, {
            default: q(() => [
              y(m, { class: "d-flex justify-center text-h5" }, {
                default: q(() => [
                  we(ce(Z(t)("home.welcome")), 1)
                ]),
                _: 1
              }),
              y(_, { class: "text-h5" }, {
                default: q(() => [
                  y(w, {
                    location: "right top",
                    "max-width": "200",
                    modelValue: s.value,
                    "onUpdate:modelValue": g[0] || (g[0] = (k) => s.value = k),
                    text: u.value
                  }, {
                    activator: q(({ props: k }) => [
                      y(h, Y(k, {
                        src: "/bee.gif",
                        alt: "Cute Bee",
                        width: "150",
                        height: "150"
                      }), null, 16)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "text"])
                ]),
                _: 1
              }),
              y(b, null, {
                default: q(() => [
                  y(C, {
                    modelValue: o.value.title,
                    "onUpdate:modelValue": g[1] || (g[1] = (k) => o.value.title = k),
                    label: Z(t)("home.task"),
                    hint: i.value + " ...",
                    "persistent-hint": !0,
                    variant: "solo-filled"
                  }, {
                    "append-inner": q(() => [
                      y(I, {
                        onClick: f,
                        color: "primary",
                        variant: "flat",
                        class: "text-none"
                      }, {
                        default: q(() => [
                          we(ce(Z(t)("general.create")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label", "hint"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), SD = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 300",
  class: "missing-cat-poster"
}, xD = {
  x: "50%",
  y: "160",
  "text-anchor": "middle",
  "font-size": "18",
  "font-family": "Arial, sans-serif",
  fill: "black",
  "font-weight": "bold"
}, CD = {
  x: "50%",
  y: "190",
  "text-anchor": "middle",
  "font-size": "14",
  "font-family": "Arial, sans-serif",
  fill: "black"
}, _D = {
  "data-v-1f6ffa4c": "",
  x: "50%",
  y: "210",
  "text-anchor": "middle",
  "font-size": "14",
  "font-family": "Arial, sans-serif",
  fill: "black"
}, TD = {
  x: "50%",
  y: "250",
  "text-anchor": "middle",
  "font-size": "16",
  "font-family": "Arial, sans-serif",
  fill: "red",
  "font-weight": "bold"
}, ID = { class: "display-1 font-weight-bold mt-5" }, AD = { class: "subheading" }, PD = /* @__PURE__ */ Qt({
  __name: "NotFoundPage",
  setup(e) {
    const { t } = mn(), n = Jr(), a = () => {
      n.push({ name: gt.HOME });
    };
    return (r, l) => {
      const i = de("v-btn"), o = de("v-col"), s = de("v-row"), u = de("v-container");
      return ge(), _e(u, {
        class: "d-flex align-center justify-center",
        style: { height: "100vh" }
      }, {
        default: q(() => [
          y(s, {
            align: "center",
            justify: "center",
            class: "text-center"
          }, {
            default: q(() => [
              y(o, {
                cols: "12",
                md: "8"
              }, {
                default: q(() => [
                  (ge(), yt("svg", SD, [
                    l[0] || (l[0] = S("rect", {
                      x: "10",
                      y: "10",
                      width: "180",
                      height: "280",
                      rx: "15",
                      ry: "15",
                      fill: "white",
                      stroke: "black",
                      "stroke-width": "2"
                    }, null, -1)),
                    l[1] || (l[1] = S("circle", {
                      cx: "100",
                      cy: "100",
                      r: "30",
                      fill: "gray"
                    }, null, -1)),
                    l[2] || (l[2] = S("circle", {
                      cx: "85",
                      cy: "90",
                      r: "5",
                      fill: "white"
                    }, null, -1)),
                    l[3] || (l[3] = S("circle", {
                      cx: "115",
                      cy: "90",
                      r: "5",
                      fill: "white"
                    }, null, -1)),
                    l[4] || (l[4] = S("path", {
                      d: "M 90 110 Q 100 120 110 110",
                      stroke: "black",
                      "stroke-width": "2",
                      fill: "transparent"
                    }, null, -1)),
                    S("text", xD, ce(Z(t)("notfound.missingCat")), 1),
                    S("text", CD, ce(Z(t)("notfound.ifFound1")), 1),
                    S("text", _D, ce(Z(t)("notfound.ifFound2")), 1),
                    S("text", TD, [
                      S("tspan", null, ce(Z(t)("notfound.error")), 1)
                    ])
                  ])),
                  S("h1", ID, ce(Z(t)("notfound.oops")), 1),
                  S("p", AD, ce(Z(t)("notfound.errorDetails")), 1),
                  y(i, {
                    color: "primary",
                    large: "",
                    class: "mt-4",
                    onClick: a
                  }, {
                    default: q(() => [
                      we(ce(Z(t)("general.goBackHome")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), VD = /* @__PURE__ */ Zn(PD, [["__scopeId", "data-v-08d6e9cc"]]), ED = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  class: "dog-chasing-tail-svg"
}, MD = {
  x: "50%",
  y: "180",
  "text-anchor": "middle",
  "font-size": "18",
  "font-family": "Arial, sans-serif",
  fill: "black",
  "font-weight": "bold"
}, OD = {
  x: "50%",
  y: "200",
  "text-anchor": "middle",
  "font-size": "16",
  "font-family": "Arial, sans-serif",
  fill: "red"
}, DD = { class: "display-1 font-weight-bold mt-5" }, LD = { class: "subheading" }, ND = /* @__PURE__ */ Qt({
  __name: "UnexpectedErrorPage",
  setup(e) {
    const { t } = mn(), n = Jr(), a = () => {
      n.push({ name: gt.HOME });
    };
    return (r, l) => {
      const i = de("v-btn"), o = de("v-col"), s = de("v-row"), u = de("v-container");
      return ge(), _e(u, {
        class: "d-flex align-center justify-center",
        style: { height: "100vh" }
      }, {
        default: q(() => [
          y(s, {
            align: "center",
            justify: "center",
            class: "text-center"
          }, {
            default: q(() => [
              y(o, {
                cols: "12",
                md: "8"
              }, {
                default: q(() => [
                  (ge(), yt("svg", ED, [
                    l[0] || (l[0] = S("circle", {
                      cx: "100",
                      cy: "100",
                      r: "40",
                      fill: "saddlebrown"
                    }, null, -1)),
                    l[1] || (l[1] = S("circle", {
                      cx: "130",
                      cy: "70",
                      r: "20",
                      fill: "saddlebrown"
                    }, null, -1)),
                    l[2] || (l[2] = S("circle", {
                      cx: "137",
                      cy: "65",
                      r: "5",
                      fill: "white"
                    }, null, -1)),
                    l[3] || (l[3] = S("circle", {
                      cx: "123",
                      cy: "65",
                      r: "5",
                      fill: "white"
                    }, null, -1)),
                    l[4] || (l[4] = S("circle", {
                      cx: "130",
                      cy: "80",
                      r: "5",
                      fill: "black"
                    }, null, -1)),
                    l[5] || (l[5] = S("path", {
                      d: "M 100 130 Q 120 140 140 120",
                      fill: "transparent",
                      stroke: "saddlebrown",
                      "stroke-width": "6"
                    }, [
                      S("animate", {
                        attributeName: "d",
                        values: "M 100 130 Q 120 140 140 120; M 100 130 Q 140 150 160 130; M 100 130 Q 120 140 140 120",
                        dur: "1.5s",
                        repeatCount: "indefinite"
                      })
                    ], -1)),
                    l[6] || (l[6] = S("circle", {
                      cx: "75",
                      cy: "135",
                      r: "10",
                      fill: "saddlebrown"
                    }, null, -1)),
                    l[7] || (l[7] = S("circle", {
                      cx: "125",
                      cy: "135",
                      r: "10",
                      fill: "saddlebrown"
                    }, null, -1)),
                    l[8] || (l[8] = S("path", {
                      d: "M 140 50 Q 150 40 160 50",
                      fill: "saddlebrown"
                    }, null, -1)),
                    l[9] || (l[9] = S("path", {
                      d: "M 120 50 Q 110 40 100 50",
                      fill: "saddlebrown"
                    }, null, -1)),
                    S("text", MD, ce(Z(t)("unexpected.oops")), 1),
                    S("text", OD, ce(Z(t)("unexpected.error")), 1)
                  ])),
                  S("h1", DD, ce(Z(t)("unexpected.error")), 1),
                  S("p", LD, ce(Z(t)("unexpected.errorDetails")), 1),
                  y(i, {
                    color: "red",
                    large: "",
                    class: "mt-4",
                    onClick: a
                  }, {
                    default: q(() => [
                      we(ce(Z(t)("general.goBackHome")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), FD = /* @__PURE__ */ Zn(ND, [["__scopeId", "data-v-a323f450"]]), RD = /* @__PURE__ */ Qt({
  __name: "TeamManagement",
  setup(e) {
    const { t } = mn(), n = Ju(), a = Jr(), r = Le("serviceStore"), l = G(!1), i = G(n.params.teamId);
    ne(
      () => n.params.teamId,
      (C) => {
        i.value = C, v(), m();
      }
    );
    const o = G(null), s = G({
      items: [],
      total: 0,
      page: 0,
      itemsPerPage: 10,
      totalFiltered: 0
    }), u = G(!1), c = G(Ga.emtpy()), d = G(!1), f = G(""), v = async () => {
      r && (o.value = await r.teamService.getTeam(i.value), f.value = o.value?.name ?? "");
    }, g = async () => {
      if (!r)
        return;
      l.value = !0, await r.teamService.deleteTeam(i.value);
      const C = _l();
      C.resetTeams(), await C.selectTeam(r, null), await C.loadTeams(r, 0, C.workspace), l.value = !1, C.workspace?.id ? await a.push({
        name: gt.WORKSPACE_MANAGEMENT,
        params: { workspaceId: C.workspace.id }
      }) : await a.push({ name: gt.HOME });
    }, m = async (C = 0) => {
      r && (l.value = !0, s.value = await r.teamService.getTeamMembers(
        i.value,
        C,
        s.value.itemsPerPage
      ), l.value = !1);
    }, h = async () => {
      r && (l.value = !0, await r.teamService.addTeamMember(i.value, c.value), await m(), l.value = !1, u.value = !1, c.value = Ga.emtpy());
    }, w = async (C) => {
      r && (l.value = !0, await r.teamService.updateTeamMember(i.value, C.id, C), m(), l.value = !1);
    }, _ = async (C) => {
      r && (l.value = !0, await r.teamService.removeTeamMember(i.value, C), m(), l.value = !1);
    }, I = async () => {
      o.value && r && (l.value = !0, o.value.name = f.value, await r.teamService.updateTeam(i.value, o.value), await v(), l.value = !1, d.value = !1);
    };
    return bt(() => {
      v(), m();
    }), (C, b) => {
      const p = de("v-progress-linear"), x = de("v-card-title"), k = de("v-card-text"), V = de("v-card"), A = de("v-col"), M = de("v-row"), L = de("v-btn"), E = de("v-icon"), P = de("v-btn-group"), O = de("v-pagination"), F = de("v-text-field"), B = de("v-spacer"), N = de("v-card-actions"), W = de("v-dialog"), R = de("v-container");
      return ge(), _e(R, null, {
        default: q(() => [
          l.value ? (ge(), _e(p, {
            key: 0,
            color: "primary",
            indeterminate: "",
            height: 12
          })) : ot("", !0),
          u.value ? (ge(), _e(M, { key: 1 }, {
            default: q(() => [
              y(A, { cols: "12" }, {
                default: q(() => [
                  y(V, null, {
                    default: q(() => [
                      y(x, null, {
                        default: q(() => [
                          we(ce(Z(t)("teamManagement.newTeamMember")), 1)
                        ]),
                        _: 1
                      }),
                      y(k, null, {
                        default: q(() => [
                          y(Pl, {
                            member: c.value,
                            "onAdd:member": h,
                            "onCancel:member": b[0] || (b[0] = (j) => u.value = !1)
                          }, null, 8, ["member"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : ot("", !0),
          u.value ? ot("", !0) : (ge(), _e(M, { key: 2 }, {
            default: q(() => [
              y(A, { cols: "12" }, {
                default: q(() => [
                  y(V, null, cm({
                    title: q(() => [
                      we(ce(Z(t)("teamManagement.title")), 1)
                    ]),
                    append: q(() => [
                      y(P, null, {
                        default: q(() => [
                          y(L, {
                            icon: "",
                            onClick: b[2] || (b[2] = (j) => u.value = !0)
                          }, {
                            default: q(() => [
                              y(E, null, {
                                default: q(() => [...b[7] || (b[7] = [
                                  we("mdi-account-multiple-plus", -1)
                                ])]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          y(L, {
                            icon: "",
                            onClick: g
                          }, {
                            default: q(() => [
                              y(E, null, {
                                default: q(() => [...b[8] || (b[8] = [
                                  we("mdi-delete", -1)
                                ])]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: q(() => [
                      y(x),
                      y(k, null, {
                        default: q(() => [
                          y(M, {
                            align: "center",
                            class: "mb-2"
                          }, {
                            default: q(() => [
                              y(A, {
                                sm: "6",
                                md: "4",
                                lg: "3"
                              }, {
                                default: q(() => [
                                  S("h2", null, ce(Z(t)("teamManagement.members")), 1)
                                ]),
                                _: 1
                              }),
                              y(A, { md: "2" }, {
                                default: q(() => [
                                  S("p", null, ce(Z(t)("teamManagement.totalMembers")) + ": " + ce(s.value.total), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (ge(!0), yt(fe, null, ia(s.value.items, (j) => (ge(), _e(Pl, {
                            key: j.id,
                            member: j,
                            "onUpdate:member": w,
                            "onRemove:member": _,
                            class: "mb-4"
                          }, null, 8, ["member"]))), 128)),
                          y(O, {
                            page: s.value.page,
                            "onUpdate:page": b[3] || (b[3] = (j) => s.value.page = j),
                            length: Math.ceil(s.value.total / s.value.itemsPerPage),
                            onInput: m
                          }, null, 8, ["page", "length"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, [
                    o.value ? {
                      name: "subtitle",
                      fn: q(() => [
                        y(M, { align: "center" }, {
                          default: q(() => [
                            y(A, null, {
                              default: q(() => [
                                we(ce(Z(t)("general.name")) + ": " + ce(o.value.name) + " ", 1),
                                y(L, {
                                  icon: "mdi-pencil",
                                  size: "x-small",
                                  onClick: b[1] || (b[1] = (j) => d.value = !0)
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      key: "0"
                    } : void 0
                  ]), 1024)
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
          y(W, {
            modelValue: d.value,
            "onUpdate:modelValue": b[6] || (b[6] = (j) => d.value = j),
            "max-width": "500px"
          }, {
            default: q(() => [
              y(V, null, {
                default: q(() => [
                  y(x, null, {
                    default: q(() => [
                      we(ce(Z(t)("teamManagement.editTeamName")), 1)
                    ]),
                    _: 1
                  }),
                  y(k, null, {
                    default: q(() => [
                      y(F, {
                        modelValue: f.value,
                        "onUpdate:modelValue": b[4] || (b[4] = (j) => f.value = j),
                        label: Z(t)("general.name")
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _: 1
                  }),
                  y(N, null, {
                    default: q(() => [
                      y(B),
                      y(L, {
                        color: "secondary",
                        variant: "flat",
                        onClick: b[5] || (b[5] = (j) => d.value = !1)
                      }, {
                        default: q(() => [
                          we(ce(Z(t)("general.cancel")), 1)
                        ]),
                        _: 1
                      }),
                      y(L, {
                        color: "primary",
                        variant: "flat",
                        onClick: I
                      }, {
                        default: q(() => [
                          we(ce(Z(t)("general.save")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      });
    };
  }
}), $D = { class: "mb-4" }, BD = { key: 0 }, UD = { key: 1 }, WD = { class: "text-h4" }, HD = { class: "text-h6" }, zD = { class: "text-medium-emphasis text-caption" }, jD = { class: "text-h5 text-medium-emphasis ps-2" }, GD = { class: "text-medium-emphasis mb-4" }, qD = { class: "mb-2" }, YD = /* @__PURE__ */ Qt({
  __name: "WorkspaceManagement",
  setup(e) {
    const { t } = mn(), n = Ju(), a = Jr(), r = Le("serviceStore"), l = G(!1), i = G(n.params.workspaceId), o = G("");
    ne(
      () => n.params.workspaceId,
      async (P) => {
        P && (i.value = P, await I(), await b(), await p(), await x());
      }
    );
    const s = G(null), u = G({
      items: [],
      total: 0,
      page: 0,
      itemsPerPage: 10,
      totalFiltered: 0
    }), c = G({
      items: [],
      total: 0,
      page: 0,
      itemsPerPage: 10,
      totalFiltered: 0
    }), d = G({
      items: [],
      total: 0,
      page: 0,
      itemsPerPage: 10,
      totalFiltered: 0
    }), f = G(!1), v = G(Cl.emtpy()), g = G(!1), m = G(!1), h = G(""), w = () => {
      o.value = "";
    }, _ = async () => {
      if (!o.value || !r)
        return;
      const P = new pa();
      P.name = o.value, P.workspace = s.value;
      try {
        const O = await r.teamService.createTeam(P);
        w(), await r.teamService.addTeamToWorkspace(O, s.value);
        const F = _l();
        F.resetTeams(), await F.loadTeams(r, 0, s.value), await F.selectWorkspace(r, s.value), await F.selectTeam(r, O), g.value = !1, p(0);
      } catch (O) {
        console.error("Failed to create team", O);
      }
    }, I = async () => {
      r && (s.value = await r.workspaceService.getWorkspace(i.value), h.value = s.value?.name ?? "");
    }, C = async () => {
      if (!s.value || !r)
        return;
      l.value = !0, await r.workspaceService.deleteWorkspace(i.value);
      const P = _l();
      P.resetWorkspaces(), await P.selectWorkspace(r, null), P.loadWorkspaces(r, 0), await a.push({ name: gt.HOME }), l.value = !1;
    }, b = async (P = 0) => {
      !s.value || !r || (l.value = !0, u.value = await r.workspaceService.getWorkspaceMembers(
        i.value,
        P,
        u.value.itemsPerPage
      ), l.value = !1);
    }, p = async (P = 0) => {
      !s.value || !r || (l.value = !0, c.value = await r.teamService.getTeams(
        P,
        c.value.itemsPerPage,
        s.value
      ), l.value = !1);
    }, x = async (P = 0) => {
      !s.value || !r || (l.value = !0, d.value = await r.teamService.getTeams(P, d.value.itemsPerPage), l.value = !1);
    }, k = async () => {
      !s.value || !r || (l.value = !0, await r.workspaceService.addWorkspaceMember(i.value, v.value), await b(u.value.page), l.value = !1, f.value = !1, v.value = Cl.emtpy());
    }, V = async (P) => {
      !P.id || !r || (l.value = !0, await r.workspaceService.updateWorkspaceMember(
        i.value,
        P.id,
        P
      ), await b(u.value.page), l.value = !1);
    }, A = async (P) => {
      !s.value || !r || (l.value = !0, await r.workspaceService.removeWorkspaceMember(i.value, P), await b(u.value.page), l.value = !1);
    }, M = async (P) => {
      !s.value || !r || (l.value = !0, await r.teamService.addTeamToWorkspace(P, s.value), await p(c.value.page), await x(d.value.page), d.value.items.length < 1 && (g.value = !1), l.value = !1);
    }, L = async (P) => {
      if (!s.value || !r)
        return;
      l.value = !0, await r.teamService.removeTeamFromWorkspace(P, s.value), await p(c.value.page), await x(d.value.page);
      const O = _l();
      O.resetTeams(), await O.loadTeams(r, 0, s.value), l.value = !1;
    }, E = async () => {
      s.value && r && (l.value = !0, s.value.name = h.value, await r.workspaceService.updateWorkspace(i.value, s.value), await I(), l.value = !1, m.value = !1);
    };
    return bt(async () => {
      await I(), await b(), await p(), await x();
    }), (P, O) => {
      const F = de("v-progress-linear"), B = de("v-card-title"), N = de("v-card-text"), W = de("v-card"), R = de("v-col"), j = de("v-row"), H = de("v-btn"), $ = de("v-icon"), z = de("v-btn-group"), te = de("v-pagination"), me = de("v-empty-state"), Q = de("v-list-item"), ie = de("v-list"), ke = de("v-divider"), ye = de("v-text-field"), ue = de("v-card-actions"), Te = de("v-dialog"), Ne = de("v-spacer"), je = de("v-container");
      return ge(), _e(je, null, {
        default: q(() => [
          l.value ? (ge(), _e(F, {
            key: 0,
            color: "primary",
            indeterminate: "",
            height: 12
          })) : ot("", !0),
          f.value ? (ge(), _e(j, { key: 1 }, {
            default: q(() => [
              y(R, { cols: "12" }, {
                default: q(() => [
                  y(W, null, {
                    default: q(() => [
                      y(B, null, {
                        default: q(() => [
                          we(ce(Z(t)("workspaceManagement.newWorkspaceMember")), 1)
                        ]),
                        _: 1
                      }),
                      y(N, null, {
                        default: q(() => [
                          y(Pl, {
                            member: v.value,
                            "onAdd:member": k,
                            "onCancel:member": O[0] || (O[0] = (xe) => f.value = !1)
                          }, null, 8, ["member"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : ot("", !0),
          f.value ? ot("", !0) : (ge(), _e(j, { key: 2 }, {
            default: q(() => [
              y(R, { cols: "12" }, {
                default: q(() => [
                  y(W, null, cm({
                    title: q(() => [
                      we(ce(Z(t)("workspaceManagement.title")), 1)
                    ]),
                    append: q(() => [
                      y(z, null, {
                        default: q(() => [
                          y(H, {
                            icon: "",
                            onClick: O[2] || (O[2] = (xe) => f.value = !0)
                          }, {
                            default: q(() => [
                              y($, null, {
                                default: q(() => [...O[13] || (O[13] = [
                                  we("mdi-account-multiple-plus", -1)
                                ])]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          y(H, {
                            icon: "",
                            onClick: C
                          }, {
                            default: q(() => [
                              y($, null, {
                                default: q(() => [...O[14] || (O[14] = [
                                  we("mdi-delete", -1)
                                ])]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: q(() => [
                      y(N, null, {
                        default: q(() => [
                          S("h2", $D, ce(Z(t)("workspaceManagement.members")), 1),
                          (ge(!0), yt(fe, null, ia(u.value.items, (xe) => (ge(), _e(Pl, {
                            key: xe.id,
                            member: xe,
                            "onUpdate:member": V,
                            "onRemove:member": A,
                            class: "mb-4"
                          }, null, 8, ["member"]))), 128)),
                          y(te, {
                            page: u.value.page,
                            "onUpdate:page": O[3] || (O[3] = (xe) => u.value.page = xe),
                            length: Math.ceil(u.value.total / u.value.itemsPerPage),
                            onInput: b
                          }, null, 8, ["page", "length"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, [
                    s.value ? {
                      name: "subtitle",
                      fn: q(() => [
                        y(j, { align: "center" }, {
                          default: q(() => [
                            y(R, null, {
                              default: q(() => [
                                we(ce(Z(t)("general.name")) + ": " + ce(s.value.name) + " ", 1),
                                y(H, {
                                  icon: "mdi-pencil",
                                  size: "x-small",
                                  onClick: O[1] || (O[1] = (xe) => m.value = !0)
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      key: "0"
                    } : void 0
                  ]), 1024)
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
          f.value ? ot("", !0) : (ge(), _e(j, { key: 3 }, {
            default: q(() => [
              y(R, null, {
                default: q(() => [
                  y(W, null, {
                    title: q(() => [
                      g.value ? (ge(), yt("span", BD, ce(Z(t)("workspaceManagement.addingTeamToWorkspace")), 1)) : (ge(), yt("span", UD, ce(Z(t)("workspaceManagement.workspaceTeams")), 1))
                    ]),
                    append: q(() => [
                      g.value ? (ge(), _e(H, {
                        key: 1,
                        icon: "",
                        onClick: O[5] || (O[5] = (xe) => g.value = !1)
                      }, {
                        default: q(() => [
                          y($, null, {
                            default: q(() => [...O[16] || (O[16] = [
                              we("mdi-arrow-left", -1)
                            ])]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })) : (ge(), _e(H, {
                        key: 0,
                        icon: "",
                        onClick: O[4] || (O[4] = (xe) => g.value = !0)
                      }, {
                        default: q(() => [
                          y($, null, {
                            default: q(() => [...O[15] || (O[15] = [
                              we("mdi-plus", -1)
                            ])]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    ]),
                    default: q(() => [
                      g.value ? (ge(), _e(N, { key: 1 }, {
                        default: q(() => [
                          y(ie, null, {
                            default: q(() => [
                              y(Q, {
                                "prepend-icon": "mdi-plus",
                                link: ""
                              }, {
                                title: q(() => [
                                  we(ce(Z(t)("general.create")), 1)
                                ]),
                                default: q(() => [
                                  y(Te, {
                                    activator: "parent",
                                    "max-width": "500"
                                  }, {
                                    default: q(({ isActive: xe }) => [
                                      y(W, { rounded: "lg" }, {
                                        default: q(() => [
                                          y(B, { class: "d-flex justify-space-between align-center" }, {
                                            default: q(() => [
                                              S("div", jD, ce(Z(t)("general.createTeam")), 1),
                                              y(H, {
                                                icon: "mdi-close",
                                                variant: "text",
                                                onClick: () => {
                                                  xe.value = !1, w();
                                                }
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          y(ke, { class: "mb-4" }),
                                          y(N, null, {
                                            default: q(() => [
                                              S("div", GD, ce(Z(t)("general.createTeamWhy")), 1),
                                              S("div", qD, ce(Z(t)("general.name")), 1),
                                              y(ye, {
                                                modelValue: o.value,
                                                "onUpdate:modelValue": O[8] || (O[8] = (Be) => o.value = Be),
                                                placeholder: Z(t)("general.teamNameExample"),
                                                counter: 50,
                                                "persistent-counter": ""
                                              }, null, 8, ["modelValue", "placeholder"])
                                            ]),
                                            _: 1
                                          }),
                                          y(ke, { class: "mt-2" }),
                                          y(ue, { class: "my-2 d-flex justify-end" }, {
                                            default: q(() => [
                                              y(H, {
                                                class: "text-none",
                                                rounded: "xl",
                                                text: "Cancel",
                                                onClick: () => {
                                                  xe.value = !1, w();
                                                }
                                              }, null, 8, ["onClick"]),
                                              y(H, {
                                                class: "text-none",
                                                color: "primary",
                                                rounded: "xl",
                                                variant: "flat",
                                                onClick: () => {
                                                  xe.value = !1, _();
                                                }
                                              }, {
                                                default: q(() => [
                                                  we(ce(Z(t)("general.create")), 1)
                                                ]),
                                                _: 1
                                              }, 8, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (ge(!0), yt(fe, null, ia(d.value.items, (xe) => (ge(), _e(Q, {
                                key: xe.id,
                                class: "mb-4"
                              }, {
                                title: q(() => [
                                  we(ce(xe.name), 1)
                                ]),
                                append: q(() => [
                                  y(H, {
                                    icon: "",
                                    onClick: zn((Be) => M(xe), ["prevent"])
                                  }, {
                                    default: q(() => [
                                      y($, null, {
                                        default: q(() => [...O[18] || (O[18] = [
                                          we("mdi-plus", -1)
                                        ])]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))), 128))
                            ]),
                            _: 1
                          }),
                          d.value.items.length > 0 ? (ge(), _e(te, {
                            key: 0,
                            page: d.value.page,
                            "onUpdate:page": O[9] || (O[9] = (xe) => d.value.page = xe),
                            length: Math.ceil(d.value.total / d.value.itemsPerPage),
                            onInput: x
                          }, null, 8, ["page", "length"])) : ot("", !0)
                        ]),
                        _: 1
                      })) : (ge(), _e(N, { key: 0 }, {
                        default: q(() => [
                          c.value.items.length < 1 ? (ge(), _e(me, {
                            key: 0,
                            icon: "$success"
                          }, {
                            media: q(() => [
                              y($, { color: "surface-variant" })
                            ]),
                            headline: q(() => [
                              S("div", WD, ce(Z(t)("workspaceManagement.noTeamHeadline")), 1)
                            ]),
                            title: q(() => [
                              S("div", HD, ce(Z(t)("workspaceManagement.noTeamTitle")), 1)
                            ]),
                            text: q(() => [
                              S("div", zD, ce(Z(t)("workspaceManagement.noTeamCaption")), 1)
                            ]),
                            actions: q(() => [
                              y(H, {
                                color: "primary",
                                elevation: "1",
                                rounded: "lg",
                                onClick: O[6] || (O[6] = (xe) => g.value = !0)
                              }, {
                                default: q(() => [
                                  we(ce(Z(t)("workspaceManagement.searchOrphanTeams")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })) : (ge(), _e(ie, { key: 1 }, {
                            default: q(() => [
                              (ge(!0), yt(fe, null, ia(c.value.items, (xe) => (ge(), _e(Q, {
                                key: xe.id,
                                class: "mb-4"
                              }, {
                                title: q(() => [
                                  we(ce(xe.name), 1)
                                ]),
                                append: q(() => [
                                  y(H, {
                                    icon: "",
                                    onClick: (Be) => L(xe)
                                  }, {
                                    default: q(() => [
                                      y($, null, {
                                        default: q(() => [...O[17] || (O[17] = [
                                          we("mdi-delete", -1)
                                        ])]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))), 128))
                            ]),
                            _: 1
                          })),
                          c.value.items.length > 0 ? (ge(), _e(te, {
                            key: 2,
                            page: c.value.page,
                            "onUpdate:page": O[7] || (O[7] = (xe) => c.value.page = xe),
                            length: Math.ceil(c.value.total / c.value.itemsPerPage),
                            onInput: p
                          }, null, 8, ["page", "length"])) : ot("", !0)
                        ]),
                        _: 1
                      }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
          y(Te, {
            modelValue: m.value,
            "onUpdate:modelValue": O[12] || (O[12] = (xe) => m.value = xe),
            "max-width": "500px"
          }, {
            default: q(() => [
              y(W, null, {
                default: q(() => [
                  y(B, null, {
                    default: q(() => [
                      we(ce(Z(t)("workspaceManagement.editWorkspaceName")), 1)
                    ]),
                    _: 1
                  }),
                  y(N, null, {
                    default: q(() => [
                      y(ye, {
                        modelValue: h.value,
                        "onUpdate:modelValue": O[10] || (O[10] = (xe) => h.value = xe),
                        label: Z(t)("general.name")
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _: 1
                  }),
                  y(ue, null, {
                    default: q(() => [
                      y(Ne),
                      y(H, {
                        color: "secondary",
                        variant: "flat",
                        onClick: O[11] || (O[11] = (xe) => m.value = !1)
                      }, {
                        default: q(() => [
                          we(ce(Z(t)("general.cancel")), 1)
                        ]),
                        _: 1
                      }),
                      y(H, {
                        color: "primary",
                        variant: "flat",
                        onClick: E
                      }, {
                        default: q(() => [
                          we(ce(Z(t)("general.save")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      });
    };
  }
}), KD = [
  {
    path: "/:lang/not-found",
    component: VD,
    name: gt.NOT_FOUND
  },
  {
    path: "/:lang/unexpected-error",
    component: FD,
    name: gt.UNEXPECTED_ERROR
  },
  {
    path: "/:lang/home",
    component: kD,
    name: gt.HOME
  },
  {
    path: "/:lang/about",
    component: wD,
    name: gt.ABOUT
  },
  {
    path: "/:lang/team/:teamId/manage",
    component: RD,
    name: gt.TEAM_MANAGEMENT
  },
  {
    path: "/:lang/workspace/:workspaceId/manage",
    component: YD,
    name: gt.WORKSPACE_MANAGEMENT
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/en/home"
  }
];
function ZD(e = [], t) {
  const n = [...KD, ...e], a = Qp({
    history: ew("/"),
    routes: n
  });
  if (t) {
    const { i18n: r, defaultLang: l, languageStore: i } = t, o = r.global.availableLocales;
    a.beforeEach((s, u, c) => {
      const d = s.params.lang;
      if (d && d !== i.currentLanguage)
        if (o.includes(d))
          r.global.locale.value = d, i.setLanguage(d);
        else {
          r.global.locale.value = l, i.setLanguage(l);
          const v = {
            name: s.name,
            params: { ...s.params, lang: l },
            query: s.query,
            hash: s.hash
          };
          c(v);
          return;
        }
      else if (!d) {
        const f = navigator.language.split("-")[0];
        if (o.includes(f)) {
          r.global.locale.value = f, i.setLanguage(f);
          const g = {
            name: gt.HOME,
            params: { lang: f }
          };
          c(g);
        } else {
          r.global.locale.value = l, i.setLanguage(l);
          const g = {
            name: gt.HOME,
            params: { lang: l }
          };
          c(g);
        }
        return;
      }
      c();
    });
  }
  return a;
}
ZD();
const JD = [
  "mdi-rabbit",
  "mdi-turtle",
  "mdi-fish",
  "mdi-duck",
  "mdi-cat",
  "mdi-dog",
  "mdi-koala",
  "mdi-panda",
  "mdi-elephant",
  "mdi-lion",
  "mdi-tiger",
  "mdi-pig",
  "mdi-cow",
  "mdi-frog",
  "mdi-owl",
  "mdi-bat",
  "mdi-bee",
  "mdi-butterfly",
  "mdi-snail",
  "mdi-spider"
];
function EL(e) {
  const t = JD, n = e ? t.filter((l) => !e.has(l)) : [...t], a = n.length > 0 ? n : [...t], r = Math.floor(Math.random() * a.length);
  return a[r] ?? t[0];
}
const XD = {
  BubblePixelIdenticon: lw,
  ChipSelect: Bs,
  ErrorSnackbar: uw,
  LanguageSelector: dw,
  MemberManagement: Pl,
  TeamAndWorkspaceManagementListItems: HC,
  SwipeToRefresh: jC,
  TutorialDisplayer: n1,
  TutorialReplayFab: Yh,
  SmartGuideDisplayer: v1
}, ML = {
  install(e) {
    Object.entries(XD).forEach(([t, n]) => {
      e.component(t, n);
    });
  }
};
export {
  xo as ApiService,
  Kk as AuthService,
  lw as BubblePixelIdenticon,
  Bs as ChipSelect,
  uw as ErrorSnackbar,
  TL as JoinShopRejectReason,
  dw as LanguageSelector,
  bc as LastSelectionDto,
  Pl as MemberManagement,
  Je as ParentModel,
  gt as Routes,
  JD as SHOP_CUSTOMER_ICON_POOL,
  _L as ShopWsClientEvent,
  sn as ShopWsInboundEvent,
  v1 as SmartGuideDisplayer,
  a1 as SmartGuideStatus,
  jC as SwipeToRefresh,
  wa as TaleDto,
  HC as TeamAndWorkspaceManagementListItems,
  pa as TeamDto,
  Ga as TeamMemberDto,
  IC as TeamService,
  n1 as TutorialDisplayer,
  Yh as TutorialReplayFab,
  Wr as UserDto,
  VC as UserService,
  r_ as WebSocketCloseCode,
  PL as WebsocketService,
  Wa as WorkspaceDto,
  Cl as WorkspaceMemberDto,
  EC as WorkspaceService,
  xL as createAppI18n,
  ZD as createAppRouter,
  CL as createLanguageStore,
  VL as createVuetifyInstance,
  ML as default,
  Jh as defaultLang,
  a_ as isCustomerLeftPayload,
  t_ as isJoinShopRejectedPayload,
  Yf as isOnlineShopCustomerPayload,
  n_ as isShopJoinedPayload,
  IL as isShopWsInboundMessage,
  AL as parseShopWsInboundMessage,
  EL as pickShopCustomerIcon,
  Ze as requestHelper,
  vl as serviceFactory,
  wm as toBooleanFailSafe,
  l1 as useSmartGuideStore,
  _l as useTeamStore,
  qC as useTutorialStore,
  qh as useUserStore,
  Vr as useUxFeedbackStore
};
